//#region Imports
import React, {
  forwardRef,
  use,
  useEffect,
  useImperativeHandle,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
//MUI
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DeleteIcon from "@mui/icons-material/Delete";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import PersonIcon from "@mui/icons-material/Person";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import InfoIcon from "@mui/icons-material/Info";
import PrintIcon from "@mui/icons-material/Print";
import DescriptionIcon from "@mui/icons-material/Description";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
  InputLabel,
  ListItemIcon,
  ListItemText,
  Alert
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import InputAdornment from "@mui/material/InputAdornment";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import mepcologo from "../../../images/mepcoLogo.png";
import pdfIcon from "../../../images/pdfIcon.png";
import MEPCOWaterMark from "../../../images/DiscosWater/mepcco-watermark.png";
import LESCOWaterMark from "../../../images/DiscosWater/lescowatermark.png";
import IESCOWaterMark from "../../../images/DiscosWater/iescowatermark.png";
import FESCOWaterMark from "../../../images/DiscosWater/fesco-watermark.png";
import GEPCOWaterMark from "../../../images/DiscosWater/gepco-watermark.png";
import HAZECOWaterMark from "../../../images/DiscosWater/hazeco-watermark.png";
import HESCOWaterMark from "../../../images/DiscosWater/hesco-watermark.png";
import TESCOWaterMark from "../../../images/DiscosWater/tesco-watermark.png";
import SEPCOWaterMark from "../../../images/DiscosWater/sepco-watermark.png";
import PESCOWaterMark from "../../../images/DiscosWater/pesco-watermark.png";
import QESCOWaterMark from "../../../images/DiscosWater/qesco-watermark.png";
import IESCODDLOGO from "../../../images/discologos/iesco logo.png";
import FESCODDLOGO from "../../../images/discologos/fesco.jpg";
import GEPCODDLOGO from "../../../images/discologos/gepco.jpg";
import HAZECODDLOGO from "../../../images/discologos/hazeco_logo-removebg-preview.png";
import HESCODDLOGO from "../../../images/discologos/hesco logo.png";
import LESCODDLOGO from "../../../images/discologos/lesco.jpg";
import MEPCODDLOGO from "../../../images/discologos/mepco1.jpg";
import PESCODDLOGO from "../../../images/discologos/pesco1.jpg";
import PITCDDLOGO from "../../../images/discologos/pitc11-removebg-preview.png";
import QESCODDLOGO from "../../../images/discologos/qesco.png";
import SEPCODDLOGO from "../../../images/discologos/sepco.jpg";
import TESCODDLOGO from "../../../images/discologos/tesco.jpg";
// import RemoveErrorIcon from '../../../images/remove.png';
//components
// import StatusBar from '../../../components/statusbar/statusbar';
import Base64Image from "../../../components/Base64Image/Base64Image";
import ProcessingSummaryTable from "../../../components/processingSummaryTable/processingSummaryTable";
import tickicon from "../../../images/Accept.png";
import pencilIcon from "../../../images/pencil.png";
import crossIcon from "../../../images/remove.png";
import {
  applicationName,
  companyName,
  companyShortName,
  convertDate,
  convertDateDDMMYY,
  convertDatewithTimeWithoutSecond,
  dBillAPI,
  divisionName,
  handleFileUpload,
  isImage,
  isPdf,
  numberFormatting,
  printStamp,
  sodowo,
  subDivAPI,
  subdivisionName,
} from "../../../services/Functions";
//scss
// import "./Newconnectiontable.scss";
import "../../../style/common.scss";
//Yup
import * as Yup from "yup";
//formik
import { useFormik } from "formik";
//urls
import { cfpBaseUrl } from "../../../network/urls";
// use scan detection
import useScanDetection from "use-scan-detection";
// authorization
import CheckPermissions from "../../../authorization/authorization";
// Services
import { openBase64Image } from "../../../services/OpenBase64Image";
//jspdf
import { jsPDF } from "jspdf";
import "jspdf-autotable";
//jsbarcode
import JsBarcode from "jsbarcode";
import QRCode from "qrcode";
import StepProgressBar from "../../../components/StepProgressBar/StepProgressBar";
import warning from "../../../images/warning.png";
import OpenBase64ImageInPopup from "../../../services/OpenBase64ImageInPopup";
import { tableStyle, tableStyleOverDue } from "../../../style/common";
//pdfjs
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";
import { useDispatch, useSelector } from "react-redux";
import ActionsCell from "../../../components/actionCell/ActionCell";
import BasicTable from "../../../components/basicTable/basicTable";
import Error from "../../../components/error/error";
import {
  fetchPaginatedNewConnectionNormal,
  filterDateFrom as filterDateFromNormal,
  filterDateTo as filterDateToNormal,
  filterLoadFrom as filterLoadFromNormal,
  filterLoadTo as filterLoadToNormal,
  filterObjectionStatus as filterObjectionStatusNormal,
  filterProgressId as filterProgressIdNormal,
  firstPage as firstPageNormal,
  lastPage as lastPageNormal,
  nextPage as nextPageNormal,
  previousPage as prePageNormal,
  resetDateFilter as resetDateFilterNormal,
  resetObjectionStatusFilter as resetObjectionStatusFilterNormal,
  resetProgressIdFilter as resetProgressIdFilterNormal,
} from "../../../features/generalServices/ncNormalSlice";
import {
  fetchPaginatedNewConnectionOverdue,
  filterDateFrom as filterDateFromOverdue,
  filterDateTo as filterDateToOverdue,
  filterLoadFrom as filterLoadFromOverdue,
  filterLoadTo as filterLoadToOverdue,
  filterObjectionStatus as filterObjectionStatusOverdue,
  filterProgressId as filterProgressIdOverdue,
  firstPage as firstPageOverdue,
  lastPage as lastPageOverdue,
  nextPage as nextPageOverdue,
  previousPage as prePageOverdue,
  resetDateFilter as resetDateFilterOverdue,
  resetLoadFilter as resetLoadFilterOverdue,
  resetObjectionStatusFilter as resetObjectionStatusFilterOverdue,
  resetProgressIdFilter as resetProgressIdFilterOverdue,
} from "../../../features/generalServices/ncOverdueSlice";

import useFetchData from "../../../hooks/fetchData";
import batchIcon from "../../../images/batchWarning.png";
import InfoImage from "../../../images/informationButton.png";
import {
  getFieldStaffDesignations,
  getWorkforceData,
  SearchIndividualApplication,
} from "../../../network/APIs/APIs";
import { documentExtensions, portalName } from "../../../utils/PortalName";
import {
  applicantCitizenshipForValidation,
  applicantStatusForValidation,
  areaTypeForValidation,
} from "./NewConnectionForm";
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from "../../../images/pitc.png";
import eOpsLogo from "../../../images/eops.png";
import { useCallback } from "react";
import OpenBase64ImageInPopupForMeterInspector from "../../../services/OpenBase64ImageInPopupForMeterInspector";
//#endregion

const Newconnectiontable = forwardRef((props, ref) => {
  //#region paginatedlogic
  const dispatch = useDispatch();
  const {
    currentPage: currentPageNormal,
    data: dataNormal,
    pageSize: pageSizeNormal,
    totalPages: totalPagesNormal,
    totalRecords: totalRecordsNormal,
    dateFrom: dateFromNormal,
    dateTo: dateToNormal,
    loadFrom: loadFromNormal,
    loadTo: loadToNormal,
    applicationProgressId: applicationProgressIdNormal,
    objectionStatus: objectionStatusNormal,
    error: ncNormalError,
    isLoading: isLoad,
  } = useSelector((state) => state.ncNormalPaginated);
  const {
    currentPage: currentPageOverdue,
    data: dataOverdue,
    pageSize: pageSizeOverdue,
    totalPages: totalPagesOverdue,
    totalRecords: totalRecordsOverdue,
    dateFrom: dateFromOverdue,
    dateTo: dateToOverdue,
    loadFrom: loadFromOverdue,
    loadTo: loadToOverdue,
    applicationProgressId: applicationProgressIdOverdue,
    objectionStatus: objectionStatusOverdue,
    error: ncOverdueError,
    isLoading: isLoadd,
  } = useSelector((state) => state.ncOverduePaginated);
  const {
    token,
    userId,
    hierarchy,
    roleId,
    roleName,
    permissions,
    code,
    roleTypeId,
  } = useSelector((state) => state.auth);
  const [installRefNo, setInstallRefNo] = useState([]);

  let userCompany = code.slice(0, 2);
  const myHeaders = new Headers();
  myHeaders.append("Authorization", token);

  const RequestOptions = (method, myHeaders) => {
    return {
      method: method,
      headers: myHeaders,
      redirect: "follow",
    };
  };

  let requestOptions = RequestOptions("GET", myHeaders);

  const {
    data: cities,
    loading: citiesLoading,
    error: citiesError,
  } = useFetchData(
    roleTypeId == 1 ? cfpBaseUrl + "electricityNewConnection/citiesList" : null,
    requestOptions
  );
  const govtDeptCodesFromlocalStorage = JSON.parse(
    localStorage.getItem("govtDeptCodes")
  );
  const getClassificationCodesFromlocalStorage = JSON.parse(
    localStorage.getItem("govtClassFeCodes")
  );

  const [isReleventToUser, setIsRelevantToUser] = useState(false);

  const handleNextPageNormal = () => {
    setViewBackdrop(true);
    dispatch(nextPageNormal());
  };

  const handleDateFromFilterNormal = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateFromNormal(value));
    }
  };

  const handleDateToFilterNormal = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateToNormal(value));
    }
  };

  const handleLoadFromFilterNormal = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterLoadFromNormal(value));
    }
  };

  const handleLoadToFilterNormal = (value) => {
    if (value) {
      setViewBackdrop(true);
      console.log(value, 'value value')
      dispatch(filterLoadToNormal(value));
    }
  };

  const handleResetDateFilterNormal = () => {
    setViewBackdrop(true);
    dispatch(resetDateFilterNormal());
  };

  // Map dropdown index to actual progress ID
  const mapIndexToProgressId = (index) => {
    const progressIdMap = {
      0: 0,   // Documents Uploading
      1: 1,   // Documents Verification
      2: 21,  // Wiring Test Report (Progress ID 21)
      3: 2,   // Arrear Verification
      4: 3,   // Field Survey
      5: 4,   // Reference No. Allocation
      6: 5,   // Demand Note Payment
      7: 6,   // DN Payment Verification
      8: 7,   // SCO Creation
      9: 8,   // Meter Installation
      10: 9  // Ready for Billing
    };
    return progressIdMap[index] !== undefined ? progressIdMap[index] : index;
  };

  const handleProgressIdFilterNormal = (value) => {

    if (value || value === 0) {
      setViewBackdrop(true);
      const progressId = mapIndexToProgressId(value);
      dispatch(filterProgressIdNormal(progressId));
    }
  };

  const handleResetProgressIdFilterNormal = () => {
    setViewBackdrop(true);
    dispatch(resetProgressIdFilterNormal());
  };

  const handleObjectionStatusFilterNormal = (value) => {
    if (value || value === 0) {
      setViewBackdrop(true);
      dispatch(filterObjectionStatusNormal(value));
    }
  };

  const handleResetObjectionStatusFilterNormal = () => {
    setViewBackdrop(true);
    dispatch(resetObjectionStatusFilterNormal());
  };

  const handlePreviousPageNormal = () => {
    setViewBackdrop(true);
    dispatch(prePageNormal());
  };

  const handleFirstPageNormal = () => {
    setViewBackdrop(true);
    dispatch(firstPageNormal());
  };

  const handleLastPageNormal = () => {
    setViewBackdrop(true);
    dispatch(lastPageNormal(totalPagesNormal)); // Replace '2' with actual value
  };

  const handleNextPageOverdue = () => {
    setViewBackdrop(true);
    dispatch(nextPageOverdue());
  };

  const handleDateFromFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateFromOverdue(value));
    }
  };

  const handleDateToFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateToOverdue(value));
    }
  };
  const handleResetDateFilterOverdue = () => {
    setViewBackdrop(true);
    dispatch(resetDateFilterOverdue());
  };
  const handleProgressIdFilterOverdue = (value) => {
    if (value || value === 0) {
      setViewBackdrop(true);
      const progressId = mapIndexToProgressId(value);
      dispatch(filterProgressIdOverdue(progressId));
    }
  };

  const handleResetProgressIdFilterOverdue = () => {
    setViewBackdrop(true);
    dispatch(resetProgressIdFilterOverdue());
  };

  const handleObjectionStatusFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterObjectionStatusOverdue(value));
    }
  };

  const handleResetObjectionStatusFilterOverdue = () => {
    setViewBackdrop(true);
    dispatch(resetObjectionStatusFilterOverdue());
  };

  const handlePreviousPageOverdue = () => {
    setViewBackdrop(true);
    dispatch(prePageOverdue());
  };

  const handleFirstPageOverdue = () => {
    setViewBackdrop(true);
    dispatch(firstPageOverdue());
  };

  const handleLastPageOverdue = () => {
    setViewBackdrop(true);
    dispatch(lastPageOverdue(totalPagesOverdue)); // Replace '2' with actual value
  };

  const handleLoadFromFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterLoadFromOverdue(value));
    }
  };

  const handleLoadToFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterLoadToOverdue(value));
    }
  };

  const handleResetLoadFilterOverdue = () => {
    setViewBackdrop(true);
    dispatch(resetLoadFilterOverdue());
  };

  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };
  const getLogo = (code) => {
    switch (code) {
      case "10":
        return pitcLogo;
      case "11":
        return LESCOLOGO;
      case "12":
        return GEPCOLOGO;
      case "13":
        return FESCOLOGO;
      case "14":
        return IESCOLOGO;
      case "15":
        return MEPCOLOGO;
      case "26":
        return PESCOLOGO;
      case "27":
        return HAZECOLOGO;
      case "37":
        return HESCOLOGO;
      case "38":
        return SEPCOLOGO;
      case "48":
        return QESCOLOGO;
      case "59":
        return TESCOLOGO;
      default:
        return MEPCOLOGO;
    }
  };
  const getWaterMarkLogo = (code) => {
    switch (code) {
      case "11":
        return LESCOWaterMark;
      case "12":
        return GEPCOWaterMark;
      case "13":
        return FESCOWaterMark;
      case "14":
        return IESCOWaterMark;
      case "15":
        return MEPCOWaterMark;
      case "26":
        return PESCOWaterMark;
      case "27":
        return HAZECOWaterMark;
      case "37":
        return HESCOWaterMark;
      case "38":
        return SEPCOWaterMark;
      case "48":
        return QESCOWaterMark;
      case "59":
        return TESCOWaterMark;
      default:
        return MEPCOWaterMark;
    }
  };

  //#endregion

  //#region initial values
  const initialValues = {
    iv_objection_Type: "No Issue",
    iv_objection_step: 4,
    iv_objection_Descripton: "",

    //arrears fields
    iv_property_reference_no: "",
    iv_arrears_remarks: "",

    //arears paid bill document field
    iv_arear_paid_bill_document: "",
    iv_arear_paid_bill_date: "",

    //applied load fields
    iv_applied_load: "",

    //dn fields
    iv_distance: 1,
    iv_estimated_distance: 0,
    iv_estimated_distance_yes: 1,
    iv_sketch_diagram: "",
    iv_coverage_area: "3",
    iv_existing_meters_ref_nos_array: "",
    iv_tariff_to_allot: "",
    iv_batch: "",
    iv_reference_to_allot: "",
    iv_industry_factory_type: "",
    iv_bank_name: "",
    iv_connection_account_no: "",
    iv_grid_sharing_cost: 0,
    iv_feeder_rehab_charges: 0,
    iv_mnt_charges: "",
    iv_labour_charges: "",
    iv_design_vetting_fee: "",
    iv_consultancy_charges: "",
    iv_variation_charges: "",
    iv_dismantlement_charges: "",
    iv_earthing_charges: "",
    iv_civil_work_charges: 0,
    iv_fixed_charges_of_metering: 0,
    iv_miscellaneous_charges: 0,
    iv_less_the_cost: 0,

    // boq fields
    iv_fieldItemId: "",
    iv_fieldItemQty: "",
    iv_fieldItemRate: "",
    iv_fieldItemUnit: "",
    iv_fieldItemAmount: "",
    iv_items_array: "",

    // payment verification fields
    iv_payment_date: "",
    iv_receipt_image: "",

    //sco fields
    iv_fata_pata: "",
    iv_rural_urban: "U",
    iv_feeder_no: "",
    iv_sub_batch: "",
    iv_fgovt: "",
    iv_cantonment_board: "",
    iv_pgovt: "",
    iv_govt_dept_code: "",
    iv_local_bodies: "",
    iv_authorized_by_name: "",
    iv_date_of_authorization: "",
    iv_store_requisition_no: "",
    iv_store_requisition_date: "",
    iv_sanctioned_load: "",
    iv_seasonal_flag: 0,
    iv_no_of_acs: 0,
    iv_no_of_meters: 0,
    iv_no_of_meter_sets: 0,
    iv_no_of_sub_sets: 0,
    iv_no_ofsupply_points: 0,
    iv_transformer_code: "",
    iv_transformer_refNo: "",
    iv_meter_id: "",
    iv_meter_serial_no: "",
    iv_sim_number: "",
    iv_sim_ID: "",
    iv_location_code: "",
    iv_meter_code1: "",
    iv_meter_code2: "",
    iv_manufacturer_code: "",
    iv_multiplying_factor: 1,
    iv_meter_range: 4,
    iv_meter_reading: "",
    iv_date_of_connection: "",
    iv_cp_78_item_no: "",
    iv_tie_up_non_tie_up: 1,
    iv_seal_on_meter: "",
    iv_seal_on_box: "",
    iv_security_slip_or_price_bond_no: "",
    iv_connection_installer_name: "",
    iv_meter_type: 1,
    iv_meter_reading_off_peak_kwh: "",
    iv_meter_reading_peak_kwh: "",
    iv_meter_reading_off_peak_kvarh: "",
    iv_meter_reading_peak_kvarh: "",
    iv_ct: "",
    iv_ct_nom: "1",
    iv_ct_denom: "1",
    iv_pt: "",
    iv_pt_nom: "1",
    iv_pt_denom: "1",
    iv_mf: "",
    iv_mdi: "",
    iv_no_of_mdi_resets: "",
    iv_installed_meter_image: "",

    // master data fields
    iv_govt_dept: 0,
    iv_ed_code: "",
    iv_standard_classification_code: "",
    iv_income_tax: 0,
    iv_authority: "",

    // Classification group Initial Values
    iv_connection_type: "Domestic",
    iv_applied_load: "",
    iv_near_by_reference_no: "",
    iv_near_by_name: "",
    iv_near_by_address: "",
    iv_circle: "",
    iv_division: "",
    iv_sub_divison: "",
    iv_type_of_application: "",
    iv_applicant_status: "Owner",
    iv_relation_type: "Father's Name",
    iv_relative_name: "",
    iv_meter_seasonal: 0,
    iv_applicant_name: "",
    iv_applicant_citizenship: "Pakistani",
    iv_applicant_cnic: "",
    iv_applicant_phone_no: "",
    iv_applicant_email: "",
    iv_ntn: "",
    iv_strn: "",
    // Owner Details group Initial Values
    iv_owner_name: "",
    iv_owner_cnic: "",
    iv_owner_phone_no: "",
    iv_owner_email: "",
    // Address Group Initial Values
    iv_area_type: "Urban",
    iv_city_district: "",
    iv_address: "",
    iv_meter_installed: 0,
    iv_town_tehsil: "",
    // Required Documents Initial Values
    iv_applicant_cnic_document_front: null,
    iv_applicant_cnic_document_back: null,
    iv_property_documents: null,
    iv_near_by_bill: null,
    iv_any_other_document: null,
    iv_owner_cnic_document_front: null,
    iv_owner_cnic_document_back: null,
    iv_noc_owner: null,
    iv_resolution: null,
    iv_memo: null,
    iv_form29initial: null,

    iv_no_of_meters_already_installed: 0,
    installedMeterRefNos: [],
    iv_select_cable: 0,
  };

  //#endregion

  //#region get item local storage
  const subDivisions = JSON.parse(window.localStorage.getItem("subDivisions"));
  //#endregion

  //#region states
  const [showTooltip, setShowTooltip] = useState(false);
  const [nearByReferenceNumber, setNearByReferenceNumber] = useState("");
  const [referenceNumberError, setReferenceNumberError] = useState("");
  const [hierarchyList, setHierarchyList] = useState([]);
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);
  const [defaultCircle, setDefaultCircle] = useState();
  const [defaultDivision, setDefaultDivision] = useState();
  const [subDivision, setSubDivision] = React.useState({
    code: null,
    name: "",
  });
  const [allTariffList, setAllTariffList] = useState([]);
  const [allFeedersList, setAllFeedersList] = useState([]);
  const [allMaterialList, setAllMaterialList] = useState([]);
  const [standardClassificationCodes, setStandardClassificationCodes] =
    useState([]);
  const [sketchDiagram, setSketchDiagram] = useState();
  const [sketchDiagramError, setSketchDiagramError] = useState();
  const [sketchDiagramThumbnail, setSketchDiagramThumbnail] = useState("");
  const [submitCP136Error, setSubmitCP136Error] = useState("");
  const [enablingRemoveObjOfArrear, setEnablingRemoveObjOfArrear] =
    useState("");
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [connectionTypesList, setConnectionTypesList] = useState([]);
  const [alreadyInstalledRefNos, setAlreadyInstalledRefNos] = useState([]);
  const [arrearFlag, setArearFlag] = useState(0);
  const [arrearsDetailsRefno, setArrearsDetailsRefno] = useState({
    arrearsAmount: "",
    meterStatus: "",
    tariffDesc: "",
    meterType: "",
    phase: "",
    consumerName: "",
    consumerNo: "",
    consumerAddress: "",
    consumerEmail: "",
  });
  const [batchError, setBatchError] = useState("");
  const [wrongBatchPopup, setWrongBatchPopup] = useState(false);
  const [phase, setPhase] = useState();
  const [tariff, setTariff] = useState();
  const [capitalCostAmnt, setCapitalCostAmnt] = useState();
  const [securityDepositeAmount, setSecurityDepositeAmount] = useState();
  const [totalEstimatedAmnt, SetTotalEstimatedAmnt] = useState();
  const [sanctionLoad, setSanctionLoad] = useState();
  const [isLTLWI40Flag, setIsLTLWI40Flag] = useState();
  const [meterTypeValueForCheck, setMeterTypeValueForCheck] = useState("0");
  const [frontImg, setFrontImg] = useState(null);
  const [backImg, setBackImg] = useState(null);

  const [meterType, setMeterType] = useState("0");
  const [phaseEdit, setPhaseEdit] = useState();
  const [tariffEdit, setTariffEdit] = useState();
  const [shortListIndustrialTariff, setShortListIndustrialTariff] = useState(
    []
  );
  const [refNoAlreadyAllocatedError, setRefNoAlreadyAllocatedError] =
    useState("");
  const [inputValue, setInputValue] = useState("");
  const [debouncedInputValue, setDebouncedInputValue] = useState(inputValue);
  const [showUpdateBatchPopup, setShowUpdateBatchPopup] = useState(false);
  const manufacturesList = [
    { code: 1, name: "General Electric" },
    { code: 10, name: "Climax" },
    { code: 11, name: "Escorts" },
    { code: 12, name: "Schlumburger France" },
    { code: 13, name: "CHINA" },
    { code: 14, name: "TIP" },
    { code: 15, name: "RUSSIAN" },
    { code: 16, name: "BULGARIA" },
    { code: 17, name: "BRAZIL" },
    { code: 18, name: "GANZ" },
    { code: 19, name: "BELGIUM" },
    { code: 2, name: "Westinghouse" },
    { code: 20, name: "SWITZERLAND" },
    { code: 21, name: "KRIZIK" },
    { code: 22, name: "HITACHI" },
    { code: 23, name: "ISKARA" },
    { code: 24, name: "ELGMA(TOU)" },
    { code: 25, name: "USA(TOD)" },
    { code: 26, name: "SABEECO" },
    { code: 27, name: "MICRO TECH" },
    { code: 28, name: "ETHOPIA" },
    { code: 29, name: "LETHIANIA" },
    { code: 3, name: "Landis & Gyr" },
    { code: 30, name: "M.T.I Micro Tech" },
    { code: 31, name: "SBEEC" },
    { code: 32, name: "Hexing(China)" },
    { code: 33, name: "Creative Electronics" },
    { code: 34, name: "Elektromed" },
    { code: 35, name: "J n P" },
    { code: 36, name: "TRANSFAB" },
    { code: 37, name: "HAMEED" },
    { code: 38, name: "ELEMATIC" },
    { code: 39, name: "TRANSPAK" },
    { code: 4, name: "Aeg" },
    { code: 40, name: "NECOPE" },
    { code: 41, name: "TRANSFOPOWER" },
    { code: 42, name: "IRAN" },
    { code: 43, name: "ACE INDIGO" },
    { code: 44, name: "PAN POWER" },
    { code: 45, name: "AB AMPERRE" },
    { code: 46, name: "POWER TECH" },
    { code: 47, name: "J.F.INDUSTRIES" },
    { code: 48, name: "KBK" },
    { code: 49, name: "M / S HAMMAD" },
    { code: 5, name: "Siemens" },
    { code: 50, name: "M / S NATIONAL" },
    { code: 51, name: "M / S IMS" },
    { code: 52, name: "ACCURATE COMPANY" },
    { code: 53, name: "VERTEX STATIC" },
    { code: 54, name: "ELSTER" },
    { code: 55, name: "RECLAIMED" },
    { code: 56, name: "KAIFA" },
    { code: 57, name: "XJ" },
    { code: 58, name: "CHINT" },
    { code: 59, name: "PEL" },
    { code: 6, name: "GEC" },
    { code: 7, name: "Ferranti" },
    { code: 8, name: "Mitsubishi" },
    { code: 9, name: "Syed Bhais" },
  ];

  const [arrearsDetailsRefnoToDisplay, setArrearsDetailsRefnoToDisplay] =
    useState({
      refNo: "",
      arrearsAmount: "",
      meterStatus: "",
      tariffDesc: "",
      meterType: "",
      phase: "",
      consumerName: "",
      consumerNo: "",
      consumerAddress: "",
      consumerEmail: "",
      paidArearImage: "",
      paidArearDate: "",
    });

  const [isDemandNoteExpired, setIsDemandNoteExpired] = useState(null);

  const [dnDetails, setDnDetails] = useState({
    urbanRural: "",
    demandNoticeNo: "",
    demandNoteExpiryCount: null,
    issueDate: "",
    applicationId: "",
    dueDate: "",
    roOfficeAddress: "",
    consumerAccountNo: "",
    batchNo: "",
    voltage: "",
    tariff: "",
    coverageAreaOfPremises: "",
    bankName: "",
    industryFactoryType: "",
    sketchImage: "",
    isDistance40: "",
    connectionAccountNo: "",
    dnPaymentFlag: "",
    paymentMethod: "",
    dnPaymentVerificationFlag: "",
    // meterRent: "",
    // serviceRent: "",
    sanctionLoad: "",
    surveyedBy: "",
    surveyedDate: "",
    filledBy: "",
    filledDate: "",
    filledFlag: null,
    approvedBy: "",
    approvedDate: "",
    approvedFlag: null,
    paymentDate: "",
    capitalCostAmount: "",
    securityDepositeAmount: "",
  });

  const [scoDetails, setScoDetails] = useState({
    scoId: "",
    applicationId: "",
    scoCreationDate: "",
    urbanRural: "",
    fataPata: "",
    refNo: "",
    feederNo: "",
    batch: "",
    subBatch: "",
    fGovt: "",
    cantonmentBoard: "",
    pGovt: "",
    localBodies: "",
    scoP1FilledBy: "",
    scoP1FillingDate: "",
    scoP1FillFlag: "",
    authorizedByName: "",
    dateOfAuthorization: "",
    scoP1ApprovedFlag: "",
    storeRequisitionNo: "",
    storeRequisitionDate: "",
    seasonalFlag: "",
    senctionLoad: "",
    noOfACs: "",
    noOfMeters: "",
    noOfMeterSets: "",
    noOfSubSets: "",
    noOfSupplyPoints: "",
    installedTransformerCapacity: "",
    meterId: "",
    meterNo: "",
    locationCode: "",
    meterCode: "",
    manufacturerCode: "",
    multiplyingFactor: "",
    meterRange: "",
    meterReading: "",
    dateOfConnection: "",
    cp78ItemNo: "",
    tieUpNonTieUp: "",
    sealOnMeter: "",
    sealOnBox: "",
    securitySlipOrPriceBondNo: "",
    connectionInstallerName: "",
    scoP2FilledBy: "",
    scoP2FillingDate: "",
    scoP2FillFlag: "",
    scoP2ApprovedBy: "",
    scoP2ApprovalDate: "",
    scoP2ApprovalFlag: "",
    installedMeterImage: "",
    meterType: null,
    threePhasePeak: null,
    threePhaseOffPeak: null,
    mdi: null,
    noOfMDIreset: null,
    cT: "",
    pT: "",
    threePhasePeakKVARH: "",
    threePhaseOffPeakKVARH: "",
    threePhasePeakKWH: "",
    threePhaseOffPeakKWH: "",
  });

  const [masterDataFormDetails, setMasterDataFormDetails] = useState({
    applicationId: "",
    electricityDuty: "",
    governmentDepartment: "",
    standardClassificationCode: "",
    incomeTax: "",
    reason: "",
    authority: "",
    filledBy: "",
    filledByDate: "",
    filledByFlag: "",
    approvedBy: "",
    approvalDate: "",
    approvalFlag: "",
  });


  const [mntCharges, setMntCharges] = useState(0);
  const [labourCharges, setLabourCharges] = useState(0);
  const [designVettingFee, setDesignVettingFee] = useState(0);
  const [consultancyCharges, setConsultancyCharges] = useState(0);
  const [variationCharges, setVariationCharges] = useState(0);
  const [dismantlementCharges, setDismantlementCharges] = useState(0);
  const [earthingCharges, setEarthingCharges] = useState(0);

  const [partialValue, setPartialValue] = useState("");
  const [noArrears, setNoArrears] = useState("");
  const [flag_copyOfApplicantCNICFront, setFlag_copyOfApplicantCNICFront] =
    useState(null);
  const [flag_copyOfApplicantCNICBack, setFlag_copyOfApplicantCNICBack] =
    useState(null);
  const [flag_premisesDocument, setFlag_premisesDocument] = useState(null);
  const [
    flag_scannedCopyOfNearByElectricityBill,
    setFlag_scannedCopyOfNearByElectricityBill,
  ] = useState(null);
  const [flag_anyOtherDocument, setFlag_anyOtherDocument] = useState(null);
  const [flag_copyOfOwnerCNICFront, setFlag_copyOfOwnerCNICFront] =
    useState(null);
  const [flag_copyOfOwnerCNICBack, setFlag_copyOfOwnerCNICBack] =
    useState(null);
  const [flag_ownerNOC, setFlag_ownerNOC] = useState(null);
  const [flag_resolutionFormDesc, setFlag_resolutionFormDesc] = useState(null);
  const [flag_certFormDesc, setFlag_certFormDesc] = useState(null);
  const [flag_certMemoDesc, setFlag_certMemoDesc] = useState(null);
  const [flag_wiringTestReport, setFlag_wiringTestReport] = useState(null);

  const [ownerNOCObjectionRemarks, setOwnerNOCObjectionRemarks] = useState("");
  const [
    premisesDocumentObjectionRemarks,
    setPremisesDocumentObjectionRemarks,
  ] = useState("");
  const [
    copyOfApplicantCNICFrontObjectionRemarks,
    setCopyOfApplicantCNICFrontObjectionRemarks,
  ] = useState("");
  const [
    copyOfApplicantCNICBackObjectionRemarks,
    setCopyOfApplicantCNICBackObjectionRemarks,
  ] = useState("");
  const [
    scannedCopyOfNearByElectricityBillObjectionRemarks,
    setScannedCopyOfNearByElectricityBillObjectionRemarks,
  ] = useState("");
  const [
    anyOtherDocumentObjectionRemarks,
    setAnyOtherDocumentObjectionRemarks,
  ] = useState("");
  const [
    copyOfOwnerCNICFrontObjectionRemarks,
    setCopyOfOwnerCNICFrontObjectionRemarks,
  ] = useState("");
  const [
    copyOfOwnerCNICBackObjectionRemarks,
    setCopyOfOwnerCNICBackObjectionRemarks,
  ] = useState("");
  const [
    resolutionFormDescObjectionRemarks,
    setResolutionFormDescObjectionRemarks,
  ] = useState("");
  const [certMemoDescObjectionRemarks, setCertMemoDescObjectionRemarks] =
    useState("");
  const [certFormDescObjectionRemarks, setCertFormDescObjectionRemarks] =
    useState("");
  const [wiringTestReportObjectionRemarks, setWiringTestReportObjectionRemarks] =
    useState("");

  const [newConnectionApplications, setNewConnectionApplications] = useState(
    []
  );
  const [
    newConnectionApplicationsToDataGrid,
    setNewConnectionApplicationsToDataGrid,
  ] = useState([]);
  const [
    newConnectionApplicationsOverDue,
    setNewConnectionApplicationsOverDue,
  ] = useState([]);
  const [
    newConnectionApplicationsOverDueToDataGrid,
    setNewConnectionApplicationsOverDueToDataGrid,
  ] = useState([]);
  const [open, setOpen] = useState(false);
  const [objectionPopUpOpen, setObjectionPopUpOpen] = useState(false);
  const [arrearsEntryPopUpOpen, setArrearsEntryPopUpOpen] = useState(false);

  const [copyOfApplicantCNICVerifyPopUp, setCopyOfApplicantCNICVerifyPopUp] =
    useState(false);
  const [propertyDocVerifyPopUp, setPropertyDocVerifyPopUp] = useState(false);
  const [nearByBillVerifyPopUp, setNearByBillVerifyPopUp] = useState(false);
  const [anyOtherDocumentVerifyPopUp, setAnyOtherDocumentVerifyPopUp] =
    useState(false);
  const [copyOfOwnerCNICVerifyPopUp, setCopyOfOwnerCNICVerifyPopUp] =
    useState(false);
  const [ownerNOCVerifyPopUp, setOwnerNOCVerifyPopUp] = useState(false);
  const [resolutionFormDescVerifyPopUp, setResolutionFormDescVerifyPopUp] =
    useState(false);
  const [certFormDescVerifyPopUp, setCertFormDescVerifyPopUp] = useState(false);
  const [certMemoDescVerifyPopUp, setCertMemoDescVerifyPopUp] = useState(false);
  const [wiringTestReportVerifyPopUp, setWiringTestReportVerifyPopUp] = useState(false);
  const [installedMeterImageVerifyPopUp, setInstalledMeterImageVerifyPopUp] =
    useState(false);

  const [paidDNImagePopUp, setPaidDNImagePopUp] = useState(false);

  const [dnPaymentVerifyAlert, setDnPaymentVerifyAlert] = React.useState(false);
  const [dnPaymentRejectAlert, setDnPaymentRejectAlert] = React.useState(false);
  const [scoPart1ApproveAlert, setScoPart1ApproveAlert] = React.useState(false);
  const [scoPart2ApproveAlert, setScoPart2ApproveAlert] = React.useState(false);
  const [meterInstallationRejectAlert, setMeterInstallationRejectAlert] = React.useState(false);
  const [submitSCOApiError, setSubmitSCOApiError] = React.useState("");
  const [rejectionRemovalAlert, setRejectionRemovalAlert] =
    React.useState(false);

  const [showCostEstimation, setShowCostEstimation] = React.useState(false);
  const [showBoq, setShowBoq] = React.useState(false);

  const [costEstimationForNC, setCostEstimationForNC] = React.useState({});
  const [fieldRejectionRemovalAlert, setFieldRejectionRemovalAlert] =
    React.useState(false);
  const [wiringTestReportRejectionRemovalAlert, setWiringTestReportRejectionRemovalAlert] =
    React.useState(false);
  const [newWiringTestReportDocument, setNewWiringTestReportDocument] = useState("");
  const [newWiringTestReportDocumentThumbnail, setNewWiringTestReportDocumentThumbnail] = useState("");
  const [newWiringTestReportDocumentError, setNewWiringTestReportDocumentError] = useState("");
  const [dialogRowData, setDialogRowData] = React.useState({});
  const [itemsArray, setItemsArray] = useState([]);
  const [dnReceiptImage, setDnReceiptImage] = useState();
  const [dnReceiptImageError, setDnReceiptImageError] = useState();
  const [dnReceiptImageThumbnail, setDnReceiptImageThumbnail] = useState();
  const [dnImage, setDnImage] = useState();
  const [dnNumber, setDnNumber] = useState();
  const [dnPaymentDate, setDnPaymentDate] = useState();
  const [bankName, setBankName] = useState();
  const [itemsAmount, setItemsAmount] = useState(null);
  const [storeCharges, setStoreCharges] = useState(null);
  const [installationCharges, setInstallationCharges] = useState(null);
  const [gridSharingCost, setGridSharingCost] = useState(0);
  const [feederRehabilitationCharges, setFeederRehabilitationCharges] =
    useState(0);
  const [civilWorkCharges, setCivilWorkCharges] = useState(0);
  const [fixedChargesOfMetering, setFixedChargesOfMetering] = useState(0);
  const [miscellaneousCharges, setMiscellaneousCharges] = useState(0);
  const [lessTheCost, setLessTheCost] = useState(0);
  const [totalCharges, setTotalCharges] = useState(0);
  const [grandTotalCharges, setGrandTotalCharges] = useState(0);
  const [standardClassificationCode, setStandardClassificationCode] = useState({
    XCLFM_CODE: "",
    XCLFM_DESC: "",
  });
  const [govtDeptCode, setGovtDeptCode] = useState({
    departmentCode: "",
    departmentName: "",
  });
  const [govtDeptCodes, setGovtDeptCodes] = useState([]);
  const [manufacturerCode, setManufcaturerCode] = useState(null);
  const [eFileData, setEFileData] = useState([]);
  const [viewDropBackForEfile, setViewDropBackForEfile] = useState(false);
  const [sketchDiagramUploaded, setSketchDiagramUploaded] = useState();
  const { state } = useLocation();
  const { foundId } = state ? state : "";
  const [foundInNc, setFoundInNc] = useState();
  const [gridFlag, setGridFlag] = useState(false);
  const [feederRehabFlag, setFeederRehabFlag] = useState(false);
  const [industryFlag, setIndustryFlag] = useState(true);
  const [arearPaidBillDocument, setArearPaidBillDocument] = useState("");
  const [arearPaidBillDocumentError, setArearPaidBillDocumentError] =
    useState("");
  const [arearPaidBillDocumentThumbnail, setArearPaidBillDocumentThumbnail] =
    useState("");
  const [installedMeterImage, setInstalledMeterImage] = useState("");
  const [installedMeterImageError, setInstalledMeterImageError] = useState("");
  const [installedMeterImageThumbnail, setInstalledMeterImageThumbnail] =
    useState("");
  const [distance, setDistance] = useState("1");

  const [ripeAge, setRipeAge] = useState(0);
  const [unripeAge, setUnripeAge] = useState(0);
  const [error, setError] = useState("");
  const [fieldSurveyError, setFieldSurveyError] = useState("");

  const [newConnectionPopup, setNewConnectionPopup] = useState(false);
  const [scoPopUp, setScoPopUp] = useState(false);
  const [srnPopUp, setSrnPopUp] = useState(false);
  const [cpPopUp, setCpPopUp] = useState(false);
  const [refNoUpdatePopup, setRefNoUpdatePopup] = useState(false);
  const [newConnectionAccountNo, setNewConnectionAccountNo] = useState("");
  const [newSubBatch, setNewSubBatch] = useState("");
  const [refNoUpdateLoading, setRefNoUpdateLoading] = useState(false);

  const [openSrnPopup, setOpenSrnPopup] = useState(false);
  const [email, setEmail] = useState();

  // Dropdown companies list
  const companies = [
    { code: "11", name: "LESCO", logo: LESCODDLOGO },
    { code: "12", name: "GEPCO", logo: GEPCODDLOGO },
    { code: "13", name: "FESCO", logo: FESCODDLOGO },
    { code: "14", name: "IESCO", logo: IESCODDLOGO },
    { code: "15", name: "MEPCO", logo: MEPCODDLOGO },
    { code: "26", name: "PESCO", logo: PESCODDLOGO },
    { code: "27", name: "HAZECO", logo: HAZECODDLOGO },
    { code: "37", name: "HESCO", logo: HESCODDLOGO },
    { code: "38", name: "SEPCO", logo: SEPCODDLOGO },
    { code: "48", name: "QESCO", logo: QESCODDLOGO },
    { code: "59", name: "TESCO", logo: TESCODDLOGO },
  ];

  // Selected officeCode state
  const [selectedOfficeCode, setSelectedOfficeCode] = useState("15");
  const tableColumnsProcessingSummary = [
    {
      header: "Step",
      accessorKey: "stepName",
    },
    {
      header: "Processed By",
      accessorKey: "processedBy",
    },
    {
      header: "Date",
      accessorKey: "date",
    },

    {
      header: "Remarks",
      accessorKey: "remarks",
    },
  ];

  const [tableDataProcessingSummary, setTableDataProcessingSummary] = useState(
    []
  );

  // Sub Popup states
  const [documentsVerifiedSubPopUp, setDocumentsVerifiedSubPopUp] =
    useState(false);
  const [applicationSubittedPopUp, setApplicationSubmittedPopUp] =
    useState(false);
  const [documentsObjectionPopUp, setDocumentsObjectionPopUp] = useState(false);
  const [documentsReuploadPopUp, setDocumentsReuploadPopUp] = useState(false);
  const [arrearObjectionPopUp, setArrearObjectionPopUp] = useState(false);
  const [rejectedDocumentsList, setRejectedDocumentsList] = useState([]);
  const [activityInfo, setActivityInfo] = useState({ processedBy: '', date: '' });
  const [arrearVerifiedSubPopUp, setArrearVerifiedSubPopUp] = useState(false);
  const [fieldSurveyedSubPopUp, setFieldSurveyedSubPopUp] = useState(false);
  const [referenceNoAllocatedSubPopUp, setReferenceNoAllocatedSubPopUp] =
    useState(false);
  const [linemanAllocationSubPopUp, setLinemanAllocationSubPopUp] =
    useState(false);
  const [dnPaymentSubmittedSubPopUp, setDnPaymentSubmittedSubPopUp] =
    useState(false);
  const [dnPaymentVerifiedSubPopUp, setDnPaymentVerifiedSubPopUp] =
    useState(false);
  const [
    serviceConnectionOrderedSubPopUp,
    setServiceConnectionOrderedSubPopUp,
  ] = useState(false);
  const [meterInstalledSubPopUp, setMeterInstalledSubPopUp] = useState(false);

  // Documents states
  const [applicantCnicDocumentFront, setApplicantCnicDocumentFront] =
    useState("");
  const [applicantCnicDocumentBack, setApplicantCnicDocumentBack] =
    useState("");
  const [propertyDocuments, setPropertDocuments] = useState("");
  const [nearByBillDocument, setNearByBillDocument] = useState("");
  const [anyOtherDocument, setAnyOtherDocument] = useState("");
  const [nocOwnerDocument, setNocOwnerDocument] = useState("");
  const [ownerCnicDocumentFront, setOwnerCnicDocumentFront] = useState("");
  const [ownerCnicDocumentBack, setOwnerCnicDocumentBack] = useState("");
  const [resolutionDocument, setResolutionDocument] = useState("");
  const [memorandumDocument, setMemorandumDocument] = useState("");
  const [form29Document, setForm29Document] = useState("");
  const [applicantCnicFrontError, setApplicantCnicFrontError] = useState("");
  const [applicantCnicBackError, setApplicantCnicBackError] = useState("");
  const [propertyDocumentError, setPropertyDocumentError] = useState("");
  const [nearByBillError, setNearByBillError] = useState("");
  const [anyOtherDocumentError, setAnyOtherDocumentError] = useState("");
  // const [referenceNumberError, setReferenceNumberError] = useState('')
  const [bodError, setBodError] = useState("");
  const [memorandumError, setMemorandumError] = useState("");
  const [formError, setFormError] = useState("");
  const [ownerCnicFrontError, setOwnerCnicFrontError] = useState("");
  const [ownerCnicBackError, setOwnerCnicBackError] = useState("");
  const [nocError, setNocError] = useState("");
  // Thumbnail states
  const [
    applicantCnicDocumentFrontThumbnail,
    setApplicantCnicDocumentFrontThumbnail,
  ] = useState("");
  const [
    applicantCnicDocumentBackThumbnail,
    setApplicantCnicDocumentBackThumbnail,
  ] = useState("");
  const [propertyDocumentsThumbnail, setPropertyDocumentsThumbnail] =
    useState("");
  const [nearByBillDocumentThumbnail, setNearByBillDocumentThumbnail] =
    useState("");
  const [anyOtherDocumentThumbnail, setAnyOtherDocumentThumbnail] =
    useState("");
  const [nocOwnerDocumentThumbnail, setNocOwnerDocumentThumbnail] =
    useState("");
  const [ownerCnicDocumentFrontThumbnail, setOwnerCnicDocumentFrontThumbnail] =
    useState("");
  const [ownerCnicDocumentBackThumbnail, setOwnerCnicDocumentBackThumbnail] =
    useState("");
  const [resolutionDocumentThumbnail, setResolutionDocumentThumbnail] =
    useState("");
  const [memorandumDocumentThumbnail, setMemorandumDocumentThumbnail] =
    useState("");
  const [form29DocumentThumbnail, setForm29DocumentThumbnail] = useState("");

  const [boqItems, setBoqItems] = useState([]);
  const [fieldSurveyData, setFieldSurveyData] = useState({
    status: "",
    applicationId: "",
    isLTLWI40Flag: null,
    estDistanceInMeter: null,
    sketchDiagram: "",
    areaMarla: "",
    noOfMeterInstalled: null,
    surveyedBy: "",
    surveyDate: "",
    installedMeterRefNos: [
      {
        installedMeterRefNo: "",
      },
    ],
  });

  const [paidDnImageDetails, setPaidDnImageDetails] = useState({
    id: null,
    applicationId: "",
    demandNoticeNo: "",
    paidDNImage: "",
    uploadedBy: "",
    uploadedAt: "",
    paymentDate: "",
    painDNImageVerification: null,
  });

  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showDnExpiryPopup, setShowDnExpiryPopup] = useState(false);
  const [showQueuePriorityPopup, setShowQueuePriorityPopup] = useState(false);
  const [queuePriorityInfo, setQueuePriorityInfo] = useState({
    requestedApplicationId: "",
    nextApplicationId: "",
    requestedQueuePosition: null,
    topQueueApplicationIds: [],
  });

  const [workForceData, setWorkForceData] = useState([]);
  const [fieldStaffDesignations, setFieldStaffDesignations] = useState([]);
  const [selectedStaffId, setSelectedStaffId] = useState("");

  //#endregion

  const [meterTypeValue, setMeterTypeValue] = useState("");
  const [areaTypeValue, setAreaType] = useState("");
  const [urbanRuralValue, setUrbanRural] = useState("");
  const [errormessageCostEstimation, setErrormessageCostEstimation] =
    useState("");
  const [errormessageBoqEstimation, setErrormessageBoqEstimation] =
    useState("");

  const [estimateDistance, setEstimateDistance] = useState("");
  const [meterAlreadyInstalled, setMeterAlreadyInstalled] = useState("");
  const [showMore, setShowMore] = React.useState(false);

  //#region constants / variables
  const navigate = useNavigate();

  const fieldObjections = [
    "No Issue",
    "Unelectrified area / No network.",
    "Meters already installed at applied premises.",
    "Invalid address.",
    "Premises / Property is disputed or sub-judice.",
    "Load at site exceeds than applied.",
    "No load / building at site.",
    "Transformer overloaded",
    "Other",
  ];

  const areaMarla = ["3", "5", "7", "10", "20"];

  let batchArray = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
  ];

  let batchArrayGeneral = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
  ];

  let batchArrayGeneralString =
    "01, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23";

  let batchArrayIndustrial = [
    "24",
    "25",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
  ];

  let batchArrayIndustrialString = "24, 25, 27, 28, 29, 30, 31, 32, 33";

  let subBatchArray = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
  ];

  const tenantStatus = ["tenant", "Tenant"];

  let NCStatusBarArray = [
    {
      title1: "DOCUMENT",
      title2: "SUBMISSION",
    },
    {
      title1: "DOCUMENT",
      title2: "VERIFICATION",
    },
    {
      title1: "WIRING TEST",
      title2: "REPORT",
    },
    {
      title1: "ARREAR",
      title2: "VERIFICATION",
    },
    {
      title1: "FIELD",
      title2: "SURVEY",
    },
    {
      title1: "REF. NO",
      title2: "ALLOCATION",
    },
    {
      title1: "DN PAYMENT",
      title2: "SUBMISSION",
    },
    {
      title1: "DN PAYMENT",
      title2: "VERIFICATION",
    },
    {
      title1: "SERVICE",
      title2: "CONN. ORDER",
    },
    {
      title1: "METER",
      title2: "INSTALLATION",
    },
    {
      title1: "READY FOR",
      title2: "BILLING",
    },
  ];

  useEffect(() => {
    setFlag_wiringTestReport(null)
  }, [])

  const onCloseSrnPopup = () => {
    setOpenSrnPopup(false);
  };
  const [responseMessage, setResponseMessage] = useState("");

  const handleSubmitSrnData = () => {
    setResponseMessage("");
    setViewBackdrop(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      Email: email,
      Store_Requisition_No: [
        {
          Store_Requisition_No: srnDetails?.storeRequisitionNo,
        },
      ],
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(cfpBaseUrl + "enc/sendSROnEmail", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          setViewBackdrop(false);
          setSrnPopUp(false);
          setResponseMessage(result.message || "Email sent successfully!");
        } else {
          setViewBackdrop(false);
          setSrnPopUp(false);
          setResponseMessage(result.message || "Something went wrong.");
        }
      })
      .catch((error) => console.error(error));

    // const myHeaders = new Headers();
    // myHeaders.append("Authorization", token);
    // myHeaders.append("Content-Type", "application/json");

    // const raw = JSON.stringify({
    //   "email": email,
    //   "storeRequisitionNo": srnDetails?.storeRequisitionNo
    // });

    // const requestOptions = {
    //   method: "POST",
    //   headers: myHeaders,
    //   body: raw,
    //   redirect: "follow"
    // };

    // fetch(cfpBaseUrl + "enc/sendSROnEmail", requestOptions)
    //   .then((response) => response.json())
    //   .then((result) => {
    //     if (result.statusCode === 200) {
    //       setViewBackdrop(false)
    //       setSrnPopUp(false)
    //       setResponseMessage(result.message || "Email sent successfully!");
    //     } else {
    //       setViewBackdrop(false)
    //       setSrnPopUp(false)
    //       setResponseMessage(result.message || "Something went wrong.");
    //     }
    //   })
    //   .catch((error) => console.error(error));
  };

  const [selectedRow, setSelectedRow] = useState(null);

  const tblColumns = [
    {
      field: "applicationId",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Application Id",
      align: "center",
      headerStyle: { ...tableStyle.headerStyle, width: "3000px" },
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "creationDate",
      type: "date",
      sortable: false,
      filterable: true,
      headerName: "Date",
      align: "center",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "applicantName",
      headerName: "Applicant Name",
      sortable: false,
      filterable: false,
      type: "text",
      align: "left",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "appliedLoad",
      type: "range",
      headerName: "Load (kW)",
      sortable: false,
      filterable: true,
      align: "center",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    // {
    //   field: "tariff",
    //   type: "text",
    //   sortable: false,
    //   filterable: false,
    //   headerName: "Tariff",
    //   align: "left",
    //   headerStyle: tableStyle.headerStyle,
    //   headerCellStyle: tableStyle.headerCellStyle,
    //   rowCellStyle: { ...tableStyle.rowCellStyle, fontSize: "12px" },
    // },
    {
      field: "applicationProgressId",
      type: "singleSelect",
      sortable: false,
      filterable: true,
      valueOptions: [
        "Documents Uploading",
        "Documents Verification",
        "Wiring Test Report",
        "Arrear Verification",
        "Field Survey",
        "Reference No. Allocation",
        "Demand Note Payment",
        "DN Payment Verification",
        "SCO Creation",
        "Meter Installation",
        "Ready for Billing",
      ],
      headerName: "Description",
      align: "left",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: { ...tableStyle.rowCellStyle, fontSize: "12px" },
    },
    {
      headerName: "Docs.",
      disableColumnMenu: true,
      sortable: false,
      filterable: false,
      flex: 1,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: { ...tableStyle.rowCellStyle, fontSize: "15px" },
      field: "downloads",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <ActionsCell
            data={params}
            onOpenSRNDialog={() => {
              setSelectedRow(params);
              setOpenSrnPopup(true);
            }}
          />
        );
      },
    },
  ];

  const tblColumnsOverDue = [
    {
      field: "applicationId",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Application Id",
      align: "center",
      headerStyle: { ...tableStyleOverDue.headerStyle, width: "3000px" },
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: { ...tableStyleOverDue.rowCellStyle, marginLeft: "5px" },
    },
    {
      field: "creationDate",
      type: "date",
      headerName: "Date",
      sortable: false,
      filterable: true,
      align: "center",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: tableStyleOverDue.rowCellStyle,
    },
    {
      field: "applicantName",
      headerName: "Applicant Name",
      sortable: false,
      filterable: false,
      type: "text",
      align: "left",
      disableColumnMenu: true,
      sortable: false,
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: tableStyleOverDue.rowCellStyle,
    },
    {
      field: "appliedLoad",
      type: "range",
      headerName: "Load (kW)",
      sortable: false,
      filterable: true,
      align: "center",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: tableStyleOverDue.rowCellStyle,
    },
    // {
    //   field: "tariff",
    //   type: "text",
    //   sortable: false,
    //   filterable: false,
    //   headerName: "Tariff",
    //   align: "left",
    //   headerStyle: tableStyleOverDue.headerStyle,
    //   headerCellStyle: tableStyleOverDue.headerCellStyle,
    //   rowCellStyle: { ...tableStyleOverDue.rowCellStyle, fontSize: "12px" },
    // },
    {
      field: "applicationProgressId",
      type: "singleSelect",
      sortable: false,
      filterable: true,
      valueOptions: [
        "Documents Uploading",
        "Documents Verification",
        "Wiring Test Report",
        "Arrear Verification",
        "Field Survey",
        "Ref. No. Allocation",
        "Demand Note Payment",
        "DN Payment Verification",
        "SCO Creation",
        "Meter Installation",
        "Ready for Billing",
      ],
      headerName: "Description",
      align: "left",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: { ...tableStyleOverDue.rowCellStyle, fontSize: "12px" },
    },
    {
      field: "exceededDuration",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Days",
      align: "center",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: {
        ...tableStyleOverDue.rowCellStyle,
        color: "red",
        minWidth: "20px",
      },
    },
    {
      headerName: "Docs.",
      disableColumnMenu: true,
      sortable: false,
      filterable: false,
      flex: 1,
      filterable: false,
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: { ...tableStyleOverDue.rowCellStyle, fontSize: "15px" },
      field: "downloads",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return <ActionsCell data={params} />;
      },
    },
  ];

  //#endregion

  //#region api function

  const callTariffList = async () => {
    let tariffList = [];
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        redirect: "follow",
        headers: myHeaders,
      };

      await fetch(
        cfpBaseUrl + "customerFaciliationPortal/getTariffsDetail",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          tariffList = result.data;
          setAllTariffList(result.data);
        })
        .catch((error) => console.log("error", error));
      return tariffList;
    } catch (e) {
      console.log(e);
    } finally {
      return tariffList;
    }
  };

  const callFeederList = async (feederCode, regCode, gridCode, sDivCode) => {
    var formdata = new FormData();

    formdata.append("feederCode", feederCode);
    formdata.append("rgnCode", regCode);
    formdata.append("gridCode", gridCode);
    formdata.append("sDivCode", sDivCode);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch("https://eopsapi.pitc.com.pk/demandNotice/getFeeders", requestOptions)
      .then((response) => response.json())
      .then((result) =>
        setAllFeedersList(Array.isArray(result?.data) ? result.data : [])
      )
      .catch((error) => console.log("error", error));
  };

  // const callMaterials = async () => {
  //   let materials = []
  //   try {

  //     var formdata = new FormData();

  //     const myHeaders = new Headers();
  //     myHeaders.append("Authorization", token);

  //     var requestOptions = {
  //       method: 'POST',
  //       body: formdata,
  //       headers: myHeaders,
  //       redirect: 'follow'
  //     };

  //     await fetch(cfpBaseUrl + "demandNotice/getMaterial", requestOptions)
  //       .then(response => response.json())
  //       .then(result => {
  //         setAllMaterialList(result.data)
  //         materials = result.data
  //       })
  //       .catch(error => console.log('error', error));
  //     return materials
  //   }
  //   catch (e) {
  //     console.log(e)
  //   }
  //   finally {
  //     return materials
  //   }
  // }

  useEffect(() => {
    if (dialogRowData && dialogRowData.applicationId) {
      // callMaterials(dialogRowData.applicationId);
    }
  }, [dialogRowData]);

  // Fetch Connection Types from API
  useEffect(() => {
    const fetchConnectionTypes = async () => {
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: "",
          redirect: "follow"
        };

        const response = await fetch(cfpBaseUrl + "enc/getConnectionTypes", requestOptions);
        const result = await response.json();

        if (result.status === "200" && result.data) {
          setConnectionTypesList(result.data);
        }
      } catch (error) {
        console.error("Error fetching connection types:", error);
      }
    };

    if (token) {
      fetchConnectionTypes();
    }
  }, [token]);

  const callMaterials = async (applicationId) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        // subDivisionCode: dialogRowData.applicationId.slice(3, 8)
        // subDivisionCode: '15175'
        subDivisionCode: applicationId.slice(3, 8),
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        "https://eopsapi.pitc.com.pk/enc/getMaterialDetails",
        requestOptions
      );
      const result = await response.json();
      setAllMaterialList(result.data);

      return result.data;
    } catch (e) {
      console.log("Error in callMaterials:", e);
      return [];
    }
  };

  const referenceApi = async (reason) => {
    if (reason == "arrears checking") {
      if (
        !arearsFormik.values.iv_property_reference_no ||
        arearsFormik.values.iv_property_reference_no.length !== 14
      ) {
        return;
      } else {
        setViewBackdrop(true);
        let apiResponse = await dBillAPI(
          token,
          arearsFormik.values.iv_property_reference_no
        );
        if (apiResponse.status) {
          setError();
          let basicInfo = apiResponse.basicInfo;
          let arrearDetailsObj = {};
          if (basicInfo.arrear != "" && basicInfo.arrear > 0) {
            setNoArrears("");
            arrearDetailsObj.arrearsAmount = numberFormatting(basicInfo.arrear);
            arrearDetailsObj.meterStatus = basicInfo.meter1Status;
            arrearDetailsObj.tariffDesc = basicInfo.tariffDescription;
            arrearDetailsObj.meterType = basicInfo.meterType;
            arrearDetailsObj.phase = basicInfo.phase;
            arrearDetailsObj.consumerName = basicInfo.consumerName;
            arrearDetailsObj.consumerNo = basicInfo.consumerContactNo;
            arrearDetailsObj.consumerAddress =
              basicInfo.consumerAddress1 + " " + basicInfo.consumerAddress2;
            arrearDetailsObj.consumerEmail = basicInfo.consumerEmail;
            setArrearsDetailsRefno(arrearDetailsObj);
          } else {
            let emptyArearObject = {
              arrearsAmount: "",
              meterStatus: "",
              tariffDesc: "",
              meterType: "",
              phase: "",
              consumerName: "",
              consumerNo: "",
              consumerAddress: "",
              consumerEmail: "",
            };
            setArrearsDetailsRefno(emptyArearObject);
            setNoArrears("No arrear exist's for entered reference number.");
          }
        } else if (apiResponse.status == false) {
          setError("No Data Found against this Reference number");
        } else {
          setError("Reference Number does not exist.");
        }
        setViewBackdrop(false);
      }
    } else if (reason == "application edit") {
      if (
        !editBasicInfoFormik.values.iv_near_by_reference_no ||
        editBasicInfoFormik.values.iv_near_by_reference_no.length !== 14
      ) {
        return;
      } else {
        setViewBackdrop(true);
        let apiResponse = await dBillAPI(
          token,
          editBasicInfoFormik.values.iv_near_by_reference_no
        );
        if (apiResponse.status) {
          setError();
          let basicInfo = apiResponse.basicInfo;
          editBasicInfoFormik.values.iv_near_by_name = basicInfo.consumerName;
          editBasicInfoFormik.values.iv_near_by_address = (
            basicInfo.consumerAddress1 + basicInfo.consumerAddress2
          ).trimStart();
        } else if (apiResponse.status == false) {
          setError("No Data Found against this Reference number");
        } else {
          setError("Reference Number does not exist.");
        }
      }
      setViewBackdrop(false);
    }
  };

  const callingUpdateDocumentStatusWithObjectionAPI = async (
    applicationId = dialogRowData.applicationId,
    applicationProgressId = dialogRowData.applicationProgressId,
    objectionStatus = dialogRowData.objectionStatus,
    flag_ownerNOC,
    flag_premisesDocument,
    flag_copyOfApplicantCNICFront,
    flag_copyOfApplicantCNICBack,
    flag_scannedCopyOfNearByElectricityBill,
    flag_anyOtherDocument,
    flag_copyOfOwnerCNICFront,
    flag_copyOfOwnerCNICBack,
    flag_resolutionFormDesc,
    flag_certMemoDesc,
    flag_certFormDesc,
    ownerNOCObjectionRemarks,
    premisesDocumentObjectionRemarks,
    copyOfApplicantCNICFrontObjectionRemarks,
    copyOfApplicantCNICBackObjectionRemarks,
    scannedCopyOfNearByElectricityBillObjectionRemarks,
    anyOtherDocumentObjectionRemarks,
    copyOfOwnerCNICFrontObjectionRemarks,
    copyOfOwnerCNICBackObjectionRemarks,
    resolutionFormDescObjectionRemarks,
    certMemoDescObjectionRemarks,
    certFormDescObjectionRemarks,
    remarks
  ) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);
    formdata.append("applicationProgressId", applicationProgressId);
    formdata.append("objectionStatus", objectionStatus);
    formdata.append("remarks", remarks);
    if (flag_ownerNOC === null) {
      formdata.append("ownerNOCFlag", "");
    } else {
      formdata.append("ownerNOCFlag", flag_ownerNOC);
    }
    formdata.append("premisesDocumentFlag", flag_premisesDocument);
    formdata.append(
      "copyOfApplicantCNICFrontFlag",
      flag_copyOfApplicantCNICFront
    );
    formdata.append(
      "copyOfApplicantCNICBackFlag",
      flag_copyOfApplicantCNICBack
    );
    if (flag_scannedCopyOfNearByElectricityBill === null) {
      formdata.append("scannedCopyOfNearByElectricityBillFlag", "");
    } else {
      formdata.append(
        "scannedCopyOfNearByElectricityBillFlag",
        flag_scannedCopyOfNearByElectricityBill
      );
    }
    if (flag_anyOtherDocument === null) {
      formdata.append("anyOtherDocumentFlag", "");
    } else {
      formdata.append("anyOtherDocumentFlag", flag_anyOtherDocument);
    }
    if (flag_copyOfOwnerCNICFront === null) {
      formdata.append("copyOfOwnerCNICFrontFlag", "");
    } else {
      formdata.append("copyOfOwnerCNICFrontFlag", flag_copyOfOwnerCNICFront);
    }
    if (flag_copyOfOwnerCNICBack === null) {
      formdata.append("copyOfOwnerCNICBackFlag", "");
    } else {
      formdata.append("copyOfOwnerCNICBackFlag", flag_copyOfOwnerCNICBack);
    }
    if (flag_resolutionFormDesc === null) {
      formdata.append("resolutionFormDescFlag", "");
    } else {
      formdata.append("resolutionFormDescFlag", flag_resolutionFormDesc);
    }
    if (flag_certMemoDesc === null) {
      formdata.append("certMemoDescFlag", "");
    } else {
      formdata.append("certMemoDescFlag", flag_certMemoDesc);
    }
    if (flag_certFormDesc === null) {
      formdata.append("certFormDescFlag", "");
    } else {
      formdata.append("certFormDescFlag", flag_certFormDesc);
    }

    formdata.append("ownerNOCObjectionRemarks", ownerNOCObjectionRemarks);
    formdata.append(
      "premisesDocumentObjectionRemarks",
      premisesDocumentObjectionRemarks
    );
    formdata.append(
      "copyOfApplicantCNICFrontObjectionRemarks",
      copyOfApplicantCNICFrontObjectionRemarks
    );
    formdata.append(
      "copyOfApplicantCNICBackObjectionRemarks",
      copyOfApplicantCNICBackObjectionRemarks
    );
    formdata.append(
      "scannedCopyOfNearByElectricityBillObjectionRemarks",
      scannedCopyOfNearByElectricityBillObjectionRemarks
    );
    formdata.append(
      "anyOtherDocumentObjectionRemarks",
      anyOtherDocumentObjectionRemarks
    );
    formdata.append(
      "copyOfOwnerCNICFrontObjectionRemarks",
      copyOfOwnerCNICFrontObjectionRemarks
    );
    formdata.append(
      "copyOfOwnerCNICBackObjectionRemarks",
      copyOfOwnerCNICBackObjectionRemarks
    );
    formdata.append(
      "resolutionFormDescObjectionRemarks",
      resolutionFormDescObjectionRemarks
    );
    formdata.append(
      "certMemoDescObjectionRemarks",
      certMemoDescObjectionRemarks
    );
    formdata.append(
      "certFormDescObjectionRemarks",
      certFormDescObjectionRemarks
    );

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "enc/updateDocumentFlag", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          setFlag_copyOfApplicantCNICFront(null);
          setFlag_copyOfApplicantCNICBack(null);
          setFlag_premisesDocument(null);
          setFlag_scannedCopyOfNearByElectricityBill(null);
          setFlag_anyOtherDocument(null);
          setFlag_copyOfOwnerCNICFront(null);
          setFlag_copyOfOwnerCNICBack(null);
          setFlag_ownerNOC(null);
          setFlag_resolutionFormDesc(null);
          setFlag_certMemoDesc(null);
          setFlag_certFormDesc(null);
          handleClose();

          // else {
          //   updateProgressIdToDocumentsVerified()
          // }
        } else {
          // console.log(result.message)
        }
      })
      .catch((error) => console.log("error", error));
  };

  const callChangeProgressIdAPI = async (
    applicationProgressId,
    status,
    remarks,
    remarksDetails = "-",
    id = dialogRowData.applicationId
  ) => {
    var formdata = new FormData();

    formdata.append("applicationId", id);
    formdata.append("applicationProgressId", applicationProgressId);
    formdata.append("remarks", remarks);
    formdata.append("remarksDetails", remarksDetails);
    formdata.append("lastModifiedBy", userId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "comman/changeProgressId", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          handleClose();
        } else {
          // console.log(result.message)
        }
      })
      .catch((error) => console.log("error", error));

    // setOpen(false);
  };

  const callChangeObjectionStatus = async (
    objectionStatus,
    remarks,
    remarksDetails = "-"
  ) => {
    var formdata = new FormData();
    formdata.append("applicationId", dialogRowData.applicationId);
    formdata.append("objectionStatus", objectionStatus);
    formdata.append("remarks", remarks);
    formdata.append("remarksDetails", remarksDetails);
    formdata.append("lastModifiedBy", userId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "comman/changeObjectionStatus", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          handleClose();
        } else {
          // console.log(result.message)
        }
      })
      .catch((error) => console.log("error", error));

    setRejectionRemovalAlert(false);
    setObjectionPopUpOpen(false);
    setFieldRejectionRemovalAlert(false);
  };

  const callResetObjectionStatus = async (applicationId) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      cfpBaseUrl + "electricityNewConnection/resetObjectionStatus",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          // setDialogRowData(lclStrdNewConApp[index])
        } else {
          // console.log(result.message)
        }
      })
      .catch((error) => console.log("error", error));
  };

  const [srnDetails, setSrnDetails] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const callDNPaymentVerification = async (
    applicationId,
    applicationProgressId,
    remarks,
    objectionStatus,
    paidDnImageRemarks,
    paidDnImageFlag
  ) => {
    if (applicationId) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: applicationId,
        applicationProgressId: applicationProgressId,
        remarks: remarks,
        objectionStatus: objectionStatus,
        paidDnImageRemarks: paidDnImageRemarks,
        paidDnImageFlag: paidDnImageFlag,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "enc/verifyPaidDNIamgeNew", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          setViewBackdrop(false);
          if (result.status === "200") {
            setErrorMessage(result.message);
            handleClose();
            setScoPopUp(true);
            setSrnPopUp(true);
            setSrnDetails(result);
            setShowMore(false);
          } else if (result.status === "400") {
            handleClose();
            setSrnDetails(result);
            setSrnPopUp(true);
            setErrorMessage(result.message);
            setShowMore(false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const callSCOApprovePart1API = async (scoId) => {
    var formdata = new FormData();
    formdata.append("scoId", scoId);
    formdata.append("authorizedByName", userId);
    formdata.append("authorizedByDesignation", roleName);
    formdata.append("scoP1ApprovedFlag", 1);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "sco/scoP1Approval", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          // console.log(result.message)
          callChangeProgressIdAPI(
            5,
            "Demand Notice Created",
            "Demand Notice Created"
          );
        } else {
          // console.log(result.message)
        }
      })
      .catch((error) => console.log(error));
  };

  const callSCOApprovePart2API = async (scoId) => {
    var formdata = new FormData();
    formdata.append("scoId", scoId);
    formdata.append("scoP2ApprovedBy", userId);
    formdata.append("scoP2ApprovedByDesignation", roleName);
    formdata.append("scoP2ApprovalFlag", 1);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "sco/scoP2Approval", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          // console.log(result.message)
          var formdata = new FormData();
          formdata.append("applicationId", dialogRowData.applicationId);
          formdata.append("cp136Type", 1);

          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);

          var requestOptions = {
            method: "POST",
            body: formdata,
            headers: myHeaders,
            redirect: "follow",
          };
          fetch(cfpBaseUrl + "cpForm136/cp136Creation", requestOptions)
            .then((response) => response.json())
            .then((result) => {
              if (result.status === "200") {
                callChangeProgressIdAPI(
                  9,
                  "Meter Installed",
                  "Meter Installed"
                );
                // console.log(result.message)
              } else {
                // console.log(result.message)
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          // console.log(result.message)
        }
      })
      .catch((error) => console.log(error));
  };

  const callGetSCOAPI = async (applicationId, phase) => {
    try {
      let scoDets = "";
      if (applicationId) {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: applicationId,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        await fetch(cfpBaseUrl + "enc/getSCODetails", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              setScoDetails(result.data[0]);
              if (result.data[0].scoP1FillFlag === 1) {
                refNoAllocationFormik.values.iv_feeder_no =
                  result.data[0].feederNo;
                refNoAllocationFormik.values.iv_batch = result.data[0].batch;
                refNoAllocationFormik.values.iv_sub_batch =
                  result.data[0].subBatch;
                refNoAllocationFormik.values.iv_fata_pata =
                  result.data[0].fataPata;
                refNoAllocationFormik.values.iv_rural_urban =
                  result.data[0].urbanRural;
                refNoAllocationFormik.values.iv_fgovt = result.data[0].fGovt;
                refNoAllocationFormik.values.iv_cantonment_board =
                  result.data[0].cantonmentBoard;

                let gdc = govtDeptCodes.find(
                  (item) =>
                    item.departmentCode ==
                    result.data[0].governmentDepartmentCode
                );
                console.log(gdc, "gdc");
                setGovtDeptCode(gdc);
                refNoAllocationFormik.values.iv_govt_dept_code = parseInt(
                  result.data[0].governmentDepartmentCode
                );
                refNoAllocationFormik.values.iv_pgovt = result.data[0].pGovt;
                refNoAllocationFormik.values.iv_local_bodies =
                  result.data[0].localBodies;
              } else {
              }
              if (result.data[0].scoP2FillFlag === 1) {
                scoPart2Formik.setFieldValue("iv_store_requisition_no", result.data[0].storeRequisitionNo);
                scoPart2Formik.setFieldValue("iv_store_requisition_date", result.data[0].storeRequisitionDate.slice(0, 10));
                scoPart2Formik.setFieldValue("iv_seasonal_flag", result.data[0].seasonalFlag);
                scoPart2Formik.setFieldValue("iv_no_of_acs", result.data[0].noOfACs);
                scoPart2Formik.setFieldValue("iv_no_of_meters", result.data[0].noOfMeters);
                scoPart2Formik.setFieldValue("iv_no_of_meter_sets", result.data[0].noOfMeterSets);
                scoPart2Formik.setFieldValue("iv_no_of_sub_sets", result.data[0].noOfSubSets);
                scoPart2Formik.setFieldValue("iv_no_ofsupply_points", result.data[0].noOfSupplyPoints);
                scoPart2Formik.setFieldValue("iv_transformer_code", result.data[0].installedTransformerCapacity);
                scoPart2Formik.setFieldValue("iv_transformer_refNo", result.data[0].transformerRefNo);
                scoPart2Formik.setFieldValue("iv_meter_id", result.data[0].meterId);
                scoPart2Formik.setFieldValue("iv_meter_serial_no", result.data[0].meterNo);
                scoPart2Formik.setFieldValue("iv_sim_ID", result.data[0].simId);
                scoPart2Formik.setFieldValue("iv_sim_number", result.data[0].simNumber);
                scoPart2Formik.setFieldValue("iv_location_code", result.data[0].locationCode ? result.data[0].locationCode : "");
                scoPart2Formik.setFieldValue("iv_meter_code1", result.data[0].meterCode1);
                scoPart2Formik.setFieldValue("iv_meter_code2", result.data[0].meterCode2);
                scoPart2Formik.setFieldValue("iv_manufacturer_code", result.data[0].manufacturerCode);
                let mC = manufacturesList.find(
                  (item) => item.code == result.data[0].manufacturerCode
                );
                setManufcaturerCode(mC);
                scoPart2Formik.setFieldValue("iv_multiplying_factor", result.data[0].multiplyingFactor);
                scoPart2Formik.setFieldValue("iv_meter_range", result.data[0].meterRange);
                scoPart2Formik.setFieldValue("iv_meter_reading", result.data[0].meterReading);

                scoPart2Formik.setFieldValue("iv_cp_78_item_no", result.data[0].cp78ItemNo);
                scoPart2Formik.setFieldValue("iv_tie_up_non_tie_up", result.data[0].tieUpNonTieUp);
                scoPart2Formik.setFieldValue("iv_seal_on_meter", result.data[0].sealOnMeter);
                scoPart2Formik.setFieldValue("iv_seal_on_box", result.data[0].sealOnBox);
                scoPart2Formik.setFieldValue("iv_security_slip_or_price_bond_no", result.data[0].securitySlipOrPriceBondNo);
                scoPart2Formik.setFieldValue("iv_connection_installer_name", result.data[0].connectionInstallerName);
                scoPart2Formik.setFieldValue("iv_installed_meter_image", result.data[0].installedMeterImage);
                scoPart2Formik.setFieldValue("iv_meter_type", result.data[0].meterType);
                setMeterTypeValueForCheck(result.data[0].meterType);
                if (phase == "3 Phase") {
                  scoPart2Formik.setFieldValue("iv_meter_reading_peak_kwh", result.data[0].threePhasePeak);
                  scoPart2Formik.setFieldValue("iv_meter_reading_off_peak_kwh", result.data[0].threePhaseOffPeak);
                } else {
                  scoPart2Formik.setFieldValue("iv_meter_reading_peak_kwh", result.data[0].threePhasePeakKWH);
                  scoPart2Formik.setFieldValue("iv_meter_reading_off_peak_kwh", result.data[0].threePhaseOffPeakKWH);
                }
                scoPart2Formik.setFieldValue("iv_mdi", result.data[0].mdi);
                scoPart2Formik.setFieldValue("iv_no_of_mdi_resets", result.data[0].noOfMDIreset);
                scoPart2Formik.setFieldValue("iv_ct", result.data[0].cT);
                scoPart2Formik.setFieldValue("iv_pt", result.data[0].pT);
                scoPart2Formik.setFieldValue("iv_ct_nom", result.data[0].cTN == 0 ? 5 : result.data[0].cTN);
                scoPart2Formik.setFieldValue("iv_pt_nom", result.data[0].pTN == 0 ? 5 : result.data[0].pTN);
                scoPart2Formik.setFieldValue("iv_ct_denom", result.data[0].cTD == 0 ? 5 : result.data[0].cTD);
                scoPart2Formik.setFieldValue("iv_pt_denom", result.data[0].pTD == 0 ? 5 : result.data[0].pTD);
                scoPart2Formik.setFieldValue("iv_meter_reading_peak_kvarh", result.data[0].threePhasePeakKVARH);
                scoPart2Formik.setFieldValue("iv_meter_reading_off_peak_kvarh", result.data[0].threePhaseOffPeakKVARH);
                setInstalledMeterImageThumbnail(
                  result.data[0].installedMeterImage
                );
              } else {
              }
              scoDets = result.data[0];
            } else {
              // console.log("NO SCO")
            }
          })
          .catch((error) => console.log("error", error));
      }
      return scoDets;
    } catch (e) {
      console.log(e, "Unable to get SCO Details");
    }
  };

  const callGetCP136API = async (applicationId) => {
    try {
      var formdata = new FormData();
      formdata.append("applicationId", applicationId);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "cpForm136/cpForm136Details", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          // if (result.status === "200") {
          //   setMasterDataFormDetails(result.data[0]);
          //   if (result.data[0].filledByFlag === 1) {
          //     masterDataFormik.values.iv_govt_dept =
          //       result.data[0].governmentDepartment;
          //     masterDataFormik.values.iv_ed_code =
          //       result.data[0].electricityDuty;
          //     masterDataFormik.values.iv_standard_classification_code =
          //       result.data[0].standardClassificationCode;
          //     let sc = standardClassificationCodes.find(
          //       (item) =>
          //         item.XCLFM_CODE === result.data[0].standardClassificationCode
          //     );
          //     setStandardClassificationCode(sc);
          //     masterDataFormik.values.iv_income_tax = result.data[0].incomeTax;
          //   }
          // }
          if (result.status === "200") {
            setMasterDataFormDetails(result.data[0]);

            if (result.data[0].filledByFlag === 1) {
              masterDataFormik.setFieldValue(
                "iv_govt_dept",
                result.data[0].governmentDepartment
              );
              masterDataFormik.setFieldValue(
                "iv_ed_code",
                result.data[0].electricityDuty
              );
              masterDataFormik.setFieldValue(
                "iv_standard_classification_code",
                result.data[0].standardClassificationCode
              );
              masterDataFormik.setFieldValue(
                "iv_income_tax",
                result.data[0].incomeTax
              );

              let sc = standardClassificationCodes.find(
                (item) => item.XCLFM_CODE === result.data[0].standardClassificationCode
              );
              setStandardClassificationCode(sc);
            }
          }

        })
        .catch((error) => console.log("error", error));
    } catch (e) {
      console.log(e, "Unable to get Master Form Data!");
    }
  };

  const callApproveCP136API = async (applicationId) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);
    formdata.append("approvedBy", userId);
    formdata.append("approvedByDesignation", roleName);
    formdata.append("approvalFlag", 1);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "cpForm136/cpForm136Approval", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callChangeProgressIdAPI(
            10,
            "Application Completed",
            "Application Completed"
          );
          // console.log(result.message)
        } else {
          // console.log(result.message)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const callEfileAPI = async (applicationId, application) => {
    // let application = newConnectionApplications.find((item) => { return item.applicationId === applicationId })
    setViewDropBackForEfile(true);
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "electricityNewConnection/getApplicationHist",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          let applicationCurrentState = result.applicationCurrentState[0];
          let applicationHistory = result.applicationHistory;
          if (applicationHistory === "No History Found") {
            applicationHistory = [];
          }

          applicationHistory.push(applicationCurrentState);
          let sortedApplicationHistory = applicationHistory.sort((a, b) => {
            const dateA = new Date(a.lastModificationDate);
            const dateB = new Date(b.lastModificationDate);
            return dateB - dateA;
          });
          console.log(applicationHistory, "applicationHistory");
          setEFileData(sortedApplicationHistory);

          let dataforTable = [];

          sortedApplicationHistory.forEach((item) => {
            // Skip applicationProgressId 0 here - we'll add it manually at the end
            if (
              item.applicationProgressId !== 0 &&
              item.lastModifiedBy &&
              item.lastModificationDate
            ) {
              let object = {};
              object.stepName = stepName(
                item.applicationProgressId,
                item.remarks,
                item.objectionStatus
              );
              object.processedBy = item.lastModifiedBy
                ? item.lastModifiedBy
                : "Last Modified By Name";
              object.date = item.lastModificationDate
                ? convertDatewithTimeWithoutSecond(item.lastModificationDate)
                : "Last Modification Time";
              object.remarks = item.remarks ? item.remarks : "-";
              dataforTable.push(object);
            }
          });

          // Add "Application Submitted" only once at the end
          dataforTable.push({
            date: convertDate(application.creationDate),
            processedBy:
              application.submittedThrough != "e-Operations"
                ? application.applicantName
                : sortedApplicationHistory[0].createdBy,
            stepName: "Application Submitted",
            time: convertDatewithTimeWithoutSecond(
              application.creationDate
            ).slice(11, 17),
            remarks: "Application Submitted.",
          });
          console.log(dataforTable, "dataforTable");

          setTableDataProcessingSummary(dataforTable);
        } else {
        }
      })
      .catch((error) => console.log("error", error))
      .finally(() => setViewDropBackForEfile(false));
  };

  const callApproveFieldAPI = async (applicationId) => {
    var formdata = new FormData();

    formdata.append("approvedBy", userId);
    formdata.append("approvedByDesignation", roleName);
    formdata.append("approvedFlag", 1);
    formdata.append("applicationNo", applicationId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "PUT",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "demandNotice/approveFeildVerification",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callSCOApprovePart1API(scoDetails.scoId);
        } else {
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const callAsyncDnDetailsAPI = async (applicationId) => {
    try {
      let dnDets = {};
      let boqItems = [];
      let dnExpiryFlag = 0;

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: applicationId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "enc/getDemandNoteData", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            console.log(result, "boqItems32433243453");
            setIsDemandNoteExpired(result.dnExpiryFlag);
            dnDets = result.data[0];
            boqItems = result.BoQitems ? result.BoQitems : [];
            dnExpiryFlag = result.dnExpiryFlag;
            setDnDetails(result.data[0]);
          }
        })
        .catch((error) => console.log("error", error));
      return { dnDets, boqItems, dnExpiryFlag };
    } catch (e) {
      console.log(e, "Unable to get Demand Notice.");
      return { dnDets: {}, boqItems: [] };
    }
  };

  const callAsyncGetSCOAPI = async (applicationId) => {
    try {
      let scoDets = {};
      if (applicationId) {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: applicationId,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        await fetch(cfpBaseUrl + "enc/getSCODetails", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              scoDets = result.data[0];
              setScoDetails(result.data[0]);
            }
          })
          .catch((error) => console.log("error", error));
        return scoDets;
      }
    } catch (e) {
      console.log(e, "Unable to get SCO Details");
    }
  };

  const callAsyncGetCP136API = async (applicationId) => {
    try {
      let cpDets = {};
      var formdata = new FormData();
      formdata.append("applicationId", applicationId);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "cpForm136/cpForm136Details", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            cpDets = result.data[0];
          }
        })
        .catch((error) => console.log("error", error));

      return cpDets;
    } catch (e) {
      console.log(e, "Unable to get Master Form Data!");
    }
  };

  const callAsyncGetDocumentsAPI = async (applicationId) => {
    try {
      setViewBackdrop(true);
      let appDocs = {};
      var formdata = new FormData();
      formdata.append("applicationId", applicationId);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "electricityNewConnection/getDocuments",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setViewBackdrop(false);
            appDocs = result.images[0];
          } else {
            setViewBackdrop(false);
          }
        })
        .catch((error) => {
          setViewBackdrop(false);
          console.log("error", error);
        });

      return appDocs;
    } catch (e) {
      console.log(e, "Unable to get Master Form Data!");
    }
  };

  const callAsyncGetPaidDnImageAPI = async (applicationId) => {
    try {
      let dnImage = "";
      var formdata = new FormData();

      formdata.append("applicationNo", applicationId);
      formdata.append("demandNoticeNo", "");

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "demandNotice/getPaidDNImage", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setPaidDnImageDetails(result.data[0]);
            dnImage = result.data[0].paidDNImage;
          }
        })
        .catch((error) => console.log("error", error));
      return dnImage;
    } catch (e) {
      console.log(e, "Error in calling paid dn image");
    }
  };

  const callAsyncFieldSurveyInformation = async (applicationId) => {
    if (applicationId) {
      var formdata = new FormData();
      formdata.append("applicationId", applicationId);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "demandNotice/getFieldSurvey", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setIsLTLWI40Flag(result.isLTLWI40Flag);
            fieldFormik.values.iv_distance = result.isLTLWI40Flag;
            fieldFormik.values.iv_estimated_distance =
              result.estDistanceInMeter;
            fieldFormik.values.iv_meter_type =
              result.meterType !== null && result.meterType !== undefined
                ? String(result.meterType)
                : "1";
            setSketchDiagramThumbnail(result.sketchDiagram);
            fieldFormik.values.iv_coverage_area = result.areaMarla;
            fieldFormik.values.iv_no_of_meters_already_installed =
              result.noOfMeterInstalled;
            let existingReferenceNumbers = Array.isArray(result.installedMeterRefNos) ? result.installedMeterRefNos : [];
            existingReferenceNumbers.forEach((item) => (item.actualFlag = null));
            setAlreadyInstalledRefNos(existingReferenceNumbers);
            setFieldSurveyData(result);
          }
        })
        .catch((error) => console.log("error", error));
    }
  };

  const deleteFieldSurvey = async (
    applicationId = dialogRowData.applicationId
  ) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "demandNotice/deleteFeildSurveyAndDNData",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callDeleteSCOAPI(applicationId);
          callAsyncResetDocsFlags(applicationId);
          callChangeProgressIdAPI(
            1,
            "Reference Number Allocation Objection",
            formik.values.iv_objection_Type,
            formik.values.iv_objection_Type
          );
          setDnDetails(!dnDetails.filledFlag);
        } else {
          setError(result.message);
        }
      });
  };

  const callDeleteSCOAPI = async (applicationId) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    const formdata = new FormData();
    formdata.append("applicationId", applicationId);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "sco/deleteSCO", requestOptions)
      .then((response) => response.json())
      .then((result) => { })
      .catch((error) => console.error(error));
  };

  const updateSco1Flag = async (
    applicationId = dialogRowData.applicationId,
    scoId = scoDetails.scoId
  ) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);
    formdata.append("scoId", scoId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "sco/updateSCOPart1Flag", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callChangeProgressIdAPI(
            7,
            "SCO. Part1 Rejected",
            "SCO. Part1 Rejected"
          );
          setScoDetails(scoDetails.scoP1FillFlag === null);
        } else {
          setError(result.message);
        }
      });
  };

  const updateCpFlag = async (applicationId = dialogRowData.applicationId) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "cpForm136/updateCP136Flag", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callChangeProgressIdAPI(9, "CP 136 Rejected", "CP 136 Rejection");
          setMasterDataFormDetails(masterDataFormDetails.filledByFlag === null);
        } else {
          setError(result.message);
        }
      });
  };

  const callAsyncResetDocsFlags = async (
    applicationId = dialogRowData.applicationId
  ) => {
    setViewBackdrop(true);
    var formdata = new FormData();
    formdata.append("applicationNo", applicationId);
    formdata.append("ownerNOCFlag", "");
    formdata.append("premisesDocumentFlag", "");
    formdata.append("copyOfApplicantCNICFlag", "");
    formdata.append("scannedCopyOfNearByElectricityBillFlag", "");
    formdata.append("copyOfOwnerCNICFlag", "");
    formdata.append("resolutionFormDescFlag", "");
    formdata.append("certMemoDescFlag", "");
    formdata.append("certFormDescFlag", "");
    formdata.append("ownerNOCObjectionRemarks", "");
    formdata.append("premisesDocumentObjectionRemarks", "");
    formdata.append("copyOfApplicantCNICFrontObjectionRemarks", "");
    formdata.append("copyOfApplicantCNICBackObjectionRemarks", "");
    formdata.append("scannedCopyOfNearByElectricityBillObjectionRemarks", "");
    formdata.append("copyOfOwnerCNICFrontObjectionRemarks", "");
    formdata.append("copyOfOwnerCNICBackObjectionRemarks", "");
    formdata.append("resolutionFormDescObjectionRemarks", "");
    formdata.append("certMemoDescObjectionRemarks", "");
    formdata.append("certFormDescObjectionRemarks", "");
    formdata.append("anyOtherDocumentFlag", "");
    formdata.append("anyOtherDocumentObjectionRemarks", "");

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "electricityNewConnection/updateDocumentFlag",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          // setNewConnectionApplications(allApplications)
          setViewBackdrop(false);
        } else {
          setViewBackdrop(false);
        }
      })
      .catch((error) => console.log("error", error));
  };

  const callDemandNoteRenewalAPI = async (
    applicationId = dialogRowData.applicationId
  ) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      const formdata = new FormData();
      formdata.append("applicationNo", applicationId);
      formdata.append("lastModifiedBy", userId);
      formdata.append("remarks", "DN Renewed.");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "demandNotice/renewExpiredDN", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            handleClose();
          } else {
            // setError(result.message)
            // console.log(result.message)
          }
        })
        .catch((error) => console.error(error));
    } catch (e) {
      console.log(e);
    }
  };

  const getWFData = async () => {
    setViewBackdrop(true);
    let wfData = await getWorkforceData(
      token,
      code
    );
    setWorkForceData(wfData);
    setViewBackdrop(false);
  };

  const callAssignmentAPI = async (applicationId, wfId) => {
    setViewBackdrop(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        assignedTo: wfId,
        lastModifiedBy: userId,
        applicationId: applicationId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "workForce/assignToEmployee", requestOptions)
        .then(async (response) => {
          if (response.status == 200) {
            return response.json();
          } else {
            let res = await response.json();
            alert(res.message);
          }
        })
        .then((result) => {
          // setLinemanAllocationSubPopUp(false)
          alert(result.message);
        })
        .catch((error) => console.error(error));
    } catch (e) { }
    setLinemanAllocationSubPopUp(false);
    setViewBackdrop(false);
  };
  //#endregion

  //#region functions

  function getTariffsForValue(value, tariffs) {
    return tariffs.filter((tariff) => {
      const from = parseInt(tariff.from, 10);
      const to = parseInt(tariff.to, 10);
      return value >= from && value <= to;
    });
  }

  const NearByReferenceNumber = (event) => {
    editBasicInfoFormik.handleChange(event);
    setNearByReferenceNumber(event.target.value);
  };

  const handleEditIconClick = async () => {
    let appDocs = await callAsyncGetDocumentsAPI(dialogRowData.applicationId);

    console.log(appDocs, "appDocs");
    console.log(dialogRowData, "dialogRowData");

    editBasicInfoFormik.values.iv_applicant_cnic_document_front =
      appDocs.copyOfApplicantCNICFront;
    setApplicantCnicDocumentBack(appDocs.copyOfApplicantCNICFront);
    setApplicantCnicDocumentFront(appDocs.copyOfApplicantCNICBack);
    setPropertDocuments(appDocs.premisesDocument);
    setNearByBillDocument(appDocs.scannedCopyOfNearByElectricityBill);
    setAnyOtherDocument(appDocs.anyOtherDocument);
    setOwnerCnicDocumentFront(appDocs.copyOfOwnerCNICFront);
    setOwnerCnicDocumentBack(appDocs.copyOfOwnerCNICBack);
    setNocOwnerDocument(appDocs.ownerNOC);
    setResolutionDocument(appDocs.resolutionFormDesc);
    setMemorandumDocument(appDocs.certMemoDesc);
    setForm29Document(appDocs.certFormDesc);
    setApplicantCnicDocumentBackThumbnail(appDocs.copyOfApplicantCNICFront);
    setApplicantCnicDocumentFrontThumbnail(appDocs.copyOfApplicantCNICBack);
    setPropertyDocumentsThumbnail(appDocs.premisesDocument);
    setNearByBillDocumentThumbnail(appDocs.scannedCopyOfNearByElectricityBill);
    setAnyOtherDocumentThumbnail(appDocs.anyOtherDocument);
    setOwnerCnicDocumentFrontThumbnail(appDocs.copyOfOwnerCNICFront);
    setOwnerCnicDocumentBackThumbnail(appDocs.copyOfOwnerCNICBack);
    setNocOwnerDocumentThumbnail(appDocs.ownerNOC);
    setResolutionDocumentThumbnail(appDocs.resolutionFormDesc);
    setMemorandumDocumentThumbnail(appDocs.certMemoDesc);
    setForm29DocumentThumbnail(appDocs.certFormDesc);
    editBasicInfoFormik.values.iv_applicant_cnic_document_back =
      appDocs.copyOfApplicantCNICBack;
    editBasicInfoFormik.values.iv_property_documents = appDocs.premisesDocument;
    editBasicInfoFormik.values.iv_near_by_bill =
      appDocs.scannedCopyOfNearByElectricityBill;
    editBasicInfoFormik.values.iv_any_other_document = appDocs.anyOtherDocument;
    editBasicInfoFormik.values.iv_owner_cnic_document_front =
      appDocs.copyOfOwnerCNICFront;
    editBasicInfoFormik.values.iv_owner_cnic_document_back =
      appDocs.copyOfOwnerCNICBack;
    editBasicInfoFormik.values.iv_noc_owner = appDocs.ownerNOC;
    editBasicInfoFormik.values.iv_resolution = appDocs.resolutionFormDesc;
    editBasicInfoFormik.values.iv_memo = appDocs.certMemoDesc;
    editBasicInfoFormik.values.iv_form29initial = appDocs.certFormDesc;

    editBasicInfoFormik.values.iv_connection_type =
      dialogRowData.connectionType;
    editBasicInfoFormik.values.iv_applicant_name = dialogRowData.applicantName;
    editBasicInfoFormik.values.iv_applicant_cnic = dialogRowData.applicantCNIC;
    editBasicInfoFormik.values.iv_relation_type =
      dialogRowData.applicantRelationType;
    editBasicInfoFormik.values.iv_relative_name =
      dialogRowData.applicantRelativeName;
    editBasicInfoFormik.values.iv_applicant_status =
      dialogRowData.applicantStatus;
    editBasicInfoFormik.values.iv_applicant_citizenship =
      dialogRowData.applicantCitizenship;
    editBasicInfoFormik.values.iv_applicant_phone_no =
      dialogRowData.applicantMobile;
    editBasicInfoFormik.values.iv_applicant_email =
      dialogRowData.applicantEmail;
    editBasicInfoFormik.values.iv_ntn = dialogRowData.NTN;
    editBasicInfoFormik.values.iv_strn = dialogRowData.STRN;
    editBasicInfoFormik.values.iv_area_type = dialogRowData.areaType;
    editBasicInfoFormik.values.iv_address = dialogRowData.premisesAddress;
    editBasicInfoFormik.values.iv_town_tehsil = dialogRowData.townTehsil;
    editBasicInfoFormik.values.iv_city_district = dialogRowData.cityDistrict;
    editBasicInfoFormik.values.iv_meter_installed =
      dialogRowData.noOfMetersAlreadyInstalled;
    editBasicInfoFormik.values.iv_applied_load = dialogRowData.appliedLoad;
    editBasicInfoFormik.values.iv_near_by_reference_no =
      dialogRowData.nearByReferenceNumber;
    editBasicInfoFormik.values.iv_near_by_name = dialogRowData.nearByName;
    editBasicInfoFormik.values.iv_near_by_address = dialogRowData.nearByAddress;
    editBasicInfoFormik.values.iv_circle = dialogRowData.circleCode;
    editBasicInfoFormik.values.iv_division = dialogRowData.divisionCode;
    editBasicInfoFormik.values.iv_sub_divison = dialogRowData.subDivisionCode;
    editBasicInfoFormik.values.iv_meter_seasonal =
      dialogRowData.seasonalNonSeasonalFlag
        ? dialogRowData.seasonalNonSeasonalFlag
        : 0;
    editBasicInfoFormik.values.iv_sub_divison = dialogRowData.subDivisionCode;
    editBasicInfoFormik.values.iv_owner_name = dialogRowData.ownerName;
    editBasicInfoFormik.values.iv_owner_cnic = dialogRowData.ownerCNIC;
    editBasicInfoFormik.values.iv_owner_phone_no = dialogRowData.ownerMobile;
    editBasicInfoFormik.values.iv_owner_email = dialogRowData.ownerEmail;
    let appTariff = getTariff(
      dialogRowData.appliedLoad,
      dialogRowData.connectionType,
      dialogRowData.seasonalNonSeasonalFlag,
      allTariffList
    );
    setTariffEdit(appTariff);
    let appPhase = getMeterPhase(
      dialogRowData.appliedLoad,
      dialogRowData.connectionType
    );
    setPhaseEdit(appPhase);
    const lists = await subDivAPI(subDivisions);

    setHierarchyList(lists.hierarchyList);
    setCircleList(lists.circleList);
    setDivisionList(lists.divisionList);
    setSubDivisionList(lists.subDivisionList);
    let appCircle = lists.circleList.find(
      (item) => item.code == dialogRowData.circleCode
    );
    let appDivision = lists.divisionList.find(
      (item) => item.code == dialogRowData.divisionCode
    );
    let appSubdivision = lists.subDivisionList.find(
      (item) => item.code == dialogRowData.subDivisionCode
    );
    setDefaultCircle(appCircle);
    setDefaultDivision(appDivision);
    setSubDivision(appSubdivision);
    setShowEditPopup(true);
  };

  // Function to set states of documents
  const ApplicantCnicDocumentFront = (event) => {
    if (event.target.files) {
      const newFileName =
        "copyOfApplicantCNICFront." +
        event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        editBasicInfoFormik.handleChange,
        setApplicantCnicDocumentFront,
        setApplicantCnicFrontError,
        setApplicantCnicDocumentFrontThumbnail,
        newFileName
      );
    }
  };

  const ApplicantCnicDocumentBack = (event) => {
    if (event.target.files) {
      const newFileName =
        "copyOfApplicantCNICBack." +
        event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        editBasicInfoFormik.handleChange,
        setApplicantCnicDocumentBack,
        setApplicantCnicBackError,
        setApplicantCnicDocumentBackThumbnail,
        newFileName
      );
    }
  };

  const PropertDocuments = (event) => {
    if (event.target.files) {
      const newFileName =
        "copyOfPropertyDocument." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        editBasicInfoFormik.handleChange,
        setPropertDocuments,
        setPropertyDocumentError,
        setPropertyDocumentsThumbnail,
        newFileName
      );
    }
  };

  const NearByBillDocument = (event) => {
    if (event.target.files) {
      const newFileName =
        "scannedCopyOfNearByElectricityBill." +
        event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        editBasicInfoFormik.handleChange,
        setNearByBillDocument,
        setNearByBillError,
        setNearByBillDocumentThumbnail,
        newFileName
      );
    }
  };

  const AnyOtherDocument = (event) => {
    if (event.target.files) {
      const newFileName =
        "anyOtherDocument." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        editBasicInfoFormik.handleChange,
        setAnyOtherDocument,
        setAnyOtherDocumentError,
        setAnyOtherDocumentThumbnail,
        newFileName
      );
    }
  };

  const NocOwnerDocument = (event) => {
    if (event.target.files) {
      const newFileName =
        "ownerNOC." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        editBasicInfoFormik.handleChange,
        setNocOwnerDocument,
        setNocError,
        setNocOwnerDocumentThumbnail,
        newFileName
      );
    }
  };

  const OwnerCnicDocumentFront = (event) => {
    if (event.target.files) {
      const newFileName =
        "copyOfOwnerCNIC." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        editBasicInfoFormik.handleChange,
        setOwnerCnicDocumentFront,
        setOwnerCnicFrontError,
        setOwnerCnicDocumentFrontThumbnail,
        newFileName
      );
    }
  };

  const OwnerCnicDocumentBack = (event) => {
    if (event.target.files) {
      const newFileName =
        "copyOfOwnerCNIC." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        editBasicInfoFormik.handleChange,
        setOwnerCnicDocumentBack,
        setOwnerCnicBackError,
        setOwnerCnicDocumentBackThumbnail,
        newFileName
      );
    }
  };

  const ResolutionDocument = (event) => {
    if (event.target.files) {
      const newFileName =
        "resolutionFormDesc." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        editBasicInfoFormik.handleChange,
        setResolutionDocument,
        setBodError,
        setResolutionDocumentThumbnail,
        newFileName
      );
    }
  };

  const MemorandumDocument = (event) => {
    if (event.target.files) {
      const newFileName =
        "certMemoDesc." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        editBasicInfoFormik.handleChange,
        setMemorandumDocument,
        setMemorandumError,
        setMemorandumDocumentThumbnail,
        newFileName
      );
    }
  };

  const Form29Document = (event) => {
    if (event.target.files) {
      const newFileName =
        "certFormDesc." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        editBasicInfoFormik.handleChange,
        setForm29Document,
        setFormError,
        setForm29DocumentThumbnail,
        newFileName
      );
    }
  };


  // useEffect(() => {
  //   // Reset state when the component is mounted or reopened
  //   setFlagWiringTestReport(0); // Reset the flag
  //   setDialogRowData((prevState) => ({
  //     ...prevState,
  //     wiringTestReportDocumentFlag: 0,
  //   }));
  // }, [applicationReopenTrigger]);


  const handleLoadChange = (event) => {
    let appliedLoad = event.target.value;
    editBasicInfoFormik.handleChange(event);
    if (editBasicInfoFormik.values.iv_connection_type === "Industrial") {
      if (editBasicInfoFormik.values.iv_seasonal_flag == 1) {
        const seasonalTariff = allTariffList.find(
          (item) => item.tariffCode === "F"
        );
        // Check if seasonalTariff is found before setting the state
        if (seasonalTariff) {
          setTariffEdit(seasonalTariff.tariffName || "");
        } else {
          // Handle the case when the seasonal tariff is not found
          setTariffEdit("");
          console.error("Seasonal tariff not found!");
        }
        if (appliedLoad <= 500) {
          setPhaseEdit("MDI (LT)(CT)");
        } else if (appliedLoad > 500) {
          setPhaseEdit("MDI (HT)(CT/PT)");
        }
      } else if (editBasicInfoFormik.values.iv_seasonal_flag == 0) {
        let shortListedTariffsArray = allTariffList.filter(
          (item) =>
            item.consumerType === editBasicInfoFormik.values.iv_connection_type
        );
        shortListedTariffsArray = shortListedTariffsArray.filter(
          (item) =>
            parseInt(item.from) <= appliedLoad &&
            parseInt(item.to) > appliedLoad
        );
        let selectedTariff = shortListedTariffsArray[0];
        // Check if seasonalTariff is found before setting the state
        if (selectedTariff) {
          setTariffEdit(selectedTariff.tariffName || "");
        } else {
          // Handle the case when the seasonal tariff is not found
          setTariffEdit("");
        }
        if (appliedLoad <= 500) {
          setPhaseEdit("MDI (LT)(CT)");
        } else if (appliedLoad > 500) {
          setPhaseEdit("MDI (HT)(CT/PT)");
        }
      }
    } else {
      if (appliedLoad && appliedLoad > 0) {
        let shortListedTariffsArray = allTariffList.filter(
          (item) =>
            item.consumerType == editBasicInfoFormik.values.iv_connection_type
        );
        shortListedTariffsArray = shortListedTariffsArray.filter(
          (item) =>
            parseInt(item.from) <= appliedLoad &&
            parseInt(item.to) > appliedLoad
        );
        setTariffEdit(shortListedTariffsArray[0].tariffName);
        if (parseInt(appliedLoad) < 5) {
          setPhaseEdit("Single Phase");
        } else if (appliedLoad >= 5 && appliedLoad < 20) {
          setPhaseEdit("3 Phase");
        } else if (appliedLoad >= 20 && appliedLoad < 500) {
          setPhaseEdit("MDI (LT)(CT)");
        } else if (appliedLoad >= 500) {
          setPhaseEdit("MDI (HT)(CT/PT)");
        }
      } else {
        setPhaseEdit("");
        setTariffEdit("");
      }
    }
  };

  const updateDocFlag = (documentName, value, remarks) => {
    switch (documentName) {
      case "copyOfApplicantCNIC":
        setFlag_copyOfApplicantCNICFront(value);
        setFlag_copyOfApplicantCNICBack(value);
        setCopyOfApplicantCNICFrontObjectionRemarks(remarks);
        setCopyOfApplicantCNICBackObjectionRemarks(remarks);
        setCopyOfApplicantCNICVerifyPopUp(false);
        break;
      case "premisesDocument":
        setFlag_premisesDocument(value);
        setPremisesDocumentObjectionRemarks(remarks);
        setPropertyDocVerifyPopUp(false);
        break;
      case "scannedCopyOfNearByElectricityBill":
        setFlag_scannedCopyOfNearByElectricityBill(value);
        setScannedCopyOfNearByElectricityBillObjectionRemarks(remarks);
        setNearByBillVerifyPopUp(false);
        break;
      case "anyOtherDocument":
        setFlag_anyOtherDocument(value);
        setAnyOtherDocumentObjectionRemarks(remarks);
        setAnyOtherDocumentVerifyPopUp(false);
        break;
      case "copyOfOwnerCNIC":
        setFlag_copyOfOwnerCNICFront(value);
        setFlag_copyOfOwnerCNICBack(value);
        setCopyOfOwnerCNICFrontObjectionRemarks(remarks);
        setCopyOfOwnerCNICBackObjectionRemarks(remarks);
        setCopyOfOwnerCNICVerifyPopUp(false);
        break;
      case "ownerNOC":
        setFlag_ownerNOC(value);
        setOwnerNOCObjectionRemarks(remarks);
        setOwnerNOCVerifyPopUp(false);
        break;
      case "resolutionFormDesc":
        setFlag_resolutionFormDesc(value);
        setResolutionFormDescObjectionRemarks(remarks);
        setResolutionFormDescVerifyPopUp(false);
        break;
      case "certFormDesc":
        setFlag_certFormDesc(value);
        setCertFormDescObjectionRemarks(remarks);
        setCertFormDescVerifyPopUp(false);
        break;
      case "certMemoDesc":
        setFlag_certMemoDesc(value);
        setCertMemoDescObjectionRemarks(remarks);
        setCertMemoDescVerifyPopUp(false);
        break;
      case "wiringTestReport":
        setFlag_wiringTestReport(value);
        setWiringTestReportObjectionRemarks(remarks);
        setWiringTestReportVerifyPopUp(false);
        break;
      default:
        break;
    }
  };

  useScanDetection({
    onComplete: async (code) => {
      if (code) {
        code = code.replace(/Shift/g, "");
        const regex = /^[A-Z]{2}-\d{14,15}$/;
        if (regex.test(code)) {
          await handleRowClick(code);
        } else {
          console.warn("Invalid code format:", code);
        }
      }
    },
    minLength: 4, // EAN13
  });

  const SketchDiagram = (event) => {
    if (event.target.files) {
      const newFileName =
        "sketchDiagram." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        fieldFormik.handleChange,
        setSketchDiagram,
        setSketchDiagramError,
        setSketchDiagramThumbnail,
        newFileName
      );
    }
  };

  const handleClose = async () => {
    //applied load field
    setIsRelevantToUser(false);
    appliedLoadFormik.resetForm();
    appliedLoadFormik.values.iv_applied_load = "";
    //field verification fields
    fieldItemFormik.resetForm();
    fieldFormik.resetForm();
    fieldFormik.values.iv_distance = 1;
    fieldFormik.values.iv_estimated_distance = 41;
    fieldFormik.values.iv_coverage_area = "";
    fieldFormik.values.iv_sanctioned_load = "";
    fieldFormik.values.iv_batch = "";
    fieldFormik.values.iv_reference_to_allot = "";
    arearsFormik.resetForm();
    setArearFlag(0);
    setArearPaidBillDocument("");
    setArearPaidBillDocumentThumbnail("");
    arearBillDocumentFormik.values.iv_arear_paid_bill_document = "";
    arearBillDocumentFormik.values.iv_arear_paid_bill_date = "";
    formik.resetForm();
    setAlreadyInstalledRefNos([]);
    setGridFlag(false);
    setFeederRehabFlag(false);
    setNewConnectionPopup(false);
    setObjectionPopUpOpen(false);
    refNoAllocationFormik.resetForm();
    dnPymentReceiptFormik.resetForm();
    setDnReceiptImage("");
    setDnReceiptImageThumbnail("");
    refNoAllocationFormik.resetForm();
    refNoAllocationFormik.values.iv_feeder_no = "";
    refNoAllocationFormik.values.iv_cantonment_board = "";
    refNoAllocationFormik.values.iv_fgovt = "";
    refNoAllocationFormik.values.iv_pgovt = "";
    refNoAllocationFormik.values.iv_govt_dept_code = "";
    refNoAllocationFormik.values.iv_local_bodies = "";
    refNoAllocationFormik.values.iv_batch = "";
    refNoAllocationFormik.values.iv_sub_batch = "";
    refNoAllocationFormik.values.iv_grid_sharing_cost = 0;
    refNoAllocationFormik.values.iv_feeder_rehab_charges = 0;
    setGridSharingCost(0);
    setFeederRehabilitationCharges(0);
    setSubmitSCOApiError("");
    scoPart2Formik.resetForm();
    scoPart2Formik.values.iv_store_requisition_no = "";
    scoPart2Formik.values.iv_store_requisition_date = "";
    scoPart2Formik.values.iv_sanctioned_load = "";
    scoPart2Formik.values.iv_no_of_meters = 0;
    scoPart2Formik.values.iv_no_of_acs = 0;
    scoPart2Formik.values.iv_no_of_meter_sets = 0;
    scoPart2Formik.values.iv_no_of_sub_sets = 0;
    scoPart2Formik.values.iv_no_ofsupply_points = 0;
    scoPart2Formik.values.iv_transformer_code = "";
    scoPart2Formik.values.iv_transformer_refNo = "";
    scoPart2Formik.values.iv_seasonal_flag = 0;
    scoPart2Formik.values.iv_meter_id = "";
    scoPart2Formik.values.iv_meter_serial_no = "";
    scoPart2Formik.values.iv_sim_ID = "";
    scoPart2Formik.values.iv_sim_number = "";
    scoPart2Formik.values.iv_location_code = "";
    scoPart2Formik.values.iv_meter_code1 = "";
    scoPart2Formik.values.iv_meter_code2 = "";
    scoPart2Formik.values.iv_manufacturer_code = "";
    scoPart2Formik.values.iv_multiplying_factor = 1;
    scoPart2Formik.values.iv_meter_range = 4;
    scoPart2Formik.values.iv_meter_reading = "";
    scoPart2Formik.values.iv_seal_on_meter = "";
    scoPart2Formik.values.iv_seal_on_box = "";
    scoPart2Formik.values.iv_ct_nom = "1";
    scoPart2Formik.values.iv_ct_denom = "1";
    scoPart2Formik.values.iv_pt_nom = "1";
    scoPart2Formik.values.iv_pt_denom = "1";
    scoPart2Formik.values.iv_seal_on_box = "";
    scoPart2Formik.values.iv_connection_installer_name = "";
    scoPart2Formik.values.iv_date_of_connection = "";
    scoPart2Formik.values.iv_cp_78_item_no = "";
    scoPart2Formik.values.iv_security_slip_or_price_bond_no = "";
    scoPart2Formik.values.iv_tie_up_non_tie_up = 0;
    scoPart2Formik.values.iv_meter_reading = "";
    scoPart2Formik.values.iv_meter_reading_off_peak_kwh = "";
    scoPart2Formik.values.iv_meter_reading_peak_kwh = "";
    scoPart2Formik.values.iv_meter_reading_off_peak_kvarh = "";
    scoPart2Formik.values.iv_meter_reading_peak_kvarh = "";
    setManufcaturerCode(null);
    setInstalledMeterImage("");
    setInstalledMeterImageThumbnail("");
    masterDataFormik.resetForm();
    arearsFormik.values.iv_property_reference_no = "";
    masterDataFormik.values.iv_govt_dept = 0;
    masterDataFormik.values.iv_income_tax = 0;
    masterDataFormik.values.iv_standard_classification_code = "";
    setStandardClassificationCode({ XCLFM_CODE: "", XCLFM_DESC: "" });
    setGovtDeptCode({ departmentCode: null, departmentName: "" });
    setStoreCharges();
    setItemsAmount();
    setSketchDiagram();
    setSketchDiagramUploaded();
    setSketchDiagramThumbnail();
    setInstallationCharges();
    setError("");
    setArrearsDetailsRefno({
      arrearsAmount: "",
      meterStatus: "",
      tariffDesc: "",
      meterType: "",
      phase: "",
      consumerName: "",
      consumerNo: "",
      consumerAddress: "",
      consumerEmail: "",
    });
    setArrearsDetailsRefnoToDisplay({
      refNo: "",
      arrearsAmount: "",
      meterStatus: "",
      tariffDesc: "",
      meterType: "",
      phase: "",
      consumerName: "",
      consumerNo: "",
      consumerAddress: "",
      consumerEmail: "",
      paidArearImage: "",
      paidArearDate: "",
    });
    setDnDetails({
      demandNoticeNo: "",
      issueDate: "",
      applicationId: "",
      dueDate: "",
      roOfficeAddress: "",
      consumerAccountNo: "",
      batchNo: "",
      voltage: "",
      tariff: "",
      coverageAreaOfPremises: "",
      bankName: "",
      industryFactoryType: "",
      sketchImage: "",
      isDistance40: "",
      connectionAccountNo: "",
      dnPaymentFlag: "",
      paymentMethod: "",
      dnPaymentVerificationFlag: "",
      // meterRent: "",
      // serviceRent: "",
      sanctionLoad: "",
      surveyedBy: "",
      surveyedDate: "",
      filledBy: "",
      filledDate: "",
      filledFlag: "",
      approvedBy: "",
      approvedDate: "",
      approvedFlag: "",
      amountOfGridSharing: "",
      amountOfFeederRehab: "",
      paymentDate: "",
      capitalCostAmount: "",
      securityDepositeAmount: "",
    });
    setScoDetails({
      scoId: "",
      applicationId: "",
      scoCreationDate: "",
      urbanRural: "",
      refNo: "",
      fataPata: "",
      feederNo: "",
      batch: "",
      subBatch: "",
      fGovt: "",
      cantonmentBoard: "",
      pGovt: "",
      localBodies: "",
      scoP1FilledBy: "",
      scoP1FillingDate: "",
      scoP1FillFlag: "",
      authorizedByName: "",
      dateOfAuthorization: "",
      scoP1ApprovedFlag: "",
      storeRequisitionNo: "",
      storeRequisitionDate: "",
      seasonalFlag: "",
      senctionLoad: "",
      noOfACs: "",
      noOfMeters: "",
      noOfMeterSets: "",
      noOfSubSets: "",
      noOfSupplyPoints: "",
      installedTransformerCapacity: "",
      meterId: "",
      meterNo: "",
      locationCode: "",
      meterCode: "",
      manufacturerCode: "",
      multiplyingFactor: "",
      meterRange: "",
      meterReading: "",
      dateOfConnection: "",
      cp78ItemNo: "",
      tieUpNonTieUp: "",
      sealOnMeter: "",
      sealOnBox: "",
      securitySlipOrPriceBondNo: "",
      connectionInstallerName: "",
      scoP2FilledBy: "",
      scoP2FillingDate: "",
      scoP2FillFlag: "",
      scoP2ApprovedBy: "",
      scoP2ApprovalDate: "",
      scoP2ApprovalFlag: "",
      installedMeterImage: "",
    });
    setDialogRowData((prevObject) => ({
      ...prevObject,
      copyOfApplicantCNICFront: "",
      copyOfApplicantCNICBack: "",
      premisesDocument: "",
      scannedCopyOfNearByElectricityBill: "",
      anyOtherDocument: "",
      copyOfOwnerCNICFront: "",
      copyOfOwnerCNICBack: "",
      ownerNOC: "",
      resolutionFormDesc: "",
      certFormDesc: "",
      certMemoDesc: "",
    }));
    setTotalCharges(0);
    setItemsArray([]);
    setCopyOfApplicantCNICFrontObjectionRemarks("");
    setCopyOfOwnerCNICBackObjectionRemarks("");
    setPremisesDocumentObjectionRemarks("");
    setScannedCopyOfNearByElectricityBillObjectionRemarks("");
    setCopyOfOwnerCNICFrontObjectionRemarks("");
    setCopyOfOwnerCNICBackObjectionRemarks("");
    setResolutionFormDescObjectionRemarks("");
    setOwnerNOCObjectionRemarks("");
    setCertFormDescObjectionRemarks("");
    setCertMemoDescObjectionRemarks("");
    setBankName();
    setFoundInNc();
    setShowEditPopup(false);
    setShowUpdateBatchPopup(false);
    setOpen(false);
    setEFileData([]);
    setTableDataProcessingSummary([]);
    setCapitalCostAmnt();
    setSecurityDepositeAmount();
    SetTotalEstimatedAmnt();
    dispatch(
      fetchPaginatedNewConnectionNormal({
        page: currentPageNormal,
        pageSize: pageSizeNormal,
        dateFrom: dateFromNormal,
        dateTo: dateToNormal,
        loadTo: loadToNormal,
        loadFrom: loadFromNormal,
        applicationProgressId: applicationProgressIdNormal,
        objectionStatus: objectionStatusNormal,
        officeCode: selectedOfficeCode || code,
      })
    );
    dispatch(
      fetchPaginatedNewConnectionOverdue({
        page: currentPageOverdue,
        pageSize: pageSizeOverdue,
        dateFrom: dateFromOverdue,
        dateTo: dateToOverdue,
        loadTo: loadToOverdue,
        loadFrom: loadFromOverdue,
        applicationProgressId: applicationProgressIdOverdue,
        objectionStatus: objectionStatusOverdue,
        officeCode: selectedOfficeCode || code,
      })
    );
    setBoqItems([]);
    setItemsAmount("");
    setStoreCharges("");
    setInstallationCharges("");
    setTotalCharges("");
    setItemsArray("");
    setFixedChargesOfMetering("");
    // setShowBoq([])
  };

  const showArrearsEntryPopup = () => {
    setArrearsEntryPopUpOpen(true);
    setEnablingRemoveObjOfArrear("1");
  };
  const hideArrearsEntryPopup = () => {
    setArrearsEntryPopUpOpen(false);
    arrearsDetailsRefno.arrearsAmount = "";
  };

  const showObjectionPopup = () => {
    setObjectionPopUpOpen(true);
  };

  const hideObjectionPopup = () => {
    formik.handleReset();
    setObjectionPopUpOpen(false);
  };

  const hideCopyOfApplicantCNICVerifyAlert = (x) => {
    setCopyOfApplicantCNICVerifyPopUp(x);
  };
  const hideInstalledMeterImageVerifyAlert = (x) => {
    setInstalledMeterImageVerifyPopUp(x);
  };
  const hidePropertyDocVerifyAlert = (x) => {
    setPropertyDocVerifyPopUp(x);
  };

  const hideNearByBillVerifyAlert = (x) => {
    setNearByBillVerifyPopUp(x);
  };

  const hideAnyOtherDocumentVerifyAlert = (x) => {
    setAnyOtherDocumentVerifyPopUp(x);
  };

  const hideCopyOfOwnerCNICVerifyAlert = (x) => {
    setCopyOfOwnerCNICVerifyPopUp(x);
  };

  const hideOwnerNocVerifyAlert = (x) => {
    setOwnerNOCVerifyPopUp(x);
  };

  const hideResolutionFormDescVerifyAlert = (x) => {
    setResolutionFormDescVerifyPopUp(x);
  };

  const hideCertFormDescVerifyAlert = (x) => {
    setCertFormDescVerifyPopUp(x);
  };

  const hideCertMemoDescVerifyAlert = (x) => {
    setCertMemoDescVerifyPopUp(x);
  };

  const hidePaidDnImagePopUp = (x) => {
    setPaidDNImagePopUp(x);
  };

  const hideWiringTestReportVerifyAlert = (x) => {
    setWiringTestReportVerifyPopUp(x);
  };

  const hideDnPaymentVerifyAlert = () => {
    setDnPaymentVerifyAlert(false);
  };

  const hideDnPaymentRejectAlert = () => {
    setDnPaymentRejectAlert(false);
  };

  const hideSCOPart1ApproveAlert = () => {
    setScoPart1ApproveAlert(false);
  };

  const hideSCOPart2ApproveAlert = () => {
    setScoPart2ApproveAlert(false);
  };

  const showRejectionRemovalAlert = () => {
    setRejectionRemovalAlert(true);
  };

  const showFieldRejectionRemovalAlert = () => {
    setFieldRejectionRemovalAlert(true);
  };

  const hideRejectionRemovalAlert = () => {
    setRejectionRemovalAlert(false);
  };

  const hideFieldRejectionRemovalAlert = () => {
    setFieldRejectionRemovalAlert(false);
  };

  const showWiringTestReportRejectionRemovalAlert = () => {
    setWiringTestReportRejectionRemovalAlert(true);
  };

  const hideWiringTestReportRejectionRemovalAlert = () => {
    setWiringTestReportRejectionRemovalAlert(false);
    setNewWiringTestReportDocument("");
    setNewWiringTestReportDocumentThumbnail("");
    setNewWiringTestReportDocumentError("");
  };

  const hideArrearsEntryAlert = () => {
    setArrearsEntryPopUpOpen(false);
  };

  const getClassName = (x) => {
    if (x === "Pending") {
      return "pending-button";
    } else if (x === "In Process") {
      return "inprocess-button";
    } else if (x === "Approved") {
      return "approved-button";
    } else if (x === "Completed") {
      return "completed-button";
    } else if (x === "Objection") {
      return "objection-button";
    }
  };

  const filterNCApp = async (applicationId) => {
    const myArray = newConnectionApplications;
    let allApplications = myArray.concat(newConnectionApplicationsOverDue);
    let itemFound = allApplications.find(
      (item) => item.applicationId === applicationId
    );
    if (itemFound) {
      setIsRelevantToUser(true);
    } else if (itemFound === undefined) {
      itemFound = await SearchIndividualApplication(token, applicationId, "1");
      setIsRelevantToUser(itemFound.isReleventToUser);
      // Extract subDivisionCode from applicationId if not available
      if (!itemFound.subDivisionCode && applicationId) {
        itemFound.subDivisionCode = applicationId.slice(3, 8);
      }
    }

    return itemFound;
  };

  const callNextNCApplicationsInQueue = async (applicationId) => {
    try {
      if (!applicationId) {
        return { canProceed: true, queueData: [] };
      }

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        searchById: applicationId,
        officeLevel:
          hierarchy == 1
            ? 1
            : hierarchy == 2
              ? 2
              : hierarchy == 3
                ? 3
                : hierarchy == 4 || hierarchy == 51
                  ? 4
                  : hierarchy == 5 || hierarchy == 52
                    ? 5
                    : null,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        cfpBaseUrl + "enc/getNextNCApplicationsInQueue",
        requestOptions
      );
      const result = await response.json();

      if (result.status === "200" && Array.isArray(result.data) && result.data.length) {
        const nextInQueue = result.data[0];
        const requestedItem = result.data.find(
          (itm) => itm.applicationId === applicationId
        );
        const canProceed = nextInQueue?.applicationId === applicationId;

        return {
          canProceed,
          queueData: result.data,
          nextInQueue,
          requestedItem,
        };
      }

      // If queue service has no actionable data, do not block normal processing.
      return { canProceed: true, queueData: [] };
    } catch (error) {
      console.log("Error while fetching NC queue priority:", error);
      // Avoid blocking workflow on API failure.
      return { canProceed: true, queueData: [] };
    }
  };

  const closeQueuePriorityPopup = () => {
    setShowQueuePriorityPopup(false);
    // Enforce queue rule: do not allow any further workflow step until app is at queue #1.
    setOpen(false);
  };
  const [objectValue, setObjectValue] = useState([]);

  const apiToDataGridConversionNormal = async () => {
    try {
      setViewBackdrop(true);
      const tempArray = [];
      if (newConnectionApplications) {
        for (const item of newConnectionApplications) {
          let dataGridObject = {};
          if (item.applicationId) {
            if (item.objectionStatus === 0 || item.objectionStatus === 2) {
              dataGridObject = {
                applicationId: item.applicationId,
                applicationType: item.applicationType,
                creationDate: convertDateDDMMYY(item.creationDate),
                lastModificationDate: convertDate(item.lastModificationDate),
                connectionType: item.connectionType,
                applicantName: item.applicantName,
                applicantCNIC: item.applicantCNIC,
                appliedLoad: item.appliedLoad,
                capitalCostAmount: item.capitalCostAmount || "",
                isLTLWI40Flag: item.isLTLWI40Flag,
                applicationStatusId: statusFunc(
                  item.applicationProgressId,
                  item.objectionStatus
                ),
                applicationProgressId: progFunc(item.applicationProgressId),
                applicationProgressNumber: item.applicationProgressId,
                inTime: item.inTime,
                tariff:
                  allTariffList &&
                  getTariff(
                    item.appliedLoad,
                    item.connectionType,
                    item.seasonalNonSeasonalFlag,
                    allTariffList,
                    item.applicationProgressId
                  ),
                exceededDuration: item.exceededDuration,
                releventApplicationFlage: item.releventApplicationFlage,
                downloadEFile: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadEFile(application);
                },
                downloadDNPDF: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadDNPDF(application);
                },
                downloadSCOPDF: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadSCOPDF(application);
                },
                downloadNOCPDF: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadNOCPDF(application);
                },
                downloadEstimatePDF: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadEstimatePDF(application);
                },
                storeRequisitionNo: item.storeRequisitionNo,
                // "downloadSCOPDF": (item.applicationId),
              };
            } else if (item.objectionStatus === 1) {
              dataGridObject = {
                applicationId: item.applicationId,
                applicationType: item.applicationType,
                creationDate: convertDateDDMMYY(item.creationDate),
                lastModificationDate: convertDate(item.lastModificationDate),
                connectionType: item.connectionType,
                applicantName: item.applicantName,
                applicantCNIC: item.applicantCNIC,
                appliedLoad: item.appliedLoad,
                capitalCostAmount: item.capitalCostAmount || "",
                isLTLWI40Flag: item.isLTLWI40Flag,
                applicationStatusId: statusFunc(
                  item.applicationProgressId,
                  item.objectionStatus
                ),
                applicationProgressId: item.remarks,
                applicationProgressNumber: item.applicationProgressId,
                inTime: item.inTime,
                tariff:
                  allTariffList &&
                  getTariff(
                    item.appliedLoad,
                    item.connectionType,
                    item.seasonalNonSeasonalFlag,
                    allTariffList,
                    item.applicationProgressId
                  ),
                exceededDuration: item.exceededDuration,
                releventApplicationFlage: item.releventApplicationFlage,
                downloadEFile: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadEFile(application);
                },
                downloadDNPDF: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadDNPDF(application);
                },
                downloadSCOPDF: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadSCOPDF(application);
                },
                downloadNOCPDF: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadNOCPDF(application);
                },
                downloadEstimatePDF: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadEstimatePDF(application);
                },
                storeRequisitionNo: item.storeRequisitionNo,
              };
            }
            tempArray.push(dataGridObject);
          }
        }
      } else {
        const dataGridObject = {
          applicationId: " ",
          connectionType: "",
          applicantName: " ",
          applicantCNIC: " ",
          applicationStatusId: statusFunc(" "),
        };
        tempArray.push(dataGridObject);
      }

      setNewConnectionApplicationsToDataGrid(tempArray);
      setViewBackdrop(false);
    } catch (e) {
      console.log(e);
      console.log("Update Failed!");
    }
  };

  const apiToDataGridConversionOverdue = async () => {
    try {
      setViewBackdrop(true);

      const tempArray = [];
      if (newConnectionApplicationsOverDue) {
        for (const item of newConnectionApplicationsOverDue) {
          let dataGridObject = {};
          // setObjectValue(item)
          if (item.applicationId) {
            if (item.objectionStatus === 0 || item.objectionStatus === 2) {
              dataGridObject = {
                applicationId: item.applicationId,
                applicationType: item.applicationType,
                creationDate: convertDateDDMMYY(item.creationDate),
                lastModificationDate: convertDate(item.lastModificationDate),
                connectionType: item.connectionType,
                applicantName: item.applicantName,
                applicantCNIC: item.applicantCNIC,
                appliedLoad: item.appliedLoad,
                capitalCostAmount: item.capitalCostAmount || "",
                isLTLWI40Flag: item.isLTLWI40Flag,
                tariff: getTariff(
                  item.appliedLoad,
                  item.connectionType,
                  item.seasonalNonSeasonalFlag,
                  allTariffList,
                  item.applicationProgressId
                ),
                applicationStatusId: statusFunc(
                  item.applicationProgressId,
                  item.objectionStatus
                ),
                applicationProgressId: progFunc(item.applicationProgressId),
                applicationProgressNumber: item.applicationProgressId,
                inTime: item.inTime,
                exceededDuration: item.exceededDuration,
                releventApplicationFlage: item.releventApplicationFlage,
                downloadEFile: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadEFile(application);
                },
                downloadDNPDF: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadDNPDF(application);
                },
                downloadSCOPDF: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadSCOPDF(application);
                },
                downloadNOCPDF: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadNOCPDF(application);
                },
                downloadEstimatePDF: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadEstimatePDF(application);
                },
                storeRequisitionNo: item.storeRequisitionNo,
              };
            } else if (item.objectionStatus === 1) {
              dataGridObject = {
                applicationId: item.applicationId,
                applicationType: item.applicationType,
                creationDate: convertDateDDMMYY(item.creationDate),
                lastModificationDate: convertDate(item.lastModificationDate),
                connectionType: item.connectionType,
                applicantName: item.applicantName,
                applicantCNIC: item.applicantCNIC,
                appliedLoad: item.appliedLoad,
                capitalCostAmount: item.capitalCostAmount || "",
                isLTLWI40Flag: item.isLTLWI40Flag,
                tariff: getTariff(
                  item.appliedLoad,
                  item.connectionType,
                  item.seasonalNonSeasonalFlag,
                  allTariffList,
                  item.applicationProgressId
                ),
                applicationStatusId: statusFunc(
                  item.applicationProgressId,
                  item.objectionStatus
                ),
                applicationProgressId: item.remarks,
                applicationProgressNumber: item.applicationProgressId,
                inTime: item.inTime,
                exceededDuration: item.exceededDuration,
                releventApplicationFlage: item.releventApplicationFlage,
                downloadEFile: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadEFile(application);
                },
                downloadDNPDF: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadDNPDF(application);
                },
                downloadSCOPDF: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadSCOPDF(application);
                },
                downloadNOCPDF: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadNOCPDF(application);
                },
                downloadEstimatePDF: async () => {
                  let application = await filterNCApp(item.applicationId);
                  await downloadEstimatePDF(application);
                },
                storeRequisitionNo: item.storeRequisitionNo,
              };
            }
            tempArray.push(dataGridObject);
          }
        }
      } else {
        const dataGridObject = {
          applicationId: " ",
          connectionType: "",
          applicantName: " ",
          applicantCNIC: " ",
          applicationStatusId: statusFunc(" "),
        };
        tempArray.push(dataGridObject);
      }

      setNewConnectionApplicationsOverDueToDataGrid(tempArray);
      setViewBackdrop(false);
    } catch (e) {
      console.log(e);
      console.log("Update Failed!");
    }
  };

  const updateDocumentStatus = () => {
    let remarksToSave = "";
    let objectionStatus = null;
    let applicationProgressId = dialogRowData.applicationProgressId;
    if (
      flag_ownerNOC === -1 ||
      flag_premisesDocument === -1 ||
      flag_copyOfApplicantCNICFront === -1 ||
      // flag_scannedCopyOfNearByElectricityBill === -1 ||
      flag_copyOfApplicantCNICBack === -1 ||
      flag_copyOfOwnerCNICFront === -1 ||
      flag_copyOfOwnerCNICBack === -1 ||
      flag_resolutionFormDesc === -1 ||
      flag_certFormDesc === -1 ||
      (dialogRowData.applicationId?.startsWith("NC-14") && flag_anyOtherDocument === -1)
    ) {
      objectionStatus = 1;
      applicationProgressId = 1;
      remarksToSave = remarksToSave + "Documents objection in:";
      if (flag_copyOfApplicantCNICFront == -1) {
        remarksToSave = remarksToSave + " Applicant CNIC Front, ";
      }
      if (flag_copyOfApplicantCNICBack == -1) {
        remarksToSave = remarksToSave + " Applicant CNIC Back, ";
      }
      if (flag_premisesDocument == -1) {
        remarksToSave = remarksToSave + "Premises Document, ";
      }
      //  if (flag_scannedCopyOfNearByElectricityBill == -1) {
      //   remarksToSave = remarksToSave + "Near By Electricity Bill Document, "
      // }
      if (flag_copyOfOwnerCNICFront == -1) {
        remarksToSave = remarksToSave + "Owner CNIC Front, ";
      }
      if (flag_copyOfOwnerCNICBack == -1) {
        remarksToSave = remarksToSave + "Owner CNIC Back, ";
      }
      if (flag_ownerNOC == -1) {
        remarksToSave = remarksToSave + "Owner NOC, ";
      }
      if (flag_resolutionFormDesc == -1) {
        remarksToSave = remarksToSave + "BoD Resolution Form, ";
      }
      if (flag_certFormDesc == -1) {
        remarksToSave = remarksToSave + "Form 29, ";
      }
      if (dialogRowData.applicationId?.startsWith("NC-14") && flag_anyOtherDocument == -1) {
        remarksToSave = remarksToSave + "Any Other Document, ";
      }
    } else {
      objectionStatus = 0;
      console.log("No Objection in documents.");
      remarksToSave = remarksToSave + "Documents Verified.";

      applicationProgressId = (dialogRowData.connectionType == "Temporary" || dialogRowData.connectionType == "Electrification") ? 2 : 21;
    }
    if (
      flag_copyOfApplicantCNICFront !== null &&
      flag_copyOfApplicantCNICBack !== null &&
      flag_premisesDocument !== null
    ) {
      if (
        dialogRowData.applicantStatus !== "Tenant" &&
        dialogRowData.applicantStatus !== "tenant"
      ) {
        if (
          dialogRowData.connectionType !== "Industrial" &&
          dialogRowData.connectionType !== "industrial"
        ) {

          callingUpdateDocumentStatusWithObjectionAPI(
            dialogRowData.applicationId,
            applicationProgressId,
            objectionStatus,
            flag_ownerNOC,
            flag_premisesDocument,
            flag_copyOfApplicantCNICFront,
            flag_copyOfApplicantCNICBack,
            flag_scannedCopyOfNearByElectricityBill,
            flag_anyOtherDocument,
            flag_copyOfOwnerCNICFront,
            flag_copyOfOwnerCNICBack,
            flag_resolutionFormDesc,
            flag_certMemoDesc,
            flag_certFormDesc,
            ownerNOCObjectionRemarks,
            premisesDocumentObjectionRemarks,
            copyOfApplicantCNICFrontObjectionRemarks,
            copyOfApplicantCNICBackObjectionRemarks,
            scannedCopyOfNearByElectricityBillObjectionRemarks,
            anyOtherDocumentObjectionRemarks,
            copyOfOwnerCNICFrontObjectionRemarks,
            copyOfOwnerCNICBackObjectionRemarks,
            resolutionFormDescObjectionRemarks,
            certMemoDescObjectionRemarks,
            certFormDescObjectionRemarks,
            remarksToSave
          );
        } else {
          if (flag_resolutionFormDesc !== null && flag_certFormDesc !== null) {
            callingUpdateDocumentStatusWithObjectionAPI(
              dialogRowData.applicationId,
              applicationProgressId,
              objectionStatus,
              flag_ownerNOC,
              flag_premisesDocument,
              flag_copyOfApplicantCNICFront,
              flag_copyOfApplicantCNICBack,
              flag_scannedCopyOfNearByElectricityBill,
              flag_anyOtherDocument,
              flag_copyOfOwnerCNICFront,
              flag_copyOfOwnerCNICBack,
              flag_resolutionFormDesc,
              flag_certMemoDesc,
              flag_certFormDesc,
              ownerNOCObjectionRemarks,
              premisesDocumentObjectionRemarks,
              copyOfApplicantCNICFrontObjectionRemarks,
              copyOfApplicantCNICBackObjectionRemarks,
              scannedCopyOfNearByElectricityBillObjectionRemarks,
              anyOtherDocumentObjectionRemarks,
              copyOfOwnerCNICFrontObjectionRemarks,
              copyOfOwnerCNICBackObjectionRemarks,
              resolutionFormDescObjectionRemarks,
              certMemoDescObjectionRemarks,
              certFormDescObjectionRemarks,
              remarksToSave
            );
          } else {
            setError("Check all the attached documents before submitting!");
          }
        }
      } else {
        if (
          flag_ownerNOC !== null &&
          flag_copyOfOwnerCNICFront !== null &&
          flag_copyOfOwnerCNICBack !== null
        ) {
          if (
            dialogRowData.connectionType !== "Industrial" &&
            dialogRowData.connectionType !== "industrial"
          ) {
            callingUpdateDocumentStatusWithObjectionAPI(
              dialogRowData.applicationId,
              applicationProgressId,
              objectionStatus,
              flag_ownerNOC,
              flag_premisesDocument,
              flag_copyOfApplicantCNICFront,
              flag_copyOfApplicantCNICBack,
              flag_scannedCopyOfNearByElectricityBill,
              flag_anyOtherDocument,
              flag_copyOfOwnerCNICFront,
              flag_copyOfOwnerCNICBack,
              flag_resolutionFormDesc,
              flag_certMemoDesc,
              flag_certFormDesc,
              ownerNOCObjectionRemarks,
              premisesDocumentObjectionRemarks,
              copyOfApplicantCNICFrontObjectionRemarks,
              copyOfApplicantCNICBackObjectionRemarks,
              scannedCopyOfNearByElectricityBillObjectionRemarks,
              anyOtherDocumentObjectionRemarks,
              copyOfOwnerCNICFrontObjectionRemarks,
              copyOfOwnerCNICBackObjectionRemarks,
              resolutionFormDescObjectionRemarks,
              certMemoDescObjectionRemarks,
              certFormDescObjectionRemarks,
              remarksToSave
            );
          } else {
            if (
              flag_resolutionFormDesc !== null &&
              flag_certFormDesc !== null
            ) {
              callingUpdateDocumentStatusWithObjectionAPI(
                dialogRowData.applicationId,
                applicationProgressId,
                objectionStatus,
                flag_ownerNOC,
                flag_premisesDocument,
                flag_copyOfApplicantCNICFront,
                flag_copyOfApplicantCNICBack,
                flag_scannedCopyOfNearByElectricityBill,
                flag_anyOtherDocument,
                flag_copyOfOwnerCNICFront,
                flag_copyOfOwnerCNICBack,
                flag_resolutionFormDesc,
                flag_certMemoDesc,
                flag_certFormDesc,
                ownerNOCObjectionRemarks,
                premisesDocumentObjectionRemarks,
                copyOfApplicantCNICFrontObjectionRemarks,
                copyOfApplicantCNICBackObjectionRemarks,
                scannedCopyOfNearByElectricityBillObjectionRemarks,
                anyOtherDocumentObjectionRemarks,
                copyOfOwnerCNICFrontObjectionRemarks,
                copyOfOwnerCNICBackObjectionRemarks,
                resolutionFormDescObjectionRemarks,
                certMemoDescObjectionRemarks,
                certFormDescObjectionRemarks,
                remarksToSave
              );
            } else {
              setError("Check all the attached documents before submitting!");
            }
          }
        } else {
          setError("Check all the attached documents before submitting!");
        }
      }
    } else {
      setError("Check all the attached documents before submitting!");
    }
  };

  const updateProgressIdToDocumentsVerified = () => {
    if (
      flag_copyOfApplicantCNICFront === 1 &&
      flag_copyOfApplicantCNICBack === 1 &&
      flag_premisesDocument === 1
    ) {
      if (
        dialogRowData.applicantStatus !== "Tenant" ||
        dialogRowData.applicantStatus !== "tenant"
      ) {
        if (
          dialogRowData.connectionType !== "Industrial" ||
          dialogRowData.connectionType !== "industrial"
        ) {
          if (dialogRowData.objectionStatus === 2) {
            callResetObjectionStatus(dialogRowData.applicationId);
          }
          setFlag_copyOfApplicantCNICFront(null);
          setFlag_copyOfApplicantCNICBack(null);
          setFlag_premisesDocument(null);
          setFlag_scannedCopyOfNearByElectricityBill(null);
          setFlag_anyOtherDocument(null);
          setFlag_copyOfOwnerCNICFront(null);
          setFlag_copyOfOwnerCNICBack(null);
          setFlag_ownerNOC(null);
          setFlag_resolutionFormDesc(null);
          setFlag_certMemoDesc(null);
          setFlag_certFormDesc(null);
          callChangeProgressIdAPI(
            2,
            "Documents Verified",
            "Documents Verified"
          );
        } else {
          if (
            flag_resolutionFormDesc === 1 &&
            flag_certFormDesc === 1 &&
            flag_certMemoDesc === 1
          ) {
            if (dialogRowData.objectionStatus === 2) {
              callResetObjectionStatus(dialogRowData.applicationId);
            }
            setFlag_copyOfApplicantCNICFront(null);
            setFlag_copyOfApplicantCNICBack(null);
            setFlag_premisesDocument(null);
            setFlag_scannedCopyOfNearByElectricityBill(null);
            setFlag_anyOtherDocument(null);
            setFlag_copyOfOwnerCNICFront(null);
            setFlag_copyOfOwnerCNICBack(null);
            setFlag_ownerNOC(null);
            setFlag_resolutionFormDesc(null);
            setFlag_certMemoDesc(null);
            setFlag_certFormDesc(null);
            callChangeProgressIdAPI(
              2,
              "Documents Verified",
              "Documents Verified"
            );
          } else {
            console.log("Failed to change status for owner industrial Case!");
          }
        }
      } else {
        if (
          flag_ownerNOC === 1 &&
          flag_copyOfOwnerCNICFront === 1 &&
          flag_copyOfOwnerCNICBack === 1
        ) {
          if (
            dialogRowData.connectionType !== "Industrial" ||
            dialogRowData.connectionType !== "industrial"
          ) {
            if (dialogRowData.objectionStatus === 2) {
              callResetObjectionStatus(dialogRowData.applicationId);
            }
            setFlag_copyOfApplicantCNICFront(null);
            setFlag_copyOfApplicantCNICBack(null);
            setFlag_premisesDocument(null);
            setFlag_scannedCopyOfNearByElectricityBill(null);
            setFlag_anyOtherDocument(null);
            setFlag_copyOfOwnerCNICFront(null);
            setFlag_copyOfOwnerCNICBack(null);
            setFlag_ownerNOC(null);
            setFlag_resolutionFormDesc(null);
            setFlag_certMemoDesc(null);
            setFlag_certFormDesc(null);
            callChangeProgressIdAPI(
              2,
              "Documents Verified",
              "Documents Verified"
            );
          } else {
            if (
              flag_resolutionFormDesc === 1 &&
              flag_certFormDesc === 1 &&
              flag_certMemoDesc === ""
            ) {
              if (dialogRowData.objectionStatus === 2) {
                callResetObjectionStatus(dialogRowData.applicationId);
              }
              callChangeProgressIdAPI(
                2,
                "Documents Verified",
                "Documents Verified"
              );
              setFlag_copyOfApplicantCNICFront(null);
              setFlag_copyOfApplicantCNICBack(null);
              setFlag_premisesDocument(null);
              setFlag_scannedCopyOfNearByElectricityBill(null);
              setFlag_anyOtherDocument(null);
              setFlag_copyOfOwnerCNICFront(null);
              setFlag_copyOfOwnerCNICBack(null);
              setFlag_ownerNOC(null);
              setFlag_resolutionFormDesc(null);
              setFlag_certMemoDesc(null);
              setFlag_certFormDesc(null);
            } else {
              console.log(
                "Failed to change status for tenant industrial case!"
              );
            }
          }
        }
      }
    } else {
      console.log("Failed to change status for owner non-industrial case!");
    }
  };

  const statusFunc = (x, objection) => {
    if (objection === 0 || objection === 2) {
      if (x === 0) {
        return "Pending";
      } else if (x > 0 && x < 5) {
        return "In Process";
      } else if (x >= 5 && x < 10) {
        return "Approved";
      } else {
        return "Completed";
      }
    } else {
      return "Objection";
    }
  };
  const formatAmount = (value) => {
    const num = Number(value) || 0; // convert safely
    return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const progFunc = (x) => {
    if (x === 0) {
      return "Documents Uploading";
    } else if (x === 1) {
      return "Documents Verification";
    } else if (x === 21) {
      return "Wiring Test Report";
    }
    else if (x === 2) {
      return "Arrear Verification";
    } else if (x === 3) {
      return "Field Survey";
    } else if (x === 4) {
      return "Reference No. Allocation";
    } else if (x === 5) {
      return "Demand Note Payment";
    } else if (x === 6) {
      return "DN Payment Verification";
    } else if (x === 7) {
      return "Service Connection Order";
    } else if (x === 8) {
      return "Meter Installation";
    } else if (x === 9) {
      return "Ready for Billing";
    } else if (x === 10) {
      return "Completed";
    }
  };

  // Function to convert applicationProgressId to step index for StepProgressBar
  const getStepIndex = (progressId) => {
    if (progressId === 0) return 0; // Document Submission
    if (progressId === 1) return 1; // Document Verification
    if (progressId === 21) return 2; // Wiring Test Report
    if (progressId === 2) return 3; // Arrear Verification
    if (progressId === 3) return 4; // Arrear Verification
    if (progressId === 4) return 5; // Field Survey
    if (progressId === 5) return 6; // Ref No Allocation
    if (progressId === 6) return 7; // DN Payment Submission
    if (progressId === 7) return 8; // DN Payment Verification
    if (progressId === 8) return 9; // Service Connection Order
    if (progressId === 9) return 10; // Meter Installation
    if (progressId === 10) return 11; // Ready for Billing
    return progressId; // Default fallback
  };

  const stepName = (x, y, objectionStatus) => {
    console.log(x, y, objectionStatus, "xyvalues");
    if (x === 0) {
      return "Application Submitted";
    } else if (x === 1) {
      // Check for Documents Reuploaded first
      if (y && y.includes("Reuploaded")) {
        return "Documents Reupload";
      }
      return objectionStatus === 1 ? "Documents Objection" : "Application Submitted";
    } else if (x === 21) {
      if (y && y.includes("Reupload")) {
        return "Wiring Test Report Reupload";
      }
      return objectionStatus === 1 ? "Wiring Test Report Rejected" : "Documents Verified";
      // return  "Documents Verification";
    } else if (x === 2) {
      if (y && y.includes("exist")) {
        return "Arrear Objection";
      }
      if (y && y.includes("Removed")) {
        return "Arrear Objection Removed";
      }
      if (y && y.includes("Removed")) {
        return "Arrear Objection Removed";
      }
      return objectionStatus === 1 ? "Arrear Objection" : "Wiring Test Report Verification";
    } else if (x === 3 || (x === 3 && y === "Arrears Verified.")) {
      return "Arrear Verification";
    } else if (x === 4) {
      return "Field Survey";
    } else if (x === 5 && y === "Reference No. allocated.") {
      return "Reference No. Allocated";
    } else if (
      (x === 5 && y === "Demand Note Approved.") ||
      (x === 5 && y === "Demand Note Issued.") ||
      (x === 5 && y === "Demand Notice Created")
    ) {
      return "Demand Note Approved";
    } else if (x === 6) {
      return "DN Payment Submission";
    } else if (x === 7) {
      return "DN Payment Verification";
    } else if (x === 8 && y === "DN Payment Verified") {
      return "DN Payment Verification";
    } else if (x === 8) {
      return "Service Connection Order";
    } else if (x === 9) {
      return "Meter Installation";
    } else if (x === 10) {
      return "Ready for Billing";
    }
  };

  const getDocumentApi = async (applicationId) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "electricityNewConnection/getDocuments",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status == "200") {

          setDialogRowData((prevObject) => ({
            ...prevObject,
            copyOfApplicantCNICFront: result.images[0].copyOfApplicantCNICFront,
            copyOfApplicantCNICBack: result.images[0].copyOfApplicantCNICBack,
            premisesDocument: result.images[0].premisesDocument,
            scannedCopyOfNearByElectricityBill:
              result.images[0].scannedCopyOfNearByElectricityBill,
            // wiringTestReportDocument: result.images[0].wiringTestReportDocument,
            anyOtherDocument: result.images[0].anyOtherDocument,
            copyOfOwnerCNICFront: result.images[0].copyOfOwnerCNICFront,
            copyOfOwnerCNICBack: result.images[0].copyOfOwnerCNICBack,
            ownerNOC: result.images[0].ownerNOC,
            resolutionFormDesc: result.images[0].resolutionFormDesc,
            certFormDesc: result.images[0].certFormDesc,
            certMemoDesc: result.images[0].certMemoDesc,
          }));
        }
      })
      .catch((error) => console.log("error", error));
  };

  const getDocumentTestWiringReport = async (applicationId) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: applicationId,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(cfpBaseUrl + "enc/getWiringTestReport", requestOptions);
      const result = await response.json();

      if (result.status === "200" && result.data && result.data.length > 0) {
        const wiringTestReportDocument = result.data[0].wiringTestReportDocument;

        // Update dialogRowData with the wiring test report document
        setDialogRowData((prevObject) => ({
          ...prevObject,
          wiringTestReportDocument: wiringTestReportDocument,
        }));

        console.log("Wiring Test Report saved successfully:", wiringTestReportDocument);
      } else {
        console.error("No wiring test report document found in the response.");
      }
    } catch (error) {
      console.error("Error fetching wiring test report:", error);
    }
  };

  const handleRowClick = async (applicationId, applicationProgress) => {
    setViewBackdrop(true);

    if (applicationProgress == "Field Survey") {
      callMaterials(applicationId);
    }
    // if (applicationProgressId === 3) {
    // }
    let allTarList = [...allTariffList];
    if (allTarList.length == 0) {
      allTarList = await callTariffList();
    }

    let demandNoticeDetails = "";
    let dnPayDate = "";
    let scoDets = "";
    if (applicationId) {
      const item = await filterNCApp(applicationId);

      if (item) {
        const isNC13Application = (item.applicationId?.slice(3, 5) === "13" || item.applicationId?.slice(3, 5) === "14");
        const shouldCheckQueue =
          isNC13Application &&
          (item.applicationProgressId < 5 || item.applicationProgressId === 21);

        if (shouldCheckQueue) {
          const queueCheck = await callNextNCApplicationsInQueue(applicationId);
          if (!queueCheck.canProceed) {
            // Keep NC workflow dialog visible first, then show queue alert over it.
            setDialogRowData(item);
            setOpen(true);
            setQueuePriorityInfo({
              requestedApplicationId: applicationId,
              nextApplicationId: queueCheck?.nextInQueue?.applicationId || "",
              requestedQueuePosition:
                queueCheck?.requestedItem?.QueuePosition ??
                queueCheck?.requestedItem?.queuePosition ??
                null,
              topQueueApplicationIds: Array.isArray(queueCheck?.queueData)
                ? queueCheck.queueData
                  .map((itm) => itm?.applicationId)
                  .filter(Boolean)
                  .slice(0, 10)
                : [],
            });
            setTimeout(() => setShowQueuePriorityPopup(true), 0);
            setViewBackdrop(false);
            return;
          }
        }

        const connectionType = item.connectionType;
        const appliedLoad = item.appliedLoad;
        const seasonalNonSeasonal = item.seasonalNonSeasonalFlag;
        const nearByRefNo = item.nearByReferenceNumber;
        let phase;

        if (item.connectionType !== "Electrification") {
          phase = await getTariffAndMeterType(
            appliedLoad,
            connectionType,
            seasonalNonSeasonal,
            allTarList,
            item.applicationProgressId
          );
        }
        const area = item.areaType?.toLowerCase();

        fieldFormik.setFieldValue(
          "iv_rural_urban",
          area.startsWith("ur") || area.startsWith("Ur")
            ? "U"
            : area.startsWith("ru")
              ? "R"
              : ""
        );
        setDialogRowData(item);
        setSanctionLoad(item.appliedLoad);
        setFlag_copyOfApplicantCNICFront(item.copyOfApplicantCNICFrontFlag);
        setFlag_copyOfApplicantCNICBack(item.copyOfApplicantCNICBackFlag);
        setFlag_scannedCopyOfNearByElectricityBill(
          item.scannedCopyOfNearByElectricityBillFlag
        );
        setFlag_anyOtherDocument(item.anyOtherDocumentFlag);
        setFlag_premisesDocument(item.premisesDocumentFlag);
        setFlag_copyOfOwnerCNICFront(item.copyOfOwnerCNICFrontFlag);
        setFlag_copyOfOwnerCNICBack(item.copyOfOwnerCNICBackFlag);
        setFlag_ownerNOC(item.ownerNOCFlag);
        setFlag_resolutionFormDesc(item.resolutionFormDescFlag);
        setFlag_certMemoDesc(item.certMemoDescFlag);
        setFlag_certFormDesc(item.certFormDescFlag);
        setCopyOfApplicantCNICFrontObjectionRemarks(
          item.copyOfApplicantCNICFrontObjectionRemarks
        );
        setCopyOfApplicantCNICBackObjectionRemarks(
          item.copyOfApplicantCNICBackObjectionRemarks
        );
        setPremisesDocumentObjectionRemarks(
          item.premisesDocumentObjectionRemarks
        );
        setScannedCopyOfNearByElectricityBillObjectionRemarks(
          item.scannedCopyOfNearByElectricityBillObjectionRemarks
        );
        setAnyOtherDocumentObjectionRemarks(
          item.anyOtherDocumentObjectionRemarks
        );
        setCopyOfOwnerCNICFrontObjectionRemarks(
          item.copyOfOwnerCNICFrontObjectionRemarks
        );
        setCopyOfOwnerCNICBackObjectionRemarks(
          item.copyOfOwnerCNICBackObjectionRemarks
        );
        setOwnerNOCObjectionRemarks(item.ownerNOCObjectionRemarks);
        setResolutionFormDescObjectionRemarks(
          item.resolutionFormDescObjectionRemarks
        );
        setCertMemoDescObjectionRemarks(item.certMemoDescObjectionRemarks);
        setCertFormDescObjectionRemarks(item.certFormDescObjectionRemarks);
        // await callEfileAPI(applicationId, item);

        if (item.applicationProgressId == 21) {
          await getDocumentTestWiringReport(item.applicationId);
          // await getDocumentApi(item.applicationId);
        }

        if (item.applicationProgressId < 3 || item.applicationProgressId == 6) {
          await getDocumentApi(item.applicationId);
        }
        if (item.applicationProgressId === 2 && item.objectionStatus === 1) {
          var formdata = new FormData();

          formdata.append("applicationNo", item.applicationId);
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);

          var requestOptions = {
            method: "POST",
            body: formdata,
            headers: myHeaders,
            redirect: "follow",
          };

          await fetch(cfpBaseUrl + "comman/getArrears", requestOptions)
            .then((response) => response.json())
            .then((result) => {
              const arrearsObject = {
                refNo: result.data[0].refNo,
                arrearsAmount: result.data[0].arrearAmount,
                meterStatus: result.data[0].meterStatus,
                tariffDesc: result.data[0].tariffDesc,
                meterType: result.data[0].meterType,
                phase: result.data[0].phase,
                consumerName: result.data[0].consumerName,
                consumerNo: result.data[0].consumerPhoneNo,
                consumerAddress: result.data[0].consumerAddress,
                consumerEmail: result.data[0].consumerEmail,
                paidArearImage: result.data[0].paidArearImage,
                paidArearDate: result.data[0].paidArearDate,
              };
              arearsFormik.values.iv_property_reference_no =
                result.data[0].refNo;
              setArrearsDetailsRefnoToDisplay(arrearsObject);
            })
            .catch((error) => console.log("error", error));
        }
        if (item.applicationProgressId === 2) {
          let cnicToTest = "";

          if (item.applicantStatus === "Owner") {
            cnicToTest = item.applicantCNIC;
          } else if (item.applicantStatus === "Tenant") {
            cnicToTest = item.ownerCNIC;
          }
          let apiResponse = await (token,
            cnicToTest + "?company_code=" + item.companyCode);
          if (apiResponse.status) {
            if (!apiResponse.error) {
              if (true) {
                let arrearsObj = {
                  arrearsAmount: apiResponse.basicInfo.arrear,
                  meterStatus: apiResponse.metersInfo[0].mtrStatus,
                  tariffDesc: apiResponse.basicInfo.tariffDescription,
                  meterType: apiResponse.basicInfo.meterType,
                  phase: apiResponse.basicInfo.phase,
                  consumerName: apiResponse.basicInfo.consumerName,
                  consumerNo: apiResponse.basicInfo.consumerContactNo,
                  consumerAddress:
                    apiResponse.basicInfo.consumerAddress1 +
                    apiResponse.basicInfo.consumerAddress2,
                  consumerEmail: apiResponse.basicInfo.consumerEmail,
                };
              }
            } else {
              console.log(
                "Unable to get errors for the CNIC. Please try later!"
              );
            }
          } else {
            setError("CNIC not found!");
          }
        }
        if (item.applicationProgressId === 3) {
          await getWFData();
          await callMaterials(item.applicationId);
          let fieldStaffDesignations = await getFieldStaffDesignations(token);
          setFieldStaffDesignations(fieldStaffDesignations);
          fieldFormik.values.iv_no_of_meters_already_installed =
            item.noOfMetersAlreadyInstalled;
          if (
            item.objectionStatus === 1 &&
            item.remarks === "Load at site exceeds than applied."
          ) {
            appliedLoadFormik.values.iv_applied_load = item.appliedLoad;
          }
        }
        if (item.applicationProgressId >= 4 && item.applicationProgressId !== 21) {
          await callFeederList("", "", "", item.subDivisionCode);
          await callMaterials(item.applicationId);
          await callAsyncFieldSurveyInformation(item.applicationId);
          let feederNoToAllocate = "";
          if (item.applicationProgressId === 4) {
            if (nearByRefNo) {
              let apiResponse = await dBillAPI(token, nearByRefNo);
              if (apiResponse.status && apiResponse.basicInfo) {
                feederNoToAllocate = apiResponse.basicInfo.feederCode;
              } else {
                setViewBackdrop(false);
              }
            }
          }

          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          myHeaders.append("Content-Type", "application/json");

          const raw = JSON.stringify({
            applicationId: item.applicationId,
          });

          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          await fetch(cfpBaseUrl + "enc/getDemandNoteData", requestOptions)
            .then((response) => response.json())
            .then((result) => {
              if (result.data.length > 0) {
                // if field survey data is already filled
                setDnDetails(result.data[0]);
                setIsDemandNoteExpired(result.dnExpiryFlag);
                demandNoticeDetails = result.data[0];
                if (item.applicationProgressId === 4) {
                  refNoAllocationFormik.values.iv_feeder_no = isNaN(
                    parseInt(result.data[0].feederNo)
                  )
                    ? feederNoToAllocate
                    : result.data[0].feederNo;
                  refNoAllocationFormik.values.iv_batch = result.data[0].batchNo
                    ? result.data[0].batchNo
                    : "";
                  refNoAllocationFormik.values.iv_reference_to_allot = result
                    .data[0].connectionAccountNo
                    ? result.data[0].connectionAccountNo.slice(7)
                    : "";
                  refNoAllocationFormik.values.iv_sub_batch = result.data[0]
                    .subBatch
                    ? result.data[0].subBatch
                    : "";
                  refNoAllocationFormik.values.iv_cantonment_board = result
                    .data[0].cantonmentBoard
                    ? result.data[0].cantonmentBoard
                    : "";
                  refNoAllocationFormik.values.iv_local_bodies = result.data[0]
                    .localBodies
                    ? result.data[0].localBodies
                    : "";
                  refNoAllocationFormik.values.iv_fgovt = result.data[0].fGovt
                    ? result.data[0].fGovt
                    : "";
                  refNoAllocationFormik.values.iv_pgovt = result.data[0].pGovt
                    ? result.data[0].pGovt
                    : "";
                  refNoAllocationFormik.values.iv_govt_dept_code = result
                    .data[0].governmentDepartmentCode
                    ? result.data[0].governmentDepartmentCode
                    : "";
                }

                let gdc = govtDeptCodes.find(
                  (item) =>
                    item.departmentCode ==
                    result.data[0].governmentDepartmentCode
                );
                setGovtDeptCode(gdc);

                if (demandNoticeDetails.tariff) {
                  setTariff(demandNoticeDetails.tariff);
                  refNoAllocationFormik.values.iv_tariff =
                    demandNoticeDetails.tariff;
                }
                if (demandNoticeDetails.meterType) {
                  setMeterType(demandNoticeDetails.meterType);
                  refNoAllocationFormik.values.iv_meter_type =
                    demandNoticeDetails.meterType;
                }
                if (demandNoticeDetails.capitalCostAmount) {
                  setCapitalCostAmnt(demandNoticeDetails.capitalCostAmount);
                }
                if (demandNoticeDetails.securityDepositeAmount) {
                  setSecurityDepositeAmount(
                    demandNoticeDetails.securityDepositeAmount
                  );
                }
                if (
                  demandNoticeDetails.capitalCostAmount &&
                  demandNoticeDetails.securityDepositeAmount
                ) {
                  SetTotalEstimatedAmnt(
                    (
                      parseFloat(demandNoticeDetails.capitalCostAmount) +
                      parseFloat(demandNoticeDetails.securityDepositeAmount)
                    ).toFixed(2)
                  );
                }
                if (result.data[0].amountOfGridSharing) {
                  setGridFlag(true);
                } else {
                  setGridFlag(false);
                }
                refNoAllocationFormik.values.iv_grid_sharing_cost = isNaN(
                  parseInt(result.data[0].amountOfGridSharing)
                )
                  ? 0
                  : parseInt(result.data[0].amountOfGridSharing);
                setGridSharingCost(
                  isNaN(parseInt(result.data[0].amountOfGridSharing))
                    ? 0
                    : parseInt(result.data[0].amountOfGridSharing)
                );

                if (result.data[0].amountOfFeederRehab) {
                  setFeederRehabFlag(true);
                } else {
                  setFeederRehabFlag(false);
                }

                refNoAllocationFormik.values.iv_feeder_rehab_charges = isNaN(
                  parseInt(result.data[0].amountOfFeederRehab)
                )
                  ? 0
                  : parseInt(result.data[0].amountOfFeederRehab);
                setFeederRehabilitationCharges(
                  isNaN(parseInt(result.data[0].amountOfFeederRehab))
                    ? 0
                    : parseInt(result.data[0].amountOfFeederRehab)
                );
                if (item.connectionType.toLowerCase() == "industrial") {
                  refNoAllocationFormik.values.iv_industry_factory_type = result
                    .data[0].industryFactoryType
                    ? result.data[0].industryFactoryType
                    : "";
                }
                refNoAllocationFormik.values.iv_civil_work_charges = isNaN(
                  parseInt(result.data[0].civilWorkCharges)
                )
                  ? 0
                  : parseInt(result.data[0].civilWorkCharges);
                setCivilWorkCharges(
                  isNaN(parseInt(result.data[0].civilWorkCharges))
                    ? 0
                    : parseInt(result.data[0].civilWorkCharges)
                );
                refNoAllocationFormik.values.iv_fixed_charges_of_metering =
                  isNaN(parseInt(result.data[0].fixedChargesOfMetering))
                    ? 0
                    : parseInt(result.data[0].fixedChargesOfMetering);
                setFixedChargesOfMetering(
                  isNaN(parseInt(result.data[0].fixedChargesOfMetering))
                    ? 0
                    : parseInt(result.data[0].fixedChargesOfMetering)
                );
                refNoAllocationFormik.values.iv_miscellaneous_charges = isNaN(
                  parseInt(result.data[0].miscellaneousCharges)
                )
                  ? 0
                  : parseInt(result.data[0].miscellaneousCharges);
                setMiscellaneousCharges(
                  isNaN(parseInt(result.data[0].miscellaneousCharges))
                    ? 0
                    : parseInt(result.data[0].miscellaneousCharges)
                );
                refNoAllocationFormik.values.iv_less_the_cost = isNaN(
                  parseInt(result.data[0].lessTheCost)
                )
                  ? 0
                  : parseInt(result.data[0].lessTheCost);
                setLessTheCost(
                  isNaN(parseInt(result.data[0].lessTheCost))
                    ? 0
                    : parseInt(result.data[0].lessTheCost)
                );

                let arrayOfBoq = result.BoQitems;
                let arrayOfItems = [];
                let materials = allMaterialList;
                arrayOfBoq.forEach((item) => {
                  const foundItem = materials.find(
                    (itm) =>
                      String(itm.item_Code || itm.Item_Code)
                        .trim()
                        .toLowerCase() ===
                      String(item.item_Code || item.Item_Code)
                        .trim()
                        .toLowerCase()
                  );

                  const itemToBeAdded = {};

                  if (foundItem) {
                    itemToBeAdded.itemCode =
                      foundItem.item_Code || foundItem.Item_Code;
                    itemToBeAdded.name =
                      foundItem.item_Name || foundItem.Item_Name;
                    itemToBeAdded.code =
                      foundItem.item_Code || foundItem.Item_Code;
                    itemToBeAdded.qty = item.qty || 0;
                    itemToBeAdded.rate = parseFloat(foundItem.item_Amount || foundItem.Item_Amount || foundItem.Rate || 0);
                    itemToBeAdded.unit =
                      foundItem.item_Unit || foundItem.Item_Unit || "";
                    itemToBeAdded.amount = Math.round(parseFloat(item.qty || 0) * itemToBeAdded.rate);
                  } else {
                    itemToBeAdded.itemCode =
                      item.item_Code || item.Item_Code || "";
                    itemToBeAdded.name =
                      item.item_Name || item.Item_Name || "Unknown Item";
                    itemToBeAdded.qty = item.qty || 0;
                    itemToBeAdded.rate = 0;
                    itemToBeAdded.unit = "";
                    itemToBeAdded.amount = 0;
                  }

                  arrayOfItems.push(itemToBeAdded);
                });

                const {
                  totalAmountofItems,
                  store_charges,
                  installation_charges,
                } = calculateCharges(arrayOfItems);

                let total_charges = Math.trunc(
                  totalAmountofItems + store_charges + installation_charges
                );

                refNoAllocationFormik.values.iv_items_array = arrayOfItems;
                setItemsAmount(totalAmountofItems);
                setStoreCharges(store_charges);
                setInstallationCharges(installation_charges);
                setTotalCharges(total_charges);
                setItemsArray(arrayOfItems);
              } else {
                SetTotalEstimatedAmnt();
                setSecurityDepositeAmount();
                setCapitalCostAmnt();
              }
            })
            .catch((error) => console.log("error", error));

          scoDets = await callGetSCOAPI(item.applicationId, phase);
          let subDivisionObject = subDivisions.find(
            (objs) => objs.subDivisionCode === item.subDivisionCode
          );
          if (subDivisionObject) {
            setBankName(subDivisionObject.subDivBankName);
          }
        }
        if (item.applicationProgressId >= 5 && item.applicationProgressId !== 21) {
          var formdata = new FormData();

          formdata.append("applicationNo", item.applicationId);
          formdata.append("demandNoticeNo", "");

          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);

          var requestOptions = {
            method: "POST",
            body: formdata,
            headers: myHeaders,
            redirect: "follow",
          };

          await fetch(
            cfpBaseUrl + "demandNotice/getPaidDNImage",
            requestOptions
          )
            .then((response) => response.json())
            .then((result) => {
              if (result.status === "200") {
                setDnImage(result.data[0].paidDNImage);
                setDnNumber(result.data[0].demandNoticeNo);
                setDnPaymentDate(result.data[0].paymentDate);
                dnPayDate = result.data[0].paymentDate;
              }
            })
            .catch((error) => console.log("error", error));
        }
        if (item.applicationProgressId >= 6 && item.applicationProgressId !== 21) {
          scoPart2Formik.setFieldValue("iv_sanctioned_load", item.appliedLoad);

          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          myHeaders.append("Content-Type", "application/json");

          const raw = JSON.stringify({
            applicationId: item.applicationId,
          });

          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          await fetch(cfpBaseUrl + "enc/getDemandNoteData", requestOptions)
            .then((response) => response.json())
            .then((result) => {
              setIsDemandNoteExpired(result.dnExpiryFlag);
              setDnDetails(result.data[0]);
              refNoAllocationFormik.setFieldValue("iv_batch", result.data[0].batchNo);
              refNoAllocationFormik.setFieldValue("iv_feeder_no", result.data[0].feederNo);
              refNoAllocationFormik.setFieldValue("iv_sub_batch", result.data[0].subBatch);
              refNoAllocationFormik.setFieldValue("iv_refNo", result.data[0].consumerAccountNo);

              if (item.areaType == "Urban" || item.areaType == "urban") {
                refNoAllocationFormik.setFieldValue("iv_rural_urban", "U");
              } else if (item.areaType == "Rural" || item.areaType == "rural") {
                refNoAllocationFormik.setFieldValue("iv_rural_urban", "R");
              }
            })
            .catch((error) => console.log("error", error));

          await callFeederList("", "", "", item.subDivisionCode);
        }
        if (item.applicationProgressId >= 7 && item.applicationProgressId !== 21) {
          scoDets = await callGetSCOAPI(item.applicationId, phase);
          if (!scoDets.scoP2FillFlag) {
            if (phase == "Single Phase") {
              scoPart2Formik.setFieldValue("iv_meter_code1", "000002");
            } else if (phase == "3 Phase") {
              scoPart2Formik.setFieldValue("iv_meter_code1", "050502");
              scoPart2Formik.setFieldValue("iv_meter_code2", "050602");
            }

            if (phase == "MDI (LT)(CT)" || phase == "MDI (HT)(CT/PT)") {
              scoPart2Formik.setFieldValue("iv_ct_nom", "5");
              scoPart2Formik.setFieldValue("iv_ct_denom", "5");
            } else {
              scoPart2Formik.setFieldValue("iv_ct_nom", "1");
              scoPart2Formik.setFieldValue("iv_ct_denom", "1");
            }

            if (phase == "MDI (HT)(CT/PT)") {
              scoPart2Formik.setFieldValue("iv_pt_nom", "11000");
              scoPart2Formik.setFieldValue("iv_pt_denom", "110");
            }

            if (
              demandNoticeDetails?.meterType !== null &&
              demandNoticeDetails?.meterType !== undefined
            ) {
              scoPart2Formik.setFieldValue(
                "iv_meter_type",
                String(demandNoticeDetails.meterType)
              );
            }

            // Set installation date from SCO details or default to today when SCO Part 2 is not filled yet
            if (scoDets?.dateOfConnection) {
              scoPart2Formik.setFieldValue("iv_date_of_connection", scoDets.dateOfConnection.slice(0, 10));
            } else if (!scoPart2Formik.values.iv_date_of_connection) {
              scoPart2Formik.setFieldValue("iv_date_of_connection", new Date().toISOString().slice(0, 10));
            }
          }
        }
        if (item.applicationProgressId >= 8 && item.applicationProgressId !== 21) {
          if (item.applicationProgressId == 8) {
            await getWFData();
            let fieldStaffDesignations = await getFieldStaffDesignations(token);
            setFieldStaffDesignations(fieldStaffDesignations);
          }

          if (!scoDets.connectionInstallerName && !scoPart2Formik.values.iv_connection_installer_name) {
            scoPart2Formik.setFieldValue("iv_connection_installer_name", userId);
          }
          refNoAllocationFormik.setFieldValue("iv_date_of_connection", scoDets.dateOfConnection);
          masterDataFormik.setFieldValue("iv_batch", scoDets.batch);
          if (scoDets.fGovt || scoDets.pGovt) {
            masterDataFormik.setFieldValue("iv_govt_dept", 1);
          } else {
            masterDataFormik.setFieldValue("iv_govt_dept", 0);
          }
          await callGetCP136API(item.applicationId);
        }
        const getUnripeAge = () => {
          let ageInDays = "";
          let crtDate = new Date(item.creationDate);
          if (item.applicationProgressId < 5) {
            let currentDate = new Date();
            const ageInMilliseconds = currentDate - crtDate;
            ageInDays = ageInMilliseconds / (1000 * 60 * 60 * 24);
            setUnripeAge(Math.floor(ageInDays));
          } else {
            if (demandNoticeDetails) {
              let dnDate = new Date(demandNoticeDetails.issueDate);
              const ageInMilliseconds = dnDate - crtDate;
              ageInDays = ageInMilliseconds / (1000 * 60 * 60 * 24);
              setUnripeAge(Math.floor(ageInDays));
            }
          }
        };

        getUnripeAge();

        const getRipeAge = () => {
          let ageInDays = "";
          let DnPaymentDate = new Date(dnPayDate);
          if (item.applicationProgressId < 8) {
            let currentDate = new Date();
            const ageInMilliseconds = currentDate - DnPaymentDate;
            ageInDays = ageInMilliseconds / (1000 * 60 * 60 * 24);
            setRipeAge(Math.floor(ageInDays));
          } else {
            if (scoDets.dateOfConnection) {
              let MeterInstallationDate = new Date(scoDets.dateOfConnection);
              const ageInMilliseconds = MeterInstallationDate - DnPaymentDate;
              ageInDays = ageInMilliseconds / (1000 * 60 * 60 * 24);
              setRipeAge(Math.floor(ageInDays));
            } else {
              setRipeAge("-");
            }
          }
        };
        getRipeAge();
        setViewBackdrop(false);
        setOpen(true);
      }
    }
  };

  const onPressViewActivityLog = async () => {
    if (dialogRowData.applicationProgressId >= 3) {
      getDocumentApi(dialogRowData.applicationId);
    }
    await callEfileAPI(dialogRowData.applicationId, dialogRowData);
  };

  // useEffect(() => {
  //   if ((props.showTable && currentPath == "/new-connection-table")) {
  //     const callStandardClassificaitionCodesAPI = async () => {
  //       try {

  //         var formdata = new FormData();

  //         const myHeaders = new Headers();
  //         myHeaders.append("Authorization", token);

  //         var requestOptions = {
  //           method: 'POST',
  //           body: formdata,
  //           headers: myHeaders,
  //           redirect: 'follow'
  //         };

  //         await fetch(cfpBaseUrl + "demandNotice/getClassificationCodes", requestOptions)
  //           .then(response => response.json())
  //           .then(result => {
  //             if (result.status === "200") {
  //               setStandardClassificationCodes(result.data)
  //             }
  //           })
  //           .catch(error => console.log('error', error))
  //       }
  //       catch (e) {
  //         console.log('error calling classification codes API', e)
  //       }
  //     }
  //     if (roleTypeId == 1) {
  //       callStandardClassificaitionCodesAPI()
  //     }
  //   }
  // }, [])

  useEffect(() => {
    if (meterType !== null && meterType !== undefined) {
      refNoAllocationFormik.setFieldValue("iv_meter_type", String(meterType));
    }
  }, [meterType]);

  const getDocumentBackGroundColor = (flagValue) => {
    switch (flagValue) {
      case null:
        return "white";
      case -1:
        return "#FFCAC9";
      case 0:
        return "#F3F6FB";
      case 1:
        return "#D6F6D5";

      default:
        return "white";
    }
  };

  const DnReceiptImage = (event) => {
    if (event.target.files) {
      const newFileName =
        "paidDnImage." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        dnPymentReceiptFormik.handleChange,
        setDnReceiptImage,
        setDnReceiptImageError,
        setDnReceiptImageThumbnail,
        newFileName
      );
    }
  };

  // const deleteItem = (code) => {
  //   let itemsInArray = [...itemsArray];
  //   const index = itemsInArray.findIndex(item => item.Id === code);

  //   if (index !== -1) {
  //     itemsInArray.splice(index, 1);
  //     const { totalAmountofItems, store_charges, installation_charges } = calculateCharges(itemsInArray);
  //     const total_charges = totalAmountofItems + store_charges + installation_charges
  //     setItemsAmount(totalAmountofItems);
  //     setStoreCharges(store_charges);
  //     setInstallationCharges(installation_charges);
  //     setTotalCharges(total_charges);
  //     setItemsArray(itemsInArray);
  //   }
  // };

  const deleteItem = (indexToDelete) => {
    const updatedItems = itemsArray.filter((_, i) => i !== indexToDelete);

    const { totalAmountofItems, store_charges, installation_charges } =
      calculateCharges(updatedItems);
    const total_charges =
      totalAmountofItems + store_charges + installation_charges;

    setItemsAmount(totalAmountofItems);
    setStoreCharges(store_charges);
    setInstallationCharges(installation_charges);
    setTotalCharges(total_charges);
    setItemsArray(updatedItems);

    fieldItemFormik.setFieldValue("iv_items_array", updatedItems);
  };

  const getMeterType = (code) => {
    switch (code) {
      case 0:
        return "Normal";
      case "0":
        return "Normal";
      case 1:
        return "Smart";
      case "1":
        return "Smart";
      default:
        return "-";
    }
  };

  const FataPata = (event) => {
    refNoAllocationFormik.handleChange(event);
    refNoAllocationFormik.values.iv_fata_pata = event.target.value;
  };

  const RuralUrban = (event) => {
    refNoAllocationFormik.handleChange(event);
    refNoAllocationFormik.values.iv_rural_urban = event.target.value;
  };

  const SeasonalNonSeasonal = (event) => {
    scoPart2Formik.handleChange(event);
    scoPart2Formik.values.iv_seasonal_flag = event.target.value;
    // console.log(value);
  };

  const GovtDept = (event) => {
    masterDataFormik.handleChange(event);
    masterDataFormik.values.iv_govt_dept = event.target.value;
    masterDataFormik.values.iv_ed_code = "";
  };

  const MeterType = (event) => {
    scoPart2Formik.handleChange(event);
    scoPart2Formik.values.iv_meter_type = event.target.value;
  };

  const IncomeTax = (event) => {
    masterDataFormik.handleChange(event);
    masterDataFormik.values.iv_income_tax = event.target.value;
  };

  const MeterLine = (event) => {
    fieldFormik.handleChange(event);
    fieldFormik.values.iv_distance = event.target.value;
    setDistance(event.target.value);
    if (event.target.value == "0") {
      setGridFlag(false);
      setFeederRehabFlag(false);
    }
    // if (event.target.value == "1") {
    //   setCivilWorkCharges(0)
    //   setFixedChargesOfMetering(0)
    //   setMiscellaneousCharges(0)
    //   setInstallationCharges('')
    //   setItemsAmount('')
    //   setStoreCharges(0)
    //   setLessTheCost(0)
    //   setGridSharingCost(0)
    //   setFeederRehabilitationCharges('')
    //   SetTotalEstimatedAmnt('')
    //   setBoqItems([])
    //   setItemsArray([])
    //   setGrandTotalCharges(0)

    // } else {
    //   setCivilWorkCharges("")
    //   setItemsArray([])
    //   setFixedChargesOfMetering('')
    //   setMiscellaneousCharges('')
    //   setInstallationCharges('')
    //   setItemsAmount('')
    //   setStoreCharges('')
    //   setLessTheCost('')
    //   setGridSharingCost("")
    //   setFeederRehabilitationCharges('')
    //   SetTotalEstimatedAmnt('')
    //   setBoqItems([])
    //   setGrandTotalCharges('')
    // }
    setCivilWorkCharges(0);
    setFixedChargesOfMetering(0);
    setMiscellaneousCharges(0);
    setInstallationCharges("");
    setItemsAmount("");
    setStoreCharges(0);
    setLessTheCost(0);
    setGridSharingCost(0);
    setFeederRehabilitationCharges("");
    SetTotalEstimatedAmnt("");
    setBoqItems([]);
    setItemsArray([]);
    setGrandTotalCharges(0);
    // Clear additional charges when toggling Estimate Lumpsum
    setMntCharges(0);
    setLabourCharges(0);
    setDesignVettingFee(0);
    setConsultancyCharges(0);
    setVariationCharges(0);
    setDismantlementCharges(0);
    setEarthingCharges(0);
  };

  const eFileIcon = () => {
    return <img src={eFileIcon} alt="Efile Icon" height="20" width="25" />;
  };

  const downloadApplicationPDF = async (application) => {
    setViewBackdrop(true);
    try {
      let applicationId = application.applicationId;
      let applicationDocs;
      let DiscoCode = application.companyCode.toString();

      await callAsyncGetDocumentsAPI(applicationId).then((response) => {
        applicationDocs = response;
      });

      const copyOfApplicantCNICFront = applicationDocs.copyOfApplicantCNICFront
        ? applicationDocs.copyOfApplicantCNICFront
        : "";
      const copyOfApplicantCNICBack = applicationDocs.copyOfApplicantCNICBack
        ? applicationDocs.copyOfApplicantCNICBack
        : "";
      const premisesDocument = applicationDocs.premisesDocument
        ? applicationDocs.premisesDocument
        : "";
      const scannedCopyOfNearByElectricityBill =
        applicationDocs.scannedCopyOfNearByElectricityBill
          ? applicationDocs.scannedCopyOfNearByElectricityBill
          : "";
      const anyOtherDocument = applicationDocs.anyOtherDocument
        ? applicationDocs.anyOtherDocument
        : "";
      const copyOfOwnerCNICFront = applicationDocs.copyOfOwnerCNICFront
        ? applicationDocs.copyOfOwnerCNICFront
        : "";
      const copyOfOwnerCNICBack = applicationDocs.copyOfOwnerCNICBack
        ? applicationDocs.copyOfOwnerCNICBack
        : "";
      const ownerNOC = applicationDocs.ownerNOC ? applicationDocs.ownerNOC : "";
      const resolutionFormDesc = applicationDocs.resolutionFormDesc
        ? applicationDocs.resolutionFormDesc
        : "";
      const certMemoDesc = applicationDocs.certMemoDesc
        ? applicationDocs.certMemoDesc
        : "";
      const certFormDesc = applicationDocs.certFormDesc
        ? applicationDocs.certFormDesc
        : "";

      const doc = new jsPDF({ compressPdf: true });

      // Helper function to add page header
      const addPageHeader = (doc, DiscoCode, applicationId, documentTitle) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const padding = 10;
        const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
        const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
        const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
        const logoX = (pageWidth - logoWidth) / 2;

        let height = 10;

        // Add logo
        doc.addImage(
          getLogo(DiscoCode),
          "PNG",
          logoX,
          5,
          logoWidth,
          logoHeight
        );

        // Add company name
        height += 15;
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
          align: "center",
        });

        // Add application ID
        height += 10;
        doc.setFont("helvetica", "normal");
        doc.text("Application Id: ", padding, height);
        doc.text(
          applicationId,
          padding + doc.getTextWidth("Application Id: "),
          height
        );

        // Add document title with border
        height += 10;
        const rectWidth = 195;
        const rectHeight = 10;
        const rectX = (pageWidth - rectWidth) / 2;

        doc.setFillColor(199, 199, 199);
        doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
        doc.setFont("helvetica", "bold");
        doc.text(documentTitle, pageWidth / 2, height, { align: "center" });

        return height + 3.5; // Return the Y position where content should start
      };

      // Helper function to add document image/PDF with fixed dimensions
      const addDocumentContent = async (doc, documentData, startHeight) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;

        // Draw rectangle for document
        doc.rect(rectX, startHeight, rectWidth, rectHeight);

        const fileType = documentData.slice(0, 6);
        let extension = "";

        if (fileType === "data:i") {
          extension = documentData.slice(11, 15);
        } else if (fileType === "data:a") {
          extension = documentData.slice(17, 19);
        }

        // Fixed dimensions to fit within the border (with small padding)
        const cardWidth = 190;
        const cardHeight = 228;
        const xPos = (pageWidth - cardWidth) / 2;
        const yPos = startHeight + 3;

        if (extension.startsWith("jp")) {
          doc.addImage(documentData, "jpeg", xPos, yPos, cardWidth, cardHeight);
        } else if (extension.startsWith("pn")) {
          doc.addImage(documentData, "png", xPos, yPos, cardWidth, cardHeight);
        } else if (extension.startsWith("pd")) {
          await addPdfasImage(
            documentData,
            rectX,
            startHeight,
            rectWidth,
            rectHeight
          );
        }
      };

      // Helper function to add CNIC images with fixed size to fit in border
      const addCNICImage = (
        doc,
        cnicData,
        startHeight,
        containerHeight = 234
      ) => {
        const pageWidth = doc.internal.pageSize.getWidth();

        // Fixed CNIC dimensions to fit nicely in the container
        const cardWidth = 150;
        const cardHeight = 95;
        const xPos = (pageWidth - cardWidth) / 2;

        // Center vertically within the container
        const yPos = startHeight + (containerHeight - cardHeight) / 2;

        const fileType = cnicData.slice(0, 6);
        let extension = "";

        if (fileType === "data:i") {
          extension = cnicData.slice(11, 15);
        } else if (fileType === "data:a") {
          extension = cnicData.slice(17, 19);
        }

        if (extension.startsWith("jp")) {
          doc.addImage(cnicData, "jpeg", xPos, yPos, cardWidth, cardHeight);
        } else if (extension.startsWith("pn")) {
          doc.addImage(cnicData, "png", xPos, yPos, cardWidth, cardHeight);
        }

        return yPos + cardHeight;
      };

      const addPdfasImage = async (
        pdfInBase64,
        rectX,
        rectY,
        rectWidth,
        rectHeight
      ) => {
        let base64ImagesArray = [];

        try {
          if (!window.pdfjsLib) {
            await new Promise((resolve, reject) => {
              const script = document.createElement("script");
              script.src =
                "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.379/pdf.min.mjs";
              script.type = "module";
              script.onload = () => {
                setTimeout(resolve, 100);
              };
              script.onerror = reject;
              document.head.appendChild(script);
            });
          }

          const pdfjsLib = window.pdfjsLib;
          pdfjsLib.GlobalWorkerOptions.workerSrc =
            "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.379/pdf.worker.min.mjs";

          const pdfData = atob(pdfInBase64.split(",")[1]);
          const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
          const docPageNumbers = pdf.numPages;

          const renderPageToBase64 = async (pageNumber) => {
            try {
              const pdfPage = await pdf.getPage(pageNumber);
              const scale = 1.5;
              const viewport = pdfPage.getViewport({ scale });
              const canvas = document.createElement("canvas");
              const canvasContext = canvas.getContext("2d");
              canvas.width = viewport.width;
              canvas.height = viewport.height;
              await pdfPage.render({ canvasContext, viewport }).promise;
              const imageDataUrl = canvas.toDataURL("image/png");
              return imageDataUrl;
            } catch (error) {
              console.error("Error rendering PDF page:", error);
              return null;
            }
          };

          for (let i = 1; i <= docPageNumbers; i++) {
            const imageDataUrl = await renderPageToBase64(i);
            if (imageDataUrl) {
              base64ImagesArray.push(imageDataUrl);
            }
          }

          // Fixed dimensions to fit within border
          const cardWidth = 190;
          const cardHeight = 228;
          const xPos = (doc.internal.pageSize.getWidth() - cardWidth) / 2;
          const yPos = rectY + 3;

          base64ImagesArray.forEach((imageDataUrl, index) => {
            if (index > 0) {
              doc.addPage();
              // Add header for additional PDF pages
              const contentHeight = addPageHeader(
                doc,
                DiscoCode,
                applicationId,
                "Property Document (Continued)"
              );
              doc.rect(rectX, contentHeight, rectWidth, rectHeight);
              doc.addImage(
                imageDataUrl,
                "PNG",
                xPos,
                contentHeight + 3,
                cardWidth,
                cardHeight
              );
            } else {
              doc.addImage(
                imageDataUrl,
                "PNG",
                xPos,
                yPos,
                cardWidth,
                cardHeight
              );
            }
          });
        } catch (error) {
          console.error("Error loading PDF:", error);
          alert("Failed to process PDF document. Please try again.");
        }
      };

      // FIRST PAGE - Application Summary
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Generate the barcode
      const barcodeCanvas = document.createElement("canvas");
      JsBarcode(barcodeCanvas, applicationId);
      const barcodeDataURL = barcodeCanvas.toDataURL("image/png");
      const qrCodeDataURL = await QRCode.toDataURL(applicationId, {
        errorCorrectionLevel: "M",
        margin: 0,
        width: 120,
      });

      const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
      const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
      const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
      const logoX = (pageWidth - logoWidth) / 2;

      doc.addImage(barcodeDataURL, "PNG", 78, 260, 40, 20);
      doc.addImage(qrCodeDataURL, "PNG", 132, 257, 18, 18);
      doc.addImage(getLogo(DiscoCode), "PNG", logoX, 5, logoWidth, logoHeight);

      let height = 25;
      const padding = 10;
      const leftMargin = 50;

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
        align: "center",
      });

      height += 8;
      doc.setFontSize(18);
      doc.text("E-Document", pageWidth / 2, height, { align: "center" });

      height += 8;
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      height += 8;

      doc.text("Document Type: ", padding, height);
      doc.text("New Connection", padding + leftMargin, height);
      doc.text("Tracking Id:", padding + leftMargin + leftMargin, height);
      doc.text(
        applicationId,
        padding + leftMargin + leftMargin + leftMargin,
        height
      );

      height += 6;
      doc.text("Application Status: ", padding, height);
      doc.text(
        statusFunc(
          application.applicationProgressId,
          application.objectionStatus
        ),
        padding + leftMargin,
        height
      );
      doc.text("Application Date:", padding + leftMargin + leftMargin, height);
      doc.text(
        convertDate(application.creationDate),
        padding + leftMargin + leftMargin + leftMargin,
        height
      );

      height += 6;
      doc.text("Sub-Division: ", padding, height);
      doc.text(
        subdivisionName(parseInt(application.subDivisionCode), subDivisions),
        padding + leftMargin,
        height
      );
      doc.text("Connection Type:", padding + leftMargin + leftMargin, height);
      doc.text(
        application.connectionType,
        padding + leftMargin + leftMargin + leftMargin,
        height
      );

      height += 6;
      doc.text("Phase / Load: ", padding, height);
      doc.text(
        application.appliedLoad.toString(),
        padding + leftMargin,
        height
      );
      doc.text("Connection Date:", padding + leftMargin + leftMargin, height);
      doc.text("-", padding + leftMargin + leftMargin + leftMargin, height);

      height += 20;
      let rectWidth = 195;
      let rectHeight = 10;
      let rectX = (pageWidth - rectWidth) / 2;

      doc.setFillColor(200, 200, 200);
      doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
      doc.setFont("helvetica", "bold");
      doc.text("Applicant Particulars", pageWidth / 2, height, {
        align: "center",
      });

      height += 6;
      rectHeight = 30;
      doc.rect(rectX, height - 2.5, rectWidth, rectHeight);

      doc.setFont("helvetica", "normal");
      height += 8;
      const extraPadding = 5;

      doc.text("Applicant Name:", padding + extraPadding, height);
      doc.text(application.applicantName, padding + 70, height);

      height += 6;
      doc.text("CNIC:", padding + extraPadding, height);
      doc.text(application.applicantCNIC, padding + 70, height);

      height += 6;
      doc.text("Present Address:", padding + extraPadding, height);
      doc.text(application.premisesAddress, padding + 70, height);

      height += 6;
      doc.text("Phone No.:", padding + extraPadding, height);
      doc.text(application.applicantMobile, padding + 70, height);

      height += 20;
      doc.setFillColor(255, 255, 255);
      doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
      doc.setFont("helvetica", "bold");
      doc.text("Premises Details", pageWidth / 2, height, { align: "center" });

      height += 3.5;
      rectHeight = 18;
      doc.rect(rectX, height, rectWidth, rectHeight);

      doc.setFont("helvetica", "normal");
      height += 8;
      doc.text(
        "No. of meter(s) already installed:",
        padding + extraPadding,
        height
      );
      doc.text(
        application.noOfMetersAlreadyInstalled.toString(),
        padding + 70,
        height
      );

      height += 6;
      doc.text("Present Address:", padding + extraPadding, height);
      doc.text(application.premisesAddress, padding + 70, height);

      // APPLICANT CNIC - Front on one page, Back on another
      if (copyOfApplicantCNICFront !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Applicant CNIC - Front"
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(
          doc,
          copyOfApplicantCNICFront,
          contentHeight,
          rectHeight
        );
      }

      if (copyOfApplicantCNICBack !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Applicant CNIC - Back"
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(
          doc,
          copyOfApplicantCNICBack,
          contentHeight,
          rectHeight
        );
      }

      // PREMISES DOCUMENT
      if (premisesDocument !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Property Document"
        );
        await addDocumentContent(doc, premisesDocument, contentHeight);
      }

      // NEARBY ELECTRICITY BILL
      if (scannedCopyOfNearByElectricityBill !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Near By Bill"
        );
        await addDocumentContent(
          doc,
          scannedCopyOfNearByElectricityBill,
          contentHeight
        );
      }

      // ANY OTHER DOCUMENT
      if (anyOtherDocument !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Any Other Document"
        );
        await addDocumentContent(doc, anyOtherDocument, contentHeight);
      }

      // OWNER CNIC - Front on one page, Back on another
      if (copyOfOwnerCNICFront !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Owner's CNIC - Front"
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(
          doc,
          copyOfOwnerCNICFront,
          contentHeight,
          rectHeight
        );
      }

      if (copyOfOwnerCNICBack !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Owner's CNIC - Back"
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(doc, copyOfOwnerCNICBack, contentHeight, rectHeight);
      }

      // OWNER NOC
      if (ownerNOC !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "NOC from Owner"
        );
        await addDocumentContent(doc, ownerNOC, contentHeight);
      }

      // RESOLUTION FORM
      if (resolutionFormDesc !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "BODs' Resolution Form"
        );
        await addDocumentContent(doc, resolutionFormDesc, contentHeight);
      }

      // MEMORANDUM OF ASSOCIATION
      if (certMemoDesc !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Memorandum of Association"
        );
        await addDocumentContent(doc, certMemoDesc, contentHeight);
      }

      // CERTIFIED FORM 29
      if (certFormDesc !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Certified Form 29"
        );
        await addDocumentContent(doc, certFormDesc, contentHeight);
      }

      // Add watermark and page numbers
      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(DiscoCode),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight()
        );
      }

      doc.setFontSize(8);
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        const pageNumberY = doc.internal.pageSize.getHeight() - 10;
        doc.text(
          "Page " + i + " of " + totalPages,
          doc.internal.pageSize.getWidth() / 2,
          pageNumberY,
          { align: "center" }
        );
      }

      const pdfBlob = doc.output("blob");

      // Create a file name
      const fileName = `${applicationId}-ApplicationPDF.pdf`;

      // Create URL for blob
      const pdfURL = URL.createObjectURL(pdfBlob);

      // Create a temporary link to trigger download
      const link = document.createElement("a");
      link.href = pdfURL;
      link.download = fileName; // <<--- This sets the file name
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(pdfURL);
    } catch (e) {
      console.log(e);
    } finally {
      // This will run after download is triggered (and small delay)
      setViewBackdrop(false); // Hide loader ONLY when everything is done
    }
  };

  const ArearPaidBillDocument = (event) => {
    if (event.target.files) {
      const newFileName =
        "arearPaidBillImage." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        arearBillDocumentFormik.handleChange,
        setArearPaidBillDocument,
        setArearPaidBillDocumentError,
        setArearPaidBillDocumentThumbnail,
        newFileName
      );
    }
  };

  const NewWiringTestReportDocument = (event) => {
    if (event.target.files) {
      const newFileName =
        "wiringTestReport." + event.target.files[0].name.split(".").pop();
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setNewWiringTestReportDocument(file.name);
        setNewWiringTestReportDocumentThumbnail(base64String);
        setNewWiringTestReportDocumentError("");
      };
      reader.readAsDataURL(file);
    }
  };

  const InstalledMeterImage = (event) => {
    if (event.target.files) {
      const newFileName =
        "installedMeterImage." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        scoPart2Formik.handleChange,
        setInstalledMeterImage,
        setInstalledMeterImageError,
        setInstalledMeterImageThumbnail,
        newFileName
      );
      setInstalledMeterImageError("");
    }
  };

  const handleInputChange = async (e, index) => {
    const { name, value } = e.target;

    const updatedDataArray = [...alreadyInstalledRefNos];

    let itemToUpdate = updatedDataArray[index];

    if (!itemToUpdate) {
      itemToUpdate = {
        refNo: "",
        actualFlag: null,
      };
    }

    if (value.length === 14) {
      let apiResponse = await dBillAPI(token, value);
      if (apiResponse.status) {
        itemToUpdate.actualFlag = true;
      } else {
        itemToUpdate.actualFlag = false;
      }
    }

    const updatedItem = {
      ...updatedDataArray[index],
      refNo: value,
      actualFlag: itemToUpdate.actualFlag,
    };
    updatedDataArray[index] = updatedItem;
    setAlreadyInstalledRefNos(updatedDataArray);
  };

  const parseRejectedDocuments = (remarks) => {
    // Parse "Documents objection in: Applicant CNIC Front, Applicant CNIC Back, Premises Document, "
    if (!remarks) return [];
    const match = remarks.match(/Documents objection in:\s*(.+)/i) || remarks.match(/Documents Reuploaded in:\s*(.+)/i);
    if (!match) return [];

    const docsList = match[1].split(',').map(doc => doc.trim()).filter(doc => doc.length > 0);

    // Combine CNIC Front and Back as single item
    const hasCNICFront = docsList.some(d => d.toLowerCase().includes('cnic front'));
    const hasCNICBack = docsList.some(d => d.toLowerCase().includes('cnic back'));

    let combinedList = docsList.filter(d =>
      !d.toLowerCase().includes('cnic front') && !d.toLowerCase().includes('cnic back')
    );

    if (hasCNICFront || hasCNICBack) {
      combinedList.unshift('Applicant CNIC');
    }

    return combinedList;
  };

  const openDetailsPopUp = async (stepName) => {
    let id = dialogRowData.applicationId;

    // Handle Documents Objection
    if (stepName === "Documents Objection") {
      const rowData = tableDataProcessingSummary.find(item => item.stepName === "Documents Objection");
      if (rowData && rowData.remarks) {
        const rejectedDocs = parseRejectedDocuments(rowData.remarks);
        setRejectedDocumentsList(rejectedDocs);
      }
      // Set activity info for footer
      if (rowData) {
        setActivityInfo({ processedBy: rowData.processedBy || '', date: rowData.date || '' });
      }
      // Show loader and fetch documents
      setViewBackdrop(true);
      await getDocumentApi(dialogRowData.applicationId);
      setViewBackdrop(false);
      setDocumentsObjectionPopUp(true);
      return;
    }

    // Handle Documents Reupload
    if (stepName === "Documents Reupload") {
      let rejectedDocs = [];
      const rowData = tableDataProcessingSummary.find(item => item.stepName === "Documents Reupload");
      if (rowData && rowData.remarks) {
        rejectedDocs = parseRejectedDocuments(rowData.remarks);
      }
      // If no documents found in reupload remarks, try to get from previous objection
      if (rejectedDocs.length === 0) {
        const objectionData = tableDataProcessingSummary.find(item => item.stepName === "Documents Objection");
        if (objectionData && objectionData.remarks) {
          rejectedDocs = parseRejectedDocuments(objectionData.remarks);
        }
      }
      setRejectedDocumentsList(rejectedDocs);
      // Set activity info for footer
      if (rowData) {
        setActivityInfo({ processedBy: rowData.processedBy || '', date: rowData.date || '' });
      }
      // Show loader and fetch documents
      setViewBackdrop(true);
      await getDocumentApi(dialogRowData.applicationId);
      setViewBackdrop(false);
      setDocumentsReuploadPopUp(true);
      return;
    }

    // Handle Arrear Objection
    if (stepName === "Arrear Objection") {
      const rowData = tableDataProcessingSummary.find(item => item.stepName === "Arrear Objection");
      if (rowData) {
        setActivityInfo({ processedBy: rowData.processedBy || '', date: rowData.date || '' });
      }
      setArrearObjectionPopUp(true);
      return;
    }

    if (
      stepName === "Application Submitted" ||
      stepName === "APPLICATION SUBMITTED"
    ) {
      setApplicationSubmittedPopUp(true);
    } else if (
      stepName === "Documents Verification" ||
      stepName === "DOCUMENT VERIFICATION"
    ) {
      setDocumentsVerifiedSubPopUp(true);
    } else if (
      stepName === "Arrear Verification" ||
      stepName === "ARREAR VERIFICATION"
    ) {
      setArrearVerifiedSubPopUp(true);
    } else if (stepName === "Field Survey" || stepName === "FIELD SURVEY") {
      await callAsyncFieldSurveyInformation(dialogRowData.applicationId);
      setFieldSurveyedSubPopUp(true);
    } else if (
      stepName === "Reference No. Allocated" ||
      stepName === "REF. NO ALLOCATION"
    ) {
      await callAsyncDnDetailsAPI(dialogRowData.applicationId);
      setReferenceNoAllocatedSubPopUp(true);
    } else if (
      stepName === "DN Payment Submission" ||
      stepName === "DN PAYMENT SUBMISSION"
    ) {
      await callAsyncGetPaidDnImageAPI(dialogRowData.applicationId);
      setDnPaymentSubmittedSubPopUp(true);
    } else if (
      stepName === "DN Payment Verification" ||
      stepName === "DN PAYMENT VERIFICATION"
    ) {
      await callAsyncGetPaidDnImageAPI(dialogRowData.applicationId);
      setDnPaymentVerifiedSubPopUp(true);
    } else if (
      stepName === "Service Connection Order" ||
      stepName === "SERVICE CONN. ORDER"
    ) {
      await callAsyncGetSCOAPI(dialogRowData.applicationId);
      setServiceConnectionOrderedSubPopUp(true);
    } else if (
      stepName === "Meter Installation" ||
      stepName === "METER INSTALLATION"
    ) {
      await callAsyncGetSCOAPI(dialogRowData.applicationId);
      setMeterInstalledSubPopUp(true);
    }
  };

  const FGovt = (event) => {
    if (refNoAllocationFormik.values.iv_fgovt) {
      refNoAllocationFormik.values.iv_fgovt = "";
      refNoAllocationFormik.handleChange(event);
    } else {
      refNoAllocationFormik.handleChange(event);
      refNoAllocationFormik.values.iv_fgovt = event.target.value;
    }
    refNoAllocationFormik.values.iv_govt_dept_code = "";
    setGovtDeptCode({ departmentCode: null, departmentName: "" });
  };

  const Contanment = (event) => {
    if (refNoAllocationFormik.values.iv_cantonment_board) {
      refNoAllocationFormik.values.iv_cantonment_board = "";
      refNoAllocationFormik.handleChange(event);
    } else {
      refNoAllocationFormik.handleChange(event);
      refNoAllocationFormik.values.iv_cantonment_board = event.target.value;
    }
  };

  const LocalBodies = (event) => {
    if (refNoAllocationFormik.values.iv_local_bodies) {
      refNoAllocationFormik.values.iv_local_bodies = "";
      refNoAllocationFormik.handleChange(event);
    } else {
      refNoAllocationFormik.handleChange(event);
      refNoAllocationFormik.values.iv_local_bodies = event.target.value;
    }
  };

  const PGovt = (event) => {
    if (refNoAllocationFormik.values.iv_pgovt) {
      refNoAllocationFormik.values.iv_pgovt = "";
      refNoAllocationFormik.handleChange(event);
    } else {
      refNoAllocationFormik.values.iv_pgovt = event.target.value;
      refNoAllocationFormik.handleChange(event);
    }
    refNoAllocationFormik.values.iv_govt_dept_code = "";
    setGovtDeptCode({ departmentCode: null, departmentName: "" });
  };

  const getTariffAndMeterType = async (
    appliedLoad,
    connectionType,
    seasonalNonSeasonal,
    tariffs,
    applicationProgressId
  ) => {
    let phase = "";
    if (connectionType === "Industrial") {
      if (seasonalNonSeasonal == 1) {
        const seasonalTariff = tariffs.find((item) => item.tariffCode === "F");
        // Check if seasonalTariff is found before setting the state
        if (seasonalTariff) {
          setTariff(seasonalTariff.tariffName || "");
          if (applicationProgressId === 4) {
            fieldFormik.values.iv_tariff_to_allot =
              seasonalTariff.tariffName || "";
          }
        } else {
          // Handle the case when the seasonal tariff is not found
          setTariff("");
          console.error("Seasonal tariff not found!");
        }
        if (appliedLoad <= 500) {
          setPhase("MDI (LT)(CT)");
          phase = "MDI (LT)(CT)";
        } else if (appliedLoad > 500) {
          setPhase("MDI (HT)(CT/PT)");
          phase = "MDI (HT)(CT/PT)";
        }
      } else if (seasonalNonSeasonal == 0 || !seasonalNonSeasonal) {
        let shortListedTariffsArray = tariffs.filter(
          (item) => item.consumerType === connectionType
        );
        shortListedTariffsArray = shortListedTariffsArray.filter(
          (item) =>
            parseInt(item.from) <= appliedLoad &&
            parseInt(item.to) > appliedLoad
        );
        let selectedTariff = shortListedTariffsArray[0];
        if (selectedTariff) {
          setTariff(selectedTariff.tariffName || "");
          if (applicationProgressId === 4) {
            fieldFormik.values.iv_tariff_to_allot =
              selectedTariff.tariffName || "";
          }
        } else {
          setTariff("");
        }
        if (appliedLoad <= 500) {
          setPhase("MDI (LT)(CT)");
          phase = "MDI (LT)(CT)";
        } else if (appliedLoad > 500) {
          setPhase("MDI (HT)(CT/PT)");
          phase = "MDI (HT)(CT/PT)";
        }
      }
    } else {
      if (appliedLoad && appliedLoad > 0 && tariffs) {
        let shortListedTariffsArray = tariffs.filter(
          (item) => item.consumerType === connectionType
        );
        shortListedTariffsArray = shortListedTariffsArray.filter(
          (item) =>
            parseInt(item.from) <= appliedLoad &&
            parseInt(item.to) > appliedLoad
        );
        setTariff(shortListedTariffsArray[0].tariffName);
        if (applicationProgressId === 4) {
          fieldFormik.values.iv_tariff_to_allot =
            shortListedTariffsArray[0].tariffName || "";
        }
        if (parseInt(appliedLoad) < 5) {
          setPhase("Single Phase");
          phase = "Single Phase";
        } else if (appliedLoad >= 5 && appliedLoad < 20) {
          setPhase("3 Phase");
          phase = "3 Phase";
        } else if (appliedLoad >= 20 && appliedLoad < 500) {
          setPhase("MDI (LT)(CT)");
          phase = "MDI (LT)(CT)";
        } else if (appliedLoad >= 500) {
          setPhase("MDI (HT)(CT/PT)");
          phase = "MDI (HT)(CT/PT)";
        }
      } else {
        setPhase("");
        phase = "";
        setTariff("");
      }
    }
    return phase;
  };

  const getTariff = (
    appliedLoad,
    connectionType,
    seasonalNonSeasonal,
    tariffs
  ) => {
    if (tariffs) {
      let tariff = "";
      if (connectionType === "Industrial") {
        if (seasonalNonSeasonal == 1) {
          const seasonalTariff = tariffs.find(
            (item) => item.tariffCode === "F"
          );
          if (seasonalTariff) {
            tariff = seasonalTariff.tariffName;
          } else {
            tariff = "";
          }
        } else if (seasonalNonSeasonal == 0 || !seasonalNonSeasonal) {
          let shortListedTariffsArray = tariffs.filter(
            (item) => item.consumerType === connectionType
          );
          shortListedTariffsArray = shortListedTariffsArray.filter(
            (item) =>
              parseInt(item.from) <= appliedLoad &&
              parseInt(item.to) > appliedLoad
          );
          let selectedTariff = shortListedTariffsArray[0];
          if (selectedTariff) {
            tariff = selectedTariff.tariffName;
          } else {
            tariff = "";
          }
        }
      } else {
        if (appliedLoad && appliedLoad > 0 && tariffs) {
          let shortListedTariffsArray = tariffs.filter(
            (item) => item.consumerType === connectionType
          );
          shortListedTariffsArray = shortListedTariffsArray.filter(
            (item) =>
              parseInt(item.from) <= appliedLoad &&
              parseInt(item.to) > appliedLoad
          );
          tariff = shortListedTariffsArray[0]
            ? shortListedTariffsArray[0].tariffName
            : "-";
        } else {
          tariff = "";
        }
      }
      return tariff;
    }
  };

  const getMeterPhase = (appliedLoad, connectionType) => {
    let phase = "";
    if (connectionType === "Industrial") {
      if (appliedLoad <= 500) {
        phase = "MDI (LT)(CT)";
      } else if (appliedLoad > 500) {
        phase = "MDI (HT)(CT/PT)";
      }
    } else {
      if (appliedLoad && appliedLoad > 0) {
        if (parseInt(appliedLoad) < 5) {
          phase = "Single Phase";
        } else if (appliedLoad >= 5 && appliedLoad < 20) {
          phase = "3 Phase";
        } else if (appliedLoad >= 20 && appliedLoad < 500) {
          phase = "MDI (LT)(CT)";
        } else if (appliedLoad >= 500) {
          phase = "MDI (HT)(CT/PT)";
        }
      } else {
        phase = "";
      }
    }
    return phase;
  };

  const handleCloses = () => {
    setNewConnectionPopup(false);
  };

  const scoHandleClose = () => {
    setScoPopUp(false);
  };

  const srnHandleClose = () => {
    setSrnPopUp(false);
  };
  const cpHandleClose = () => {
    setCpPopUp(false);
  };

  const refNoUpdatePopupClose = () => {
    setRefNoUpdatePopup(false);
    setNewConnectionAccountNo("");
    setNewSubBatch("");
    setSubmitCP136Error("");
  };

  const handleUpdateRefNoForBilling = async () => {
    if (newConnectionAccountNo.length !== 7) {
      alert("Reference No must be 7 digits.");
      return;
    }
    if (!newSubBatch) {
      alert("Please select a Batch.");
      return;
    }

    setRefNoUpdateLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    try {
      // Concatenate: batch + subdivision + reference (7 digits)
      const concatenatedAccountNo = newSubBatch.concat(dialogRowData.subDivisionCode).concat(newConnectionAccountNo);

      const submitRaw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: masterDataFormDetails.filledByFlag === 1 ? 10 : 9,
        remarks: "CP-136 Approved.",
        objectionStatus: 0,
        cp136Type: 1,
        electricityDuty: masterDataFormik.values.iv_ed_code,
        governmentDepartment: masterDataFormik.values.iv_govt_dept,
        standardClassificationCode: masterDataFormik.values.iv_standard_classification_code,
        incomeTax: masterDataFormik.values.iv_income_tax,
        reason: "Reference Number Updated",
        authority: parseInt(dialogRowData.appliedLoad) < 15 ? "SDO" : "XEN",
        filledByFlag: 1,
        approvedByDesignation: roleName,
        approvalFlag: masterDataFormDetails.filledByFlag === 1 ? 1 : null,
        connectionAccountNo: concatenatedAccountNo,
      });

      const submitRequestOptions = {
        method: "POST",
        headers: myHeaders,
        body: submitRaw,
        redirect: "follow",
      };

      const submitResponse = await fetch(cfpBaseUrl + "enc/submitCP136", submitRequestOptions);
      const submitResult = await submitResponse.json();

      if (submitResult.status === "200") {
        setSubmitCP136Error("");
        refNoUpdatePopupClose();
        handleClose();
        setCpPopUp(true);
      } else {
        alert(submitResult.message || "Failed to submit CP136.");
      }
    } catch (error) {
      console.error(error);
      alert("Error submitting CP136.");
    } finally {
      setRefNoUpdateLoading(false);
    }
  };

  const errorCloses = () => {
    setError("");
    setFieldSurveyError("");
  };

  const filterOptions = (options, { inputValue }, fields = []) => {
    const trimmedInputValue = inputValue.trim().toLowerCase();
    const inputLength = trimmedInputValue.length;
    let count = 0;

    return inputLength === 0
      ? options
      : options.filter((option) => {
        const optionLabel = fields
          .map((field) => option[field])
          .join("")
          .toLowerCase();

        const containsInput = optionLabel.includes(trimmedInputValue);
        const match = containsInput && count < 5;
        if (match) {
          count += 1;
        }
        return match;
      });
  };

  const calculateTotalAmountOfItems = (arrayOfItems) => {
    return arrayOfItems.reduce(
      (total, item) => total + (Number(item.amount) || 0),
      0
    );
  };

  const calculateCharges = (arrayOfItems) => {
    const totalAmountofItems = calculateTotalAmountOfItems(arrayOfItems);
    const roundedTotalAmountofItems = Math.round(Number(totalAmountofItems) || 0);
    const isCase13 = String(dialogRowData?.applicationId || "")
      .toUpperCase()
      .startsWith("NC-13");
    const store_charges = isCase13
      ? 0
      : Math.floor((roundedTotalAmountofItems * 12 + 50) / 100);
    const installationBase = roundedTotalAmountofItems + store_charges;
    const installation_charges = Math.floor((installationBase * 8 + 50) / 100);

    return {
      totalAmountofItems: roundedTotalAmountofItems,
      store_charges,
      installation_charges,
    };
  };

  const handleBatchEditClick = () => {
    setShowUpdateBatchPopup(true);
  };

  // const downloadDNPDF = async (application, openInNewTab = false) => {
  //   setViewBackdrop(true);
  //   const applicationId = application.applicationId;
  //   let DiscoCode = application.companyCode.toString();
  //   if (!application.subDivisionCode) {
  //     try {
  //       application = await SearchIndividualApplication(token, application.applicationId, '1');
  //     } catch (e) {
  //       console.log(e, 'error getting Application details');
  //     }
  //   }
  //   try {
  //     let dnDets;
  //     let boqItems;
  //     let dnExpiryFlag;
  //     await callAsyncDnDetailsAPI(applicationId)
  //       .then(response => {
  //         console.log(response, 'response from dn details api');
  //         dnDets = response.dnDets;
  //         console.log(dnDets, 'dnDets');
  //         boqItems = response.boqItems;
  //         dnExpiryFlag = response.dnExpiryFlag;
  //       });

  //     if (dnExpiryFlag === '1') {
  //       setShowDnExpiryPopup(true);
  //     } else {
  //       let officeCode = application.subDivisionCode.toString();
  //       let officeName = subdivisionName(parseInt(officeCode), subDivisions);
  //       let authorizedByName = dnDets.approvedBy ? dnDets.approvedBy : '---';
  //       let authorizedByDesignation = dnDets.approvedByDesignation ? dnDets.approvedByDesignation : 'Role';
  //       console.log(dnDets.approvedDate, 'dnDets.approvedDate');
  //       let dateToPrint = dnDets.approvedDate ? dnDets.approvedDate : '---';
  //       console.log(officeCode, officeName, authorizedByName, authorizedByDesignation, dateToPrint, 'stamp details');
  //       let stampData = printStamp(officeCode, officeName, authorizedByName, authorizedByDesignation, dateToPrint);

  //       const fontSize = 8;
  //       const doc = new jsPDF({ compressPdf: true });

  //       // Function to generate page content
  //       const generatePageContent = (pageNumber) => {
  //         let padding = 10;
  //         let line2Height = 10;
  //         let lineHeightIncreament = 5;

  //         if (dnDets.approvedBy) {
  //           if (pageNumber === 2) {
  //             doc.addImage(stampData, 'PNG', 20, 180, 55, 40);
  //             doc.addImage(stampData, 'PNG', 140, 240, 55, 40);
  //           } else {
  //             doc.addImage(stampData, 'PNG', 20, 200, 55, 40);
  //             doc.addImage(stampData, 'PNG', 140, 265, 55, 40);
  //           }
  //         }

  //         doc.setFontSize(fontSize);
  //         doc.setFont('helvetica', 'bold');
  //         doc.text((!dnDets.demandNoteExpiryCount ? 'Due Date: ' : 'Extended Due Date: ') + convertDate(dnDets.dueDate), padding, line2Height, {});

  //         doc.setFont('helvetica', 'normal');
  //         doc.text(companyName(dnDets.connectionAccountNo.slice(2, 4)).concat(application.appliedLoad < 15 ? '(' + dnDets.connectionAccountNo.slice(2, 7) + "-" + subdivisionName(parseInt(application.subDivisionCode), subDivisions) + ')' : '(' + dnDets.connectionAccountNo.slice(2, 6) + '-' + divisionName(parseInt(application.divisionCode), subDivisions) + ')'), doc.internal.pageSize.getWidth() / 2, line2Height, {
  //           align: 'center',
  //         });

  //         line2Height = line2Height + lineHeightIncreament;
  //         doc.text('(Department of Electricity)', doc.internal.pageSize.getWidth() / 2, line2Height, {
  //           align: 'center',
  //         });

  //         line2Height = line2Height + lineHeightIncreament;
  //         let lineSpace = 12;
  //         let text1 = 'Demand Notice Serial No.: ';
  //         let text2 = dnDets.demandNoticeNo;
  //         let text3 = 'Application Id: ';
  //         let text4 = applicationId;
  //         let text5 = 'Apply Date: ';
  //         let text6 = convertDate(application.creationDate);

  //         doc.text(text1, padding, line2Height);
  //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
  //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

  //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
  //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
  //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

  //         doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
  //         doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
  //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);

  //         line2Height = line2Height + lineHeightIncreament;
  //         lineSpace = 3.35;
  //         text1 = 'Demand Notice Issuance Date: ';
  //         text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-';
  //         text3 = 'Application Type: ';
  //         text4 = application.applicationType ? applicationName(application.applicationType) : '-';
  //         text5 = '(New Connection, Reconnection etc.): ';
  //         text6 = application.applicationType ? applicationName(application.applicationType) : '-';

  //         doc.text(text1, padding, line2Height);
  //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
  //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

  //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
  //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
  //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

  //         doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
  //         doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
  //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);

  //         line2Height = line2Height + lineHeightIncreament;
  //         lineSpace = 6.6;
  //         text1 = 'New Alloated Reference No.: ';
  //         text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : '-';
  //         text3 = 'Consumer Mobile No.: ';
  //         text4 = dnDets.applicantMobile ? dnDets.applicantMobile : '-';
  //         text5 = 'Connection type: ';
  //         text6 = dnDets.connectionType ? dnDets.connectionType : '-';

  //         doc.text(text1, padding, line2Height);
  //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
  //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

  //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
  //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
  //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

  //         doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
  //         doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
  //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);

  //         line2Height = line2Height + lineHeightIncreament;
  //         lineSpace = 7;
  //         text1 = '(under which the funds are to be deposited in the bank with the concerned officer of the department)';
  //         text2 = 'Type of Industry / Factory:';
  //         text3 = dnDets.industryFactoryType ? dnDets.industryFactoryType : '-';

  //         doc.setFontSize(6);
  //         doc.text(text1, padding, line2Height);
  //         doc.setFontSize(fontSize);
  //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
  //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
  //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + padding + (lineSpace), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + padding + (lineSpace * 2)) + (doc.getTextWidth(text3) + (lineSpace * 2)), line2Height + 1);

  //         line2Height = line2Height + lineHeightIncreament;
  //         lineSpace = 22.25;
  //         text1 = `Department's approved Bank name: `;
  //         text2 = dnDets.bankName ? dnDets.bankName : '-';
  //         text3 = 'Required Load (kW): ';
  //         text4 = application.appliedLoad ? application.appliedLoad.toString() : '|';

  //         doc.text(text1, padding, line2Height);
  //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
  //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

  //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
  //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
  //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

  //         line2Height = line2Height + lineHeightIncreament;
  //         lineSpace = 22;
  //         text1 = `Department's Revenue Officer: `;
  //         text2 = divisionName(parseInt(application.divisionCode), subDivisions);
  //         text3 = 'Required Voltage: ';
  //         text4 = dnDets.voltage ? dnDets.voltage.toString() : '-';

  //         doc.text(text1, padding, line2Height);
  //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
  //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

  //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
  //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
  //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

  //         line2Height = line2Height + lineHeightIncreament;
  //         lineSpace = 16;
  //         text1 = `Coverage Area: `;
  //         text2 = dnDets.areaMarla ? dnDets.areaMarla : '|';
  //         text3 = 'Required Tariff : ';
  //         text4 = dnDets.tariff ? dnDets.tariff : '-';

  //         doc.text(text1, padding, line2Height);
  //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
  //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

  //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
  //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
  //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

  //         line2Height = line2Height + lineHeightIncreament;
  //         doc.text(`DEMAND NOTICE${pageNumber > 1 ? ' (Page ' + pageNumber + ')' : ''}`, doc.internal.pageSize.getWidth() / 2, line2Height, {
  //           align: 'center',
  //         });

  //         line2Height = line2Height + lineHeightIncreament;
  //         doc.text('(Notification of Approval Application and Demand Under Guarantee)', doc.internal.pageSize.getWidth() / 2, line2Height, {
  //           align: 'center',
  //         });

  //         line2Height = line2Height + lineHeightIncreament;
  //         doc.text(`Applicant's part`, doc.internal.pageSize.getWidth() / 2, line2Height, {
  //           align: 'center',
  //         });

  //         line2Height = line2Height + lineHeightIncreament;
  //         lineSpace = 16;
  //         text1 = `Mr. / Mrs.`;
  //         text2 = application.applicantName ? application.applicantName.concat(' | ').concat(application.premisesAddress) : '|';
  //         text3 = ``;

  //         doc.text(text1, padding, line2Height);
  //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
  //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

  //         doc.setFontSize(6);
  //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);

  //         lineHeightIncreament = 4;
  //         line2Height = line2Height + lineHeightIncreament;
  //         doc.setFontSize(fontSize);
  //         let maxWidth = doc.internal.pageSize.getWidth() - (padding * 2);
  //         text1 = `You are hereby informed by demand notice that your application for obtaining electricity connection whose particulars are mentioned above has been approved by the authorized officer on the following conditions apart from the prevailing general conditions of electricity of the department.`;
  //         let lines = doc.splitTextToSize(text1, maxWidth);
  //         for (var i = 0; i < lines.length; i++) {
  //           doc.text(lines[i], padding, line2Height);
  //           line2Height = line2Height + lineHeightIncreament;
  //         }

  //         doc.setFontSize(fontSize);
  //         maxWidth = doc.internal.pageSize.getWidth() - (padding * 2);
  //         let noOfDays = '30';
  //         text1 = `1. You should deposit the following amounts in the approved bank of the department or with the concerned officer of the department itself within [word1] days from the date of issue of this notice and inform my office with the receipt number and date of your payment.`;
  //         lines = doc.splitTextToSize(text1, maxWidth);
  //         for (var i = 0; i < lines.length; i++) {
  //           let lineText = lines[i].replace("[word1]", noOfDays);
  //           doc.text(lineText, padding, line2Height);
  //           line2Height = line2Height + lineHeightIncreament;
  //         }

  //         doc.setFontSize(fontSize);
  //         maxWidth = doc.internal.pageSize.getWidth() - (padding * 2);
  //         noOfDays = '30';
  //         text1 = pageNumber === 2
  //           ? `A. Expenditure service connection as per approved Security _______________ PKR. (this amount is to be deposited with the concerned officer of the department). If the charges are found to be more than the service approved estimate prior to connection, a deposit equal to the difference in the amount collected will be issued for which additional demand notice will be issued.`
  //           : `A. Expenditure service connection as per approved estimate ______________ PKR. (this amount is to be deposited with the concerned officer of the department). If the charges are found to be more than the service approved estimate prior to connection, a deposit equal to the difference in the amount collected will be issued for which additional demand notice will be issued.`;
  //         text2 = dnDets.capitalCostAmount ? numberFormatting(dnDets.capitalCostAmount) : '';
  //         text3 = dnDets.securityDepositeAmount ? numberFormatting(dnDets.securityDepositeAmount) : '';
  //         lines = doc.splitTextToSize(text1, maxWidth);
  //         doc.setFont('helvetica', 'bold');
  //         // doc.text(text2, 90, line2Height);
  //         // doc.text(text3, 130, line2Height);
  //         if (pageNumber === 1) {
  //           doc.text(text2, 90, line2Height);
  //         } else {
  //           doc.text(text3, 90, line2Height);
  //         }
  //         doc.setFont('helvetica', 'normal');
  //         for (var i = 0; i < lines.length; i++) {
  //           let lineText = lines[i];

  //           // ✅ Page 1 → show capital cost only
  //           if (pageNumber === 1) {
  //             lineText = lineText.replace(
  //               "[capitalCost]",
  //               dnDets.capitalCostAmount ? numberFormatting(dnDets.capitalCostAmount) : ''
  //             );
  //             lineText = lineText.replace("[securityCost]", "");
  //           }

  //           // ✅ Page 2 → show security cost only
  //           if (pageNumber === 2) {
  //             lineText = lineText.replace("[securityCost]", dnDets.securityDepositeAmount ? numberFormatting(dnDets.securityDepositeAmount) : '');
  //             lineText = lineText.replace("[capitalCost]", "");
  //           }

  //           doc.text(lineText, padding, line2Height);
  //           line2Height += lineHeightIncreament;
  //         }

  //         doc.setFontSize(fontSize);
  //         maxWidth = doc.internal.pageSize.getWidth() - (padding * 2);
  //         noOfDays = '30';
  //         text1 = `B. Arrears due to non-payment of previous electricity bills etc. _____ PKR. (this amount is to be deposited in the bank after receiving the final bill from the revenue officer).`;

  //         lines = pageNumber === 1 ? doc.splitTextToSize(text1, maxWidth) : "";
  //         for (var i = 0; i < lines.length; i++) {
  //           doc.text(lines[i], padding, line2Height);
  //           line2Height = line2Height + lineHeightIncreament;
  //         }

  //         doc.setFontSize(fontSize);
  //         maxWidth = doc.internal.pageSize.getWidth() - (padding * 2);
  //         noOfDays = '30';
  //         text1 = `NOTE: If you are an applicant or consumer of domestic, commercial, industrial wholesale supply, you should fill the demand notice in this regard on the sub-layer (reserved for your business) and affix your signature and date on it and send back to my office.`;
  //         lines = doc.splitTextToSize(text1, maxWidth);
  //         for (var i = 0; i < lines.length; i++) {
  //           doc.text(lines[i], padding, line2Height);
  //           line2Height = line2Height + lineHeightIncreament;
  //         }

  //         doc.setFontSize(fontSize);
  //         maxWidth = doc.internal.pageSize.getWidth() - (padding * 2);
  //         noOfDays = '30';
  //         text1 = `2. You shall, within [noOfDays] days from the date of issue of this notice, obtain a test report from a Government approved wiring contractor in proof of the soundness and quality of the internal wiring of your building and the completion of the installation of your electrical appliances and send to my office for further departmental inspection and testing and get receipt (Blank Test Report is on Form CP-7).`;
  //         lines = doc.splitTextToSize(text1, maxWidth);
  //         for (var i = 0; i < lines.length; i++) {
  //           let lineText = lines[i].replace("[noOfDays]", noOfDays);
  //           doc.text(lineText, padding, line2Height);
  //           line2Height = line2Height + lineHeightIncreament;
  //         }

  //         doc.setFontSize(fontSize);
  //         maxWidth = doc.internal.pageSize.getWidth() - (padding * 2);
  //         let amount = '_____';

  //         text1 = `3. Since you have not provided your purchased meter to the department for measuring the supply of electricity, you will be charged a monthly meter rental fee of [amount] PKR.`;
  //         // lines = doc.splitTextToSize(text1, maxWidth);
  //         lines = pageNumber === 1 ? doc.splitTextToSize(text1, maxWidth) : "";
  //         for (var i = 0; i < lines.length; i++) {
  //           let lineText = lines[i].replace("[amount]", amount);
  //           doc.text(lineText, padding, line2Height);
  //           line2Height = line2Height + lineHeightIncreament;
  //         }

  //         doc.setFontSize(fontSize);
  //         maxWidth = doc.internal.pageSize.getWidth() - (padding * 2);
  //         amount = '_____';
  //         text1 = `4. Demand notices for release of security deposit sent separately Process of connection will start after deposit of both demand notice amounts separate.`;
  //         // lines = doc.splitTextToSize(text1, maxWidth);
  //         lines = pageNumber === 1 ? doc.splitTextToSize(text1, maxWidth) : "";

  //         for (var i = 0; i < lines.length; i++) {
  //           let lineText = lines[i].replace("[amount]", amount);
  //           doc.text(lineText, padding, line2Height);
  //           line2Height = line2Height + lineHeightIncreament;
  //         }

  //         doc.text(`(Irrelevant should be cut down)`, doc.internal.pageSize.getWidth() / 2, line2Height, {
  //           align: 'center',
  //         });

  //         line2Height = line2Height + lineHeightIncreament;
  //         maxWidth = doc.internal.pageSize.getWidth() - (padding * 2);
  //         let noOfMonth = '1';
  //         text1 = `If you do not comply with the above conditions in response to the demand notice within the prescribed period, your application form for obtaining electricity will not be considered with the serial number allotted. Demand notices thereof ( [noOfMonth] month after the date of issue) shall automatically be deemed ineffective.`;
  //         lines = doc.splitTextToSize(text1, maxWidth);
  //         for (var i = 0; i < lines.length; i++) {
  //           let lineText = lines[i].replace("[noOfMonth]", noOfMonth);
  //           doc.text(lineText, padding, line2Height);
  //           line2Height = line2Height + lineHeightIncreament;
  //         }

  //         doc.setFontSize(fontSize);
  //         text1 = `Regards`;
  //         let spaceLeft = 100;
  //         doc.text(text1, padding + spaceLeft, line2Height);

  //         line2Height = line2Height + lineHeightIncreament;
  //         text1 = application.appliedLoad < 15 ? "Sub-Division Office " + applicationId.slice(3, 8) + '-' + subdivisionName(parseInt(application.subDivisionCode), subDivisions) + ' SDO ' + companyShortName(DiscoCode) : "Division Office " + applicationId.slice(3, 7) + ' - ' + divisionName(parseInt(application.divisionCode), subDivisions) + ' XEN ' + companyShortName(DiscoCode);
  //         doc.text(text1, padding + spaceLeft, line2Height);

  //         line2Height = line2Height + lineHeightIncreament;
  //         text1 = 'Signature Bank Officer: ';
  //         // text2 = application.appliedLoad < 15 ? 'Line Superintendent Office' + '(' + applicationId.slice(3, 8) + ' - ' + subdivisionName(parseInt(application.subDivisionCode), subDivisions) + ') SDO ' + companyShortName(DiscoCode) : 'Line Superintendent Office' + '(' + applicationId.slice(3, 7) + ' - ' + divisionName(parseInt(application.divisionCode), subDivisions) + ') XEN ' + companyShortName(DiscoCode);
  //         doc.text(text1, padding, line2Height);
  //         // doc.text(text2, padding + spaceLeft, line2Height);

  //         line2Height = line2Height + lineHeightIncreament;
  //         spaceLeft = 10;
  //         text1 = '--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------';
  //         doc.text(text1, padding + spaceLeft, line2Height);

  //         lineHeightIncreament = 5;
  //         line2Height = line2Height + lineHeightIncreament;
  //         doc.text((!dnDets.demandNoteExpiryCount ? 'Due Date: ' : 'Extended Due Date: ') + convertDate(dnDets.dueDate), padding, line2Height, {});
  //         doc.text('For Bank Use Only', doc.internal.pageSize.getWidth() / 2, line2Height, {
  //           align: 'center',
  //         });

  //         line2Height = line2Height + lineHeightIncreament;
  //         doc.text('(The concerned bank will separate this layer from the demand notice and send it to the revenue officer along with its bank scroll)', doc.internal.pageSize.getWidth() / 2, line2Height, {
  //           align: 'center',
  //         });

  //         line2Height = line2Height + lineHeightIncreament;
  //         lineSpace = 16;
  //         text1 = `1. Applicant's Name and Complete address `;
  //         text2 = application.applicantName ? application.applicantName.concat(' | ').concat(application.premisesAddress) : '|';
  //         text3 = ``;

  //         doc.text(text1, padding, line2Height);
  //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
  //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

  //         doc.setFontSize(6);
  //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);

  //         doc.setFontSize(fontSize);
  //         line2Height = line2Height + lineHeightIncreament;
  //         lineSpace = 6.6;
  //         text1 = '2. Application Id: ';
  //         text2 = application.applicationId ? application.applicationId : '-';
  //         text3 = 'Date: ';
  //         text4 = application.creationDate ? convertDate(application.creationDate) : '-';
  //         text5 = '1. Service Connection:';
  //         text6 = dnDets.capitalCostAmount ? numberFormatting(dnDets.capitalCostAmount) : '-';
  //         spaceLeft = 40;

  //         doc.text(text1, padding, line2Height);
  //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
  //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

  //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
  //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
  //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

  //         if (pageNumber === 1) {
  //           doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + spaceLeft + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
  //           doc.setFont('helvetica', 'bold');
  //           doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + spaceLeft, line2Height);
  //           doc.setFont('helvetica', 'normal');
  //           doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + spaceLeft, line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2) + spaceLeft, line2Height + 1);
  //         }

  //         doc.setFontSize(fontSize);
  //         line2Height = line2Height + lineHeightIncreament;
  //         lineSpace = 6.6;
  //         text1 = '3. Demand Notice Serial No.: ';
  //         text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-';
  //         text3 = 'Date: ';
  //         text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-';
  //         text5 = '1. Security: ';
  //         text6 = dnDets.securityDepositeAmount ? numberFormatting(dnDets.securityDepositeAmount) : '-';
  //         spaceLeft = 35;

  //         doc.text(text1, padding, line2Height);
  //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
  //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

  //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
  //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
  //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);
  //         if (pageNumber === 1) {
  //           // doc.text(text2, 90, line2Height);
  //         } else {
  //           doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + spaceLeft + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
  //           doc.setFont('helvetica', 'bold');
  //           doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + spaceLeft, line2Height);
  //           doc.setFont('helvetica', 'normal');
  //           doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + spaceLeft, line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2) + spaceLeft, line2Height + 1);
  //         }

  //         doc.setFontSize(fontSize);
  //         line2Height = line2Height + lineHeightIncreament;
  //         lineSpace = 6.6;
  //         text1 = '4. Account No. for acquisition connection: ';
  //         text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : '-';
  //         text3 = ' ';
  //         text4 = ' ';
  //         text5 = '2. Grid Share / Feeder Rehab. Charges:';

  //         text6 = dnDets.amountOfGridSharing ? numberFormatting(dnDets.amountOfGridSharing).concat(' / ').concat(dnDets.amountOfFeederRehab ? numberFormatting(dnDets.amountOfFeederRehab) : "-") : '-'.concat(' / ').concat(dnDets.amountOfFeederRehab ? numberFormatting(dnDets.amountOfFeederRehab) : "-");
  //         spaceLeft = 10;

  //         doc.text(text1, padding, line2Height);
  //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
  //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

  //         if (pageNumber === 1) {
  //           doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + spaceLeft + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
  //           doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + spaceLeft, line2Height);
  //           doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + spaceLeft, line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2) + spaceLeft, line2Height + 1);
  //         }
  //         doc.setFontSize(fontSize);
  //         line2Height = line2Height + lineHeightIncreament;
  //         lineSpace = 6.6;
  //         text1 = '5. Approved bank name and address:';
  //         text2 = dnDets.bankName ? dnDets.bankName : '-';

  //         doc.text(text1, padding, line2Height);
  //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
  //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

  //         doc.setFontSize(fontSize);
  //         line2Height = line2Height + lineHeightIncreament + lineHeightIncreament;
  //         lineSpace = 6.6;
  //         text1 = application.appliedLoad < 15 ? '                                                                                 ' : '                                                                                  ';
  //         text2 = ' ';
  //         text3 = ' ';
  //         text4 = ' ';
  //         text5 = ' ';
  //         text6 = 'Signature Bank Officer ';
  //         spaceLeft = 20;
  //         doc.text(text1, padding, line2Height);
  //         doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + spaceLeft, line2Height);

  //         doc.setFontSize(fontSize);
  //         line2Height = line2Height + lineHeightIncreament;
  //         lineSpace = 6.6;
  //         text1 = ' ';
  //         text2 = ' ';
  //         text3 = ' ';
  //         text4 = ' ';
  //         text5 = ' ';
  //         text6 = ' ';
  //         spaceLeft = 10;
  //         doc.setFontSize(6);
  //         doc.text(text1, padding, line2Height);

  //         doc.setFontSize(fontSize);
  //         line2Height = line2Height + lineHeightIncreament;
  //         spaceLeft = 10;
  //         text1 = '--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------';
  //         doc.text(text1, padding + spaceLeft, line2Height);

  //         lineHeightIncreament = 4;
  //         line2Height = line2Height + lineHeightIncreament;
  //         doc.text((!dnDets.demandNoteExpiryCount ? 'Due Date: ' : 'Extended Due Date: ') + convertDate(dnDets.dueDate), padding, line2Height, {});
  //         doc.text(`Applicant's Response`, doc.internal.pageSize.getWidth() / 2, line2Height, {
  //           align: 'center',
  //         });

  //         lineHeightIncreament = 4;
  //         line2Height = line2Height + lineHeightIncreament;
  //         doc.setFontSize(fontSize);
  //         maxWidth = doc.internal.pageSize.getWidth() - (padding * 2);
  //         text1 = pageNumber === 2
  //           ? `1. I/We have submitted the security amount of [securityCost] only in the department's approved bank [bankName] by receipt no. _______________________________________ on date _______________________________.`
  //           : `1. I/We have submitted the service connection of [capitalCost] only in the department's approved bank [bankName] by receipt no. _______________________________________ on date _______________________________.`;
  //         lines = doc.splitTextToSize(text1, maxWidth);
  //         for (var i = 0; i < lines.length; i++) {
  //           let lineText = lines[i].replace("[capitalCost]", numberFormatting(dnDets.capitalCostAmount) || '-');
  //           lineText = lineText.replace("[securityCost]", numberFormatting(dnDets.securityDepositeAmount) || '-');
  //           lineText = lineText.replace("[bankName]", dnDets.bankName ? dnDets.bankName : '-');
  //           doc.text(lineText, padding, line2Height);
  //           line2Height = line2Height + lineHeightIncreament;
  //         }

  //         doc.setFontSize(fontSize);
  //         maxWidth = doc.internal.pageSize.getWidth() - (padding * 2);
  //         noOfDays = '30';
  //         text1 = `2. Since I/We did not provide funds to buy meter to the department, I am/We are responsible to pay monthly rent of ______ PKR as meter rent.`;
  //         lines = pageNumber === 1 && doc.splitTextToSize(text1, maxWidth);
  //         for (var i = 0; i < lines.length; i++) {
  //           doc.text(lines[i], padding, line2Height);
  //           line2Height = line2Height + lineHeightIncreament;
  //         }

  //         doc.setFontSize(fontSize);
  //         maxWidth = doc.internal.pageSize.getWidth() - (padding * 2);
  //         noOfDays = '30';
  //         text1 = `3. I am/We are sending herewith demand notice, a certified list report from a government approved wiring contractor to prove that the internal wiring of my/our building is sound and of standard and that the installation of my/our utility equipment has been completed. I will send within the specified period.`;
  //         text2 = `2. I am/We are sending herewith demand notice, a certified list report from a government approved wiring contractor to prove that the internal wiring of my/our building is sound and of standard and that the installation of my/our utility equipment has been completed. I will send within the specified period.`;

  //         lines = pageNumber === 1 ? doc.splitTextToSize(text1, maxWidth) : doc.splitTextToSize(text2, maxWidth)
  //         for (var i = 0; i < lines.length; i++) {
  //           doc.text(lines[i], padding, line2Height);
  //           line2Height = line2Height + lineHeightIncreament;
  //         }

  //         doc.setFontSize(fontSize);
  //         line2Height = line2Height + lineHeightIncreament;
  //         doc.text(`For Computer Center Use`, doc.internal.pageSize.getWidth() / 2, line2Height, {
  //           align: 'center',
  //         });

  //         line2Height = line2Height + lineHeightIncreament;
  //         doc.text(`(Demand Notice Data)`, doc.internal.pageSize.getWidth() / 2, line2Height, {
  //           align: 'center',
  //         });

  //         line2Height = line2Height + lineHeightIncreament;
  //         lineHeightIncreament = 5;
  //         padding = 10;
  //         lineSpace = 7.5;
  //         text1 = 'Demand Notice Serial No.: ';
  //         text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-';
  //         text3 = 'Application Id: ';
  //         text4 = applicationId ? applicationId : '-';
  //         text5 = 'Application Form No.: ';
  //         text6 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-';

  //         doc.text(text1, padding, line2Height);
  //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
  //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

  //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
  //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
  //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

  //         doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
  //         doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
  //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);

  //         line2Height = line2Height + lineHeightIncreament;
  //         lineHeightIncreament = 5;
  //         padding = 10;
  //         lineSpace = 7.5;
  //         text1 = 'Demand Notice Issuance Date: ';
  //         text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-';
  //         // text3 = 'Amount to be paid: ';
  //         // text4 = (dnDets.capitalCostAmount || dnDets.securityDepositeAmount) ? numberFormatting(parseInt(dnDets.capitalCostAmount) + parseInt(dnDets.securityDepositeAmount) + (!isNaN(parseInt(dnDets.amountOfGridSharing)) ? parseInt(dnDets.amountOfGridSharing) : 0) + (!isNaN(parseInt(dnDets.amountOfFeederRehab)) ? parseInt(dnDets.amountOfFeederRehab) : 0)) : '-';
  //         text3 = 'Amount to be paid: ';

  //         // ✅ Page-based total calculation
  //         if (pageNumber === 1) {
  //           text4 = dnDets.capitalCostAmount
  //             ? numberFormatting(
  //               parseInt(dnDets.capitalCostAmount) +
  //               (!isNaN(parseInt(dnDets.amountOfGridSharing))
  //                 ? parseInt(dnDets.amountOfGridSharing)
  //                 : 0) +
  //               (!isNaN(parseInt(dnDets.amountOfFeederRehab))
  //                 ? parseInt(dnDets.amountOfFeederRehab)
  //                 : 0)
  //             )
  //             : '-';
  //         } else if (pageNumber === 2) {
  //           text4 = dnDets.securityDepositeAmount
  //             ? numberFormatting(
  //               parseInt(dnDets.securityDepositeAmount)
  //             )
  //             : '-';
  //         }

  //         // draw to PDF
  //         // doc.setFont('helvetica', 'bold');
  //         // doc.text(text3, padding, line2Height + 20);
  //         // doc.setFont('helvetica', 'normal');
  //         // doc.text(text4, 90, line2Height + 20);

  //         text5 = ' ';
  //         text6 = ' ';

  //         doc.text(text1, padding, line2Height);
  //         doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
  //         doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

  //         doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
  //         doc.setFont('helvetica', 'bold');
  //         doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
  //         doc.setFont('helvetica', 'normal');
  //         doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

  //         doc.setFontSize(fontSize);
  //         line2Height = line2Height + lineHeightIncreament + lineHeightIncreament / 2;
  //         lineSpace = 6.6;
  //         text1 = ' ';
  //         text2 = ' ';
  //         text3 = ' ';
  //         text4 = ' ';
  //         text5 = ' ';
  //         text6 = application.appliedLoad < 15 ? ' ' : ' ';
  //         spaceLeft = 110;
  //         doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + spaceLeft, line2Height);

  //         doc.setFontSize(6);
  //         lineHeightIncreament = 2;
  //         maxWidth = doc.internal.pageSize.getWidth() - (padding * 8);
  //         text1 = 'NOTE - Computer generated demand notice, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/applicant. In case any document is found false at later stages, the said connection is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and company reserved its rights to take legal action against owner/applicant. ';
  //         lineSpace = 6.6;
  //         lines = doc.splitTextToSize(text1, maxWidth);
  //         for (var i = 0; i < lines.length; i++) {
  //           doc.text(lines[i], padding, line2Height);
  //           line2Height = line2Height + lineHeightIncreament;
  //         }
  //       };

  //       // Generate Page 1
  //       generatePageContent(1);

  //       // Add Page 2 and generate identical content
  //       doc.addPage();
  //       generatePageContent(2);

  //       // Add watermark to all pages
  //       const totalPages = doc.internal.getNumberOfPages();
  //       for (let i = 1; i <= totalPages; i++) {
  //         doc.setPage(i);
  //         doc.addImage(getWaterMarkLogo(DiscoCode), 'PNG', 0, 0, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight());
  //       }

  //       const pdfBlob = doc.output('blob');
  //       const pdfDataUrl = URL.createObjectURL(pdfBlob);

  //       const htmlContent = `
  //         <!DOCTYPE html>
  //         <html>
  //         <head>
  //           <title>Demand Notice</title>
  //           <style>
  //             body { margin: 0; overflow: hidden; }
  //             embed { width: 100vw; height: 100vh; }
  //           </style>
  //         </head>
  //         <body>
  //           <embed src="${pdfDataUrl}" type="application/pdf">
  //         </body>
  //         </html>
  //       `;

  //       const htmlBlob = new Blob([htmlContent], { type: 'text/html' });
  //       const htmlDataUrl = URL.createObjectURL(htmlBlob);

  //       window.open(htmlDataUrl, '_blank');

  //       setTimeout(() => {
  //         URL.revokeObjectURL(pdfDataUrl);
  //         URL.revokeObjectURL(htmlDataUrl);
  //       }, 1000);
  //     }
  //   } catch (e) {
  //     console.log("Unable to generate Master Data Form!");
  //     console.log(e);
  //   }
  //   setViewBackdrop(false);
  // };

  const downloadDNPDF = async (application) => {
    setViewBackdrop(true);
    const applicationId = application.applicationId;
    let DiscoCode = application.companyCode.toString();
    if (!application.subDivisionCode) {
      try {
        application = await SearchIndividualApplication(
          token,
          application.applicationId,
          "1",
        );
      } catch (e) {
        console.log(e, "error getting Application details");
      }
    }
    try {
      let dnDets;
      let boqItems;
      let dnExpiryFlag;
      await callAsyncDnDetailsAPI(applicationId).then((response) => {
        dnDets = response.dnDets;
        boqItems = response.boqItems;
        dnExpiryFlag = response.dnExpiryFlag;
      });

      const securityAmount = parseFloat(dnDets.securityDepositeAmount) || 0;
      const capitalCost = parseFloat(dnDets.capitalCostAmount) || 0;

      const totalServiceConnectionAmount =
        (parseInt(dnDets.capitalCostAmount) || 0) +
        // (!isNaN(parseInt(dnDets.amountOfGridSharing)) ? parseInt(dnDets.amountOfGridSharing) : 0) +
        // (!isNaN(parseInt(dnDets.amountOfFeederRehab)) ? parseInt(dnDets.amountOfFeederRehab) : 0) +
        (!isNaN(parseInt(dnDets.civilWorkCharges))
          ? parseInt(dnDets.civilWorkCharges)
          : 0) +
        (!isNaN(parseInt(dnDets.fixedChargesOfMetering))
          ? parseInt(dnDets.fixedChargesOfMetering)
          : 0) +
        (!isNaN(parseInt(dnDets.miscellaneousCharges))
          ? parseInt(dnDets.miscellaneousCharges)
          : 0) +
        (!isNaN(parseInt(dnDets.mtCharges)) ? parseInt(dnDets.mtCharges) : 0) +
        (!isNaN(parseInt(dnDets.labourCharges))
          ? parseInt(dnDets.labourCharges)
          : 0) +
        (!isNaN(parseInt(dnDets.designVetteingFee))
          ? parseInt(dnDets.designVetteingFee)
          : 0) +
        (!isNaN(parseInt(dnDets.consultancyCharges))
          ? parseInt(dnDets.consultancyCharges)
          : 0) +
        (!isNaN(parseInt(dnDets.variationsCharges))
          ? parseInt(dnDets.variationsCharges)
          : 0) +
        (!isNaN(parseInt(dnDets.dismentalmentCharges))
          ? parseInt(dnDets.dismentalmentCharges)
          : 0) +
        (!isNaN(parseInt(dnDets.earthingCharges))
          ? parseInt(dnDets.earthingCharges)
          : 0);

      console.log(totalServiceConnectionAmount, "totalServiceConnectionAmount");

      const totalServiceConnectionAmountForTotal =
        (parseInt(dnDets.capitalCostAmount) || 0) +
        (!isNaN(parseInt(dnDets.amountOfGridSharing))
          ? parseInt(dnDets.amountOfGridSharing)
          : 0) +
        (!isNaN(parseInt(dnDets.amountOfFeederRehab))
          ? parseInt(dnDets.amountOfFeederRehab)
          : 0) +
        (!isNaN(parseInt(dnDets.civilWorkCharges))
          ? parseInt(dnDets.civilWorkCharges)
          : 0) +
        (!isNaN(parseInt(dnDets.fixedChargesOfMetering))
          ? parseInt(dnDets.fixedChargesOfMetering)
          : 0) +
        (!isNaN(parseInt(dnDets.miscellaneousCharges))
          ? parseInt(dnDets.miscellaneousCharges)
          : 0) +
        (!isNaN(parseInt(dnDets.mtCharges)) ? parseInt(dnDets.mtCharges) : 0) +
        (!isNaN(parseInt(dnDets.labourCharges))
          ? parseInt(dnDets.labourCharges)
          : 0) +
        (!isNaN(parseInt(dnDets.designVetteingFee))
          ? parseInt(dnDets.designVetteingFee)
          : 0) +
        (!isNaN(parseInt(dnDets.consultancyCharges))
          ? parseInt(dnDets.consultancyCharges)
          : 0) +
        (!isNaN(parseInt(dnDets.variationsCharges))
          ? parseInt(dnDets.variationsCharges)
          : 0) +
        (!isNaN(parseInt(dnDets.dismentalmentCharges))
          ? parseInt(dnDets.dismentalmentCharges)
          : 0) +
        (!isNaN(parseInt(dnDets.earthingCharges))
          ? parseInt(dnDets.earthingCharges)
          : 0);

      console.log(
        totalServiceConnectionAmountForTotal,
        "totalServiceConnectionAmountForTotal",
      );
      if (securityAmount == 0 && capitalCost == 0) {
        alert(
          "Cannot generate PDF: Both Security Deposit Amount and Capital Cost Amount are zero.",
        );
        setViewBackdrop(false);
        return;
      }

      if (dnExpiryFlag === "1") {
        setShowDnExpiryPopup(true);
      } else {
        let officeCode = application.subDivisionCode.toString();
        let officeName = subdivisionName(parseInt(officeCode), subDivisions);
        let authorizedByName = dnDets.approvedBy ? dnDets.approvedBy : "---";
        let authorizedByDesignation = dnDets.approvedByDesignation
          ? dnDets.approvedByDesignation
          : "Role";
        let dateToPrint = dnDets.approvedDate
          ? numberFormatting(new Date(dnDets.approvedDate))
          : "---";

        let stampData = printStamp(
          officeCode,
          officeName,
          authorizedByName,
          authorizedByDesignation,
          dnDets.approvedDate,
        );

        const fontSize = 8;
        const doc = new jsPDF({ compressPdf: true });
        if (dnDets.approvedBy) {
          doc.addImage(stampData, "PNG", 20, 200, 55, 40);
          doc.addImage(stampData, "PNG", 140, 265, 55, 40);
        }

        if (dnDets.securityAmountQR && dnDets.capitalCostQR) {
          const securityAmountQR = dnDets.securityAmountQR;
          const capitalCostQR = dnDets.capitalCostQR;
          const securityQrCodeDataURL = await QRCode.toDataURL(
            securityAmountQR,
            {
              errorCorrectionLevel: "M",
              margin: 0,
              width: 120,
            },
          );
          const capitalCostQrCodeDataURL = await QRCode.toDataURL(
            capitalCostQR,
            {
              errorCorrectionLevel: "M",
              margin: 0,
              width: 120,
            },
          );
          doc.setFontSize(7);
          doc.setFont("helvetica", "bold");
          doc.setTextColor(0, 102, 204);
          doc.text("Scan QR for online payment", 178, 206, { align: "center" });
          doc.setTextColor(0, 0, 0);
          doc.setFont("helvetica", "normal");
          // doc.addImage(securityQrCodeDataURL, "PNG", 158, 208, 18, 18);
          // doc.addImage(capitalCostQrCodeDataURL, "PNG", 180, 208, 18, 18);
          doc.setFontSize(6.5);
          doc.setFont("helvetica", "bold");
          doc.text("Security", 167, 229, { align: "center" });
          doc.text("Capital Cost", 189, 229, { align: "center" });
          doc.setFont("helvetica", "normal");
        }

        //#region Line 1
        var padding = 10;
        var line2Height = 10;
        var lineHeightIncreament = 5;
        doc.setFontSize(fontSize);
        doc.setFont("helvetica", "bold");
        doc.text(
          (!dnDets.demandNoteExpiryCount
            ? "Due Date: "
            : "Extended Due Date: ") + convertDate(dnDets.dueDate),
          padding,
          line2Height,
          {},
        );

        doc.setFont("helvetica", "normal");
        doc.text(
          companyName(dnDets.connectionAccountNo.slice(2, 4)).concat(
            application.appliedLoad < 15
              ? "(" +
              dnDets.connectionAccountNo.slice(2, 7) +
              "-" +
              subdivisionName(
                parseInt(application.subDivisionCode),
                subDivisions,
              ) +
              ")"
              : "(" +
              dnDets.connectionAccountNo.slice(2, 6) +
              "-" +
              divisionName(
                parseInt(application.divisionCode),
                subDivisions,
              ) +
              ")",
          ),
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion
        //#region Line 2
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "(Department of Electricity)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 3
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 12;
        var text1 = "Demand Notice Serial No.: ";
        var text2 = dnDets.demandNoticeNo;
        var text3 = "Application Id: ";
        var text4 = applicationId;
        var text5 = "Apply Date: ";
        var text6 = convertDate(application.creationDate);

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 4
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 3.35;
        var text1 = "Demand Notice Issuance Date: ";
        var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        var text3 = "Application Type: ";
        var text4 = application.applicationType
          ? applicationName(application.applicationType)
          : "-";
        var text5 = "(New Connection, Reconnection etc.): ";
        var text6 = application.applicationType
          ? applicationName(application.applicationType)
          : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 5
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "New Allocated Reference No.: ";
        var text2 = dnDets.connectionAccountNo
          ? dnDets.connectionAccountNo
          : "-";
        var text3 = "Consumer Mobile No.: ";
        var text4 = dnDets.applicantMobile ? dnDets.applicantMobile : "-";
        var text5 = "Connection type: ";
        var text6 = dnDets.connectionType ? dnDets.connectionType : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 6
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 7;
        var text1 =
          "(under which the funds are to be deposited in the bank with the concerned officer of the department)";
        var text2 = "Type of Industry / Factory:";
        var text3 = dnDets.industryFactoryType
          ? dnDets.industryFactoryType
          : "-";

        doc.setFontSize(6);
        doc.text(text1, padding, line2Height);
        doc.setFontSize(fontSize);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.text(
          text3,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text3) + lineSpace * 2),
          line2Height + 1,
        );

        //#endregion

        //#region Line 7
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 22.25;
        var text1 = `Department's approved Bank name: `;
        var text2 = dnDets.bankName ? dnDets.bankName : "-";
        var text3 = "Required Load (kW): ";
        var text4 = application.appliedLoad
          ? application.appliedLoad.toString()
          : "|";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 8
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 22;
        var text1 = `Department's Revenue Officer: `;
        var text2 = divisionName(
          parseInt(application.divisionCode),
          subDivisions,
        );
        var text3 = "Coverage Area: ";
        var text4 = dnDets.areaMarla ? dnDets.areaMarla : "|";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 9
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 16;
        var text1 = `Alloted Tariff : `;
        var text2 = dnDets.tariff ? dnDets.tariff : "-";
        var text3 = " ";
        var text4 = " ";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 10
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          "DEMAND NOTICE",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 11
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          "(Notification of Approval Application and Demand Under Guarantee)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 12
        var line2Height = line2Height + lineHeightIncreament;
        var originalFontSize = doc.getFontSize();
        if (
          application.appliedLoad < 5 &&
          dnDets.connectionAccountNo.slice(2, 4) == "15" &&
          dnDets.capitalCostAmount == "3100"
        ) {
          doc.setTextColor(255, 0, 0);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(9);

          doc.text("Meter Cost Excluded.", 160, line2Height - 1.5);
          doc.text("Obtain NOC to purchase.", 160, line2Height + 2.5);

          doc.setTextColor(0, 0, 0);
        }

        doc.setFontSize(fontSize);
        doc.setFont("helvetica", "normal");

        doc.text(
          `Applicant's part`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" },
        );
        //#endregion
        //#region Line 13
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 16;
        var text1 = `Mr. / Mrs.`;
        var relationType = application.applicantRelationType;
        var relationTypeText =
          relationType == 1 || relationType == "S/O"
            ? "S/O"
            : relationType == 2 || relationType == "D/O"
              ? "D/O"
              : relationType == 3 || relationType == "W/O"
                ? "W/O"
                : relationType == 4 || relationType == "C/O"
                  ? "C/O"
                  : "";
        var relativePart = application.applicantRelativeName
          ? ` ${relationTypeText} ${application.applicantRelativeName}`
          : "";
        var text2 = application.applicantName
          ? application.applicantName
            .concat(relativePart)
            .concat(" | ")
            .concat(application.premisesAddress)
          : "|";
        var text3 = ``;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.setFontSize(6);
        doc.text(
          text3,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        //#endregion

        //#region Line 14
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var text1 = `You are hereby informed by demand notice that your application for obtaining electricity connection whose particulars are mentioned above has been approved by the authorized officer on the following conditions apart from the prevailing general conditions of electricity of the department.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 15
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `1. You should deposit the following amounts in the approved bank of the department or with the concerned officer of the department itself within [word1] days from the date of issue of this notice and inform my office with the receipt number and date of your payment.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[word1]", noOfDays);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 16
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `A. Expenditure service connection as per approved estimate ______________ and Security _______________ PKR. (this amount is to be deposited with the concerned officer of the department). If the charges are found to be more than the service approved estimate prior to connection, a deposit equal to the difference in the amount collected will be issued for which additional demand notice will be issued.`;
        var text2 = totalServiceConnectionAmount
          ? numberFormatting(totalServiceConnectionAmount)
          : "";
        var text3 = dnDets.securityDepositeAmount
          ? numberFormatting(dnDets.securityDepositeAmount)
          : "";
        var lines = doc.splitTextToSize(text1, maxWidth);
        doc.setFont("helvetica", "bold");
        doc.text(text2, 90, line2Height);
        doc.text(text3, 130, line2Height);
        doc.setFont("helvetica", "normal");
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace(
            "[capitalCost]",
            dnDets.capitalCostAmount
              ? numberFormatting(dnDets.capitalCostAmount)
              : "",
          );
          lineText = lineText.replace(
            "[securityCost]",
            dnDets.securityDepositeAmount
              ? numberFormatting(dnDets.securityDepositeAmount)
              : "",
          );
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }

        //#endregion

        //#region Line 17
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `B. Arrears due to non-payment of previous electricity bills etc. _____ PKR. (this amount is to be deposited in the bank after receiving the final bill from the revenue officer).`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 18
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `NOTE: If you are an applicant or consumer of domestic, commercial, industrial wholesale supply, you should fill the demand notice in this regard on the sub-layer (reserved for your business) and affix your signature and date on it and send back to my office.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 19
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `2. You shall, within [noOfDays] days from the date of issue of this notice, obtain a test report from a Government approved wiring contractor in proof of the soundness and quality of the internal wiring of your building and the completion of the installation of your electrical appliances and send send to my office for further departmental inspection and testing and get receipt (Blank Test Report is on Form CP-7).`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[noOfDays]", noOfDays);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 20
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var amount = "_____";
        var text1 = `3. Since you have not provided your purchased meter to the department for measuring the supply of electricity, you will be charged a monthly meter rental fee of [amount] PKR.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[amount]", amount);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 21
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var amount = "_____";
        var text1 = `4. Demand notices for release of security deposit sent separately Process of connection will start after deposit of both demand notice amounts separate.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[amount]", amount);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 22
        doc.text(
          `(Irrelevant should be cut down)`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 23
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfMonth = "1";
        var text1 = `If you do not comply with the above conditions in response to the demand notice within the prescribed period, your application form for obtaining electricity will not be considered with the serial number allotted. Demand notices thereof ( [noOfMonth] month after the date of issue) shall automatically be deemed ineffective.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[noOfMonth]", noOfMonth);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 24
        doc.setFontSize(fontSize);
        var line24Y = line2Height;

        // var text1 = "Regards";
        // var spaceLeft = 100;
        // doc.text(text1, padding + spaceLeft, line24Y);

        if (
          application.appliedLoad < 5 &&
          dnDets.connectionAccountNo.slice(2, 4) == "15" &&
          dnDets.capitalCostAmount == "3100"
        ) {
          var originalFontSize = doc.getFontSize();

          doc.setTextColor(255, 0, 0);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(9);

          doc.text("Meter Cost Excluded.", 50, line24Y);

          doc.text("Obtain NOC to purchase.", 50, line24Y + 4);

          doc.setFont("helvetica", "normal");
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(originalFontSize);
        }
        //#endregion

        // //#region Line 25
        // doc.setFontSize(fontSize);
        // var line2Height = line2Height + lineHeightIncreament;
        // var text1 =
        //   application.appliedLoad < 15
        //     ? "Sub-Division Office " +
        //     applicationId.slice(3, 8) +
        //     "-" +
        //     subdivisionName(
        //       parseInt(application.subDivisionCode),
        //       subDivisions
        //     ) +
        //     " SDO " +
        //     companyShortName(DiscoCode)
        //     : "Division Office " +
        //     applicationId.slice(3, 7) +
        //     " - " +
        //     divisionName(parseInt(application.divisionCode), subDivisions) +
        //     " XEN " +
        //     companyShortName(DiscoCode);
        // doc.text(text1, padding + spaceLeft, line2Height);
        // //#endregion

        //#region Line 26
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var text1 = "Signature Bank Officer: ";
        var text2 =
          application.appliedLoad < 15
            ? "Line Superintendent Office" +
            "(" +
            applicationId.slice(3, 8) +
            " - " +
            subdivisionName(
              parseInt(application.subDivisionCode),
              subDivisions,
            ) +
            ") SDO " +
            companyShortName(DiscoCode)
            : "Line Superintendent Office" +
            "(" +
            applicationId.slice(3, 7) +
            " - " +
            divisionName(parseInt(application.divisionCode), subDivisions) +
            ") XEN " +
            companyShortName(DiscoCode);
        doc.text(text1, padding, line2Height);
        // doc.text(text2, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 27
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        spaceLeft = 10;
        var text1 =
          "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
        doc.text(text1, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 28
        lineHeightIncreament = 5;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          (!dnDets.demandNoteExpiryCount
            ? "Due Date: "
            : "Extended Due Date: ") + convertDate(dnDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          "For Bank Use Only",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 29
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "(The concerned bank will separate this layer from the demand notice and send it to the revenue officer along with its bank scroll)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 30
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 16;
        var spaceLeft = 50;

        var text1 = `1. Applicant's Name and Complete address `;
        var bankRelationType = application.applicantRelationType;
        var bankRelationTypeText =
          bankRelationType == 1 || bankRelationType == "S/O"
            ? "S/O"
            : bankRelationType == 2 || bankRelationType == "D/O"
              ? "D/O"
              : bankRelationType == 3 || bankRelationType == "W/O"
                ? "W/O"
                : bankRelationType == 4 || bankRelationType == "C/O"
                  ? "C/O"
                  : "";
        var bankRelativePart = application.applicantRelativeName
          ? ` ${bankRelationTypeText} ${application.applicantRelativeName}`
          : "";
        var text2 = application.applicantName
          ? application.applicantName
            .concat(bankRelativePart)
            .concat(" | ")
            .concat(application.premisesAddress)
          : "|";
        var text3 = ``;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.setFontSize(6);
        doc.text(
          text3,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2 + spaceLeft),
          line2Height,
        );
        //#endregion

        //#region Line 31
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "2. Application Id: ";
        var text2 = application.applicationId ? application.applicationId : "-";
        var text3 = "Date: ";
        var text4 = application.creationDate
          ? convertDate(application.creationDate)
          : "-";
        var text5 = "1. Service Connection:";
        var text6 = totalServiceConnectionAmount
          ? numberFormatting(totalServiceConnectionAmount)
          : "-";
        var leftSpace = 40;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.setFont("helvetica", "bold");
        doc.text(
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          +leftSpace,
          line2Height,
        );
        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          leftSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2 +
          leftSpace,
          line2Height + 1,
        );
        //#endregion

        //#region Line 32
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "3. Demand Notice Serial No.: ";
        var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";
        var text3 = "Date: ";
        var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        var text5 = "2. Security: ";
        var text6 = dnDets.securityDepositeAmount
          ? numberFormatting(dnDets.securityDepositeAmount)
          : "-";
        var leftSpace = 35;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.setFont("helvetica", "bold");
        doc.text(
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          +leftSpace,
          line2Height,
        );
        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          leftSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2 +
          leftSpace,
          line2Height + 1,
        );
        //#endregion

        //#region Line 33
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "4. Account No. for acquisition connection: ";
        var text2 = dnDets.connectionAccountNo
          ? dnDets.connectionAccountNo
          : "-";
        var text3 = " ";
        var text4 = " ";
        var text5 = "3. Grid Share / Feeder Rehab. Charges:";
        var text6 = dnDets.amountOfGridSharing
          ? numberFormatting(dnDets.amountOfGridSharing)
            .concat(" / ")
            .concat(
              dnDets.amountOfFeederRehab
                ? numberFormatting(dnDets.amountOfFeederRehab)
                : "-",
            )
          : "-"
            .concat(" / ")
            .concat(
              dnDets.amountOfFeederRehab
                ? numberFormatting(dnDets.amountOfFeederRehab)
                : "-",
            );
        var leftSpace = 10;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        // doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
        // doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
        // doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

        doc.text(
          text5,
          doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          +leftSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          leftSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2 +
          leftSpace,
          line2Height + 1,
        );
        //#endregion

        //#region Line 34
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "5. Approved bank name and address:";
        var text2 = dnDets.bankName ? dnDets.bankName : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 35
        doc.setFontSize(fontSize);
        var line2Height =
          line2Height + lineHeightIncreament + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 =
          application.appliedLoad < 15
            ? "                                                                                 "
            : "                                                                                  ";
        // var text1 = application.appliedLoad < 15 ? 'Signature Sub-Divisional Officer or Line Superintendent-in-charge' : 'Signature Divisional Officer or Line Superintendent-in-charge'
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = "Signature Bank Officer ";
        var bankOfficerX = doc.internal.pageSize.getWidth() - 125;
        doc.text(text1, padding, line2Height);
        doc.text(text6, bankOfficerX, line2Height);
        //#endregion

        //#region Line 36
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = " ";
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = " ";
        var leftSpace = 10;
        doc.setFontSize(6);
        doc.text(text1, padding, line2Height);
        //#endregion

        //#region Line 37
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        spaceLeft = 0;
        // var text1 =
        //   "----------------------------------------------------------------------------------------------------------------------------";
        var text1 =
          "------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
        doc.text(text1, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 38
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          (!dnDets.demandNoteExpiryCount
            ? "Due Date: "
            : "Extended Due Date: ") + convertDate(dnDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          `Applicant's Response`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 39
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var text1 = `1. I/We have submitted the security amount of [securityCost] and service connection of [capitalCost] only in the department's approved bank [bankName] by receipt no. _______________________________________ on date _______________________________.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace(
            "[capitalCost]",
            numberFormatting(totalServiceConnectionAmount),
          );
          lineText = lineText.replace(
            "[securityCost]",
            numberFormatting(dnDets.securityDepositeAmount),
          );
          lineText = lineText.replace(
            "[bankName]",
            dnDets.bankName ? dnDets.bankName : "-",
          );
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 40
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `2. Since I/We did not provide funds to buy meter to the department, I am/We are responsible to pay monthly rent of ______ PKR as meter rent.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 41
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `3. I am/We are sending herewith demand notice, a certified list report from a government approved wiring contractor to prove that the internal wiring of my/our building is sound and of standard and that the installation of my/our utility equipment has been completed. I will send within the specified period.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        lineHeightIncreament = 5;
        var line2Height = line2Height + lineHeightIncreament;

        var line42Y = line2Height;

        if (
          application.appliedLoad < 5 &&
          dnDets.connectionAccountNo.slice(2, 4) == "15" &&
          dnDets.capitalCostAmount == "3100"
        ) {
          var originalFontSize = doc.getFontSize();

          doc.setTextColor(255, 0, 0);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(9);

          doc.text("Meter Cost Excluded.", 30, line42Y);

          doc.text("Obtain NOC to purchase.", 30, line42Y + 4);

          doc.setFont("helvetica", "normal");
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(originalFontSize);
        }

        doc.text(
          `For Computer Center Use`,
          doc.internal.pageSize.getWidth() / 2,
          line42Y,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 43
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          `(Demand Notice Data)`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 44
        var line2Height = line2Height + lineHeightIncreament;
        var lineHeightIncreament = 5;
        var padding = 10;
        var lineSpace = 7.5;
        var text1 = "Demand Notice Serial No.: ";
        var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";
        var text3 = "Application Id: ";
        var text4 = applicationId ? applicationId : "-";
        var text5 = "Application Form No.: ";
        var text6 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 45
        var line2Height = line2Height + lineHeightIncreament;
        var lineHeightIncreament = 5;
        var padding = 10;
        var lineSpace = 7.5;
        var text1 = "Demand Notice Issuance Date: ";
        var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        var text3 = "Amount to be paid: ";
        var text4 =
          dnDets.capitalCostAmount || dnDets.securityDepositeAmount
            ? numberFormatting(
              totalServiceConnectionAmountForTotal +
              parseInt(dnDets.securityDepositeAmount || 0),
            )
            : "-";
        var text5 = " ";
        var text6 = " ";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.setFont("helvetica", "bold");
        doc.text(
          text4,
          doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height,
        );
        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        //#endregion

        //#region Line 46
        doc.setFontSize(fontSize);
        var line2Height =
          line2Height + lineHeightIncreament + lineHeightIncreament / 2;
        var lineSpace = 6.6;
        var text1 = " ";
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = application.appliedLoad < 15 ? " " : " ";
        var leftSpace = 110;
        doc.text(
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          +leftSpace,
          line2Height,
        );
        //#endregion

        //#region Line 47
        doc.setFontSize(6);
        lineHeightIncreament = 2;
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 8;
        var text1 =
          "NOTE - Computer generated demand notice, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/appplicant. In case any document is found false at later stages,the said connection is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and campany reserved its rights to take legal action against owner/applicant. ";
        var lineSpace = 6.6;
        var lines = doc.splitTextToSize(text1, maxWidth);
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        const totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          doc.setPage(i);
          doc.addImage(
            getWaterMarkLogo(DiscoCode),
            "PNG",
            0,
            0,
            doc.internal.pageSize.getWidth(),
            doc.internal.pageSize.getHeight(),
          );
        }

        const pdfBlob = doc.output("blob");
        const pdfDataUrl = URL.createObjectURL(pdfBlob);

        // Open the PDF in a new tab
        window.open(pdfDataUrl, "_blank");

        //#endregion
      }
    } catch (e) {
      console.log(e);
    }
    setViewBackdrop(false);
  };

  const downloadRejectionNoticePDF = async (application) => {
    setViewBackdrop(true);
    try {
      const applicationId = application.applicationId;

      if (!application.subDivisionCode) {
        try {
          application = await SearchIndividualApplication(
            token,
            application.applicationId,
            "1"
          );
        } catch (e) {
          console.log(e, "error getting Application details");
        }
      }

      // Get rejection data from eFileData or fetch it
      let rejectionData = null;
      let rejectedBy = "";
      let rejectedOn = "";
      let rejectionStep = "";
      let applicationHistoryData = eFileData;

      // Fetch application history if eFileData is empty
      if (!eFileData || eFileData.length === 0) {
        try {
          var formdata = new FormData();
          formdata.append("applicationId", applicationId);
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          var requestOptions = {
            method: "POST",
            body: formdata,
            headers: myHeaders,
            redirect: "follow",
          };

          const response = await fetch(
            cfpBaseUrl + "electricityNewConnection/getApplicationHist",
            requestOptions
          );
          const result = await response.json();

          if (result.status === "200") {
            let applicationCurrentState = result.applicationCurrentState[0];
            let applicationHistory = result.applicationHistory;

            if (applicationHistory === "No History Found") {
              applicationHistory = [];
            }

            applicationHistory = applicationHistory.filter((item) => item.lastModificationDate);
            applicationHistory.push(applicationCurrentState);
            applicationHistoryData = applicationHistory.sort((a, b) => {
              const dateA = new Date(a.lastModificationDate);
              const dateB = new Date(b.lastModificationDate);
              return dateB - dateA;
            });
          }
        } catch (e) {
          console.log("Error fetching application history:", e);
        }
      }

      // Get step name based on applicationProgressId
      const getStepNameForRejection = (progressId) => {
        const stepNames = {
          0: "Document Submission",
          1: "Document Verification",
          2: "Arrear Verification",
          3: "Field Survey",
          4: "Reference Number Allocation",
          5: "DN Payment Submission",
          6: "DN Payment Verification",
          7: "Service Connection Order",
          8: "Meter Installation",
          9: "Ready for Billing",
          10: "Completed"
        };
        return stepNames[progressId] || "Processing";
      };

      // Find the rejection entry from applicationHistoryData
      if (applicationHistoryData && applicationHistoryData.length > 0) {
        rejectionData = applicationHistoryData.find(item =>
          item.objectionStatus === 1 ||
          (item.remarks && item.remarks.toLowerCase().includes('reject'))
        );

        if (rejectionData) {
          rejectedBy = rejectionData.lastModifiedBy || "";
          rejectedOn = rejectionData.lastModificationDate ? convertDate(rejectionData.lastModificationDate) : "";
          rejectionStep = getStepNameForRejection(rejectionData.applicationProgressId);
        }
      }

      // Get rejection remarks
      const rejectionRemarks = rejectionData?.remarks || "";

      // Fallback to application's current progressId if no rejection data found
      if (!rejectionStep) {
        rejectionStep = getStepNameForRejection(application.applicationProgressId);
      }

      // Generate Rejection Notice Number
      const rejectionNoticeNo = "FNC-RN-" + applicationId.replace("NC-", "").slice(0, 15);

      const fontSize = 11;
      const doc = new jsPDF({ compressPdf: true });
      const pageWidth = doc.internal.pageSize.getWidth();
      const padding = 20;
      let yPos = 10;
      const lineHeight = 7;

      // Get company name dynamically based on company code from applicationId
      const discoCode = applicationId.slice(3, 5);
      const companyFullName = companyName(discoCode);
      const companyShort = companyShortName(discoCode);

      // Add logos - Company logo on left, PITC/eOps logo on right
      const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
      const logoWidth = smallLogoCodes.includes(discoCode) ? 25 : 30;
      const logoHeight = smallLogoCodes.includes(discoCode) ? 15 : 12;

      // Company logo on left
      doc.addImage(getLogo(discoCode), "PNG", padding, yPos, logoWidth, logoHeight);

      // eOps logo on right
      doc.addImage(eOpsLogo, "PNG", pageWidth - padding - logoWidth, yPos, logoWidth, logoHeight);

      // Header - Company Name (centered between logos)
      yPos += logoHeight / 2 + 2;
      doc.setFontSize(14);
      doc.setFont("helvetica", "normal");
      doc.text(companyFullName, pageWidth / 2, yPos, { align: "center" });
      yPos += logoHeight / 2 + 5;

      // Title - Rejection Notice
      yPos += 15;
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");
      doc.text("Rejection Notice", pageWidth / 2, yPos, { align: "center" });

      // Underline
      const titleWidth = doc.getTextWidth("Rejection Notice");
      doc.line((pageWidth - titleWidth) / 2, yPos + 2, (pageWidth + titleWidth) / 2, yPos + 2);

      // Rejection Notice No and Date
      yPos += 15;
      doc.setFontSize(fontSize);
      doc.setFont("helvetica", "normal");
      doc.text(`Rejection Notice No: ${rejectionNoticeNo}    Rejected On: ${rejectedOn || convertDate(new Date())}`, padding, yPos);

      // Rejection Step
      yPos += 10;
      doc.setFont("helvetica", "bold");
      doc.text(`Rejected at Step: ${rejectionStep}`, padding, yPos);
      doc.setFont("helvetica", "normal");

      // Rejection Remarks
      if (rejectionRemarks) {
        yPos += 10;
        doc.setFont("helvetica", "bold");
        doc.text("Remarks: ", padding, yPos);
        doc.setFont("helvetica", "normal");
        const remarksText = doc.splitTextToSize(rejectionRemarks, pageWidth - (padding * 2) - doc.getTextWidth("Remarks: "));
        doc.text(remarksText, padding + doc.getTextWidth("Remarks: "), yPos);
        yPos += remarksText.length * lineHeight;
      }

      // Body text
      yPos += 12;
      const bodyText = `This is to inform you that ${companyShort} has considered your application for new connection of electricity vide Tracking No.${applicationId} submitted on ${convertDate(application.creationDate)} in the name of ${application.applicantName || ""} located at ${application.premisesAddress || "-"}. The authority has rejected your application at the stage "${rejectionStep}".`;

      const splitBody = doc.splitTextToSize(bodyText, pageWidth - (padding * 2));
      doc.text(splitBody, padding, yPos);
      yPos += splitBody.length * lineHeight + 5;

      // Footer
      yPos += 10;
      doc.text("This is system generated report and doesn't require signature.", padding, yPos);
      yPos += lineHeight;
      doc.text(`Processed by ${rejectedBy || "System"} dated ${rejectedOn || convertDate(new Date())}`, padding, yPos);

      // Add watermark to all pages
      const totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(discoCode),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight()
        );
      }

      // Open PDF in new tab
      const pdfBlob = doc.output("blob");
      const pdfDataUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfDataUrl, "_blank");

    } catch (e) {
      console.log("Error generating Rejection Notice PDF:", e);
    }
    setViewBackdrop(false);
  };

  const downloadNOCPDF = async (application, dnDets) => {
    setViewBackdrop(true);
    const applicationId = application.applicationId;

    if (!application.subDivisionCode) {
      try {
        application = await SearchIndividualApplication(
          token,
          application.applicationId,
          "1"
        );
      } catch (e) {
        console.log(e, "error getting Application details");
      }
    }

    try {
      let boqItems;
      let dnExpiryFlag;

      // Fetch demand notice details
      await callAsyncDnDetailsAPI(applicationId).then((response) => {
        dnDets = response.dnDets;
        boqItems = response.boqItems;
        dnExpiryFlag = response.dnExpiryFlag;
      });

      const baseFont = 9;
      const doc = new jsPDF({ compressPdf: true });

      // Layout variables
      let padding = 10;
      let line2Height = 10;
      let lineHeightIncreament = 5;
      let lines = [];

      // Header
      doc.setFontSize(baseFont + 1);
      doc.setFont(undefined, "normal");
      doc.text(
        companyName(applicationId.slice(3, 5)).concat(
          " (" +
          applicationId.slice(3, 8) +
          "-" +
          subdivisionName(parseInt(applicationId.slice(3, 8)), subDivisions) +
          ")"
        ),
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        { align: "center" }
      );

      // Row 1 - No, Dated
      line2Height += lineHeightIncreament + 5;
      const textPairs2 = [
        ["No.: ", applicationId],
        [
          "Dated: ",
          new Date()
            .toLocaleDateString("en-GB", {
              day: "numeric",
              month: "short",
              year: "numeric",
            })
            .replace(/ /g, "-"),
        ],
      ];

      const colWidth = (doc.internal.pageSize.getWidth() - padding * 2) / 2; // equal spacing
      let xPos = padding;
      textPairs2.forEach(([label, value], index) => {
        doc.setFontSize(baseFont);
        doc.setFont(undefined, "normal");
        const labelY = line2Height;
        doc.text(label, xPos, labelY);
        const labelWidth = doc.getTextWidth(label);
        const valueX = xPos + labelWidth + 3;
        doc.text(value, valueX, labelY);
        const valueWidth = doc.getTextWidth(value);
        // underline value
        doc.line(valueX, labelY + 1.5, valueX + valueWidth, labelY + 1.5);
        // move to next column
        xPos += colWidth;
      });

      // Row 2 - Name & Address
      line2Height += lineHeightIncreament + 2;
      const textPairsNameAddress = [
        ["Name: ", dnDets.applicantName || "-"],
        ["Address: ", dnDets.premisesAddress || "-"],
      ];

      xPos = padding;
      textPairsNameAddress.forEach(([label, value]) => {
        doc.setFontSize(baseFont);
        doc.setFont(undefined, "normal");
        const labelY = line2Height;
        doc.text(label, xPos, labelY);
        const labelWidth = doc.getTextWidth(label);
        const valueX = xPos + labelWidth + 3;
        doc.text(value, valueX, labelY);
        const valueWidth = doc.getTextWidth(value);
        doc.line(valueX, labelY + 1.5, valueX + valueWidth, labelY + 1.5);
        xPos += colWidth;
      });

      // Row 3 - Phone & S/O D/O
      line2Height += lineHeightIncreament + 2;
      const textPairsPhoneSO = [
        ["S/O, W/O, D/O: ", dnDets.applicantRelativeName || "-"],
        ["Phone: ", dnDets.applicantMobile || "-"],
      ];

      xPos = padding;
      textPairsPhoneSO.forEach(([label, value]) => {
        doc.setFontSize(baseFont);
        doc.setFont(undefined, "normal");
        const labelY = line2Height;
        doc.text(label, xPos, labelY);
        const labelWidth = doc.getTextWidth(label);
        const valueX = xPos + labelWidth + 3;
        doc.text(value, valueX, labelY);
        const valueWidth = doc.getTextWidth(value);
        doc.line(valueX, labelY + 1.5, valueX + valueWidth, labelY + 1.5);
        xPos += colWidth;
      });

      // Add Top Margin Before Title
      line2Height += lineHeightIncreament + 10;

      // Title
      doc.setFontSize(12);
      doc.setFont(undefined, "normal");
      const titleText =
        "NOC FOR PURCHASE OF 01 NO. SINGLE PHASE AMI SMART ENERGY METER PRIVATELY TO THE CONSUMER FROM THE APPROVED MANUFACTURERS";
      const splitTitle = doc.splitTextToSize(titleText, 180);
      const pageWidth = doc.internal.pageSize.getWidth();
      splitTitle.forEach((line, i) => {
        doc.text(line, pageWidth / 2, line2Height + i * 6, { align: "center" });
      });
      line2Height += splitTitle.length * 6;

      // Paragraph
      line2Height += lineHeightIncreament + 2;
      doc.setFontSize(baseFont);
      doc.setFont(undefined, "normal");
      const maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      const newParagraph =
        "MEPCO BOD in its 237th meeting held on 06.10.2025, circulated vide Company Secretary MEPCO Memo No.14212 dated 06.10.2025 has allowed the consumers for private purchase of Single Phase AMI Smart Energy Meters from the approved meter manufacturers having valid prototype approval of Chief Engineer (S&S) NTDC, as time gap arrangement and till further order.";
      lines = doc.splitTextToSize(newParagraph, maxWidth);
      for (let i = 0; i < lines.length; i++) {
        doc.text(lines[i], padding, line2Height);
        line2Height += lineHeightIncreament;
      }

      // Meter Manufacturers List
      line2Height += lineHeightIncreament;

      // First 9 static manufacturers
      const meterManufacturers = [
        "1. M/s PEL 14-KM Ferozepur Road, Lahore.",
        "2. M/s Microtech Industries (Pvt.) Ltd., Plot # 2, St # 2, Attari Industrial Estate 18-Km Ferozepur Road, Lahore.",
        "3. M/s Creative Electronics (Pvt.) Ltd., 160-151/S, QIE Kot Lakhpat, Lahore.",
        "4. M/s Accurate (Pvt.) Ltd., 104-J, M.A Johar Town Lahore.",
        "5. M/s KBK Electronics Engg & Control (Pvt.) Ltd., 1st Floor Sanam Building 37-Ferozpur Road, Lahore.",
        "6. M/s Transfopower Industries Pvt. Ltd., 2-Km Katar Bund Road, Off. Multan Road, Thokar Niaz Baig, Lahore.",
        "7. M/s Intelligent Metering System (Pvt.) Ltd., 62, Block-C Model Town, Lahore.",
        "8. M/s Vertex Electronics (Pvt.) Ltd., 506-Sundar Industrial Estate, Lahore.",
        "9. M/s AM Associates Pvt. Ltd., 69/3 FCC Gulberg IV Canal Bank Road, Lahore.",
      ];

      // Print static manufacturers
      doc.setFont(undefined, "normal");
      meterManufacturers.forEach((item) => {
        lines = doc.splitTextToSize(item, maxWidth);
        lines.forEach((l) => {
          doc.text(l, padding, line2Height);
          line2Height += lineHeightIncreament;
        });
      });

      // Separate 3 dynamic lines
      line2Height += lineHeightIncreament;

      // Line 1: Payment info with bold + underline for specific values
      let x = padding;
      const lineText1 =
        "The consumer has paid lump sum capital cost vide Demand Notice No. ";
      const dnText = dnDets.demandNoticeNo || "-";
      const lineText2 = " on dated ";
      const payDate = dnDets.paymentDate
        ? convertDate(dnDets.paymentDate)
        : "-";
      const lineText3 = " and security Rs. ";
      const secAmount = dnDets.securityDepositeAmount || "-";
      const lineText4 = " on dated ";
      const secDate = dnDets.paymentDate
        ? convertDate(dnDets.paymentDate)
        : "-";

      // Helper for underline
      const underline = (doc, x, y, text) => {
        const w = doc.getTextWidth(text);
        doc.line(x, y + 1.5, x + w, y + 1.5);
        return w;
      };

      // First line
      let xR = padding;
      doc.setFont(undefined, "normal");
      doc.text(lineText1, xR, line2Height);
      xR += doc.getTextWidth(lineText1);

      doc.setFont(undefined, "bold");
      doc.text(dnText, xR, line2Height);
      underline(doc, xR, line2Height, dnText);
      xR += doc.getTextWidth(dnText);

      doc.setFont(undefined, "normal");
      doc.text(lineText2, xR, line2Height);
      xR += doc.getTextWidth(lineText2);

      doc.setFont(undefined, "bold");
      doc.text(payDate, xR, line2Height);
      underline(doc, xR, line2Height, payDate);

      // Move to next line before security info
      line2Height += lineHeightIncreament + 2;
      xR = padding;

      doc.setFont(undefined, "normal");
      doc.text(lineText3, xR, line2Height);
      xR += doc.getTextWidth(lineText3);

      doc.setFont(undefined, "bold");
      doc.text(secAmount, xR, line2Height);
      underline(doc, xR, line2Height, secAmount);
      xR += doc.getTextWidth(secAmount);

      doc.setFont(undefined, "normal");
      doc.text(lineText4, xR, line2Height);
      xR += doc.getTextWidth(lineText4);

      doc.setFont(undefined, "bold");
      doc.text(secDate, xR, line2Height);
      underline(doc, xR, line2Height, secDate);

      line2Height += lineHeightIncreament * 2;

      // Line 2: Objection statement
      doc.setFont(undefined, "normal");
      const objectionLine =
        "This office has no objection for purchase of 01 No. Single Phase AMI Smart Energy Meter from above approved meter manufacturers at your own level.";
      lines = doc.splitTextToSize(objectionLine, maxWidth);
      lines.forEach((l) => {
        doc.text(l, padding, line2Height);
        line2Height += lineHeightIncreament;
      });

      // Line 3: Handover statement
      doc.setFont(undefined, "normal");
      const handoverLine =
        "After purchasing of said meter, it will be handed over to Divisional AMI Cell for further process.";
      lines = doc.splitTextToSize(handoverLine, maxWidth);
      lines.forEach((l) => {
        doc.text(l, padding, line2Height);
        line2Height += lineHeightIncreament;
      });

      // Sub Divisional Officer Section
      line2Height += lineHeightIncreament;
      const xPosition = padding + 110;
      doc.setFontSize(10);
      doc.setFont(undefined, "normal");
      doc.text("Sub Divisional Officer", xPosition, line2Height);

      line2Height += lineHeightIncreament;
      doc.setFontSize(9.5);
      doc.setFont(undefined, "normal");
      doc.text(
        `MEPCO Sub Division ${subdivisionName(
          parseInt(applicationId.slice(3, 8)),
          subDivisions
        )}`,
        xPosition,
        line2Height
      );

      // C.C. Section
      line2Height += lineHeightIncreament * 2;
      doc.setFontSize(baseFont);
      doc.setFont(undefined, "normal");
      doc.text("C.C.", padding, line2Height);

      line2Height += lineHeightIncreament;
      doc.setFontSize(baseFont - 0.5);
      doc.setFont(undefined, "normal");
      doc.text(
        `1. XEN (OP) MEPCO Division ${subdivisionName(
          parseInt(applicationId.slice(3, 8)),
          subDivisions
        )} (Attention: Divisional AMI Cell).`,
        padding,
        line2Height
      );
      line2Height += lineHeightIncreament;
      doc.text("2. Master File.", padding, line2Height);

      // Note at Bottom
      // doc.setFontSize(8);
      // doc.setFont(undefined, 'normal');
      // lineHeightIncreament = 2;
      // const text1 =
      //   'NOTE - Computer generated demand notice, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/applicant. In case any document is found false at later stages, the said connection is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and company reserved its rights to take legal action against owner/applicant.';
      // lines = doc.splitTextToSize(text1, maxWidth);
      // const pageHeight = doc.internal.pageSize.getHeight();
      // const bottomMargin = 10;
      // const noteHeight = lines.length * lineHeightIncreament;
      // line2Height = pageHeight - bottomMargin - noteHeight;
      // for (let i = 0; i < lines.length; i++) {
      //   doc.text(lines[i], padding, line2Height);
      //   line2Height += lineHeightIncreament;
      // }

      // Watermark
      const totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(userCompany),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight()
        );
      }

      // Save PDF
      doc.save(application.applicationId + "- NOC.pdf");
    } catch (e) {
      console.log("Unable to generate Master Data Form!");
      console.log(e);
    }

    setViewBackdrop(false);
  };

  const downloadEstimatePDF = async (application, dnDets) => {
    setViewBackdrop(true);
    const applicationId = application.applicationId;

    if (!application.subDivisionCode) {
      try {
        application = await SearchIndividualApplication(
          token,
          application.applicationId,
          "1"
        );
      } catch (e) {
        console.log(e, "error getting Application details");
      }
    }

    try {
      let boqItems;
      let dnExpiryFlag;

      await callAsyncDnDetailsAPI(applicationId).then((response) => {
        dnDets = response.dnDets;
        boqItems = response.boqItems;
        dnExpiryFlag = response.dnExpiryFlag;
      });
      const formatAmount = (value) => {
        const num = Number(value) || 0;
        const rounded = Math.round(num);              // yahan truncate chahiye ho to Math.trunc
        return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      };
      const materialsList = await callMaterials(applicationId, token);

      const doc = new jsPDF({ compressPdf: true });
      let padding = 10;
      let line2Height = 10;

      const DiscoCode = applicationId.slice(3, 5);
      const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
      const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
      const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const logoX = (pageWidth - logoWidth) / 2;

      doc.addImage(
        getLogo(DiscoCode),
        "PNG",
        logoX,
        line2Height,
        logoWidth,
        logoHeight
      );

      doc.setFont("helvetica", "normal");
      doc.setFontSize(12);
      line2Height += 20;

      const companyShort = companyName(DiscoCode);
      doc.text(companyShort, pageWidth / 2, line2Height, { align: "center" });

      line2Height += 10;
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.text("Cost Estimate", pageWidth / 2, line2Height, {
        align: "center",
      });

      line2Height += 12;

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");

      const tableX = padding;
      const tableY = line2Height;
      const colWidths = [100, 45, 45];

      const rowHeight = 7;

      const headers = ["Item Name", "Qty", "Item Amount"];
      let x = tableX;

      headers.forEach((h, i) => {
        doc.setDrawColor(0, 0, 0);
        doc.rect(x, tableY, colWidths[i], rowHeight);
        doc.text(h, x + 2, tableY + 5);
        x += colWidths[i];
      });

      doc.setFont("helvetica", "normal");
      doc.setFontSize(12);
      let rowY = tableY + rowHeight;

      // Calculate total amount
      let totalAmount = 0;

      boqItems.forEach((item) => {
        let colX = tableX;

        const matchedItem = materialsList.find(
          (m) => m.item_Code?.toString() === item.itemCode?.toString()
        );

        const itemName = matchedItem ? matchedItem.item_Name : item.itemCode;

        colWidths.forEach((width) => {
          doc.setDrawColor(0, 0, 0);
          doc.rect(colX, rowY, width, rowHeight);
          colX += width;
        });

        const data = [
          itemName,
          item.qty?.toString() ?? "",
          item.itemAmount?.toString() ?? "",
        ];

        // Add to total
        totalAmount += parseFloat(item.itemAmount) || 0;

        colX = tableX;
        data.forEach((value, i) => {
          doc.text(String(value), colX + 2, rowY + 5);
          colX += colWidths[i];
        });

        rowY += rowHeight;
      });

      // // ---------- ADD TOTAL ROW ----------
      // doc.setFont("helvetica", "bold");

      // // Draw merged cell for first two columns
      // const mergedWidth = colWidths[0] + colWidths[1];
      // doc.setDrawColor(0, 0, 0);
      // doc.rect(tableX, rowY, mergedWidth, rowHeight);

      // // Draw "Total" text centered in merged cell
      // const totalText = "Total";
      // const totalTextWidth = doc.getTextWidth(totalText);
      // const totalTextX = tableX + (mergedWidth - totalTextWidth) / 2;
      // doc.text(totalText, totalTextX, rowY + 5);

      // // Draw third column with total amount
      // const thirdColX = tableX + mergedWidth;
      // doc.rect(thirdColX, rowY, colWidths[2], rowHeight);
      // doc.text(formatAmount(totalAmount.toFixed(2)), thirdColX + 2, rowY + 5);

      // rowY += rowHeight;
      // // ---------- END TOTAL ROW ----------

      line2Height = rowY + 10;

      // ========== ADD SERVICE COST ESTIMATE PAGE ==========
      doc.addPage();
      let height = 10;
      doc.addImage(getLogo(DiscoCode), "PNG", logoX, 5, logoWidth, logoHeight);

      let increment = 15;
      height += increment;
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
        align: "center",
      });

      increment = 10;
      height += increment;
      doc.setFontSize(11);
      doc.text("Application Id:", padding, height);
      doc.text(applicationId || "-", padding + 40, height);
      doc.text("Name:", pageWidth / 2 + 5, height);
      doc.text(application?.applicantName || "-", pageWidth / 2 + 25, height);

      height += increment;
      const rectWidth = 195;
      const rectHeight = 10;
      const rectX = (pageWidth - rectWidth) / 2;
      doc.setFillColor(199, 199, 199);
      doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
      doc.setFont("helvetica", "bold");
      doc.text("Service Cost Estimate", pageWidth / 2, height, {
        align: "center",
      });

      height += 10;

      const itemsTotalValue = Number(totalAmount) || 0;
      const roundedItemsTotal = Math.round(itemsTotalValue);
      const isCase13 = String(applicationId || "")
        .toUpperCase()
        .startsWith("NC-13");
      const storeCharges = isCase13
        ? 0
        : Math.floor((roundedItemsTotal * 12 + 50) / 100);
      const installationCharges = Math.floor(
        ((roundedItemsTotal + storeCharges) * 8 + 50) / 100
      );
      const gridSharing = Number(dnDets.amountOfGridSharing) || 0;
      const feederRehab = Number(dnDets.amountOfFeederRehab) || 0;
      const civilWork = Number(dnDets.civilWorkCharges) || 0;
      const miscCharges = Number(dnDets.miscellaneousCharges) || 0;
      const mtCharges = Number(dnDets.mtCharges) || 0;
      const labourCharges = Number(dnDets.labourCharges) || 0;
      const metering = Number(dnDets.fixedChargesOfMetering) || 0;
      const designVettingFee = Number(dnDets.designVetteingFee) || 0;
      const consultancyCharges = Number(dnDets.consultancyCharges) || 0;
      const variationCharges = Number(dnDets.variationsCharges) || 0;
      const dismantlementCharges = Number(dnDets.dismentalmentCharges) || 0;
      const earthingCharges = Number(dnDets.earthingCharges) || 0;
      const lessCost = Number(dnDets.lessTheCost) || 0;
      const securityDeposit = Number(dnDets.securityDepositeAmount) || 0;

      const subtotalA = roundedItemsTotal + storeCharges;
      const subtotalB = installationCharges + gridSharing + feederRehab;
      const subtotalC = civilWork + miscCharges + mtCharges + labourCharges;
      const subtotalD =
        metering +
        designVettingFee +
        consultancyCharges +
        variationCharges +
        dismantlementCharges +
        earthingCharges;
      const grossTotal = subtotalA + subtotalB + subtotalC + subtotalD;
      const netTotal = grossTotal - lessCost;
      const grandTotal = netTotal + securityDeposit;

      const rightX = pageWidth - 15;

      const drawSectionHeader = (title) => {
        doc.setFillColor(225, 225, 225);
        doc.rect(padding, height - 5.5, pageWidth - padding * 2, 8, "F");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(11);
        doc.setTextColor(45, 66, 89);
        doc.text(title, padding + 3, height);
        doc.setTextColor(0, 0, 0);
        height += 8;
      };

      const drawItemRow = (label, value, options = {}) => {
        doc.setFont("helvetica", options.bold ? "bold" : "normal");
        doc.setFontSize(11);

        if (options.green) {
          doc.setTextColor(0, 120, 0);
        }
        if (options.red) {
          doc.setTextColor(170, 0, 0);
        }

        doc.text(label, padding + 12, height);
        doc.text(`${formatAmount(value)} /-`, rightX, height, { align: "right" });

        if (!options.noLine) {
          doc.setDrawColor(180, 180, 180);
          doc.setLineDashPattern([1, 1], 0);
          doc.line(padding + 70, height - 1, rightX - 2, height - 1);
          doc.setLineDashPattern([], 0);
        }

        doc.setTextColor(0, 0, 0);
        height += 8;
      };

      const drawRule = () => {
        doc.setDrawColor(140, 140, 140);
        doc.line(padding, height - 4, pageWidth - padding, height - 4);
      };

      drawSectionHeader("A. Material & Store Cost");
      drawItemRow("Items Total Amount", roundedItemsTotal);
      drawItemRow(isCase13 ? "Store Charges (0%)" : "Store Charges (12%)", storeCharges);
      drawItemRow("Subtotal (A)", subtotalA, { bold: true, noLine: true });
      drawRule();

      drawSectionHeader("B. Installation & Technical Cost");
      drawItemRow("Installation Charges (8%)", installationCharges);
      drawItemRow("Grid Sharing Cost", gridSharing);
      drawItemRow("Feeder Rehab Charges", feederRehab);
      drawItemRow("Subtotal (B)", subtotalB, { bold: true, noLine: true });
      drawRule();

      drawSectionHeader("C. Civil & Miscellaneous");
      drawItemRow("Civil Work Charges", civilWork);
      drawItemRow("Misc. Charges", miscCharges);
      drawItemRow("MNT Charges", mtCharges);
      drawItemRow("Labour Charges", labourCharges);
      drawItemRow("Subtotal (C)", subtotalC, { bold: true, noLine: true });
      drawRule();

      drawSectionHeader("D. Other Charges");
      drawItemRow("Fixed Charges Of Metering", metering);
      drawItemRow("Design Vetting Fee", designVettingFee);
      drawItemRow("Consultancy Charges", consultancyCharges);
      drawItemRow("Variation Charges", variationCharges);
      drawItemRow("Dismantlement Charges", dismantlementCharges);
      drawItemRow("Earthing Charges", earthingCharges);
      drawItemRow("Subtotal (D)", subtotalD, { bold: true, noLine: true });

      height += 1;
      doc.setFillColor(232, 232, 232);
      doc.rect(padding, height - 5.5, pageWidth - padding * 2, 8, "F");
      drawItemRow("Gross Total (A+B+C+D)", grossTotal, { bold: true, noLine: true });

      const lessLabelX = padding + 3;
      doc.setFont("helvetica", "bold");
      doc.setTextColor(170, 0, 0);
      doc.text("Less:", lessLabelX, height);
      doc.setTextColor(0, 0, 0);
      doc.text("Cost Adjustment", lessLabelX + doc.getTextWidth("Less: "), height);
      doc.text(`${formatAmount(lessCost)} /-`, rightX, height, { align: "right" });
      height += 8;

      drawItemRow("Net Total", netTotal, { bold: true, noLine: true });
      drawItemRow("Security Deposit", securityDeposit, { bold: true, noLine: true });

      doc.setFillColor(220, 236, 220);
      doc.rect(padding, height - 5.5, pageWidth - padding * 2, 8, "F");
      drawItemRow("GRAND TOTAL PAYABLE", grandTotal, {
        bold: true,
        green: true,
        noLine: true,
      });

      // ========== END SERVICE COST ESTIMATE PAGE ==========

      const totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);

        // Always show watermark image
        doc.addImage(
          getWaterMarkLogo(userCompany),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight()
        );

        // Show red stamp only if applicationProgressId === 4
        if (application.applicationProgressId === 4) {
          const addWatermarkStamps = () => {
            const stampWidth = 50;
            const stampHeight = 17;

            const stampLines = [
              "This cost estimate is",
              "not yet approved by",
              "the sanctioning",
              "authority.",
            ];

            const watermarkPositions = [
              { x: 5, y: 20 },
              { x: doc.internal.pageSize.getWidth() - stampWidth - 5, y: 20 },
              {
                x: doc.internal.pageSize.getWidth() / 2 - stampWidth / 2,
                y: doc.internal.pageSize.getHeight() / 2 - stampHeight / 2,
              },
              { x: 20, y: doc.internal.pageSize.getHeight() - 65 },
              {
                x: doc.internal.pageSize.getWidth() - stampWidth - 20,
                y: doc.internal.pageSize.getHeight() - 65,
              },
            ];

            doc.saveGraphicsState();

            watermarkPositions.forEach((pos) => {
              doc.setDrawColor(255, 0, 0);
              doc.setLineWidth(0.5);
              doc.rect(pos.x, pos.y, stampWidth, stampHeight);

              doc.setTextColor(255, 0, 0);
              doc.setFont("helvetica", "bold");
              doc.setFontSize(12);

              const lineHeight = 4;
              const startY = pos.y + 4;

              stampLines.forEach((line, index) => {
                const textWidth = doc.getTextWidth(line);
                const textX = pos.x + (stampWidth - textWidth) / 2;
                const textY = startY + index * lineHeight;
                doc.text(line, textX, textY);
              });
            });

            doc.restoreGraphicsState();
          };

          addWatermarkStamps();
        }
      }

      doc.save(application.applicationId + "- Cost Estimate.pdf");
    } catch (e) {
      console.log(e);
    }

    setViewBackdrop(false);
  };
  const downloadSCOPDF = async (application) => {
    setViewBackdrop(true);
    const applicationId = application.applicationId;
    let DiscoCode = application.companyCode.toString();
    if (!application.subDivisionCode) {
      try {
        application = await SearchIndividualApplication(
          token,
          application.applicationId,
          "1",
        );
      } catch (e) {
        console.log(e, "error in getting application details");
      }
    }
    try {
      let scoDets;

      await callAsyncGetSCOAPI(applicationId).then((response) => {
        scoDets = response;
      });

      let dnDets;
      let boqItems;
      await callAsyncDnDetailsAPI(applicationId).then((response) => {
        dnDets = response.dnDets;
        boqItems = response.boqItems;
      });

      let officeCode = application.subDivisionCode.toString();
      let officeName = subdivisionName(parseInt(officeCode), subDivisions);
      let authorizedByName = scoDets.authorizedByName
        ? scoDets.authorizedByName
        : "---";
      let authorizedByDesignation = scoDets.authorizedByDesignation
        ? scoDets.authorizedByDesignation
        : "---";
      let scoP2ApprovedBy = scoDets.scoP2ApprovedBy
        ? scoDets.scoP2ApprovedBy
        : "---";
      let scoP2ApprovedByDesignation = scoDets.scoP2ApprovedByDesignation
        ? scoDets.scoP2ApprovedByDesignation
        : "Role";
      let dateOfAuthorization = scoDets.dateOfAuthorization
        ? new Date(scoDets.dateOfAuthorization).toLocaleDateString()
        : "---";
      let scoP2ApprovalDate = scoDets.scoP2ApprovalDate
        ? new Date(scoDets.scoP2ApprovalDate).toLocaleDateString()
        : "---";
      let part1StampData = printStamp(
        officeCode,
        officeName,
        authorizedByName,
        authorizedByDesignation,
        dateOfAuthorization,
      );
      let part2StampData = printStamp(
        officeCode,
        officeName,
        scoP2ApprovedBy,
        scoP2ApprovedByDesignation,
        scoP2ApprovalDate,
      );

      const fontSize = 9;
      //#region text
      const doc = new jsPDF({ compressPdf: true });
      // Add image to PDF
      if (scoDets.authorizedByName) {
        doc.addImage(part1StampData, "PNG", 145, 70, 55, 40); // Add image to PDF (x, y, width, height)
      }
      if (scoDets.scoP2ApprovedBy) {
        doc.addImage(part2StampData, "PNG", 145, 230, 55, 40); // Add image to PDF (x, y, width, height)
      }
      //#region Line 1
      var padding = 10;
      var line2Height = 10;
      var lineHeightIncreament = 6;
      doc.setFontSize(fontSize);
      doc.text(
        companyName(applicationId.slice(3, 5)),
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        },
      );
      //#endregion

      //#region Line 2
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        "Service Connection Order (SCO)",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        },
      );
      //#endregion

      //#region Line 3
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "1. Sub Division: ";
      var text2 = application.subDivisionCode
        ? application.subDivisionCode
            .toString()
            .concat(" / ")
            .concat(subdivisionName(application.subDivisionCode, subDivisions))
        : "-";
      var text3 = "SCO No.: ";
      var text4 = scoDets.scoId ? scoDets.scoId : "-";
      var text5 = "Creation Date: ";
      var text6 = scoDets.scoP2ApprovalDate
        ? convertDate(scoDets.scoP2ApprovalDate)
        : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text6,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
        line2Height + 1,
      );
      //#endregion

      //#region Line 4
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 2;
      var text1 = "2. Application No.: ";
      var text2 = application.applicationId ? application.applicationId : "-";
      var text3 = "Date: ";
      var text4 = application.creationDate
        ? convertDate(application.creationDate)
        : "-";
      var text5 = "Tariff: ";
      var text6 = dnDets.tariff ? dnDets.tariff : "-";
      var text7 = scoDets.fataPata ? scoDets.fataPata : "-";
      var text8 = scoDets.urbanRural ? scoDets.urbanRural : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text6,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
        line2Height + 1,
      );
      doc.text(
        text7,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          doc.getTextWidth(text6) +
          padding +
          lineSpace * 7,
        line2Height,
      );
      doc.text(
        text8,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          doc.getTextWidth(text6) +
          doc.getTextWidth(text7) +
          padding +
          lineSpace * 8,
        line2Height,
      );
      //#endregion

      //#region Line 5
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "3. Account No.: ";
      var text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : "-";
      var text3 = "Feeder No.: ";
      var text4 = scoDets.feederNo ? scoDets.feederNo : "-";
      var text5 = "Batch: ";
      var text6 = scoDets.batch ? scoDets.batch : "-";
      var text7 = "Sub Batch: ";
      var text8 = scoDets.subBatch ? scoDets.subBatch : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text6,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
        line2Height + 1,
      );

      doc.text(
        text7,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          doc.getTextWidth(text6) +
          padding +
          lineSpace * 6,
        line2Height,
      );
      doc.text(
        text8,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          doc.getTextWidth(text6) +
          doc.getTextWidth(text7) +
          padding +
          lineSpace * 7,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          doc.getTextWidth(text6) +
          doc.getTextWidth(text7) +
          padding +
          lineSpace * 6,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          doc.getTextWidth(text6) +
          doc.getTextWidth(text7) +
          padding +
          lineSpace * 6 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
        line2Height + 1,
      );

      //#endregion

      //#region Line 6
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = `4. Applicant's Name: `;
      // Map relation codes to human-readable phrases
      var relationType = application.applicantRelationType;
      var relationTypeText =
        relationType == 1 || relationType == "S/O"
          ? "S/O"
          : relationType == 2 || relationType == "D/O"
            ? "D/O"
            : relationType == 3 || relationType == "W/O"
              ? "W/O"
              : relationType == 4 || relationType == "C/O"
                ? "C/Os"
                : "";
      var relativePart = application.applicantRelativeName
        ? ` ${relationTypeText} ${application.applicantRelativeName}`
        : "";
      var text2 = application.applicantName
        ? application.applicantName.concat(relativePart)
        : "-";
      var text3 = "CNIC/NIC/NICOP: ";
      var text4 = application.applicantCNIC ? application.applicantCNIC : "-";
      var leftSpace = 50;

      const pageWidth = doc.internal.pageSize.getWidth();

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      // Compute a safe X position for CNIC label so it doesn't overflow the page
      const baseX =
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2);
      const shiftLeft = 40; // move further left by this many units
      const desiredX3 = baseX + leftSpace - shiftLeft;
      const minX3 = padding + doc.getTextWidth(text1) + lineSpace;
      const maxX3 =
        pageWidth -
        padding -
        doc.getTextWidth(text3) -
        doc.getTextWidth(text4) -
        10;
      const x3 = Math.min(Math.max(desiredX3, minX3), maxX3);

      doc.text(text3, x3, line2Height);

      const x4 = x3 + doc.getTextWidth(text3) + lineSpace;
      doc.text(text4, x4, line2Height);

      doc.line(
        x4 - lineSpace / 2,
        line2Height + 1,
        x4 - lineSpace / 2 + (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 7
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = `5. Address: `;
      var text2 = application.premisesAddress
        ? application.premisesAddress
        : "-";
      var text3 = "Mobile No.: ";
      var text4 = application.applicantMobile
        ? application.applicantMobile
        : "-";
      var leftSpace = 50;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      var reducedLeftSpace = 20;

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2) +
          reducedLeftSpace,
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3 +
          reducedLeftSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          reducedLeftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2) +
          reducedLeftSpace,
        line2Height + 1,
      );

      //#region Line 8
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = `6. Service Connection Cost DN No.: `;
      var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";
      var text3 = "Issuance Date: ";
      var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
      var leftSpace = 35;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2) +
          leftSpace,
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3 +
          leftSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2) +
          leftSpace,
        line2Height + 1,
      );
      //#endregion

      //#region Line 9
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = `7. Security Deposit DN No.: `;
      var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";
      // var text3 = 'Issuance Date: '
      var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
      var leftSpace = 47;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      // doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
      // doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
      // doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
      //#endregion

      //#region Line 10
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = `8. Amount of Service Connection: `;
      var text2 = dnDets.capitalCostAmount
        ? numberFormatting(dnDets.capitalCostAmount)
        : "-";
      var text3 = "Payment Date: ";
      var text4 = dnDets.paymentDate ? convertDate(dnDets.paymentDate) : "-";
      var leftSpace = 52;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2) +
          leftSpace,
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3 +
          leftSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2) +
          leftSpace,
        line2Height + 1,
      );
      //#endregion

      //#region Line 11
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = `9. Amount of Security Deposit: `;
      var text2 = dnDets.securityDepositeAmount
        ? numberFormatting(dnDets.securityDepositeAmount)
        : "-";
      // var text3 = 'Payment Date: '
      var text4 = dnDets.paymentDate ? convertDate(dnDets.paymentDate) : "-";
      var leftSpace = 56.5;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      // doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
      // doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
      // doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
      //#endregion

      //#region Line 11a onward - DN Cost Components
      const toAmount = (value) => Number(value) || 0;
      const hasAmount = (value) => Number(value) !== 0;
      const hasDisplayValue = (value) => {
        if (value === null || value === undefined) return false;
        const text = String(value).trim();
        return text !== "" && text !== "-";
      };
      const formatCostText = (amount) => {
        const formattedAmount = numberFormatting(Math.round(amount));
        return formattedAmount !== undefined && formattedAmount !== null
          ? String(formattedAmount)
          : "0";
      };

      let amountSerial = 10;

      const drawCostPair = (
        leftLabel,
        leftAmount,
        rightLabel = "",
        rightAmount = null,
      ) => {
        const leftLabelX = padding;
        const leftValueX = 52;
        const rightLabelX = 110;
        const rightValueX = 175;
        const showLeft = hasAmount(leftAmount);
        const showRight = rightLabel && hasAmount(rightAmount);

        if (!showLeft && !showRight) {
          return;
        }

        line2Height = line2Height + lineHeightIncreament;

        // Keep rows compact: if only one side has value, render it on left columns.
        if (!showLeft && showRight) {
          const shiftedText = formatCostText(rightAmount);
          const rightNumberedLabel = `${amountSerial}. ${rightLabel}`;
          amountSerial += 1;
          doc.text(rightNumberedLabel, leftLabelX, line2Height);
          doc.text(shiftedText, leftValueX, line2Height);
          doc.line(
            leftValueX - 1,
            line2Height + 1,
            leftValueX + 22,
            line2Height + 1,
          );
          return;
        }

        const leftText = formatCostText(leftAmount);
        const leftNumberedLabel = `${amountSerial}. ${leftLabel}`;
        amountSerial += 1;

        doc.text(leftNumberedLabel, leftLabelX, line2Height);
        doc.text(leftText, leftValueX, line2Height);
        doc.line(
          leftValueX - 1,
          line2Height + 1,
          leftValueX + 22,
          line2Height + 1,
        );

        if (showRight) {
          const rightText = formatCostText(rightAmount);
          const rightNumberedLabel = `${amountSerial}. ${rightLabel}`;
          amountSerial += 1;
          doc.text(rightNumberedLabel, rightLabelX, line2Height);
          doc.text(rightText, rightValueX, line2Height);
          doc.line(
            rightValueX - 1,
            line2Height + 1,
            rightValueX + 22,
            line2Height + 1,
          );
        }
      };

      const serviceConnectionAmount = toAmount(dnDets.capitalCostAmount);
      const securityDepositAmount = toAmount(dnDets.securityDepositeAmount);
      const amountOfGridSharing = toAmount(dnDets.amountOfGridSharing);
      const amountOfFeederRehab = toAmount(dnDets.amountOfFeederRehab);
      const civilWorkCharges = toAmount(dnDets.civilWorkCharges);
      const fixedChargesOfMetering = toAmount(dnDets.fixedChargesOfMetering);
      const miscellaneousCharges = toAmount(dnDets.miscellaneousCharges);
      const mtCharges = toAmount(dnDets.mtCharges);
      const labourCharges = toAmount(dnDets.labourCharges);
      const designVettingFee = toAmount(dnDets.designVetteingFee);
      const consultancyCharges = toAmount(dnDets.consultancyCharges);
      const variationsCharges = toAmount(dnDets.variationsCharges);
      const dismentalmentCharges = toAmount(dnDets.dismentalmentCharges);
      const earthingCharges = toAmount(dnDets.earthingCharges);
      const lessTheCost = toAmount(dnDets.lessTheCost);

      drawCostPair(
        "Grid Sharing Cost:",
        amountOfGridSharing,
        "Feeder Rehab Charges:",
        amountOfFeederRehab,
      );
      drawCostPair(
        "Civil Work Charges:",
        civilWorkCharges,
        "Fixed Charges Of Metering:",
        fixedChargesOfMetering,
      );
      drawCostPair(
        "Miscellaneous Charges:",
        miscellaneousCharges,
        "M&T Charges:",
        mtCharges,
      );
      drawCostPair(
        "Labour Charges:",
        labourCharges,
        "Design Vetting Fee:",
        designVettingFee,
      );
      drawCostPair(
        "Consultancy Charges:",
        consultancyCharges,
        "Variation Charges:",
        variationsCharges,
      );
      drawCostPair(
        "Dismantlement Charges:",
        dismentalmentCharges,
        "Earthing Charges:",
        earthingCharges,
      );

      const totalAmount =
        serviceConnectionAmount +
        securityDepositAmount +
        amountOfGridSharing +
        amountOfFeederRehab +
        civilWorkCharges +
        fixedChargesOfMetering +
        miscellaneousCharges +
        mtCharges +
        labourCharges +
        designVettingFee +
        consultancyCharges +
        variationsCharges +
        dismentalmentCharges +
        earthingCharges -
        lessTheCost;

      drawCostPair(
        "Less The Cost:",
        -Math.abs(lessTheCost),
        "Total Amount:",
        totalAmount,
      );

      const continueOnNewPageIfNeeded = (rowsNeeded = 1) => {
        const pageBottomLimit = doc.internal.pageSize.getHeight() - 14;
        const requiredSpace = lineHeightIncreament * rowsNeeded;
        if (line2Height + requiredSpace > pageBottomLimit) {
          doc.addPage();
          line2Height = 14;
          doc.text(
            "Service Connection Order (SCO) - Continued",
            doc.internal.pageSize.getWidth() / 2,
            line2Height,
            {
              align: "center",
            },
          );
        }
      };
      //#endregion

      //#region Line 12
      continueOnNewPageIfNeeded(1);
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 =
        "13. F. Govt / Autonomous and Local Bodies under Prov. Govt.: ";
      var text2 = scoDets.fGovt ? scoDets.fGovt : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 13
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "14. Cantonment Board: ";
      var text2 = scoDets.cantonmentBoard ? scoDets.cantonmentBoard : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 14
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 =
        "15. Prov. Govt / Autonomous and Local Bodies under Prov Govt.: ";
      var text2 = scoDets.pGovt ? scoDets.pGovt : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 15
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "16. Local Bodies: ";
      var text2 = scoDets.localBodies ? scoDets.localBodies : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 16
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = `17. Authorized By (Name): `;
      var text2 = scoDets.authorizedByName ? scoDets.authorizedByName : "-";
      var text3 = "Stamp: ______________________";
      var leftSpace = 62;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      // doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2) +
          leftSpace,
        line2Height,
      );
      //#endregion

      //#region Line 17
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      // var text1 = 'Authorization Date: '
      var text1 = " ";
      var text2 = " ";
      // var text2 = scoDets.dateOfAuthorization ? convertDate(scoDets.dateOfAuthorization) : '-'
      var leftSpace = 122;

      doc.text(text1, padding + leftSpace, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace + leftSpace,
        line2Height,
      );
      // doc.line(doc.getTextWidth(text1) + padding + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height + 1);
      //#endregion

      //#region Line 18
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      // var text1 = 'Designation: __________________________'
      var text1 = "  ";
      var leftSpace = 122;

      doc.text(text1, padding + leftSpace, line2Height);
      //#endregion

      //#region Line 19
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      // var text1 = 'Stamp: ______________________________'
      var text1 = " ";
      var leftSpace = 122;

      doc.text(text1, padding + leftSpace, line2Height);
      //#endregion

      //#region Line 20
      var line2Height = line2Height + lineHeightIncreament;
      var text1 = `18. Store Requisition No.: `;
      var text2 = scoDets.storeRequisitionNo
        ? numberFormatting(scoDets.storeRequisitionNo)
        : "-";
      var text3 = "Requisition Date: ";
      var text4 = scoDets.storeRequisitionDate
        ? convertDate(scoDets.storeRequisitionDate)
        : "-";
      var leftLabelX = padding;
      var leftValueX = 64;
      var rightLabelX = 120;
      var rightValueX = 172;

      doc.text(text1, leftLabelX, line2Height);
      doc.text(text2, leftValueX, line2Height);
      doc.line(
        leftValueX - 1,
        line2Height + 1,
        leftValueX + 26,
        line2Height + 1,
      );

      doc.text(text3, rightLabelX, line2Height);
      doc.text(text4, rightValueX, line2Height);
      doc.line(
        rightValueX - 1,
        line2Height + 1,
        rightValueX + 24,
        line2Height + 1,
      );
      //#endregion

      //#region Line 21
      continueOnNewPageIfNeeded(1);
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "19. Nature as per Standard Classification Code Booklet: ";
      var text2 = dnDets.tariff ? dnDets.tariff : "-";

      doc.text(text1, padding, line2Height);
      doc.text(text2, doc.getTextWidth(text1) + padding, line2Height);
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 22
      var line2Height = line2Height + lineHeightIncreament;
      var text1 = `20. Seasonal/Non-Seasonal: `;
      var text2 = scoDets.seasonalFlag ? scoDets.seasonalFlag.toString() : "-";
      var text3 = "Sanctioned Load: ";
      var text4 = dnDets.sanctionLoad ? dnDets.sanctionLoad.toString() : "-";
      var leftLabelX = padding;
      var leftValueX = 64;
      var rightLabelX = 132;
      var rightValueX = 186;

      doc.text(text1, leftLabelX, line2Height);
      doc.text(text2, leftValueX, line2Height);
      doc.line(
        leftValueX - 1,
        line2Height + 1,
        leftValueX + 18,
        line2Height + 1,
      );

      doc.text(text3, rightLabelX, line2Height);
      doc.text(text4, rightValueX, line2Height);
      doc.line(
        rightValueX - 1,
        line2Height + 1,
        rightValueX + 12,
        line2Height + 1,
      );
      //#endregion

      //#region Line 23
      var line2Height = line2Height + lineHeightIncreament;
      var leftLabelX = padding;
      var leftValueX = 56;
      var rightLabelX = 98;
      var rightValueX = 187;
      var text1 = `21. No. of meters: `;
      var text2 = scoDets.noOfMeters ? scoDets.noOfMeters.toString() : "-";
      var text3 = "No. of AC/Centrally Air Conditioned Code: ";
      var text4 = scoDets.noOfACs ? scoDets.noOfACs.toString() : "-";

      doc.text(text1, leftLabelX, line2Height);
      doc.text(text2, leftValueX, line2Height);
      doc.line(
        leftValueX - 1,
        line2Height + 1,
        leftValueX + 20,
        line2Height + 1,
      );

      doc.text(text3, rightLabelX, line2Height);
      doc.text(text4, rightValueX, line2Height);
      doc.line(
        rightValueX - 1,
        line2Height + 1,
        rightValueX + 12,
        line2Height + 1,
      );
      //#endregion

      //#region Line 24
      var line2Height = line2Height + lineHeightIncreament;
      var leftLabelX = padding;
      var leftValueX = 56;
      var rightLabelX = 106;
      var rightValueX = 187;
      var text1 = "22. No. of meter sets: ";
      var text2 = scoDets.noOfMeterSets
        ? scoDets.noOfMeterSets.toString()
        : "-";
      var text3 = "No. of supply points: ";
      var text4 = scoDets.noOfSupplyPoints
        ? scoDets.noOfSupplyPoints.toString()
        : "-";

      doc.text(text1, leftLabelX, line2Height);
      doc.text(text2, leftValueX, line2Height);
      doc.line(
        leftValueX - 1,
        line2Height + 1,
        leftValueX + 20,
        line2Height + 1,
      );

      doc.text(text3, rightLabelX, line2Height);
      doc.text(text4, rightValueX, line2Height);
      doc.line(
        rightValueX - 1,
        line2Height + 1,
        rightValueX + 12,
        line2Height + 1,
      );

      var line2Height = line2Height + lineHeightIncreament;
      var text5 = "No. of sub sets: ";
      var text6 = scoDets.noOfSubSets ? scoDets.noOfSubSets.toString() : "-";
      doc.text(text5, leftLabelX, line2Height);
      doc.text(text6, leftValueX, line2Height);
      doc.line(
        leftValueX - 1,
        line2Height + 1,
        leftValueX + 20,
        line2Height + 1,
      );
      //#endregion

      //#region Line 25-33 (Meter Details in 2 columns with dynamic numbering)
      const meterDetails = [
        {
          label: "Transformer Code",
          value: scoDets.installedTransformerCapacity
            ? scoDets.installedTransformerCapacity.toString()
            : "",
        },
        {
          label: "Transformer Reference No",
          value: scoDets.transformerRefNo
            ? scoDets.transformerRefNo.toString()
            : "",
        },
        {
          label: "Meter Id",
          value: scoDets.meterId ? scoDets.meterId.toString() : "",
        },
        {
          label: "Meter Serial Number",
          value: scoDets.meterNo ? scoDets.meterNo.toString() : "",
        },
        {
          label: "Location Code",
          value: scoDets.locationCode ? scoDets.locationCode.toString() : "",
        },
        {
          label: "Meter Code",
          value: scoDets.meterCode1 ? scoDets.meterCode1.toString() : "",
        },
        {
          label: "Manufacturer Code",
          value: scoDets.manufacturerCode
            ? scoDets.manufacturerCode.toString()
            : "",
        },
        {
          label: "Multiplying Factor",
          value: scoDets.multiplyingFactor
            ? scoDets.multiplyingFactor.toString()
            : "1",
        },
        {
          label: "Meter Range",
          value: scoDets.meterRange ? scoDets.meterRange.toString() : "",
        },
        {
          label: "Meter Reading",
          value: scoDets.meterReading ? scoDets.meterReading.toString() : "",
        },
      ];

      // Always show these meter details rows; when value missing, display '-'
      const visibleMeterDetails = meterDetails;

      let meterSerial = 23;
      const detailLeftLabelX = padding;
      const detailLeftValueX = 56;
      const detailRightLabelX = 108;
      const detailRightValueX = 186;

      const drawMeterPair = (leftItem, rightItem = null) => {
        if (!leftItem) {
          return;
        }

        line2Height = line2Height + lineHeightIncreament;

        const leftLabel = `${meterSerial}. ${leftItem.label}: `;
        meterSerial += 1;
        const leftPrint = hasDisplayValue(leftItem.value)
          ? leftItem.value
          : "-";
        doc.text(leftLabel, detailLeftLabelX, line2Height);
        doc.text(leftPrint, detailLeftValueX, line2Height);
        doc.line(
          detailLeftValueX - 1,
          line2Height + 1,
          detailLeftValueX + 20,
          line2Height + 1,
        );

        if (rightItem) {
          const rightLabel = `${meterSerial}. ${rightItem.label}: `;
          meterSerial += 1;
          const rightPrint = hasDisplayValue(rightItem.value)
            ? rightItem.value
            : "-";
          doc.text(rightLabel, detailRightLabelX, line2Height);
          doc.text(rightPrint, detailRightValueX, line2Height);
          doc.line(
            detailRightValueX - 1,
            line2Height + 1,
            detailRightValueX + 14,
            line2Height + 1,
          );
        }
      };

      for (let i = 0; i < visibleMeterDetails.length; i += 2) {
        drawMeterPair(visibleMeterDetails[i], visibleMeterDetails[i + 1]);
      }
      //#endregion

      //#region Line 34
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        "Note: Where sets are more than one give information (21 to 28) of remaining set on reverse.",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        },
      );
      //#endregion

      //#region Line 35
      continueOnNewPageIfNeeded(12);
      var line2Height = line2Height + lineHeightIncreament;
      var text1 = `${meterSerial}. Date of Connection: `;
      var text2 = scoDets.dateOfConnection
        ? convertDate(scoDets.dateOfConnection)
        : "-";
      // Increment meterSerial since we've consumed this number
      meterSerial += 1;
      var text3 = "Cp-79 item No.: ";
      var text4 = scoDets.cp78ItemNo ? scoDets.cp78ItemNo.toString() : "-";
      var leftLabelX = padding;
      var leftValueX = 64;
      var rightLabelX = 132;
      var rightValueX = 176;

      doc.text(text1, leftLabelX, line2Height);
      doc.text(text2, leftValueX, line2Height);
      doc.line(
        leftValueX - 1,
        line2Height + 1,
        leftValueX + 22,
        line2Height + 1,
      );

      doc.text(text3, rightLabelX, line2Height);
      doc.text(text4, rightValueX, line2Height);
      doc.line(
        rightValueX - 1,
        line2Height + 1,
        rightValueX + 20,
        line2Height + 1,
      );
      //#endregion

      // //#region Line 36 // Removed by Shafiq sb
      // var line2Height = line2Height + lineHeightIncreament
      // var lineSpace = 10
      // var leftSpace = 35
      // var text1 = '30. Meter Rent: '
      // var text2 = dnDets.meterRent ? numberFormatting(dnDets.meterRent) : '-'
      // var text3 = 'Service Rent: '
      // var text4 = dnDets.serviceRent ? numberFormatting(dnDets.serviceRent) : '-'
      // var text5 = scoDets.tieUpNonTieUp ? scoDets.tieUpNonTieUp === 0 ? 'Non-Tie Up' : 'Tie Up' : '-'

      // doc.text(text1, padding, line2Height);
      // doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      // doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

      // doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
      // doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
      // doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);

      // doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (leftSpace * 2) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
      // //#endregion

      //#region Line 37
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 =
        "34. Signature of Consumer in Token of Installation of Connection: ____________________________________________________ ";

      doc.text(text1, padding, line2Height);
      //#endregion

      //#region Line 38
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 =
        "35. Signature of Consumer in Token of Receipt of Meter Reading Card: ________________________________________________ ";

      doc.text(text1, padding, line2Height);
      //#endregion

      //#region Line 39
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "36. Seal on the meter: ";
      var text2 = scoDets.sealOnMeter ? scoDets.sealOnMeter : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 40
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "37. Seal on the box: ";
      var text2 = scoDets.sealOnBox ? scoDets.sealOnBox : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 41
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "34-A. Security Slip / Price Bond No.: ";
      var text2 = scoDets.securitySlipOrPriceBondNo
        ? scoDets.securitySlipOrPriceBondNo.toString()
        : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 42
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "38. Connection Installed By: ";
      var text2 = scoDets.connectionInstallerName
        ? scoDets.connectionInstallerName
        : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 43
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "Signature: __________________________";
      var leftSpace = 122;

      doc.text(text1, padding + leftSpace, line2Height);
      //#endregion

      //#region Line 44
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "Designation: ________________________";
      var leftSpace = 122;

      doc.text(text1, padding + leftSpace, line2Height);
      //#endregion

      //#region Line 45
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "Stamp: ____________________________";
      var leftSpace = 122;

      doc.text(text1, padding + leftSpace, line2Height);
      //#endregion

      //#region Line 46
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 10;
      var text1 = "UserName: ";

      doc.text(text1, padding, line2Height);
      doc.text(userId, padding + doc.getTextWidth(text1), line2Height);
      //#endregion

      //#endregion

      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(DiscoCode),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight(),
        );
      }

      const pdfBlob = doc.output("blob");
      const pdfDataUrl = URL.createObjectURL(pdfBlob);

      // Open the PDF in a new tab
      window.open(pdfDataUrl, "_blank");
    } catch (e) {
      console.log("Unable to generate Master Data Form!", e);
    }
    setViewBackdrop(false);
  };

  const downloadMasterData = async (application) => {
    setViewBackdrop(true);
    const applicationId = application.applicationId;
    let DiscoCode = application.companyCode.toString();
    if (!application.subDivisionCode) {
      try {
        application = await SearchIndividualApplication(
          token,
          application.applicationId,
          "1"
        );
      } catch (e) {
        console.log(e, "Error getting application info");
      }
    }

    try {
      let dnDets, boqItems, scoDets, masterDataFormDets;

      await callAsyncDnDetailsAPI(applicationId).then((response) => {
        dnDets = response.dnDets;
        boqItems = response.boqItems;
      });

      await callAsyncGetSCOAPI(applicationId).then((response) => {
        scoDets = response;
      });

      await callAsyncGetCP136API(applicationId).then((response) => {
        masterDataFormDets = response;
      });

      //#region text
      const doc = new jsPDF({ compressPdf: true });
      doc.setFontSize(10);
      doc.text(
        "MASTER DATA ADDITION / CHANGE FORM",
        doc.internal.pageSize.getWidth() / 2,
        10,
        {
          align: "center",
        }
      );
      doc.text(
        application.connectionType != "Domestic" &&
          application.connectionType != "Commercial"
          ? "(For MDI Consumer Only)"
          : "(For General Consumer Only)",
        doc.internal.pageSize.getWidth() / 2,
        15,
        {
          align: "center",
        }
      );
      doc.setFontSize(8);
      doc.text(
        "Name & Address of Consumer",
        doc.internal.pageSize.getWidth() / 2,
        100,
        {
          align: "center",
        }
      );
      doc.setFontSize(8);
      doc.text("Meter Information", doc.internal.pageSize.getWidth() / 2, 140, {
        align: "center",
      });
      if (phase != "Single Phase" && phase != "3 Phase") {
        doc.text(
          "Reading Information",
          doc.internal.pageSize.getWidth() / 2,
          180,
          {
            align: "center",
          }
        );
      }
      doc.setFontSize(8);
      doc.text("Reason: New Connection", 20, 240, {});
      //#endregion

      // Set default properties for the table
      const tableProps1 = {
        margin: { top: 20, right: 20, bottom: 20, left: 20 },
        cellHeight: 10,
        headerColor: "#000",
        rowColors: ["#EEE", "#FFF"],
        lineWidth: 0.1,
        lineColor: "#000", // Solid black border color
        headStyles: {
          fillColor: "#FFF",
          textColor: "#000",
          lineWidth: 0.1,
          halign: "center",
          valign: "middle",
          fontSize: 7,
        },
        styles: {
          fontSize: 7,
          fontStyle: "normal",
        },
      };

      // const header = [[{ colSpan: 3, content: 'Reference Number' }, { rowSpan: 2, content: 'Sub Batch' }, { rowSpan: 2, content: 'Tariff Code' }, { colSpan: 2, content: 'Application Registration' }, { colSpan: 2, content: 'Security Deposit' }]];

      const header1 = [
        [
          { colSpan: 3, content: ["Reference Number"] },
          { colSpan: 1, rowSpan: 2, content: ["Sub Batch"] },
          { rowSpan: 2, content: ["Tariff Code"] },
          { colSpan: 2, content: "Application Registration" },
          { colSpan: 2, content: "Security Deposit" },
        ],
      ];

      const data1 = [
        [
          "Batch #",
          "Sub Div.",
          "Account Number",
          "",
          "",
          "Number",
          "Date",
          "Amount",
          "Date",
        ],
        [
          dnDets.batchNo ? dnDets.batchNo : "-",
          application.subDivisionCode
            ? application.subDivisionCode.toString()
            : "-",
          dnDets.consumerAccountNo ? dnDets.consumerAccountNo.toString() : "-",
          scoDets.subBatch ? scoDets.subBatch.toString() : "-",
          dnDets.tariff ? dnDets.tariff.toString().slice(0, 7) : "-",
          dnDets.tariff
            ? dnDets.tariff
              .toString()
              .slice(0, 1)
              .concat(application.applicationId.slice(4))
            : "-",
          application.creationDate
            ? convertDate(application.creationDate)
            : "-",
          dnDets.securityDepositeAmount
            ? numberFormatting(dnDets.securityDepositeAmount)
            : "-",
          dnDets.issueDate ? convertDate(dnDets.issueDate) : "-",
        ],
      ];

      doc.autoTable({
        startY: 20,
        head: header1,
        body: data1,
        theme: "grid",
        ...tableProps1,
      });

      // Set default properties for the table
      const tableProps2 = {
        margin: { top: 20, right: 20, bottom: 20, left: 20 },
        cellHeight: 10,
        headerColor: "#000",
        rowColors: ["#EEE", "#FFF"],
        lineWidth: 0.1,
        lineColor: "#000", // Solid black border color
        headStyles: {
          fillColor: "#FFF",
          textColor: "#000",
          lineWidth: 0.1,
          halign: "center",
          valign: "middle",
          fontSize: 7,
        },
        styles: {
          fontSize: 7,
          fontStyle: "normal",
        },
      };

      const header2 = [
        [
          { rowSpan: 2, content: ["Date of Connection"] },
          { rowSpan: 2, content: ["Sanctioned Load"] },
          { colSpan: 8, content: ["Codes"] },
        ],
      ];

      const data2 = [
        [
          "",
          "",
          "R/U",
          "F/P",
          "Seasonal",
          "Transformer Code",
          "Electricity Duty",
          "Government Department",
          "Standard Classification",
          "Income Tax",
        ],
        [
          scoDets.dateOfConnection,
          scoDets.senctionLoad,
          scoDets.urbanRural,
          scoDets.fataPata,
          scoDets.seasonalFlag,
          scoDets.installedTransformerCapacity,
          masterDataFormDets.electricityDuty,
          masterDataFormDets.governmentDepartment,
          masterDataFormDets.standardClassificationCode,
          masterDataFormDets.incomeTax,
        ],
      ];

      doc.autoTable({
        startY: 50,
        head: header2,
        body: data2,
        theme: "grid",
        ...tableProps2,
      });

      // Set default properties for the tables
      const tableProps3 = {
        margin: { top: 20, right: 20, bottom: 20, left: 20 },
        cellWidth: 30,
        cellHeight: 10,
        headerColor: "#000",
        rowColors: ["#EEE", "#FFF"],
        lineWidth: 0.1,
        lineColor: "#000", // Solid black border color
        headStyles: {
          fillColor: "#FFF",
          textColor: "#000",
          lineWidth: 0.1,
          halign: "center",
          valign: "middle",
          fontSize: 7,
        },
        styles: {
          fontSize: 7,
          fontStyle: "normal",
        },
      };

      const header3 = [["National Identity Card No."]];
      const data3 = [[application.applicantCNIC]];

      doc.autoTable({
        head: header3,
        startY: 80,
        body: data3,
        theme: "grid",
        tableWidth: 80,
        ...tableProps3,
      });

      // Set default properties for the tables
      const tableProps4 = {
        margin: { top: 20, right: 20, bottom: 20, left: 140 },
        align: "right",
        cellWidth: 30,
        cellHeight: 10,
        headerColor: "#000",
        rowColors: ["#EEE", "#FFF"],
        lineWidth: 0.1,
        lineColor: "#000", // Solid black border color
        headStyles: {
          fillColor: "#FFF",
          textColor: "#000",
          lineWidth: 0.1,
          halign: "center",
          valign: "middle",
          fontSize: 7,
        },
        styles: {
          fontSize: 7,
          fontStyle: "normal",
        },
      };

      const header4 = [["Store Requisition No.", "Date"]];
      const data4 = [
        [scoDets.storeRequisitionNo, convertDate(scoDets.scoCreationDate)],
      ];

      doc.autoTable({
        head: header4,
        startY: 80,
        body: data4,
        theme: "grid",
        tableWidth: 50,
        ...tableProps4,
      });

      // Set default properties for the table
      const tableProps5 = {
        margin: { top: 20, right: 20, bottom: 20, left: 20 },
        cellHeight: 10,
        cellWidth: 5,
        headerColor: "#000",
        rowColors: ["#EEE", "#FFF"],
        lineWidth: 0.1,
        lineColor: "#000", // Solid black border color
        headStyles: {
          fillColor: "#FFF",
          textColor: "#000",
          lineWidth: 0.1,
          halign: "center",
          valign: "middle",
          fontSize: 7,
        },
        styles: {
          fontSize: 7,
          fontStyle: "normal",
        },
      };

      const header5 = [
        ["Name", { colSpan: 3, content: [application.applicantName] }],
      ];

      const data5 = [
        ["Address", { colSpan: 3, content: [application.premisesAddress] }],
        [
          "Cell No.",
          application.applicantMobile,
          "Email Address",
          application.applicantEmail,
        ],
        [
          sodowo(application.applicantRelationType),
          application.applicantRelativeName
            ? application.applicantRelativeName
            : "-",
          "NTN",
          application.NTN ? application.NTN : "-",
        ],
      ];

      doc.autoTable({
        startY: 105,
        head: header5,
        body: data5,
        theme: "grid",
        ...tableProps5,
      });

      if (phase === "Single Phase") {
        // Set default properties for the table
        const tableProps6 = {
          margin: { top: 20, right: 20, bottom: 20, left: 20 },
          cellHeight: 10,
          cellWidth: [5, 10, 10, 10, 10, 10, 10],
          headerColor: "#000",
          rowColors: ["#EEE", "#FFF"],
          lineWidth: 0.1,
          lineColor: "#000", // Solid black border color
          headStyles: {
            fillColor: "#FFF",
            textColor: "#000",
            lineWidth: 0.1,
            halign: "center",
            valign: "middle",
            fontSize: 7,
          },
          styles: {
            fontSize: 7,
            fontStyle: "normal",
          },
        };
        const header6 = [
          [
            "Feeder Code",
            "Meter Number",
            "Location Code",
            "Manufacturer Code",
            "Meter Code",
            "Meter Range",
            "Initial Meter Reading",
          ],
        ];

        const data6 = [
          [
            scoDets.feederNo,
            scoDets.meterNo,
            scoDets.locationCode ? scoDets.locationCode : "-",
            scoDets.meterNo.slice(0, 2),
            scoDets.meterCode1 ? scoDets.meterCode1 : "-",
            scoDets.meterRange ? scoDets.meterRange : "-",
            scoDets.meterReading,
          ],
        ];

        doc.autoTable({
          startY: 145,
          head: header6,
          body: data6,
          theme: "grid",
          ...tableProps6,
        });
      } else if (phase === "3 Phase") {
        // Set default properties for the table
        const tableProps6 = {
          margin: { top: 20, right: 20, bottom: 20, left: 20 },
          cellHeight: 10,
          cellWidth: [5, 10, 10, 10, 10, 10, 10],
          headerColor: "#000",
          rowColors: ["#EEE", "#FFF"],
          lineWidth: 0.1,
          lineColor: "#000", // Solid black border color
          headStyles: {
            fillColor: "#FFF",
            textColor: "#000",
            lineWidth: 0.1,
            halign: "center",
            valign: "middle",
            fontSize: 7,
          },
          styles: {
            fontSize: 7,
            fontStyle: "normal",
          },
        };
        const header6 = [
          [
            { rowSpan: 2, content: ["Feeder Code"] },
            { rowSpan: 2, content: ["MSN"] },
            { rowSpan: 2, content: ["Location Code"] },
            { rowSpan: 2, content: ["Manufacturer Code"] },
            { colSpan: 2, content: ["Meter Code"] },
            { rowSpan: 2, content: ["Meter Range"] },
            { colSpan: 2, content: ["Initial Meter Reading (kWh)"] },
          ],
        ];

        const data6 = [
          ["", "", "", "", "Peak", "Off Peak", "", "Peak", "Off Peak"],
          [
            scoDets.feederNo,
            scoDets.meterNo,
            scoDets.locationCode ? scoDets.locationCode : "-",
            scoDets.meterNo.slice(0, 2),
            scoDets.meterCode1 ? scoDets.meterCode1 : "-",
            scoDets.meterCode2 ? scoDets.meterCode2 : "-",
            scoDets.meterRange ? scoDets.meterRange : "-",
            scoDets.threePhasePeak,
            scoDets.threePhaseOffPeak,
          ],
        ];

        doc.autoTable({
          startY: 145,
          head: header6,
          body: data6,
          theme: "grid",
          ...tableProps6,
        });
      } else {
        const tableProps6 = {
          margin: { top: 20, right: 20, bottom: 20, left: 20 },
          cellHeight: 10,
          cellWidth: [5, 10, 10, 10, 10, 10, 10],
          headerColor: "#000",
          rowColors: ["#EEE", "#FFF"],
          lineWidth: 0.1,
          lineColor: "#000", // Solid black border color
          headStyles: {
            fillColor: "#FFF",
            textColor: "#000",
            lineWidth: 0.1,
            halign: "center",
            valign: "middle",
            fontSize: 7,
          },
          styles: {
            fontSize: 7,
            fontStyle: "normal",
          },
        };

        const header6 = [
          [
            { rowSpan: 2, content: ["Feeder Code"] },
            { rowSpan: 2, content: ["MSN"] },
            { rowSpan: 2, content: ["Location Code"] },
            { rowSpan: 2, content: ["Manufacturer Code"] },
            { colSpan: 2, content: ["Meter Code"] },
            { rowSpan: 2, content: ["Meter Range"] },
          ],
        ];

        const data6 = [
          ["", "", "", "", "Peak", "Off Peak", ""],
          [
            scoDets.feederNo,
            scoDets.meterNo,
            scoDets.locationCode ? scoDets.locationCode : "-",
            scoDets.meterNo.slice(0, 2),
            scoDets.meterCode1 ? scoDets.meterCode1 : "-",
            scoDets.meterCode2 ? scoDets.meterCode2 : "-",
            scoDets.meterRange ? scoDets.meterRange : "-",
          ],
        ];

        doc.autoTable({
          startY: 145,
          head: header6,
          body: data6,
          theme: "grid",
          ...tableProps6,
        });

        const tableProps7 = {
          margin: { top: 20, right: 20, bottom: 20, left: 20 },
          cellHeight: 10,
          cellWidth: [5, 10, 10, 10, 10, 10, 10],
          headerColor: "#000",
          rowColors: ["#EEE", "#FFF"],
          lineWidth: 0.1,
          lineColor: "#000", // Solid black border color
          headStyles: {
            fillColor: "#FFF",
            textColor: "#000",
            lineWidth: 0.1,
            halign: "center",
            valign: "middle",
            fontSize: 7,
          },
          styles: {
            fontSize: 7,
            fontStyle: "normal",
          },
        };

        const header7 = [
          [
            { colSpan: 2, content: ["kWh"] },
            { colSpan: 2, content: ["kVARh"] },
            { rowSpan: 2, content: ["MDI"] },
            { rowSpan: 2, content: ["No. of MDI Resets"] },
            { rowSpan: 2, content: ["Multiplying Factor"] },
          ],
        ];

        const data7 = [
          ["Peak", "Off Peak", "Peak", "Off Peak", "", "", ""],
          [
            scoDets.threePhasePeakKWH,
            scoDets.threePhaseOffPeakKWH,
            scoDets.threePhasePeakKVARH,
            scoDets.threePhaseOffPeakKVARH,
            scoDets.mdi,
            scoDets.noOfMDIreset,
            scoDets.multiplyingFactor
              ? scoDets.multiplyingFactor.toString()
              : "-",
          ],
        ];

        doc.autoTable({
          startY: 185,
          head: header7,
          body: data7,
          theme: "grid",
          ...tableProps7,
        });
      }

      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(DiscoCode),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight()
        );
      }
      const pdfBlob = doc.output("blob");
      const pdfDataUrl = URL.createObjectURL(pdfBlob);

      // Open the PDF in a new tab
      window.open(pdfDataUrl, "_blank");
    } catch (e) {
      console.log(e);
    }
    setViewBackdrop(false);
  };

  const downloadEFile = async (application) => {
    setViewBackdrop(true);
    let applicationId = application.applicationId;
    let DiscoCode = application.companyCode.toString();
    try {
      // Round off values without decimal points for E-File
      const formatAmount = (value) => {
        const num = Number(value) || 0;
        const rounded = Math.round(num);
        return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      };
      let eFileDataLocal = [];

      let phase = getTariffAndMeterType(
        application.appliedLoad,
        application.connectionType,
        application.seasonalNonSeasonal,
        allTariffList,
        application.applicationProgressId,
      );
      var formdata = new FormData();
      formdata.append("applicationId", applicationId);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "electricityNewConnection/getApplicationHist",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            let applicationCurrentState = result.applicationCurrentState[0];
            let applicationHistory = result.applicationHistory;

            if (applicationHistory === "No History Found") {
              applicationHistory = [];
            }

            applicationHistory = applicationHistory.filter((item) => {
              return item.lastModificationDate;
            });

            applicationHistory.push(applicationCurrentState);
            let sortedApplicationHistory = applicationHistory.sort((a, b) => {
              const dateA = new Date(a.lastModificationDate);
              const dateB = new Date(b.lastModificationDate);
              return dateB - dateA;
            });
            eFileDataLocal = sortedApplicationHistory;
          }
        })
        .catch((error) => console.log("Error in Efile Api"));

      let dnDets = {},
        boqItems = [],
        scoDets,
        masterDataFormDets,
        applicationDocs = null;
      let wiringTestReportDocument = "";
      if (application.applicationProgressId >= 1) {
        try {
          const myHeaders2 = new Headers();
          myHeaders2.append("Authorization", token);
          myHeaders2.append("Content-Type", "application/json");

          const raw2 = JSON.stringify({
            applicationId: applicationId,
          });

          const requestOptions2 = {
            method: "POST",
            headers: myHeaders2,
            body: raw2,
            redirect: "follow",
          };

          const resp = await fetch(
            cfpBaseUrl + "enc/getWiringTestReport",
            requestOptions2,
          );
          const resJson = await resp.json();
          if (
            resJson.status === "200" &&
            resJson.data &&
            resJson.data.length > 0
          ) {
            wiringTestReportDocument =
              resJson.data[0].wiringTestReportDocument || "";
          }
        } catch (err) {
          console.error("Error fetching wiring test report for efile", err);
        }
      }
      // let application = await filterNCApp(applicationId)

      await callAsyncGetDocumentsAPI(applicationId).then((response) => {
        applicationDocs = response;
      });

      const copyOfApplicantCNICFront = applicationDocs.copyOfApplicantCNICFront
        ? applicationDocs.copyOfApplicantCNICFront
        : "";
      const copyOfApplicantCNICBack = applicationDocs.copyOfApplicantCNICBack
        ? applicationDocs.copyOfApplicantCNICBack
        : "";
      const premisesDocument = applicationDocs.premisesDocument
        ? applicationDocs.premisesDocument
        : "";
      const scannedCopyOfNearByElectricityBill =
        applicationDocs.scannedCopyOfNearByElectricityBill
          ? applicationDocs.scannedCopyOfNearByElectricityBill
          : "";
      const anyOtherDocument = applicationDocs.anyOtherDocument
        ? applicationDocs.anyOtherDocument
        : "";
      const copyOfOwnerCNICFront = applicationDocs.copyOfOwnerCNICFront
        ? applicationDocs.copyOfOwnerCNICFront
        : "";
      const copyOfOwnerCNICBack = applicationDocs.copyOfOwnerCNICBack
        ? applicationDocs.copyOfOwnerCNICBack
        : "";
      const ownerNOC = applicationDocs.ownerNOC ? applicationDocs.ownerNOC : "";
      const resolutionFormDesc = applicationDocs.resolutionFormDesc
        ? applicationDocs.resolutionFormDesc
        : "";
      const certMemoDesc = applicationDocs.certMemoDesc
        ? applicationDocs.certMemoDesc
        : "";
      const certFormDesc = applicationDocs.certFormDesc
        ? applicationDocs.certFormDesc
        : "";

      if (application.applicationProgressId >= 4) {
        await callAsyncDnDetailsAPI(applicationId).then((response) => {
          dnDets = response.dnDets;
          console.log(dnDets, "response. response. response.");
          boqItems = response.boqItems;
        });
      }
      // console.log(boqItems, "sdakjdaskdasndsaklsdankdlnakldnklasnd")
      // if (application.applicationProgressId >= 6) {
      //   await callAsyncGetSCOAPI(applicationId)
      //     .then(response => {
      //       scoDets = response;
      //     });
      // }

      // if (application.applicationProgressId) {
      //   await callAsyncGetCP136API(applicationId)
      //     .then(response => {
      //       masterDataFormDets = response;
      //     });
      // }

      const doc = new jsPDF({ compressPdf: true });

      var pageWidth = doc.internal.pageSize.getWidth();
      var pageHeight = doc.internal.pageSize.getHeight();

      // Generate the barcode image using JsBarcode
      const barcodeCanvas = document.createElement("canvas");
      JsBarcode(barcodeCanvas, applicationId);

      // Convert the barcode image to data URL
      const barcodeDataURL = barcodeCanvas.toDataURL("image/png");
      var height = 10;
      var padding = 10;
      const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];

      const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
      const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
      // Get page width

      // Calculate X position to center the logo
      const logoX = (pageWidth - logoWidth) / 2;

      // Add the barcode image to the PDF document
      doc.addImage(barcodeDataURL, "PNG", 164, height, 40, 20); // Adjust the position and size of the barcode image
      doc.addImage(getLogo(DiscoCode), "PNG", logoX, 5, logoWidth, logoHeight);

      var increment = 15;
      height = height + increment;
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(
        getCompanies(DiscoCode),
        doc.internal.pageSize.getWidth() / 2,
        height,
        {
          align: "center",
        },
      );

      increment = 8;
      height = height + increment;
      doc.setFontSize(18);
      doc.text("E-Document", doc.internal.pageSize.getWidth() / 2, height, {
        align: "center",
      });

      height = height + increment;
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      var increment = 8;
      var height = height + increment;
      var leftMargin = 50;
      doc.text("Document Type: ", padding, height);
      doc.text("New Connection", padding + leftMargin, height);
      doc.text("Tracking Id:", padding + leftMargin + leftMargin, height);
      doc.text(
        applicationId,
        padding + leftMargin + leftMargin + leftMargin,
        height,
      );

      var increment = 6;
      var height = height + increment;
      doc.text("Application Status: ", padding, height);
      doc.text(
        statusFunc(
          application.applicationProgressId,
          application.objectionStatus,
        ),
        padding + leftMargin,
        height,
      );
      doc.text("Application Date:", padding + leftMargin + leftMargin, height);
      doc.text(
        convertDate(application.creationDate),
        padding + leftMargin + leftMargin + leftMargin,
        height,
      );

      var increment = 6;
      var height = height + increment;
      doc.text("Sub-Division: ", padding, height);
      doc.text(
        subdivisionName(parseInt(application.subDivisionCode), subDivisions),
        padding + leftMargin,
        height,
      );
      doc.text("Connection Type:", padding + leftMargin + leftMargin, height);
      doc.text(
        application.connectionType,
        padding + leftMargin + leftMargin + leftMargin,
        height,
      );

      var increment = 6;
      var height = height + increment;
      doc.text("Phase / Load: ", padding, height);
      doc.text(
        application.appliedLoad.toString(),
        padding + leftMargin,
        height,
      );
      doc.text("Connection Date:", padding + leftMargin + leftMargin, height);
      doc.text("-", padding + leftMargin + leftMargin + leftMargin, height);

      increment = 20;
      height = height + increment;
      var rectWidth = 195; // Width of the rectangle
      var rectHeight = 10; // Height of the rectangle

      // Calculate the coordinates for the rectangle
      var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
      doc.setFillColor(199, 199, 199);
      // Draw the rectangle
      doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");

      doc.setFont("helvetica", "bold");
      doc.text(
        "Applicant Particulars",
        doc.internal.pageSize.getWidth() / 2,
        height,
        {
          align: "center",
        },
      );

      increment = 6;
      var height = height + increment;
      // Get the page width and height

      var rectWidth = 195; // Width of the rectangle
      var rectHeight = 30; // Height of the rectangle

      // Calculate the coordinates for the rectangle
      var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
      // Draw the rectangle
      doc.rect(rectX, height - 2.5, rectWidth, rectHeight);

      doc.setFont("helvetica", "normal");
      increment = 6;
      var height = height + increment;
      var leftMargin = 70;
      var extraPadding = 5;
      doc.text("Applicant Name:", padding + extraPadding, height);
      doc.text(application.applicantName, padding + leftMargin, height);

      increment = 6;
      var height = height + increment;
      var leftMargin = 70;
      doc.text("CNIC No.:", padding + extraPadding, height);
      doc.text(application.applicantCNIC, padding + leftMargin, height);

      var height = height + increment;
      var leftMargin = 70;
      doc.text("Phone No.:", padding + extraPadding, height);
      doc.text(
        application.applicantMobile ? application.applicantMobile : "-",
        padding + leftMargin,
        height,
      );

      var height = height + increment;
      var leftMargin = 70;
      doc.text("Present Address:", padding + extraPadding, height);
      doc.text(application.premisesAddress, padding + leftMargin, height);

      increment = 20;
      height = height + increment;
      var rectWidth = 195;
      var rectHeight = 10;

      var rectX = (pageWidth - rectWidth) / 2;
      doc.setFillColor(199, 199, 199);

      doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
      doc.setFont("helvetica", "bold");
      doc.text(
        "Application Summary",
        doc.internal.pageSize.getWidth() / 2,
        height,
        {
          align: "center",
        },
      );

      doc.setFontSize(12);
      increment = 3.5;
      height = height + increment;

      var rectWidth = 195;
      var rectHeight = 122.5;
      var rectX = (pageWidth - rectWidth) / 2;

      doc.rect(rectX, height, rectWidth, rectHeight);

      const summaryTableProps = {
        margin: { left: rectX + 3, right: 10 },
        cellHeight: 10,
        headStyles: {
          fillColor: "#FFF",
          textColor: "#000",
          fontSize: 11,
          fontStyle: "bold",
          halign: "center",
          valign: "middle",
          lineWidth: 0,
        },
        styles: {
          fontSize: 11,
          fontStyle: "normal",
          halign: "center",
          valign: "middle",
          lineWidth: 0,
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          minCellHeight: 10,
        },
        alternateRowStyles: {
          fillColor: [235, 235, 235],
        },
        columnStyles: {
          0: { halign: "center" },
          1: { halign: "center" },
          2: { halign: "center" },
          3: { halign: "center" },
          4: { halign: "center" },
          5: { halign: "center" },
        },
      };

      const summaryData = [];

      // Sort the array by applicationProgressId in descending order (10, 9, 8, 7, 6, 5, 4, 4, 3, 2, 1)
      const sortedData = [...eFileDataLocal].sort(
        (a, b) => b.applicationProgressId - a.applicationProgressId,
      );

      // +1 for the manually added "Application Submitted" row
      let srNumber = sortedData.length + 1;

      for (let i = 0; i < sortedData.length; i++) {
        const row = sortedData[i];

        // Skip applicationProgressId 0 — we'll add "Application Submitted" manually at the end
        if (row.applicationProgressId === 0) {
          srNumber--;
          continue;
        }

        const stepProgressId = stepName(
          row.applicationProgressId,
          row.remarks,
          row.objectionStatus,
        );

        // If applicationProgressId is 1 and no objection, use "Application Submitted." as remarks
        const remarksToShow =
          row.applicationProgressId === 1 && row.objectionStatus !== 1
            ? "Application Submitted."
            : row.remarks;

        summaryData.push([
          srNumber.toString(),
          stepProgressId || "",
          row.lastModifiedBy,
          convertDatewithTimeWithoutSecond(row.lastModificationDate).slice(
            0,
            11,
          ),
          convertDatewithTimeWithoutSecond(row.lastModificationDate).slice(11),
          remarksToShow,
        ]);

        srNumber--;
      }

      // Add "Application Submitted" row at the end (same as popup Activity Log)
      summaryData.push([
        "1",
        "Application Submitted",
        application.submittedThrough !== "e-Operations"
          ? application.applicantName
          : sortedData.length > 0
            ? sortedData[0].createdBy
            : application.applicantName,
        convertDate(application.creationDate),
        convertDatewithTimeWithoutSecond(application.creationDate).slice(11),
        "Application Submitted.",
      ]);

      doc.autoTable({
        startY: height + 5,
        head: [["Sr.", "Step", "Processed By", "Date", "Time", "Remarks"]],
        body: summaryData,
        theme: "grid",
        ...summaryTableProps,
      });

      // Helper function to add page header
      const addPageHeader = (doc, DiscoCode, applicationId, documentTitle) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const padding = 10;
        const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
        const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
        const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
        const logoX = (pageWidth - logoWidth) / 2;

        let height = 10;

        // Add logo
        doc.addImage(
          getLogo(DiscoCode),
          "PNG",
          logoX,
          5,
          logoWidth,
          logoHeight,
        );

        // Add company name
        height += 15;
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
          align: "center",
        });

        // Add application ID
        height += 10;
        doc.setFont("helvetica", "normal");
        doc.text("Application Id: ", padding, height);
        doc.text(
          applicationId,
          padding + doc.getTextWidth("Application Id: "),
          height,
        );

        // Add document title with border
        height += 10;
        const rectWidth = 195;
        const rectHeight = 10;
        const rectX = (pageWidth - rectWidth) / 2;

        doc.setFillColor(199, 199, 199);
        doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
        doc.setFont("helvetica", "bold");
        doc.text(documentTitle, pageWidth / 2, height, { align: "center" });

        return height + 3.5; // Return the Y position where content should start
      };

      // Helper function to add document image/PDF with fixed dimensions
      const addDocumentContent = async (
        doc,
        documentData,
        startHeight,
        documentTitle,
      ) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;

        // Draw rectangle for document
        doc.rect(rectX, startHeight, rectWidth, rectHeight);

        const fileType = documentData.slice(0, 6);
        let extension = "";

        if (fileType === "data:i") {
          extension = documentData.slice(11, 15);
        } else if (fileType === "data:a") {
          extension = documentData.slice(17, 19);
        }

        // Fixed dimensions to fit within the border (with small padding)
        const cardWidth = 190;
        const cardHeight = 228;
        const xPos = (pageWidth - cardWidth) / 2;
        const yPos = startHeight + 3;

        if (extension.startsWith("jp")) {
          doc.addImage(documentData, "jpeg", xPos, yPos, cardWidth, cardHeight);
        } else if (extension.startsWith("pn")) {
          doc.addImage(documentData, "png", xPos, yPos, cardWidth, cardHeight);
        } else if (extension.startsWith("pd")) {
          await addPdfasImage(
            documentData,
            rectX,
            startHeight,
            rectWidth,
            rectHeight,
            documentTitle,
          );
        }
      };

      // Helper function to add CNIC images with fixed size to fit in border
      const addCNICImage = (
        doc,
        cnicData,
        startHeight,
        containerHeight = 234,
      ) => {
        const pageWidth = doc.internal.pageSize.getWidth();

        // Fixed CNIC dimensions to fit nicely in the container
        const cardWidth = 150;
        const cardHeight = 95;
        const xPos = (pageWidth - cardWidth) / 2;

        // Center vertically within the container
        const yPos = startHeight + (containerHeight - cardHeight) / 2;

        const fileType = cnicData.slice(0, 6);
        let extension = "";

        if (fileType === "data:i") {
          extension = cnicData.slice(11, 15);
        } else if (fileType === "data:a") {
          extension = cnicData.slice(17, 19);
        }

        if (extension.startsWith("jp")) {
          doc.addImage(cnicData, "jpeg", xPos, yPos, cardWidth, cardHeight);
        } else if (extension.startsWith("pn")) {
          doc.addImage(cnicData, "png", xPos, yPos, cardWidth, cardHeight);
        }

        return yPos + cardHeight;
      };

      const addPdfasImage = async (
        pdfInBase64,
        rectX,
        rectY,
        rectWidth,
        rectHeight,
        documentTitle,
      ) => {
        let base64ImagesArray = [];

        try {
          if (!window.pdfjsLib) {
            await new Promise((resolve, reject) => {
              const script = document.createElement("script");
              script.src =
                "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.379/pdf.min.mjs";
              script.type = "module";
              script.onload = () => {
                setTimeout(resolve, 100);
              };
              script.onerror = reject;
              document.head.appendChild(script);
            });
          }

          const pdfjsLib = window.pdfjsLib;
          pdfjsLib.GlobalWorkerOptions.workerSrc =
            "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.379/pdf.worker.min.mjs";

          const pdfData = atob(pdfInBase64.split(",")[1]);
          const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
          const docPageNumbers = pdf.numPages;

          const renderPageToBase64 = async (pageNumber) => {
            try {
              const pdfPage = await pdf.getPage(pageNumber);
              const scale = 1.5;
              const viewport = pdfPage.getViewport({ scale });
              const canvas = document.createElement("canvas");
              const canvasContext = canvas.getContext("2d");
              canvas.width = viewport.width;
              canvas.height = viewport.height;
              await pdfPage.render({ canvasContext, viewport }).promise;
              const imageDataUrl = canvas.toDataURL("image/png");
              return imageDataUrl;
            } catch (error) {
              console.error("Error rendering PDF page:", error);
              return null;
            }
          };

          for (let i = 1; i <= docPageNumbers; i++) {
            const imageDataUrl = await renderPageToBase64(i);
            if (imageDataUrl) {
              base64ImagesArray.push(imageDataUrl);
            }
          }

          // Fixed dimensions to fit within border
          const cardWidth = 190;
          const cardHeight = 228;
          const xPos = (doc.internal.pageSize.getWidth() - cardWidth) / 2;
          const yPos = rectY + 3;

          base64ImagesArray.forEach((imageDataUrl, index) => {
            if (index > 0) {
              doc.addPage();
              // Add header for additional PDF pages using the caller's document title
              const continuedTitle = documentTitle
                ? `${documentTitle} (Continued)`
                : "Property Document (Continued)";
              const contentHeight = addPageHeader(
                doc,
                DiscoCode,
                applicationId,
                continuedTitle,
              );
              doc.rect(rectX, contentHeight, rectWidth, rectHeight);
              doc.addImage(
                imageDataUrl,
                "PNG",
                xPos,
                contentHeight + 3,
                cardWidth,
                cardHeight,
              );
            } else {
              doc.addImage(
                imageDataUrl,
                "PNG",
                xPos,
                yPos,
                cardWidth,
                cardHeight,
              );
            }
          });
        } catch (error) {
          console.error("Error loading PDF:", error);
          alert("Failed to process PDF document. Please try again.");
        }
      };

      // APPLICANT CNIC - Front on one page, Back on another
      if (copyOfApplicantCNICFront !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Applicant CNIC - Front",
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(
          doc,
          copyOfApplicantCNICFront,
          contentHeight,
          rectHeight,
        );
      }

      if (copyOfApplicantCNICBack !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Applicant CNIC - Back",
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(
          doc,
          copyOfApplicantCNICBack,
          contentHeight,
          rectHeight,
        );
      }

      // PREMISES DOCUMENT
      if (premisesDocument !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Property Document",
        );
        await addDocumentContent(
          doc,
          premisesDocument,
          contentHeight,
          "Property Document",
        );
      }

      // NEARBY ELECTRICITY BILL
      if (scannedCopyOfNearByElectricityBill !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Near By Bill",
        );
        await addDocumentContent(
          doc,
          scannedCopyOfNearByElectricityBill,
          contentHeight,
          "Near By Bill",
        );
      }

      // ANY OTHER DOCUMENT
      if (anyOtherDocument !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Any Other Document",
        );
        await addDocumentContent(
          doc,
          anyOtherDocument,
          contentHeight,
          "Any Other Document",
        );
      }

      // OWNER CNIC - Front on one page, Back on another
      if (copyOfOwnerCNICFront !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Owner's CNIC - Front",
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(
          doc,
          copyOfOwnerCNICFront,
          contentHeight,
          rectHeight,
        );
      }

      if (copyOfOwnerCNICBack !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Owner's CNIC - Back",
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(doc, copyOfOwnerCNICBack, contentHeight, rectHeight);
      }

      // OWNER NOC
      if (ownerNOC !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "NOC from Owner",
        );
        await addDocumentContent(
          doc,
          ownerNOC,
          contentHeight,
          "NOC from Owner",
        );
      }

      // RESOLUTION FORM
      if (resolutionFormDesc !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "BODs' Resolution Form",
        );
        await addDocumentContent(
          doc,
          resolutionFormDesc,
          contentHeight,
          "BODs' Resolution Form",
        );
      }

      // MEMORANDUM OF ASSOCIATION
      if (certMemoDesc !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Memorandum of Association",
        );
        await addDocumentContent(
          doc,
          certMemoDesc,
          contentHeight,
          "Memorandum of Association",
        );
      }

      // CERTIFIED FORM 29
      if (certFormDesc !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Certified Form 29",
        );
        await addDocumentContent(
          doc,
          certFormDesc,
          contentHeight,
          "Certified Form 29",
        );
      }

        // WIRING TEST REPORT - include after Any Other Document if available
      if (wiringTestReportDocument && wiringTestReportDocument !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Wiring Test Report",
        );
        await addDocumentContent(
          doc,
          wiringTestReportDocument,
          contentHeight,
          "Wiring Test Report",
        );
      }
      // SKETCH DIAGRAM (from DN) - include only when application progress > 3
      try {
        if (application.applicationProgressId > 3) {
          const sketchData =
            (dnDets && (dnDets.sketchDiagram || dnDets.sketchDiagramImage)) ||
            "";
          const isLiteralEmpty = /^\s*(?:undefined|null)\s*$/i.test(sketchData);
          if (sketchData && !isLiteralEmpty) {
            doc.addPage();
            let contentHeight = addPageHeader(
              doc,
              DiscoCode,
              applicationId,
              "Sketch Diagram",
            );
            console.log(
              "Adding sketchDiagram to E-File, length:",
              (sketchData && sketchData.length) || 0,
            );
              try {
              await addDocumentContent(
                doc,
                sketchData,
                contentHeight,
                "Sketch Diagram",
              );
            } catch (e) {
              console.error("Failed to add sketchDiagram to PDF:", e);
            }
          }
        }
      } catch (err) {
        console.error("Sketch diagram handling error:", err);
      }

      if (application.applicationProgressId >= 5) {
        //#region Paid Demand Notice Image

        var fontSize = 8;
        doc.setFontSize(fontSize);
        let paidDnImage = "";

        await callAsyncGetPaidDnImageAPI(applicationId).then((response) => {
          paidDnImage = response;
        });

        if (paidDnImage != "") {
          doc.addPage();
          var pageWidth = doc.internal.pageSize.getWidth();
          var pageHeight = doc.internal.pageSize.getHeight();
          // Convert the barcode image to data URL
          var height = 10;
          var padding = 10;
          const smallLogoCodes = [
            "12",
            "13",
            "11",
            "16",
            "26",
            "27",
            "48",
            "59",
          ];

          const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
          const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
          // Get page width

          // Calculate X position to center the logo
          const logoX = (pageWidth - logoWidth) / 2;
          // Add the barcode image to the PDF document
          doc.addImage(
            getLogo(DiscoCode),
            "PNG",
            logoX,
            5,
            logoWidth,
            logoHeight,
          );

          var increment = 15;
          height = height + increment;
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text(
            getCompanies(DiscoCode),
            doc.internal.pageSize.getWidth() / 2,
            height,
            {
              align: "center",
            },
          );

          var increment = 10;
          height = height + increment;
          let extension = paidDnImage.slice(11, 15);
          doc.text("Application Id: ", padding, height);
          doc.text(
            applicationId,
            padding + doc.getTextWidth("Application Id: "),
            height,
          );
          height = height + increment;

          var rectWidth = 195; // Width of the rectangle
          var rectHeight = 10; // Height of the rectangle

          // Calculate the coordinates for the rectangle
          var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
          doc.setFillColor(199, 199, 199);
          // Draw the rectangle
          doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
          doc.setFont("helvetica", "bold");
          doc.text(
            `Paid Demand Notice Image`,
            doc.internal.pageSize.getWidth() / 2,
            height,
            {
              align: "center",
            },
          );
          increment = 3.5;
          var height = height + increment;
          // Get the page width and height
          var rectWidth = 195; // Width of the rectangle
          var rectHeight = 234; // Height of the rectangle

          // Calculate the coordinates for the rectangle
          var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
          // Draw the rectangle
          doc.rect(rectX, height, rectWidth, rectHeight);
          height = height + increment;
          let cardWidth = 190;
          let cardHeight = 228;
          var xPos = (pageWidth - cardWidth) / 2;
          const isPdf = paidDnImage.startsWith("data:application/pdf");
          const isJpeg = paidDnImage.startsWith("data:image/jpeg");
          const isPng = paidDnImage.startsWith("data:image/png");
          if (isPdf) {
            // 🔹 Convert PDF → Image(s) and add to jsPDF
            await addPdfasImage(
              paidDnImage,
              rectX,
              height,
              rectWidth,
              rectHeight,
              "Paid Demand Notice Image",
            );
          } else if (isJpeg) {
            doc.addImage(
              paidDnImage,
              "JPEG",
              xPos,
              height,
              cardWidth,
              cardHeight,
            );
          } else if (isPng) {
            doc.addImage(
              paidDnImage,
              "PNG",
              xPos,
              height,
              cardWidth,
              cardHeight,
            );
          }
        }

        //#endregion
      }

      if (dnDets.approvedFlag == 1 && application.applicationProgressId > 4) {
        // if (application.applicationProgressId >= 4) {
        doc.addPage();
        //#region Demand Notice

        let officeCode = application.subDivisionCode.toString();
        let officeName = subdivisionName(parseInt(officeCode), subDivisions);
        let authorizedByName = dnDets.approvedBy ? dnDets.approvedBy : "---";
        let authorizedByDesignation = dnDets.approvedByDesignation
          ? dnDets.approvedByDesignation
          : "Role";
        let dateToPrint = dnDets.approvedDate ? dnDets.approvedDate : "---";
        let stampData = printStamp(
          officeCode,
          officeName,
          authorizedByName,
          authorizedByDesignation,
          dateToPrint,
        );

        var fontSize = 8;

        if (dnDets.approvedBy) {
          doc.addImage(stampData, "PNG", 20, 200, 55, 40);
          doc.addImage(stampData, "PNG", 140, 265, 55, 40);
        }

        if (dnDets.securityAmountQR && dnDets.capitalCostQR) {
          const securityAmountQR = dnDets.securityAmountQR;
          const capitalCostQR = dnDets.capitalCostQR;
          const securityQrCodeDataURL = await QRCode.toDataURL(
            securityAmountQR,
            {
              errorCorrectionLevel: "M",
              margin: 0,
              width: 120,
            },
          );
          const capitalCostQrCodeDataURL = await QRCode.toDataURL(
            capitalCostQR,
            {
              errorCorrectionLevel: "M",
              margin: 0,
              width: 120,
            },
          );
          doc.setFontSize(7);
          doc.setFont("helvetica", "bold");
          doc.setTextColor(0, 102, 204);
          doc.text("Scan QR for online payment", 178, 206, { align: "center" });
          doc.setTextColor(0, 0, 0);
          doc.setFont("helvetica", "normal");
          // doc.addImage(securityQrCodeDataURL, "PNG", 158, 208, 18, 18);
          // doc.addImage(capitalCostQrCodeDataURL, "PNG", 180, 208, 18, 18);
          doc.setFontSize(6.5);
          doc.setFont("helvetica", "bold");
          doc.text("Security", 167, 229, { align: "center" });
          doc.text("Capital Cost", 189, 229, { align: "center" });
          doc.setFont("helvetica", "normal");
        }

        var fontSize = 8;
        doc.setFontSize(fontSize);

        //#region Line 1
        var padding = 10;
        var line2Height = 10;
        var lineHeightIncreament = 5;
        doc.text(
          (!dnDets.demandNoteExpiryCount
            ? "Due Date: "
            : "Extended Due Date: ") + convertDate(dnDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.setFont("helvetica", "normal");
        doc.text(
          companyName(dnDets.connectionAccountNo.slice(2, 4)).concat(
            application.appliedLoad < 15
              ? "(" +
                  dnDets.connectionAccountNo.slice(2, 7) +
                  "-" +
                  subdivisionName(
                    parseInt(application.subDivisionCode),
                    subDivisions,
                  ) +
                  ")"
              : "(" +
                  dnDets.connectionAccountNo.slice(2, 6) +
                  "-" +
                  divisionName(
                    parseInt(application.divisionCode),
                    subDivisions,
                  ) +
                  ")",
          ),
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 2
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "(Department of Electricity)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 3
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 12;
        var text1 = "Demand Notice Serial No.: ";
        var text2 = dnDets.demandNoticeNo;
        var text3 = "Application Id: ";
        var text4 = applicationId;
        var text5 = "Apply Date: ";
        var text6 = convertDate(application.creationDate);

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 4
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 3.35;
        var text1 = "Demand Notice Issuance Date: ";
        var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        var text3 = "Application Type: ";
        var text4 = application.applicationType
          ? applicationName(application.applicationType)
          : "-";
        var text5 = "(New Connection, Reconnection etc.): ";
        var text6 = application.applicationType
          ? applicationName(application.applicationType)
          : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 5
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "New Allocated Reference No.: ";
        var text2 = dnDets.connectionAccountNo
          ? dnDets.connectionAccountNo
          : "-";
        var text3 = "Consumer Mobile No.: ";
        var text4 = dnDets.applicantMobile ? dnDets.applicantMobile : "-";
        var text5 = "Connection type: ";
        var text6 = dnDets.connectionType ? dnDets.connectionType : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 6
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 7;
        var text1 =
          "(under which the funds are to be deposited in the bank with the concerned officer of the department)";
        var text2 = "Type of Industry / Factory:";
        var text3 = dnDets.industryFactoryType
          ? dnDets.industryFactoryType
          : "-";

        doc.setFontSize(6);
        doc.text(text1, padding, line2Height);
        doc.setFontSize(fontSize);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            padding +
            lineSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text3) + lineSpace * 2),
          line2Height + 1,
        );

        //#endregion

        //#region Line 7
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 22.25;
        var text1 = `Department's approved Bank name: `;
        var text2 = dnDets.bankName ? dnDets.bankName : "-";
        var text3 = "Required Load(kW): ";
        var text4 = application.appliedLoad
          ? application.appliedLoad.toString()
          : "|";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 8
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 22;
        var text1 = `Department's Revenue Officer: `;
        var text2 = divisionName(
          parseInt(application.divisionCode),
          subDivisions,
        );
        var text3 = "Coverage Area: ";
        var text4 = dnDets.areaMarla ? dnDets.areaMarla : "|";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 9
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 16;
        var text1 = `Alloted Tariff : `;
        var text2 = dnDets.tariff ? dnDets.tariff : "-";
        var text3 = " ";
        var text4 = " ";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 10
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          "DEMAND NOTICE",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 11
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          "(Notification of Approval Application and Demand Under Guarantee)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 12
        var line2Height = line2Height + lineHeightIncreament;
        var originalFontSize = doc.getFontSize();
        if (
          application.appliedLoad < 5 &&
          dnDets.connectionAccountNo.slice(2, 4) == "15" &&
          dnDets.capitalCostAmount == "3100"
        ) {
          doc.setTextColor(255, 0, 0);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(9);

          doc.text("Meter Cost Excluded.", 160, line2Height - 1.5);
          doc.text("Obtain NOC to purchase.", 160, line2Height + 2.5);

          doc.setTextColor(0, 0, 0);
        }

        doc.setFontSize(fontSize);
        doc.setFont("helvetica", "normal");

        doc.text(
          `Applicant's part`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" },
        );
        //#endregion

        //#region Line 13
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 16;
        var text1 = `Mr. / Mrs.`;
        var relationType = application.applicantRelationType;
        var relationTypeText =
          relationType == 1 || relationType == "S/O"
            ? "S/O"
            : relationType == 2 || relationType == "D/O"
              ? "D/O"
              : relationType == 3 || relationType == "W/O"
                ? "W/O"
                : relationType == 4 || relationType == "C/O"
                  ? "C/O"
                  : "";
        var relativePart = application.applicantRelativeName
          ? ` ${relationTypeText} ${application.applicantRelativeName}`
          : "";
        var text2 = application.applicantName
          ? application.applicantName
              .concat(relativePart)
              .concat(" | ")
              .concat(application.premisesAddress)
          : "|";
        var text3 = ``;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.setFontSize(6);
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        //#endregion

        const totalServiceConnectionAmount =
          (parseInt(dnDets.capitalCostAmount) || 0) +
          // (!isNaN(parseInt(dnDets.amountOfGridSharing)) ? parseInt(dnDets.amountOfGridSharing) : 0) +
          // (!isNaN(parseInt(dnDets.amountOfFeederRehab)) ? parseInt(dnDets.amountOfFeederRehab) : 0) +
          (!isNaN(parseInt(dnDets.civilWorkCharges))
            ? parseInt(dnDets.civilWorkCharges)
            : 0) +
          (!isNaN(parseInt(dnDets.fixedChargesOfMetering))
            ? parseInt(dnDets.fixedChargesOfMetering)
            : 0) +
          (!isNaN(parseInt(dnDets.miscellaneousCharges))
            ? parseInt(dnDets.miscellaneousCharges)
            : 0) +
          (!isNaN(parseInt(dnDets.mtCharges))
            ? parseInt(dnDets.mtCharges)
            : 0) +
          (!isNaN(parseInt(dnDets.labourCharges))
            ? parseInt(dnDets.labourCharges)
            : 0) +
          (!isNaN(parseInt(dnDets.designVetteingFee))
            ? parseInt(dnDets.designVetteingFee)
            : 0) +
          (!isNaN(parseInt(dnDets.consultancyCharges))
            ? parseInt(dnDets.consultancyCharges)
            : 0) +
          (!isNaN(parseInt(dnDets.variationsCharges))
            ? parseInt(dnDets.variationsCharges)
            : 0) +
          (!isNaN(parseInt(dnDets.dismentalmentCharges))
            ? parseInt(dnDets.dismentalmentCharges)
            : 0) +
          (!isNaN(parseInt(dnDets.earthingCharges))
            ? parseInt(dnDets.earthingCharges)
            : 0);

        const totalServiceConnectionAmountForTotal =
          (parseInt(dnDets.capitalCostAmount) || 0) +
          (!isNaN(parseInt(dnDets.amountOfGridSharing))
            ? parseInt(dnDets.amountOfGridSharing)
            : 0) +
          (!isNaN(parseInt(dnDets.amountOfFeederRehab))
            ? parseInt(dnDets.amountOfFeederRehab)
            : 0) +
          (!isNaN(parseInt(dnDets.civilWorkCharges))
            ? parseInt(dnDets.civilWorkCharges)
            : 0) +
          (!isNaN(parseInt(dnDets.fixedChargesOfMetering))
            ? parseInt(dnDets.fixedChargesOfMetering)
            : 0) +
          (!isNaN(parseInt(dnDets.miscellaneousCharges))
            ? parseInt(dnDets.miscellaneousCharges)
            : 0) +
          (!isNaN(parseInt(dnDets.mtCharges))
            ? parseInt(dnDets.mtCharges)
            : 0) +
          (!isNaN(parseInt(dnDets.labourCharges))
            ? parseInt(dnDets.labourCharges)
            : 0) +
          (!isNaN(parseInt(dnDets.designVetteingFee))
            ? parseInt(dnDets.designVetteingFee)
            : 0) +
          (!isNaN(parseInt(dnDets.consultancyCharges))
            ? parseInt(dnDets.consultancyCharges)
            : 0) +
          (!isNaN(parseInt(dnDets.variationsCharges))
            ? parseInt(dnDets.variationsCharges)
            : 0) +
          (!isNaN(parseInt(dnDets.dismentalmentCharges))
            ? parseInt(dnDets.dismentalmentCharges)
            : 0) +
          (!isNaN(parseInt(dnDets.earthingCharges))
            ? parseInt(dnDets.earthingCharges)
            : 0);

        console.log(dnDets.capitalCostAmount, "dnDets.capitalCostAmount");
        console.log(dnDets.amountOfGridSharing, "dnDets.amountOfGridSharing");
        console.log(dnDets.amountOfFeederRehab, "dnDets.amountOfFeederRehab");
        console.log(dnDets.mtCharges, "dnDets.mtCharges");
        console.log(dnDets.labourCharges, "dnDets.labourCharges");
        console.log(dnDets.designVetteingFee, "dnDets.designVetteingFee");
        console.log(dnDets.consultancyCharges, "dnDets.consultancyCharges");
        console.log(dnDets.variationsCharges, "dnDets.variationsCharges");
        console.log(dnDets.dismentalmentCharges, "dnDets.dismentalmentCharges");
        console.log(dnDets.earthingCharges, "dnDets.earthingCharges");

        //#region Line 14
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var text1 = `You are hereby informed by demand notice that your application for obtaining electricity connection whose particulars are mentioned above has been approved by the authorized officer on the following conditions apart from the prevailing general conditions of electricity of the department.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 15
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `1. You should deposit the following amounts in the approved bank of the department or with the concerned officer of the department itself within [word1] days from the date of issue of this notice and inform my office with the receipt number and date of your payment.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[word1]", noOfDays);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 16
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `A. Expenditure service connection as per approved estimate ______________ and Security _______________ PKR. (this amount is to be deposited with the concerned officer of the department). If the charges are found to be more than the service approved estimate prior to connection, a deposit equal to the difference in the amount collected will be issued for which additional demand notice will be issued.`;
        var text2 = totalServiceConnectionAmount
          ? numberFormatting(totalServiceConnectionAmount)
          : "";
        var text3 = dnDets.securityDepositeAmount
          ? numberFormatting(dnDets.securityDepositeAmount)
          : "";
        var lines = doc.splitTextToSize(text1, maxWidth);
        doc.setFont("helvetica", "bold");
        doc.text(text2, 90, line2Height);
        doc.text(text3, 130, line2Height);
        doc.setFont("helvetica", "normal");
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace(
            "[capitalCost]",
            totalServiceConnectionAmount
              ? numberFormatting(totalServiceConnectionAmount)
              : "",
          );
          lineText = lineText.replace(
            "[securityCost]",
            dnDets.securityDepositeAmount
              ? numberFormatting(dnDets.securityDepositeAmount)
              : "",
          );
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }

        //#region Line 17
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `B. Arrears due to non-payment of previous electricity bills etc. _____ PKR. (this amount is to be deposited in the bank after receiving the final bill from the revenue officer).`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 18
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `NOTE: If you are an applicant or consumer of domestic, commercial, industrial wholesale supply, you should fill the demand notice in this regard on the sub-layer (reserved for your business) and affix your signature and date on it and send back to my office.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 19
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `2. You shall, within [noOfDays] days from the date of issue of this notice, obtain a test report from a Government approved wiring contractor in proof of the soundness and quality of the internal wiring of your building and the completion of the installation of your electrical appliances and send send to my office for further departmental inspection and testing and get receipt (Blank Test Report is on Form CP-7).`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[noOfDays]", noOfDays);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 20
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var amount = "_____";
        var text1 = `3. Since you have not provided your purchased meter to the department for measuring the supply of electricity, you will be charged a monthly meter rental fee of [amount] PKR.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[amount]", amount);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 21
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var amount = "_____";
        var text1 = `4. Demand notices for release of security deposit sent separately Process of connection will start after deposit of both demand notice amounts separate.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[amount]", amount);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 22
        doc.text(
          `(Irrelevant should be cut down)`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 23
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfMonth = "1";
        var text1 = `If you do not comply with the above conditions in response to the demand notice within the prescribed period, your application form for obtaining electricity will not be considered with the serial number allotted. Demand notices thereof ( [noOfMonth] month after the date of issue) shall automatically be deemed ineffective.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[noOfMonth]", noOfMonth);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 24
        doc.setFontSize(fontSize);
        var line24Y = line2Height;

        // var text1 = "Regards";
        // var spaceLeft = 100;
        // doc.text(text1, padding + spaceLeft, line24Y);

        if (
          application.appliedLoad < 5 &&
          dnDets.connectionAccountNo.slice(2, 4) == "15" &&
          dnDets.capitalCostAmount == "3100"
        ) {
          var originalFontSize = doc.getFontSize();

          doc.setTextColor(255, 0, 0);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(9);

          doc.text("Meter Cost Excluded.", 50, line24Y);

          doc.text("Obtain NOC to purchase.", 50, line24Y + 4);

          doc.setFont("helvetica", "normal");
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(originalFontSize);
        }
        //#endregion
        doc.setTextColor(220, 0, 0);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(24);
        doc.text(
          "NOT VALID FOR BANKS",
          doc.internal.pageSize.getWidth() / 2,
          145,
          {
            align: "center",
            angle: 320,
          },
        );
        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(fontSize);
        // //#region Line 25
        // doc.setFontSize(fontSize);
        // var line2Height = line2Height + lineHeightIncreament;
        // var text1 =
        //   application.appliedLoad < 15
        //     ? "Sub-Division Office " +
        //     applicationId.slice(3, 8) +
        //     "-" +
        //     subdivisionName(
        //       parseInt(application.subDivisionCode),
        //       subDivisions
        //     ) +
        //     " SDO " +
        //     companyShortName(DiscoCode)
        //     : "Division Office " +
        //     applicationId.slice(3, 7) +
        //     " - " +
        //     divisionName(parseInt(application.divisionCode), subDivisions) +
        //     " XEN " +
        //     companyShortName(DiscoCode);
        // doc.text(text1, padding + spaceLeft, line2Height);
        // //#endregion

        //#region Line 26
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var text1 = "Signature Bank Officer: ";
        var text2 =
          application.appliedLoad < 15
            ? "Line Superintendent Office" +
              "(" +
              applicationId.slice(3, 8) +
              " - " +
              subdivisionName(
                parseInt(application.subDivisionCode),
                subDivisions,
              ) +
              ") SDO " +
              companyShortName(DiscoCode)
            : "Line Superintendent Office" +
              "(" +
              applicationId.slice(3, 7) +
              " - " +
              divisionName(parseInt(application.divisionCode), subDivisions) +
              ") XEN " +
              companyShortName(DiscoCode);
        doc.text(text1, padding, line2Height);
        // doc.text(text2, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 27
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        spaceLeft = 10;
        var text1 =
          "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
        doc.text(text1, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 28
        lineHeightIncreament = 5;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          (!dnDets.demandNoteExpiryCount
            ? "Due Date: "
            : "Extended Due Date: ") + convertDate(dnDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          "For Bank Use Only",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 29
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "(The concerned bank will separate this layer from the demand notice and send it to the revenue officer along with its bank scroll)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 30
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 16;
        var spaceLeft = 50;

        var text1 = `1. Applicant's Name and Complete address `;
        var bankRelationType = application.applicantRelationType;
        var bankRelationTypeText =
          bankRelationType == 1 || bankRelationType == "S/O"
            ? "S/O"
            : bankRelationType == 2 || bankRelationType == "D/O"
              ? "D/O"
              : bankRelationType == 3 || bankRelationType == "W/O"
                ? "W/O"
                : bankRelationType == 4 || bankRelationType == "C/O"
                  ? "C/O"
                  : "";
        var bankRelativePart = application.applicantRelativeName
          ? ` ${bankRelationTypeText} ${application.applicantRelativeName}`
          : "";
        var text2 = application.applicantName
          ? application.applicantName
              .concat(bankRelativePart)
              .concat(" | ")
              .concat(application.premisesAddress)
          : "|";
        var text3 = ``;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.setFontSize(6);
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2 + spaceLeft),
          line2Height,
        );
        //#endregion

        //#region Line 31
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "2. Application Id: ";
        var text2 = application.applicationId ? application.applicationId : "-";
        var text3 = "Date: ";
        var text4 = application.creationDate
          ? convertDate(application.creationDate)
          : "-";
        var text5 = "1. Service Connection:";
        var text6 = totalServiceConnectionAmount
          ? numberFormatting(totalServiceConnectionAmount)
          : "-";
        var leftSpace = 40;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            leftSpace +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.setFont("helvetica", "bold");
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            leftSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2 +
            leftSpace,
          line2Height + 1,
        );
        //#endregion

        //#region Line 32
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "3. Demand Notice Serial No.: ";
        var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";
        var text3 = "Date: ";
        var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        var text5 = "2. Security: ";
        var text6 = dnDets.securityDepositeAmount
          ? numberFormatting(dnDets.securityDepositeAmount)
          : "-";
        var leftSpace = 35;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            leftSpace +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.setFont("helvetica", "bold");
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            leftSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2 +
            leftSpace,
          line2Height + 1,
        );
        //#endregion

        //#region Line 33
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "4. Account No. for acquisition connection: ";
        var text2 = dnDets.connectionAccountNo
          ? dnDets.connectionAccountNo
          : "-";
        var text3 = " ";
        var text4 = " ";
        var text5 = "3. Grid Share / Feeder Rehab. Charges:";
        var text6 = dnDets.amountOfGridSharing
          ? numberFormatting(dnDets.amountOfGridSharing)
              .concat(" / ")
              .concat(
                dnDets.amountOfFeederRehab
                  ? numberFormatting(dnDets.amountOfFeederRehab)
                  : "-",
              )
          : "-"
              .concat(" / ")
              .concat(
                dnDets.amountOfFeederRehab
                  ? numberFormatting(dnDets.amountOfFeederRehab)
                  : "-",
              );
        var leftSpace = 10;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        // doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
        // doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
        // doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            leftSpace +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            leftSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2 +
            leftSpace,
          line2Height + 1,
        );
        //#endregion

        //#region Line 34
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "5. Approved bank name and address:";
        var text2 = dnDets.bankName ? dnDets.bankName : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 35
        doc.setFontSize(fontSize);
        var line2Height =
          line2Height + lineHeightIncreament + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 =
          application.appliedLoad < 15
            ? "                                                                                 "
            : "                                                                                 ";
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = "Signature Bank Officer ";
        var bankOfficerX = doc.internal.pageSize.getWidth() - 125;
        doc.text(text1, padding, line2Height);
        doc.text(text6, bankOfficerX, line2Height);
        //#endregion

        //#region Line 36
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "                          ";
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = " ";
        var leftSpace = 10;
        doc.setFontSize(6);
        doc.text(text1, padding, line2Height);
        //#endregion

        //#region Line 37
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        spaceLeft = 0;
        // var text1 =
        //   "----------------------------------------------------------------------------------------------------------------------------";
        var text1 =
          "------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
        doc.text(text1, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 38
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          (!dnDets.demandNoteExpiryCount
            ? "Due Date: "
            : "Extended Due Date: ") + convertDate(dnDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          `Applicant's Response`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 39
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var text1 = `1. I/We have submitted the security amount of [securityCost] and service connection of [capitalCost] only in the department'a approved bank [bankName] by receipt no. _______ on date ________.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace(
            "[capitalCost]",
            numberFormatting(totalServiceConnectionAmount),
          );
          lineText = lineText.replace(
            "[securityCost]",
            numberFormatting(dnDets.securityDepositeAmount),
          );
          lineText = lineText.replace(
            "[bankName]",
            dnDets.bankName ? dnDets.bankName : "-",
          );
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 40
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `2. Since I/We did not provide funds to buy meter to the department, I am/We are responsible to pay monthly rent of ______ PKR as meter rent.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 41
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `3. I am/We are sending herewith demand notice, a certified list report from a government approved wiring contractor to prove that the internal wiring of my/our building is sound and of standard and that the installation of my/our utility equipment has been completed. I will send within the specified period.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 42
        lineHeightIncreament = 5;
        var line2Height = line2Height + lineHeightIncreament;

        var line42Y = line2Height;

        if (
          application.appliedLoad < 5 &&
          dnDets.connectionAccountNo.slice(2, 4) == "15" &&
          dnDets.capitalCostAmount == "3100"
        ) {
          var originalFontSize = doc.getFontSize();

          doc.setTextColor(255, 0, 0);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(9);

          doc.text("Meter Cost Excluded.", 30, line42Y);

          doc.text("Obtain NOC to purchase.", 30, line42Y + 4);

          doc.setFont("helvetica", "normal");
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(originalFontSize);
        }

        doc.text(
          `For Computer Center Use`,
          doc.internal.pageSize.getWidth() / 2,
          line42Y,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 43
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          `(Demand Notice Data)`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 44
        var line2Height = line2Height + lineHeightIncreament;
        var lineHeightIncreament = 5;
        var padding = 10;
        var lineSpace = 7.5;
        var text1 = "Demand Notice Serial No.: ";
        var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";
        var text3 = "Application Id: ";
        var text4 = applicationId ? applicationId : "-";
        var text5 = "Application Form No.: ";
        var text6 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 45
        var line2Height = line2Height + lineHeightIncreament;
        var lineHeightIncreament = 5;
        var padding = 10;
        var lineSpace = 7.5;
        var text1 = "Demand Notice Issuance Date: ";
        var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        var text3 = "Amount to be paid: ";
        var text4 =
          dnDets.capitalCostAmount || dnDets.securityDepositeAmount
            ? numberFormatting(
                totalServiceConnectionAmountForTotal +
                  parseInt(dnDets.securityDepositeAmount || 0),
              )
            : "-";
        var text5 = " ";
        var text6 = " ";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.setFont("helvetica", "bold");
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        //#endregion

        //#region Line 46
        doc.setFontSize(fontSize);
        var line2Height =
          line2Height + lineHeightIncreament + lineHeightIncreament / 2;
        var lineSpace = 6.6;
        var text1 = " ";
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = application.appliedLoad < 15 ? " " : " ";
        var leftSpace = 110;
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        //#endregion

        //#region Line 47
        doc.setFontSize(6);
        lineHeightIncreament = 2;
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 8;
        var text1 =
          "NOTE - Computer generated demand notice, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/appplicant. In case any document is found false at later stages,the said connection is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and campany reserved its rights to take legal action against owner/applicant. ";
        var lineSpace = 6.6;
        var lines = doc.splitTextToSize(text1, maxWidth);
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#endregion

        //#endregion
      }
      if (application.applicationProgressId >= 4) {
        if (boqItems.length >= 1) {
          doc.addPage();

          var pageWidth = doc.internal.pageSize.getWidth();
          var pageHeight = doc.internal.pageSize.getHeight();
          var height = 10;
          var padding = 10;
          const smallLogoCodes = [
            "12",
            "13",
            "11",
            "16",
            "26",
            "27",
            "48",
            "59",
          ];

          const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
          const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;

          const logoX = (pageWidth - logoWidth) / 2;
          doc.addImage(
            getLogo(DiscoCode),
            "PNG",
            logoX,
            5,
            logoWidth,
            logoHeight,
          );

          var increment = 15;
          height += increment;
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
            align: "center",
          });

          increment = 10;
          height += increment;
          doc.setFontSize(11);
          doc.text("Application Id:", padding, height);
          doc.text(applicationId || "-", padding + 40, height);
          doc.text("Name:", pageWidth / 2 + 5, height);
          doc.text(
            application?.applicantName || "-",
            pageWidth / 2 + 25,
            height,
          );
          height += increment;

          // Draw header rectangle
          var rectWidth = 195;
          var rectHeight = 10;
          var rectX = (pageWidth - rectWidth) / 2;
          doc.setFillColor(199, 199, 199);
          doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
          doc.setFont("helvetica", "bold");
          doc.text("Items List", pageWidth / 2, height, { align: "center" });

          height += 3.5;
          rectHeight = 230;
          doc.rect(rectX, height, rectWidth, rectHeight);

          // Table setup
          const boqTableProps = {
            margin: { top: 0, right: 20, bottom: 20, left: 20 },
            cellHeight: 10,
            headerColor: "#000",
            rowColors: ["#EEE", "#FFF"],
            lineWidth: 1,
            lineColor: "#000",
            headStyles: {
              fillColor: "#FFF",
              textColor: "#000",
              fontSize: 11,
              fontStyle: "bold",
              halign: "left",
              valign: "middle",
            },
            styles: {
              fontSize: 11,
              fontStyle: "normal",
              lineWidth: 0,
              lineColor: [0, 0, 0],
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
            },
            alternateRowStyles: { fillColor: [235, 235, 235] },
          };

          const boqHeaders = [["Sr.", "Item Name", "Unit", "Qty", "Amount"]];
          const boqData = [];
          let itemsTotal = 0;
          const materialsList = await callMaterials(applicationId, token);
          for (let i = 0; i < boqItems.length; i++) {
            const rowData = boqItems[i];

            // Match BOQ item with material list using item_Code
            const item = materialsList.find(
              (mat) => String(mat.item_Code) === String(rowData.itemCode),
            );
            if (!item) {
              console.warn(
                `No matching item found for itemCode: ${rowData.itemCode}`,
              );
              continue; // skip this row
            }

            const serialNo = i + 1;
            const itemName = item.item_Name;
            const unit = item.item_Unit ? item.item_Unit : "-";
            const qty = rowData.qty ? numberFormatting(rowData.qty) : "-";
            const rate = rowData.qty
              ? numberFormatting(rowData.itemAmount / rowData.qty)
              : "-";
            const amount = rowData.itemAmount
              ? numberFormatting(rowData.itemAmount)
              : "-";
            itemsTotal += rowData.itemAmount;

            const row = [serialNo.toString(), itemName, unit, qty, amount];
            boqData.push(row);
          }

          // Generate PDF table
          doc.autoTable({
            startY: 50,
            head: boqHeaders,
            body: boqData,
            theme: "grid",
            ...boqTableProps,
          });

          // Add page for Service Cost Estimate
          doc.addPage();
          height = 10;
          doc.addImage(
            getLogo(DiscoCode),
            "PNG",
            logoX,
            5,
            logoWidth,
            logoHeight,
          );

          increment = 15;
          height += increment;
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
            align: "center",
          });

          increment = 10;
          height += increment;
          doc.text("Application Id: ", padding, height);
          doc.text(
            applicationId,
            padding + doc.getTextWidth("Application Id: "),
            height,
          );
          height += increment;

          // Header for Service Cost Estimate
          rectWidth = 195;
          rectHeight = 10;
          rectX = (pageWidth - rectWidth) / 2;
          doc.setFillColor(199, 199, 199);
          doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
          doc.setFont("helvetica", "bold");
          doc.text("Service Cost Estimate", pageWidth / 2, height, {
            align: "center",
          });

          height += 10;

          const itemsTotalValue = Number(itemsTotal) || 0;
          const roundedItemsTotal = Math.round(itemsTotalValue);
          const isCase13 = String(applicationId || "")
            .toUpperCase()
            .startsWith("NC-13");
          const storeCharges = isCase13
            ? 0
            : Math.floor((roundedItemsTotal * 12 + 50) / 100);
          const installationCharges = Math.floor(
            ((roundedItemsTotal + storeCharges) * 8 + 50) / 100,
          );
          const gridSharing = Number(dnDets.amountOfGridSharing) || 0;
          const feederRehab = Number(dnDets.amountOfFeederRehab) || 0;
          const civilWork = Number(dnDets.civilWorkCharges) || 0;
          const miscCharges = Number(dnDets.miscellaneousCharges) || 0;
          const mtCharges = Number(dnDets.mtCharges) || 0;
          const labourCharges = Number(dnDets.labourCharges) || 0;
          const metering = Number(dnDets.fixedChargesOfMetering) || 0;
          const designVettingFee = Number(dnDets.designVetteingFee) || 0;
          const consultancyCharges = Number(dnDets.consultancyCharges) || 0;
          const variationCharges = Number(dnDets.variationsCharges) || 0;
          const dismantlementCharges = Number(dnDets.dismentalmentCharges) || 0;
          const earthingCharges = Number(dnDets.earthingCharges) || 0;
          const lessCost = Number(dnDets.lessTheCost) || 0;
          const securityDeposit = Number(dnDets.securityDepositeAmount) || 0;

          const subtotalA = roundedItemsTotal + storeCharges;
          const subtotalB = installationCharges + gridSharing + feederRehab;
          const subtotalC = civilWork + miscCharges + mtCharges + labourCharges;
          const subtotalD =
            metering +
            designVettingFee +
            consultancyCharges +
            variationCharges +
            dismantlementCharges +
            earthingCharges;
          const grossTotal = subtotalA + subtotalB + subtotalC + subtotalD;
          const netTotal = grossTotal - lessCost;
          const grandTotal = netTotal + securityDeposit;

          const rightX = pageWidth - 15;

          const drawSectionHeader = (title) => {
            doc.setFillColor(225, 225, 225);
            doc.rect(padding, height - 5.5, pageWidth - padding * 2, 8, "F");
            doc.setFont("helvetica", "bold");
            doc.setFontSize(11);
            doc.setTextColor(45, 66, 89);
            doc.text(title, padding + 3, height);
            doc.setTextColor(0, 0, 0);
            height += 8;
          };

          const drawItemRow = (label, value, options = {}) => {
            doc.setFont("helvetica", options.bold ? "bold" : "normal");
            doc.setFontSize(11);

            if (options.green) {
              doc.setTextColor(0, 120, 0);
            }
            if (options.red) {
              doc.setTextColor(170, 0, 0);
            }

            doc.text(label, padding + 12, height);
            doc.text(`${formatAmount(value)} /-`, rightX, height, {
              align: "right",
            });

            if (!options.noLine) {
              doc.setDrawColor(180, 180, 180);
              doc.setLineDashPattern([1, 1], 0);
              doc.line(padding + 70, height - 1, rightX - 2, height - 1);
              doc.setLineDashPattern([], 0);
            }

            doc.setTextColor(0, 0, 0);
            height += 8;
          };

          const drawRule = () => {
            doc.setDrawColor(140, 140, 140);
            doc.line(padding, height - 4, pageWidth - padding, height - 4);
          };

          drawSectionHeader("A. Material & Store Cost");
          drawItemRow("Items Total Amount", roundedItemsTotal);
          drawItemRow(
            isCase13 ? "Store Charges (0%)" : "Store Charges (12%)",
            storeCharges,
          );
          drawItemRow("Subtotal (A)", subtotalA, { bold: true, noLine: true });
          drawRule();

          drawSectionHeader("B. Installation & Technical Cost");
          drawItemRow("Installation Charges (8%)", installationCharges);
          drawItemRow("Grid Sharing Cost", gridSharing);
          drawItemRow("Feeder Rehab Charges", feederRehab);
          drawItemRow("Subtotal (B)", subtotalB, { bold: true, noLine: true });
          drawRule();

          drawSectionHeader("C. Civil & Miscellaneous");
          drawItemRow("Civil Work Charges", civilWork);
          drawItemRow("Misc. Charges", miscCharges);
          drawItemRow("MNT Charges", mtCharges);
          drawItemRow("Labour Charges", labourCharges);
          drawItemRow("Subtotal (C)", subtotalC, { bold: true, noLine: true });
          drawRule();

          drawSectionHeader("D. Other Charges");
          drawItemRow("Fixed Charges Of Metering", metering);
          drawItemRow("Design Vetting Fee", designVettingFee);
          drawItemRow("Consultancy Charges", consultancyCharges);
          drawItemRow("Variation Charges", variationCharges);
          drawItemRow("Dismantlement Charges", dismantlementCharges);
          drawItemRow("Earthing Charges", earthingCharges);
          drawItemRow("Subtotal (D)", subtotalD, { bold: true, noLine: true });

          height += 1;
          doc.setFillColor(232, 232, 232);
          doc.rect(padding, height - 5.5, pageWidth - padding * 2, 8, "F");
          drawItemRow("Gross Total (A+B+C+D)", grossTotal, {
            bold: true,
            noLine: true,
          });

          const lessLabelX = padding + 3;
          doc.setFont("helvetica", "bold");
          doc.setTextColor(170, 0, 0);
          doc.text("Less:", lessLabelX, height);
          doc.setTextColor(0, 0, 0);
          doc.text(
            "Cost Adjustment",
            lessLabelX + doc.getTextWidth("Less: "),
            height,
          );
          doc.text(`${formatAmount(lessCost)} /-`, rightX, height, {
            align: "right",
          });
          height += 8;

          drawItemRow("Net Total", netTotal, { bold: true, noLine: true });
          drawItemRow("Security Deposit", securityDeposit, {
            bold: true,
            noLine: true,
          });

          doc.setFillColor(220, 236, 220);
          doc.rect(padding, height - 5.5, pageWidth - padding * 2, 8, "F");
          drawItemRow("GRAND TOTAL PAYABLE", grandTotal, {
            bold: true,
            green: true,
            noLine: true,
          });
        }
      }

      const totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(DiscoCode),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight(),
        );
      }

      doc.setFontSize(8);

      // Loop through each page
      for (var i = 1; i <= totalPages; i++) {
        // Set the current page
        doc.setPage(i);

        // Get the page width and height
        var pageWidth = doc.internal.pageSize.getWidth();
        var pageHeight = doc.internal.pageSize.getHeight();

        // Set the position for the page number
        var pageNumberX = pageWidth - 20; // X-coordinate of the page number
        var pageNumberY = pageHeight - 10; // Y-coordinate of the page number

        // Add the page number
        doc.text(
          "Page " + i + " of " + totalPages,
          doc.internal.pageSize.getWidth() / 2,
          pageNumberY,
          {
            align: "center",
          },
        );
      }
      const pdfBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);

      // Open PDF in new tab instead of downloading
      window.open(pdfUrl, "_blank");

      // Hide loader after opening
      setViewBackdrop(false);

      // Cleanup after a delay to ensure new tab has loaded the PDF
      setTimeout(() => URL.revokeObjectURL(pdfUrl), 10000);
    } catch (e) {
      setViewBackdrop(false); // ← Also hide loader on error
    }
    // Remove the old setViewBackdrop(false) that was outside the try/catch
  };

  const arearsFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_property_reference_no: Yup.string().when("dialogRowData", {
        is: () => arrearFlag == 1,
        then: Yup.string()
          .required("Enter the reference number to get arrear details.")
          .min(14, "Enter 14 digit reference number.")
          .max(14, "Enter 14 digit reference number."),
        otherwise: Yup.string().optional(),
      }),
      iv_arrears_remarks: Yup.string().when("dialogRowData", {
        is: () => arrearFlag == 1 || arrearsDetailsRefno.arrearsAmount,
        then: Yup.string()
          .required("Please enter remarks before submitting.")
          .min(10, "Remarks must be at least 10 characters."),
        otherwise: Yup.string().optional(),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);

      let applicationProgressId = dialogRowData.applicationProgressId;
      let objectionStatus = null;
      let remarks = "";

      if (arrearFlag == 0 && !arrearsDetailsRefno.arrearsAmount) {
        applicationProgressId += 1;
        objectionStatus = 0;
        remarks = "Arrears Verified.";
      } else {
        objectionStatus = 1;
        remarks = values.iv_arrears_remarks;
      }
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      const formdata = new FormData();
      formdata.append("applicationId", dialogRowData.applicationId);
      formdata.append("applicationProgressId", applicationProgressId);
      formdata.append("objectionStatus", objectionStatus);
      formdata.append("remarks", remarks);
      formdata.append("refNo", values.iv_property_reference_no);
      formdata.append("arrearAmount", arrearsDetailsRefno.arrearsAmount);
      formdata.append("meterStatus", arrearsDetailsRefno.meterStatus);
      formdata.append("tariff", arrearsDetailsRefno.tariffDesc);
      formdata.append("meterType", arrearsDetailsRefno.meterType);
      formdata.append("phase", arrearsDetailsRefno.phase);
      formdata.append("consumerName", arrearsDetailsRefno.consumerName);
      formdata.append("consumerPhoneNo", arrearsDetailsRefno.consumerNo);
      formdata.append("consumerEmail", arrearsDetailsRefno.consumerEmail);
      formdata.append("consumerAddress", arrearsDetailsRefno.consumerAddress);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "enc/verifyENCArrears", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setArrearsEntryPopUpOpen(false);
            handleClose();
          } else {
          }
        })
        .catch((error) => console.log("error", error));
      setViewBackdrop(false);
    },
  });

  const appliedLoadFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_applied_load: Yup.number()
        .min(
          dialogRowData.appliedLoad,
          "New load can not be less than previous load."
        )
        .max(1000, "Applied load can not be more than 1000kW.")
        .required("Enter applied load."),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      var formdata = new FormData();
      formdata.append("applicationId", dialogRowData.applicationId);
      formdata.append("appliedLoad", appliedLoadFormik.values.iv_applied_load);
      formdata.append("lastModifiedBy", userId);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "electricityNewConnection/updateAppliedLoad",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            let nCApplications = newConnectionApplications;
            setNewConnectionApplications(nCApplications);
            callChangeObjectionStatus(2, "Field Objection Removed");
          } else {
            // console.log(result.message)
          }
        })
        .catch((error) => {
          console.log(error);
        });
      setViewBackdrop(false);
    },
  });

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_objection_Descripton: Yup.string().required(
        "Enter reason for rejection."
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: values.iv_objection_step,
        remarks: values.iv_objection_Descripton,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "enc/revertFromRefNoAllocation", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status == "200") {
            handleClose();
            setCapitalCostAmnt();
            setSecurityDepositeAmount();
            SetTotalEstimatedAmnt();
          }
        })
        .catch((error) => console.error(error));
      // callChangeObjectionStatus(1, values.iv_objection_Type, values.iv_objection_Type)
      resetForm();
      setViewBackdrop(false);
    },
  });

  // const fieldFormik = useFormik({
  //   initialValues,
  //   validationSchema: Yup.object().shape({
  //     iv_objection_Type: Yup.string().required("Enter reason for rejection."),

  //     iv_coverage_area: Yup.mixed().when("iv_objection_Type", {
  //       is: "No Issue",
  //       then: Yup.mixed()
  //         .required("Select the area from list.")
  //         .oneOf(areaMarla, "Please select a valid option"),
  //       otherwise: Yup.mixed().notRequired(),
  //     }),

  //     iv_grid_sharing_cost: Yup.number().when(
  //       ["gridFlag", "iv_objection_Type"],
  //       {
  //         is: (gridFlag, iv_objection_Type) =>
  //           gridFlag === true && iv_objection_Type === "No Issue",
  //         then: Yup.number()
  //           .typeError("Enter value in numbers.")
  //           .required("Enter grid sharing cost.")
  //           .min(1, "Cost cannot be less than 1"),
  //         otherwise: Yup.number().notRequired(),
  //       }
  //     ),

  //     iv_feeder_rehab_charges: Yup.number().when(
  //       ["feederRehabFlag", "iv_objection_Type"],
  //       {
  //         is: (feederRehabFlag, iv_objection_Type) =>
  //           feederRehabFlag === true && iv_objection_Type === "No Issue",
  //         then: Yup.number()
  //           .typeError("Enter value in numbers.")
  //           .required("Enter feeder rehab cost.")
  //           .min(1, "Cost cannot be less than 1"),
  //         otherwise: Yup.number().notRequired(),
  //       }
  //     ),

  //     iv_no_of_meters_already_installed: Yup.number().when(
  //       "iv_objection_Type",
  //       {
  //         is: "No Issue",
  //         then: Yup.number()
  //           .required("Enter already installed meters.")
  //           .min(
  //             dialogRowData.noOfMetersAlreadyInstalled,
  //             `No. can't < consumer's applied no.`
  //           ),
  //         otherwise: Yup.number().notRequired(),
  //       }
  //     ),

  //     installedMeterRefNos: Yup.array().when(
  //       ["iv_no_of_meters_already_installed", "iv_objection_Type"],
  //       {
  //         is: (count, iv_objection_Type) =>
  //           iv_objection_Type === "No Issue" && count > 0,
  //         then: Yup.array()
  //           .of(
  //             Yup.string()
  //               .required("Ref No is required")
  //               .matches(/^\d{14}$/, "Ref No must be exactly 14 digits")
  //           )
  //           .min(1, "At least one Ref No required"),
  //         otherwise: Yup.array().notRequired(),
  //       }
  //     ),

  //     iv_distance: Yup.string().when("iv_objection_Type", {
  //       is: "No Issue",
  //       then: Yup.string().required("Select option for the property distance."),
  //       otherwise: Yup.string().notRequired(),
  //     }),

  //     iv_estimated_distance: Yup.number().when(
  //       ["iv_distance", "iv_objection_Type"],
  //       {
  //         is: (iv_distance, iv_objection_Type) =>
  //           iv_objection_Type === "No Issue" && iv_distance == 0,
  //         then: Yup.number()
  //           .min(41, "Minimum 41M.")
  //           .required("Enter est. distance."),
  //         otherwise: Yup.number().notRequired(),
  //       }
  //     ),

  //     iv_meter_type: Yup.mixed().when("iv_objection_Type", {
  //       is: "No Issue",
  //       then: Yup.mixed().required("Select meter type!"),
  //       otherwise: Yup.mixed().notRequired(),
  //     }),

  //     iv_sketch_diagram: Yup.mixed().when(
  //       ["iv_distance", "iv_objection_Type"],
  //       {
  //         is: (iv_distance, iv_objection_Type) =>
  //           iv_objection_Type === "No Issue" && iv_distance == 0,
  //         then: Yup.mixed().required("Upload the sketch diagram."),
  //         otherwise: Yup.mixed().notRequired(),
  //       }
  //     ),

  //     iv_existing_meters_ref_nos_array: Yup.mixed().notRequired(),

  //     iv_rural_urban: Yup.mixed().when("iv_objection_Type", {
  //       is: "No Issue",
  //       then: Yup.mixed().required("Select Urban / Rural!"),
  //       otherwise: Yup.mixed().notRequired(),
  //     }),
  //   }),

  //   onSubmit: async (values, { resetForm }) => {
  //     console.log("hello");
  //     setInstallRefNo(values.installedMeterRefNos);
  //     console.log(
  //       "Form Values",
  //       values.installedMeterRefNos,
  //       "values.installedMeterRefNos"
  //     );
  //     setEstimateDistance(values.iv_estimated_distance);
  //     setMeterAlreadyInstalled(values.iv_no_of_meters_already_installed);
  //     setShowBoq(false);

  //     if (values.iv_distance == 0 && boqItems.length == 0) {
  //       setErrormessageBoqEstimation("Please add BOQ items before submitting.");
  //       return;
  //     }
  //     setErrormessageBoqEstimation("");

  //     if (values.iv_distance == 0 && !sketchDiagramThumbnail) {
  //       setSketchDiagramError(
  //         "Upload the Sketch Diagram in JPG, PNG or PDF format."
  //       );
  //     } else if (values.iv_distance == 0) {
  //       const myHeaders = new Headers();
  //       myHeaders.append("Authorization", token);
  //       myHeaders.append("Content-Type", "application/json");

  //       const raw = JSON.stringify({
  //         urbanRural: values.iv_rural_urban,
  //         tariff: getTariff(
  //           dialogRowData.appliedLoad,
  //           dialogRowData.connectionType,
  //           dialogRowData.seasonalNonSeasonalFlag,
  //           allTariffList
  //         ),
  //         connectionType: dialogRowData.connectionType,
  //         isDistatanceIn40M: values.iv_distance,
  //         meterType: values.iv_meter_type,
  //         amountOfGridSharing: gridSharingCost ? gridSharingCost : 0,
  //         amountOfFeederRehab: feederRehabilitationCharges
  //           ? feederRehabilitationCharges
  //           : 0,
  //         sanctionLoad: dialogRowData.appliedLoad,
  //         civilWorkCharges: civilWorkCharges ? civilWorkCharges : 0,
  //         fixedChargesOfMetering: fixedChargesOfMetering
  //           ? fixedChargesOfMetering
  //           : 0,
  //         miscellaneousCharges: miscellaneousCharges
  //           ? miscellaneousCharges
  //           : 0,
  //         lessTheCost: lessTheCost ? lessTheCost : 0,
  //       });

  //       const requestOptions = {
  //         method: "POST",
  //         headers: myHeaders,
  //         body: raw,
  //         redirect: "follow",
  //       };

  //       fetch(cfpBaseUrl + "enc/costEstimationForNC", requestOptions)
  //         .then((response) => response.json())
  //         .then((result) => {
  //           setViewBackdrop(false);
  //           setShowCostEstimation(true);
  //           setCostEstimationForNC(result.data[0]);
  //         })
  //         .catch((error) => console.error(error, "error"));
  //     } else {
  //       let applicationProgressId = dialogRowData.applicationProgressId;
  //       let objectionStatus = null;
  //       let remarks = "";

  //       if (values.iv_objection_Type != "No Issue") {
  //         objectionStatus = 1;
  //         remarks = values.iv_objection_Type;
  //         const myHeaders = new Headers();
  //         myHeaders.append("Authorization", token);
  //         myHeaders.append("Content-Type", "application/json");

  //         const raw = JSON.stringify({
  //           applicationId: dialogRowData.applicationId,
  //           applicationProgressId: 3,
  //           remarks: remarks,
  //           objectionStatus: objectionStatus,
  //           meterType: "",
  //           tariff: "",
  //           sanctionLoad: "",
  //           urbanRural: "",
  //           amountOfGridSharing: "",
  //           amountOfFeederRehab: "",
  //           civilWorkCharges: "",
  //           fixedChargesOfMetering: "",
  //           miscellaneousCharges: "",
  //           lessTheCost: "",
  //           capitalCostAmount: "",
  //           securityDepositAmount: "",
  //           isLTLWI40Flag: 1,
  //           estDistanceInMeter: "40",
  //           sketchDiagram: "",
  //           areaMarla: areaTypeValue,
  //           noOfMeterInstalled: 0,
  //           surveyedBy: "",
  //           installedMeterRefNo: [],
  //           submittedThrough: "e-Operation",
  //           BoQItems: [],
  //         });

  //         const requestOptions = {
  //           method: "POST",
  //           headers: myHeaders,
  //           body: raw,
  //           redirect: "follow",
  //         };

  //         fetch(cfpBaseUrl + "enc/saveFieldSurveyAndCostEstimate", requestOptions)
  //           .then((response) => response.json())
  //           .then((result) => {
  //             if (result.status === "200") {
  //               setViewBackdrop(false);
  //               setShowCostEstimation(false);
  //               setErrormessageCostEstimation("");
  //               handleClose();
  //             } else {
  //               setViewBackdrop(false);
  //               setErrormessageCostEstimation(result.message);
  //             }
  //           })
  //           .catch((error) => console.error(error));
  //       } else {
  //         applicationProgressId += 1;
  //         objectionStatus = 0;
  //         remarks = "Field Surveyed";

  //         const myHeaders = new Headers();
  //         myHeaders.append("Authorization", token);
  //         myHeaders.append("Content-Type", "application/json");

  //         const raw = JSON.stringify({
  //           urbanRural: values.iv_rural_urban,
  //           tariff: getTariff(
  //             dialogRowData.appliedLoad,
  //             dialogRowData.connectionType,
  //             dialogRowData.seasonalNonSeasonalFlag,
  //             allTariffList
  //           ),
  //           connectionType: dialogRowData.connectionType,
  //           isDistatanceIn40M: values.iv_distance,
  //           meterType: values.iv_meter_type,
  //           amountOfGridSharing: gridSharingCost ? gridSharingCost : 0,
  //           amountOfFeederRehab: feederRehabilitationCharges
  //             ? feederRehabilitationCharges
  //             : 0,
  //           sanctionLoad: dialogRowData.appliedLoad,
  //           civilWorkCharges: civilWorkCharges ? civilWorkCharges : 0,
  //           fixedChargesOfMetering: fixedChargesOfMetering
  //             ? fixedChargesOfMetering
  //             : 0,
  //           miscellaneousCharges: miscellaneousCharges
  //             ? miscellaneousCharges
  //             : 0,
  //           lessTheCost: lessTheCost ? lessTheCost : 0,
  //         });

  //         const requestOptions = {
  //           method: "POST",
  //           headers: myHeaders,
  //           body: raw,
  //           redirect: "follow",
  //         };

  //         fetch(cfpBaseUrl + "enc/costEstimationForNC", requestOptions)
  //           .then((response) => response.json())
  //           .then((result) => {
  //             setViewBackdrop(false);
  //             setShowCostEstimation(true);
  //             setCostEstimationForNC(result.data[0]);
  //           })
  //           .catch((error) => console.error(error, "error"));
  //       }
  //       setViewBackdrop(false);
  //     }

  //     setMeterTypeValue(values.iv_meter_type);
  //     setAreaType(values.iv_coverage_area);
  //     setUrbanRural(values.iv_rural_urban);
  //   },
  // });
  const isFesco = dialogRowData?.applicationId?.slice(3, 5) === "13";
  const minDistance = 41;
  // const fieldFormik = useFormik({
  //   initialValues,
  //   validationSchema: Yup.lazy((values) => {
  //     if (values.iv_objection_Type !== "No Issue") {
  //       return Yup.object().shape({
  //         iv_objection_Type: Yup.string().required("Enter reason for rejection."),
  //       });
  //     }

  //     return Yup.object().shape({
  //       iv_objection_Type: Yup.string().required("Enter reason for rejection."),

  //       iv_coverage_area: Yup.mixed()
  //         .required("Select the area from list.")
  //         .oneOf(areaMarla, "Please select a valid option"),

  //       iv_grid_sharing_cost: Yup.number().when([], {
  //         is: () => gridFlag === true,
  //         then: Yup.number()
  //           .typeError("Enter value in numbers.")
  //           .required("Enter grid sharing cost.")
  //           .min(1, "Cost cannot be less than 1"),
  //         otherwise: Yup.number()
  //           .test(
  //             "is-valid",
  //             "Enter value in numbers or enter '0'.",
  //             (value) => value === "0" || !isNaN(Number(value))
  //           )
  //           .optional(),
  //       }),

  //       iv_feeder_rehab_charges: Yup.number().when([], {
  //         is: () => feederRehabFlag === true,
  //         then: Yup.number()
  //           .typeError("Enter value in numbers.")
  //           .required("Enter feeder rehab cost.")
  //           .min(1, "Cost cannot be less than 1"),
  //         otherwise: Yup.number()
  //           .test(
  //             "is-valid",
  //             "Enter value in numbers or enter '0'.",
  //             (value) => value === "0" || !isNaN(Number(value))
  //           )
  //           .optional(),
  //       }),

  //       iv_no_of_meters_already_installed: Yup.number()
  //         .required("Enter already installed meters.")
  //         .min(
  //           dialogRowData.noOfMetersAlreadyInstalled,
  //           `No. can't < consumer's applied no.`
  //         ),

  //       installedMeterRefNos: Yup.array().when(
  //         "iv_no_of_meters_already_installed",
  //         {
  //           is: (count) => count > 0,
  //           then: Yup.array()
  //             .of(
  //               Yup.string()
  //                 .required("Ref No is required")
  //                 .matches(/^\d{14}$/, "Ref No must be exactly 14 digits")
  //             )
  //             .min(1, "At least one Ref No required"),
  //           otherwise: Yup.array().optional(),
  //         }
  //       ),

  //       iv_distance: Yup.string().required("Select option for the property distance."),
  //       iv_estimated_distance: Yup.number().when("iv_distance", {
  //         is: (iv_distance) => iv_distance == 0,
  //         then: Yup.number()
  //           .min(minDistance, `Minimum ${minDistance}M.`) // FESCO = 21, others = 41
  //           .required("Enter est. distance."),
  //         otherwise: Yup.number()
  //           .min(41, "Minimum 41M.") // 👈 other case bhi 41 se kam na ho
  //           .optional(),
  //       }),
  //       iv_meter_type: Yup.mixed().required("Select meter type!"),

  //       iv_sketch_diagram: Yup.mixed().when("iv_distance", {
  //         is: (iv_distance) => iv_distance == 0,
  //         then: Yup.mixed().required("Upload the sketch diagram."),
  //         otherwise: Yup.mixed().optional(),
  //       }),

  //       iv_existing_meters_ref_nos_array: Yup.mixed().optional(),

  //       iv_rural_urban: Yup.mixed().required("Select Urban / Rural!"),
  //     });
  //   }),
  //   onSubmit: async (values, { resetForm }) => {
  //     console.log(fieldFormik.values.iv_tariff_to_allot)
  //     setInstallRefNo(values.installedMeterRefNos)
  //     setEstimateDistance(values.iv_estimated_distance)
  //     setMeterAlreadyInstalled(values.iv_no_of_meters_already_installed)
  //     setShowBoq(false)

  //     if (values.iv_distance == 0 && boqItems.length == 0) {
  //       setErrormessageBoqEstimation("Please add BOQ items before submitting.")
  //       return
  //     }
  //     setErrormessageBoqEstimation("")

  //     if (values.iv_distance == 0 && !sketchDiagramThumbnail) {
  //       setSketchDiagramError("Upload the Sketch Diagram in JPG, PNG or PDF format.")
  //     } else if (values.iv_distance == 0) {
  //       const myHeaders = new Headers();
  //       myHeaders.append("Authorization", token);
  //       myHeaders.append("Content-Type", "application/json");

  //       const raw = JSON.stringify({
  //         "urbanRural": values.iv_rural_urban,
  //         "tariff": getTariff(dialogRowData.appliedLoad, dialogRowData.connectionType, dialogRowData.seasonalNonSeasonalFlag, allTariffList),
  //         "connectionType": dialogRowData.connectionType,
  //         "isDistatanceIn40M": values.iv_distance,
  //         "meterType": values.iv_meter_type,
  //         "amountOfGridSharing": gridSharingCost ? gridSharingCost : 0,
  //         "amountOfFeederRehab": feederRehabilitationCharges ? feederRehabilitationCharges : 0,
  //         "sanctionLoad": dialogRowData.appliedLoad,
  //         "civilWorkCharges": civilWorkCharges ? civilWorkCharges : 0,
  //         "fixedChargesOfMetering": fixedChargesOfMetering ? fixedChargesOfMetering : 0,
  //         "miscellaneousCharges": miscellaneousCharges ? miscellaneousCharges : 0,
  //         "lessTheCost": lessTheCost ? lessTheCost : 0
  //       });

  //       const requestOptions = {
  //         method: "POST",
  //         headers: myHeaders,
  //         body: raw,
  //         redirect: "follow"
  //       };

  //       fetch(cfpBaseUrl + "enc/costEstimationForNC", requestOptions)
  //         .then((response) => response.json())
  //         .then((result) => {
  //           setViewBackdrop(false)
  //           setShowCostEstimation(true)
  //           setCostEstimationForNC(result.data[0])
  //         })
  //         .catch((error) => console.error(error, 'error'));
  //     } else {

  //       let applicationProgressId = dialogRowData.applicationProgressId
  //       let objectionStatus = null
  //       let remarks = ''

  //       if (values.iv_objection_Type != "No Issue") {
  //         objectionStatus = 1
  //         remarks = values.iv_objection_Type
  //         const myHeaders = new Headers();
  //         myHeaders.append("Authorization", token);
  //         myHeaders.append("Content-Type", "application/json");

  //         const raw = JSON.stringify({
  //           "applicationId": dialogRowData.applicationId,
  //           "applicationProgressId": 3,
  //           "remarks": remarks,
  //           "objectionStatus": objectionStatus,
  //           "meterType": '',
  //           "tariff": '',
  //           "sanctionLoad": '',
  //           "urbanRural": '',
  //           "amountOfGridSharing": "",
  //           "amountOfFeederRehab": "",
  //           "civilWorkCharges": "",
  //           "fixedChargesOfMetering": "",
  //           "miscellaneousCharges": "",
  //           "lessTheCost": "",
  //           "capitalCostAmount": "",
  //           "securityDepositAmount": "",
  //           "isLTLWI40Flag": 1,
  //           "estDistanceInMeter": "40",
  //           "sketchDiagram": "",
  //           "areaMarla": areaTypeValue,
  //           "noOfMeterInstalled": 0,
  //           "surveyedBy": "",
  //           "installedMeterRefNo": [],
  //           "submittedThrough": "e-Operation",
  //           "BoQItems": []
  //         });

  //         const requestOptions = {
  //           method: "POST",
  //           headers: myHeaders,
  //           body: raw,
  //           redirect: "follow"
  //         };

  //         fetch(cfpBaseUrl + "enc/saveFieldSurveyAndCostEstimate", requestOptions)
  //           .then((response) => response.json())
  //           .then((result) => {
  //             if (result.status === "200") {
  //               setViewBackdrop(false)
  //               setShowCostEstimation(false)
  //               setErrormessageCostEstimation('')
  //               // resetForm()
  //               handleClose()
  //             } else {
  //               setViewBackdrop(false)
  //               // setShowCostEstimation(false)
  //               setErrormessageCostEstimation(result.message)
  //             }

  //           })
  //           .catch((error) => console.error(error));

  //       } else {
  //         applicationProgressId += 1
  //         objectionStatus = 0
  //         remarks = 'Field Surveyed'

  //         const myHeaders = new Headers();
  //         myHeaders.append("Authorization", token);
  //         myHeaders.append("Content-Type", "application/json");

  //         const raw = JSON.stringify({
  //           "urbanRural": values.iv_rural_urban,
  //           "tariff": getTariff(dialogRowData.appliedLoad, dialogRowData.connectionType, dialogRowData.seasonalNonSeasonalFlag, allTariffList),
  //           "connectionType": dialogRowData.connectionType,
  //           "isDistatanceIn40M": values.iv_distance,
  //           "meterType": values.iv_meter_type,
  //           "amountOfGridSharing": gridSharingCost ? gridSharingCost : 0,
  //           "amountOfFeederRehab": feederRehabilitationCharges ? feederRehabilitationCharges : 0,
  //           "sanctionLoad": dialogRowData.appliedLoad,
  //           "civilWorkCharges": civilWorkCharges ? civilWorkCharges : 0,
  //           "fixedChargesOfMetering": fixedChargesOfMetering ? fixedChargesOfMetering : 0,
  //           "miscellaneousCharges": miscellaneousCharges ? miscellaneousCharges : 0,
  //           "lessTheCost": lessTheCost ? lessTheCost : 0
  //         });

  //         const requestOptions = {
  //           method: "POST",
  //           headers: myHeaders,
  //           body: raw,
  //           redirect: "follow"
  //         };

  //         fetch(cfpBaseUrl + "enc/costEstimationForNC", requestOptions)
  //           .then((response) => response.json())
  //           .then((result) => {
  //             setViewBackdrop(false)
  //             setShowCostEstimation(true)
  //             setCostEstimationForNC(result.data[0])
  //             // setShowCostEstimation(true)
  //           })
  //           .catch((error) => console.error(error, 'error'));
  //       }
  //       setViewBackdrop(false)
  //     }

  //     setMeterTypeValue(values.iv_meter_type)
  //     setAreaType(values.iv_coverage_area)
  //     setUrbanRural(values.iv_rural_urban)

  //   }
  // });
  const fieldFormik = useFormik({
    initialValues,
    validationSchema: Yup.lazy((values) => {
      if (values.iv_objection_Type === "Other") {
        return Yup.object().shape({
          iv_objection_Type: Yup.string().required(
            "Enter reason for rejection."
          ),
          iv_objection_Descripton: Yup.string()
            .required("Please enter remarks.")
            .min(10, "Remarks must be at least 10 characters."),
        });
      }
      if (values.iv_objection_Type !== "No Issue") {
        return Yup.object().shape({
          iv_objection_Type: Yup.string().required(
            "Enter reason for rejection."
          ),
        });
      }
      return Yup.object().shape({
        iv_objection_Type: Yup.string().required("Enter reason for rejection."),

        iv_coverage_area: Yup.number()
          .typeError("Enter value in numbers.")
          .required("Enter area (Marla).")
          .min(3, "Minimum area is 3"),

        iv_grid_sharing_cost: Yup.number().when([], {
          is: () => gridFlag === true,
          then: Yup.number()
            .typeError("Enter value in numbers.")
            .required("Enter grid sharing cost.")
            .min(1, "Cost cannot be less than 1"),
          otherwise: Yup.number()
            .test(
              "is-valid",
              "Enter value in numbers or enter '0'.",
              (value) => value === "0" || !isNaN(Number(value))
            )
            .optional(),
        }),

        iv_feeder_rehab_charges: Yup.number().when([], {
          is: () => feederRehabFlag === true,
          then: Yup.number()
            .typeError("Enter value in numbers.")
            .required("Enter feeder rehab cost.")
            .min(1, "Cost cannot be less than 1"),
          otherwise: Yup.number()
            .test(
              "is-valid",
              "Enter value in numbers or enter '0'.",
              (value) => value === "0" || !isNaN(Number(value))
            )
            .optional(),
        }),
        iv_no_of_meters_already_installed: Yup.number()
          .required("Enter already installed meters.")
          .min(
            dialogRowData.noOfMetersAlreadyInstalled,
            `No. can't < consumer's applied no.`
          ),

        installedMeterRefNos: Yup.array().when(
          "iv_no_of_meters_already_installed",
          {
            is: (count) => count > 0,
            then: Yup.array()
              .of(
                Yup.string()
                  .required("Ref No is required")
                  .matches(/^\d{14}$/, "Ref No must be exactly 14 digits")
              )
              .min(1, "At least one Ref No required"),
            otherwise: Yup.array().optional(),
          }
        ),

        iv_distance: Yup.string().required(
          "Select option for the property distance."
        ),

        iv_estimated_distance: Yup.number().when(["iv_distance"], {
          is: (iv_distance) => iv_distance == 0,
          then: Yup.number()
            .min(minDistance, `Minimum ${minDistance}M.`)
            .required("Enter est. distance."),
          otherwise: Yup.number().optional(),
        }),

        iv_estimated_distance_yes: Yup.number().when(
          ["iv_distance", "applicationId"],
          {
            is: (iv_distance, applicationId) => {
              const companyCode = applicationId?.slice(3, 5);
              return companyCode === "14";
            },
            then: Yup.number().when("iv_distance", {
              is: 1,
              then: Yup.number()
                .min(1, "Minimum 1M.")
                .max(40, "Maximum 40M.")
                .required("Enter est. distance (1–40)."),
              otherwise: Yup.number()
                .min(41, "Minimum 41M.")
                .required("Enter est. distance."),
            }),
            otherwise: Yup.number().optional(),
          }
        ),
        iv_select_cable: Yup.mixed().when(
          ["applicationId", "iv_meter_type", "iv_distance"],
          {
            is: (appId) =>
              appId?.slice(3, 5) === "14" &&
              values.iv_meter_type === 1 &&
              values.iv_distance != 0,
            then: Yup.mixed().required("Select cable!"),
            otherwise: Yup.mixed().optional(),
          }
        ),
        iv_sketch_diagram:
          dialogRowData?.applicationId?.slice(3, 5) === "13" ||
            dialogRowData?.applicationId?.slice(3, 5) === "14" ||
            dialogRowData?.applicationId?.slice(3, 5) === "15"
            ? Yup.mixed().required("Upload the sketch diagram.")
            : Yup.mixed().nullable(),

        // iv_select_cable: Yup.mixed().when([], {
        //   is: () => dialogRowData?.applicationId?.slice(3, 5) === "14",
        //   then: Yup.mixed().required("Select cable!"),
        //   otherwise: Yup.mixed().optional(),
        // }),
        iv_meter_type: Yup.mixed().required("Select meter type!"),

        iv_existing_meters_ref_nos_array: Yup.mixed().optional(),

        iv_rural_urban: Yup.mixed().required("Select Urban / Rural!"),
      });
    }),
    onSubmit: async (values, { resetForm }) => {
      setInstallRefNo(values.installedMeterRefNos);
      setEstimateDistance(values.iv_estimated_distance);
      setMeterAlreadyInstalled(values.iv_no_of_meters_already_installed);
      setShowBoq(false);

      // Check if BOQ items are required for applicationId '13' or iv_distance == 0
      if (
        values.iv_distance == 0 &&
        boqItems.length == 0 &&
        values.iv_objection_Type === "No Issue"
      ) {
        setErrormessageBoqEstimation("Please add BOQ items before submitting.");
        return;
      }
      setErrormessageBoqEstimation("");

      if (
        values.iv_distance == 0 &&
        !sketchDiagramThumbnail &&
        dialogRowData.applicationId.slice(3, 5) !== "13" &&
        values.iv_objection_Type === "No Issue"
      ) {
        setSketchDiagramError(
          "Upload the Sketch Diagram in JPG, PNG or PDF format."
        );
        return;
      }

      if (values.iv_objection_Type != "No Issue") {
        let applicationProgressId = dialogRowData.applicationProgressId;
        let objectionStatus = 1;
        let remarks = values.iv_objection_Type === "Other" ? values.iv_objection_Descripton : values.iv_objection_Type;

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          applicationProgressId: 3,
          remarks: remarks,
          objectionStatus: objectionStatus,
          meterType: "",
          tariff: "",
          sanctionLoad: "",
          urbanRural: "",
          amountOfGridSharing: "",
          amountOfFeederRehab: "",
          civilWorkCharges: "",
          fixedChargesOfMetering: "",
          miscellaneousCharges: "",
          lessTheCost: "",
          capitalCostAmount: "",
          securityDepositAmount: "",
          isLTLWI40Flag: 1,
          estDistanceInMeter: "40",
          sketchDiagram: "",
          areaMarla: areaTypeValue,
          noOfMeterInstalled: 0,
          surveyedBy: "",
          installedMeterRefNo: [],
          submittedThrough: "e-Operation",
          BoQItems: [],
          connectionType: ""
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(cfpBaseUrl + "enc/saveFieldSurveyAndCostEstimate", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              setViewBackdrop(false);
              setShowCostEstimation(false);
              setErrormessageCostEstimation("");
              handleClose();
            } else {
              setViewBackdrop(false);
              setErrormessageCostEstimation(result.message);
            }
          })
          .catch((error) => console.error(error));
      } else {
        if (
          dialogRowData?.applicationId?.slice(3, 5) === "14" &&
          values.iv_meter_type == 1 &&
          !values.iv_select_cable &&
          values.iv_distance != 0
        ) {
          fieldFormik.setFieldTouched("iv_select_cable", true);
          fieldFormik.setFieldError("iv_select_cable", "Select cable!");
          return;
        }
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          urbanRural: values.iv_rural_urban,
          tariff: tariff,
          connectionType: dialogRowData.connectionType,
          isDistatanceIn40M: values.iv_distance,
          meterType: values.iv_meter_type,
          amountOfGridSharing: gridSharingCost ? gridSharingCost : 0,
          amountOfFeederRehab: feederRehabilitationCharges
            ? feederRehabilitationCharges
            : 0,
          sanctionLoad: dialogRowData.appliedLoad,
          civilWorkCharges: civilWorkCharges ? civilWorkCharges : 0,
          fixedChargesOfMetering: fixedChargesOfMetering
            ? fixedChargesOfMetering
            : 0,
          miscellaneousCharges: miscellaneousCharges ? miscellaneousCharges : 0,
          lessTheCost: lessTheCost ? lessTheCost : 0,
          estDistanceInMeter:
            values.iv_distance == 1
              ? values.iv_estimated_distance_yes
              : values.iv_estimated_distance,
          itemCode:
            dialogRowData?.applicationId?.slice(3, 5) === "14"
              ? Number(values.iv_select_cable)
              : 0,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(cfpBaseUrl + "enc/costEstimationForNC", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status == "200") {
              setViewBackdrop(false);
              setShowCostEstimation(true);
              setCostEstimationForNC(result.data[0]);
              setErrormessageCostEstimation("");
            } else if (result.status == "400") {
              setViewBackdrop(false);
              setErrormessageCostEstimation(result.message);
            }
          })
          .catch((error) => console.error(error, "error"));
      }

      setMeterTypeValue(values.iv_meter_type);
      setAreaType(values.iv_coverage_area);
      setUrbanRural(values.iv_rural_urban);
    },
  });

  useEffect(() => {
    if (
      fieldFormik.values.iv_distance == 0 &&
      fieldFormik.values.iv_objection_Type == "No Issue"
    ) {
      fieldFormik.validateField("iv_sketch_diagram");
    }
  }, [fieldFormik.values.iv_distance]);

  const refNoAllocationFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      // iv_grid_sharing_cost: Yup.number().when('gridFlag', {
      //   is: () => gridFlag === true,
      //   then: Yup.number()
      //     .typeError('Enter value in numbers.')
      //     .required('Enter grid sharing cost.')
      //     .min(1, 'Cost cannot be less than 1'),
      //   otherwise: Yup.number()
      //     .test(
      //       'is-valid',
      //       "Enter value in numbers or enter '0'.",
      //       (value) => value === '0' || !isNaN(Number(value))
      //     )
      //     .optional('Enter value in numbers or enter "0".'),
      // }),
      // iv_feeder_rehab_charges: Yup.number().when('feederRehabFlag', {
      //   is: () => feederRehabFlag === true,
      //   then: Yup.number()
      //     .typeError('Enter value in numbers.')
      //     .required('Enter feeder rehab cost.')
      //     .min(1, 'Cost cannot be less than 1'),
      //   otherwise: Yup.number()
      //     .test(
      //       'is-valid',
      //       "Enter value in numbers or enter '0'.",
      //       (value) => value === '0' || !isNaN(Number(value))
      //     )
      //     .optional('Enter value in numbers or enter "0".'),
      // }),
      iv_civil_work_charges: Yup.number(
        `Enter value in numbers or enter '0'.`
      ).optional(),
      iv_fixed_charges_of_metering: Yup.number(
        `Enter value in numbers or enter '0'.`
      ).optional(),
      iv_miscellaneous_charges: Yup.number(
        `Enter value in numbers or enter '0'.`
      ).optional(),
      iv_less_the_cost: Yup.number(
        `Enter value in numbers or enter '0'.`
      ).optional(),
      iv_feeder_no: Yup.mixed().required("Select feeder!"),
      iv_sub_batch: Yup.mixed().required("Select sub batch."),
      iv_batch: Yup.mixed().required("Select batch."),
      iv_reference_to_allot: Yup.string()
        .required("Enter reference no. to allot.")
        .min(7, `Reference no. can't be < 12 digits.`)
        .max(7, `Reference no. can't > 12 digits.`)
        .matches(/^[0-9]+$/, "Enter reference no. as 01234567891234"),
      iv_industry_factory_type: Yup.string().when("connectionType", {
        is: () =>
          (dialogRowData.connectionType === "Industrial" &&
            industryFlag === true) ||
          (dialogRowData.connectionType === "industrial" &&
            industryFlag === true),
        then: Yup.string().required("Please enter industry / factory type."),
        otherwise: Yup.string().optional(),
      }),
      iv_items_array: Yup.mixed().optional(),
      iv_fata_pata: Yup.mixed().optional("Select FATA / PATA!"),
      // iv_rural_urban: Yup.mixed().required('Select Urban / Rural!'),
      iv_fgovt: Yup.string().optional(
        "Select Federal Govt / Autonomous and Local Bodies under Prov. Govt"
      ),
      iv_cantonment_board: Yup.string().optional("Select Cantonment Board"),
      iv_pgovt: Yup.string().optional(
        "Select Provincial Govt / Autonomous and Local Bodies under Prov. Govt"
      ),
      iv_govt_dept_code: Yup.string().when(["iv_pgovt", "iv_fgovt"], {
        is: (iv_pgovt, iv_fgovt) => Boolean(iv_pgovt || iv_fgovt),
        then: Yup.string().required("Select Govt. Department Code."),
        otherwise: Yup.string().optional(),
      }),
      iv_local_bodies: Yup.string().optional("Select Local Bodies"),
      iv_meter_type: Yup.mixed().required("Select meter type!"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      let DNDets = dnDetails;
      let applicationProgressId = dialogRowData.applicationProgressId;
      let remarks = "";
      let objectionStatus = 0;
      let filledFlag = "";
      let approvedFlag = "";

      if (!DNDets.issueDate) {
        filledFlag = 1;
        approvedFlag = "";
        remarks = "Reference No. allocated.";

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          applicationProgressId: 4,
          remarks: remarks,
          objectionStatus: 0,
          consumerAccountNo: values.iv_reference_to_allot,
          batchNo: values.iv_batch,
          feederNo: values.iv_feeder_no,
          subBatch: values.iv_sub_batch,
          bankName: bankName,
          industryFactoryType: values.iv_industry_factory_type,
          connectionAccountNo: values.iv_batch
            .concat(partialValue)
            .concat(values.iv_reference_to_allot),
          meterRent: 0,
          serviceRent: 0,
          filledFlag: filledFlag,
          approvedFlag: approvedFlag,
          fataPata: values.iv_fata_pata,
          fGovt: values.iv_fgovt,
          cantonmentBoard: values.iv_cantonment_board,
          pGovt: values.iv_pgovt,
          localBodies: values.iv_local_bodies,
          governmentDepartmentCode:
            values.iv_govt_dept_code && values.iv_govt_dept_code != NaN
              ? values.iv_govt_dept_code
              : "",
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(cfpBaseUrl + "enc/referenceNoAllocationNew", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status == "200") {
              setViewBackdrop(false);
              resetForm();
              handleClose();
            } else if (result.status == "400") {
              setViewBackdrop(false);
              setRefNoAlreadyAllocatedError(result.message[0]);
            }
          })
          .catch((error) => console.error(error));
      } else {
        applicationProgressId += 1;
        filledFlag = 1;
        approvedFlag = 1;
        remarks = "Demand Note Issued.";

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          applicationProgressId: 5,
          remarks: remarks,
          objectionStatus: 0,
          consumerAccountNo: values.iv_reference_to_allot,
          batchNo: values.iv_batch,
          feederNo: values.iv_feeder_no,
          subBatch: values.iv_sub_batch,
          bankName: bankName,
          industryFactoryType: values.iv_industry_factory_type,
          connectionAccountNo: values.iv_batch
            .concat(partialValue)
            .concat(values.iv_reference_to_allot),
          meterRent: 0,
          serviceRent: 0,
          filledFlag: filledFlag,
          approvedFlag: approvedFlag,
          fataPata: values.iv_fata_pata,
          fGovt: values.iv_fgovt,
          cantonmentBoard: values.iv_cantonment_board,
          pGovt: values.iv_pgovt,
          localBodies: values.iv_local_bodies,
          governmentDepartmentCode:
            values.iv_govt_dept_code && values.iv_govt_dept_code != NaN
              ? values.iv_govt_dept_code
              : "",
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(cfpBaseUrl + "enc/referenceNoAllocationNew", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status == "200") {
              resetForm();
              handleClose();
            } else if (result.status == "400") {
              setViewBackdrop(false);
              setRefNoAlreadyAllocatedError(result.message[0]);
            }
          })
          .catch((error) => console.error(error));
      }

      let arrayOfItems = [];

      if (fieldFormik.values.iv_distance === 0) {
        itemsArray.forEach((item) => {
          let itemObject = {};
          itemObject.itemCode = item.itemCode;
          itemObject.Id = item.Id.toString();
          itemObject.qty = item.qty;
          arrayOfItems.push(itemObject);
        });
      }

      // const myHeaders = new Headers();
      // myHeaders.append("Authorization", token);
      // myHeaders.append("Content-Type", "application/json");

      // const raw = JSON.stringify({
      //   "applicationId": dialogRowData.applicationId,
      //   "applicationProgressId": applicationProgressId,
      //   "remarks": remarks,
      //   "objectionStatus": objectionStatus,
      //   "consumerAccountNo": values.iv_reference_to_allot,
      //   "batchNo": values.iv_batch,
      //   "feederNo": values.iv_feeder_no,
      //   "subBatch": values.iv_sub_batch,
      //   "meterType": values.iv_meter_type,
      //   "tariff": tariff,
      //   "bankName": bankName,
      //   "industryFactoryType": values.iv_industry_factory_type,
      //   "connectionAccountNo": values.iv_batch.concat(partialValue).concat(values.iv_reference_to_allot),
      //   "meterRent": 0,
      //   "serviceRent": 0,
      //   "sanctionLoad": dialogRowData.appliedLoad,
      //   "filledFlag": filledFlag,
      //   "approvedFlag": approvedFlag,
      //   "amountOfGridSharing": values.iv_grid_sharing_cost,
      //   "amountOfFeederRehab": values.iv_feeder_rehab_charges,
      //   "civilWorkCharges": civilWorkCharges,
      //   "fixedChargesOfMetering": fixedChargesOfMetering,
      //   "miscellaneousCharges": miscellaneousCharges,
      //   "lessTheCost": lessTheCost,
      //   "urbanRural": values.iv_rural_urban,
      //   "fataPata": values.iv_fata_pata,
      //   "fGovt": values.iv_fgovt,
      //   "cantonmentBoard": values.iv_cantonment_board,
      //   "pGovt": values.iv_pgovt,
      //   "localBodies": values.iv_local_bodies,
      //   "governmentDepartmentCode": (values.iv_govt_dept_code && values.iv_govt_dept_code != NaN) ? values.iv_govt_dept_code : "",
      //   "BoQItems": arrayOfItems
      // });

      // const requestOptions = {
      //   method: "POST",
      //   headers: myHeaders,
      //   body: raw,
      //   redirect: "follow"
      // };

      // await fetch(cfpBaseUrl + "enc/referenceNoAllocation", requestOptions)
      //   .then((response) => response.json())
      //   .then((result) => {
      //     if (result.status == "200") {
      //       resetForm()
      //       handleClose()
      //     }
      //     else if (result.status == "400") {
      //       setRefNoAlreadyAllocatedError(result.message[0])

      //     }
      //   })
      //   .catch((error) => console.error(error));
      // setViewBackdrop(false)
    },
  });

  const dnPymentReceiptFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_payment_date: Yup.date()
        .max(new Date(), "Payment date must be in the past!")
        .required("Payment date is required!"),
      iv_receipt_image: Yup.mixed().required(
        "Upload paid demand notice receipt image."
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      if (dnReceiptImageThumbnail) {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          remarks: "DN Paid Image Uploaded.",
          paymentDate: values.iv_payment_date,
          paymentMethod: "1",
          submittedThrough: portalName,
          paidDNImage: dnReceiptImageThumbnail,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        await fetch(cfpBaseUrl + "enc/uploadPaidDNImage", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              resetForm();
              setDnReceiptImage();
              setDnReceiptImageThumbnail();
              handleClose();
            }
          })
          .catch((error) => console.log("error", error));
      } else {
        setDnReceiptImageError(
          "Upload the demand note image in JPG, PNG or PDF format."
        );
      }
      setViewBackdrop(false);
    },
  });

  const fieldItemFormik = useFormik({
    initialValues: {
      iv_fieldItemId: "",
      iv_fieldItemQty: "",
      iv_fieldItemRate: "",
      iv_fieldItemUnit: "",
      iv_fieldItemAmount: "",
      iv_items_array: itemsArray,
    },
    validationSchema: Yup.object().shape({
      iv_fieldItemId: Yup.mixed().required("Select the item from list."),
      iv_fieldItemQty: Yup.number().required("Enter qty."),
      iv_fieldItemRate: Yup.string().optional(),
      iv_fieldItemUnit: Yup.string().optional(),
      iv_fieldItemAmount: Yup.string().optional(),
    }),

    onSubmit: (values, { resetForm }) => {
      let itemToBeAdded = {};
      let arrayOfItems = [...itemsArray];

      const qty = parseFloat(values.iv_fieldItemQty);
      const rate = parseFloat(values.iv_fieldItemRate);

      if (isNaN(qty) || qty <= 0) return;
      if (isNaN(rate) || rate < 0) return;

      itemToBeAdded.item_Code = values.iv_fieldItemId;

      // ✅ Case-insensitive match (handles both Item_Code / item_Code)
      let alreadyPresent = arrayOfItems.find(
        (item) =>
          String(item.item_Code).trim().toLowerCase() ===
          String(itemToBeAdded.item_Code).trim().toLowerCase()
      );

      if (alreadyPresent) {
        const index = arrayOfItems.findIndex(
          (item) =>
            String(item.item_Code).trim().toLowerCase() ===
            String(itemToBeAdded.item_Code).trim().toLowerCase()
        );
        arrayOfItems[index].qty = parseFloat(arrayOfItems[index].qty) + qty;
        arrayOfItems[index].amount = Math.round(
          arrayOfItems[index].qty * parseFloat(arrayOfItems[index].rate)
        );
      } else {
        // ✅ Handle both cases from backend
        let it = allMaterialList.find(
          (item) =>
            String(item.item_Code || item.Item_Code)
              .trim()
              .toLowerCase() ===
            String(itemToBeAdded.item_Code).trim().toLowerCase()
        );

        if (it) {
          itemToBeAdded.item_Code = it.item_Code || it.Item_Code;
          itemToBeAdded.item_Name = it.item_Name || it.Item_Name;
          itemToBeAdded.unit = it.item_Unit || it.Item_Unit;
          itemToBeAdded.rate = parseFloat(it.item_Amount || it.Item_Amount || 0);
        } else return;

        itemToBeAdded.qty = qty;
        itemToBeAdded.amount = Math.round(qty * itemToBeAdded.rate);
        arrayOfItems.push(itemToBeAdded);
      }

      const { totalAmountofItems, store_charges, installation_charges } =
        calculateCharges(arrayOfItems);

      const total_charges =
        totalAmountofItems + store_charges + installation_charges;

      setItemsAmount(totalAmountofItems);
      setStoreCharges(store_charges);
      setInstallationCharges(installation_charges);
      setTotalCharges(total_charges);
      setItemsArray(arrayOfItems);

      resetForm();
    },
  });

  const scoPart2Formik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      // iv_store_requisition_no: Yup.string()
      //   .required('Enter store requisition no.')
      //   .min(6, 'SRN should be 6 digits.')
      //   .max(6, 'SRN should be 6 digits.')
      //   .matches(/^[1-9][0-9]{5}$/, "SRN should be a 6-digit number and cannot start with 0."),
      // iv_store_requisition_date: Yup.date().max(new Date(), 'Requisition date must be in the past.').required('Enter requisition date.'),
      // iv_store_requisition_no: Yup.string()
      //   .required("Store Requisition No. is required")
      //   .length(6, "Must be 6 digits"),
      // iv_store_requisition_no: Yup.string()
      //   .when("$scoP2FillFlag", {
      //     is: 13, // agar flag 13 hai
      //     then: (schema) => schema.required("Store Requisition No. is required"),
      //     otherwise: (schema) =>
      //       schema
      //         .required("Store Requisition No. is required")
      //         .length(6, "Must be 6 digits"),
      //   }),

      iv_store_requisition_no: Yup.string()
        .required("Store Requisition No. is required")
        .test(
          "check-iv_store_requisition_no",
          "Store Requisition No. must be 6 digits",
          function (value) {
            const { dialogRowData } = this.options.context;
            const appId = dialogRowData?.applicationId || "";
            const status = dialogRowData?.status; // assuming status is in dialogRowData

            // agar '13' hai → skip 6-digit validation
            if (appId.slice(3, 5) === "13") {
              return true;
            }

            // agar Approved case hai to 6-digit check apply karo
            if (status === "Approved") {
              return !!value && value.length === 6;
            }
            return true;
          }
        ),

      iv_store_requisition_date: dialogRowData?.storeRequisitionDate
        ? Yup.string()
        : Yup.string().required("Store Requisition Date is required"),
      iv_sanctioned_load: Yup.number()
        .when([], {
          is: () => dialogRowData.connectionType === "Domestic",
          then: Yup.number()
            .min(2, "Load can't be less than 2.")
            .max(1000, "Residential Maximum Load 1000kW.")
            .required("Enter sanctioned load."),
        })
        .when([], {
          is: () => dialogRowData.connectionType === "Commercial",
          then: Yup.number()
            .min(2, "Load can't be less than 2.")
            .max(5000, "Commercial Maximum Load 5000kW.")
            .required("Enter sanctioned load."),
        })
        .when([], {
          is: () => dialogRowData.connectionType === "Industrial",
          then: Yup.number()
            .min(2, "Load can't be less than 2.")
            .required("Enter sanctioned load."),
        })
        .when([], {
          is: () => dialogRowData.connectionType === "Agriculture",
          then: Yup.number()
            .min(2, "Load can't be less than 2.")
            .max(5000, "Applied load cannot be more than 5000kW.")
            .required("Enter sanctioned load."),
        })
        .when([], {
          is: () =>
            [
              "Tubewell",
              "Temporary",
              "GeneralServices",
              "Electrification",
              "StreetLight",
              "CorporateCompany",
            ].includes(dialogRowData.connectionType),
          then: Yup.number()
            .min(2, "Load can't be less than 2.")
            .max(5000, "Applied load cannot be more than 5000kW.")
            .required("Enter sanctioned load."),
        })
        .required("Enter sanctioned load."),
      iv_seasonal_flag: Yup.mixed().when("phase", {
        is: () => phase != "Single Phase" || phase != "3 Phase",
        then: Yup.mixed().required("Select seasonal / non seasonal value."),
        otherwise: Yup.mixed().optional(),
      }),
      iv_meter_range: Yup.number("Range should be a number.")
  .min(4, "Range can't be less than 4.")
  .max(8, "Range can't be greater than 8.")
  .required("Enter meter range."),
      iv_meter_code1: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .matches(/^[0-9]{6}$/, "Code must be a 6-digit number.")
          .nullable()
          .required("Enter meter code."),
        otherwise: Yup.string()
          .oneOf(
            ["000002", "050502"],
            "For Single Phase, the meter code must be 000002."
          )
          .required("Enter meter code."),
      }),

      iv_meter_code2: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .matches(/^[0-9]{6}$/, "Code must be a 6-digit number.")
          .nullable()
          .required("Enter meter code."),
        otherwise: Yup.string().nullable().optional(),
      }),
      iv_transformer_code: Yup.string().optional(),
      iv_transformer_refNo: Yup.string().when("$userCompany", {
        is: (val) => val !== "13", // Compare as string
        then: Yup.string()
          .required("Transformer reference no is required.")
          .min(14, "Please enter 14 digit transformer reference no.")
          .max(14, "Please enter 14 digit transformer reference no.")
          .matches(
            /^[0-9]+$/,
            "Enter 14 digit transformer reference no as 01234567891234"
          ),
        otherwise: Yup.string() // optional if userCompany is '13'
          .min(14, "Please enter 14 digit transformer reference no.")
          .max(14, "Please enter 14 digit transformer reference no.")
          .matches(
            /^[0-9]+$/,
            "Enter 14 digit transformer reference no as 01234567891234"
          )
          .optional(),
      }),

      iv_location_code: Yup.mixed().required("Select location."),
      iv_manufacturer_code: Yup.string().required("Select Manufacturer."),
      // iv_meter_serial_no: Yup.string()
      //   .required('Enter meter number.')
      //   .min(7, 'Meter no. should be 7 digits.')
      //   .max(15, 'Meter no. should be 15 digits.')
      //   .matches(/^[0-9]+$/, "Meter no. should be number only.")
      //   .when('iv_manufacturer_code', (iv_manufacturer_code, schema) => {
      //     return schema.test(
      //       'starts-with-manufacturer-code',
      //       'Meter number should start with the manufacturer code.',
      //       (value) => value && value.startsWith(iv_manufacturer_code.toString())
      //     )
      //   }
      //   ),
      // iv_meter_serial_no: Yup.string()
      //   .required('Enter meter number.')
      //   .length(10, 'Meter number should be exactly 10 digits.')
      //   .matches(/^\d{10}$/, 'Meter number should contain digits only.')
      //   .when('iv_manufacturer_code', (iv_manufacturer_code, schema) => {
      //     return schema.test(
      //       'starts-with-manufacturer-code',
      //       'Meter number should start with the manufacturer code.',
      //       (value) =>
      //         value &&
      //         iv_manufacturer_code &&
      //         value.startsWith(iv_manufacturer_code.toString())
      //     );
      //   }),
      iv_meter_serial_no: Yup.string()
        .required("Enter Meter serial no.")
        .when([], {
          is: () =>
            (scoDetails?.meterType === 1 || scoDetails?.meterType === "1") &&
            dialogRowData?.applicationId?.startsWith("NC-14"),
          then: (schema) =>
            schema
              .length(14, "Meter serial no. should be exactly 14 digits for Smart meter.")
              .matches(/^\d{14}$/, "Meter serial no. should contain digits only."),
          otherwise: (schema) =>
            schema
              .length(10, "Meter serial no. should be exactly 10 digits.")
              .matches(/^\d{10}$/, "Meter serial no. should contain digits only."),
        }),

      // iv_sim_number: Yup.string().when([], {
      //   is: () => scoDetails?.meterType === 1 || scoDetails?.meterType === "1",
      //   then: (schema) =>
      //     schema
      //       .required('Enter SIM number.')
      //       .matches(/^03[0-9]{9}$/, 'SIM number must start with 03 and be 11 digits total.'),
      //   otherwise: (schema) => schema.notRequired(),
      // }),

      // iv_sim_ID: Yup.string().when([], {
      //   is: () => scoDetails?.meterType === 1 || scoDetails?.meterType === "1",
      //   then: (schema) =>
      //     schema
      //       .required('Enter SIM ID.')
      //       .min(18, 'SIM ID should be at least 18 characters.')
      //       .max(20, 'SIM ID should not exceed 20 characters.'),
      //   otherwise: (schema) => schema.notRequired(),
      // }),
      iv_sim_number: Yup.string()
        .nullable()
        .when([], {
          is: () =>
            scoDetails?.meterType !== 0 && scoDetails?.meterType !== "0" &&
            !dialogRowData?.applicationId?.startsWith("NC-13"),
          then: (schema) =>
            schema
              .required("Enter SIM number.")
              .matches(
                /^03[0-9]{9}$/,
                "SIM number must start with 03 and be 11 digits total."
              ),
          otherwise: (schema) => schema.notRequired(),
        }),

      iv_sim_ID: Yup.string()
        .nullable()
        .when([], {
          is: () =>
            scoDetails?.meterType !== 0 && scoDetails?.meterType !== "0",
          then: (schema) =>
            schema
              .required("Enter SIM ID.")
              .min(18, "SIM ID should be at least 18 characters.")
              .max(20, "SIM ID should not exceed 20 characters."),
          otherwise: (schema) => schema.notRequired(),
        }),

      iv_meter_reading: Yup.string().when("phase", {
        is: () => phase === "Single Phase",
        then: Yup.string()
          .max(9, "Meter reading can not be more than 999999999.")
          .min(1, "Meter reading can not be less than 1.")
          .required("Enter meter reading.")
          .matches(/^[0-9]+$/, "Enter meter reading in numbers."),
        otherwise: Yup.string().optional(),
      }),
      iv_meter_reading_peak_kwh: Yup.string().when("phase", {
        is: () => phase != "Single Phase",
        then: Yup.string()
          .required("Enter peak reading.")
          .test(
            "is-decimal",
            "Enter peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value)
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_meter_reading_off_peak_kwh: Yup.string().when("phase", {
        is: () => phase != "Single Phase",
        then: Yup.string()
          .required("Enter off peak reading.")
          .test(
            "is-decimal",
            "Enter off peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value)
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_meter_reading_peak_kvarh: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .required("Enter peak reading.")
          .test(
            "is-decimal",
            "Enter peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value)
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_meter_reading_off_peak_kvarh: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .required("Enter peak reading.")
          .test(
            "is-decimal",
            "Enter off peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value)
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_date_of_connection: Yup.date()
        .max(new Date(), "Connection date must be in the past.")
        .required("Enter connection date."),
      iv_connection_installer_name: Yup.string()
        .required("Enter installed by name.")
        .max(30, "Name should be less than 30 characters."),
      iv_installed_meter_image: Yup.mixed().optional(),
      iv_meter_type: Yup.mixed().required("Select meter type!"),
      iv_ct_nom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter CT Nom.")
          .matches(/^\d+$/, "Enter CT Nom in whole numbers.")
          .test(
            "ct-standard-values",
            "The CT Nom must be 0, 5, 100, 200, 300, 400, 600, 800, 1000.",
            (value) => {
              if (value === undefined || value === null) return false;
              const ctNom = parseInt(value, 10);
              return [0, 5, 100, 200, 300, 400, 600, 800, 1000].includes(ctNom);
            }
          ),
        otherwise: Yup.string().nullable(),
      }),
      iv_ct_denom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter CT Denom.")
          .matches(/^\d+$/, "Enter CT Denom in whole numbers.")
          .test(
            "is-less-than-nom",
            "CT Denom must be less than CT Nom.",
            function (value) {
              const { iv_ct_nom } = this.parent;
      
              if (!value || !iv_ct_nom) return true;
      
              const nom = parseInt(iv_ct_nom, 10);
              const denom = parseInt(value, 10);
      
              // allow 0 safely
              if (denom === 0) return true;
      
              return denom < nom;
            }
          ),
        otherwise: Yup.string().nullable(),
      }),
      iv_pt_nom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter PT Nom.")
          .matches(/^\d+$/, "Enter PT Nom in whole numbers.")
          .test(
            "pt-valid",
            "PT Nom validation failed.",
            function (value) {
              const { iv_pt_denom } = this.parent;
      
              if (!value || !iv_pt_denom) return true;
      
              return parseInt(iv_pt_denom, 10) <= parseInt(value, 10);
            }
          ),
        otherwise: Yup.string().nullable(),
      }),
      iv_pt_denom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter PT Denom.")
          .matches(/^\d+$/, "Enter PT Denom in whole numbers."),
        otherwise: Yup.string().nullable(),
      }),
      iv_mdi: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .required("Enter PT Denom.")
          .matches(/^[1-9]\d*$/, "Enter PT Denom in numbers greater than 0.")
          .test(
            "is-positive",
            "PT Denom must be greater than 0.",
            (value) => parseFloat(value) > 0
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_no_of_mdi_resets: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .max(5, "No. of MDI reset can not be more than 99999.")
          .min(1, "No. of MDI reset can not be less than 1.")
          .required("Enter No. of MDI reset.")
          .matches(/^[0-9]+$/, "Enter No. of MDI reset in numbers."),
        otherwise: Yup.string().optional().nullable(),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      setSubmitSCOApiError("");
      let applicationProgressId = dialogRowData.applicationProgressId;
      let remarks = "";
      let scoPart2FillFlag = 0;
      let scoP2ApprovalFlag = 0;
      let scoP2ApprovedByDesignation = "";
      let authorizedByName = "";
      let authorizedByDesignation = "";

      if (scoDetails.scoP2FillFlag === null || scoDetails.scoP2FillFlag == 0) {
        remarks = "Meter Installed on premises.";
        scoPart2FillFlag = 1;
      } else if (scoDetails.scoP2FillFlag == 1) {
        applicationProgressId += 1;
        remarks = "Meter Installation Approved.";
        scoPart2FillFlag = 1;
        scoP2ApprovalFlag = 1;
        scoP2ApprovedByDesignation = roleName;
        authorizedByName = userId;
        authorizedByDesignation = roleName;
      }

      if (
        scoDetails.scoP2FillFlag == 1 ||
        (!scoDetails.scoP2FillFlag && installedMeterImageThumbnail)
      ) {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          applicationProgressId: applicationProgressId,
          remarks: remarks,
          objectionStatus: 0,
          scoId: scoDetails.scoId,
          scoP2FillFlag: scoPart2FillFlag,
          scoP2ApprovalFlag: scoP2ApprovalFlag,
          scoP2ApprovedByDesignation: scoP2ApprovedByDesignation,
          authorizedByName: authorizedByName,
          authorizedByDesignation: authorizedByDesignation,
          storeRequisitionNo: values.iv_store_requisition_no,
          storeRequisitionDate: values.iv_store_requisition_date,
          seasonalFlag: values.iv_seasonal_flag,
          senctionLoad: values.iv_sanctioned_load,
          installedTransformerCapacity: values.iv_transformer_code,
          transformerRefNo: values.iv_transformer_refNo,
          meterNo: values.iv_meter_serial_no,
          locationCode: values.iv_location_code,
          meterCode1: values.iv_meter_code1,
          meterCode2: values.iv_meter_code2,
          manufacturerCode: values.iv_manufacturer_code,
          multiplyingFactor:
            phase != "Single Phase" && phase != "3 Phase"
              ? (() => {
                const val = calculateMF(
                  values.iv_ct_nom,
                  values.iv_ct_denom,
                  values.iv_pt_nom,
                  values.iv_pt_denom
                );

                return !isFinite(val) || val === 0 ? 1 : val;
              })()
              : "",
          meterRange: values.iv_meter_range,
          meterReading: phase === "Single Phase" ? values.iv_meter_reading : "",
          dateOfConnection: values.iv_date_of_connection,
          installedMeterImage: installedMeterImageThumbnail,
          cT:
            phase != "Single Phase" && phase != "3 Phase" && calculateMF(
              values.iv_ct_nom,
              values.iv_ct_denom,
              values.iv_pt_nom,
              values.iv_pt_denom
            )
              ? values.iv_ct_nom / values.iv_ct_denom
              : "",
          cTD:
            phase != "Single Phase" && phase != "3 Phase" && calculateMF(
              values.iv_ct_nom,
              values.iv_ct_denom,
              values.iv_pt_nom,
              values.iv_pt_denom
            ) === 1
              ? 0
              : phase != "Single Phase" && phase != "3 Phase"
                ? values.iv_ct_denom
                : "",
          cTN:
            phase != "Single Phase" && phase != "3 Phase" && calculateMF(
              values.iv_ct_nom,
              values.iv_ct_denom,
              values.iv_pt_nom,
              values.iv_pt_denom
            ) === 1
              ? 0
              : phase != "Single Phase" && phase != "3 Phase"
                ? values.iv_ct_nom
                : "",
          pT:
            phase != "Single Phase" && phase != "3 Phase"
              ? values.iv_pt_nom / values.iv_pt_denom
              : "",
          pTD:
            phase != "Single Phase" && phase != "3 Phase" && calculateMF(
              values.iv_ct_nom,
              values.iv_ct_denom,
              values.iv_pt_nom,
              values.iv_pt_denom
            ) === 1
              ? 0
              : phase != "Single Phase" && phase != "3 Phase"
                ? values.iv_pt_denom
                : "",
          pTN:
            phase != "Single Phase" && phase != "3 Phase" && calculateMF(
              values.iv_ct_nom,
              values.iv_ct_denom,
              values.iv_pt_nom,
              values.iv_pt_denom
            ) === 1
              ? 0
              : phase != "Single Phase" && phase != "3 Phase"
                ? values.iv_pt_nom
                : "",
          threePhasePeakKVARH:
            phase != "Single Phase" && phase != "3 Phase"
              ? values.iv_meter_reading_peak_kvarh
              : "",
          threePhaseOffPeakKVARH:
            phase != "Single Phase" && phase != "3 Phase"
              ? values.iv_meter_reading_off_peak_kvarh
              : "",
          threePhasePeakKWH:
            phase != "Single Phase" && phase != "3 Phase"
              ? values.iv_meter_reading_peak_kwh
              : "",
          threePhaseOffPeakKWH:
            phase != "Single Phase" && phase != "3 Phase"
              ? values.iv_meter_reading_off_peak_kwh
              : "",
          connectionInstallerName: values.iv_connection_installer_name,
          meterType: values.iv_meter_type,
          threePhasePeak:
            phase === "3 Phase" ? values.iv_meter_reading_peak_kwh : "",
          threePhaseOffPeak:
            phase === "3 Phase" ? values.iv_meter_reading_off_peak_kwh : "",
          mdi:
            phase != "Single Phase" && phase != "3 Phase" ? values.iv_mdi : "",
          noOfMDIreset:
            phase != "Single Phase" && phase != "3 Phase"
              ? values.iv_no_of_mdi_resets
              : "",
          simId: values.iv_sim_ID,
          simNumber: values.iv_sim_number,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        await fetch(cfpBaseUrl + "enc/submitSCO", requestOptions)
          .then(async (response) => {
            let result;
            try {
              result = await response.json();
            } catch {
              setSubmitSCOApiError("Invalid response from server.");
              return;
            }
            const ok =
              result?.status === "200" ||
              result?.status === 200 ||
              result?.status === "201";
            if (ok) {
              setSubmitSCOApiError("");
              resetForm();
              handleClose();
              if (scoDetails.scoP2FillFlag === 1) {
                setScoPopUp(true);
              }
            } else {
              setSubmitSCOApiError(
                result?.message ||
                  (response.status
                    ? `Request failed (${response.status}).`
                    : "Request failed.")
              );
            }
          })
          .catch((error) => {
            console.log(error);
            setSubmitSCOApiError(
              "Network error. Please check your connection and try again."
            );
          });
      } else {
        setInstalledMeterImageError(
          "Upload the Installed meter image in JPG, PNG."
        );
      }

      setViewBackdrop(false);
    },
  });

  // Set Meter Installation form values from scoDetails when scoP2FillFlag === 1
  useEffect(() => {
    const appId = dialogRowData?.applicationId || "";

    // Set Store Requisition No. from scoDetails
    if (scoDetails?.storeRequisitionNo) {
      scoPart2Formik.setFieldValue("iv_store_requisition_no", scoDetails.storeRequisitionNo);
    }
    // Set Store Requisition Date from scoDetails
    if (scoDetails?.storeRequisitionDate) {
      scoPart2Formik.setFieldValue("iv_store_requisition_date", scoDetails.storeRequisitionDate.slice(0, 10));
    }
    // Set Sanctioned Load from scoDetails or dialogRowData.appliedLoad
    if (scoDetails?.senctionLoad) {
      scoPart2Formik.setFieldValue("iv_sanctioned_load", scoDetails.senctionLoad);
    } else if (dialogRowData?.appliedLoad) {
      scoPart2Formik.setFieldValue("iv_sanctioned_load", dialogRowData.appliedLoad);
    }

    // When scoP2FillFlag === 1, set all meter installation form values
    if (scoDetails?.scoP2FillFlag === 1) {
      scoPart2Formik.setFieldValue("iv_seasonal_flag", scoDetails.seasonalFlag);
      scoPart2Formik.setFieldValue("iv_no_of_acs", scoDetails.noOfACs);
      scoPart2Formik.setFieldValue("iv_no_of_meters", scoDetails.noOfMeters);
      scoPart2Formik.setFieldValue("iv_no_of_meter_sets", scoDetails.noOfMeterSets);
      scoPart2Formik.setFieldValue("iv_no_of_sub_sets", scoDetails.noOfSubSets);
      scoPart2Formik.setFieldValue("iv_no_ofsupply_points", scoDetails.noOfSupplyPoints);
      if (!scoPart2Formik.touched.iv_transformer_code) {
        scoPart2Formik.setFieldValue(
          "iv_transformer_code",
          scoDetails.installedTransformerCapacity
        );
      }
      if (!scoPart2Formik.touched.iv_transformer_refNo) {
        scoPart2Formik.setFieldValue(
          "iv_transformer_refNo",
          scoDetails.transformerRefNo
        );
      }
      scoPart2Formik.setFieldValue("iv_meter_id", scoDetails.meterId);
      scoPart2Formik.setFieldValue("iv_meter_serial_no", scoDetails.meterNo);
      scoPart2Formik.setFieldValue("iv_sim_ID", scoDetails.simId);
      scoPart2Formik.setFieldValue("iv_sim_number", scoDetails.simNumber);
      scoPart2Formik.setFieldValue("iv_location_code", scoDetails.locationCode ? scoDetails.locationCode : "");
      scoPart2Formik.setFieldValue("iv_meter_code1", scoDetails.meterCode1);
      scoPart2Formik.setFieldValue("iv_meter_code2", scoDetails.meterCode2);
      scoPart2Formik.setFieldValue("iv_manufacturer_code", scoDetails.manufacturerCode);
      scoPart2Formik.setFieldValue("iv_multiplying_factor", scoDetails.multiplyingFactor);
      scoPart2Formik.setFieldValue("iv_meter_range", scoDetails.meterRange);
      scoPart2Formik.setFieldValue("iv_meter_reading", scoDetails.meterReading);
      scoPart2Formik.setFieldValue("iv_cp_78_item_no", scoDetails.cp78ItemNo);
      scoPart2Formik.setFieldValue("iv_tie_up_non_tie_up", scoDetails.tieUpNonTieUp);
      scoPart2Formik.setFieldValue("iv_seal_on_meter", scoDetails.sealOnMeter);
      scoPart2Formik.setFieldValue("iv_seal_on_box", scoDetails.sealOnBox);
      scoPart2Formik.setFieldValue("iv_security_slip_or_price_bond_no", scoDetails.securitySlipOrPriceBondNo);
      scoPart2Formik.setFieldValue("iv_connection_installer_name", scoDetails.connectionInstallerName);
      scoPart2Formik.setFieldValue("iv_installed_meter_image", scoDetails.installedMeterImage);
      scoPart2Formik.setFieldValue("iv_meter_type", scoDetails.meterType);
      setMeterTypeValueForCheck(scoDetails.meterType);
      if (phase == "3 Phase") {
        scoPart2Formik.setFieldValue("iv_meter_reading_peak_kwh", scoDetails.threePhasePeak);
        scoPart2Formik.setFieldValue("iv_meter_reading_off_peak_kwh", scoDetails.threePhaseOffPeak);
      } else {
        scoPart2Formik.setFieldValue("iv_meter_reading_peak_kwh", scoDetails.threePhasePeakKWH);
        scoPart2Formik.setFieldValue("iv_meter_reading_off_peak_kwh", scoDetails.threePhaseOffPeakKWH);
      }
      scoPart2Formik.setFieldValue("iv_mdi", scoDetails.mdi);
      scoPart2Formik.setFieldValue("iv_no_of_mdi_resets", scoDetails.noOfMDIreset);
      scoPart2Formik.setFieldValue("iv_ct", scoDetails.cT);
      scoPart2Formik.setFieldValue("iv_pt", scoDetails.pT);
      scoPart2Formik.setFieldValue("iv_ct_nom", scoDetails.cTN);
      scoPart2Formik.setFieldValue("iv_pt_nom", scoDetails.pTN);
      scoPart2Formik.setFieldValue("iv_ct_denom", scoDetails.cTD);
      scoPart2Formik.setFieldValue("iv_pt_denom", scoDetails.pTD);
      scoPart2Formik.setFieldValue("iv_meter_reading_peak_kvarh", scoDetails.threePhasePeakKVARH);
      scoPart2Formik.setFieldValue("iv_meter_reading_off_peak_kvarh", scoDetails.threePhaseOffPeakKVARH);
      if (scoDetails.dateOfConnection) {
        scoPart2Formik.setFieldValue("iv_date_of_connection", scoDetails.dateOfConnection.slice(0, 10));
      }
      setInstalledMeterImageThumbnail(scoDetails.installedMeterImage);
      let mC = manufacturesList.find((item) => item.code == scoDetails.manufacturerCode);
      setManufcaturerCode(mC);
    } else if (!scoDetails?.scoP2FillFlag || scoDetails?.scoP2FillFlag === 0) {
      // Set default Installed By (connection installer name) to current user
      if (!scoPart2Formik.values.iv_connection_installer_name) {
        scoPart2Formik.setFieldValue("iv_connection_installer_name", userId);
      }
      // Set default Meter Code based on phase when scoP2FillFlag is not 1
      if (appId.slice(3, 5) === "13") {
        if (phase === "Single Phase") {
          scoPart2Formik.setFieldValue("iv_meter_code1", "000002");
        } else if (phase === "3 Phase") {
          scoPart2Formik.setFieldValue("iv_meter_code1", "050502");
          scoPart2Formik.setFieldValue("iv_meter_code2", "050602");
        }

        // Set CT values based on phase
        if (phase === "MDI (LT)(CT)" || phase === "MDI (HT)(CT/PT)") {
          scoPart2Formik.setFieldValue("iv_ct_nom", "5");
          scoPart2Formik.setFieldValue("iv_ct_denom", "5");
        } else {
          scoPart2Formik.setFieldValue("iv_ct_nom", "1");
          scoPart2Formik.setFieldValue("iv_ct_denom", "1");
        }

        // Set PT values for HT phase
        if (phase === "MDI (HT)(CT/PT)") {
          scoPart2Formik.setFieldValue("iv_pt_nom", "11000");
          scoPart2Formik.setFieldValue("iv_pt_denom", "110");
        }
      }
    }
  }, [dialogRowData, scoDetails, phase]);

  const handleCostEstimationClose = () => {
    setShowCostEstimation(false);
  };
  const masterDataFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_govt_dept: Yup.mixed().required("Select Govt Dept."),
      iv_batch: Yup.mixed().required("Select batch."),
      iv_ed_code: Yup.mixed().required("Select Electricity Duty code."),
      // iv_standard_classification_code: Yup.mixed().when(['iv_ed_code'], {
      //   is: (iv_ed_code) => {
      //     // Extract the numeric part inside parentheses
      //     const matchedTariff = tariff.match(/\((\d{2})\)/);
      //     const numericTariff = matchedTariff ? matchedTariff[1] : null;

      //     return ['01', '02', '03'].includes(numericTariff) && !['5', '6'].includes(iv_ed_code);
      //   },
      //   then: Yup.mixed()
      //     .required('Select Std. classification code.')
      //     .test(
      //       'is-valid-code',
      //       'Invalid Std. classification code.',
      //       (value) => {
      //         // Extract the part after `-`
      //         const code = value ? value.split(' - ')[1] : null;
      //         return ['00100', '00101', '00102', '00103', '00104', '00105', '00106', '00107', '00108', '00109'].includes(code);
      //       }
      //     ),
      //   otherwise: Yup.mixed().required('Select Std. classification code.'),
      // }),
      iv_standard_classification_code: Yup.mixed().when(["iv_ed_code"], {
        is: (iv_ed_code) => {
          const matchedTariff = tariff.match(/\((\d{2})\)/);
          const numericTariff = matchedTariff ? matchedTariff[1] : null;
          return (
            ["01", "02", "03"].includes(numericTariff) &&
            !["5", "6"].includes(iv_ed_code)
          );
        },
        then: Yup.mixed()
          .required("Select Std. classification code.")
          .test(
            "is-valid-code",
            "Invalid Std. classification code.",
            (value) => {
              return standardClassificationCodes.some(
                (code) => code.XCLFM_CODE === value
              );
            }
          ),
        otherwise: Yup.mixed().required("Select Std. classification code."),
      }),

      iv_income_tax: Yup.mixed().required("Select Income tax value."),
      iv_authority: Yup.mixed().optional("Select Authority."),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);

      let applicationProgressId = dialogRowData.applicationProgressId;
      let remarks = "";
      let filledByFlag = 0;
      let approvalFlag = 0;
      let approvedBy = "";
      let approvedByDesignation = "";

      if (
        masterDataFormDetails.filledByFlag == null ||
        masterDataFormDetails.filledByFlag == 0
      ) {
        remarks = "CP-136 Created.";
        filledByFlag = 1;
      } else if (masterDataFormDetails.filledByFlag === 1) {
        applicationProgressId += 1;
        remarks = "CP-136 Approved.";
        filledByFlag = 1;
        approvalFlag = 1;
        approvedBy = userId;
        approvedByDesignation = roleName;
      }

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: applicationProgressId,
        remarks: remarks,
        objectionStatus: 0,
        cp136Type: 1,
        electricityDuty: masterDataFormik.values.iv_ed_code,
        governmentDepartment: masterDataFormik.values.iv_govt_dept,
        standardClassificationCode:
          masterDataFormik.values.iv_standard_classification_code,
        incomeTax: masterDataFormik.values.iv_income_tax,
        reason: "New Connection",
        authority: parseInt(dialogRowData.appliedLoad) < 15 ? "SDO" : "XEN",
        filledByFlag: filledByFlag,
        approvedByDesignation: approvedByDesignation,
        approvalFlag: approvalFlag,
        connectionAccountNo: masterDataFormik.values.iv_batch
          .concat(dialogRowData.subDivisionCode)
          .concat(dnDetails.consumerAccountNo),
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "enc/submitCP136", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setSubmitCP136Error("");
            resetForm();
            handleClose();
            if (masterDataFormDetails.filledByFlag === 1) {
              setCpPopUp(true);
            }
          } else if (result.status === "400") {
            setSubmitCP136Error(result.message);
            if (result.message === "Reference No. already exist." || result.message === "Reference No. already exist (IBS)." || result.message === "Reference No. already exist (eOps).") {
              setRefNoUpdatePopup(true);
            } else {
              setCpPopUp(true);
            }
          }
        })
        .catch((error) => console.log(error));
      setViewBackdrop(false);
    },
  });

  const arearBillDocumentFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_arear_paid_bill_document: Yup.mixed().required(
        "Upload arrears paid bill document!"
      ),
      iv_arear_paid_bill_date: Yup.string().required(
        "Enter date on which arrears are paid!"
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      if (arearPaidBillDocumentThumbnail) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", token);

        var raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          paidBillDate: values.iv_arear_paid_bill_date,
          paidBillImage: arearPaidBillDocumentThumbnail,
        });

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        await fetch(
          cfpBaseUrl + "comman/updateENCArearPaidBillImage",
          requestOptions
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              callChangeObjectionStatus(
                0,
                "Arrears Objection Removed",
                "Arrears Paid by consumer"
              );
              callChangeProgressIdAPI(
                3,
                "Arrears Verified",
                "Arrears Verified",
                "",
                dialogRowData.applicationId
              );
              resetForm();
              setRejectionRemovalAlert(false);
              handleClose();
            } else {
              // console.log(result.message)
            }
          })
          .catch((error) => console.log(error));
      } else {
        setArearPaidBillDocumentError(
          "Upload the Paid Bill image in JPG, PNG or PDF format."
        );
      }
      setViewBackdrop(false);
    },
  });

  const editBasicInfoFormik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object().shape({
      // Classification group Validations
      iv_connection_type: Yup.mixed()
        .required("Please select connection type.")
        .test(
          "valid-connection-type",
          "Please select a valid option",
          function (value) {
            if (!value) return false;
            // If API list is loaded, validate against it; otherwise allow any non-empty value
            if (connectionTypesList.length > 0) {
              return connectionTypesList.some(type => type.connectionTypeName === value);
            }
            return true;
          }
        ),
      iv_applied_load: Yup.number()
        .when("iv_connection_type", {
          is: "Domestic",
          then: Yup.number()
            .min(3, `Load can't be less than 3.`)
            .max(1000, "Residential Maximum Load 1000kW.")
            .required("Please enter applied load."),
        })
        .when("iv_connection_type", {
          is: "Commercial",
          then: Yup.number()
            .min(3, `Load can't be less than 3.`)
            .max(5000, "Commercial Maximum Load 5000kW.")
            .required("Please enter applied load."),
        })
        .when("iv_connection_type", {
          is: "Industrial",
          then: Yup.number()
            .min(3, `Load can't be less than 3.`)
            .required("Please enter applied load."),
        })
        .when("iv_connection_type", {
          is: "Agriculture",
          then: Yup.number()
            .min(3, `Load can't be less than 3.`)
            .max(5000, "Applied load cannot be more than 5000kW.")
            .required("Please enter applied load."),
        })
        .when("iv_connection_type", {
          is: "Tubewell",
          then: Yup.number()
            .min(3, `Load can't be less than 3.`)
            .max(5000, "Applied load cannot be more than 5000kW.")
            .required("Please enter applied load."),
        })
        .when("iv_connection_type", {
          is: "Temporary",
          then: Yup.number()
            .min(3, `Load can't be less than 3.`)
            .max(5000, "Applied load cannot be more than 5000kW.")
            .required("Please enter applied load."),
        })
        .when("iv_connection_type", {
          is: "GeneralServices",
          then: Yup.number()
            .min(3, `Load can't be less than 3.`)
            .max(5000, "Applied load cannot be more than 5000kW.")
            .required("Please enter applied load."),
        })
        .when("iv_connection_type", {
          is: "Electrification",
          then: Yup.number()
            .min(3, `Load can't be less than 3.`)
            .max(5000, "Applied load cannot be more than 5000kW.")
            .required("Please enter applied load."),
        })
        .when("iv_connection_type", {
          is: "StreetLight",
          then: Yup.number()
            .min(3, `Load can't be less than 3.`)
            .max(5000, "Applied load cannot be more than 5000kW.")
            .required("Please enter applied load."),
        })
        .when("iv_connection_type", {
          is: "CorporateCompany",
          then: Yup.number()
            .min(3, `Load can't be less than 3.`)
            .max(5000, "Applied load cannot be more than 5000kW.")
            .required("Please enter applied load."),
        })
        .when("iv_area_type", (areaType, schema) => {
          if (areaType === "Rural") {
            return schema
              .min(2, "Load can't be less than 2 in case of Rural.")
              .max(5000, "Applied load cannot be more than 5000kW.");
          } else if (areaType === "Urban") {
            return schema
              .min(3, "Load can't be less than 3 in case of Urban.")
              .max(5000, "Applied load cannot be more than 5000kW.");
          }
          return schema;
        }),
      iv_near_by_reference_no: Yup.string()
        .min(14, "Please enter 14 digit reference number.")
        .max(14, "Please enter 14 digit reference number.")
        .matches(
          /^[0-9]+$/,
          "Enter 14 digit reference number as 01234567891234"
        )
        .optional(),
      iv_circle: Yup.mixed().required("Please select a circle."),
      iv_division: Yup.mixed().required("Please select a division."),
      iv_near_by_name: Yup.string().optional(),
      iv_near_by_address: Yup.string().optional(),
      iv_sub_divison: Yup.mixed().required("Please select a sub division."),
      iv_applicant_status: Yup.mixed()
        .required("Please select applicant status.")
        .oneOf(applicantStatusForValidation, "Please select a valid option"),
      iv_meter_seasonal: Yup.mixed().required(
        "Please select Meter seasonal type."
      ),
      iv_applicant_name: Yup.string()
        .min(3, "Name should be atleast 3 characters.")
        .max(30, "Name should be less than 30 characters.")
        .required("Please enter applicant name.")
        .matches(/^[A-Za-z. ]*$/, "Only letters and '.' are allowed."),
      iv_applicant_cnic: Yup.string()
        .min(13, "Please enter 13 digit CNIC.")
        .max(13, "Please enter 13 digit CNIC.")
        .required("Please enter valid CNIC number.")
        .matches(/^[0-9]+$/, "Enter CNIC number as 3520212345678."),
      iv_applicant_citizenship: Yup.mixed()
        .required("Please select citizenship.")
        .oneOf(
          applicantCitizenshipForValidation,
          "Please select a valid option"
        ),
      iv_applicant_phone_no: Yup.string()
        .max(11, "Please enter 11 digit phone number.")
        .min(11, "Please enter 11 digit phone number.")
        .required("Please enter valid mobile number.")
        .matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
      iv_applicant_email: Yup.string()
        .email("Enter email as 'john@gmail.com'.")
        .notRequired(),
      iv_relation_type: Yup.mixed().required("Please select relation type."),
      iv_relative_name: Yup.string()
        .min(3, "Name should be atleast 3 characters.")
        .max(30, "Name should be less than 30 characters.")
        .required("Please enter relative name.")
        .matches(/^[A-Za-z. ]*$/, "Only letters and '.' are allowed."),
      iv_ntn: Yup.string().when("iv_connection_type", {
        is: (iv_connection_type) =>
          iv_connection_type === "Industrial" ||
          iv_connection_type === "Commercial" ||
          iv_connection_type === "Corporate Company",
        then: Yup.string()
          .required("Please enter valid NTN.")
          .min(7, "NTN. should be atleast 7 digits.")
          .max(13, "NTN. should be 13 digits."),
        otherwise: Yup.string().optional(),
      }),
      // STRN
      iv_strn: Yup.string().when("iv_connection_type", {
        is: (iv_connection_type) =>
          iv_connection_type === "Industrial" ||
          iv_connection_type === "Commercial" ||
          iv_connection_type === "Corporate Company",
        then: Yup.string()
          .required("Please enter valid STRN.")
          .max(13, "STRN. should be 13 digits.")
          .min(13, "STRN. should be 13 digits."),
        otherwise: Yup.string().optional(),
      }),
      iv_owner_name: Yup.string().when("iv_applicant_status", {
        is: (iv_applicant_status) => iv_applicant_status === "Tenant",
        then: Yup.string()
          .max(30)
          .required("Please enter valid owner name.")
          .matches(/^[A-Za-z. ]*$/, "Only letters and '.' are allowed."),
        otherwise: Yup.string(),
      }),
      iv_owner_cnic: Yup.string().when("iv_applicant_status", {
        is: (iv_applicant_status) => iv_applicant_status === "Tenant",
        then: Yup.string()
          .min(13, "Please enter 13 digit CNIC.")
          .max(13, "Please enter 13 digit CNIC.")
          .required("Please enter valid CNIC number.")
          .matches(/^[0-9]+$/, "Enter CNIC number as 3520212345678."),
        otherwise: Yup.string(),
      }),
      iv_owner_phone_no: Yup.string().when("iv_applicant_status", {
        is: (iv_applicant_status) => iv_applicant_status === "Tenant",
        then: Yup.string()
          .max(11, "Please enter 11 digit phone number.")
          .min(11, "Please enter 11 digit phone number.")
          .required("Please enter valid mobile number.")
          .matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
        otherwise: Yup.string(),
      }),
      // Owner Email
      iv_owner_email: Yup.string().when("iv_applicant_status", {
        is: (iv_applicant_status) => iv_applicant_status === "Tenant",
        then: Yup.string().email("Enter email as 'john@gmail.com'.").optional(),
        otherwise: Yup.string(),
      }),
      // Address group Validations
      iv_area_type: Yup.mixed()
        .required("Please select area type.")
        .oneOf(areaTypeForValidation, "Please select a valid option"),
      iv_meter_installed: Yup.number().required(
        "Please enter no of meters already installed."
      ),
      iv_city_district: Yup.string()
        .required("Please select a city.")
        .oneOf(cities ? cities : [], "Please select a valid option"),
      // Urban
      iv_address: Yup.string().when("iv_area_type", {
        is: "Urban", // Checks if iv_area_type is "Urban"
        then: Yup.string()
          .required("Enter address.")
          .max(40, `Address can't be more than 40 characters.`),
        otherwise: Yup.string()
          .required("Enter address.") // Applies for non-Urban values
          .max(30, `Address can't be more than 30 characters.`),
      }),
      iv_town_tehsil: Yup.string().when("iv_area_type", {
        is: (iv_area_type) => iv_area_type === "Rural",
        then: Yup.string()
          .max(15, "Tehsil must be less than 15 character")
          .required("Please enter town.")
          .matches(
            /^[a-zA-Z0-9/#\s]*$/,
            "Town must be alphanumeric characters only."
          ),
        otherwise: Yup.string(),
      }),
      // Required Documents Validation
      iv_applicant_cnic_document_front: Yup.mixed().required(
        "Please upload CNIC Front image in jpg, jpeg, png or pdf format."
      ),
      iv_applicant_cnic_document_back: Yup.mixed().required(
        "Please upload CNIC Back image in jpg, jpeg, png or pdf format."
      ),
      iv_property_documents: Yup.mixed().required(
        "Please upload property documents in jpg, jpeg, png or pdf format."
      ),
      iv_near_by_bill: Yup.mixed()
        .nullable()
        .notRequired(
          "Please upload near by electricity bill in jpg, jpeg, png or pdf format."
        ),
      iv_any_other_document: Yup.mixed()
        .nullable()
        .notRequired(
          "Please upload additional document in jpg, jpeg, png or pdf format."
        ),
      iv_owner_cnic_document_front: Yup.mixed().when("iv_applicant_status", {
        is: (iv_applicant_status) => iv_applicant_status === "Tenant",
        then: Yup.mixed().required(
          "Please upload CNIC Front in jpg, jpeg, png or pdf format."
        ),
        otherwise: Yup.mixed(),
      }),
      iv_owner_cnic_document_back: Yup.mixed().when("iv_applicant_status", {
        is: (iv_applicant_status) => iv_applicant_status === "Tenant",
        then: Yup.mixed().required(
          "Please upload CNIC Back in jpg, jpeg, png or pdf format."
        ),
        otherwise: Yup.mixed(),
      }),
      iv_noc_owner: Yup.mixed().when("iv_applicant_status", {
        is: (iv_applicant_status) => iv_applicant_status === "Tenant",
        then: Yup.mixed().required(
          "Please upload NoC in jpg, jpeg, png or pdf format."
        ),
        otherwise: Yup.mixed(),
      }),
      iv_resolution: Yup.mixed().when("iv_connection_type", {
        is: (iv_connection_type) => iv_connection_type === "Industrial",
        then: Yup.mixed().required(
          "Please upload resolution form in jpg, jpeg, png or pdf format."
        ),
        otherwise: Yup.mixed(),
      }),
      iv_memo: Yup.mixed()
        .nullable()
        .notRequired(
          "Please upload MoA Certificate in jpg, jpeg, png or pdf format."
        ),
      iv_form29initial: Yup.mixed().when("iv_connection_type", {
        is: (iv_connection_type) => iv_connection_type === "Industrial",
        then: Yup.mixed().required(
          "Please upload Form 29 in jpg, jpeg, png or pdf format."
        ),
        otherwise: Yup.mixed(),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      let isSubDivisionChanged =
        dialogRowData.nearByReferenceNumber.slice(2, 7) ==
          values.iv_near_by_reference_no.slice(2, 7)
          ? 0
          : 1;

      const formdata = new FormData();
      formdata.append("isSubDivisionChanged", isSubDivisionChanged);
      formdata.append("applicationId", dialogRowData.applicationId);
      formdata.append("lastModifiedBy", userId);
      formdata.append("remarks", "Basic info. updated.");
      formdata.append(
        "remarksDetail",
        "Application basic information is updated."
      );
      formdata.append("submittedThrough", portalName);
      formdata.append("subDivisionCode", subDivision.code);
      formdata.append("divisionCode", defaultDivision.code);
      formdata.append("circleCode", defaultCircle.code);
      formdata.append("termAndConditionFlag", "yes");
      formdata.append(
        "companyCode",
        parseInt(defaultCircle.code.toString().slice(0, 2))
      );
      formdata.append("nearByReferenceNumber", values.iv_near_by_reference_no);
      formdata.append("nearByName", values.iv_near_by_name);
      formdata.append("nearByAddress", values.iv_near_by_name);
      formdata.append("connectionType", values.iv_connection_type);
      formdata.append("applicantStatus", values.iv_applicant_status);
      formdata.append("applicantName", values.iv_applicant_name);
      formdata.append("applicantCNIC", values.iv_applicant_cnic);
      formdata.append("applicantMobile", values.iv_applicant_phone_no);
      formdata.append("applicantEmail", values.iv_applicant_email);
      formdata.append("applicantCitizenship", values.iv_applicant_citizenship);
      if (values.iv_area_type === "Urban" || values.iv_area_type === "urban") {
        formdata.append(
          "premisesAddress",
          values.iv_address.concat(" " + values.iv_city_district)
        );
      }
      if (values.iv_area_type === "Rural" || values.iv_area_type === "rural") {
        formdata.append(
          "premisesAddress",
          values.iv_address.concat(
            " " + values.iv_town_tehsil + " " + values.iv_city_district
          )
        );
      }
      formdata.append("appliedLoad", values.iv_applied_load);
      if (
        values.iv_applicant_status === "Owner" ||
        values.iv_applicant_status === "owner"
      ) {
        formdata.append("ownerName", values.iv_applicant_name);
        formdata.append("ownerCNIC", values.iv_applicant_cnic);
        formdata.append("ownerMobile", values.iv_applicant_phone_no);
        formdata.append("ownerEmail", values.iv_applicant_email);
      } else if (
        values.iv_applicant_status === "Tenant" ||
        values.iv_applicant_status === "tenant"
      ) {
        formdata.append("ownerName", values.iv_owner_name);
        formdata.append("ownerCNIC", values.iv_owner_cnic);
        formdata.append("ownerMobile", values.iv_owner_phone_no);
        formdata.append("ownerEmail", values.iv_owner_email);
      }
      formdata.append("noOfMetersAlreadyInstalled", values.iv_meter_installed);
      formdata.append("areaType", values.iv_area_type);
      formdata.append("houseNo", "");
      formdata.append("streetNo", "");
      formdata.append("sectorBlockPhaseMohalah", "");
      formdata.append("chakStreet", "");
      formdata.append("village", "");
      formdata.append("townTehsil", values.iv_town_tehsil);
      formdata.append("cityDistrict", values.iv_city_district);
      formdata.append("NTN", values.iv_ntn);
      formdata.append("STRN", values.iv_strn);
      formdata.append(
        "applicationProgressId",
        dialogRowData.applicationProgressId
      );
      formdata.append("seasonalNonSeasonalFlag", values.iv_meter_seasonal);
      formdata.append("relationType", values.iv_relation_type);
      formdata.append("relativeName", values.iv_relative_name);
      formdata.append("premisesDocument", propertyDocumentsThumbnail);
      formdata.append(
        "copyOfApplicantCNICFront",
        applicantCnicDocumentFrontThumbnail
      );
      formdata.append(
        "copyOfApplicantCNICBack",
        applicantCnicDocumentBackThumbnail
      );
      formdata.append(
        "scannedCopyOfNearByElectricityBill",
        nearByBillDocumentThumbnail
      );
      formdata.append("anyOtherDocument", anyOtherDocumentThumbnail);
      formdata.append("resolutionFormDesc", resolutionDocumentThumbnail);
      formdata.append("certMemoDesc", memorandumDocumentThumbnail);
      formdata.append("certFormDesc", form29DocumentThumbnail);
      formdata.append("ownerNOC", nocOwnerDocumentThumbnail);
      formdata.append("copyOfOwnerCNICFront", ownerCnicDocumentFrontThumbnail);
      formdata.append("copyOfOwnerCNICBack", ownerCnicDocumentBackThumbnail);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      const requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };
      await fetch(
        cfpBaseUrl +
        "electricityNewConnection/updateElectricityNewConnectionApplication",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            resetForm();
            setViewBackdrop(false);
            setShowEditPopup(false);
            handleClose();
          } else {
            setViewBackdrop(false);
          }
        })
        .catch((error) => {
          setViewBackdrop(false);
          console.error(error);
        });
      // setViewBackdrop(false)
    },
  });

  useEffect(() => {
    if (props.showTable && currentPath === "/new-connection-table") {
      if (token) {
        dispatch(
          fetchPaginatedNewConnectionNormal({
            page: currentPageNormal,
            pageSize: pageSizeNormal,
            dateFrom: dateFromNormal,
            dateTo: dateToNormal,
            loadFrom: loadFromNormal,
            loadTo: loadToNormal,
            applicationProgressId: applicationProgressIdNormal,
            objectionStatus: objectionStatusNormal,
            officeCode: selectedOfficeCode || code, // <-- important
          })
        );
      }
    }
  }, [
    currentPageNormal,
    pageSizeNormal,
    dateFromNormal,
    dateToNormal,
    loadFromNormal,
    loadToNormal,
    applicationProgressIdNormal,
    objectionStatusNormal,
    selectedOfficeCode,
  ]);

  useEffect(() => { }, [viewBackdrop]);

  // useEffect(() => {
  //   if (props.showTable && currentPath == "/new-connection-table") {
  //     setViewBackdrop(true);
  //     dispatch(
  //       fetchPaginatedNewConnectionNormal({
  //         page: currentPageNormal,
  //         pageSize: pageSizeNormal,
  //         dateFrom: dateFromNormal,
  //         dateTo: dateToNormal,
  //         loadTo: loadToNormal,
  //         loadFrom: loadFromNormal,
  //         applicationProgressId: applicationProgressIdNormal,
  //         objectionStatus: objectionStatusNormal,
  //         officeCode: selectedOfficeCode || code,
  //       })
  //     );
  //   }
  // }, []);

  useEffect(() => {
    if (dataNormal) {
      setNewConnectionApplications(dataNormal);
      setViewBackdrop(false);
    }
  }, [dataNormal]);

  useEffect(() => {
    if (props.showTable && currentPath === "/new-connection-table") {
      if (token) {
        dispatch(
          fetchPaginatedNewConnectionOverdue({
            page: currentPageOverdue,
            pageSize: pageSizeOverdue,
            dateFrom: dateFromOverdue,
            dateTo: dateToOverdue,
            loadFrom: loadFromOverdue,
            loadTo: loadToOverdue,
            applicationProgressId: applicationProgressIdOverdue,
            objectionStatus: objectionStatusOverdue,
            officeCode: selectedOfficeCode || code, // <-- important
          })
        );
      }
    }
  }, [
    currentPageOverdue,
    pageSizeOverdue,
    dateFromOverdue,
    dateToOverdue,
    loadFromOverdue,
    loadToOverdue,
    applicationProgressIdOverdue,
    objectionStatusOverdue,
    selectedOfficeCode,
  ]);

  useEffect(() => {
    if (dataOverdue) {
      setNewConnectionApplicationsOverDue(dataOverdue);
      setViewBackdrop(false);
    }
  }, [dataOverdue]);

  // Debounce the input value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedInputValue(inputValue);
    }, 300); // Adjust the debounce delay as needed

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  useEffect(() => {
    if (batchError) {
      setWrongBatchPopup(true);
    } else {
      setWrongBatchPopup(false);
    }
  }, [batchError]);
  useEffect(() => {
    if (arrearsEntryPopUpOpen) {
      arearsFormik.setFieldValue("iv_property_reference_no", "");
      arearsFormik.setFieldValue("iv_arrears_remarks", "");
    }
  }, [arrearsEntryPopUpOpen]);
  // useEffect(() => {
  //   if (dialogRowData && allTariffList) {
  //     if (dialogRowData.connectionType == "Industrial") {
  //       let industrialTariffs = allTariffList.filter((tariff) => tariff.consumerType === "Industrial");
  //       let shortlistedTariffs = getTariffsForValue(parseInt(dialogRowData.appliedLoad), industrialTariffs);
  //       setShortListIndustrialTariff(shortlistedTariffs);
  //     }
  //   } else {
  //     setShortListIndustrialTariff([])
  //   }
  // }, [dialogRowData, allTariffList])

  useEffect(() => {
    if (dialogRowData && allTariffList) {
      const connectionType = dialogRowData?.connectionType?.toLowerCase() || "";

      const matchedTariffs = allTariffList.filter(
        (tariff) =>
          tariff?.consumerType &&
          tariff.consumerType.toLowerCase() === connectionType
      );

      const shortlistedTariffs = getTariffsForValue(
        parseInt(dialogRowData?.appliedLoad || 0),
        matchedTariffs
      );

      if (shortlistedTariffs.length > 0) {
        setShortListIndustrialTariff(shortlistedTariffs);
      } else {
        setShortListIndustrialTariff(allTariffList);
      }

    } else {
      setShortListIndustrialTariff(allTariffList || []);
    }
  }, [dialogRowData, allTariffList]);

  useEffect(() => {
    if (nearByReferenceNumber.length === 14) {
      let enteredReferenceNo = nearByReferenceNumber;
      let circleCode = enteredReferenceNo.slice(2, 5);
      let circleObject = {};
      circleObject = circleList.find(
        (item) => item.code === parseInt(circleCode)
      );

      setDefaultCircle(circleObject);

      if (circleObject) {
        editBasicInfoFormik.values.iv_circle = circleObject.code;
      }

      let divisionCode = enteredReferenceNo.slice(2, 6);
      let subDivisionCode = enteredReferenceNo.slice(2, 7);

      let uniqueDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const division = hierarchyList[i];
        if (division.circleCode === parseInt(circleCode)) {
          const existingDivision = uniqueDivisions.find(
            (c) => c.code === division.divisionCode
          );
          if (!existingDivision) {
            uniqueDivisions.push({
              code: division.divisionCode,
              name: division.divisionName,
            });
          }
        }
      }

      let sortedDivisionArray = uniqueDivisions.sort(function (a, b) {
        var divisionA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        var divisionB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        if (divisionA < divisionB) {
          return -1; // nameA comes before nameB in the sorted order
        }
        if (divisionA > divisionB) {
          return 1; // nameA comes after nameB in the sorted order
        }
        return 0; // names are equal, their order doesn't matter
      });
      let defDivision = sortedDivisionArray.find(
        (item) => item.code === parseInt(divisionCode)
      );

      setDefaultDivision(defDivision);
      if (defDivision) {
        editBasicInfoFormik.values.iv_division = defDivision.code;
      }
      setDivisionList(sortedDivisionArray);

      let uniqueSubDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const subDivision = hierarchyList[i];
        if (subDivision.divisionCode === parseInt(divisionCode)) {
          const existingSubDivision = uniqueSubDivisions.find(
            (c) => c.code === subDivision.subDivisionCode
          );
          if (!existingSubDivision) {
            uniqueSubDivisions.push({
              code: subDivision.subDivisionCode,
              name: subDivision.subDivisionName,
            });
          }
        }
      }

      let sortedSubDivisionArray = uniqueSubDivisions.sort(function (a, b) {
        var subDivisionA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        var subDivisionB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        if (subDivisionA < subDivisionB) {
          return -1; // nameA comes before nameB in the sorted order
        }
        if (subDivisionA > subDivisionB) {
          return 1; // nameA comes after nameB in the sorted order
        }
        return 0; // names are equal, their order doesn't matter
      });
      let subDivisionObject = sortedSubDivisionArray.find(
        (item) => item.code === parseInt(subDivisionCode)
      );
      if (subDivisionObject) {
        editBasicInfoFormik.values.iv_sub_divison = subDivisionObject.code;
      }
      setSubDivision(subDivisionObject);
      setSubDivisionList(sortedSubDivisionArray);
      referenceApi("application edit");
    } else {
      setReferenceNumberError("");
      editBasicInfoFormik.values.iv_near_by_address = "";
      editBasicInfoFormik.values.iv_near_by_name = "";
      setDefaultCircle("");
      setDefaultDivision("");
      setSubDivision("");
    }
  }, [nearByReferenceNumber]);

  useEffect(() => {
    if (
      arearsFormik.values.iv_property_reference_no.length === 14 &&
      arearsFormik.values.iv_property_reference_no.length
    ) {
      referenceApi("arrears checking");
    } else {
      let emptyArearObject = {
        arrearsAmount: "",
        meterStatus: "",
        tariffDesc: "",
        meterType: "",
        phase: "",
        consumerName: "",
        consumerNo: "",
        consumerAddress: "",
        consumerEmail: "",
      };
      setArrearsDetailsRefno(emptyArearObject);
      setNoArrears("");
      return;
    }
  }, [arearsFormik.values.iv_property_reference_no]);

  useEffect(() => {
    if (!hierarchyList || !defaultCircle) return;

    const uniqueDivisions = hierarchyList
      .filter((division) => division.circleCode === defaultCircle.code)
      .reduce((uniqueDivisions, division) => {
        const existingDivision = uniqueDivisions.find(
          (d) => d.code === division.divisionCode
        );
        if (!existingDivision) {
          uniqueDivisions.push({
            code: division.divisionCode,
            name: division.divisionName,
          });
        }
        return uniqueDivisions;
      }, []);

    const sortedDivisionArray = uniqueDivisions.sort((a, b) =>
      a.name.localeCompare(b.name, "en", { ignorePunctuation: true })
    );

    setDivisionList(sortedDivisionArray);
  }, [defaultCircle, hierarchyList]);

  useEffect(() => {
    if (!defaultDivision || !hierarchyList) return;

    const uniqueSubDivisions = hierarchyList
      .filter(
        (subDivision) => subDivision.divisionCode === defaultDivision.code
      )
      .reduce((uniqueSubDivisions, subDivision) => {
        const existingSubDivision = uniqueSubDivisions.find(
          (s) => s.code === subDivision.subDivisionCode
        );
        if (!existingSubDivision) {
          uniqueSubDivisions.push({
            code: subDivision.subDivisionCode,
            name: subDivision.subDivisionName,
          });
        }
        return uniqueSubDivisions;
      }, []);

    const sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) =>
      a.name.localeCompare(b.name, "en", { ignorePunctuation: true })
    );

    setSubDivisionList(sortedSubDivisionArray);
  }, [defaultDivision, hierarchyList]);

  useEffect(() => {
    if (props.showTable && currentPath == "/new-connection-table") {
      callTariffList();
      // callMaterials()
    }
  }, []);

  useEffect(() => {
    if (props.showTable && currentPath == "/new-connection-table") {
      const loadSubDivs = async () => {
        setViewBackdrop(true);
        const lists = await subDivAPI(subDivisions);
        setHierarchyList(lists.hierarchyList);
        setCircleList(lists.circleList);
        setDivisionList(lists.divisionList);
        setSubDivisionList(lists.subDivisionList);
        setViewBackdrop(false);
      };
      loadSubDivs();
    }
  }, []);

  useEffect(() => {
    if (newConnectionApplications && allTariffList) {
      apiToDataGridConversionNormal();
    }
  }, [allTariffList, newConnectionApplications]);

  useEffect(() => {
    if (newConnectionApplicationsOverDue && allTariffList) {
      apiToDataGridConversionOverdue();
    }
  }, [allTariffList, newConnectionApplicationsOverDue]);

  useEffect(() => {
    if (dialogRowData && refNoAllocationFormik.values.iv_batch) {
      if (
        dialogRowData.connectionType == "Domestic" ||
        dialogRowData.connectionType == "Commercial"
      ) {
        if (
          batchArrayIndustrial.includes(refNoAllocationFormik.values.iv_batch)
        ) {
          setBatchError(
            dialogRowData.connectionType +
            " connection should have batch in " +
            batchArrayGeneralString
          );
        }
      } else {
        if (batchArrayGeneral.includes(refNoAllocationFormik.values.iv_batch)) {
          setBatchError(
            dialogRowData.connectionType +
            " connection should have batch in " +
            batchArrayIndustrialString
          );
        }
      }
    }
  }, [dialogRowData, refNoAllocationFormik.values.iv_batch]);

  useEffect(() => {
    setRefNoAlreadyAllocatedError("");
  }, [
    refNoAllocationFormik.values.iv_batch,
    refNoAllocationFormik.values.iv_reference_to_allot,
  ]);

  useEffect(() => {
    setPartialValue(dialogRowData.subDivisionCode);
  }, [dialogRowData]);

  useEffect(() => {
    const { iv_fieldItemId } = fieldItemFormik.values;

    if (iv_fieldItemId && allMaterialList?.length > 0) {
      const item = allMaterialList.find(
        (it) =>
          String(it.item_Code || it.Item_Code)
            .trim()
            .toLowerCase() === String(iv_fieldItemId).trim().toLowerCase()
      );

      if (item) {
        fieldItemFormik.setFieldValue(
          "iv_fieldItemRate",
          parseFloat(item.item_Amount || item.Item_Amount || 0)
        );
        fieldItemFormik.setFieldValue(
          "iv_fieldItemUnit",
          item.item_Unit || item.Item_Unit || ""
        );
      } else {
        console.warn("⚠️ No matching item found for:", iv_fieldItemId);
        fieldItemFormik.setFieldValue("iv_fieldItemRate", "");
        fieldItemFormik.setFieldValue("iv_fieldItemUnit", "");
      }
    }
  }, [fieldItemFormik.values.iv_fieldItemId, allMaterialList]);

  useEffect(() => {
    if (foundId && foundId !== "") {
      setFoundInNc(foundId);
    }
  }, [foundId]);

  useLayoutEffect(() => {
    if (foundInNc) {
      handleRowClick(foundInNc);
    }
  }, [foundInNc]);

  // ...existing code...
  useEffect(() => {
    let totalCost = totalCharges;

    const totalChargesValue = isNaN(parseInt(totalCharges))
      ? 0
      : parseInt(totalCharges);
    const gridSharingCostValue = isNaN(parseInt(gridSharingCost))
      ? 0
      : parseInt(gridSharingCost);
    const feederRehabilitationChargesValue = isNaN(
      parseInt(feederRehabilitationCharges)
    )
      ? 0
      : parseInt(feederRehabilitationCharges);
    const civilWorkChargesValue = isNaN(parseInt(civilWorkCharges))
      ? 0
      : parseInt(civilWorkCharges);
    const fixedChargesOfMeteringValue = isNaN(parseInt(fixedChargesOfMetering))
      ? 0
      : parseInt(fixedChargesOfMetering);
    const miscellaneousChargesValue = isNaN(parseInt(miscellaneousCharges))
      ? 0
      : parseInt(miscellaneousCharges);
    const lessTheCostValue = isNaN(parseInt(lessTheCost))
      ? 0
      : parseInt(lessTheCost);
    const mntChargesValue = isNaN(parseInt(mntCharges))
      ? 0
      : parseInt(mntCharges);
    const labourChargesValue = isNaN(parseInt(labourCharges))
      ? 0
      : parseInt(labourCharges);
    const designVettingFeeValue = isNaN(parseInt(designVettingFee))
      ? 0
      : parseInt(designVettingFee);
    const consultancyChargesValue = isNaN(parseInt(consultancyCharges))
      ? 0
      : parseInt(consultancyCharges);
    const variationChargesValue = isNaN(parseInt(variationCharges))
      ? 0
      : parseInt(variationCharges);
    const dismantlementChargesValue = isNaN(parseInt(dismantlementCharges))
      ? 0
      : parseInt(dismantlementCharges);

    const earthingChargesValue = isNaN(parseInt(earthingCharges))
      ? 0
      : parseInt(earthingCharges);


    if (dialogRowData?.applicationId?.slice(3, 5) === "13") {
      totalCost =
        gridSharingCostValue +
        feederRehabilitationChargesValue +
        civilWorkChargesValue +
        fixedChargesOfMeteringValue +
        miscellaneousChargesValue +
        mntChargesValue +
        itemsAmount + installationCharges +
        labourChargesValue +
        designVettingFeeValue +
        consultancyChargesValue +
        variationChargesValue +
        dismantlementChargesValue +
        earthingChargesValue -
        lessTheCostValue;
    } else {
      totalCost =
        gridSharingCostValue +
        feederRehabilitationChargesValue +
        civilWorkChargesValue +
        fixedChargesOfMeteringValue +
        miscellaneousChargesValue +
        mntChargesValue +
        itemsAmount + storeCharges + installationCharges +
        labourChargesValue +
        designVettingFeeValue +
        consultancyChargesValue +
        variationChargesValue +
        dismantlementChargesValue +
        earthingChargesValue -
        lessTheCostValue;
    }


    setGrandTotalCharges(totalCost);
  }, [
    civilWorkCharges,
    fixedChargesOfMetering,
    miscellaneousCharges,
    lessTheCost,
    totalCharges,
    gridSharingCost,
    feederRehabilitationCharges,
    mntCharges,
    labourCharges,
    designVettingFee,
    consultancyCharges,
    variationCharges,
    dismantlementCharges,
    earthingCharges,

  ]);

  useEffect(() => {
    if (
      govtDeptCodesFromlocalStorage &&
      govtDeptCodesFromlocalStorage.length > 0
    ) {
      setGovtDeptCodes(govtDeptCodesFromlocalStorage);
    }
  }, [govtDeptCodesFromlocalStorage]);
  useEffect(() => {
    if (
      getClassificationCodesFromlocalStorage &&
      getClassificationCodesFromlocalStorage.length > 0
    ) {
      setStandardClassificationCodes(getClassificationCodesFromlocalStorage);
    }
  }, [getClassificationCodesFromlocalStorage]);

  //#endregion

  useImperativeHandle(ref, () => ({
    handleRowClick,
  }));

  const calculateMF = (ctNom, ctDenom, ptNom, ptDenom) => {
    let mf = (ctNom / ctDenom) * (ptNom / ptDenom);
    return mf;
  };

  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => { }, [arrearsDetailsRefno]);

  const onPressCostEstimationConfirm = () => {
    const safeItemsArray = Array.isArray(itemsArray) ? itemsArray :
      Array.isArray(boqItems) ? boqItems : [];

    if (distance == 1) {
      const apiData = allMaterialList || [];
      const appCode = dialogRowData.applicationId.slice(3, 5);
      const load = dialogRowData.appliedLoad;
      const distanceFlag = fieldFormik.values.iv_distance;
      const estDistance = fieldFormik.values.iv_estimated_distance_yes;

      let selectedItems = [];
      let BoQItems = []; // ✅ Declare outside so it’s accessible later

      // Helper function
      const getBoqItems = (selectedItems) => {
        return selectedItems.map((item) => {
          const material = apiData.find(
            (m) => String(m.item_Code).trim() === String(item.itemCode).trim()
          );
          const amount = material ? Math.round(parseFloat(material.item_Amount || 0) * item.qty) : 0;

          return {
            qty: item.qty.toString(),
            itemCode: item.itemCode,
            itemAmount: String(amount),
          };
        });
      };

      // --- All logic in one place
      if (appCode === "13" && distanceFlag == 1) {
        // --- Case 1: Load < 4, Distance 1–20
        if (load < 4 && estDistance >= 1 && estDistance <= 20) {
          selectedItems = [
            { qty: 1, itemCode: "000000000030003061" },
            { qty: 20, itemCode: "000000000030000335" },
          ];
        }
        // --- Case 2: Load < 4, Distance 21–40
        else if (load < 4 && estDistance >= 21 && estDistance <= 40) {
          selectedItems = [
            { qty: 1, itemCode: "000000000030003061" },
            { qty: 40, itemCode: "000000000030000335" },
          ];
        }
        // --- Case 3: Load > 3, Distance 1–20
        else if (load > 3 && estDistance >= 1 && estDistance <= 20) {
          selectedItems = [
            { qty: 1, itemCode: "000000000030001901" },
            { qty: 20, itemCode: "000000000030000335" },
          ];
        }
        // --- Case 4: Load > 3, Distance 21–40
        else if (load > 3 && estDistance >= 21 && estDistance <= 40) {
          selectedItems = [
            { qty: 1, itemCode: "000000000030001901" },
            { qty: 40, itemCode: "000000000030000335" },
          ];
        }

        // --- Generate BoQItems
        if (selectedItems.length > 0) {
          BoQItems = getBoqItems(selectedItems);
          setBoqItems(BoQItems);
        }
      }

      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const installedMeterRefNo =
        installRefNo.length !== 0
          ? installRefNo.map((item) => ({
            installedRefNo: item || "",
          }))
          : [];

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: 4,
        remarks: "Field surveyed and Cost estimated.",
        objectionStatus: 0,
        meterType: meterTypeValue,
        tariff: tariff,
        sanctionLoad: dialogRowData.appliedLoad,
        urbanRural: urbanRuralValue,
        amountOfGridSharing: costEstimationForNC?.amountOfGridSharing
          ? costEstimationForNC?.amountOfGridSharing
          : 0,
        amountOfFeederRehab: costEstimationForNC?.amountOfFeederRehab
          ? costEstimationForNC?.amountOfFeederRehab
          : 0,
        civilWorkCharges: costEstimationForNC?.civilWorkCharges
          ? costEstimationForNC?.civilWorkCharges
          : 0,
        fixedChargesOfMetering: costEstimationForNC?.fixedChargesOfMetering
          ? costEstimationForNC?.fixedChargesOfMetering
          : 0,
        miscellaneousCharges: costEstimationForNC?.miscellaneousCharges
          ? costEstimationForNC?.miscellaneousCharges
          : 0,
        lessTheCost: costEstimationForNC?.lessTheCost
          ? costEstimationForNC?.lessTheCost
          : 0,
        capitalCostAmount: costEstimationForNC?.estimatedCapitalCost
          ? costEstimationForNC?.estimatedCapitalCost
          : 0,
        securityDepositAmount: costEstimationForNC?.estimatedSecurityAmount
          ? costEstimationForNC?.estimatedSecurityAmount
          : 0,
        mtCharges: mntCharges
          ? Number(mntCharges)
          : Number(costEstimationForNC?.mntCharges || 0),
        labourCharges: labourCharges
          ? Number(labourCharges)
          : Number(costEstimationForNC?.labourCharges || 0),
        designVetteingFee: designVettingFee
          ? Number(designVettingFee)
          : Number(costEstimationForNC?.designVettingFee || 0),
        consultancyCharges: consultancyCharges
          ? Number(consultancyCharges)
          : Number(costEstimationForNC?.consultancyCharges || 0),
        variationsCharges: variationCharges
          ? Number(variationCharges)
          : Number(costEstimationForNC?.variationCharges || 0),
        dismentalmentCharges: dismantlementCharges
          ? Number(dismantlementCharges)
          : Number(costEstimationForNC?.dismantlementCharges || 0),
        earthingCharges: earthingCharges ? Number(earthingCharges) : Number(costEstimationForNC?.earthingCharges || 0),
        isLTLWI40Flag: 1,
        estDistanceInMeter:
          fieldFormik.values.iv_distance == 1
            ? fieldFormik.values.iv_estimated_distance_yes
            : fieldFormik.values.iv_estimated_distance_no,
        sketchDiagram: "",
        areaMarla: areaTypeValue,
        noOfMeterInstalled: meterAlreadyInstalled ? meterAlreadyInstalled : 0,
        surveyedBy: "",
        installedMeterRefNo: installedMeterRefNo,
        submittedThrough: "e-Operation",
        BoQItems: BoQItems ? BoQItems : [],
        connectionType: dialogRowData.connectionType

      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(cfpBaseUrl + "enc/saveFieldSurveyAndCostEstimate", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setViewBackdrop(false);
            setShowCostEstimation(false);
            setErrormessageCostEstimation("");
            // resetForm()
            handleClose();
          } else {
            setViewBackdrop(false);
            setErrormessageCostEstimation(result.message);
          }
        })
        .catch((error) => console.error(error));
    } else {
      const BoQItems = itemsArray.map((item) => ({
        qty: String(item.qty),
        itemCode: String(item.item_Code),
        itemAmount: String(Math.round(item.amount)),
      }));

      setBoqItems(BoQItems);

      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const installedMeterRefNo =
        installRefNo.length !== 0
          ? installRefNo.map((item) => ({
            installedRefNo: item || "",
          }))
          : [];

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: 4,
        remarks: "Field surveyed and Cost estimated.",
        objectionStatus: 0,
        meterType: meterTypeValue,
        tariff: tariff,
        sanctionLoad: dialogRowData.appliedLoad,
        urbanRural: urbanRuralValue,
        amountOfGridSharing: gridSharingCost ? gridSharingCost : 0,
        amountOfFeederRehab: feederRehabilitationCharges
          ? feederRehabilitationCharges
          : 0,
        civilWorkCharges: civilWorkCharges ? civilWorkCharges : 0,
        fixedChargesOfMetering: fixedChargesOfMetering
          ? fixedChargesOfMetering
          : 0,
        miscellaneousCharges: miscellaneousCharges ? miscellaneousCharges : 0,
        lessTheCost: lessTheCost ? lessTheCost : 0,
        capitalCostAmount: [
          itemsAmount || 0,
          storeCharges || 0,
          installationCharges || 0,
          -(lessTheCost || 0),
        ]
          .map(Number)
          .reduce((acc, val) => acc + val, 0),
        securityDepositAmount: costEstimationForNC?.estimatedSecurityAmount
          ? costEstimationForNC?.estimatedSecurityAmount
          : 0,
        mtCharges: mntCharges ? Number(mntCharges) : 0,
        labourCharges: labourCharges ? Number(labourCharges) : 0,
        designVetteingFee: designVettingFee ? Number(designVettingFee) : 0,
        consultancyCharges: consultancyCharges ? Number(consultancyCharges) : 0,
        variationsCharges: variationCharges ? Number(variationCharges) : 0,
        dismentalmentCharges: dismantlementCharges ? Number(dismantlementCharges) : 0,
        earthingCharges: earthingCharges ? Number(earthingCharges) : Number(costEstimationForNC?.earthingCharges || 0),
        isLTLWI40Flag: 0,
        estDistanceInMeter: estimateDistance,
        sketchDiagram: sketchDiagramThumbnail ? sketchDiagramThumbnail : "",
        areaMarla: areaTypeValue,
        noOfMeterInstalled: meterAlreadyInstalled ? meterAlreadyInstalled : 0,
        surveyedBy: "",
        installedMeterRefNo: installedMeterRefNo,
        submittedThrough: "e-Operation",
        BoQItems: BoQItems,
        connectionType: dialogRowData.connectionType
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(cfpBaseUrl + "enc/saveFieldSurveyAndCostEstimate", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setViewBackdrop(false);
            setShowCostEstimation(false);
            setErrormessageCostEstimation("");
            // resetForm()
            handleClose();
          } else {
            setViewBackdrop(false);
            // setShowCostEstimation(false)
            setErrormessageCostEstimation(result.message);
          }
        })
        .catch((error) => console.error(error));
    }
  };

  const onSaveCostEstimationConfirm = () => {
    setErrormessageBoqEstimation("");
    setShowBoq(false);
    const BoQItems = itemsArray.map((item) => ({
      qty: String(item.qty),
      itemCode: String(item.item_Code),
      itemAmount: String(item.amount),
    }));
    setBoqItems(BoQItems);
    // }
  };

  const onPressAddPrepare = useCallback(() => {
    setShowBoq(true);
  }, []);

  useEffect(() => {
    // hide BOQ
    if (
      fieldFormik.values.iv_distance === 0 &&
      dialogRowData.applicationProgressId === 3
    ) {
      setShowBoq(false);
    }

    const isFesco = dialogRowData?.applicationId?.slice(3, 5) === "13";
    const newDistance = 41;

    if (fieldFormik.values.iv_estimated_distance !== newDistance) {
      fieldFormik.setFieldValue("iv_estimated_distance", newDistance);
    }
  }, [
    fieldFormik.values.iv_distance,
    dialogRowData.applicationId,
    dialogRowData.applicationProgressId,
  ]);

  useEffect(() => {
    if (fieldFormik.values.iv_objection_Type !== "No Issue") {
      fieldFormik.setFieldValue("iv_distance", null);
    }
  }, [fieldFormik.values.iv_objection_Type]);

  // useEffect(() => {
  //   callMaterials()
  // }, [])

  // useEffect(() => {
  //   const count = fieldFormik.values.iv_no_of_meters_already_installed || 0;
  //   fieldFormik.setFieldValue(
  //     "installedMeterRefNos",
  //     Array(count).fill("")
  //   );
  // }, [fieldFormik.values.iv_no_of_meters_already_installed]);

  useEffect(() => {
    const count = fieldFormik.values.iv_no_of_meters_already_installed;

    if (count > 0) {
      const newArray = Array(count)
        .fill("")
        .map((_, i) => fieldFormik.values.installedMeterRefNos[i] || "");
      fieldFormik.setFieldValue("installedMeterRefNos", newArray);
    } else {
      fieldFormik.setFieldValue("installedMeterRefNos", []);
    }
  }, [fieldFormik.values.iv_no_of_meters_already_installed]);

  useEffect(() => {
    if (!boqItems || boqItems.length === 0) {
      fieldFormik.setFieldValue("iv_grid_sharing_cost", 0);
      setGridSharingCost(0);

      fieldFormik.setFieldValue("iv_feeder_rehab_charges", 0);
      setFeederRehabilitationCharges(0);
      fieldFormik.setFieldValue("iv_civil_work_charges", 0);
      setCivilWorkCharges(0);
      fieldFormik.setFieldValue("iv_miscellaneous_charges", 0);
      setMiscellaneousCharges(0);
      fieldFormik.setFieldValue("iv_fixed_charges_of_metering", 0);
      setFixedChargesOfMetering(0);
      fieldFormik.setFieldValue("iv_less_the_cost", 0);
      setLessTheCost(0);

      fieldFormik.setFieldValue("iv_mnt_charges", 0);
      setMntCharges(0);

      fieldFormik.setFieldValue("iv_labour_charges", 0);
      setLabourCharges(0);

      fieldFormik.setFieldValue("iv_design_vetting_fee", 0);
      setDesignVettingFee(0);

      fieldFormik.setFieldValue("iv_consultancy_charges", 0);
      setConsultancyCharges(0);

      fieldFormik.setFieldValue("iv_variation_charges", 0);
      setVariationCharges(0);

      fieldFormik.setFieldValue("iv_dismantlement_charges", 0);
      setDismantlementCharges(0);

      fieldFormik.setFieldValue("iv_earthing_charges", 0);
      setEarthingCharges(0);





    }
  }, [boqItems]);

  useEffect(() => {
    if (fieldFormik.values.iv_distance == 1) {
      fieldFormik.setFieldValue("iv_estimated_distance_yes", 1);
    } else if (fieldFormik.values.iv_distance == 0) {
      fieldFormik.setFieldValue("iv_estimated_distance_yes", 41);
    }
  }, [fieldFormik.values.iv_distance]);

  const pdfjsLib = window.pdfjsLib;
  pdfjsLib.GlobalWorkerOptions.workerSrc =
    "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.379/pdf.worker.min.mjs";

  const pdfToImage = async (base64) => {
    const pdfData = atob(base64.replace("data:application/pdf;base64,", ""));
    const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
    const page = await pdf.getPage(1);

    const viewport = page.getViewport({ scale: 1.5 });
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    canvas.height = viewport.height;
    canvas.width = viewport.width;

    await page.render({ canvasContext: context, viewport }).promise;
    return canvas.toDataURL("image/png");
  };

  const onPressRejectMeterInstallation = () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "applicationId": dialogRowData.applicationId,
      "remarks": "Application reverted."
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(cfpBaseUrl + "enc/revertMeterInstallation", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        handleClose()
      })
      .catch((error) => console.error(error));
  }
  useEffect(() => {
    const convert = async () => {
      if (
        dialogRowData.copyOfApplicantCNICFront?.startsWith(
          "data:application/pdf"
        )
      ) {
        const img = await pdfToImage(dialogRowData.copyOfApplicantCNICFront);
        setFrontImg(img);
      } else {
        setFrontImg(dialogRowData.copyOfApplicantCNICFront);
      }

      if (
        dialogRowData.copyOfApplicantCNICBack?.startsWith(
          "data:application/pdf"
        )
      ) {
        const img = await pdfToImage(dialogRowData.copyOfApplicantCNICBack);
        setBackImg(img);
      } else {
        setBackImg(dialogRowData.copyOfApplicantCNICBack);
      }
    };

    convert();
  }, [dialogRowData]);


  const verifyOrRejectWiringTestReport = async (applicationId, progressId, objectionStatus, remarks, wiringTestReportDocumentFlag, wiringTestReportDocumentObjectionRemarks) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "applicationId": applicationId,
      "applicationProgressId": progressId,
      "objectionStatus": objectionStatus,
      "remarks": remarks,
      "wiringTestReportDocumentFlag": wiringTestReportDocumentFlag,
      "wiringTestReportDocumentObjectionRemarks": wiringTestReportDocumentObjectionRemarks,
      "lastModifiedBy": userId
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(cfpBaseUrl + "enc/verifyWiringTestReport", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 200) {
          setFlag_wiringTestReport(null)
          handleClose()
          // setOpen(false);
        }
      })
      .catch((error) => console.error(error));
  }

  const reuploadWiringTestReportAndRemoveObjection = async () => {
    if (!newWiringTestReportDocumentThumbnail) {
      setNewWiringTestReportDocumentError("Please upload new Wiring Test Report document");
      return;
    }

    setViewBackdrop(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "applicationId": dialogRowData.applicationId,
      "applicationProgressId": 21,
      "objectionStatus": 2,
      "wiringTestReportDocument": newWiringTestReportDocumentThumbnail,
      "lastModifiedBy": userId,
      'remarks': "Wiring Test Report Reupload."
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(cfpBaseUrl + "enc/reuploadWiringTestReport", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 200 || result.status === "200") {
          handleClose()
          setNewWiringTestReportDocument("");
          setNewWiringTestReportDocumentThumbnail("");
          setNewWiringTestReportDocumentError("");
          setOpen(false);
        } else {
          setNewWiringTestReportDocumentError(result.message || "Failed to reupload document");
        }
        setViewBackdrop(false);
      })
      .catch((error) => {
        console.error(error);
        setNewWiringTestReportDocumentError("Failed to reupload document");
        setViewBackdrop(false);
      });
  }

  const uploadWiringTestReport = async () => {
    if (!newWiringTestReportDocumentThumbnail) {
      setNewWiringTestReportDocumentError("Please upload Wiring Test Report document");
      return;
    }

    setViewBackdrop(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "applicationId": dialogRowData.applicationId,
      "applicationProgressId": 21,
      "objectionStatus": 0,
      "wiringTestReportDocument": newWiringTestReportDocumentThumbnail,
      "lastModifiedBy": userId,
      'remarks': "Wiring Test Report Uploaded."
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(cfpBaseUrl + "enc/reuploadWiringTestReport", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 200 || result.status === "200") {
          setDialogRowData((prevObject) => ({
            ...prevObject,
            wiringTestReportDocument: newWiringTestReportDocumentThumbnail,
          }));
          setNewWiringTestReportDocument("");
          setNewWiringTestReportDocumentThumbnail("");
          setNewWiringTestReportDocumentError("");
          handleClose()
          setOpen(false);

        } else {
          setNewWiringTestReportDocumentError(result.message || "Failed to upload document");
        }
        setViewBackdrop(false);
      })
      .catch((error) => {
        console.error(error);
        setNewWiringTestReportDocumentError("Failed to upload document");
        setViewBackdrop(false);
      });
  }

  return (
    <>
      {props.showTable && currentPath == "/new-connection-table" && (
        <Box className="form-box">
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Box className="application-table" style={{ marginRight: "10px" }}>
              {code == 10 ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box>
                    <h3 style={{ color: "#006ad1", marginBottom: "10px" }}>
                      New Connection ({" "}
                      {numberFormatting(totalRecordsNormal)
                        ? numberFormatting(totalRecordsNormal)
                        : "-"}{" "}
                      )
                    </h3>
                  </Box>

                  <Box style={{ marginBottom: "1px" }}>
                    <FormControl sx={{ minWidth: 200 }} variant="outlined">
                      <Select
                        value={selectedOfficeCode}
                        onChange={(e) => setSelectedOfficeCode(e.target.value)}
                        sx={{
                          backgroundColor: "white",
                          "& .MuiSelect-select": {
                            padding: "7.5px 14px",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid lightgray",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid lightgray",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid lightgray",
                          },
                        }}
                        renderValue={(selected) => {
                          const company = companies.find((c) => c.code === selected);
                          return company ? (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
                              <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{company.name}</span>
                              <img
                                src={company.logo}
                                alt={`${company.name} logo`}
                                style={{ width: 30, height: 30, marginLeft: 12 }}
                              />
                            </div>
                          ) : (
                            "Select a company"
                          );
                        }}
                      >
                        {companies.map((company) => (
                          <MenuItem key={company.code} value={company.code}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                              <ListItemText primary={company.name} />
                              <img src={company.logo} alt={`${company.name} logo`} style={{ width: 30, height: 30, marginLeft: 12 }} />
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Box>
              ) : (
                <h3 style={{ color: "#006ad1", marginBottom: "10px" }}>
                  New Connection ({" "}
                  {numberFormatting(totalRecordsNormal)
                    ? numberFormatting(totalRecordsNormal)
                    : "-"}{" "}
                  )
                </h3>
              )}
              <div className="div-datagrid">
                <BasicTable
                  columns={tblColumns}
                  data={newConnectionApplicationsToDataGrid}
                  handleRowClick={(params) =>
                    handleRowClick(
                      params.applicationId,
                      params.applicationProgressId
                    )
                  }
                  sx={tableStyle}
                  rowHeight={37}
                  pageSize={20}
                  totalPages={totalPagesNormal}
                  totalRecords={totalRecordsNormal}
                  currentPage={currentPageNormal}
                  handleFilterDateFrom={handleDateFromFilterNormal}
                  handleFilterDateTo={handleDateToFilterNormal}
                  handleFilterLoadFrom={handleLoadFromFilterNormal}
                  handleFilterLoadTo={handleLoadToFilterNormal}
                  resetDateFilter={handleResetDateFilterNormal}
                  handleFilterProgressId={handleProgressIdFilterNormal}
                  handleFilterObjectionStatus={
                    handleObjectionStatusFilterNormal
                  }
                  resetProgressIdFilter={handleResetProgressIdFilterNormal}
                  resetObjectionStatusFilter={
                    handleResetObjectionStatusFilterNormal
                  }
                  firstPage={handleFirstPageNormal}
                  nextPage={handleNextPageNormal}
                  previousPage={handlePreviousPageNormal}
                  lastPage={handleLastPageNormal}
                  isLoading={isLoad}
                  rowsPerPageOptions={[18, 30, 60]}
                  rowsPageOption={false}
                  getRowStyle={(params) => {
                    return params.indexRelativeToCurrentPage % 2 === 0
                      ? tableStyle.evenRow
                      : tableStyle.oddRow;
                  }}
                />
              </div>
            </Box>
            <Box className="application-table">
              <div style={{ display: "flex", alignItems: "end" }}>
                <h3 style={{ color: "#9d192f", marginBottom: "10px" }}>
                  <img
                    src={warning}
                    alt="icon"
                    style={{ width: "1vw", marginRight: "5px" }}
                  />
                  Over Due Applications ({" "}
                  {numberFormatting(totalRecordsOverdue)
                    ? numberFormatting(totalRecordsOverdue)
                    : "-"}{" "}
                  )
                </h3>
              </div>
              <div className="div-datagrid">
                <BasicTable
                  columns={tblColumnsOverDue}
                  data={newConnectionApplicationsOverDueToDataGrid}
                  handleRowClick={(params) =>
                    handleRowClick(
                      params.applicationId,
                      params.applicationProgressId
                    )
                  }
                  sx={tableStyleOverDue}
                  rowHeight={37.5}
                  pageSize={20}
                  firstPage={handleFirstPageOverdue}
                  nextPage={handleNextPageOverdue}
                  previousPage={handlePreviousPageOverdue}
                  lastPage={handleLastPageOverdue}
                  handleFilterDateFrom={handleDateFromFilterOverdue}
                  handleFilterDateTo={handleDateToFilterOverdue}
                  resetDateFilter={handleResetDateFilterOverdue}
                  resetProgressIdFilter={handleResetProgressIdFilterOverdue}
                  resetObjectionStatusFilter={
                    handleResetObjectionStatusFilterOverdue
                  }
                  handleFilterProgressId={handleProgressIdFilterOverdue}
                  handleFilterObjectionStatus={
                    handleObjectionStatusFilterOverdue
                  }
                  totalPages={totalPagesOverdue}
                  totalRecords={totalRecordsOverdue}
                  currentPage={currentPageOverdue}
                  rowsPerPageOptions={[18, 30, 60]}
                  rowsPageOption={false}
                  isLoading={isLoadd}
                  handleFilterLoadFrom={handleLoadFromFilterOverdue}
                  handleFilterLoadTo={handleLoadToFilterOverdue}
                  resetLoadFilter={handleResetLoadFilterOverdue}
                  getRowStyle={(params) => {
                    return params.indexRelativeToCurrentPage % 2 === 0
                      ? tableStyleOverDue.evenRow
                      : tableStyleOverDue.oddRow;
                  }}
                />
              </div>
            </Box>
          </div>
        </Box>
      )}
      {/* Show Cost Estimation */}
      <Dialog
        open={showCostEstimation}
        onClose={handleCostEstimationClose}
        fullWidth={true}
        maxWidth={"sm"}
        className="rejection-removal"
      >
        <DialogTitle
          className="dialog-title"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Cost Estimation
          <Box sx={{ marginRight: "2%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                arearBillDocumentFormik.resetForm();
                arearBillDocumentFormik.values.iv_arear_paid_bill_document = "";
                handleCostEstimationClose();
              }}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>

        <DialogContent>
          {costEstimationForNC ? (
            <Box
              sx={{
                border: "1px solid #ddd",
                borderRadius: "12px",
                padding: "16px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                backgroundColor: "#fff",
                marginTop: "10px",
              }}
            >
              {/* <Typography variant="h6" gutterBottom>
            Cost Estimation
          </Typography> */}

              {/* setItemsAmount(totalAmountofItems);
              setStoreCharges(store_charges);
              setInstallationCharges(installation_charges);
              setTotalCharges(total_charges);
              setItemsArray(arrayOfItems); */}

              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong> Items' Total Amount:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {itemsAmount
                      ? Number(itemsAmount).toLocaleString()
                      : Number(
                        costEstimationForNC?.estimatedCapitalCost || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                {
                  dialogRowData?.applicationId?.slice(3, 5) === "13" ?
                    <>
                      <Grid item xs={6}>
                        <Typography variant="body1">
                          <strong> Store Charges (0%):</strong>
                        </Typography>
                      </Grid>
                      <Grid item xs={6} textAlign="right">
                        <Typography variant="body1">
                          Rs.{" "}
                          {0}
                        </Typography>
                      </Grid>
                    </>
                    :
                    <>
                      <Grid item xs={6}>
                        <Typography variant="body1">
                          <strong> Store Charges (12%):</strong>
                        </Typography>
                      </Grid>
                      <Grid item xs={6} textAlign="right">
                        <Typography variant="body1">
                          Rs.{" "}
                          {storeCharges ? Number(storeCharges).toLocaleString() : 0}
                        </Typography>
                      </Grid>
                    </>
                }

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong> Installation Charges (8%):</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {installationCharges
                      ? Number(installationCharges).toLocaleString()
                      : 0}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Grid Sharing Cost:</strong>
                  </Typography>
                </Grid>

                <Grid item xs={6} textAlign="right">
                  {/* <Typography variant="body1">
                    Rs.{" "} */}
                  {/* {!boqItems || boqItems.length === 0
                      ? 0
                      : gridSharingCost !== null && gridSharingCost !== undefined && gridSharingCost !== ""
                        ? Number(gridSharingCost).toLocaleString()
                        : Number(costEstimationForNC?.amountOfGridSharing || 0).toLocaleString()} */}
                  {/* {Number(costEstimationForNC?.amountOfGridSharing || 0).toLocaleString()} */}
                  <Typography variant="body1">
                    Rs.{" "}
                    {gridSharingCost
                      ? Number(gridSharingCost).toLocaleString()
                      : Number(
                        costEstimationForNC?.amountOfGridSharing || 0
                      ).toLocaleString()}
                  </Typography>
                  {/* </Typography> */}
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Feeder Rehab Cost:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  {/* <Typography variant="body1">
                    Rs. {Number(costEstimationForNC?.amountOfFeederRehab || 0).toLocaleString()}
                  </Typography> */}
                  <Typography variant="body1">
                    Rs.{" "}
                    {feederRehabilitationCharges
                      ? Number(feederRehabilitationCharges).toLocaleString()
                      : Number(
                        costEstimationForNC?.amountOfFeederRehab || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Civil Work Charges:</strong>
                  </Typography>
                </Grid>

                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {civilWorkCharges
                      ? Number(civilWorkCharges).toLocaleString()
                      : Number(
                        costEstimationForNC?.civilWorkCharges || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                {dialogRowData.appliedLoad > 4 && (
                  <>
                    <Grid item xs={6}>
                      <Typography variant="body1">
                        <strong>M&T Charges:</strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={6} textAlign="right">
                      <Typography variant="body1">
                        Rs.{" "}
                        {mntCharges
                          ? Number(mntCharges).toLocaleString()
                          : Number(
                            costEstimationForNC?.mntCharges || 0
                          ).toLocaleString()}
                      </Typography>
                    </Grid>

                    <Grid item xs={6}>
                      <Typography variant="body1">
                        <strong>Labour Charges:</strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={6} textAlign="right">
                      <Typography variant="body1">
                        Rs.{" "}
                        {labourCharges
                          ? Number(labourCharges).toLocaleString()
                          : Number(
                            costEstimationForNC?.labourCharges || 0
                          ).toLocaleString()}
                      </Typography>
                    </Grid>

                    <Grid item xs={6}>
                      <Typography variant="body1">
                        <strong>Design Vetting Fee:</strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={6} textAlign="right">
                      <Typography variant="body1">
                        Rs.{" "}
                        {designVettingFee
                          ? Number(designVettingFee).toLocaleString()
                          : Number(
                            costEstimationForNC?.designVettingFee || 0
                          ).toLocaleString()}
                      </Typography>
                    </Grid>

                    <Grid item xs={6}>
                      <Typography variant="body1">
                        <strong>Consultancy Charges:</strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={6} textAlign="right">
                      <Typography variant="body1">
                        Rs.{" "}
                        {consultancyCharges
                          ? Number(consultancyCharges).toLocaleString()
                          : Number(
                            costEstimationForNC?.consultancyCharges || 0
                          ).toLocaleString()}
                      </Typography>
                    </Grid>

                    <Grid item xs={6}>
                      <Typography variant="body1">
                        <strong>Variation Charges:</strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={6} textAlign="right">
                      <Typography variant="body1">
                        Rs.{" "}
                        {variationCharges
                          ? Number(variationCharges).toLocaleString()
                          : Number(
                            costEstimationForNC?.variationCharges || 0
                          ).toLocaleString()}
                      </Typography>
                    </Grid>

                    <Grid item xs={6}>
                      <Typography variant="body1">
                        <strong>Dismantlement Charges:</strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={6} textAlign="right">
                      <Typography variant="body1">
                        Rs.{" "}
                        {dismantlementCharges
                          ? Number(dismantlementCharges).toLocaleString()
                          : Number(
                            costEstimationForNC?.dismantlementCharges || 0
                          ).toLocaleString()}
                      </Typography>
                    </Grid>

                    <Grid item xs={6}>
                      <Typography variant="body1">
                        <strong>Earthing Charges:</strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={6} textAlign="right">
                      <Typography variant="body1">
                        Rs.{" "}
                        {earthingCharges
                          ? Number(earthingCharges).toLocaleString()
                          : Number(
                            costEstimationForNC?.earthingCharges || 0
                          ).toLocaleString()}
                      </Typography>
                    </Grid>
                  </>
                )}

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Fixed Charges:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {fixedChargesOfMetering
                      ? Number(fixedChargesOfMetering).toLocaleString()
                      : Number(
                        costEstimationForNC?.fixedChargesOfMetering || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Miscellaneous Charges:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  {/* <Typography variant="body1">
                    Rs. {Number(costEstimationForNC?.miscellaneousCharges || 0).toLocaleString()}
                  </Typography> */}
                  <Typography variant="body1">
                    Rs.{" "}
                    {miscellaneousCharges
                      ? Number(miscellaneousCharges).toLocaleString()
                      : Number(
                        costEstimationForNC?.miscellaneousCharges || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Less the Cost:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  {/* <Typography variant="body1">
                    Rs. {Number(costEstimationForNC?.lessTheCost || 0).toLocaleString()}
                  </Typography> */}
                  <Typography variant="body1">
                    Rs.{" "}
                    {lessTheCost
                      ? Number(lessTheCost).toLocaleString()
                      : Number(
                        costEstimationForNC?.lessTheCost || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Capital Cost:</strong>
                  </Typography>
                </Grid>


                <Grid item xs={6} textAlign="right">

                  {itemsAmount ? (
                    <>
                      {
                        dialogRowData?.applicationId?.slice(3, 5) === "13" ? <>
                          <Typography
                            variant="body1"
                            sx={{ fontWeight: "bold", color: "green" }}
                          >
                            Rs.{" "}
                            {[
                              itemsAmount,
                              gridSharingCost,
                              // storeCharges,
                              installationCharges,
                              feederRehabilitationCharges,
                              civilWorkCharges,
                              fixedChargesOfMetering,
                              miscellaneousCharges,
                              mntCharges !== 0 ? mntCharges : Number(fieldFormik.values.iv_mnt_charges) || 0,
                              labourCharges !== 0 ? labourCharges : Number(fieldFormik.values.iv_labour_charges) || 0,
                              designVettingFee !== 0 ? designVettingFee : Number(fieldFormik.values.iv_design_vetting_fee) || 0,
                              consultancyCharges !== 0 ? consultancyCharges : Number(fieldFormik.values.iv_consultancy_charges) || 0,
                              variationCharges !== 0 ? variationCharges : Number(fieldFormik.values.iv_variation_charges) || 0,
                              dismantlementCharges !== 0 ? dismantlementCharges : Number(fieldFormik.values.iv_dismantlement_charges) || 0,
                              earthingCharges !== 0 ? earthingCharges : Number(fieldFormik.values.iv_earthing_charges) || 0,
                              -(lessTheCost !== 0 ? lessTheCost : Number(fieldFormik.values.iv_less_the_cost) || 0),
                            ]
                              .map((val) => Number(val) || 0)
                              .reduce((acc, val) => acc + val, 0)
                              .toLocaleString()}
                          </Typography>
                        </> : <>
                          <Typography
                            variant="body1"
                            sx={{ fontWeight: "bold", color: "green" }}
                          >
                            Rs.{" "}
                            {[
                              itemsAmount,
                              gridSharingCost,
                              storeCharges,
                              installationCharges,
                              feederRehabilitationCharges,
                              civilWorkCharges,
                              fixedChargesOfMetering,
                              miscellaneousCharges,
                              mntCharges !== 0 ? mntCharges : Number(fieldFormik.values.iv_mnt_charges) || 0,
                              labourCharges !== 0 ? labourCharges : Number(fieldFormik.values.iv_labour_charges) || 0,
                              designVettingFee !== 0 ? designVettingFee : Number(fieldFormik.values.iv_design_vetting_fee) || 0,
                              consultancyCharges !== 0 ? consultancyCharges : Number(fieldFormik.values.iv_consultancy_charges) || 0,
                              variationCharges !== 0 ? variationCharges : Number(fieldFormik.values.iv_variation_charges) || 0,
                              dismantlementCharges !== 0 ? dismantlementCharges : Number(fieldFormik.values.iv_dismantlement_charges) || 0,
                              earthingCharges !== 0 ? earthingCharges : Number(fieldFormik.values.iv_earthing_charges) || 0,
                              -(lessTheCost !== 0 ? lessTheCost : Number(fieldFormik.values.iv_less_the_cost) || 0),
                            ]
                              .map((val) => Number(val) || 0)
                              .reduce((acc, val) => acc + val, 0)
                              .toLocaleString()}
                          </Typography>
                        </>
                      }
                    </>

                  ) : (
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: "bold", color: "green" }}
                    >
                      Rs.{" "}
                      {[
                        costEstimationForNC?.estimatedCapitalCost || 0,
                        costEstimationForNC?.amountOfGridSharing || 0,
                        costEstimationForNC?.amountOfFeederRehab || 0,
                        costEstimationForNC?.civilWorkCharges || 0,
                        costEstimationForNC?.fixedChargesOfMetering || 0,
                        costEstimationForNC?.miscellaneousCharges || 0,
                        costEstimationForNC?.mntCharges || Number(fieldFormik.values.iv_mnt_charges) || 0,
                        costEstimationForNC?.labourCharges || Number(fieldFormik.values.iv_labour_charges) || 0,
                        costEstimationForNC?.designVettingFee || Number(fieldFormik.values.iv_design_vetting_fee) || 0,
                        costEstimationForNC?.consultancyCharges || Number(fieldFormik.values.iv_consultancy_charges) || 0,
                        costEstimationForNC?.variationCharges || Number(fieldFormik.values.iv_variation_charges) || 0,
                        costEstimationForNC?.dismantlementCharges || Number(fieldFormik.values.iv_dismantlement_charges) || 0,
                        costEstimationForNC?.earthingCharges || Number(fieldFormik.values.iv_earthing_charges) || 0,
                        -(costEstimationForNC?.lessTheCost || Number(fieldFormik.values.iv_less_the_cost) || 0),
                      ]
                        .map(Number)
                        .reduce((acc, val) => acc + val, 0)
                        .toLocaleString()}
                    </Typography>
                  )}
                </Grid>


                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Security Deposit:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {Number(
                      costEstimationForNC?.estimatedSecurityAmount
                    ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Total Cost Estimation Deposit:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  {itemsAmount ? (
                    <>
                      {
                        dialogRowData?.applicationId?.slice(3, 5) === "13" ? <>
                          <Typography
                            variant="body1"
                            sx={{ fontWeight: "bold", color: "green" }}
                          >
                            Rs.{" "}
                            {[
                              itemsAmount,
                              gridSharingCost,
                              // storeCharges,
                              installationCharges,
                              feederRehabilitationCharges,
                              civilWorkCharges,
                              fixedChargesOfMetering,
                              miscellaneousCharges,
                              mntCharges !== 0 ? mntCharges : Number(fieldFormik.values.iv_mnt_charges) || 0,
                              labourCharges !== 0 ? labourCharges : Number(fieldFormik.values.iv_labour_charges) || 0,
                              designVettingFee !== 0 ? designVettingFee : Number(fieldFormik.values.iv_design_vetting_fee) || 0,
                              consultancyCharges !== 0 ? consultancyCharges : Number(fieldFormik.values.iv_consultancy_charges) || 0,
                              variationCharges !== 0 ? variationCharges : Number(fieldFormik.values.iv_variation_charges) || 0,
                              dismantlementCharges !== 0 ? dismantlementCharges : Number(fieldFormik.values.iv_dismantlement_charges) || 0,
                              earthingCharges !== 0 ? earthingCharges : Number(fieldFormik.values.iv_earthing_charges) || 0,
                              -(lessTheCost !== 0 ? lessTheCost : Number(fieldFormik.values.iv_less_the_cost) || 0),
                              costEstimationForNC?.estimatedSecurityAmount || 0
                            ]
                              .map((val) => Number(val) || 0)
                              .reduce((acc, val) => acc + val, 0)
                              .toLocaleString()}
                          </Typography>
                        </> : <>
                          <Typography
                            variant="body1"
                            sx={{ fontWeight: "bold", color: "green" }}
                          >
                            Rs.{" "}
                            {[
                              itemsAmount,
                              gridSharingCost,
                              storeCharges,
                              installationCharges,
                              feederRehabilitationCharges,
                              civilWorkCharges,
                              fixedChargesOfMetering,
                              miscellaneousCharges,
                              mntCharges !== 0 ? mntCharges : Number(fieldFormik.values.iv_mnt_charges) || 0,
                              labourCharges !== 0 ? labourCharges : Number(fieldFormik.values.iv_labour_charges) || 0,
                              designVettingFee !== 0 ? designVettingFee : Number(fieldFormik.values.iv_design_vetting_fee) || 0,
                              consultancyCharges !== 0 ? consultancyCharges : Number(fieldFormik.values.iv_consultancy_charges) || 0,
                              variationCharges !== 0 ? variationCharges : Number(fieldFormik.values.iv_variation_charges) || 0,
                              dismantlementCharges !== 0 ? dismantlementCharges : Number(fieldFormik.values.iv_dismantlement_charges) || 0,
                              earthingCharges !== 0 ? earthingCharges : Number(fieldFormik.values.iv_earthing_charges) || 0,
                              -(lessTheCost !== 0 ? lessTheCost : Number(fieldFormik.values.iv_less_the_cost) || 0),
                              costEstimationForNC?.estimatedSecurityAmount || 0
                            ]
                              .map((val) => Number(val) || 0)
                              .reduce((acc, val) => acc + val, 0)
                              .toLocaleString()}
                          </Typography>
                        </>
                      }
                    </>
                  ) : (
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: "bold", color: "green" }}
                    >
                      Rs.{" "}
                      {[

                        costEstimationForNC?.estimatedCapitalCost || 0,
                        costEstimationForNC?.amountOfGridSharing || 0,
                        costEstimationForNC?.amountOfFeederRehab || 0,
                        costEstimationForNC?.civilWorkCharges || 0,
                        costEstimationForNC?.fixedChargesOfMetering || 0,
                        costEstimationForNC?.miscellaneousCharges || 0,
                        costEstimationForNC?.mntCharges || Number(fieldFormik.values.iv_mnt_charges) || 0,
                        costEstimationForNC?.labourCharges || Number(fieldFormik.values.iv_labour_charges) || 0,
                        costEstimationForNC?.designVettingFee || Number(fieldFormik.values.iv_design_vetting_fee) || 0,
                        costEstimationForNC?.consultancyCharges || Number(fieldFormik.values.iv_consultancy_charges) || 0,
                        costEstimationForNC?.variationCharges || Number(fieldFormik.values.iv_variation_charges) || 0,
                        costEstimationForNC?.dismantlementCharges || Number(fieldFormik.values.iv_dismantlement_charges) || 0,
                        costEstimationForNC?.earthingCharges || Number(fieldFormik.values.iv_earthing_charges) || 0,
                        -(costEstimationForNC?.lessTheCost || Number(fieldFormik.values.iv_less_the_cost) || 0),
                        costEstimationForNC?.estimatedSecurityAmount || 0
                      ]
                        .map(Number)
                        .reduce((acc, val) => acc + val, 0)
                        .toLocaleString()}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Box>
          ) : (
            <Typography variant="body2">Loading cost details...</Typography>
          )}
        </DialogContent>
        {errormessageCostEstimation ? (
          <Typography
            style={{
              // border: "1px solid #ddd",
              // borderRadius: "12px",
              paddingLeft: "20px",
              paddingBottom: "20px",
              color: "red",
              // boxShadow: ,
              // backgroundColor: "red",
              // marginTop: "10px"
            }}
          >
            {errormessageCostEstimation}
          </Typography>
        ) : null}

        <DialogActions>
          <Button
            variant="contained"
            className="confirmButton"
            sx={{ width: "30%", textTransform: "capitalize" }}
            onClick={onPressCostEstimationConfirm}
          >
            Save Cost Estimation
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showBoq}
        onClose={() => setShowBoq(false)}
        fullWidth
        maxWidth={false}
        className="rejection-removal"
        sx={{
          "& .MuiDialog-paper": {
            width: "80%",
            maxWidth: "1000px",
          },
        }}
      >
        <DialogTitle
          className="dialog-title"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Prepare Estimate
          <Box sx={{ marginRight: "2%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                arearBillDocumentFormik.resetForm();
                arearBillDocumentFormik.values.iv_arear_paid_bill_document = "";
                setShowBoq(false);
              }}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>

        <DialogContent sx={{ overflow: "visible", padding: 2 }}>
          {/* {fieldFormik.values.iv_distance == 0 && ( */}
          <Grid container direction="column" spacing={3}>
            <Grid item xs={12} display="flex" justifyContent="center">
              <TableContainer
                component={Paper}
                sx={{ p: 2, maxWidth: 900, width: "100%" }}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6}>
                    <Typography className="fieldLabel">Item</Typography>
                    <Autocomplete
                      options={allMaterialList || []}
                      getOptionLabel={(option) => {
                        if (!option) return "";
                        const code = option.Item_Code || option.item_Code || "";
                        const name = option.Item_Name || option.item_Name || "";
                        return name ? `${code} - ${name}` : code;
                      }}
                      value={
                        (allMaterialList || []).find(
                          (item) =>
                            String(item.Item_Code || item.item_Code)
                              .trim()
                              .toLowerCase() ===
                            String(fieldItemFormik.values.iv_fieldItemId)
                              .trim()
                              .toLowerCase()
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        if (newValue) {
                          const rate = Math.round(
                            parseFloat(newValue.item_Amount || newValue.Item_Amount || 0)
                          );
                          const unit = newValue.item_Unit || newValue.Item_Unit;

                          fieldItemFormik.setFieldValue(
                            "iv_fieldItemId",
                            newValue.Item_Code || newValue.item_Code
                          );
                          fieldItemFormik.setFieldValue(
                            "iv_fieldItemRate",
                            rate
                          );
                          fieldItemFormik.setFieldValue(
                            "iv_fieldItemUnit",
                            unit
                          );
                        } else {
                          fieldItemFormik.setFieldValue("iv_fieldItemId", "");
                          fieldItemFormik.setFieldValue("iv_fieldItemRate", "");
                          fieldItemFormik.setFieldValue("iv_fieldItemUnit", "");
                        }
                      }}
                      filterOptions={(options, state) =>
                        options.filter((option) => {
                          const input = state.inputValue.toLowerCase();
                          return (
                            String(option.Item_Code || option.item_Code || "")
                              .toLowerCase()
                              .includes(input) ||
                            String(option.Item_Name || option.item_Name || "")
                              .toLowerCase()
                              .includes(input)
                          );
                        })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Item"
                          size="small"
                          error={
                            fieldItemFormik.touched.iv_fieldItemId &&
                            Boolean(fieldItemFormik.errors.iv_fieldItemId)
                          }
                          helperText={
                            fieldItemFormik.touched.iv_fieldItemId &&
                            fieldItemFormik.errors.iv_fieldItemId
                          }
                          sx={{
                            "& .MuiInputBase-root": {
                              height: 35,
                              minHeight: 35,
                            },
                            "& .MuiInputBase-input": {
                              padding: "0 8px",
                            },
                          }}
                        />
                      )}
                      disableClearable
                      fullWidth
                      disabled={dnDetails && dnDetails.filledFlag === 1}
                    />
                  </Grid>

                  {/* Unit */}
                  <Grid item xs={2}>
                    <Typography className="fieldLabel">Unit</Typography>
                    <TextField
                      name="iv_fieldItemUnit"
                      value={fieldItemFormik.values.iv_fieldItemUnit}
                      fullWidth
                      disabled
                      InputProps={{
                        sx: {
                          height: 35, // 👈 yahan height control karein
                          textAlign: "right", // 👈 text right aligned
                          "& input": {
                            textAlign: "right", // 👈 ensure karein ke input ke andar text right me ho
                          },
                        },
                      }}
                    />
                  </Grid>

                  {/* Qty */}
                  <Grid item xs={2}>
                    <Typography className="fieldLabel">Qty</Typography>
                    <TextField
                      name="iv_fieldItemQty"
                      disabled={dnDetails && dnDetails.filledFlag === 1}
                      value={fieldItemFormik.values.iv_fieldItemQty}
                      fullWidth
                      onChange={fieldItemFormik.handleChange}
                      size="small" // 👈 chhota input
                      InputProps={{
                        sx: {
                          height: 35, // 👈 yahan height control karein
                          textAlign: "right", // 👈 text right aligned
                          "& input": {
                            textAlign: "right", // 👈 ensure karein ke input ke andar text right me ho
                          },
                        },
                      }}
                    />
                  </Grid>

                  {/* Add Button */}
                  <Grid item xs={2}>
                    <Button
                      variant="contained"
                      startIcon={<AddIcon />}
                      fullWidth
                      sx={{ height: 50, marginTop: 2, height: 35 }} // 🔹 set height here
                      onClick={fieldItemFormik.handleSubmit}
                      disabled={dnDetails && dnDetails.filledFlag === 1}
                    >
                      Add
                    </Button>
                  </Grid>
                </Grid>
              </TableContainer>
            </Grid>

            {/* ➤ Items Table */}
            {/* ➤ Items Table */}
            {itemsArray?.length > 0 && (
              <Grid item>
                <TableContainer
                  component={Paper}
                  sx={{
                    maxHeight: 250,
                    overflowY: "auto",
                  }}
                >
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>Sr.</TableCell>
                        <TableCell>Item Name</TableCell>
                        <TableCell align="right">Unit</TableCell>
                        <TableCell align="right">Qty</TableCell>
                        <TableCell align="right">Rate</TableCell>
                        <TableCell align="right">Amount</TableCell>
                        <TableCell align="center"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {itemsArray.map((row, index) => (
                        <TableRow key={row.Id || index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{row.item_Name}</TableCell>
                          <TableCell align="right">{row.unit}</TableCell>
                          <TableCell align="right">{row.qty}</TableCell>
                          <TableCell align="right">
                            {numberFormatting(row.rate)}
                          </TableCell>
                          <TableCell align="right">
                            {numberFormatting(row.amount)}
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              onClick={() => deleteItem(index)}
                              disabled={dnDetails && dnDetails.filledFlag === 1}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}

            {/* ➤ Charges Table */}
            <Grid item>
              <TableContainer component={Paper}>
                {/* <Typography variant="h6" sx={{ mb: 1, p: 1 }}>
                    Charges
                  </Typography> */}
                <Table sx={{ border: "1px solid #ccc" }}>
                  <TableBody>
                    {/* Row 1 */}
                    <TableRow>
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Items' Total Amount:
                          </Typography>
                          <Typography
                            className="value"
                            sx={{ flex: 1, textAlign: "right" }}
                          >
                            {itemsAmount ? numberFormatting(itemsAmount) : "-"}
                          </Typography>
                        </Box>
                      </TableCell>


                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {storeCharges === 0 ? "Store Charges (0%)" : "Store Charges (12%)"}
                          </Typography>
                          <Typography
                            className="value"
                            sx={{ flex: 1, textAlign: "right" }}
                          >
                            {storeCharges !== null && storeCharges !== undefined
                              ? numberFormatting(storeCharges)
                              : "-"}
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* Row 2 */}
                    <TableRow>
                      {/* Installation Charges (read-only value) */}
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Installation Charges (8%):
                          </Typography>
                          <Typography
                            className="value"
                            sx={{ flex: 1, textAlign: "right" }}
                          >
                            {installationCharges
                              ? numberFormatting(installationCharges)
                              : "-"}
                          </Typography>
                        </Box>
                      </TableCell>

                      {/* Grid Sharing Cost (input field) */}
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Grid Sharing Cost:
                          </Typography>
                          <TextField
                            name="iv_grid_sharing_cost"
                            value={fieldFormik.values.iv_grid_sharing_cost}
                            type="number"
                            size="small"
                            inputProps={{ min: 0 }}
                            onChange={(e) => {
                              fieldFormik.handleChange(e);
                              setGridSharingCost(
                                e.target.value === ""
                                  ? 0
                                  : parseInt(e.target.value)
                              );
                            }}
                            sx={{ flex: 1 }}
                            onKeyDown={(e) => {
                              if (e.key === '.' || e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                e.preventDefault();
                              }
                            }}
                            InputProps={{
                              sx: {
                                height: 35, // 👈 yahan height control karein
                                textAlign: "right", // 👈 text right aligned
                                "& input": {
                                  textAlign: "right", // 👈 ensure karein ke input ke andar text right me ho
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* Row 3 */}
                    {/* <TableRow>
                        <TableCell sx={{ border: "1px solid #ccc" }}>
                          <Typography className="title">Feeder Rehab Charges</Typography>
                          <TextField
                            name="iv_feeder_rehab_charges"
                            value={fieldFormik.values.iv_feeder_rehab_charges}
                            type="number"
                            fullWidth
                            size="small"
                            onChange={fieldFormik.handleChange}
                            onBlur={(e) =>
                              setFeederRehabilitationCharges(
                                e.target.value === "" ? 0 : parseInt(e.target.value)
                              )
                            }
                          />
                        </TableCell>
                        <TableCell sx={{ border: "1px solid #ccc" }}>
                          <Typography className="title">Civil Work Charges</Typography>
                          <TextField
                            name="iv_civil_work_charges"
                            value={fieldFormik.values.iv_civil_work_charges}
                            type="number"
                            fullWidth
                            size="small"
                            onChange={fieldFormik.handleChange}
                            onBlur={(e) =>
                              setCivilWorkCharges(e.target.value === "" ? 0 : parseInt(e.target.value))
                            }
                          />
                        </TableCell>
                      </TableRow> */}

                    <TableRow>
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Feeder Rehab Charges
                          </Typography>
                          <TextField
                            name="iv_feeder_rehab_charges"
                            value={fieldFormik.values.iv_feeder_rehab_charges}
                            type="number"
                            size="small"
                            inputProps={{ min: 0 }}
                            onChange={fieldFormik.handleChange}
                            onBlur={(e) =>
                              setFeederRehabilitationCharges(
                                e.target.value === ""
                                  ? 0
                                  : parseInt(e.target.value)
                              )
                            }
                            sx={{ flex: 1 }}
                            onKeyDown={(e) => {
                              if (e.key === '.' || e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                e.preventDefault();
                              }
                            }}
                            InputProps={{
                              sx: {
                                height: 35,
                                textAlign: "right",
                                "& input": {
                                  textAlign: "right",
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>

                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Civil Work Charges
                          </Typography>
                          <TextField
                            name="iv_civil_work_charges"
                            value={fieldFormik.values.iv_civil_work_charges}
                            type="number"
                            size="small"
                            onChange={fieldFormik.handleChange}
                            inputProps={{ min: 0 }}
                            onBlur={(e) =>
                              setCivilWorkCharges(
                                e.target.value === ""
                                  ? 0
                                  : parseInt(e.target.value)
                              )
                            }
                            sx={{ flex: 1 }}
                            onKeyDown={(e) => {
                              if (e.key === '.' || e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                e.preventDefault();
                              }
                            }}
                            InputProps={{
                              sx: {
                                height: 35,
                                textAlign: "right",
                                "& input": {
                                  textAlign: "right",
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* Conditional 6 fields in symmetric 2-column rows */}
                    {dialogRowData.appliedLoad > 4 && (
                      <>
                        <TableRow>
                          <TableCell sx={{ border: "1px solid #ccc" }}>
                            <Box
                              sx={{ display: "flex", alignItems: "center", gap: 2 }}
                            >
                              <Typography
                                className="title"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                M&T Charges
                              </Typography>
                              <TextField
                                name="iv_mnt_charges"
                                value={fieldFormik.values.iv_mnt_charges ?? 0}
                                type="number"
                                size="small"
                                onChange={fieldFormik.handleChange}
                                onBlur={(e) =>
                                  setMntCharges(
                                    e.target.value === ""
                                      ? 0
                                      : parseInt(e.target.value)
                                  )
                                }
                                onKeyDown={(e) => {
                                  if (e.key === '.' || e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                    e.preventDefault();
                                  }
                                }}
                                sx={{ flex: 1 }}
                                InputProps={{
                                  inputProps: { min: 0, step: 1 },
                                  sx: {
                                    height: 35,
                                    textAlign: "right",
                                    "& input": {
                                      textAlign: "right",
                                    },
                                  },
                                }}
                              />
                            </Box>
                          </TableCell>

                          <TableCell sx={{ border: "1px solid #ccc" }}>
                            <Box
                              sx={{ display: "flex", alignItems: "center", gap: 2 }}
                            >
                              <Typography
                                className="title"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                Labour Charges
                              </Typography>
                              <TextField
                                name="iv_labour_charges"
                                value={fieldFormik.values.iv_labour_charges ?? 0}
                                type="number"
                                size="small"
                                onChange={fieldFormik.handleChange}
                                onBlur={(e) =>
                                  setLabourCharges(
                                    e.target.value === ""
                                      ? 0
                                      : parseInt(e.target.value)
                                  )
                                }
                                onKeyDown={(e) => {
                                  if (e.key === '.' || e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                    e.preventDefault();
                                  }
                                }}
                                sx={{ flex: 1 }}
                                InputProps={{
                                  inputProps: { min: 0, step: 1 },
                                  sx: {
                                    height: 35,
                                    textAlign: "right",
                                    "& input": {
                                      textAlign: "right",
                                    },
                                  },
                                }}
                              />
                            </Box>
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ border: "1px solid #ccc" }}>
                            <Box
                              sx={{ display: "flex", alignItems: "center", gap: 2 }}
                            >
                              <Typography
                                className="title"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                Design Vetting Fee
                              </Typography>
                              <TextField
                                name="iv_design_vetting_fee"
                                value={fieldFormik.values.iv_design_vetting_fee ?? 0}
                                type="number"
                                size="small"
                                onChange={fieldFormik.handleChange}
                                onBlur={(e) =>
                                  setDesignVettingFee(
                                    e.target.value === ""
                                      ? 0
                                      : parseInt(e.target.value)
                                  )
                                }
                                onKeyDown={(e) => {
                                  if (e.key === '.' || e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                    e.preventDefault();
                                  }
                                }}
                                sx={{ flex: 1 }}
                                InputProps={{
                                  inputProps: { min: 0, step: 1 },
                                  sx: {
                                    height: 35,
                                    textAlign: "right",
                                    "& input": {
                                      textAlign: "right",
                                    },
                                  },
                                }}
                              />
                            </Box>
                          </TableCell>

                          <TableCell sx={{ border: "1px solid #ccc" }}>
                            <Box
                              sx={{ display: "flex", alignItems: "center", gap: 2 }}
                            >
                              <Typography
                                className="title"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                Consultancy Charges
                              </Typography>
                              <TextField
                                name="iv_consultancy_charges"
                                value={fieldFormik.values.iv_consultancy_charges ?? 0}
                                type="number"
                                size="small"
                                onChange={fieldFormik.handleChange}
                                onBlur={(e) =>
                                  setConsultancyCharges(
                                    e.target.value === ""
                                      ? 0
                                      : parseInt(e.target.value)
                                  )
                                }

                                sx={{ flex: 1 }}
                                InputProps={{
                                  sx: {
                                    height: 35,
                                    textAlign: "right",
                                    "& input": {
                                      textAlign: "right",
                                    },
                                  },
                                }}
                              />
                            </Box>
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ border: "1px solid #ccc" }}>
                            <Box
                              sx={{ display: "flex", alignItems: "center", gap: 2 }}
                            >
                              <Typography
                                className="title"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                Variation Charges
                              </Typography>
                              <TextField
                                name="iv_variation_charges"
                                value={fieldFormik.values.iv_variation_charges ?? 0}
                                type="number"
                                size="small"
                                onChange={fieldFormik.handleChange}
                                onBlur={(e) =>
                                  setVariationCharges(
                                    e.target.value === ""
                                      ? 0
                                      : parseInt(e.target.value)
                                  )
                                }
                                sx={{ flex: 1 }}
                                InputProps={{
                                  sx: {
                                    height: 35,
                                    textAlign: "right",
                                    "& input": {
                                      textAlign: "right",
                                    },
                                  },
                                }}
                              />
                            </Box>
                          </TableCell>

                          <TableCell sx={{ border: "1px solid #ccc" }}>
                            <Box
                              sx={{ display: "flex", alignItems: "center", gap: 2 }}
                            >
                              <Typography
                                className="title"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                Dismantlement Charges
                              </Typography>
                              <TextField
                                name="iv_dismantlement_charges"
                                value={fieldFormik.values.iv_dismantlement_charges ?? 0}
                                type="number"
                                size="small"
                                onChange={fieldFormik.handleChange}
                                onBlur={(e) =>
                                  setDismantlementCharges(
                                    e.target.value === ""
                                      ? 0
                                      : parseInt(e.target.value)
                                  )
                                }
                                sx={{ flex: 1 }}
                                InputProps={{
                                  sx: {
                                    height: 35,
                                    textAlign: "right",
                                    "& input": {
                                      textAlign: "right",
                                    },
                                  },
                                }}
                              />
                            </Box>
                          </TableCell>
                        </TableRow>
                      </>
                    )}

                    {/* Row 4 */}
                    <TableRow>
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Misc. Charges
                          </Typography>
                          <TextField
                            name="iv_miscellaneous_charges"
                            value={fieldFormik.values.iv_miscellaneous_charges}
                            type="number"
                            size="small"
                            onChange={fieldFormik.handleChange}
                            onBlur={(e) =>
                              setMiscellaneousCharges(
                                e.target.value === ""
                                  ? 0
                                  : parseInt(e.target.value)
                              )
                            }
                            sx={{ flex: 1 }}
                            InputProps={{
                              sx: {
                                height: 35,
                                textAlign: "right",
                                "& input": {
                                  textAlign: "right",
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>

                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Fixed Charges
                          </Typography>
                          <TextField
                            name="iv_fixed_charges_of_metering"
                            value={
                              fieldFormik.values.iv_fixed_charges_of_metering
                            }
                            type="number"
                            size="small"
                            onChange={fieldFormik.handleChange}
                            onBlur={(e) =>
                              setFixedChargesOfMetering(
                                e.target.value === ""
                                  ? 0
                                  : parseInt(e.target.value)
                              )
                            }
                            sx={{ flex: 1 }}
                            InputProps={{
                              sx: {
                                height: 35,
                                textAlign: "right",
                                "& input": {
                                  textAlign: "right",
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* ✅ Total Row */}
                    <TableRow>
                      {
                        dialogRowData.appliedLoad > 4 &&
                        <TableCell sx={{ border: "1px solid #ccc" }}>
                          <Box
                            sx={{ display: "flex", alignItems: "center", gap: 2 }}
                          >
                            <Typography
                              className="title"
                              sx={{ whiteSpace: "nowrap" }}
                            >
                              Earthing Charges
                            </Typography>
                            <TextField
                              name="iv_earthing_charges"
                              value={fieldFormik.values.iv_earthing_charges ?? 0}
                              type="number"
                              size="small"
                              onChange={fieldFormik.handleChange}
                              onBlur={(e) =>
                                setEarthingCharges(
                                  e.target.value === ""
                                    ? 0
                                    : parseInt(e.target.value)
                                )
                              }
                              sx={{ flex: 1 }}
                              InputProps={{
                                sx: {
                                  height: 35,
                                  textAlign: "right",
                                  "& input": {
                                    textAlign: "right",
                                  },
                                },
                              }}
                            />
                          </Box>
                        </TableCell>
                      }


                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Less the Cost
                          </Typography>
                          <TextField
                            name="iv_less_the_cost"
                            value={fieldFormik.values.iv_less_the_cost}
                            type="number"
                            size="small"
                            onChange={fieldFormik.handleChange}
                            onBlur={(e) =>
                              setLessTheCost(
                                e.target.value === ""
                                  ? 0
                                  : parseInt(e.target.value)
                              )
                            }
                            sx={{ flex: 1 }} // 👈 TextField gets full remaining width
                            InputProps={{
                              sx: {
                                height: 25, // 👈 yahan height control karein
                                textAlign: "right", // 👈 text right aligned
                                "& input": {
                                  textAlign: "right", // 👈 ensure karein ke input ke andar text right me ho
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>


                    </TableRow>

                    <TableRow>
                      <TableCell
                        colSpan={2}
                        align="right"
                        sx={{
                          backgroundColor: "#0282ff",
                          border: "1px solid #ccc",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            color: "white",
                            fontSize: "20px",
                          }}
                        >
                          Total:{" "}
                          {grandTotalCharges
                            ? numberFormatting(grandTotalCharges)
                            : "-"}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
          {/* )} */}
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            className="confirmButton"
            sx={{ width: "30%", textTransform: "capitalize" }}
            onClick={onSaveCostEstimationConfirm}
          >
            Save Estimate
          </Button>
        </DialogActions>
      </Dialog>

      {/* Main Popup */}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth={"false"}
        className="main-dialog"
      >
        <DialogTitle className="dialog-title">
          <Grid container spacing={1} className="headercontainer">
            <Grid item xs className="applicationTitleGrid">
              <Typography className="applicationTitleText">
                New Connection -
                <span style={{ marginLeft: "1%", color: "white" }}>
                  {dialogRowData.applicationProgressId === 0 &&
                    " Document Uploading"}
                  {dialogRowData.applicationProgressId === 1 &&
                    " Document Verification"}
                  {dialogRowData.applicationProgressId === 21 &&
                    " Wiring Test Report Verification"}
                  {dialogRowData.applicationProgressId === 2 &&
                    " Arrear Verification"}
                  {dialogRowData.applicationProgressId === 3 && " Field Survey"}
                  {dialogRowData.applicationProgressId === 4 &&
                    " Reference Number Allocation"}
                  {dialogRowData.applicationProgressId === 5 &&
                    " DN Payment Submission"}
                  {dialogRowData.applicationProgressId === 6 &&
                    " DN Payment Verification"}
                  {dialogRowData.applicationProgressId === 7 &&
                    " Service Connection Order"}
                  {dialogRowData.applicationProgressId === 8 &&
                    " Meter Installation"}
                  {dialogRowData.applicationProgressId === 9 &&
                    " Ready for Billing"}
                  {dialogRowData.applicationProgressId === 10 && " Completed"}
                </span>
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                marginLeft: "auto",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                paddingRight: "4px",
              }}
            >
              {dialogRowData.objectionStatus === 1 && (
                <DescriptionIcon
                  onClick={() => downloadRejectionNoticePDF(dialogRowData)}
                  sx={{
                    cursor: "pointer",
                    color: "#ff2d2d",
                    fontSize: "22px",
                    animation: "rejectionIconBlink 1s ease-in-out infinite",
                    "@keyframes rejectionIconBlink": {
                      "0%, 100%": { opacity: 1 },
                      "50%": { opacity: 0.2 },
                    },
                  }}
                  titleAccess="Download Rejection Notice"
                />
              )}

              {dialogRowData.applicationProgressId >= 7 && (
                <Button
                  variant="contained"
                  startIcon={<PrintIcon />}
                  onClick={() => downloadSCOPDF(dialogRowData)}
                  sx={{
                    textTransform: "none",
                    backgroundColor: "#7094cf",
                    "&:hover": { backgroundColor: "#7094cf" }
                  }}
                >
                  SCO
                </Button>
              )}
              <Button
                variant="contained"
                startIcon={<PrintIcon />}
                onClick={() => downloadEFile(dialogRowData)}
                sx={{
                  textTransform: "none",
                  backgroundColor: "#7094cf",
                  "&:hover": { backgroundColor: "#7094cf" }
                }}
              >
                E-File
              </Button>
              <CloseIcon
                id="clearPopup"
                onClick={handleClose}
                sx={{ color: "white" }}
              />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: "white" }}>
          <DialogContentText component="div" className="dialog-content">
            <Grid container spacing={1} className="headercontainer">
              <Grid item lg={12} className="status-bar">
                <StepProgressBar
                  array={NCStatusBarArray}
                  applicationProgressId={getStepIndex(dialogRowData.applicationProgressId)}
                  objection={dialogRowData.objectionStatus}
                  openDetailsPopUp={openDetailsPopUp}
                />
              </Grid>
              <Grid item lg={12} className="application-details">
                <Grid container spacing={1} className="first-row">
                  <Grid item lg={1.33} className="first-row-item">
                    <p className="prop-title">Application Id</p>
                    <p className="prop-detail">{dialogRowData.applicationId}</p>
                  </Grid>
                  <Grid item lg={2.66} className="first-row-item">
                    <p className="prop-title">Applicant Name</p>
                    <p className="prop-detail">{dialogRowData.applicantName}</p>
                  </Grid>
                  <Grid item lg={1.33} className="first-row-item">
                    <p className="prop-title">Applicant CNIC</p>
                    <p className="prop-detail">{dialogRowData.applicantCNIC}</p>
                  </Grid>
                  <Grid item lg={1.33} className="first-row-item">
                    <p className="prop-title">
                      {dialogRowData.applicantRelationType
                        ? sodowo(dialogRowData.applicantRelationType)
                        : "-"}
                    </p>
                    <p className="prop-detail">
                      {dialogRowData.applicantRelativeName}
                    </p>
                  </Grid>
                  <Grid item lg={1} className="first-row-item">
                    <p className="prop-title">Applied Load(kW)</p>
                    <p className="prop-detail">{dialogRowData.appliedLoad}</p>
                  </Grid>
                  <Grid item lg={1} className="first-row-item">
                    <p className="prop-title">Connection Type</p>
                    <p className="prop-detail">
                      {dialogRowData.connectionType}
                    </p>
                  </Grid>
                  {/* <Grid item lg={1} className='first-row-item'>
                    <p className='prop-title'>Meter Type</p><p className='prop-detail'>{phase && phase}</p>
                  </Grid>
                  <Grid item lg={1} className='first-row-item'>
                    <p className='prop-title'>Tariff</p><p className='prop-detail'>{tariff && tariff}</p>
                  </Grid> */}
                  <Grid item lg={1} className="first-row-item">
                    <p className="prop-title">Meter Type</p>
                    <p className="prop-detail">{phase ? phase : "-"}</p>
                  </Grid>

                  <Grid item lg={1} className="first-row-item">
                    <p className="prop-title">Tariff</p>
                    <p className="prop-detail">{tariff ? tariff : "-"}</p>
                  </Grid>

                  <Grid item lg={1.33} className="first-row-item">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p className="prop-title">Unripe Age (Days)</p>
                      {dialogRowData.applicationProgressId <= 4 &&
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "New Connection",
                          "Basic Permissions",
                          "Update"
                        ) && (
                          <img
                            src={pencilIcon}
                            alt="edit"
                            width={17.5}
                            height={17.5}
                            style={{
                              position: "relative",
                              cursor: "pointer",
                              marginRight: "-22.5px",
                            }}
                            onClick={async () => await handleEditIconClick()}
                          />
                        )}
                    </div>
                    <p className="prop-detail">
                      {dialogRowData.applicationProgressId >= 1
                        ? (isNaN(unripeAge) ? "-" : unripeAge)
                        : "-"}
                    </p>
                  </Grid>
                </Grid>
                <Grid container spacing={1} className="second-row">
                  <Grid item lg={1.33} className="second-row-item">
                    <p className="prop-title">Subdivision</p>
                    <p className="prop-detail">
                      {subdivisionName(
                        dialogRowData.subDivisionCode,
                        subDivisions
                      )}
                    </p>
                  </Grid>
                  <Grid item lg={1.33} className="second-row-item">
                    <p className="prop-title">Near By Ref. No.</p>
                    <p className="prop-detail">
                      {dialogRowData.nearByReferenceNumber
                        ? dialogRowData.nearByReferenceNumber
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={0.665} className="second-row-item">
                    <p className="prop-title">Inst. Meters</p>
                    <p className="prop-detail">
                      {dialogRowData.noOfMetersAlreadyInstalled
                        ? dialogRowData.noOfMetersAlreadyInstalled
                        : "0"}
                    </p>
                  </Grid>
                  <Grid item lg={0.665} className="second-row-item">
                    <p className="prop-title">Status</p>
                    <p className="prop-detail">
                      {dialogRowData.applicantStatus
                        ? dialogRowData.applicantStatus
                        : "_"}
                    </p>
                  </Grid>
                  <Grid item lg={1.33} className="second-row-item">
                    <p className="prop-title">Phone No.</p>
                    <p className="prop-detail">
                      {dialogRowData.applicantMobile
                        ? dialogRowData.applicantMobile
                        : "-"}
                    </p>
                  </Grid>
                  {dialogRowData.connectionType == "Domestic" ||
                    dialogRowData.connectionType == "Temporary" ||
                    dialogRowData.connectionType == "Public Lightning" ||
                    dialogRowData.connectionType == "Railway Tracking" ? (
                    <>
                      <Grid item lg={3.99} className="second-row-item">
                        <p className="prop-title">Address</p>
                        <p className="prop-detail">
                          {dialogRowData.premisesAddress}
                        </p>
                      </Grid>
                      <Grid item lg={1.33} className="second-row-item">
                        <p className="prop-title">Exceeded (Days)</p>
                        <p className="prop-detail">
                          {dialogRowData.exceededDuration
                            ? dialogRowData.exceededDuration
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.33} className="second-row-item">
                        <p className="prop-title">Ripe Age (Days)</p>
                        <p className="prop-detail">
                          {dialogRowData.applicationProgressId >= 5
                            ? (isNaN(ripeAge) ? "-" : ripeAge)
                            : "-"}
                        </p>
                      </Grid>
                    </>
                  ) : (
                    <>
                      <Grid item lg={2.66} className="second-row-item">
                        <p className="prop-title">Address</p>
                        <p className="prop-detail">
                          {dialogRowData.premisesAddress}
                        </p>
                      </Grid>
                      <Grid item lg={1} className="second-row-item">
                        <p className="prop-title">NTN.</p>
                        <p className="prop-detail">
                          {dialogRowData.NTN ? dialogRowData.NTN : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1} className="second-row-item">
                        <p className="prop-title">STRN.</p>
                        <p className="prop-detail">
                          {dialogRowData.STRN ? dialogRowData.STRN : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1} className="second-row-item">
                        <p className="prop-title">Exceeded (Days)</p>
                        <p className="prop-detail">
                          {dialogRowData.exceededDuration
                            ? dialogRowData.exceededDuration
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1} className="second-row-item">
                        <p className="prop-title">Ripe Age (Days)</p>
                        <p className="prop-detail">
                          {dialogRowData.applicationProgressId >= 5
                            ? (isNaN(ripeAge) ? "-" : ripeAge)
                            : "-"}
                        </p>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
              <Grid item className="processing-summary">
                <div
                  className="title"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <h2 style={{ margin: 0, fontSize: 22 }}>Activity Log</h2>
                </div>

                {viewDropBackForEfile ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "20px",
                    }}
                  >
                    <CircularProgress size={30} />
                  </div>
                ) : eFileData && eFileData.length > 0 ? (
                  <ProcessingSummaryTable
                    key={eFileData.length}
                    data={tableDataProcessingSummary}
                    columns={tableColumnsProcessingSummary}
                    openDetailsPopUp={openDetailsPopUp}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "20px",
                    }}
                  >
                    {/* <button
                      onClick={onPressViewActivityLog}
                      className='view-button'
                      style={{
                        cursor: "pointer",
                        padding: "10px 20px",
                        fontSize: "14px",
                        fontWeight: "500",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        backgroundColor: "#f9f9f9",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        transition: "all 0.3s ease"
                      }}
                    >
                      <span style={{ fontSize: "12px" }}>▼</span> View Activity Log
                    </button> */}
                    <button
                      onClick={onPressViewActivityLog}
                      type="submit"
                      className="view-button"
                      style={{
                        marginBottom: "10px",
                        backgroundColor: "#003971",
                        borderRadius: "20px",
                        color: "white",
                        padding: "12px 25px",
                      }}
                    >
                      <span style={{ fontSize: "12px" }}>▼</span> Load Activity
                      Log
                    </button>
                  </div>
                )}
              </Grid>

              <Grid item className="action-form">
                <div className="fields">
                  {dialogRowData.applicationProgressId === 0 ? (
                    <>
                      <h3 className="step-title">Documents Pending</h3>
                      <Grid
                        container
                        spacing={1}
                        sx={{ display: "flex", justifyContent: "flex-start" }}
                      >
                        {error && (
                          <div
                            style={{
                              backgroundColor: "#FFF3F3",
                              display: "flex",
                              flexDirection: "row",
                              marginLeft: "1%",
                              width: "100%",
                              padding: "1%",
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <ErrorIcon
                              style={{ color: "#bb0303", marginRight: "1%" }}
                            />
                            <p
                              style={{
                                color: "#bb0303",
                              }}
                            >
                              {error}
                            </p>
                            <CloseIcon
                              onClick={errorCloses}
                              style={{
                                color: "#bb0303",
                                marginRight: "1%",
                                marginTop: "1%",
                                cursor: "pointer",
                              }}
                            />
                          </div>
                        )}
                        {(dialogRowData.copyOfApplicantCNICFront ||
                          dialogRowData.copyOfApplicantCNICBack) && (
                            <Grid item lg={2}>
                              <Grid
                                container
                                sx={{
                                  backgroundColor:
                                    dialogRowData.copyOfApplicantCNICFrontFlag &&
                                      dialogRowData.copyOfApplicantCNICBackFlag
                                      ? getDocumentBackGroundColor(
                                        dialogRowData.copyOfApplicantCNICFrontFlag
                                      )
                                      : getDocumentBackGroundColor(
                                        flag_copyOfApplicantCNICFront
                                      ),
                                  borderRadius: "10px",
                                  minHeight: "125px",
                                  height: "auto",
                                }}
                              >
                                <Grid item lg={12} className="tittlegrid">
                                  <p className="docTitle">Applicant's CNIC.</p>
                                </Grid>
                                <Grid
                                  item
                                  lg={12}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    paddingBottom: "5px",
                                  }}
                                >
                                  <div
                                    onClick={() => {
                                      if (!copyOfApplicantCNICVerifyPopUp) {
                                        setCopyOfApplicantCNICVerifyPopUp(true);
                                      }
                                    }}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {dialogRowData.copyOfApplicantCNICFront.slice(
                                      0,
                                      6
                                    ) == "data:i" ? (
                                      <Base64Image
                                        data={
                                          dialogRowData.copyOfApplicantCNICFront
                                        }
                                        width="80"
                                      />
                                    ) : (
                                      <Base64Image data={pdfIcon} width="40" />
                                    )}
                                    <Base64Image
                                      data={
                                        dialogRowData.copyOfApplicantCNICBack.slice(
                                          5,
                                          6
                                        ) == "ima"
                                          ? dialogRowData.copyOfApplicantCNICBack
                                          : pdfIcon
                                      }
                                      width="80"
                                      height="50"
                                    />
                                    {copyOfApplicantCNICVerifyPopUp && (
                                      <OpenBase64ImageInPopup
                                        docVerifyPopUp={
                                          copyOfApplicantCNICVerifyPopUp
                                        }
                                        hideDocVerifyPopup={
                                          hideCopyOfApplicantCNICVerifyAlert
                                        }
                                        documentName="Applicant CNIC"
                                        documentImage={
                                          dialogRowData.copyOfApplicantCNICFront
                                        }
                                        backDocumentImage={
                                          dialogRowData.copyOfApplicantCNICBack
                                        }
                                        width={"100%"}
                                        document={
                                          dialogRowData.copyOfApplicantCNICFront
                                        }
                                        documentFlag={
                                          dialogRowData.copyOfApplicantCNICFrontFlag
                                        }
                                        applicationProgressId={
                                          dialogRowData.applicationProgressId
                                        }
                                        objectionStatus={
                                          dialogRowData.objectionStatus
                                        }
                                        updateDocFlag={updateDocFlag}
                                        titleToUpdateFlag="copyOfApplicantCNIC"
                                        documentRemarks={
                                          copyOfApplicantCNICFrontObjectionRemarks
                                        }
                                        flag_document={
                                          flag_copyOfApplicantCNICFront
                                        }
                                        flag_documentBack={
                                          flag_copyOfApplicantCNICBack
                                        }
                                      />
                                    )}
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                        {dialogRowData.premisesDocument && (
                          <Grid item lg={2}>
                            <Grid
                              container
                              sx={{
                                backgroundColor:
                                  dialogRowData.premisesDocumentFlag
                                    ? getDocumentBackGroundColor(
                                      dialogRowData.premisesDocumentFlag
                                    )
                                    : getDocumentBackGroundColor(
                                      flag_premisesDocument
                                    ),
                                borderRadius: "10px",
                                minHeight: "125px",
                                height: "auto",
                              }}
                            >
                              <Grid item lg={12} className="tittlegrid">
                                <p className="docTitle">Property Documents</p>
                              </Grid>
                              <Grid
                                item
                                lg={12}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  paddingBottom: "5px",
                                }}
                              >
                                <div
                                  onClick={() => {
                                    if (!propertyDocVerifyPopUp) {
                                      setPropertyDocVerifyPopUp(true);
                                    }
                                  }}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {dialogRowData.premisesDocument.slice(0, 6) ==
                                    "data:i" ? (
                                    <Base64Image
                                      data={dialogRowData.premisesDocument}
                                      width="80"
                                    />
                                  ) : (
                                    <Base64Image data={pdfIcon} width="40" />
                                  )}
                                  {propertyDocVerifyPopUp && (
                                    <OpenBase64ImageInPopup
                                      docVerifyPopUp={propertyDocVerifyPopUp}
                                      hideDocVerifyPopup={
                                        hidePropertyDocVerifyAlert
                                      }
                                      documentName="Property Document"
                                      documentImage={
                                        dialogRowData.premisesDocument
                                      }
                                      width={"100%"}
                                      document={dialogRowData.premisesDocument}
                                      documentFlag={
                                        dialogRowData.premisesDocumentFlag
                                      }
                                      applicationProgressId={
                                        dialogRowData.applicationProgressId
                                      }
                                      objectionStatus={
                                        dialogRowData.objectionStatus
                                      }
                                      updateDocFlag={updateDocFlag}
                                      documentRemarks={
                                        premisesDocumentObjectionRemarks
                                      }
                                      titleToUpdateFlag="premisesDocument"
                                      flag_document={flag_premisesDocument}
                                    />
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                        {dialogRowData.scannedCopyOfNearByElectricityBill && (
                          <Grid item lg={2}>
                            <Grid
                              container
                              sx={{
                                backgroundColor:
                                  dialogRowData.scannedCopyOfNearByElectricityBillFlag
                                    ? getDocumentBackGroundColor(
                                      dialogRowData.scannedCopyOfNearByElectricityBillFlag
                                    )
                                    : getDocumentBackGroundColor(
                                      flag_scannedCopyOfNearByElectricityBill
                                    ),
                                borderRadius: "10px",
                                minHeight: "125px",
                                height: "auto",
                              }}
                            >
                              <Grid item lg={12} className="tittlegrid">
                                <p className="docTitle">Near-by Elec. Bill</p>
                              </Grid>
                              <Grid
                                item
                                lg={12}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  paddingBottom: "5px",
                                }}
                              >
                                <div
                                  onClick={() => {
                                    if (!nearByBillVerifyPopUp) {
                                      setNearByBillVerifyPopUp(true);
                                    }
                                  }}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {dialogRowData.scannedCopyOfNearByElectricityBill.slice(
                                    0,
                                    6
                                  ) == "data:i" ? (
                                    <Base64Image
                                      data={
                                        dialogRowData.scannedCopyOfNearByElectricityBill
                                      }
                                      width="80"
                                      height="100"
                                    />
                                  ) : (
                                    <Base64Image data={pdfIcon} width="80" />
                                  )}
                                  {nearByBillVerifyPopUp && (
                                    <OpenBase64ImageInPopup
                                      docVerifyPopUp={nearByBillVerifyPopUp}
                                      hideDocVerifyPopup={
                                        hideNearByBillVerifyAlert
                                      }
                                      documentName="Near-by Electricity Bill"
                                      documentImage={
                                        dialogRowData.scannedCopyOfNearByElectricityBill
                                      }
                                      width={"100%"}
                                      document={
                                        dialogRowData.scannedCopyOfNearByElectricityBill
                                      }
                                      documentFlag={
                                        dialogRowData.scannedCopyOfNearByElectricityBillFlag
                                      }
                                      applicationProgressId={
                                        dialogRowData.applicationProgressId
                                      }
                                      objectionStatus={
                                        dialogRowData.objectionStatus
                                      }
                                      updateDocFlag={updateDocFlag}
                                      documentRemarks={
                                        scannedCopyOfNearByElectricityBillObjectionRemarks
                                      }
                                      titleToUpdateFlag="scannedCopyOfNearByElectricityBill"
                                      flag_document={
                                        flag_scannedCopyOfNearByElectricityBill
                                      }
                                    />
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                        {dialogRowData.anyOtherDocument && (
                          <Grid item lg={2}>
                            <Grid
                              container
                              sx={{
                                backgroundColor:
                                  dialogRowData.anyOtherDocumentFlag
                                    ? getDocumentBackGroundColor(
                                      dialogRowData.anyOtherDocumentFlag
                                    )
                                    : getDocumentBackGroundColor(
                                      flag_anyOtherDocument
                                    ),
                                borderRadius: "10px",
                                minHeight: "125px",
                                height: "auto",
                              }}
                            >
                              <Grid item lg={12} className="tittlegrid">
                                <p className="docTitle">Any Other Document</p>
                              </Grid>
                              <Grid
                                item
                                lg={12}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  paddingBottom: "5px",
                                }}
                              >
                                <div
                                  onClick={() => {
                                    if (!anyOtherDocumentVerifyPopUp) {
                                      setAnyOtherDocumentVerifyPopUp(true);
                                    }
                                  }}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {dialogRowData.anyOtherDocument.slice(0, 6) ==
                                    "data:i" ? (
                                    <Base64Image
                                      data={dialogRowData.anyOtherDocument}
                                      width="80"
                                      height="100"
                                    />
                                  ) : (
                                    <Base64Image data={pdfIcon} width="80" />
                                  )}
                                  {anyOtherDocumentVerifyPopUp && (
                                    <OpenBase64ImageInPopup
                                      docVerifyPopUp={
                                        anyOtherDocumentVerifyPopUp
                                      }
                                      hideDocVerifyPopup={
                                        hideAnyOtherDocumentVerifyAlert
                                      }
                                      documentName="Any Other Document"
                                      documentImage={
                                        dialogRowData.anyOtherDocument
                                      }
                                      width={"100%"}
                                      document={dialogRowData.anyOtherDocument}
                                      documentFlag={
                                        dialogRowData.anyOtherDocumentFlag
                                      }
                                      applicationProgressId={
                                        dialogRowData.applicationProgressId
                                      }
                                      objectionStatus={
                                        dialogRowData.objectionStatus
                                      }
                                      updateDocFlag={updateDocFlag}
                                      documentRemarks={
                                        anyOtherDocumentObjectionRemarks
                                      }
                                      titleToUpdateFlag="anyOtherDocument"
                                      flag_document={flag_anyOtherDocument}
                                    />
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                        {tenantStatus.includes(
                          dialogRowData.applicantStatus
                        ) ? (
                          <>
                            {(dialogRowData.copyOfOwnerCNICFront ||
                              dialogRowData.copyOfOwnerCNICBack) && (
                                <Grid item lg={2}>
                                  <Grid
                                    container
                                    sx={{
                                      backgroundColor:
                                        dialogRowData.copyOfOwnerCNICFrontFlag
                                          ? getDocumentBackGroundColor(
                                            dialogRowData.copyOfOwnerCNICFrontFlag
                                          )
                                          : getDocumentBackGroundColor(
                                            flag_copyOfOwnerCNICFront
                                          ),
                                      borderRadius: "10px",
                                      minHeight: "125px",
                                      height: "auto",
                                    }}
                                  >
                                    <Grid item lg={12} className="tittlegrid">
                                      <p className="docTitle">Owner's CNIC.</p>
                                    </Grid>
                                    <Grid
                                      item
                                      lg={12}
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <div
                                        onClick={() => {
                                          if (!copyOfOwnerCNICVerifyPopUp) {
                                            setCopyOfOwnerCNICVerifyPopUp(true);
                                          }
                                        }}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          flexDirection: "column",
                                        }}
                                      >
                                        {dialogRowData.copyOfOwnerCNICFront.slice(
                                          0,
                                          6
                                        ) == "data:i" ? (
                                          <Base64Image
                                            data={
                                              dialogRowData.copyOfOwnerCNICFront
                                            }
                                            width="80"
                                          />
                                        ) : (
                                          <Base64Image
                                            data={pdfIcon}
                                            width="40"
                                          />
                                        )}
                                        {dialogRowData.copyOfOwnerCNICBack.slice(
                                          0,
                                          6
                                        ) == "data:i" ? (
                                          <Base64Image
                                            data={
                                              dialogRowData.copyOfOwnerCNICBack
                                            }
                                            width="80"
                                          />
                                        ) : (
                                          <Base64Image
                                            data={pdfIcon}
                                            width="40"
                                          />
                                        )}
                                        {copyOfOwnerCNICVerifyPopUp && (
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={
                                              copyOfOwnerCNICVerifyPopUp
                                            }
                                            hideDocVerifyPopup={
                                              hideCopyOfOwnerCNICVerifyAlert
                                            }
                                            documentName="Owner's CNIC"
                                            documentImage={
                                              dialogRowData.copyOfOwnerCNICFront
                                            }
                                            backDocumentImage={
                                              dialogRowData.copyOfOwnerCNICBack
                                            }
                                            width={"100%"}
                                            document={
                                              dialogRowData.copyOfOwnerCNICFront
                                            }
                                            documentFlag={
                                              dialogRowData.copyOfOwnerCNICFrontFlag
                                            }
                                            applicationProgressId={
                                              dialogRowData.applicationProgressId
                                            }
                                            objectionStatus={
                                              dialogRowData.objectionStatus
                                            }
                                            updateDocFlag={updateDocFlag}
                                            titleToUpdateFlag="copyOfOwnerCNIC"
                                            documentRemarks={
                                              copyOfOwnerCNICFrontObjectionRemarks
                                            }
                                            flag_document={
                                              flag_copyOfOwnerCNICFront
                                            }
                                            flag_documentBack={
                                              flag_copyOfOwnerCNICBack
                                            }
                                          />
                                        )}
                                      </div>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                            {dialogRowData.ownerNOC && (
                              <Grid item lg={2}>
                                <Grid
                                  container
                                  sx={{
                                    backgroundColor: dialogRowData.ownerNOCFlag
                                      ? getDocumentBackGroundColor(
                                        dialogRowData.ownerNOCFlag
                                      )
                                      : getDocumentBackGroundColor(
                                        flag_ownerNOC
                                      ),
                                    borderRadius: "10px",
                                    minHeight: "125px",
                                    height: "auto",
                                  }}
                                >
                                  <Grid item lg={12} className="tittlegrid">
                                    <p className="docTitle">NOC. from Owner</p>
                                  </Grid>
                                  <Grid
                                    item
                                    lg={12}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      paddingBottom: "5px",
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        if (!ownerNOCVerifyPopUp) {
                                          setOwnerNOCVerifyPopUp(true);
                                        }
                                      }}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {dialogRowData.ownerNOC.slice(0, 6) ==
                                        "data:i" ? (
                                        <Base64Image
                                          data={dialogRowData.ownerNOC}
                                          width="80"
                                        />
                                      ) : (
                                        <Base64Image
                                          data={pdfIcon}
                                          width="80"
                                        />
                                      )}
                                      {ownerNOCVerifyPopUp && (
                                        <OpenBase64ImageInPopup
                                          docVerifyPopUp={ownerNOCVerifyPopUp}
                                          hideDocVerifyPopup={
                                            hideOwnerNocVerifyAlert
                                          }
                                          documentName="Noc from Owner"
                                          documentImage={dialogRowData.ownerNOC}
                                          width={"100%"}
                                          document={dialogRowData.ownerNOC}
                                          documentFlag={
                                            dialogRowData.ownerNOCFlag
                                          }
                                          applicationProgressId={
                                            dialogRowData.applicationProgressId
                                          }
                                          objectionStatus={
                                            dialogRowData.objectionStatus
                                          }
                                          updateDocFlag={updateDocFlag}
                                          documentRemarks={
                                            ownerNOCObjectionRemarks
                                          }
                                          titleToUpdateFlag="ownerNOC"
                                          flag_document={flag_ownerNOC}
                                        />
                                      )}
                                    </div>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                          </>
                        ) : null}
                        <Grid item lg={12}></Grid>
                        {dialogRowData.connectionType === "Industrial" ? (
                          <>
                            {dialogRowData.resolutionFormDesc && (
                              <Grid item lg={2}>
                                <Grid
                                  container
                                  sx={{
                                    backgroundColor:
                                      dialogRowData.resolutionFormDescFlag
                                        ? getDocumentBackGroundColor(
                                          dialogRowData.resolutionFormDescFlag
                                        )
                                        : getDocumentBackGroundColor(
                                          flag_resolutionFormDesc
                                        ),
                                    borderRadius: "10px",
                                    minHeight: "125px",
                                    height: "auto",
                                  }}
                                >
                                  <Grid item lg={12} className="tittlegrid">
                                    <p className="docTitle">
                                      BoD's Resolution Form
                                    </p>
                                  </Grid>
                                  <Grid
                                    item
                                    lg={12}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      paddingBottom: "5px",
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        if (!resolutionFormDescVerifyPopUp) {
                                          setResolutionFormDescVerifyPopUp(
                                            true
                                          );
                                        }
                                      }}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {dialogRowData.resolutionFormDesc.slice(
                                        0,
                                        6
                                      ) == "data:i" ? (
                                        <Base64Image
                                          data={
                                            dialogRowData.resolutionFormDesc
                                          }
                                          width="80"
                                        />
                                      ) : (
                                        <Base64Image
                                          data={pdfIcon}
                                          width="80"
                                        />
                                      )}
                                      {resolutionFormDescVerifyPopUp && (
                                        <OpenBase64ImageInPopup
                                          docVerifyPopUp={
                                            resolutionFormDescVerifyPopUp
                                          }
                                          hideDocVerifyPopup={
                                            hideResolutionFormDescVerifyAlert
                                          }
                                          documentName="BoD's Resolution Form<"
                                          documentImage={
                                            dialogRowData.resolutionFormDesc
                                          }
                                          width={"100%"}
                                          document={
                                            dialogRowData.resolutionFormDesc
                                          }
                                          documentFlag={
                                            dialogRowData.resolutionFormDescFlag
                                          }
                                          applicationProgressId={
                                            dialogRowData.applicationProgressId
                                          }
                                          objectionStatus={
                                            dialogRowData.objectionStatus
                                          }
                                          updateDocFlag={updateDocFlag}
                                          documentRemarks={
                                            resolutionFormDescObjectionRemarks
                                          }
                                          titleToUpdateFlag="resolutionFormDesc"
                                          flag_document={
                                            flag_resolutionFormDesc
                                          }
                                        />
                                      )}
                                    </div>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                            {dialogRowData.certMemoDesc && (
                              <Grid item lg={2}>
                                <Grid
                                  container
                                  sx={{
                                    backgroundColor:
                                      dialogRowData.certMemoDescFlag
                                        ? getDocumentBackGroundColor(
                                          dialogRowData.certMemoDescFlag
                                        )
                                        : getDocumentBackGroundColor(
                                          flag_certMemoDesc
                                        ),
                                    borderRadius: "10px",
                                    minHeight: "125px",
                                    height: "auto",
                                  }}
                                >
                                  <Grid item lg={12} className="tittlegrid">
                                    <p className="docTitle">
                                      Memorandum of association
                                    </p>
                                  </Grid>
                                  <Grid
                                    item
                                    lg={12}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      paddingBottom: "5px",
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        if (!certMemoDescVerifyPopUp) {
                                          setCertMemoDescVerifyPopUp(true);
                                        }
                                      }}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {dialogRowData.certMemoDesc.slice(0, 6) ==
                                        "data:i" ? (
                                        <Base64Image
                                          data={dialogRowData.certMemoDesc}
                                          width="80"
                                        />
                                      ) : (
                                        <Base64Image
                                          data={pdfIcon}
                                          width="80"
                                        />
                                      )}
                                      {certMemoDescVerifyPopUp && (
                                        <OpenBase64ImageInPopup
                                          docVerifyPopUp={
                                            certMemoDescVerifyPopUp
                                          }
                                          hideDocVerifyPopup={
                                            hideCertMemoDescVerifyAlert
                                          }
                                          documentName="Memorandum of Association"
                                          documentImage={
                                            dialogRowData.certMemoDesc
                                          }
                                          width={"100%"}
                                          document={dialogRowData.certMemoDesc}
                                          documentFlag={
                                            dialogRowData.certMemoDescFlag
                                          }
                                          applicationProgressId={
                                            dialogRowData.applicationProgressId
                                          }
                                          objectionStatus={
                                            dialogRowData.objectionStatus
                                          }
                                          updateDocFlag={updateDocFlag}
                                          documentRemarks={
                                            certMemoDescObjectionRemarks
                                          }
                                          titleToUpdateFlag="certMemoDesc"
                                          flag_document={flag_certMemoDesc}
                                        />
                                      )}
                                    </div>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                            {dialogRowData.certFormDesc && (
                              <Grid item lg={2}>
                                <Grid
                                  container
                                  sx={{
                                    backgroundColor:
                                      dialogRowData.certFormDescFlag
                                        ? getDocumentBackGroundColor(
                                          dialogRowData.certFormDescFlag
                                        )
                                        : getDocumentBackGroundColor(
                                          flag_certFormDesc
                                        ),
                                    borderRadius: "10px",
                                    minHeight: "125px",
                                    height: "auto",
                                  }}
                                >
                                  <Grid item lg={12} className="tittlegrid">
                                    <p className="docTitle">
                                      Certified Form-29
                                    </p>
                                  </Grid>
                                  <Grid
                                    item
                                    lg={12}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      paddingBottom: "5px",
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        if (!certFormDescVerifyPopUp) {
                                          setCertFormDescVerifyPopUp(true);
                                        }
                                      }}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {dialogRowData.certFormDesc.slice(0, 6) ==
                                        "data:i" ? (
                                        <Base64Image
                                          data={dialogRowData.certFormDesc}
                                          width="80"
                                        />
                                      ) : (
                                        <Base64Image
                                          data={pdfIcon}
                                          width="80"
                                        />
                                      )}
                                      {certFormDescVerifyPopUp && (
                                        <OpenBase64ImageInPopup
                                          docVerifyPopUp={
                                            certFormDescVerifyPopUp
                                          }
                                          hideDocVerifyPopup={
                                            hideCertFormDescVerifyAlert
                                          }
                                          documentName="Certified Form-29"
                                          documentImage={
                                            dialogRowData.certFormDesc
                                          }
                                          width={"100%"}
                                          document={dialogRowData.certFormDesc}
                                          documentFlag={
                                            dialogRowData.certFormDescFlag
                                          }
                                          applicationProgressId={
                                            dialogRowData.applicationProgressId
                                          }
                                          objectionStatus={
                                            dialogRowData.objectionStatus
                                          }
                                          updateDocFlag={updateDocFlag}
                                          documentRemarks={
                                            certFormDescObjectionRemarks
                                          }
                                          titleToUpdateFlag="certFormDesc"
                                          flag_document={flag_certFormDesc}
                                        />
                                      )}
                                    </div>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                          </>
                        ) : null}
                      </Grid>
                    </>
                  ) : dialogRowData.applicationProgressId === 1 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "New Connection",
                      "Workflow Permissions",
                      "Document Verification"
                    ) ? (
                      <>
                        <h3 className="step-title">Attached Documents</h3>
                        <Grid
                          className="document-verification-container"
                          container
                          spacing={1}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            marginTop: "1%",
                            padding: "2%",
                          }}
                        >
                          {error && (
                            <Error
                              error={error}
                              onClose={errorCloses}
                              backgroundColor="#FFC0CB"
                              textColor="#bb0303"
                              iconColor="#bb0303"
                            />
                          )}
                          {(dialogRowData.copyOfApplicantCNICFront ||
                            dialogRowData.copyOfApplicantCNICBack) && (
                              <Grid item lg={2}>
                                <Grid
                                  container
                                  sx={{
                                    backgroundColor:
                                      dialogRowData.copyOfApplicantCNICFrontFlag &&
                                        dialogRowData.copyOfApplicantCNICBackFlag
                                        ? getDocumentBackGroundColor(
                                          dialogRowData.copyOfApplicantCNICFrontFlag
                                        )
                                        : getDocumentBackGroundColor(
                                          flag_copyOfApplicantCNICFront
                                        ),
                                    borderRadius: "10px",
                                    minHeight: "125px",
                                    height: "auto",
                                  }}
                                >
                                  <Grid item lg={12} className="tittlegrid">
                                    <p className="docTitle">Applicant's CNIC.</p>
                                  </Grid>
                                  <Grid
                                    item
                                    lg={12}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      paddingBottom: "5px",
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        if (!copyOfApplicantCNICVerifyPopUp) {
                                          setCopyOfApplicantCNICVerifyPopUp(true);
                                        }
                                      }}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        flexDirection: "column",
                                        alignItems: "center",
                                      }}
                                    >
                                      {dialogRowData.copyOfApplicantCNICFront &&
                                        dialogRowData.copyOfApplicantCNICFront.slice(
                                          0,
                                          6
                                        ) == "data:i" ? (
                                        <Base64Image
                                          data={
                                            dialogRowData.copyOfApplicantCNICFront
                                          }
                                          width="80"
                                        />
                                      ) : (
                                        <Base64Image data={pdfIcon} width="40" />
                                      )}
                                      {dialogRowData.copyOfApplicantCNICBack &&
                                        dialogRowData.copyOfApplicantCNICBack.slice(
                                          0,
                                          6
                                        ) === "data:i" ? (
                                        flag_copyOfApplicantCNICFront === 1 ||
                                          flag_copyOfApplicantCNICBack === 1 ? (
                                          <>
                                            <Base64Image
                                              data={
                                                dialogRowData.copyOfApplicantCNICBack
                                              }
                                              width="80"
                                            />
                                            <img
                                              src={tickicon}
                                              width="25px"
                                              height="25px"
                                              alt="Tick Icon"
                                              style={{
                                                position: "relative",
                                                zIndex: "2",
                                                marginRight: "-120px",
                                                marginTop: "-30px",
                                              }}
                                            />
                                          </>
                                        ) : flag_copyOfApplicantCNICFront ===
                                          -1 ||
                                          flag_copyOfApplicantCNICBack === -1 ? (
                                          <>
                                            <Base64Image
                                              data={
                                                dialogRowData.copyOfApplicantCNICBack
                                              }
                                              width="80"
                                            />
                                            <img
                                              src={crossIcon}
                                              width="25px"
                                              height="25px"
                                              alt="Cross Icon"
                                              style={{
                                                position: "relative",
                                                zIndex: "2",
                                                marginRight: "-120px",
                                                marginTop: "-30px",
                                              }}
                                            />
                                          </>
                                        ) : (
                                          <Base64Image
                                            data={
                                              dialogRowData.copyOfApplicantCNICBack
                                            }
                                            width="80"
                                          />
                                        )
                                      ) : (
                                        <Base64Image data={pdfIcon} width="40" />
                                      )}

                                      {copyOfApplicantCNICVerifyPopUp && (
                                        <OpenBase64ImageInPopup
                                          docVerifyPopUp={
                                            copyOfApplicantCNICVerifyPopUp
                                          }
                                          hideDocVerifyPopup={
                                            hideCopyOfApplicantCNICVerifyAlert
                                          }
                                          documentName="Applicant CNIC"
                                          documentImage={
                                            dialogRowData.copyOfApplicantCNICFront
                                          }
                                          backDocumentImage={
                                            dialogRowData.copyOfApplicantCNICBack
                                          }
                                          width={"100%"}
                                          document={
                                            dialogRowData.copyOfApplicantCNICFront
                                          }
                                          documentFlag={
                                            dialogRowData.copyOfApplicantCNICFrontFlag
                                          }
                                          applicationProgressId={
                                            dialogRowData.applicationProgressId
                                          }
                                          objectionStatus={
                                            dialogRowData.objectionStatus
                                          }
                                          updateDocFlag={updateDocFlag}
                                          titleToUpdateFlag="copyOfApplicantCNIC"
                                          documentRemarks={
                                            copyOfApplicantCNICFrontObjectionRemarks
                                          }
                                          flag_document={
                                            flag_copyOfApplicantCNICFront
                                          }
                                          flag_documentBack={
                                            flag_copyOfApplicantCNICBack
                                          }
                                        />
                                      )}
                                    </div>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                          {dialogRowData.premisesDocument && (
                            <Grid item lg={2}>
                              <Grid
                                container
                                sx={{
                                  backgroundColor:
                                    dialogRowData.premisesDocumentFlag
                                      ? getDocumentBackGroundColor(
                                        dialogRowData.premisesDocumentFlag
                                      )
                                      : getDocumentBackGroundColor(
                                        flag_premisesDocument
                                      ),
                                  borderRadius: "10px",
                                  minHeight: "125px",
                                  height: "auto",
                                }}
                              >
                                <Grid item lg={12} className="tittlegrid">
                                  <p className="docTitle">Property Documents</p>
                                </Grid>
                                <Grid
                                  item
                                  lg={12}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    onClick={() => {
                                      if (!propertyDocVerifyPopUp) {
                                        setPropertyDocVerifyPopUp(true);
                                      }
                                    }}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {dialogRowData.premisesDocument.slice(
                                      0,
                                      6
                                    ) === "data:i" ? (
                                      flag_premisesDocument === 1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.premisesDocument
                                            }
                                            width="80"
                                            height="100"
                                          />
                                          <img
                                            src={tickicon}
                                            width="25px"
                                            height="25px"
                                            alt="Tick Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-20px",
                                              marginTop: "60px",
                                            }}
                                          />
                                        </>
                                      ) : flag_premisesDocument === -1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.premisesDocument
                                            }
                                            width="80"
                                            height="100"
                                          />
                                          <img
                                            src={crossIcon}
                                            width="25px"
                                            height="25px"
                                            alt="Cross Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-20px",
                                              marginTop: "60px",
                                            }}
                                          />
                                        </>
                                      ) : (
                                        <Base64Image
                                          data={dialogRowData.premisesDocument}
                                          width="80"
                                          height="100"
                                        />
                                      )
                                    ) : (
                                      <Base64Image data={pdfIcon} width="80" />
                                    )}
                                    {propertyDocVerifyPopUp && (
                                      <OpenBase64ImageInPopup
                                        docVerifyPopUp={propertyDocVerifyPopUp}
                                        hideDocVerifyPopup={
                                          hidePropertyDocVerifyAlert
                                        }
                                        documentName="Property Document"
                                        documentImage={
                                          dialogRowData.premisesDocument
                                        }
                                        width={"100%"}
                                        document={
                                          dialogRowData.premisesDocument
                                        }
                                        documentFlag={
                                          dialogRowData.premisesDocumentFlag
                                        }
                                        applicationProgressId={
                                          dialogRowData.applicationProgressId
                                        }
                                        objectionStatus={
                                          dialogRowData.objectionStatus
                                        }
                                        updateDocFlag={updateDocFlag}
                                        documentRemarks={
                                          premisesDocumentObjectionRemarks
                                        }
                                        titleToUpdateFlag="premisesDocument"
                                        flag_document={flag_premisesDocument}
                                      />
                                    )}
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                          {dialogRowData.scannedCopyOfNearByElectricityBill && (
                            <Grid item lg={2}>
                              <Grid
                                container
                                sx={{
                                  backgroundColor:
                                    dialogRowData.scannedCopyOfNearByElectricityBillFlag
                                      ? getDocumentBackGroundColor(
                                        dialogRowData.scannedCopyOfNearByElectricityBillFlag
                                      )
                                      : getDocumentBackGroundColor(
                                        flag_scannedCopyOfNearByElectricityBill
                                      ),
                                  borderRadius: "10px",
                                  minHeight: "125px",
                                  height: "auto",
                                }}
                              >
                                <Grid item lg={12} className="tittlegrid">
                                  <p className="docTitle">Near-by Elec. Bill</p>
                                </Grid>
                                <Grid
                                  item
                                  lg={12}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    paddingBottom: "5px",
                                  }}
                                >
                                  <div
                                    onClick={() => {
                                      if (!nearByBillVerifyPopUp) {
                                        setNearByBillVerifyPopUp(true);
                                      }
                                    }}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {dialogRowData.scannedCopyOfNearByElectricityBill.slice(
                                      0,
                                      6
                                    ) === "data:i" ? (
                                      flag_scannedCopyOfNearByElectricityBill ===
                                        1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.scannedCopyOfNearByElectricityBill
                                            }
                                            width="80"
                                            height="100"
                                          />
                                          <img
                                            src={tickicon}
                                            width="25px"
                                            height="25px"
                                            alt="Tick Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-30px",
                                              marginTop: "60px",
                                            }}
                                          />
                                        </>
                                      ) : flag_scannedCopyOfNearByElectricityBill ===
                                        -1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.scannedCopyOfNearByElectricityBill
                                            }
                                            width="80"
                                            height="100"
                                          />
                                          <img
                                            src={crossIcon}
                                            width="25px"
                                            height="25px"
                                            alt="Cross Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-30px",
                                              marginTop: "60px",
                                            }}
                                          />
                                        </>
                                      ) : (
                                        <Base64Image
                                          data={
                                            dialogRowData.scannedCopyOfNearByElectricityBill
                                          }
                                          width="80"
                                          height="100"
                                        />
                                      )
                                    ) : (
                                      <Base64Image data={pdfIcon} width="80" />
                                    )}
                                    {nearByBillVerifyPopUp && (
                                      <OpenBase64ImageInPopup
                                        docVerifyPopUp={nearByBillVerifyPopUp}
                                        hideDocVerifyPopup={
                                          hideNearByBillVerifyAlert
                                        }
                                        documentName="Near-by Electricity Bill"
                                        documentImage={
                                          dialogRowData.scannedCopyOfNearByElectricityBill
                                        }
                                        width={"100%"}
                                        document={
                                          dialogRowData.scannedCopyOfNearByElectricityBill
                                        }
                                        documentFlag={
                                          dialogRowData.scannedCopyOfNearByElectricityBillFlag
                                        }
                                        applicationProgressId={
                                          dialogRowData.applicationProgressId
                                        }
                                        objectionStatus={
                                          dialogRowData.objectionStatus
                                        }
                                        updateDocFlag={updateDocFlag}
                                        documentRemarks={
                                          scannedCopyOfNearByElectricityBillObjectionRemarks
                                        }
                                        titleToUpdateFlag="scannedCopyOfNearByElectricityBill"
                                        flag_document={
                                          flag_scannedCopyOfNearByElectricityBill
                                        }
                                      />
                                    )}
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                          {dialogRowData.anyOtherDocument && (
                            <Grid item lg={2}>
                              <Grid
                                container
                                sx={{
                                  backgroundColor:
                                    dialogRowData.anyOtherDocumentFlag
                                      ? getDocumentBackGroundColor(
                                        dialogRowData.anyOtherDocumentFlag
                                      )
                                      : getDocumentBackGroundColor(
                                        flag_anyOtherDocument
                                      ),
                                  borderRadius: "10px",
                                  minHeight: "125px",
                                  height: "auto",
                                }}
                              >
                                <Grid item lg={12} className="tittlegrid">
                                  <p className="docTitle">Any Other Document</p>
                                </Grid>
                                <Grid
                                  item
                                  lg={12}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    paddingBottom: "5px",
                                  }}
                                >
                                  <div
                                    onClick={() => {
                                      if (!anyOtherDocumentVerifyPopUp) {
                                        setAnyOtherDocumentVerifyPopUp(true);
                                      }
                                    }}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {dialogRowData.anyOtherDocument.slice(
                                      0,
                                      6
                                    ) === "data:i" ? (
                                      flag_anyOtherDocument === 1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.anyOtherDocument
                                            }
                                            width="80"
                                            height="100"
                                          />
                                          <img
                                            src={tickicon}
                                            width="25px"
                                            height="25px"
                                            alt="Tick Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-30px",
                                              marginTop: "60px",
                                            }}
                                          />
                                        </>
                                      ) : flag_anyOtherDocument === -1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.anyOtherDocument
                                            }
                                            width="80"
                                            height="100"
                                          />
                                          <img
                                            src={crossIcon}
                                            width="25px"
                                            height="25px"
                                            alt="Cross Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-30px",
                                              marginTop: "60px",
                                            }}
                                          />
                                        </>
                                      ) : (
                                        <Base64Image
                                          data={dialogRowData.anyOtherDocument}
                                          width="80"
                                          height="100"
                                        />
                                      )
                                    ) : (
                                      <Base64Image data={pdfIcon} width="80" />
                                    )}
                                    {anyOtherDocumentVerifyPopUp && (
                                      <OpenBase64ImageInPopup
                                        docVerifyPopUp={
                                          anyOtherDocumentVerifyPopUp
                                        }
                                        hideDocVerifyPopup={
                                          hideAnyOtherDocumentVerifyAlert
                                        }
                                        documentName="Any Other Document"
                                        documentImage={
                                          dialogRowData.anyOtherDocument
                                        }
                                        width={"100%"}
                                        document={
                                          dialogRowData.anyOtherDocument
                                        }
                                        documentFlag={
                                          dialogRowData.anyOtherDocumentFlag
                                        }
                                        applicationProgressId={
                                          dialogRowData.applicationProgressId
                                        }
                                        objectionStatus={
                                          dialogRowData.objectionStatus
                                        }
                                        updateDocFlag={updateDocFlag}
                                        documentRemarks={
                                          anyOtherDocumentObjectionRemarks
                                        }
                                        titleToUpdateFlag="anyOtherDocument"
                                        flag_document={flag_anyOtherDocument}
                                      />
                                    )}
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                          {tenantStatus.includes(
                            dialogRowData.applicantStatus
                          ) ? (
                            <>
                              {(dialogRowData.copyOfOwnerCNICFront ||
                                dialogRowData.copyOfOwnerCNICBack) && (
                                  <Grid item lg={2}>
                                    <Grid
                                      container
                                      sx={{
                                        backgroundColor:
                                          dialogRowData.copyOfOwnerCNICFrontFlag
                                            ? getDocumentBackGroundColor(
                                              dialogRowData.copyOfOwnerCNICFrontFlag
                                            )
                                            : getDocumentBackGroundColor(
                                              flag_copyOfOwnerCNICFront
                                            ),
                                        borderRadius: "10px",
                                        minHeight: "125px",
                                        height: "auto",
                                      }}
                                    >
                                      <Grid item lg={12} className="tittlegrid">
                                        <p className="docTitle">Owner's CNIC.</p>
                                      </Grid>
                                      <Grid
                                        item
                                        lg={12}
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          paddingBottom: "5px",
                                        }}
                                      >
                                        <div
                                          onClick={() => {
                                            if (!copyOfOwnerCNICVerifyPopUp) {
                                              setCopyOfOwnerCNICVerifyPopUp(true);
                                            }
                                          }}
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            flexDirection: "column",
                                          }}
                                        >
                                          {dialogRowData.copyOfOwnerCNICFront.slice(
                                            0,
                                            6
                                          ) == "data:i" ? (
                                            <Base64Image
                                              data={
                                                dialogRowData.copyOfOwnerCNICFront
                                              }
                                              width="80"
                                            />
                                          ) : (
                                            <Base64Image
                                              data={pdfIcon}
                                              width="40"
                                            />
                                          )}
                                          {dialogRowData.copyOfOwnerCNICBack.slice(
                                            0,
                                            6
                                          ) === "data:i" ? (
                                            flag_copyOfOwnerCNICFront === 1 ||
                                              flag_copyOfOwnerCNICBack === 1 ? (
                                              <>
                                                <Base64Image
                                                  data={
                                                    dialogRowData.copyOfOwnerCNICBack
                                                  }
                                                  width="80"
                                                />
                                                <img
                                                  src={tickicon}
                                                  width="25px"
                                                  height="25px"
                                                  alt="Tick Icon"
                                                  style={{
                                                    position: "relative",
                                                    zIndex: "2",
                                                    marginLeft: "90px",
                                                    marginTop: "-30px",
                                                  }}
                                                />
                                              </>
                                            ) : flag_copyOfOwnerCNICFront ===
                                              -1 ||
                                              flag_copyOfOwnerCNICBack === -1 ? (
                                              <>
                                                <Base64Image
                                                  data={
                                                    dialogRowData.copyOfOwnerCNICBack
                                                  }
                                                  width="80"
                                                />
                                                <img
                                                  src={crossIcon}
                                                  width="25px"
                                                  height="25px"
                                                  alt="Cross Icon"
                                                  style={{
                                                    position: "relative",
                                                    zIndex: "2",
                                                    marginLeft: "90px",
                                                    marginTop: "-30px",
                                                  }}
                                                />
                                              </>
                                            ) : (
                                              <Base64Image
                                                data={
                                                  dialogRowData.copyOfOwnerCNICBack
                                                }
                                                width="80"
                                              />
                                            )
                                          ) : (
                                            <Base64Image
                                              data={pdfIcon}
                                              width="40"
                                            />
                                          )}

                                          {copyOfOwnerCNICVerifyPopUp && (
                                            <OpenBase64ImageInPopup
                                              docVerifyPopUp={
                                                copyOfOwnerCNICVerifyPopUp
                                              }
                                              hideDocVerifyPopup={
                                                hideCopyOfOwnerCNICVerifyAlert
                                              }
                                              documentName="Owner's CNIC"
                                              documentImage={
                                                dialogRowData.copyOfOwnerCNICFront
                                              }
                                              backDocumentImage={
                                                dialogRowData.copyOfOwnerCNICBack
                                              }
                                              width={"100%"}
                                              document={
                                                dialogRowData.copyOfOwnerCNICFront
                                              }
                                              documentFlag={
                                                dialogRowData.copyOfOwnerCNICFrontFlag
                                              }
                                              applicationProgressId={
                                                dialogRowData.applicationProgressId
                                              }
                                              objectionStatus={
                                                dialogRowData.objectionStatus
                                              }
                                              updateDocFlag={updateDocFlag}
                                              documentRemarks={
                                                copyOfOwnerCNICFrontObjectionRemarks
                                              }
                                              titleToUpdateFlag="copyOfOwnerCNIC"
                                              flag_document={
                                                flag_copyOfOwnerCNICFront
                                              }
                                              flag_documentBack={
                                                flag_copyOfOwnerCNICBack
                                              }
                                            />
                                          )}
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                )}
                              {dialogRowData.ownerNOC && (
                                <Grid item lg={2}>
                                  <Grid
                                    container
                                    sx={{
                                      backgroundColor:
                                        dialogRowData.ownerNOCFlag
                                          ? getDocumentBackGroundColor(
                                            dialogRowData.ownerNOCFlag
                                          )
                                          : getDocumentBackGroundColor(
                                            flag_ownerNOC
                                          ),
                                      borderRadius: "10px",
                                      minHeight: "125px",
                                      height: "auto",
                                    }}
                                  >
                                    <Grid item lg={12} className="tittlegrid">
                                      <p className="docTitle">
                                        NOC. from Owner
                                      </p>
                                    </Grid>
                                    <Grid
                                      item
                                      lg={12}
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <div
                                        onClick={() => {
                                          if (!ownerNOCVerifyPopUp) {
                                            setOwnerNOCVerifyPopUp(true);
                                          }
                                        }}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        {(() => {
                                          const isImage =
                                            dialogRowData.ownerNOC.slice(0, 6) ===
                                            "data:i";

                                          if (!isImage) {
                                            return (
                                              <Base64Image
                                                data={pdfIcon}
                                                width="40"
                                              />
                                            );
                                          }

                                          if (flag_ownerNOC === 1) {
                                            return (
                                              <>
                                                <Base64Image
                                                  data={dialogRowData.ownerNOC}
                                                  width="80"
                                                  height="100"
                                                />
                                                <img
                                                  src={tickicon}
                                                  width="25px"
                                                  height="25px"
                                                  alt="Tick Icon"
                                                  style={{
                                                    position: "relative",
                                                    zIndex: "2",
                                                    marginRight: "-30px",
                                                    marginTop: "62px",
                                                  }}
                                                />
                                              </>
                                            );
                                          }

                                          if (flag_ownerNOC === -1) {
                                            return (
                                              <>
                                                <Base64Image
                                                  data={dialogRowData.ownerNOC}
                                                  width="80"
                                                  height="100"
                                                />
                                                <img
                                                  src={crossIcon}
                                                  width="25px"
                                                  height="25px"
                                                  alt="Cross Icon"
                                                  style={{
                                                    position: "relative",
                                                    zIndex: "2",
                                                    marginRight: "-30px",
                                                    marginTop: "62px",
                                                  }}
                                                />
                                              </>
                                            );
                                          }

                                          return (
                                            <Base64Image
                                              data={dialogRowData.ownerNOC}
                                              width="80"
                                              height="100"
                                            />
                                          );
                                        })()}

                                        {ownerNOCVerifyPopUp && (
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={ownerNOCVerifyPopUp}
                                            hideDocVerifyPopup={
                                              hideOwnerNocVerifyAlert
                                            }
                                            documentName="Noc from Owner"
                                            documentImage={
                                              dialogRowData.ownerNOC
                                            }
                                            width={"100%"}
                                            document={dialogRowData.ownerNOC}
                                            documentFlag={
                                              dialogRowData.ownerNOCFlag
                                            }
                                            applicationProgressId={
                                              dialogRowData.applicationProgressId
                                            }
                                            objectionStatus={
                                              dialogRowData.objectionStatus
                                            }
                                            updateDocFlag={updateDocFlag}
                                            documentRemarks={
                                              ownerNOCObjectionRemarks
                                            }
                                            titleToUpdateFlag="ownerNOC"
                                            flag_document={flag_ownerNOC}
                                          />
                                        )}
                                      </div>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                            </>
                          ) : null}
                          <Grid item lg={12}></Grid>
                          {dialogRowData.connectionType === "Industrial" ? (
                            <>
                              {dialogRowData.resolutionFormDesc && (
                                <Grid item lg={2}>
                                  <Grid
                                    container
                                    sx={{
                                      backgroundColor:
                                        dialogRowData.resolutionFormDescFlag
                                          ? getDocumentBackGroundColor(
                                            dialogRowData.resolutionFormDescFlag
                                          )
                                          : getDocumentBackGroundColor(
                                            flag_resolutionFormDesc
                                          ),
                                      borderRadius: "10px",
                                      minHeight: "125px",
                                      height: "auto",
                                    }}
                                  >
                                    <Grid item lg={12} className="tittlegrid">
                                      <p className="docTitle">
                                        BoD's Resolution Form
                                      </p>
                                    </Grid>
                                    <Grid
                                      item
                                      lg={12}
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <div
                                        onClick={() => {
                                          if (!resolutionFormDescVerifyPopUp) {
                                            setResolutionFormDescVerifyPopUp(
                                              true
                                            );
                                          }
                                        }}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        {dialogRowData.resolutionFormDesc.slice(
                                          0,
                                          6
                                        ) === "data:i" ? (
                                          flag_resolutionFormDesc === 1 ? (
                                            <>
                                              <Base64Image
                                                data={
                                                  dialogRowData.resolutionFormDesc
                                                }
                                                width="80"
                                                height="100"
                                              />
                                              <img
                                                src={tickicon}
                                                width="25px"
                                                height="25px"
                                                alt="Tick Icon"
                                                style={{
                                                  position: "relative",
                                                  zIndex: "2",
                                                  marginRight: "-30px",
                                                  marginTop: "62px",
                                                }}
                                              />
                                            </>
                                          ) : flag_resolutionFormDesc === -1 ? (
                                            <>
                                              <Base64Image
                                                data={
                                                  dialogRowData.resolutionFormDesc
                                                }
                                                width="80"
                                                height="100"
                                              />
                                              <img
                                                src={crossIcon}
                                                width="25px"
                                                height="25px"
                                                alt="Cross Icon"
                                                style={{
                                                  position: "relative",
                                                  zIndex: "2",
                                                  marginRight: "-30px",
                                                  marginTop: "62px",
                                                }}
                                              />
                                            </>
                                          ) : (
                                            <Base64Image
                                              data={
                                                dialogRowData.resolutionFormDesc
                                              }
                                              width="80"
                                              height="100"
                                            />
                                          )
                                        ) : (
                                          <Base64Image
                                            data={pdfIcon}
                                            width="40"
                                          />
                                        )}

                                        {resolutionFormDescVerifyPopUp && (
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={
                                              resolutionFormDescVerifyPopUp
                                            }
                                            hideDocVerifyPopup={
                                              hideResolutionFormDescVerifyAlert
                                            }
                                            documentName="BoD's Resolution Form<"
                                            documentImage={
                                              dialogRowData.resolutionFormDesc
                                            }
                                            width={"100%"}
                                            document={
                                              dialogRowData.resolutionFormDesc
                                            }
                                            documentFlag={
                                              dialogRowData.resolutionFormDescFlag
                                            }
                                            applicationProgressId={
                                              dialogRowData.applicationProgressId
                                            }
                                            objectionStatus={
                                              dialogRowData.objectionStatus
                                            }
                                            updateDocFlag={updateDocFlag}
                                            documentRemarks={
                                              resolutionFormDescObjectionRemarks
                                            }
                                            titleToUpdateFlag="resolutionFormDesc"
                                            flag_document={
                                              flag_resolutionFormDesc
                                            }
                                          />
                                        )}
                                      </div>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                              {dialogRowData.certMemoDesc && (
                                <Grid item lg={2}>
                                  <Grid
                                    container
                                    sx={{
                                      backgroundColor:
                                        dialogRowData.certMemoDescFlag
                                          ? getDocumentBackGroundColor(
                                            dialogRowData.certMemoDescFlag
                                          )
                                          : getDocumentBackGroundColor(
                                            flag_certMemoDesc
                                          ),
                                      borderRadius: "10px",
                                      minHeight: "125px",
                                      height: "auto",
                                    }}
                                  >
                                    <Grid item lg={12} className="tittlegrid">
                                      <p className="docTitle">
                                        Memorandum of association
                                      </p>
                                    </Grid>
                                    <Grid
                                      item
                                      lg={12}
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <div
                                        onClick={() => {
                                          if (!certMemoDescVerifyPopUp) {
                                            setCertMemoDescVerifyPopUp(true);
                                          }
                                        }}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        {dialogRowData.certMemoDesc.slice(
                                          0,
                                          6
                                        ) === "data:i" ? (
                                          flag_certMemoDesc === 1 ? (
                                            <>
                                              <Base64Image
                                                data={
                                                  dialogRowData.certMemoDesc
                                                }
                                                width="80"
                                                height="100"
                                              />
                                              <img
                                                src={tickicon}
                                                width="25px"
                                                height="25px"
                                                alt="Tick Icon"
                                                style={{
                                                  position: "relative",
                                                  zIndex: "2",
                                                  marginRight: "-30px",
                                                  marginTop: "62px",
                                                }}
                                              />
                                            </>
                                          ) : flag_certMemoDesc === -1 ? (
                                            <>
                                              <Base64Image
                                                data={
                                                  dialogRowData.certMemoDesc
                                                }
                                                width="80"
                                                height="100"
                                              />
                                              <img
                                                src={crossIcon}
                                                width="25px"
                                                height="25px"
                                                alt="Cross Icon"
                                                style={{
                                                  position: "relative",
                                                  zIndex: "2",
                                                  marginRight: "-30px",
                                                  marginTop: "62px",
                                                }}
                                              />
                                            </>
                                          ) : (
                                            <Base64Image
                                              data={dialogRowData.certMemoDesc}
                                              width="80"
                                              height="100"
                                            />
                                          )
                                        ) : (
                                          <Base64Image
                                            data={pdfIcon}
                                            width="40"
                                          />
                                        )}

                                        {certMemoDescVerifyPopUp && (
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={
                                              certMemoDescVerifyPopUp
                                            }
                                            hideDocVerifyPopup={
                                              hideCertMemoDescVerifyAlert
                                            }
                                            documentName="Memorandum of Association"
                                            documentImage={
                                              dialogRowData.certMemoDesc
                                            }
                                            width={"100%"}
                                            document={
                                              dialogRowData.certMemoDesc
                                            }
                                            documentFlag={
                                              dialogRowData.certMemoDescFlag
                                            }
                                            applicationProgressId={
                                              dialogRowData.applicationProgressId
                                            }
                                            objectionStatus={
                                              dialogRowData.objectionStatus
                                            }
                                            updateDocFlag={updateDocFlag}
                                            documentRemarks={
                                              certMemoDescObjectionRemarks
                                            }
                                            titleToUpdateFlag="certMemoDesc"
                                            flag_document={flag_certMemoDesc}
                                          />
                                        )}
                                      </div>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                              {dialogRowData.certFormDesc && (
                                <Grid item lg={2}>
                                  <Grid
                                    container
                                    sx={{
                                      backgroundColor:
                                        dialogRowData.certFormDescFlag
                                          ? getDocumentBackGroundColor(
                                            dialogRowData.certFormDescFlag
                                          )
                                          : getDocumentBackGroundColor(
                                            flag_certFormDesc
                                          ),
                                      borderRadius: "10px",
                                      minHeight: "125px",
                                      height: "auto",
                                    }}
                                  >
                                    <Grid item lg={12} className="tittlegrid">
                                      <p className="docTitle">
                                        Certified Form-29
                                      </p>
                                    </Grid>
                                    <Grid
                                      item
                                      lg={12}
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <div
                                        onClick={() => {
                                          if (!certFormDescVerifyPopUp) {
                                            setCertFormDescVerifyPopUp(true);
                                          }
                                        }}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        {dialogRowData.certFormDesc.slice(
                                          0,
                                          6
                                        ) === "data:i" ? (
                                          flag_certFormDesc === 1 ? (
                                            <>
                                              <Base64Image
                                                data={
                                                  dialogRowData.certFormDesc
                                                }
                                                width="80"
                                                height="100"
                                              />
                                              <img
                                                src={tickicon}
                                                width="25px"
                                                height="25px"
                                                alt="Tick Icon"
                                                style={{
                                                  position: "relative",
                                                  zIndex: "2",
                                                  marginRight: "-30px",
                                                  marginTop: "62px",
                                                }}
                                              />
                                            </>
                                          ) : flag_certFormDesc === -1 ? (
                                            <>
                                              <Base64Image
                                                data={
                                                  dialogRowData.certFormDesc
                                                }
                                                width="80"
                                                height="100"
                                              />
                                              <img
                                                src={crossIcon}
                                                width="25px"
                                                height="25px"
                                                alt="Cross Icon"
                                                style={{
                                                  position: "relative",
                                                  zIndex: "2",
                                                  marginRight: "-30px",
                                                  marginTop: "62px",
                                                }}
                                              />
                                            </>
                                          ) : (
                                            <Base64Image
                                              data={dialogRowData.certFormDesc}
                                              width="80"
                                              height="100"
                                            />
                                          )
                                        ) : (
                                          <Base64Image
                                            data={pdfIcon}
                                            width="40"
                                          />
                                        )}
                                        {certFormDescVerifyPopUp && (
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={
                                              certFormDescVerifyPopUp
                                            }
                                            hideDocVerifyPopup={
                                              hideCertFormDescVerifyAlert
                                            }
                                            documentName="Certified Form-29"
                                            documentImage={
                                              dialogRowData.certFormDesc
                                            }
                                            width={"100%"}
                                            document={
                                              dialogRowData.certFormDesc
                                            }
                                            documentFlag={
                                              dialogRowData.certFormDescFlag
                                            }
                                            applicationProgressId={
                                              dialogRowData.applicationProgressId
                                            }
                                            objectionStatus={
                                              dialogRowData.objectionStatus
                                            }
                                            updateDocFlag={updateDocFlag}
                                            documentRemarks={
                                              certFormDescObjectionRemarks
                                            }
                                            titleToUpdateFlag="certFormDesc"
                                            flag_document={flag_certFormDesc}
                                          />
                                        )}
                                      </div>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                            </>
                          ) : null}
                        </Grid>
                      </>
                    ) : (
                      <>
                        <h3 className="step-title">Documents Verification</h3>
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" /> Document verification
                            is in process by the Customer Service Lead.
                          </p>
                        </div>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 1 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <h3 className="step-title">Documents Objection</h3>
                      <Grid
                        className="document-verification-container"
                        container
                        spacing={1}
                        sx={{ display: "flex", justifyContent: "flex-start" }}
                      >
                        {(dialogRowData.copyOfApplicantCNICFront ||
                          dialogRowData.copyOfApplicantCNICBack) && (
                            <Grid item lg={2}>
                              <Grid
                                container
                                sx={{
                                  backgroundColor:
                                    dialogRowData.copyOfApplicantCNICFrontFlag &&
                                      dialogRowData.copyOfApplicantCNICBackFlag
                                      ? getDocumentBackGroundColor(
                                        dialogRowData.copyOfApplicantCNICFrontFlag
                                      )
                                      : getDocumentBackGroundColor(
                                        flag_copyOfApplicantCNICFront
                                      ),
                                  borderRadius: "10px",
                                  minHeight: "125px",
                                  height: "auto",
                                }}
                              >
                                <Grid item lg={12} className="tittlegrid">
                                  <p className="docTitle">Applicant's CNIC.</p>
                                </Grid>
                                <Grid
                                  item
                                  lg={12}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    paddingBottom: "5px",
                                  }}
                                >
                                  <div
                                    onClick={() => {
                                      if (!copyOfApplicantCNICVerifyPopUp) {
                                        setCopyOfApplicantCNICVerifyPopUp(true);
                                      }
                                    }}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {dialogRowData.copyOfApplicantCNICFront &&
                                      dialogRowData.copyOfApplicantCNICFront.slice(
                                        0,
                                        6
                                      ) == "data:i" ? (
                                      <Base64Image
                                        data={
                                          dialogRowData.copyOfApplicantCNICFront
                                        }
                                        width="80"
                                      />
                                    ) : (
                                      <Base64Image data={pdfIcon} width="40" />
                                    )}
                                    {dialogRowData.copyOfApplicantCNICBack &&
                                      dialogRowData.copyOfApplicantCNICBack.slice(
                                        0,
                                        6
                                      ) == "data:i" ? (
                                      <Base64Image
                                        data={
                                          dialogRowData.copyOfApplicantCNICBack
                                        }
                                        width="80"
                                      />
                                    ) : (
                                      <Base64Image data={pdfIcon} width="40" />
                                    )}
                                    {copyOfApplicantCNICVerifyPopUp && (
                                      <OpenBase64ImageInPopup
                                        docVerifyPopUp={
                                          copyOfApplicantCNICVerifyPopUp
                                        }
                                        hideDocVerifyPopup={
                                          hideCopyOfApplicantCNICVerifyAlert
                                        }
                                        documentName="Applicant CNIC"
                                        documentImage={
                                          dialogRowData.copyOfApplicantCNICFront
                                        }
                                        backDocumentImage={
                                          dialogRowData.copyOfApplicantCNICBack
                                        }
                                        width={400}
                                        document={
                                          dialogRowData.copyOfApplicantCNICFront
                                        }
                                        documentFlag={
                                          dialogRowData.copyOfApplicantCNICFrontFlag
                                        }
                                        applicationProgressId={
                                          dialogRowData.applicationProgressId
                                        }
                                        objectionStatus={
                                          dialogRowData.objectionStatus
                                        }
                                        updateDocFlag={updateDocFlag}
                                        documentRemarks={
                                          copyOfApplicantCNICFrontObjectionRemarks
                                        }
                                        titleToUpdateFlag="copyOfApplicantCNIC"
                                        flag_document={
                                          flag_copyOfApplicantCNICFront
                                        }
                                        flag_documentBack={
                                          flag_copyOfApplicantCNICBack
                                        }
                                      />
                                    )}
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                        {dialogRowData.premisesDocument && (
                          <Grid item lg={2}>
                            <Grid
                              container
                              sx={{
                                backgroundColor:
                                  dialogRowData.premisesDocumentFlag
                                    ? getDocumentBackGroundColor(
                                      dialogRowData.premisesDocumentFlag
                                    )
                                    : getDocumentBackGroundColor(
                                      flag_premisesDocument
                                    ),
                                borderRadius: "10px",
                                minHeight: "125px",
                                height: "auto",
                              }}
                            >
                              <Grid item lg={12} className="tittlegrid">
                                <p className="docTitle">Property Documents</p>
                              </Grid>
                              <Grid
                                item
                                lg={12}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  paddingBottom: "5px",
                                }}
                              >
                                <div
                                  onClick={() => {
                                    if (!propertyDocVerifyPopUp) {
                                      setPropertyDocVerifyPopUp(true);
                                    }
                                  }}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {dialogRowData.premisesDocument.slice(0, 6) ==
                                    "data:i" ? (
                                    <Base64Image
                                      data={dialogRowData.premisesDocument}
                                      width="80"
                                      height="100"
                                    />
                                  ) : (
                                    <Base64Image data={pdfIcon} width="40" />
                                  )}
                                  {propertyDocVerifyPopUp && (
                                    <OpenBase64ImageInPopup
                                      docVerifyPopUp={propertyDocVerifyPopUp}
                                      hideDocVerifyPopup={
                                        hidePropertyDocVerifyAlert
                                      }
                                      documentName="Property Document"
                                      documentImage={
                                        dialogRowData.premisesDocument
                                      }
                                      width={400}
                                      document={dialogRowData.premisesDocument}
                                      documentFlag={
                                        dialogRowData.premisesDocumentFlag
                                      }
                                      applicationProgressId={
                                        dialogRowData.applicationProgressId
                                      }
                                      objectionStatus={
                                        dialogRowData.objectionStatus
                                      }
                                      updateDocFlag={updateDocFlag}
                                      documentRemarks={
                                        premisesDocumentObjectionRemarks
                                      }
                                      titleToUpdateFlag="premisesDocument"
                                      flag_document={flag_premisesDocument}
                                    />
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                        {dialogRowData.scannedCopyOfNearByElectricityBill && (
                          <Grid item lg={2}>
                            <Grid
                              container
                              sx={{
                                backgroundColor:
                                  dialogRowData.scannedCopyOfNearByElectricityBillFlag
                                    ? getDocumentBackGroundColor(
                                      dialogRowData.scannedCopyOfNearByElectricityBillFlag
                                    )
                                    : getDocumentBackGroundColor(
                                      flag_scannedCopyOfNearByElectricityBill
                                    ),
                                borderRadius: "10px",
                                minHeight: "125px",
                                height: "auto",
                              }}
                            >
                              <Grid item lg={12} className="tittlegrid">
                                <p className="docTitle">Near-by Elec. Bill</p>
                              </Grid>
                              <Grid
                                item
                                lg={12}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  paddingBottom: "5px",
                                }}
                              >
                                <div
                                  onClick={() => {
                                    if (!nearByBillVerifyPopUp) {
                                      setNearByBillVerifyPopUp(true);
                                    }
                                  }}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {dialogRowData.scannedCopyOfNearByElectricityBill.slice(
                                    0,
                                    6
                                  ) == "data:i" ? (
                                    <Base64Image
                                      data={
                                        dialogRowData.scannedCopyOfNearByElectricityBill
                                      }
                                      width="80"
                                      height="100"
                                    />
                                  ) : (
                                    <Base64Image data={pdfIcon} width="80" />
                                  )}
                                  {nearByBillVerifyPopUp && (
                                    <OpenBase64ImageInPopup
                                      docVerifyPopUp={nearByBillVerifyPopUp}
                                      hideDocVerifyPopup={
                                        hideNearByBillVerifyAlert
                                      }
                                      documentName="Near-by Electricity Bill"
                                      documentImage={
                                        dialogRowData.scannedCopyOfNearByElectricityBill
                                      }
                                      width={400}
                                      document={
                                        dialogRowData.scannedCopyOfNearByElectricityBill
                                      }
                                      documentFlag={
                                        dialogRowData.scannedCopyOfNearByElectricityBillFlag
                                      }
                                      applicationProgressId={
                                        dialogRowData.applicationProgressId
                                      }
                                      objectionStatus={
                                        dialogRowData.objectionStatus
                                      }
                                      updateDocFlag={updateDocFlag}
                                      documentRemarks={
                                        scannedCopyOfNearByElectricityBillObjectionRemarks
                                      }
                                      titleToUpdateFlag="scannedCopyOfNearByElectricityBill"
                                      flag_document={
                                        flag_scannedCopyOfNearByElectricityBill
                                      }
                                    />
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                        {dialogRowData.anyOtherDocument && (
                          <Grid item lg={2}>
                            <Grid
                              container
                              sx={{
                                backgroundColor:
                                  dialogRowData.anyOtherDocumentFlag
                                    ? getDocumentBackGroundColor(
                                      dialogRowData.anyOtherDocumentFlag
                                    )
                                    : getDocumentBackGroundColor(
                                      flag_anyOtherDocument
                                    ),
                                borderRadius: "10px",
                                minHeight: "125px",
                                height: "auto",
                              }}
                            >
                              <Grid item lg={12} className="tittlegrid">
                                <p className="docTitle">Any Other Document</p>
                              </Grid>
                              <Grid
                                item
                                lg={12}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  paddingBottom: "5px",
                                }}
                              >
                                <div
                                  onClick={() => {
                                    if (!anyOtherDocumentVerifyPopUp) {
                                      setAnyOtherDocumentVerifyPopUp(true);
                                    }
                                  }}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {dialogRowData.anyOtherDocument.slice(0, 6) ==
                                    "data:i" ? (
                                    <Base64Image
                                      data={dialogRowData.anyOtherDocument}
                                      width="80"
                                      height="100"
                                    />
                                  ) : (
                                    <Base64Image data={pdfIcon} width="80" />
                                  )}
                                  {anyOtherDocumentVerifyPopUp && (
                                    <OpenBase64ImageInPopup
                                      docVerifyPopUp={
                                        anyOtherDocumentVerifyPopUp
                                      }
                                      hideDocVerifyPopup={
                                        hideAnyOtherDocumentVerifyAlert
                                      }
                                      documentName="Any Other Document"
                                      documentImage={
                                        dialogRowData.anyOtherDocument
                                      }
                                      width={400}
                                      document={dialogRowData.anyOtherDocument}
                                      documentFlag={
                                        dialogRowData.anyOtherDocumentFlag
                                      }
                                      applicationProgressId={
                                        dialogRowData.applicationProgressId
                                      }
                                      objectionStatus={
                                        dialogRowData.objectionStatus
                                      }
                                      updateDocFlag={updateDocFlag}
                                      documentRemarks={
                                        anyOtherDocumentObjectionRemarks
                                      }
                                      titleToUpdateFlag="anyOtherDocument"
                                      flag_document={flag_anyOtherDocument}
                                    />
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                        {tenantStatus.includes(
                          dialogRowData.applicantStatus
                        ) ? (
                          <>
                            {(dialogRowData.copyOfOwnerCNICFront ||
                              dialogRowData.copyOfOwnerCNICBack) && (
                                <Grid item lg={2}>
                                  <Grid
                                    container
                                    sx={{
                                      backgroundColor:
                                        dialogRowData.copyOfOwnerCNICFrontFlag
                                          ? getDocumentBackGroundColor(
                                            dialogRowData.copyOfOwnerCNICFrontFlag
                                          )
                                          : getDocumentBackGroundColor(
                                            flag_copyOfOwnerCNICFront
                                          ),
                                      borderRadius: "10px",
                                      minHeight: "125px",
                                      height: "auto",
                                    }}
                                  >
                                    <Grid item lg={12} className="tittlegrid">
                                      <p className="docTitle">Owner's CNIC.</p>
                                    </Grid>
                                    <Grid
                                      item
                                      lg={12}
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <div
                                        onClick={() => {
                                          if (!copyOfOwnerCNICVerifyPopUp) {
                                            setCopyOfOwnerCNICVerifyPopUp(true);
                                          }
                                        }}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          flexDirection: "column",
                                        }}
                                      >
                                        {dialogRowData.copyOfOwnerCNICFront.slice(
                                          0,
                                          6
                                        ) == "data:i" ? (
                                          <Base64Image
                                            data={
                                              dialogRowData.copyOfOwnerCNICFront
                                            }
                                            width="80"
                                          />
                                        ) : (
                                          <Base64Image
                                            data={pdfIcon}
                                            width="40"
                                          />
                                        )}
                                        {dialogRowData.copyOfOwnerCNICBack.slice(
                                          0,
                                          6
                                        ) == "data:i" ? (
                                          <Base64Image
                                            data={
                                              dialogRowData.copyOfOwnerCNICBack
                                            }
                                            width="80"
                                          />
                                        ) : (
                                          <Base64Image
                                            data={pdfIcon}
                                            width="40"
                                          />
                                        )}
                                        {copyOfOwnerCNICVerifyPopUp && (
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={
                                              copyOfOwnerCNICVerifyPopUp
                                            }
                                            hideDocVerifyPopup={
                                              hideCopyOfOwnerCNICVerifyAlert
                                            }
                                            documentName="Owner's CNIC"
                                            documentImage={
                                              dialogRowData.copyOfOwnerCNICFront
                                            }
                                            backDocumentImage={
                                              dialogRowData.copyOfOwnerCNICBack
                                            }
                                            width={400}
                                            document={
                                              dialogRowData.copyOfOwnerCNICFront
                                            }
                                            documentFlag={
                                              dialogRowData.copyOfOwnerCNICFrontFlag
                                            }
                                            applicationProgressId={
                                              dialogRowData.applicationProgressId
                                            }
                                            objectionStatus={
                                              dialogRowData.objectionStatus
                                            }
                                            updateDocFlag={updateDocFlag}
                                            documentRemarks={
                                              copyOfOwnerCNICFrontObjectionRemarks
                                            }
                                            titleToUpdateFlag="copyOfOwnerCNIC"
                                            flag_document={
                                              flag_copyOfOwnerCNICFront
                                            }
                                            flag_documentBack={
                                              flag_copyOfOwnerCNICBack
                                            }
                                          />
                                        )}
                                      </div>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                            {dialogRowData.ownerNOC && (
                              <Grid item lg={2}>
                                <Grid
                                  container
                                  sx={{
                                    backgroundColor: dialogRowData.ownerNOCFlag
                                      ? getDocumentBackGroundColor(
                                        dialogRowData.ownerNOCFlag
                                      )
                                      : getDocumentBackGroundColor(
                                        flag_ownerNOC
                                      ),
                                    borderRadius: "10px",
                                    minHeight: "125px",
                                    height: "auto",
                                  }}
                                >
                                  <Grid item lg={12} className="tittlegrid">
                                    <p className="docTitle">NOC. from Owner</p>
                                  </Grid>
                                  <Grid
                                    item
                                    lg={12}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      paddingBottom: "5px",
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        if (!ownerNOCVerifyPopUp) {
                                          setOwnerNOCVerifyPopUp(true);
                                        }
                                      }}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {dialogRowData.ownerNOC.slice(0, 6) ==
                                        "data:i" ? (
                                        <Base64Image
                                          data={dialogRowData.ownerNOC}
                                          width="80"
                                          height="100"
                                        />
                                      ) : (
                                        <Base64Image
                                          data={pdfIcon}
                                          width="80"
                                        />
                                      )}
                                      {ownerNOCVerifyPopUp && (
                                        <OpenBase64ImageInPopup
                                          docVerifyPopUp={ownerNOCVerifyPopUp}
                                          hideDocVerifyPopup={
                                            hideOwnerNocVerifyAlert
                                          }
                                          documentName="Noc from Owner"
                                          documentImage={dialogRowData.ownerNOC}
                                          width={400}
                                          document={dialogRowData.ownerNOC}
                                          documentFlag={
                                            dialogRowData.ownerNOCFlag
                                          }
                                          applicationProgressId={
                                            dialogRowData.applicationProgressId
                                          }
                                          objectionStatus={
                                            dialogRowData.objectionStatus
                                          }
                                          updateDocFlag={updateDocFlag}
                                          documentRemarks={
                                            ownerNOCObjectionRemarks
                                          }
                                          titleToUpdateFlag="ownerNOC"
                                          flag_document={flag_ownerNOC}
                                        />
                                      )}
                                    </div>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                          </>
                        ) : null}
                        {dialogRowData.connectionType === "Industrial" ? (
                          <>
                            {dialogRowData.resolutionFormDesc && (
                              <Grid item lg={2}>
                                <Grid
                                  container
                                  sx={{
                                    backgroundColor:
                                      dialogRowData.resolutionFormDescFlag
                                        ? getDocumentBackGroundColor(
                                          dialogRowData.resolutionFormDescFlag
                                        )
                                        : getDocumentBackGroundColor(
                                          flag_resolutionFormDesc
                                        ),
                                    borderRadius: "10px",
                                    minHeight: "125px",
                                    height: "auto",
                                  }}
                                >
                                  <Grid item lg={12} className="tittlegrid">
                                    <p className="docTitle">
                                      BoD's Resolution Form
                                    </p>
                                  </Grid>
                                  <Grid
                                    item
                                    lg={12}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      paddingBottom: "5px",
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        if (!resolutionFormDescVerifyPopUp) {
                                          setResolutionFormDescVerifyPopUp(
                                            true
                                          );
                                        }
                                      }}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {dialogRowData.resolutionFormDesc.slice(
                                        0,
                                        6
                                      ) == "data:i" ? (
                                        <Base64Image
                                          data={
                                            dialogRowData.resolutionFormDesc
                                          }
                                          width="80"
                                          height="100"
                                        />
                                      ) : (
                                        <Base64Image
                                          data={pdfIcon}
                                          width="80"
                                        />
                                      )}
                                      {resolutionFormDescVerifyPopUp && (
                                        <OpenBase64ImageInPopup
                                          docVerifyPopUp={
                                            resolutionFormDescVerifyPopUp
                                          }
                                          hideDocVerifyPopup={
                                            hideResolutionFormDescVerifyAlert
                                          }
                                          documentName="BoD's Resolution Form<"
                                          documentImage={
                                            dialogRowData.resolutionFormDesc
                                          }
                                          width={400}
                                          document={
                                            dialogRowData.resolutionFormDesc
                                          }
                                          documentFlag={
                                            dialogRowData.resolutionFormDescFlag
                                          }
                                          applicationProgressId={
                                            dialogRowData.applicationProgressId
                                          }
                                          objectionStatus={
                                            dialogRowData.objectionStatus
                                          }
                                          updateDocFlag={updateDocFlag}
                                          documentRemarks={
                                            resolutionFormDescObjectionRemarks
                                          }
                                          titleToUpdateFlag="resolutionFormDesc"
                                          flag_document={
                                            flag_resolutionFormDesc
                                          }
                                        />
                                      )}
                                    </div>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                            {dialogRowData.certMemoDesc && (
                              <Grid item lg={2}>
                                <Grid
                                  container
                                  sx={{
                                    backgroundColor:
                                      dialogRowData.certMemoDescFlag
                                        ? getDocumentBackGroundColor(
                                          dialogRowData.certMemoDescFlag
                                        )
                                        : getDocumentBackGroundColor(
                                          flag_certMemoDesc
                                        ),
                                    borderRadius: "10px",
                                    minHeight: "125px",
                                    height: "auto",
                                  }}
                                >
                                  <Grid item lg={12} className="tittlegrid">
                                    <p className="docTitle">
                                      Memorandum of association
                                    </p>
                                  </Grid>
                                  <Grid
                                    item
                                    lg={12}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      paddingBottom: "5px",
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        if (!certMemoDescVerifyPopUp) {
                                          setCertMemoDescVerifyPopUp(true);
                                        }
                                      }}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {dialogRowData.certMemoDesc.slice(0, 6) ==
                                        "data:i" ? (
                                        <Base64Image
                                          data={dialogRowData.certMemoDesc}
                                          width="80"
                                          height="100"
                                        />
                                      ) : (
                                        <Base64Image
                                          data={pdfIcon}
                                          width="80"
                                        />
                                      )}
                                      {certMemoDescVerifyPopUp && (
                                        <OpenBase64ImageInPopup
                                          docVerifyPopUp={
                                            certMemoDescVerifyPopUp
                                          }
                                          hideDocVerifyPopup={
                                            hideCertMemoDescVerifyAlert
                                          }
                                          documentName="Memorandum of Association"
                                          documentImage={
                                            dialogRowData.certMemoDesc
                                          }
                                          width={400}
                                          document={dialogRowData.certMemoDesc}
                                          documentFlag={
                                            dialogRowData.certMemoDescFlag
                                          }
                                          applicationProgressId={
                                            dialogRowData.applicationProgressId
                                          }
                                          objectionStatus={
                                            dialogRowData.objectionStatus
                                          }
                                          updateDocFlag={updateDocFlag}
                                          documentRemarks={
                                            certMemoDescObjectionRemarks
                                          }
                                          titleToUpdateFlag="certMemoDesc"
                                          flag_document={flag_certMemoDesc}
                                        />
                                      )}
                                    </div>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                            {dialogRowData.certFormDesc && (
                              <Grid item lg={2}>
                                <Grid
                                  container
                                  sx={{
                                    backgroundColor:
                                      dialogRowData.certFormDescFlag
                                        ? getDocumentBackGroundColor(
                                          dialogRowData.certFormDescFlag
                                        )
                                        : getDocumentBackGroundColor(
                                          flag_certFormDesc
                                        ),
                                    borderRadius: "10px",
                                    minHeight: "125px",
                                    height: "auto",
                                  }}
                                >
                                  <Grid item lg={12} className="tittlegrid">
                                    <p className="docTitle">
                                      Certified Form-29
                                    </p>
                                  </Grid>
                                  <Grid
                                    item
                                    lg={12}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      paddingBottom: "5px",
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        if (!certFormDescVerifyPopUp) {
                                          setCertFormDescVerifyPopUp(true);
                                        }
                                      }}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {dialogRowData.certFormDesc.slice(0, 6) ==
                                        "data:i" ? (
                                        <Base64Image
                                          data={dialogRowData.certFormDesc}
                                          width="80"
                                          height="100"
                                        />
                                      ) : (
                                        <Base64Image
                                          data={pdfIcon}
                                          width="80"
                                        />
                                      )}
                                      {certFormDescVerifyPopUp && (
                                        <OpenBase64ImageInPopup
                                          docVerifyPopUp={
                                            certFormDescVerifyPopUp
                                          }
                                          hideDocVerifyPopup={
                                            hideCertFormDescVerifyAlert
                                          }
                                          documentName="Certified Form-29"
                                          documentImage={
                                            dialogRowData.certFormDesc
                                          }
                                          width={400}
                                          document={dialogRowData.certFormDesc}
                                          documentFlag={
                                            dialogRowData.certFormDescFlag
                                          }
                                          applicationProgressId={
                                            dialogRowData.applicationProgressId
                                          }
                                          objectionStatus={
                                            dialogRowData.objectionStatus
                                          }
                                          updateDocFlag={updateDocFlag}
                                          documentRemarks={
                                            certFormDescObjectionRemarks
                                          }
                                          titleToUpdateFlag="certFormDesc"
                                          flag_document={flag_certFormDesc}
                                        />
                                      )}
                                    </div>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                          </>
                        ) : null}
                      </Grid>
                    </>
                  ) : (dialogRowData.applicationProgressId === 21 && (dialogRowData.objectionStatus != 1 || dialogRowData.objectionStatus == 2)) ? (

                    <>
                      <h3 className="step-title">{dialogRowData.wiringTestReportDocument ? "Wiring Test Report Verification" : "Wiring Test Report Upload"}</h3>
                      <Grid container spacing={2} className="documents-container">
                        {dialogRowData.wiringTestReportDocument ? (

                          CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Wiring Test Report"
                          ) ?
                            <Grid item lg={2}>
                              <Grid
                                container
                                sx={{
                                  backgroundColor:
                                    dialogRowData.wiringTestReportDocumentFlag
                                      ? getDocumentBackGroundColor(
                                        dialogRowData.wiringTestReportDocumentFlag
                                      )
                                      : getDocumentBackGroundColor(
                                        flag_wiringTestReport
                                      ),
                                  borderRadius: "10px",
                                  minHeight: "125px",
                                  height: "auto",
                                  margin: '20px'

                                }}
                              >
                                <Grid item lg={12} className="tittlegrid">
                                  <p className="docTitle" style={{ textAlign: 'center' }}>Wiring Test Report</p>
                                </Grid>
                                <Grid
                                  item
                                  lg={12}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    paddingBottom: "5px",
                                  }}
                                >
                                  <div
                                    onClick={() => {
                                      if (!wiringTestReportVerifyPopUp) {
                                        setWiringTestReportVerifyPopUp(true);
                                      }
                                    }}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {dialogRowData.wiringTestReportDocument.slice(0, 6) ===
                                      "data:i" ? (
                                      flag_wiringTestReport === 1 ? (
                                        <>
                                          <Base64Image
                                            data={dialogRowData.wiringTestReportDocument}
                                            width="80"
                                          />
                                          <img
                                            src={tickicon}
                                            width="25px"
                                            height="25px"
                                            alt="Tick Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-20px",
                                              marginTop: "60px",
                                            }}
                                          />
                                        </>
                                      ) : flag_wiringTestReport === -1 ? (
                                        <>
                                          <Base64Image
                                            data={dialogRowData.wiringTestReportDocument}
                                            width="80"
                                          />
                                          <img
                                            src={crossIcon}
                                            width="25px"
                                            height="25px"
                                            alt="Cross Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-20px",
                                              marginTop: "60px",
                                            }}
                                          />
                                        </>
                                      ) : (
                                        <Base64Image
                                          data={dialogRowData.wiringTestReportDocument}
                                          width="80"
                                        />
                                      )
                                    ) : (
                                      <Base64Image data={pdfIcon} width="40" />
                                    )}
                                    {wiringTestReportVerifyPopUp && (
                                      <OpenBase64ImageInPopupForMeterInspector
                                        docVerifyPopUp={wiringTestReportVerifyPopUp}
                                        hideDocVerifyPopup={
                                          hideWiringTestReportVerifyAlert
                                        }
                                        documentName="Wiring Test Report"
                                        documentImage={
                                          dialogRowData.wiringTestReportDocument
                                        }
                                        width={"100%"}
                                        document={dialogRowData.wiringTestReportDocument}
                                        documentFlag={
                                          dialogRowData.wiringTestReportDocumentFlag
                                        }
                                        applicationProgressId={
                                          dialogRowData.applicationProgressId
                                        }
                                        objectionStatus={
                                          dialogRowData.objectionStatus
                                        }
                                        updateDocFlag={updateDocFlag}
                                        documentRemarks={
                                          wiringTestReportObjectionRemarks
                                        }
                                        titleToUpdateFlag="wiringTestReport"
                                        flag_document={flag_wiringTestReport}
                                      />
                                    )}
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                            :
                            <div className="description-box">
                              <p className="group-description">
                                <InfoIcon className="icon" />
                                Wiring Test Report is in process by sanctioning authority.
                              </p>
                            </div>
                        ) : (
                          CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Basic Permissions",
                            "Update"
                          ) ? (
                            <Grid item lg={12} sx={{ display: "flex", justifyContent: "center", padding: "20px" }}>
                              <Box
                                sx={{
                                  width: "100%",
                                  maxWidth: "400px",
                                  backgroundColor: "#ffffff",
                                  borderRadius: "12px",
                                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                                  padding: "24px",
                                  textAlign: "center"
                                }}
                              >
                                {newWiringTestReportDocumentThumbnail ? (
                                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
                                    <Box
                                      sx={{
                                        position: "relative",
                                        padding: "16px",
                                        backgroundColor: "#f8fafc",
                                        borderRadius: "8px",
                                        border: "2px solid #e2e8f0"
                                      }}
                                    >
                                      {newWiringTestReportDocumentThumbnail.slice(0, 10) === "data:image" ? (
                                        <img
                                          src={newWiringTestReportDocumentThumbnail}
                                          alt="Wiring Test Report"
                                          style={{ maxWidth: "120px", maxHeight: "120px", borderRadius: "4px" }}
                                        />
                                      ) : (
                                        <img src={pdfIcon} alt="PDF" width="60" />
                                      )}
                                      <Box
                                        onClick={() => {
                                          setNewWiringTestReportDocument("");
                                          setNewWiringTestReportDocumentThumbnail("");
                                        }}
                                        sx={{
                                          position: "absolute",
                                          top: "-8px",
                                          right: "-8px",
                                          width: "24px",
                                          height: "24px",
                                          backgroundColor: "#ef4444",
                                          borderRadius: "50%",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          cursor: "pointer",
                                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                          "&:hover": { backgroundColor: "#dc2626" }
                                        }}
                                      >
                                        <CloseIcon sx={{ fontSize: "16px", color: "#fff" }} />
                                      </Box>
                                    </Box>
                                    <Typography sx={{ color: "#22c55e", fontWeight: "500", fontSize: "14px" }}>
                                      File uploaded successfully
                                    </Typography>
                                  </Box>
                                ) : (
                                  <Box
                                    component="label"
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      padding: "32px 24px",
                                      border: "2px dashed #cbd5e1",
                                      borderRadius: "12px",
                                      backgroundColor: "#f8fafc",
                                      marginTop: '10px',
                                      cursor: "pointer",
                                      transition: "all 0.2s ease",
                                      "&:hover": {
                                        borderColor: "#003971",
                                        backgroundColor: "#f1f5f9"
                                      }
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        width: "56px",
                                        height: "56px",
                                        backgroundColor: "#e0e7ff",
                                        borderRadius: "50%",
                                        display: "flex",
                                        // alignItems: "center",
                                        justifyContent: "center",
                                        marginBottom: "16px"
                                      }}
                                    >
                                      <FileUploadOutlinedIcon sx={{ fontSize: "28px", color: "#003971" }} />
                                    </Box>
                                    <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", marginBottom: "4px" }}>
                                      Click to upload
                                    </Typography>
                                    <Typography sx={{ fontSize: "13px", color: "#64748b" }}>
                                      JPG, PNG or PDF
                                    </Typography>
                                    <input
                                      hidden
                                      accept=".jpg,.jpeg,.png,.pdf"
                                      type="file"
                                      onChange={NewWiringTestReportDocument}
                                    />
                                  </Box>
                                )}
                                {newWiringTestReportDocumentError && (
                                  <Box sx={{ color: "#ef4444", marginTop: "12px", fontSize: "13px", fontWeight: "500" }}>
                                    {newWiringTestReportDocumentError}
                                  </Box>
                                )}
                              </Box>
                            </Grid>
                          ) : (
                            <div className="description-box">
                              <p className="group-description">
                                <InfoIcon className="icon" />
                                {
                                  dialogRowData.wiringTestReportDocument ? "Wiring Test Report is in process by sanctioning authority." : "Wiring Test Report Upload is in process by CSR."
                                }

                              </p>
                            </div>
                          )
                        )}
                      </Grid>
                    </>

                  ) : (dialogRowData.applicationProgressId === 21 && dialogRowData.objectionStatus == 1) ? (
                    <>
                      <h3 className="step-title">Wiring Test Report Objection</h3>
                      <Grid container spacing={2} className="documents-container">
                        {
                          CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Basic Permissions",
                            "Update"
                          )
                            ?
                            <Grid item lg={2}>
                              <Grid
                                container
                                sx={{
                                  backgroundColor: newWiringTestReportDocumentThumbnail ? "#d4edda" : "#f8d7da",
                                  borderRadius: "10px",
                                  minHeight: "125px",
                                  height: "auto",
                                  margin: '20px'
                                }}
                              >
                                <Grid item lg={12} className="tittlegrid">
                                  <p className="docTitle" style={{ textAlign: 'center', color: newWiringTestReportDocumentThumbnail ? '#155724' : '#721c24' }}>
                                    {newWiringTestReportDocumentThumbnail ? 'Wiring Test Report (New)' : 'Wiring Test Report (Rejected)'}
                                  </p>
                                </Grid>
                                <Grid
                                  item
                                  lg={12}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    paddingBottom: "5px",
                                  }}
                                >
                                  {newWiringTestReportDocumentThumbnail ? (
                                    // Show new uploaded document
                                    <div style={{ position: "relative" }}>
                                      {newWiringTestReportDocumentThumbnail.slice(0, 10) === "data:image" ? (
                                        <img
                                          src={newWiringTestReportDocumentThumbnail}
                                          alt="New Wiring Test Report"
                                          width="80"
                                        />
                                      ) : (
                                        <img src={pdfIcon} alt="PDF" width="40" />
                                      )}
                                      <CloseIcon
                                        onClick={() => {
                                          setNewWiringTestReportDocument("");
                                          setNewWiringTestReportDocumentThumbnail("");
                                        }}
                                        style={{
                                          position: "absolute",
                                          top: "-8px",
                                          right: "-8px",
                                          cursor: "pointer",
                                          backgroundColor: "#fff",
                                          borderRadius: "50%",
                                          color: "red",
                                          fontSize: "18px"
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    // Show rejected document with reupload button
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                      <div
                                        onClick={() => {
                                          if (!wiringTestReportVerifyPopUp) {
                                            setWiringTestReportVerifyPopUp(true);
                                          }
                                        }}
                                        style={{ cursor: "pointer", position: "relative" }}
                                      >
                                        {dialogRowData.wiringTestReportDocument && dialogRowData.wiringTestReportDocument.slice(0, 6) === "data:i" ? (
                                          <>
                                            <Base64Image
                                              data={dialogRowData.wiringTestReportDocument}
                                              width="80"
                                            />
                                            <img
                                              src={crossIcon}
                                              width="25px"
                                              height="25px"
                                              alt="Cross Icon"
                                              style={{
                                                position: "absolute",
                                                bottom: "0",
                                                right: "-12px",
                                              }}
                                            />
                                          </>
                                        ) : (
                                          <Base64Image data={pdfIcon} width="40" />
                                        )}
                                        {wiringTestReportVerifyPopUp && (
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={wiringTestReportVerifyPopUp}
                                            hideDocVerifyPopup={hideWiringTestReportVerifyAlert}
                                            documentName="Wiring Test Report"
                                            documentImage={dialogRowData.wiringTestReportDocument}
                                            width={"100%"}
                                            document={dialogRowData.wiringTestReportDocument}
                                            documentFlag={dialogRowData.wiringTestReportDocumentFlag}
                                            applicationProgressId={dialogRowData.applicationProgressId}
                                            objectionStatus={dialogRowData.objectionStatus}
                                            updateDocFlag={updateDocFlag}
                                            documentRemarks={wiringTestReportObjectionRemarks}
                                            titleToUpdateFlag="wiringTestReport"
                                            flag_document={flag_wiringTestReport}
                                          />
                                        )}
                                      </div>
                                      <Button
                                        variant="outlined"
                                        component="label"
                                        startIcon={<FileUploadOutlinedIcon />}
                                        sx={{ textTransform: "none", fontSize: '10px', marginTop: '8px' }}
                                        size="small"
                                      >
                                        Reupload
                                        <input
                                          hidden
                                          accept=".jpg,.jpeg,.png,.pdf"
                                          type="file"
                                          onChange={NewWiringTestReportDocument}
                                        />
                                      </Button>
                                    </div>
                                  )}
                                </Grid>
                              </Grid>
                            </Grid>
                            :
                            <>
                              <div
                                className="description-box"
                                style={{
                                  background: "linear-gradient(135deg, #fff1f2 0%, #ffe4e6 100%)",
                                  border: "1px solid #fecdd3",
                                }}>
                                <p className="group-description">
                                  <InfoIcon className="icon" />
                                  <span style={{ color: "#b91c1c", fontWeight: 600 }}>
                                    The Wiring Test Report has been rejected by the Electric Inspector due to{" "}
                                    {dialogRowData.wiringTestReportDocumentObjectionRemarks} indicating a fake wiring report.
                                  </span>
                                </p>
                              </div>
                              <div className="description-box">
                                <p className="group-description">
                                  <InfoIcon className="icon" />
                                  CFC staff is required to re-upload a valid Wiring Test Report for further processing.
                                </p>
                              </div>
                            </>
                        }


                      </Grid>
                    </>
                  ) : dialogRowData.applicationProgressId === 2 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <h3 className="step-title">Arrear Verification</h3>

                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "New Connection",
                        "Workflow Permissions",
                        "Arrears Verification"
                      ) &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "New Connection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "15"
                        ) &&
                          dialogRowData.appliedLoad > 0 &&
                          dialogRowData.appliedLoad <= 15 &&
                          ((CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A1"
                          ) &&
                            allTariffList &&
                            getTariff(
                              dialogRowData.appliedLoad,
                              dialogRowData.connectionType,
                              dialogRowData.seasonalNonSeasonalFlag,
                              allTariffList
                            )?.startsWith("A1")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "New Connection",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A2"
                            ) &&
                              allTariffList &&
                              getTariff(
                                dialogRowData.appliedLoad,
                                dialogRowData.connectionType,
                                dialogRowData.seasonalNonSeasonalFlag,
                                allTariffList
                              )?.startsWith("A2")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "New Connection",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A3"
                            ) &&
                              allTariffList &&
                              getTariff(
                                dialogRowData.appliedLoad,
                                dialogRowData.connectionType,
                                dialogRowData.seasonalNonSeasonalFlag,
                                allTariffList
                              )?.startsWith("A3")))) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "70"
                          ) &&
                            dialogRowData.appliedLoad > 0 &&
                            dialogRowData.appliedLoad <= 70 &&
                            // ✅ Tariff A1, A2, A3 nahi hone chahiye
                            !["A1", "A2", "A3"].some((tariffCode) =>
                              getTariff(
                                dialogRowData.appliedLoad,
                                dialogRowData.connectionType,
                                dialogRowData.seasonalNonSeasonalFlag,
                                allTariffList
                              )
                                ?.toUpperCase()
                                .startsWith(tariffCode)
                            )) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "70"
                          ) &&
                            dialogRowData.appliedLoad > 15 &&
                            dialogRowData.appliedLoad <= 70) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "500"
                          ) &&
                            dialogRowData.appliedLoad > 70 &&
                            dialogRowData.appliedLoad <= 500) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "5000"
                          ) &&
                            dialogRowData.appliedLoad > 500)) ? (
                        <>
                          <Grid container className="field-survey-container">
                            <Grid item lg={12}>
                              <Grid container spacing={2}>
                                <Grid item lg={5}>
                                  <Typography
                                    className="fieldLabel"
                                    sx={{ marginTop: "5px" }}
                                  >
                                    Any <b style={{ color: "red" }}>ARREARS</b>{" "}
                                    against this Property / Applicant ?
                                  </Typography>
                                </Grid>
                                <Grid item lg={6}>
                                  <FormControl>
                                    <RadioGroup
                                      defaultValue={arrearFlag}
                                      value={arrearFlag}
                                      className="radio"
                                      name="iv_arears_flag"
                                      onChange={() => {
                                        if (arrearFlag === 1) {
                                          setArearFlag(0);
                                        } else {
                                          setArearFlag(1);
                                        }
                                        setNoArrears();
                                        arearsFormik.resetForm();
                                      }}
                                      row
                                    >
                                      <FormControlLabel
                                        value={1}
                                        className="option-left"
                                        sx={{
                                          padding: "0px 30px",
                                          marginRight: "15px",
                                        }}
                                        control={<Radio />}
                                        label="Yes"
                                      />
                                      <FormControlLabel
                                        value={0}
                                        className="option-left"
                                        sx={{ padding: "0px 30px" }}
                                        control={<Radio />}
                                        label="No"
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                </Grid>
                                {arrearFlag === 1 ? (
                                  <>
                                    <Grid item lg={6}>
                                      <Typography
                                        className="fieldLabel"
                                        sx={{
                                          marginBottom: "10px",
                                          marginTop: "5px",
                                        }}
                                      >
                                        Reference number associated with default
                                      </Typography>
                                      <TextField
                                        required
                                        type="text"
                                        name="iv_property_reference_no"
                                        value={
                                          arearsFormik.values
                                            .iv_property_reference_no
                                        }
                                        inputProps={{ maxLength: 14 }}
                                        onChange={arearsFormik.handleChange}
                                        onBlur={arearsFormik.handleBlur}
                                        style={{
                                          width: "50%",
                                          backgroundColor: "white",
                                        }}
                                        id="iv_property_reference_no"
                                        className="arearsReferenceNumber"
                                      />
                                      <Box className="form-error">
                                        {arearsFormik.errors
                                          .iv_property_reference_no &&
                                          arearsFormik.touched
                                            .iv_property_reference_no
                                          ? arearsFormik.errors
                                            .iv_property_reference_no
                                          : null}
                                      </Box>
                                    </Grid>
                                    {arrearsDetailsRefno.arrearsAmount ? (
                                      <Grid item lg={6}>
                                        <Typography
                                          className="fieldLabel"
                                          sx={{
                                            marginBottom: "10px",
                                            marginTop: "5px",
                                          }}
                                        >
                                          Remarks <span style={{ color: "red" }}>*</span>
                                        </Typography>
                                        <TextField
                                          required
                                          type="text"
                                          name="iv_arrears_remarks"
                                          multiline
                                          rows={3}
                                          placeholder="Enter remarks for arrears (min 10 characters)"
                                          value={
                                            arearsFormik.values
                                              .iv_arrears_remarks
                                          }
                                          onChange={arearsFormik.handleChange}
                                          onBlur={arearsFormik.handleBlur}
                                          style={{
                                            width: "100%",
                                            backgroundColor: "white",
                                          }}
                                          id="iv_arrears_remarks"
                                        />
                                        <Box className="form-error">
                                          {arearsFormik.errors
                                            .iv_arrears_remarks &&
                                            arearsFormik.touched
                                              .iv_arrears_remarks
                                            ? arearsFormik.errors
                                              .iv_arrears_remarks
                                            : null}
                                        </Box>
                                      </Grid>
                                    ) : null}
                                    {/* {
                                                  error &&
                                                  <Error
                                                    error={error}
                                                    onClose={errorCloses}
                                                    backgroundColor="#FFC0CB"
                                                    textColor="#bb0303"
                                                    iconColor="#bb0303"
                                                  />
                                                } */}
                                  </>
                                ) : (
                                  <>
                                    {/* <Grid item lg={12}>
                                                  <Grid item lg={12} sx={{ display: 'flex', alignItems: 'center', marginLeft: '5%', marginTop: '5%' }}>
                                                    <img src={frontImg} alt="Cnic Front" style={{ width: '45%', height: '40%' }} ></img>
                                                    <img src={backImg} alt="Cnic Back" style={{ width: '45%', height: '40%', marginLeft: '2%' }} ></img>
                                                  </Grid>
                                                </Grid> */}
                                    <Grid
                                      container
                                      spacing={2}
                                      alignItems="flex-start"
                                      justifyContent="space-between"
                                      marginLeft={10}
                                      marginRight={10}
                                      marginTop={2}
                                    >
                                      {/* CNIC Front Section */}
                                      <Grid
                                        item
                                        lg={6}
                                        md={6}
                                        sm={12}
                                        className="item"
                                      >
                                        <Typography
                                          className="title"
                                          sx={{ marginBottom: "8px" }}
                                        >
                                          CNIC Front
                                        </Typography>
                                        <Grid
                                          container
                                          sx={{
                                            backgroundColor:
                                              getDocumentBackGroundColor(0),
                                            borderRadius: "10px",
                                            // height: "250px",
                                            width: "100%",
                                          }}
                                          className="docContainer"
                                        >
                                          <img
                                            src={frontImg}
                                            alt="Cnic Front"
                                            style={{
                                              width: "100%",
                                              height: "100%",
                                            }}
                                          />
                                        </Grid>
                                      </Grid>

                                      {/* CNIC Back Section */}
                                      <Grid
                                        item
                                        lg={6}
                                        md={6}
                                        sm={12}
                                        className="item"
                                      >
                                        <Typography
                                          className="title"
                                          sx={{ marginBottom: "8px" }}
                                        >
                                          CNIC Back
                                        </Typography>
                                        <Grid
                                          container
                                          sx={{
                                            backgroundColor:
                                              getDocumentBackGroundColor(0),
                                            borderRadius: "10px",
                                            // height: "250px",
                                            width: "100%",
                                          }}
                                          className="docContainer"
                                        >
                                          <img
                                            src={backImg}
                                            alt="Cnic Back"
                                            style={{
                                              width: "100%",
                                              height: "100%",
                                            }}
                                          />
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </>
                                )}
                                {arrearFlag === 1 &&
                                  arearsFormik.values.iv_property_reference_no
                                    .length === 14 ? (
                                  arrearsDetailsRefno.arrearsAmount ? (
                                    <>
                                      <Grid
                                        item
                                        container
                                        className="fieldLabel1"
                                      >
                                        <Grid item lg={3}>
                                          <Typography
                                            sx={{
                                              fontWeight: "bold",
                                              fontSize: 13,
                                            }}
                                            className="fieldLabel"
                                          >
                                            Arrear Amount
                                          </Typography>
                                          <Typography className="fieldLabels">
                                            {arrearsDetailsRefno.arrearsAmount
                                              ? arrearsDetailsRefno.arrearsAmount
                                              : "-"}
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={3}>
                                          <Typography
                                            sx={{
                                              fontWeight: "bold",
                                              fontSize: 13,
                                            }}
                                            className="fieldLabel"
                                          >
                                            Consumer Name
                                          </Typography>
                                          <Typography className="fieldLabels">
                                            {arrearsDetailsRefno.consumerName
                                              ? arrearsDetailsRefno.consumerName
                                              : "-"}
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={3}>
                                          <Typography
                                            sx={{
                                              fontWeight: "bold",
                                              fontSize: 13,
                                            }}
                                            className="fieldLabel"
                                          >
                                            Consumer Phone No.
                                          </Typography>
                                          <Typography className="fieldLabels">
                                            {arrearsDetailsRefno.consumerNo
                                              ? arrearsDetailsRefno.consumerNo
                                              : "-"}
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={3}>
                                          <Typography
                                            sx={{
                                              fontWeight: "bold",
                                              fontSize: 13,
                                            }}
                                            className="fieldLabel"
                                          >
                                            Consumer Address
                                          </Typography>
                                          <Typography className="fieldLabels">
                                            {arrearsDetailsRefno.consumerAddress
                                              ? arrearsDetailsRefno.consumerAddress
                                              : "-"}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </>
                                  ) : (
                                    noArrears && (
                                      <Box
                                        sx={{
                                          color: "#00B091",
                                          marginTop: "2%",
                                          marginLeft: "2%",
                                          backgroundColor: "#DFFFE4",
                                          padding: "3%",
                                          width: "100%",
                                          display: "flex",
                                          flexDirection: "row",
                                        }}
                                      >
                                        <ErrorIcon
                                          style={{
                                            color: "#00B091",
                                            marginLeft: "1%",
                                          }}
                                        />
                                        <h4
                                          style={{
                                            marginLeft: "10px",
                                            fontSize: "1vw",
                                            fontWeight: "normal",
                                          }}
                                        >
                                          {noArrears}
                                        </h4>
                                      </Box>
                                    )
                                  )
                                ) : null}
                              </Grid>
                            </Grid>
                          </Grid>
                        </>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            Arrears Verification is in process by sanctioning
                            authority.{" "}
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 2 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <h3 className="step-title">Arrears Objection</h3>
                      <>
                        <Grid item lg={12}>
                          <Grid
                            item
                            lg={12}
                            sx={{
                              marginTop: "2%",
                              alignItems: "center",
                              marginLeft: "8%",
                            }}
                          >
                            <img
                              src={dialogRowData.copyOfApplicantCNICFront}
                              alt="Cnic Front"
                              style={{ width: "40%", height: "40%" }}
                            ></img>
                            <img
                              src={dialogRowData.copyOfApplicantCNICBack}
                              alt="Cnic Back"
                              style={{
                                width: "40%",
                                height: "40%",
                                marginLeft: "2%",
                              }}
                            ></img>
                          </Grid>
                        </Grid>
                        <Grid item lg={12} className="arrear-container">
                          <Grid
                            className="arrear-container1"
                            item
                            container
                            spacing={2}
                          >
                            <Grid item lg={3}>
                              <Typography className="fieldLabel">
                                Reference No.
                              </Typography>
                              <Typography className="arrear-label">
                                {arrearsDetailsRefnoToDisplay.refNo
                                  ? arrearsDetailsRefnoToDisplay.refNo
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3}>
                              <Typography className="fieldLabel">
                                Arrear Amount
                              </Typography>
                              <Typography className="arrear-label">
                                {arrearsDetailsRefnoToDisplay.arrearsAmount
                                  ? arrearsDetailsRefnoToDisplay.arrearsAmount
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3}>
                              <Typography className="fieldLabel">
                                Consumer Name
                              </Typography>
                              <Typography className="arrear-label">
                                {arrearsDetailsRefnoToDisplay.consumerName
                                  ? arrearsDetailsRefnoToDisplay.consumerName
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3}>
                              <Typography className="fieldLabel">
                                Consumer Phone No.
                              </Typography>
                              <Typography className="arrear-label">
                                {arrearsDetailsRefnoToDisplay.consumerNo
                                  ? arrearsDetailsRefnoToDisplay.consumerNo
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={12}>
                              <Typography className="fieldLabel">
                                Consumer Address
                              </Typography>
                              <Typography className="arrear-label">
                                {arrearsDetailsRefnoToDisplay.consumerAddress
                                  ? arrearsDetailsRefnoToDisplay.consumerAddress
                                  : "-"}
                              </Typography>
                            </Grid>
                          </Grid>
                          <>
                            {arrearsDetailsRefnoToDisplay.paidArearImage && (
                              <Grid item lg={4}>
                                <Typography sx={{ fontWeight: "bold" }}>
                                  Arear Paid Bill Image{" "}
                                </Typography>
                                <a
                                  href="#"
                                  onClick={() =>
                                    openBase64Image(
                                      arrearsDetailsRefnoToDisplay.paidArearImage
                                    )
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Base64Image
                                    data={
                                      arrearsDetailsRefnoToDisplay.paidArearImage
                                    }
                                    width={80}
                                  />
                                </a>
                              </Grid>
                            )}
                            {arrearsDetailsRefnoToDisplay.paidArearDate && (
                              <Grid item lg={4}>
                                <Typography sx={{ fontWeight: "bold" }}>
                                  Arear Paid Date{" "}
                                </Typography>
                                <Typography>
                                  {arrearsDetailsRefnoToDisplay.paidArearDate}
                                </Typography>
                              </Grid>
                            )}
                          </>
                        </Grid>
                      </>
                    </>
                  ) : dialogRowData.applicationProgressId === 3 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <h3 className="step-title">Field Survey</h3>
                      {fieldSurveyError && (
                        <div
                          style={{
                            backgroundColor: "#FFF3F3",
                            display: "flex",
                            flexDirection: "row",

                            width: "100%",
                            padding: "1%",

                            justifyContent: "space-between",
                            marginBottom: "1%",
                          }}
                        >
                          <div
                            style={{
                              backgroundColor: "#FFF3F3",
                              display: "flex",
                              flexDirection: "row",
                              marginLeft: "1%",
                              width: "100%",
                              padding: "1%",
                              alignItems: "center",
                            }}
                          >
                            <ErrorIcon
                              style={{ color: "#bb0303", marginRight: "1%" }}
                            />

                            <p
                              style={{
                                color: "#bb0303",
                              }}
                            >
                              {fieldSurveyError}
                            </p>
                          </div>
                          <CloseIcon
                            onClick={errorCloses}
                            style={{
                              color: "#bb0303",
                              marginRight: "2%",
                              marginTop: "1%",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      )}
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "New Connection",
                        "Workflow Permissions",
                        "Field Survey"
                      ) &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "New Connection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "15"
                        ) &&
                          dialogRowData.appliedLoad > 0 &&
                          dialogRowData.appliedLoad <= 15 &&
                          ((CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A1"
                          ) &&
                            allTariffList &&
                            getTariff(
                              dialogRowData.appliedLoad,
                              dialogRowData.connectionType,
                              dialogRowData.seasonalNonSeasonalFlag,
                              allTariffList
                            )?.startsWith("A1")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "New Connection",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A2"
                            ) &&
                              allTariffList &&
                              getTariff(
                                dialogRowData.appliedLoad,
                                dialogRowData.connectionType,
                                dialogRowData.seasonalNonSeasonalFlag,
                                allTariffList
                              )?.startsWith("A2")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "New Connection",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A3"
                            ) &&
                              allTariffList &&
                              getTariff(
                                dialogRowData.appliedLoad,
                                dialogRowData.connectionType,
                                dialogRowData.seasonalNonSeasonalFlag,
                                allTariffList
                              )?.startsWith("A3")))) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "70"
                          ) &&
                            dialogRowData.appliedLoad > 0 &&
                            dialogRowData.appliedLoad <= 70 &&
                            !["A1", "A2", "A3"].some((tariffCode) =>
                              getTariff(
                                dialogRowData.appliedLoad,
                                dialogRowData.connectionType,
                                dialogRowData.seasonalNonSeasonalFlag,
                                allTariffList
                              )
                                ?.toUpperCase()
                                .startsWith(tariffCode)
                            )) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "70"
                          ) &&
                            dialogRowData.appliedLoad > 15 &&
                            dialogRowData.appliedLoad <= 70) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "500"
                          ) &&
                            dialogRowData.appliedLoad > 70 &&
                            dialogRowData.appliedLoad <= 500) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "5000"
                          ) &&
                            dialogRowData.appliedLoad > 500)) ? (
                        <>
                          {errormessageCostEstimation && (
                            <>
                              <div
                                style={{
                                  backgroundColor: "#FFF3F3",
                                  display: "flex",
                                  flexDirection: "row",
                                  width: "100%",
                                  padding: "1%",
                                  justifyContent: "space-between",
                                  marginBottom: "1%",
                                }}
                              >
                                <div
                                  style={{
                                    backgroundColor: "#FFF3F3",
                                    display: "flex",
                                    flexDirection: "row",
                                    marginLeft: "1%",
                                    width: "100%",
                                    padding: "1%",
                                    alignItems: "center",
                                  }}
                                >
                                  <ErrorIcon
                                    style={{
                                      color: "#bb0303",
                                      marginRight: "1%",
                                    }}
                                  />
                                  <p
                                    style={{
                                      color: "#bb0303",
                                    }}
                                  >
                                    {errormessageCostEstimation}
                                  </p>
                                </div>
                              </div>
                            </>
                          )}
                          <Grid
                            container
                            spacing={0.5}
                            className="field-survey-container"
                          >
                            <Grid item lg={2.5} sx={{ marginTop: "2%" }}>
                              <Typography className="fieldLabel">
                                Site Observation
                              </Typography>
                              <Select
                                value={fieldFormik.values.iv_objection_Type}
                                onChange={fieldFormik.handleChange}
                                onBlur={fieldFormik.handleBlur}
                                className="fieldBatch"
                                name="iv_objection_Type"
                                id="iv_objection_Type"
                                sx={{ width: "95%" }}
                              >
                                {dialogRowData.applicationProgressId === 3
                                  ? fieldObjections.map((option) => (
                                    <MenuItem key={option} value={option}>
                                      {option}
                                    </MenuItem>
                                  ))
                                  : null}
                              </Select>
                              <Box className="from-Error">
                                {fieldFormik.errors.iv_objection_Type &&
                                  fieldFormik.touched.iv_objection_Type
                                  ? fieldFormik.errors.iv_objection_Type
                                  : null}
                              </Box>
                            </Grid>
                            {fieldFormik.values.iv_objection_Type ===
                              "Other" && (
                                <Grid item lg={4} sx={{ marginTop: "2%" }}>
                                  <Typography className="fieldLabel">
                                    Remarks <span style={{ color: "red" }}>*</span>
                                  </Typography>
                                  <TextField
                                    required
                                    type="text"
                                    name="iv_objection_Descripton"
                                    multiline
                                    rows={3}
                                    placeholder="Enter remarks (min 10 characters)"
                                    value={
                                      fieldFormik.values.iv_objection_Descripton
                                    }
                                    onChange={fieldFormik.handleChange}
                                    onBlur={fieldFormik.handleBlur}
                                    style={{
                                      width: "95%",
                                      backgroundColor: "white",
                                    }}
                                    id="iv_objection_Descripton"
                                  />
                                  <Box className="form-error">
                                    {fieldFormik.errors.iv_objection_Descripton &&
                                      fieldFormik.touched.iv_objection_Descripton
                                      ? fieldFormik.errors.iv_objection_Descripton
                                      : null}
                                  </Box>
                                </Grid>
                              )}
                            {fieldFormik.values.iv_objection_Type ===
                              "No Issue" && (
                                <>
                                  <Grid item lg={2} sx={{ marginTop: "20px" }}>
                                    <Typography className="fieldLabel">
                                      Tariff
                                    </Typography>
                                    <Select
                                      sx={{ width: "100%" }}
                                      value={tariff}
                                      onChange={(e) => {
                                        fieldFormik.handleChange(e);
                                        setTariff(e.target.value);
                                      }}
                                      onBlur={fieldFormik.handleBlur}
                                      displayEmpty
                                      disabled={
                                        dnDetails && dnDetails.filledFlag === 1
                                      }
                                      className="fieldBatch"
                                      name="iv_tariff_to_allot"
                                      id="iv_tariff_to_allot"
                                      MenuProps={{
                                        PaperProps: {
                                          style: {
                                            maxHeight: Math.min(
                                              shortListIndustrialTariff.length *
                                              36 +
                                              48,
                                              300
                                            ),
                                            width: 200,
                                          },
                                        },
                                      }}
                                    >
                                      <MenuItem
                                        value=""
                                        sx={{ fontSize: "12px" }}
                                      >
                                        Select Tariff
                                      </MenuItem>
                                      {shortListIndustrialTariff.map((option) => (
                                        <MenuItem
                                          key={option.tariffName}
                                          value={option.tariffName}
                                          sx={{ fontSize: "12px" }}
                                        >
                                          {option.tariffName}
                                        </MenuItem>
                                      ))}
                                    </Select>

                                    {/* )} */}
                                    <Box className="form-error">
                                      {fieldFormik.errors.iv_tariff_to_allot &&
                                        fieldFormik.touched.iv_tariff_to_allot
                                        ? fieldFormik.errors.iv_tariff_to_allot
                                        : null}
                                    </Box>
                                  </Grid>
                                  {/* <Grid item lg={1.5} sx={{ marginTop: "2%" }}>
                                    <Typography className="fieldLabel">
                                      Area (Marla)
                                    </Typography>
                                    <TextField
                                      size="small"
                                      value={
                                        fieldFormik.values.iv_coverage_area !==
                                        undefined
                                          ? fieldFormik.values.iv_coverage_area
                                          : ""
                                      }
                                      onChange={(e) => {
                                        const raw = e.target.value || "";
                                        const digits = raw.replace(/\D/g, "");
                                        const val = digits === "" ? "" : parseInt(digits, 10);
                                        fieldFormik.setFieldValue(
                                          "iv_coverage_area",
                                          val
                                        );
                                      }}
                                      onBlur={fieldFormik.handleBlur}
                                      name="iv_coverage_area"
                                      id="iv_coverage_area"
                                      className="fieldBatch"
                                      sx={{
                                        width: "95%",
                                        '& .MuiInputBase-root': { height: 35 },
                                      }}
                                      inputProps={{ inputMode: "numeric", pattern: "\\d*", min: 3 }}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <IconButton
                                              size="small"
                                              onClick={() => {
                                                const curr = parseInt(
                                                  fieldFormik.values.iv_coverage_area
                                                );
                                                const current = isNaN(curr) ? 3 : curr;
                                                const next = current - 1 >= 3 ? current - 1 : 3;
                                                fieldFormik.setFieldValue(
                                                  "iv_coverage_area",
                                                  next
                                                );
                                              }}
                                            >
                                              <RemoveIcon fontSize="small" />
                                            </IconButton>
                                            <IconButton
                                              size="small"
                                              onClick={() => {
                                                const curr = parseInt(
                                                  fieldFormik.values.iv_coverage_area
                                                );
                                                const current = isNaN(curr) ? 3 : curr;
                                                fieldFormik.setFieldValue(
                                                  "iv_coverage_area",
                                                  current + 1
                                                );
                                              }}
                                            >
                                              <AddIcon fontSize="small" />
                                            </IconButton>
                                          </InputAdornment>
                                        ),
                                      }}
                                    />
                                    <p className="form-error">
                                      {fieldFormik.errors.iv_coverage_area &&
                                        fieldFormik.touched.iv_coverage_area
                                        ? fieldFormik.errors.iv_coverage_area
                                        : null}
                                    </p>
                                  </Grid> */}

                                  <Grid item lg={1.5} sx={{ marginTop: "2%" }}>
                                    <Typography className="fieldLabel">
                                      Area (Marla)
                                    </Typography>

                                    <TextField
                                      size="small"
                                      value={
                                        fieldFormik.values.iv_coverage_area !==
                                          undefined
                                          ? fieldFormik.values.iv_coverage_area
                                          : ""
                                      }
                                      onChange={(e) => {
                                        const raw = e.target.value || "";
                                        const digits = raw.replace(/\D/g, "");
                                        const val = digits === "" ? "" : parseInt(digits, 10);
                                        fieldFormik.setFieldValue(
                                          "iv_coverage_area",
                                          val
                                        );
                                      }}
                                      onBlur={fieldFormik.handleBlur}
                                      name="iv_coverage_area"
                                      id="iv_coverage_area"
                                      className="fieldBatch"
                                      sx={{ width: "95%", '& .MuiInputBase-root': { height: 35 } }}
                                      inputProps={{ inputMode: "numeric", pattern: "\\d*", min: 3 }}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <IconButton
                                              size="small"
                                              onClick={() => {
                                                const curr = parseInt(
                                                  fieldFormik.values.iv_coverage_area
                                                );
                                                const current = isNaN(curr) ? 3 : curr;
                                                const next = current - 1 >= 3 ? current - 1 : 3;
                                                fieldFormik.setFieldValue(
                                                  "iv_coverage_area",
                                                  next
                                                );
                                              }}
                                            >
                                              <RemoveIcon fontSize="small" />
                                            </IconButton>
                                            <IconButton
                                              size="small"
                                              onClick={() => {
                                                const curr = parseInt(
                                                  fieldFormik.values.iv_coverage_area
                                                );
                                                const current = isNaN(curr) ? 3 : curr;
                                                fieldFormik.setFieldValue(
                                                  "iv_coverage_area",
                                                  current + 1
                                                );
                                              }}
                                            >
                                              <AddIcon fontSize="small" />
                                            </IconButton>
                                          </InputAdornment>
                                        ),
                                      }}
                                      disabled={dialogRowData.applicationProgressId !== 3}
                                    />

                                    <p className="form-error">
                                      {fieldFormik.errors.iv_coverage_area &&
                                        fieldFormik.touched.iv_coverage_area
                                        ? fieldFormik.errors.iv_coverage_area
                                        : null}
                                    </p>
                                  </Grid>

                                  <Grid item lg={2} sx={{ marginTop: "2%" }}>
                                    <Typography className="fieldLabel">
                                      Meters Already Installed
                                    </Typography>
                                    <TextField
                                      required
                                      type="number"
                                      InputProps={{
                                        inputProps: {
                                          min: dialogRowData.noOfMetersAlreadyInstalled,
                                        },
                                      }}
                                      sx={{ width: "80%" }}
                                      autoComplete="off"
                                      name="iv_no_of_meters_already_installed"
                                      value={
                                        fieldFormik.values
                                          .iv_no_of_meters_already_installed
                                      }
                                      onChange={fieldFormik.handleChange}
                                      onBlur={fieldFormik.handleBlur}
                                      id="iv_no_of_meters_already_installed"
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {fieldFormik.errors
                                        .iv_no_of_meters_already_installed &&
                                        fieldFormik.touched
                                          .iv_no_of_meters_already_installed
                                        ? fieldFormik.errors
                                          .iv_no_of_meters_already_installed
                                        : null}
                                    </p>
                                  </Grid>

                                  <Grid item lg={3} sx={{ marginTop: "3%" }}>
                                    <FormGroup className="radio-group">
                                      <RadioGroup
                                        row
                                        name="iv_rural_urban"
                                        value={fieldFormik.values.iv_rural_urban}
                                        onChange={(e) =>
                                          fieldFormik.setFieldValue(
                                            "iv_rural_urban",
                                            e.target.value
                                          )
                                        }
                                      >
                                        <FormControlLabel
                                          value="U"
                                          control={<Radio />}
                                          label="Urban"
                                        />
                                        <FormControlLabel
                                          value="R"
                                          control={
                                            <Radio
                                              disabled={
                                                !CheckPermissions(
                                                  permissions,
                                                  "General Services",
                                                  "New Connection",
                                                  "Workflow Permissions",
                                                  "Meter Installation",
                                                  "SCO P1 Creation"
                                                )
                                              }
                                            />
                                          }
                                          label="Rural"
                                        />
                                      </RadioGroup>
                                    </FormGroup>

                                    <Box className="form-error">
                                      {fieldFormik.errors.iv_rural_urban &&
                                        fieldFormik.touched.iv_rural_urban
                                        ? fieldFormik.errors.iv_rural_urban
                                        : null}
                                    </Box>
                                  </Grid>
                                  {/* <Grid item lg={2} sx={{ marginTop: "20px" }}>
                                                <Typography className="fieldLabel">Tariff</Typography>
                                                {dialogRowData.connectionType != "Industrial" ? (
                                                  <TextField
                                                    value={tariff}
                                                    fullWidth
                                                    disabled={true}
                                                    name="iv_tariff_to_allot"
                                                    id="iv_tariff_to_allot"
                                                    className="fieldCoverageMarla"
                                                  />
                                                ) : (
                                                  <Select
                                                    sx={{ width: "100%" }}
                                                    value={tariff}
                                                    onChange={(e) => {
                                                      fieldFormik.handleChange(e);
                                                      setTariff(e.target.value);
                                                    }}
                                                    onBlur={fieldFormik.handleBlur}
                                                    displayEmpty
                                                    disabled={dnDetails && dnDetails.filledFlag === 1}
                                                    className="fieldBatch"
                                                    name="iv_tariff_to_allot"
                                                    id="iv_tariff_to_allot"
                                                    MenuProps={{
                                                      PaperProps: {
                                                        style: {
                                                          width: 20,
                                                          height: 180,
                                                        },
                                                      },
                                                    }}
                                                  >
                                                    <MenuItem value="" sx={{ fontSize: "12px" }}>
                                                      Select Tariff
                                                    </MenuItem>
                                                    {shortListIndustrialTariff.map((option) => (
                                                      <MenuItem
                                                        key={option.tariffName}
                                                        value={option.tariffName}
                                                        sx={{ fontSize: "12px" }}
                                                      >
                                                        {option.tariffName}
                                                      </MenuItem>
                                                    ))}
                                                  </Select>
                                                )}
                                                <Box className="form-error">
                                                  {fieldFormik.errors.iv_tariff_to_allot &&
                                                    fieldFormik.touched.iv_tariff_to_allot
                                                    ? fieldFormik.errors.iv_tariff_to_allot
                                                    : null}
                                                </Box>
                                              </Grid> */}

                                  <Grid container spacing={2}>
                                    {fieldFormik.values.iv_objection_Type ===
                                      "No Issue" &&
                                      [
                                        ...Array(
                                          fieldFormik.values
                                            .iv_no_of_meters_already_installed
                                        ),
                                      ].map((_, i) => (
                                        <Grid item lg={2} key={i}>
                                          <Typography className="fieldLabel">
                                            Meter {i + 1} Ref No.
                                          </Typography>
                                          <TextField
                                            name={`installedMeterRefNos[${i}]`}
                                            value={
                                              fieldFormik.values
                                                .installedMeterRefNos[i] || ""
                                            }
                                            onChange={fieldFormik.handleChange}
                                            onBlur={fieldFormik.handleBlur}
                                            error={Boolean(
                                              fieldFormik.touched
                                                .installedMeterRefNos?.[i] &&
                                              fieldFormik.errors
                                                .installedMeterRefNos?.[i]
                                            )}
                                            helperText={
                                              fieldFormik.touched
                                                .installedMeterRefNos?.[i] &&
                                              fieldFormik.errors
                                                .installedMeterRefNos?.[i]
                                            }
                                            fullWidth
                                            inputProps={{ maxLength: 14 }}
                                            sx={{
                                              "& .MuiOutlinedInput-root": {
                                                height: 40,
                                                backgroundColor: "white",
                                                borderRadius: "6px",
                                              },
                                              "& .MuiInputBase-input": {
                                                height: "40px",
                                                padding: "0 10px",
                                              },
                                            }}
                                          />
                                        </Grid>
                                      ))}
                                  </Grid>
                                </>
                              )}

                            {/* {
                                            fieldFormik.values.iv_objection_Type === "No Issue" &&
                                            <>
                                              <Grid item lg={12}>
                                              </Grid>
                                              <Grid item lg={2.5} sx={{ marginTop: '2%' }} >
                                                <Typography className='fieldLabel' >{dialogRowData.applicationId.slice(3, 5) == '13' ? "LT Line within 20 meters" : "LT Line within 40 meters"}</Typography>
                                                <FormControl  >
                                                  <RadioGroup
                                                    defaultValue={fieldFormik.values.iv_distance}
                                                    value={fieldFormik.values.iv_distance}
                                                    name="iv_distance"
                                                    onChange={MeterLine}
                                                    row
                                                  >
                                                    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                                      <FormControlLabel value={1} sx={{ backgroundColor: 'white', padding: '0px 10px', borderRadius: '5px', marginLeft: '0px', marginRight: '10px', border: '1px solid lightgrey', marginTop: '2%' }} control={<Radio />} label="Yes" />
                                                      <FormControlLabel value={0} sx={{ backgroundColor: 'white', padding: '0px 10px', borderRadius: '5px', border: '1px solid lightgrey', textAlign: 'right', marginLeft: '2%', marginTop: '2%' }} control={<Radio />} label="No" />
                                                    </Box>
                                                  </RadioGroup>
                                                </FormControl>
                                                <p className='form-error'>
                                                  {fieldFormik.errors.iv_distance && fieldFormik.touched.iv_distance ? (fieldFormik.errors.iv_distance) : null}
                                                </p>
                                              </Grid>

                                              <Grid item lg={3.5} sx={{ marginTop: '2%', marginLeft: '1%' }}>
                                                <Typography className='fieldLabel'>Meter Type</Typography>
                                                <FormControl className='form-control'>
                                                  <RadioGroup
                                                    className='radio-group'
                                                    row
                                                    name="iv_meter_type"
                                                    value={
                                                      dialogRowData.applicationId?.slice(3, 5) === '13'
                                                        ? '1' // Force Smart
                                                        : fieldFormik.values.iv_meter_type
                                                    }
                                                    onChange={fieldFormik.handleChange}
                                                  >
                                                    <FormControlLabel
                                                      value="1"
                                                      className='form-control-label'
                                                      control={<Radio />}
                                                      label="Smart"
                                                      labelPlacement="end"
                                                      disabled={
                                                        dialogRowData.appliedLoad < 5 ||
                                                        dialogRowData.applicationId?.slice(3, 5) === '13'
                                                      }
                                                      sx={{
                                                        backgroundColor: 'white',
                                                        padding: '0px 10px',
                                                        borderRadius: '5px',
                                                        marginLeft: '0px',
                                                        marginRight: '5px',
                                                        border: '1px solid lightgrey',
                                                      }}
                                                    />
                                                    <FormControlLabel
                                                      value="0"
                                                      className='form-control-label'
                                                      control={<Radio />}
                                                      label="Normal"
                                                      labelPlacement="end"
                                                      disabled={
                                                        dialogRowData.appliedLoad < 5 ||
                                                        dialogRowData.applicationId?.slice(3, 5) === '13'
                                                      }
                                                      sx={{
                                                        backgroundColor: 'white',
                                                        padding: '0px 10px',
                                                        borderRadius: '5px',
                                                        marginLeft: '0px',
                                                        marginRight: '10px',
                                                        border: '1px solid lightgrey',
                                                      }}
                                                    />
                                                  </RadioGroup>
                                                </FormControl>

                                                {(fieldFormik.touched.iv_meter_type || fieldFormik.submitCount > 0) && fieldFormik.errors.iv_meter_type && (
                                                  <p className='form-error'>{fieldFormik.errors.iv_meter_type}</p>
                                                )}
                                              </Grid>

                                              {
                                                fieldFormik.values.iv_distance != 0 &&
                                                <>
                                                  <Grid item lg={2.5} sx={{ marginTop: '2%' }}>
                                                    <Typography className='fieldLabel' >Grid Sharing Cost applied ?</Typography>
                                                    <FormControl >
                                                      <RadioGroup
                                                        defaultValue={gridFlag}
                                                        value={gridFlag}
                                                        onChange={() => {
                                                          if (gridFlag) {
                                                            setGridFlag(false)
                                                          } else {
                                                            setGridFlag(true)
                                                          }
                                                          fieldFormik.values.iv_grid_sharing_cost = 0
                                                          setGridSharingCost()
                                                        }}
                                                        row
                                                      >
                                                        <FormControlLabel value={true} sx={{ backgroundColor: 'white', padding: '0px 8px', borderRadius: '5px', marginLeft: '0px', marginRight: '5px', border: '1px solid lightgrey', marginTop: '2%' }} control={<Radio />} label="Yes" />
                                                        <FormControlLabel value={false} sx={{ backgroundColor: 'white', padding: '0px 8px', borderRadius: '5px', marginLeft: '0px', marginRight: '5px', border: '1px solid lightgrey', marginTop: '2%' }} control={<Radio />} label="No" />
                                                      </RadioGroup>
                                                    </FormControl>
                                                    {
                                                      gridFlag && fieldFormik.values.iv_distance !== 0 &&
                                                      <>
                                                        <TextField
                                                          name="iv_grid_sharing_cost"
                                                          value={fieldFormik.values.iv_grid_sharing_cost}
                                                          type="number"
                                                          sx={{ width: '90%', marginTop: '4%' }}
                                                          fullWidth
                                                          onChange={(e) => {
                                                            fieldFormik.handleChange(e);                  // Formik ke liye
                                                            setGridSharingCost(Number(e.target.value));   // Local state update
                                                          }}
                                                          onBlur={fieldFormik.handleBlur}  // ✅ ye zaroori hai
                                                          className="fieldCoverageMarla"
                                                          error={Boolean(
                                                            fieldFormik.touched.iv_grid_sharing_cost &&
                                                            fieldFormik.errors.iv_grid_sharing_cost
                                                          )}
                                                          helperText={
                                                            fieldFormik.touched.iv_grid_sharing_cost &&
                                                            fieldFormik.errors.iv_grid_sharing_cost
                                                          }
                                                        />
                                                        <p className='form-error'>
                                                          {fieldFormik.errors.iv_grid_sharing_cost && fieldFormik.touched.iv_grid_sharing_cost ? (refNoAllocationFormik.errors.iv_grid_sharing_cost) : null}
                                                        </p>
                                                      </>
                                                    }
                                                  </Grid>

                                                  <Grid item lg={3} sx={{ marginTop: '2%', marginLeft: '1%' }}>
                                                    <Typography className='fieldLabel' >Feeder Rehabilitation Charges applied ?</Typography>
                                                    <FormControl >
                                                      <RadioGroup
                                                        defaultValue={feederRehabFlag}
                                                        value={feederRehabFlag}
                                                        onChange={() => {
                                                          if (feederRehabFlag) {
                                                            setFeederRehabFlag(false)
                                                          } else {
                                                            setFeederRehabFlag(true)
                                                          }
                                                          fieldFormik.values.iv_feeder_rehab_charges = 0
                                                          setFeederRehabilitationCharges()
                                                        }}
                                                        row
                                                      >
                                                        <FormControlLabel value={true} sx={{ backgroundColor: 'white', padding: '0px 8px', borderRadius: '5px', marginLeft: '0px', marginRight: '5px', border: '1px solid lightgrey', marginTop: '2%' }} control={<Radio />} label="Yes" />
                                                        <FormControlLabel value={false} sx={{ backgroundColor: 'white', padding: '0px 8px', borderRadius: '5px', marginLeft: '0px', marginRight: '5px', border: '1px solid lightgrey', marginTop: '2%' }} control={<Radio />} label="No" />
                                                      </RadioGroup>
                                                    </FormControl>
                                                    {
                                                      feederRehabFlag && fieldFormik.values.iv_distance !== 0 &&
                                                      <>
                                                        <TextField
                                                          name="iv_feeder_rehab_charges"
                                                          value={fieldFormik.values.iv_feeder_rehab_charges}
                                                          type="number"
                                                          fullWidth
                                                          sx={{ width: '60%', marginTop: '4%' }}
                                                          onChange={(e) => {
                                                            fieldFormik.handleChange(e);
                                                            setFeederRehabilitationCharges(Number(e.target.value));
                                                          }}
                                                          onBlur={fieldFormik.handleBlur}
                                                          className="fieldCoverageMarla"
                                                          error={Boolean(
                                                            fieldFormik.touched.iv_feeder_rehab_charges &&
                                                            fieldFormik.errors.iv_feeder_rehab_charges
                                                          )}
                                                          helperText={
                                                            fieldFormik.touched.iv_feeder_rehab_charges &&
                                                            fieldFormik.errors.iv_feeder_rehab_charges
                                                          }
                                                        />
                                                        <p className='form-error'>
                                                          {fieldFormik.errors.iv_feeder_rehab_charges && fieldFormik.touched.iv_feeder_rehab_charges ? (refNoAllocationFormik.errors.iv_feeder_rehab_charges) : null}
                                                          {fieldFormik.errors.iv_civil_work_charges && fieldFormik.touched.iv_civil_work_charges ? (refNoAllocationFormik.errors.iv_civil_work_charges) : null}
                                                          {fieldFormik.errors.iv_fixed_charges_of_metering && fieldFormik.touched.iv_fixed_charges_of_metering ? (refNoAllocationFormik.errors.iv_fixed_charges_of_metering) : null}
                                                          {fieldFormik.errors.iv_miscellaneous_charges && fieldFormik.touched.iv_miscellaneous_charges ? (refNoAllocationFormik.errors.iv_miscellaneous_charges) : null}
                                                          {fieldFormik.errors.iv_less_the_cost && fieldFormik.touched.iv_less_the_cost ? (refNoAllocationFormik.errors.iv_less_the_cost) : null}
                                                        </p>
                                                      </>
                                                    }
                                                  </Grid>
                                                </>
                                              }


                                              {
                                                fieldFormik.values.iv_distance == 0 ?
                                                  <>
                                                    <Grid item lg={1.5} sx={{ marginTop: '2%' }}>
                                                      <Typography className="fieldLabel">Est. Distance (m)</Typography>
                                                      <TextField
                                                        name="iv_estimated_distance"
                                                        value={fieldFormik.values.iv_estimated_distance}
                                                        type="number"
                                                        sx={{ width: '85%', marginTop: '2%' }}
                                                        fullWidth
                                                        InputProps={{
                                                          inputProps: { min: minDistance }, // 👈 dynamic check
                                                        }}
                                                        onChange={fieldFormik.handleChange}
                                                        onBlur={fieldFormik.handleBlur}
                                                        className="fieldCoverageMarla1"
                                                      />
                                                      <p className="form-error">
                                                        {fieldFormik.errors.iv_estimated_distance &&
                                                          fieldFormik.touched.iv_estimated_distance
                                                          ? fieldFormik.errors.iv_estimated_distance
                                                          : null}
                                                      </p>
                                                    </Grid>

                                                    <Grid item lg={2} sx={{ marginTop: '2%' }}>
                                                      <Typography className='fieldLabel' >Sketch / Diagram</Typography>
                                                      <Box className='form-error'>
                                                        {fieldFormik.errors.iv_sketch_diagram && fieldFormik.touched.iv_sketch_diagram ? (fieldFormik.errors.iv_sketch_diagram) : null}
                                                      </Box>
                                                      <Box className='form-error'>
                                                        {sketchDiagramError ? (sketchDiagramError) : null}
                                                      </Box>
                                                      {
                                                        sketchDiagramUploaded ?
                                                          <Grid container>
                                                            <Grid item sm={6}>
                                                              <a href="#" onClick={() => openBase64Image(sketchDiagramUploaded)} target='_blank' rel="noreferrer" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2%' }} >
                                                                <img src={sketchDiagramThumbnail} alt="Sketch Diagram" style={{ width: '100%' }} />
                                                              </a>
                                                            </Grid>
                                                            {
                                                              <Grid item sm={6}>
                                                                <Button varient='outlined' component="label" startIcon={<CloseIcon sx={{ color: 'red' }} />} disabled={(dnDetails && dnDetails.filledFlag && dnDetails.filledFlag === 1 && CheckPermissions(permissions, 'General Services', 'New Connection', 'Workflow Permissions', 'Field Survey', 'Survey Form Creation'))} >
                                                                  Change
                                                                  <input hidden accept={documentExtensions} id='iv_sketch_diagram' name='iv_sketch_diagram' type="file" onChange={SketchDiagram} />
                                                                </Button>
                                                              </Grid>
                                                            }
                                                          </Grid>
                                                          :
                                                          sketchDiagram ?
                                                            <>
                                                              <Button varient='contained' component="label" startIcon={<CloseIcon sx={{ color: 'red' }} onClick={() => { setSketchDiagram('') }} />}  >
                                                                {sketchDiagramThumbnail && <img src={sketchDiagramThumbnail} alt="Sketch Diagram" width="100" />}
                                                              </Button>
                                                            </>
                                                            :
                                                            <>
                                                              <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />} sx={{ width: '80%', backgroundColor: 'white', textTransform: 'capitalize', padding: '6%' }} >
                                                                Upload
                                                                <input hidden accept={documentExtensions} id='iv_sketch_diagram' name='iv_sketch_diagram' type="file" onChange={SketchDiagram} />
                                                              </Button>
                                                            </>
                                                      }
                                                    </Grid>

                                                    <Grid item lg={2} sx={{ marginTop: '2%' }}>
                                                      <Typography className='fieldLabel'>Prepare Estimate</Typography>
                                                      <Button
                                                        variant="contained"
                                                        fullWidth
                                                        component="label"
                                                        sx={{ textTransform: 'capitalize' }}
                                                        startIcon={<AddIcon />}
                                                        onClick={() => onPressAddPrepare()}
                                                      >
                                                        Prepare
                                                      </Button>

                                                      {errormessageBoqEstimation && (
                                                        <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                                                          {errormessageBoqEstimation}
                                                        </Typography>
                                                      )}
                                                    </Grid>



                                                  </>
                                                  :
                                                  null
                                              }


                                            </>
                                          } */}

                            {fieldFormik.values.iv_objection_Type ===
                              "No Issue" && (
                                <>
                                  <Grid item lg={12}></Grid>
                                  <Grid item lg={2.5} sx={{ marginTop: "2%" }}>
                                    <Typography className="fieldLabel">
                                      {dialogRowData.applicationId.slice(3, 5) ==
                                        "15"
                                        ? "LT Line within 10 meters"
                                        : "Estimate Lumsum ?"}
                                    </Typography>
                                    <FormControl>
                                      <RadioGroup
                                        defaultValue={
                                          fieldFormik.values.iv_distance
                                        }
                                        value={fieldFormik.values.iv_distance}
                                        name="iv_distance"
                                        onChange={MeterLine}
                                        row
                                      >
                                        <Box
                                          sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                          }}
                                        >
                                          <FormControlLabel
                                            value={1}
                                            sx={{
                                              backgroundColor: "white",
                                              padding: "0px 10px",
                                              borderRadius: "5px",
                                              marginLeft: "0px",
                                              marginRight: "10px",
                                              border: "1px solid lightgrey",
                                              marginTop: "2%",
                                            }}
                                            control={<Radio />}
                                            label="Yes"
                                          />
                                          <FormControlLabel
                                            value={0}
                                            sx={{
                                              backgroundColor: "white",
                                              padding: "0px 10px",
                                              borderRadius: "5px",
                                              border: "1px solid lightgrey",
                                              textAlign: "right",
                                              marginLeft: "2%",
                                              marginTop: "2%",
                                            }}
                                            control={<Radio />}
                                            label="No"
                                          />
                                        </Box>
                                      </RadioGroup>
                                    </FormControl>
                                    <p className="form-error">
                                      {fieldFormik.errors.iv_distance &&
                                        fieldFormik.touched.iv_distance
                                        ? fieldFormik.errors.iv_distance
                                        : null}
                                    </p>
                                  </Grid>
                                  <Grid
                                    item
                                    lg={3.5}
                                    sx={{ marginTop: "2%", marginLeft: "1%" }}
                                  >
                                    <Typography className="fieldLabel">
                                      Meter Type
                                    </Typography>
                                    <FormControl className="form-control">
                                      <RadioGroup
                                        className="radio-group"
                                        row
                                        name="iv_meter_type"
                                        value={fieldFormik.values.iv_meter_type}
                                        onChange={fieldFormik.handleChange}
                                      >
                                        <FormControlLabel
                                          value="1"
                                          control={<Radio />}
                                          label="Smart"
                                          disabled={
                                            dialogRowData?.applicationId?.slice(
                                              3,
                                              5
                                            ) !== "14"
                                          }
                                          sx={{
                                            backgroundColor: "white",
                                            padding: "0px 10px",
                                            borderRadius: "5px",
                                            // marginRight: '10px', // increased slightly
                                            border: "1px solid lightgrey",
                                          }}
                                        />
                                        <FormControlLabel
                                          value="0"
                                          control={<Radio />}
                                          label="Normal"
                                          disabled={
                                            dialogRowData?.applicationId?.slice(
                                              3,
                                              5
                                            ) !== "14"
                                          }
                                          sx={{
                                            backgroundColor: "white",
                                            padding: "0px 10px",
                                            borderRadius: "5px",
                                            marginLeft: "10px", // adds small space
                                            border: "1px solid lightgrey",
                                          }}
                                        />
                                      </RadioGroup>
                                    </FormControl>

                                    {(fieldFormik.touched.iv_meter_type ||
                                      fieldFormik.submitCount > 0) &&
                                      fieldFormik.errors.iv_meter_type && (
                                        <p className="form-error">
                                          {fieldFormik.errors.iv_meter_type}
                                        </p>
                                      )}
                                  </Grid>

                                  {fieldFormik.values.iv_distance == 0 &&
                                    dialogRowData?.applicationId?.slice(3, 5) !=
                                    "14" ? (
                                    <Grid item lg={1.5} sx={{ marginTop: "2%" }}>
                                      <Typography className="fieldLabel">
                                        Est. Distance (m)
                                      </Typography>

                                      <TextField
                                        name="iv_estimated_distance"
                                        value={
                                          fieldFormik.values
                                            .iv_estimated_distance || ""
                                        }
                                        type="number"
                                        sx={{ width: "85%", marginTop: "2%" }}
                                        fullWidth
                                        InputProps={{
                                          inputProps: { min: 0 }, // allow typing freely
                                        }}
                                        onChange={(e) => {
                                          // ✅ Allow user to type or clear freely
                                          fieldFormik.handleChange(e);
                                        }}
                                        onBlur={(e) => {
                                          const value = e.target.value;

                                          // Allow empty value (user clears field)
                                          if (value === "") {
                                            fieldFormik.setFieldValue(
                                              "iv_estimated_distance",
                                              ""
                                            );
                                            fieldFormik.handleBlur(e);
                                            return;
                                          }

                                          const numericValue = Number(value);

                                          // ✅ Only apply rule when iv_distance == 0
                                          if (
                                            fieldFormik.values.iv_distance == 0 &&
                                            numericValue < 41
                                          ) {
                                            fieldFormik.setFieldValue(
                                              "iv_estimated_distance",
                                              41
                                            );
                                          }

                                          fieldFormik.handleBlur(e);
                                        }}
                                        className="fieldCoverageMarla1"
                                      />

                                      <p className="form-error">
                                        {fieldFormik.errors
                                          .iv_estimated_distance &&
                                          fieldFormik.touched.iv_estimated_distance
                                          ? fieldFormik.errors
                                            .iv_estimated_distance
                                          : null}
                                      </p>
                                    </Grid>
                                  ) : (
                                    ((fieldFormik.values.iv_distance == 1 &&
                                      (dialogRowData?.applicationId?.slice(
                                        3,
                                        5
                                      ) == "14" ||
                                        dialogRowData?.applicationId?.slice(
                                          3,
                                          5
                                        ) == "13")) ||
                                      (fieldFormik.values.iv_distance == 0 &&
                                        dialogRowData?.applicationId?.slice(
                                          3,
                                          5
                                        ) == "14")) && (
                                      <Grid
                                        item
                                        lg={1.5}
                                        sx={{ marginTop: "2%" }}
                                      >
                                        <Typography className="fieldLabel">
                                          Est. Distance (m)
                                        </Typography>

                                        <TextField
                                          name="iv_estimated_distance_yes"
                                          value={
                                            fieldFormik.values
                                              .iv_estimated_distance_yes || ""
                                          }
                                          type="number"
                                          sx={{ width: "85%", marginTop: "2%" }}
                                          fullWidth
                                          InputProps={{
                                            inputProps: {
                                              min:
                                                fieldFormik.values.iv_distance ==
                                                  1
                                                  ? 1
                                                  : undefined,
                                              max:
                                                fieldFormik.values.iv_distance ==
                                                  1
                                                  ? dialogRowData?.appliedLoad < 5
                                                    ? 160
                                                    : 40
                                                  : undefined,
                                            },
                                          }}
                                          onChange={(e) => {
                                            const value = e.target.value;

                                            // ✅ Allow empty while typing
                                            fieldFormik.setFieldValue(
                                              "iv_estimated_distance_yes",
                                              value
                                            );
                                          }}
                                          onBlur={(e) => {
                                            const value = e.target.value;
                                            if (value === "") return; // if user clears, don’t auto-set

                                            const numericValue = Number(value);
                                            const isDistanceOne =
                                              fieldFormik.values.iv_distance == 1;

                                            if (isDistanceOne) {
                                              // ✅ For iv_distance == 1 → min/max apply
                                              const min = 1;
                                              const max =
                                                dialogRowData?.appliedLoad < 5
                                                  ? 160
                                                  : 40;

                                              if (numericValue < min) {
                                                fieldFormik.setFieldValue(
                                                  "iv_estimated_distance_yes",
                                                  min
                                                );
                                                return;
                                              }

                                              if (numericValue > max) {
                                                fieldFormik.setFieldValue(
                                                  "iv_estimated_distance_yes",
                                                  max
                                                );
                                                return;
                                              }

                                              fieldFormik.setFieldValue(
                                                "iv_estimated_distance_yes",
                                                numericValue
                                              );
                                            } else {
                                              // ✅ For iv_distance == 0 → only check < 41
                                              if (numericValue < 41) {
                                                fieldFormik.setFieldValue(
                                                  "iv_estimated_distance_yes",
                                                  41
                                                );
                                              } else {
                                                fieldFormik.setFieldValue(
                                                  "iv_estimated_distance_yes",
                                                  numericValue
                                                );
                                              }
                                            }

                                            fieldFormik.handleBlur(e);
                                          }}
                                          className="fieldCoverageMarla1"
                                        />

                                        <p className="form-error">
                                          {fieldFormik.errors
                                            .iv_estimated_distance_yes &&
                                            fieldFormik.touched
                                              .iv_estimated_distance_yes
                                            ? fieldFormik.errors
                                              .iv_estimated_distance_yes
                                            : null}
                                        </p>
                                      </Grid>
                                    )
                                  )}
                                  <Grid item lg={2} sx={{ marginTop: "2%" }}>
                                    <Typography className="fieldLabel">
                                      Sketch / Diagram
                                    </Typography>
                                    <Box className="form-error">
                                      {fieldFormik.errors.iv_sketch_diagram &&
                                        fieldFormik.touched.iv_sketch_diagram
                                        ? fieldFormik.errors.iv_sketch_diagram
                                        : null}
                                    </Box>
                                    <Box className="form-error">
                                      {sketchDiagramError
                                        ? sketchDiagramError
                                        : null}
                                    </Box>
                                    {sketchDiagramUploaded ? (
                                      <Grid container>
                                        <Grid item sm={6}>
                                          <a
                                            href="#"
                                            onClick={() =>
                                              openBase64Image(
                                                sketchDiagramUploaded
                                              )
                                            }
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              marginTop: "2%",
                                            }}
                                          >
                                            <img
                                              src={sketchDiagramThumbnail}
                                              alt="Sketch Diagram"
                                              style={{ width: "100%" }}
                                            />
                                          </a>
                                        </Grid>
                                        {
                                          <Grid item sm={6}>
                                            <Button
                                              varient="outlined"
                                              component="label"
                                              startIcon={
                                                <CloseIcon
                                                  sx={{ color: "red" }}
                                                />
                                              }
                                              disabled={
                                                dnDetails &&
                                                dnDetails.filledFlag &&
                                                dnDetails.filledFlag === 1 &&
                                                CheckPermissions(
                                                  permissions,
                                                  "General Services",
                                                  "New Connection",
                                                  "Workflow Permissions",
                                                  "Field Survey",
                                                  "Survey Form Creation"
                                                )
                                              }
                                            >
                                              Change
                                              <input
                                                hidden
                                                accept={documentExtensions}
                                                id="iv_sketch_diagram"
                                                name="iv_sketch_diagram"
                                                type="file"
                                                onChange={SketchDiagram}
                                              />
                                            </Button>
                                          </Grid>
                                        }
                                      </Grid>
                                    ) : sketchDiagram ? (
                                      <>
                                        <Button
                                          varient="contained"
                                          component="label"
                                          startIcon={
                                            <CloseIcon
                                              sx={{ color: "red" }}
                                              onClick={() => {
                                                setSketchDiagram("");
                                              }}
                                            />
                                          }
                                        >
                                          {sketchDiagramThumbnail && (
                                            <img
                                              src={sketchDiagramThumbnail}
                                              alt="Sketch Diagram"
                                              width="100"
                                            />
                                          )}
                                        </Button>
                                      </>
                                    ) : (
                                      <>
                                        <Button
                                          variant="outlined"
                                          component="label"
                                          startIcon={<FileUploadOutlinedIcon />}
                                          sx={{
                                            width: "80%",
                                            backgroundColor: "white",
                                            textTransform: "capitalize",
                                            padding: "6%",
                                          }}
                                        >
                                          Upload
                                          <input
                                            hidden
                                            accept={documentExtensions}
                                            id="iv_sketch_diagram"
                                            name="iv_sketch_diagram"
                                            type="file"
                                            onChange={SketchDiagram}
                                          />
                                        </Button>
                                      </>
                                    )}
                                  </Grid>

                                  {fieldFormik.values.iv_objection_Type ===
                                    "No Issue" &&
                                    fieldFormik.values.iv_distance == 0 && (
                                      <Grid item lg={2} sx={{ marginTop: "2%" }}>
                                        <Typography className="fieldLabel">
                                          Prepare Estimate
                                        </Typography>
                                        <Button
                                          variant="contained"
                                          fullWidth
                                          component="label"
                                          sx={{ textTransform: "capitalize" }}
                                          startIcon={<AddIcon />}
                                          onClick={() => onPressAddPrepare()}
                                        >
                                          Prepare
                                        </Button>
                                        {errormessageBoqEstimation && (
                                          <Typography
                                            variant="body2"
                                            color="error"
                                            sx={{ mt: 1 }}
                                          >
                                            {errormessageBoqEstimation}
                                          </Typography>
                                        )}
                                      </Grid>
                                    )}
                                </>
                              )}
                            {fieldFormik.values.iv_objection_Type ===
                              "No Issue" &&
                              fieldFormik.values.iv_distance != 0 && (
                                <>
                                  <Grid item lg={2.5} sx={{ marginTop: "2%" }}>
                                    <Typography className="fieldLabel">
                                      Grid Sharing Cost applied ?
                                    </Typography>
                                    <FormControl>
                                      <RadioGroup
                                        defaultValue={gridFlag}
                                        value={gridFlag}
                                        onChange={() => {
                                          if (gridFlag) {
                                            setGridFlag(false);
                                          } else {
                                            setGridFlag(true);
                                          }
                                          fieldFormik.values.iv_grid_sharing_cost = 0;
                                          setGridSharingCost();
                                        }}
                                        row
                                      >
                                        <FormControlLabel
                                          value={true}
                                          sx={{
                                            backgroundColor: "white",
                                            padding: "0px 8px",
                                            borderRadius: "5px",
                                            marginLeft: "0px",
                                            marginRight: "5px",
                                            border: "1px solid lightgrey",
                                            marginTop: "2%",
                                          }}
                                          control={<Radio />}
                                          label="Yes"
                                        />
                                        <FormControlLabel
                                          value={false}
                                          sx={{
                                            backgroundColor: "white",
                                            padding: "0px 8px",
                                            borderRadius: "5px",
                                            marginLeft: "0px",
                                            marginRight: "5px",
                                            border: "1px solid lightgrey",
                                            marginTop: "2%",
                                          }}
                                          control={<Radio />}
                                          label="No"
                                        />
                                      </RadioGroup>
                                    </FormControl>
                                    {gridFlag &&
                                      fieldFormik.values.iv_distance !== 0 && (
                                        <>
                                          <TextField
                                            name="iv_grid_sharing_cost"
                                            value={
                                              fieldFormik.values
                                                .iv_grid_sharing_cost
                                            }
                                            onKeyDown={(e) => {
                                              if (e.key === '.' || e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                                e.preventDefault();
                                              }
                                            }}
                                            type="number"
                                            inputProps={{ min: 0 }}
                                            sx={{
                                              width: "90%",
                                              marginTop: "4%",
                                            }}
                                            fullWidth
                                            onChange={(e) => {
                                              fieldFormik.handleChange(e);
                                              setGridSharingCost(
                                                Number(e.target.value)
                                              );
                                            }}
                                            onBlur={fieldFormik.handleBlur} // ✅ ye zaroori hai
                                            className="fieldCoverageMarla"
                                            error={Boolean(
                                              fieldFormik.touched
                                                .iv_grid_sharing_cost &&
                                              fieldFormik.errors
                                                .iv_grid_sharing_cost
                                            )}
                                            helperText={
                                              fieldFormik.touched
                                                .iv_grid_sharing_cost &&
                                              fieldFormik.errors
                                                .iv_grid_sharing_cost
                                            }
                                          />
                                          <p className="form-error">
                                            {fieldFormik.errors
                                              .iv_grid_sharing_cost &&
                                              fieldFormik.touched
                                                .iv_grid_sharing_cost
                                              ? refNoAllocationFormik.errors
                                                .iv_grid_sharing_cost
                                              : null}
                                          </p>
                                        </>
                                      )}
                                  </Grid>

                                  <Grid
                                    item
                                    lg={3}
                                    sx={{ marginTop: "2%", marginLeft: "1%" }}
                                  >
                                    <Typography className="fieldLabel">
                                      Feeder Rehabilitation Charges applied ?
                                    </Typography>
                                    <FormControl>
                                      <RadioGroup
                                        defaultValue={feederRehabFlag}
                                        value={feederRehabFlag}
                                        onChange={() => {
                                          if (feederRehabFlag) {
                                            setFeederRehabFlag(false);
                                          } else {
                                            setFeederRehabFlag(true);
                                          }
                                          fieldFormik.values.iv_feeder_rehab_charges = 0;
                                          setFeederRehabilitationCharges();
                                        }}
                                        row
                                      >
                                        <FormControlLabel
                                          value={true}
                                          sx={{
                                            backgroundColor: "white",
                                            padding: "0px 8px",
                                            borderRadius: "5px",
                                            marginLeft: "0px",
                                            marginRight: "5px",
                                            border: "1px solid lightgrey",
                                            marginTop: "2%",
                                          }}
                                          control={<Radio />}
                                          label="Yes"
                                        />
                                        <FormControlLabel
                                          value={false}
                                          sx={{
                                            backgroundColor: "white",
                                            padding: "0px 8px",
                                            borderRadius: "5px",
                                            marginLeft: "0px",
                                            marginRight: "5px",
                                            border: "1px solid lightgrey",
                                            marginTop: "2%",
                                          }}
                                          control={<Radio />}
                                          label="No"
                                        />
                                      </RadioGroup>
                                    </FormControl>
                                    {feederRehabFlag &&
                                      fieldFormik.values.iv_distance !== 0 && (
                                        <>
                                          <TextField
                                            name="iv_feeder_rehab_charges"
                                            value={
                                              fieldFormik.values
                                                .iv_feeder_rehab_charges
                                            }
                                            type="number"
                                            fullWidth
                                            inputProps={{ min: 0 }}
                                            sx={{
                                              width: "60%",
                                              marginTop: "4%",
                                            }}
                                            onChange={(e) => {
                                              fieldFormik.handleChange(e);
                                              setFeederRehabilitationCharges(
                                                Number(e.target.value)
                                              );
                                            }}
                                            onKeyDown={(e) => {
                                              if (e.key === '.' || e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                                e.preventDefault();
                                              }
                                            }}
                                            onBlur={fieldFormik.handleBlur}
                                            className="fieldCoverageMarla"
                                            error={Boolean(
                                              fieldFormik.touched
                                                .iv_feeder_rehab_charges &&
                                              fieldFormik.errors
                                                .iv_feeder_rehab_charges
                                            )}
                                            helperText={
                                              fieldFormik.touched
                                                .iv_feeder_rehab_charges &&
                                              fieldFormik.errors
                                                .iv_feeder_rehab_charges
                                            }
                                          />
                                          <p className="form-error">
                                            {fieldFormik.errors
                                              .iv_feeder_rehab_charges &&
                                              fieldFormik.touched
                                                .iv_feeder_rehab_charges
                                              ? refNoAllocationFormik.errors
                                                .iv_feeder_rehab_charges
                                              : null}
                                            {fieldFormik.errors
                                              .iv_civil_work_charges &&
                                              fieldFormik.touched
                                                .iv_civil_work_charges
                                              ? refNoAllocationFormik.errors
                                                .iv_civil_work_charges
                                              : null}
                                            {fieldFormik.errors
                                              .iv_fixed_charges_of_metering &&
                                              fieldFormik.touched
                                                .iv_fixed_charges_of_metering
                                              ? refNoAllocationFormik.errors
                                                .iv_fixed_charges_of_metering
                                              : null}
                                            {fieldFormik.errors
                                              .iv_miscellaneous_charges &&
                                              fieldFormik.touched
                                                .iv_miscellaneous_charges
                                              ? refNoAllocationFormik.errors
                                                .iv_miscellaneous_charges
                                              : null}
                                            {fieldFormik.errors
                                              .iv_less_the_cost &&
                                              fieldFormik.touched.iv_less_the_cost
                                              ? refNoAllocationFormik.errors
                                                .iv_less_the_cost
                                              : null}
                                          </p>
                                        </>
                                      )}
                                  </Grid>

                                  {dialogRowData.appliedLoad > 4 &&
                                    fieldFormik.values.iv_distance != 0 && (
                                      <>
                                        <Grid item lg={2.5} sx={{ marginTop: "2%" }}>
                                          <Typography className="fieldLabel">
                                            M&T Charges
                                          </Typography>
                                          <TextField
                                            name="iv_mnt_charges"
                                            value={fieldFormik.values.iv_mnt_charges}
                                            type="number"
                                            onChange={(e) => {
                                              fieldFormik.handleChange(e);
                                              setMntCharges(e.target.value === "" ? 0 : parseInt(e.target.value) || 0);
                                            }}
                                            onBlur={(e) => {
                                              fieldFormik.handleBlur(e);
                                              setMntCharges(e.target.value === "" ? 0 : parseInt(e.target.value) || 0);
                                            }}
                                            onKeyDown={(e) => {
                                              if (e.key === '.' || e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                                e.preventDefault();
                                              }
                                            }}
                                            sx={{ width: "90%", marginTop: "4%" }}
                                            className="fieldCoverageMarla"
                                            InputProps={{ inputProps: { min: 0, step: 1 } }}
                                          />
                                        </Grid>

                                        <Grid item lg={2.5} sx={{ marginTop: "2%" }}>
                                          <Typography className="fieldLabel">
                                            Labour Charges
                                          </Typography>
                                          <TextField
                                            name="iv_labour_charges"
                                            value={fieldFormik.values.iv_labour_charges}
                                            type="number"
                                            onChange={(e) => {
                                              fieldFormik.handleChange(e);
                                              setLabourCharges(e.target.value === "" ? 0 : parseInt(e.target.value) || 0);
                                            }}
                                            onBlur={(e) => {
                                              fieldFormik.handleBlur(e);
                                              setLabourCharges(e.target.value === "" ? 0 : parseInt(e.target.value) || 0);
                                            }}
                                            onKeyDown={(e) => {
                                              if (e.key === '.' || e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                                e.preventDefault();
                                              }
                                            }}
                                            sx={{ width: "90%", marginTop: "4%" }}
                                            className="fieldCoverageMarla"
                                            InputProps={{ inputProps: { min: 0, step: 1 } }}
                                          />
                                        </Grid>

                                        <Grid item lg={2.5} sx={{ marginTop: "2%" }}>
                                          <Typography className="fieldLabel">
                                            Design Vetting Fee
                                          </Typography>
                                          <TextField
                                            name="iv_design_vetting_fee"
                                            value={fieldFormik.values.iv_design_vetting_fee}
                                            type="number"
                                            onChange={(e) => {
                                              fieldFormik.handleChange(e);
                                              setDesignVettingFee(e.target.value === "" ? 0 : parseInt(e.target.value) || 0);
                                            }}
                                            onBlur={(e) => {
                                              fieldFormik.handleBlur(e);
                                              setDesignVettingFee(e.target.value === "" ? 0 : parseInt(e.target.value) || 0);
                                            }}
                                            onKeyDown={(e) => {
                                              if (e.key === '.' || e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                                e.preventDefault();
                                              }
                                            }}
                                            sx={{ width: "90%", marginTop: "4%" }}
                                            className="fieldCoverageMarla"
                                            InputProps={{ inputProps: { min: 0, step: 1 } }}
                                          />
                                        </Grid>

                                        <Grid item lg={2.5} sx={{ marginTop: "2%" }}>
                                          <Typography className="fieldLabel">
                                            Consultancy Charges
                                          </Typography>
                                          <TextField
                                            name="iv_consultancy_charges"
                                            value={fieldFormik.values.iv_consultancy_charges}
                                            type="number"
                                            onChange={(e) => {
                                              fieldFormik.handleChange(e);
                                              setConsultancyCharges(e.target.value === "" ? 0 : parseInt(e.target.value) || 0);
                                            }}
                                            onBlur={(e) => {
                                              fieldFormik.handleBlur(e);
                                              setConsultancyCharges(e.target.value === "" ? 0 : parseInt(e.target.value) || 0);
                                            }}
                                            onKeyDown={(e) => {
                                              if (e.key === '.' || e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                                e.preventDefault();
                                              }
                                            }}
                                            sx={{ width: "90%", marginTop: "4%" }}
                                            className="fieldCoverageMarla"
                                            InputProps={{ inputProps: { min: 0, step: 1 } }}
                                          />
                                        </Grid>

                                        <Grid item lg={2.5} sx={{ marginTop: "2%" }}>
                                          <Typography className="fieldLabel">
                                            Variation Charges
                                          </Typography>
                                          <TextField
                                            name="iv_variation_charges"
                                            value={fieldFormik.values.iv_variation_charges}
                                            type="number"
                                            onChange={(e) => {
                                              fieldFormik.handleChange(e);
                                              setVariationCharges(e.target.value === "" ? 0 : parseInt(e.target.value) || 0);
                                            }}
                                            onBlur={(e) => {
                                              fieldFormik.handleBlur(e);
                                              setVariationCharges(e.target.value === "" ? 0 : parseInt(e.target.value) || 0);
                                            }}
                                            onKeyDown={(e) => {
                                              if (e.key === '.' || e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                                e.preventDefault();
                                              }
                                            }}
                                            sx={{ width: "90%", marginTop: "4%" }}
                                            className="fieldCoverageMarla"
                                            InputProps={{ inputProps: { min: 0, step: 1 } }}
                                          />
                                        </Grid>

                                        <Grid item lg={2.5} sx={{ marginTop: "2%" }}>
                                          <Typography className="fieldLabel">
                                            Dismantlement Charges
                                          </Typography>
                                          <TextField
                                            name="iv_dismantlement_charges"
                                            value={fieldFormik.values.iv_dismantlement_charges}
                                            type="number"
                                            onChange={(e) => {
                                              fieldFormik.handleChange(e);
                                              setDismantlementCharges(e.target.value === "" ? 0 : parseInt(e.target.value) || 0);
                                            }}
                                            onBlur={(e) => {
                                              fieldFormik.handleBlur(e);
                                              setDismantlementCharges(e.target.value === "" ? 0 : parseInt(e.target.value) || 0);
                                            }}
                                            onKeyDown={(e) => {
                                              if (e.key === '.' || e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                                e.preventDefault();
                                              }
                                            }}
                                            sx={{ width: "90%", marginTop: "4%" }}
                                            className="fieldCoverageMarla"
                                            InputProps={{ inputProps: { min: 0, step: 1 } }}
                                          />
                                        </Grid>

                                        <Grid item lg={2.5} sx={{ marginTop: "2%" }}>
                                          <Typography className="fieldLabel">
                                            Earthing Charges
                                          </Typography>
                                          <TextField
                                            name="iv_earthing_charges"
                                            value={fieldFormik.values.iv_earthing_charges}
                                            type="number"
                                            onChange={(e) => {
                                              fieldFormik.handleChange(e);
                                              setEarthingCharges(e.target.value === "" ? 0 : parseInt(e.target.value) || 0);
                                            }}
                                            onBlur={(e) => {
                                              fieldFormik.handleBlur(e);
                                              setEarthingCharges(e.target.value === "" ? 0 : parseInt(e.target.value) || 0);
                                            }}
                                            onKeyDown={(e) => {
                                              if (e.key === '.' || e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                                e.preventDefault();
                                              }
                                            }}
                                            sx={{ width: "90%", marginTop: "4%" }}
                                            className="fieldCoverageMarla"
                                            InputProps={{ inputProps: { min: 0, step: 1 } }}
                                          />
                                        </Grid>
                                      </>
                                    )}

                                </>
                              )}
                            {dialogRowData?.applicationId?.slice(3, 5) ==
                              "14" &&
                              fieldFormik.values.iv_meter_type == 1 &&
                              fieldFormik.values.iv_distance != 0 &&
                              fieldFormik.values.iv_objection_Type ===
                              "No Issue" && (
                                <Grid item lg={2.5} sx={{ marginTop: "2%" }}>
                                  <Typography className="fieldLabel">
                                    Select Cable
                                  </Typography>
                                  <Select
                                    value={fieldFormik.values.iv_select_cable}
                                    onChange={fieldFormik.handleChange}
                                    onBlur={fieldFormik.handleBlur}
                                    className="fieldBatch"
                                    name="iv_select_cable"
                                    id="iv_select_cable"
                                    sx={{ width: "120%" }}
                                  >
                                    {(() => {
                                      // Allowed codes array
                                      const allowedCodes = [
                                        // "14221",
                                        "14241",
                                        "14252",
                                        // '14254',
                                        "14253",
                                      ];

                                      // Filter API items based on allowed codes
                                      const filteredItems =
                                        allMaterialList.filter((item) =>
                                          allowedCodes.includes(String(item.item_Code))
                                        );

                                      return filteredItems.map((item) => (
                                        <MenuItem
                                          key={item.item_Code}
                                          value={item.item_Code}
                                        >
                                          {item.item_Code} — {item.item_Name}
                                        </MenuItem>
                                      ));
                                    })()}
                                  </Select>
                                  <Box className="from-Error">
                                    {fieldFormik.touched.iv_select_cable &&
                                      fieldFormik.errors.iv_select_cable && (
                                        <Typography
                                          sx={{
                                            color: "red",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {fieldFormik.errors.iv_select_cable}
                                        </Typography>
                                      )}
                                  </Box>
                                </Grid>
                              )}
                          </Grid>
                        </>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            Field Survey is in process by the sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 3 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <h3 className="step-title">Field Survey Objection</h3>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "New Connection",
                        "Workflow Permissions",
                        "Field Survey"
                      ) ? (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            {dialogRowData.remarks}{" "}
                          </p>
                        </div>
                      ) : (
                        <>
                          <div className="description-box">
                            <p className="group-description">
                              <InfoIcon className="icon" />
                              The application has been objected at field survey
                              stage. : {dialogRowData.remarks}{" "}
                            </p>
                          </div>
                          {dialogRowData.remarks ===
                            "Load at site exceeds than applied." &&
                            CheckPermissions(
                              permissions,
                              "General Services",
                              "New Connection",
                              "Basic Permissions",
                              "Update"
                            ) && (
                              <>
                                <Grid
                                  container
                                  spacing={2}
                                  className="field-survey-container"
                                >
                                  <Grid item lg={3}>
                                    <Typography className="fieldLabel">
                                      Update Applied Load
                                    </Typography>
                                    <TextField
                                      required
                                      type="number"
                                      InputProps={{
                                        inputProps: {
                                          min: dialogRowData.appliedLoad,
                                        },
                                      }}
                                      autoComplete="off"
                                      name="iv_applied_load"
                                      value={
                                        appliedLoadFormik.values.iv_applied_load
                                      }
                                      onChange={appliedLoadFormik.handleChange}
                                      onBlur={appliedLoadFormik.handleBlur}
                                      id="iv_applied_load"
                                      className="fieldReferenceNo"
                                    />
                                    <Box className="form-error">
                                      {appliedLoadFormik.errors
                                        .iv_applied_load &&
                                        appliedLoadFormik.touched.iv_applied_load
                                        ? appliedLoadFormik.errors
                                          .iv_applied_load
                                        : null}
                                    </Box>
                                  </Grid>
                                </Grid>
                              </>
                            )}
                        </>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 4 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <h3 className="step-title">
                        Reference Number Allocation
                      </h3>
                      {(CheckPermissions(
                        permissions,
                        "General Services",
                        "New Connection",
                        "Workflow Permissions",
                        "Reference No. Allocation"
                      ) &&
                        ((!dnDetails || dnDetails.filledFlag !== 1) ||
                          CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Demand Note Approval"
                          )) &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "New Connection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "15"
                        ) &&
                          dialogRowData.appliedLoad > 0 &&
                          dialogRowData.appliedLoad <= 15 &&
                          ((CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A1"
                          ) &&
                            allTariffList &&
                            getTariff(
                              dialogRowData.appliedLoad,
                              dialogRowData.connectionType,
                              dialogRowData.seasonalNonSeasonalFlag,
                              allTariffList
                            )?.startsWith("A1")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "New Connection",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A2"
                            ) &&
                              allTariffList &&
                              getTariff(
                                dialogRowData.appliedLoad,
                                dialogRowData.connectionType,
                                dialogRowData.seasonalNonSeasonalFlag,
                                allTariffList
                              )?.startsWith("A2")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "New Connection",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A3"
                            ) &&
                              allTariffList &&
                              getTariff(
                                dialogRowData.appliedLoad,
                                dialogRowData.connectionType,
                                dialogRowData.seasonalNonSeasonalFlag,
                                allTariffList
                              )?.startsWith("A3")))) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "70"
                          ) &&
                            dialogRowData.appliedLoad > 0 &&
                            dialogRowData.appliedLoad <= 70 &&
                            // ✅ Tariff A1, A2, A3 nahi hone chahiye
                            !["A1", "A2", "A3"].some((tariffCode) =>
                              getTariff(
                                dialogRowData.appliedLoad,
                                dialogRowData.connectionType,
                                dialogRowData.seasonalNonSeasonalFlag,
                                allTariffList
                              )
                                ?.toUpperCase()
                                .startsWith(tariffCode)
                            )) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "70"
                          ) &&
                            dialogRowData.appliedLoad > 15 &&
                            dialogRowData.appliedLoad <= 70) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "500"
                          ) &&
                            dialogRowData.appliedLoad > 70 &&
                            dialogRowData.appliedLoad <= 500) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "5000"
                          ) &&
                            dialogRowData.appliedLoad > 500))) ? (
                        <>
                          {dnDetails &&
                            dnDetails.filledFlag &&
                            dnDetails.filledFlag === 1 && (
                              <>
                                <Grid
                                  container
                                  className="dn-payment-submission-container"
                                >
                                  {/* <Grid item lg={3} className='item'>
                                                    <Typography className='title'>Demand Notice No.</Typography>
                                                    <Typography className='value'>{dnDetails.demandNoticeNo ? dnDetails.demandNoticeNo : '-'}</Typography>
                                                  </Grid>
                                                  <Grid item lg={3} className='item'>
                                                    <Typography className='title'>Reference No.</Typography>
                                                    <Typography className='value'>{dnDetails.connectionAccountNo ? dnDetails.connectionAccountNo : '-'}</Typography>
                                                  </Grid> */}
                                  {/* <Grid item lg={3} className='item'>
                                                <Typography className='title'>Issue Date</Typography>
                                                <Typography className='value'>{dnDetails.issueDate ? convertDate(dnDetails.issueDate) : '-'}</Typography>
                                              </Grid>
                                              <Grid item lg={3} className='item'>
                                                <Typography className='title'>Due Date</Typography>
                                                <Typography className='value'>{dnDetails.dueDate ? convertDate(dnDetails.dueDate) : '-'}</Typography>
                                              </Grid> */}
                                  <Grid item lg={3} className="item">
                                    <Typography className="title">
                                      Capital Cost
                                    </Typography>
                                    <Typography className="value">
                                      {dnDetails.capitalCostAmount
                                        ? numberFormatting(
                                          dnDetails.capitalCostAmount
                                        )
                                        : "-"}
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={3} className="item">
                                    <Typography className="title">
                                      Security Cost
                                    </Typography>
                                    <Typography className="value">
                                      {dnDetails.securityDepositeAmount
                                        ? numberFormatting(
                                          dnDetails.securityDepositeAmount
                                        )
                                        : "-"}
                                    </Typography>
                                  </Grid>
                                  {Number(dnDetails.amountOfGridSharing) !== 0 && (
                                    <Grid item lg={3} className="item">
                                      <Typography className="title">
                                        Grid Sharing Cost
                                      </Typography>
                                      <Typography className="value">
                                        {dnDetails.amountOfGridSharing
                                          ? numberFormatting(
                                            dnDetails.amountOfGridSharing
                                          )
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                  )}
                                  {Number(dnDetails.amountOfFeederRehab) !== 0 && (
                                    <Grid item lg={3} className="item">
                                      <Typography className="title">
                                        Feeder Rehabilitation Cost
                                      </Typography>
                                      <Typography className="value">
                                        {dnDetails.amountOfFeederRehab
                                          ? numberFormatting(
                                            dnDetails.amountOfFeederRehab
                                          )
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                  )}

                                  {
                                    Number(dnDetails.civilWorkCharges) !== 0 && (
                                      <Grid item lg={3} className="item">
                                        <Typography className="title">
                                          Civil Work Charges
                                        </Typography>
                                        <Typography className="value">
                                          {dnDetails.civilWorkCharges
                                            ? numberFormatting(
                                              dnDetails.civilWorkCharges
                                            )
                                            : "-"}
                                        </Typography>
                                      </Grid>
                                    )
                                  }
                                  {
                                    Number(dnDetails.miscellaneousCharges) !== 0 && (
                                      <Grid item lg={3} className="item">
                                        <Typography className="title">
                                          Miscellaneous Charges
                                        </Typography>
                                        <Typography className="value">
                                          {dnDetails.miscellaneousCharges
                                            ? numberFormatting(
                                              dnDetails.miscellaneousCharges
                                            )
                                            : "-"}
                                        </Typography>
                                      </Grid>
                                    )
                                  }
                                  {
                                    Number(dnDetails.fixedChargesOfMetering) !== 0 && (
                                      <Grid item lg={3} className="item">
                                        <Typography className="title">
                                          Fixed Charges Of Metering
                                        </Typography>
                                        <Typography className="value">
                                          {dnDetails.fixedChargesOfMetering
                                            ? numberFormatting(
                                              dnDetails.fixedChargesOfMetering
                                            )
                                            : "-"}
                                        </Typography>
                                      </Grid>
                                    )
                                  }
                                  {
                                    Number(dnDetails.mtCharges) !== 0 && (
                                      <Grid item lg={3} className="item">
                                        <Typography className="title">
                                          M&T Charges
                                        </Typography>
                                        <Typography className="value">
                                          {dnDetails.mtCharges
                                            ? numberFormatting(
                                              dnDetails.mtCharges
                                            )
                                            : "-"}
                                        </Typography>
                                      </Grid>
                                    )
                                  }
                                  {
                                    Number(dnDetails.labourCharges) !== 0 && (
                                      <Grid item lg={3} className="item">
                                        <Typography className="title">
                                          Labour Charges
                                        </Typography>
                                        <Typography className="value">
                                          {dnDetails.labourCharges
                                            ? numberFormatting(
                                              dnDetails.labourCharges
                                            )
                                            : "-"}
                                        </Typography>
                                      </Grid>
                                    )
                                  }

                                  {
                                    Number(dnDetails.designVetteingFee) !== 0 && (
                                      <Grid item lg={3} className="item">
                                        <Typography className="title">
                                          Design Vetting fee
                                        </Typography>
                                        <Typography className="value">
                                          {dnDetails.designVetteingFee
                                            ? numberFormatting(
                                              dnDetails.designVetteingFee
                                            )
                                            : "-"}
                                        </Typography>
                                      </Grid>
                                    )
                                  }

                                  {
                                    Number(dnDetails.variationsCharges) !== 0 && (
                                      <Grid item lg={3} className="item">
                                        <Typography className="title">
                                          Variation Charges
                                        </Typography>
                                        <Typography className="value">
                                          {dnDetails.variationsCharges
                                            ? numberFormatting(
                                              dnDetails.variationsCharges
                                            )
                                            : "-"}
                                        </Typography>
                                      </Grid>
                                    )
                                  }
                                  {
                                    Number(dnDetails.consultancyCharges) !== 0 && (
                                      <Grid item lg={3} className="item">
                                        <Typography className="title">
                                          Consultancy Charges
                                        </Typography>
                                        <Typography className="value">
                                          {dnDetails.consultancyCharges
                                            ? numberFormatting(
                                              dnDetails.consultancyCharges
                                            )
                                            : "-"}
                                        </Typography>
                                      </Grid>
                                    )
                                  }


                                  {
                                    Number(dnDetails.dismentalmentCharges) !== 0 && (
                                      <Grid item lg={3} className="item">
                                        <Typography className="title">
                                          DismentalmentCharges
                                        </Typography>
                                        <Typography className="value">
                                          {dnDetails.dismentalmentCharges
                                            ? numberFormatting(
                                              dnDetails.dismentalmentCharges
                                            )
                                            : "-"}
                                        </Typography>
                                      </Grid>
                                    )
                                  }

                                  {
                                    Number(dnDetails.earthingCharges) !== 0 && (
                                      <Grid item lg={3} className="item">
                                        <Typography className="title">
                                          Earthing Charges
                                        </Typography>
                                        <Typography className="value">
                                          {dnDetails.earthingCharges
                                            ? numberFormatting(
                                              dnDetails.earthingCharges
                                            )
                                            : "-"}
                                        </Typography>
                                      </Grid>
                                    )
                                  }

                                  <Grid item lg={3} className="item">
                                    <Typography className="title">
                                      Total Cost
                                    </Typography>
                                    <Typography className="value">
                                      {dnDetails.capitalCostAmount ||
                                        dnDetails.securityDepositeAmount
                                        ? numberFormatting(
                                          parseInt(
                                            dnDetails.capitalCostAmount
                                          ) +
                                          parseInt(
                                            dnDetails.securityDepositeAmount
                                          ) +
                                          (!isNaN(
                                            parseInt(
                                              dnDetails.amountOfGridSharing
                                            )
                                          )
                                            ? parseInt(
                                              dnDetails.amountOfGridSharing
                                            )
                                            : 0) +
                                          (!isNaN(
                                            parseInt(
                                              dnDetails.amountOfFeederRehab
                                            )
                                          )
                                            ? parseInt(
                                              dnDetails.amountOfFeederRehab
                                            )
                                            : 0) +
                                          (!isNaN(parseInt(dnDetails.miscellaneousCharges)) ? parseInt(dnDetails.miscellaneousCharges) : 0) +
                                          (!isNaN(parseInt(dnDetails.fixedChargesOfMetering)) ? parseInt(dnDetails.fixedChargesOfMetering) : 0) +

                                          (!isNaN(parseInt(dnDetails.civilWorkCharges)) ? parseInt(dnDetails.civilWorkCharges) : 0) +
                                          (!isNaN(parseInt(dnDetails.mtCharges)) ? parseInt(dnDetails.mtCharges) : 0) +
                                          (!isNaN(parseInt(dnDetails.labourCharges)) ? parseInt(dnDetails.labourCharges) : 0) +
                                          (!isNaN(parseInt(dnDetails.designVetteingFee)) ? parseInt(dnDetails.designVetteingFee) : 0) +
                                          (!isNaN(parseInt(dnDetails.consultancyCharges)) ? parseInt(dnDetails.consultancyCharges) : 0) +
                                          (!isNaN(parseInt(dnDetails.variationsCharges)) ? parseInt(dnDetails.variationsCharges) : 0) +
                                          (!isNaN(parseInt(dnDetails.dismentalmentCharges)) ? parseInt(dnDetails.dismentalmentCharges) : 0) +
                                          (!isNaN(parseInt(dnDetails.earthingCharges)) ? parseInt(dnDetails.earthingCharges) : 0)
                                        )
                                        : "-"}
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={3} className="item">
                                    <Typography className="title">
                                      Bank Name
                                    </Typography>
                                    <Typography className="value">
                                      {dnDetails.bankName
                                        ? dnDetails.bankName
                                        : "-"}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </>
                            )}

                          <Grid
                            container
                            spacing={2}
                            className="field-survey-container"
                          >
                            <Grid item lg={2.5}>
                              <Typography className="fieldLabel">
                                Feeder
                              </Typography>
                              <Select
                                sx={{ width: "100%" }}
                                value={
                                  refNoAllocationFormik.values.iv_feeder_no
                                }
                                onChange={refNoAllocationFormik.handleChange}
                                onBlur={refNoAllocationFormik.handleBlur}
                                displayEmpty
                                className="fieldBatch"
                                name="iv_feeder_no"
                                id="iv_feeder_no"
                                disabled={
                                  dnDetails && dnDetails.filledFlag === 1
                                } // 👈 direct condition
                                MenuProps={{
                                  PaperProps: {
                                    style: {
                                      height: 180,
                                      width: 35,
                                    },
                                  },
                                }}
                              >
                                <MenuItem value="" sx={{ fontSize: "12px" }}>
                                  Select feeder
                                </MenuItem>
                                {(allFeedersList || []).map((option) => (
                                  <MenuItem
                                    sx={{ fontSize: "12px" }}
                                    key={option.FEEDERCODE}
                                    value={option.FEEDERCODE}
                                  >
                                    {option.FEEDERNAME}
                                  </MenuItem>
                                ))}
                              </Select>
                              <p className="form-error">
                                {refNoAllocationFormik.errors.iv_feeder_no &&
                                  refNoAllocationFormik.touched.iv_feeder_no
                                  ? refNoAllocationFormik.errors.iv_feeder_no
                                  : null}
                              </p>
                            </Grid>

                            <Grid item lg={4}>
                              <Typography className="fieldLabel">
                                Allot Reference No.
                              </Typography>
                              <Grid container spacing={1} display="flex">
                                <Grid item lg={4.5}>
                                  <Select
                                    sx={{ width: "100%" }}
                                    value={
                                      refNoAllocationFormik.values.iv_batch
                                    }
                                    onChange={
                                      refNoAllocationFormik.handleChange
                                    }
                                    onBlur={refNoAllocationFormik.handleBlur}
                                    displayEmpty
                                    className="fieldBatch"
                                    name="iv_batch"
                                    id="iv_batch"
                                    disabled={
                                      dnDetails && dnDetails.filledFlag === 1
                                    } // 👈 direct
                                    MenuProps={{
                                      PaperProps: {
                                        style: {
                                          width: 20,
                                          height: 180,
                                        },
                                      },
                                    }}
                                  >
                                    <MenuItem
                                      value=""
                                      sx={{ fontSize: "12px" }}
                                    >
                                      Batch
                                    </MenuItem>
                                    {batchArray.map((option) => (
                                      <MenuItem
                                        key={option}
                                        value={option}
                                        sx={{ fontSize: "12px" }}
                                      >
                                        {option}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  <Box className="form-error">
                                    {refNoAllocationFormik.errors.iv_batch &&
                                      refNoAllocationFormik.touched.iv_batch
                                      ? refNoAllocationFormik.errors.iv_batch
                                      : null}
                                  </Box>
                                </Grid>

                                <Grid item lg={7.5}>
                                  <TextField
                                    name="iv_reference_to_allot"
                                    value={
                                      refNoAllocationFormik.values
                                        .iv_reference_to_allot
                                    }
                                    fullWidth
                                    onChange={
                                      refNoAllocationFormik.handleChange
                                    }
                                    onBlur={refNoAllocationFormik.handleBlur}
                                    type="text"
                                    sx={{ width: "100%" }}
                                    inputProps={{
                                      maxLength: 7,
                                      readOnly:
                                        dnDetails && dnDetails.filledFlag === 1, // 👈 direct
                                    }}
                                    disabled={
                                      dnDetails && dnDetails.filledFlag === 1
                                    } // 👈 direct
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment
                                          position="start"
                                          sx={{ fontSize: "12px" }}
                                          style={{ background: "#F2F4F6" }}
                                        >
                                          {partialValue}
                                        </InputAdornment>
                                      ),
                                    }}
                                    className="fieldCoverageMarla"
                                  />
                                  <Box className="form-error">
                                    {refNoAllocationFormik.errors
                                      .iv_reference_to_allot &&
                                      refNoAllocationFormik.touched
                                        .iv_reference_to_allot
                                      ? refNoAllocationFormik.errors
                                        .iv_reference_to_allot
                                      : null}
                                  </Box>
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item lg={2}>
                              <Typography className="fieldLabel">
                                Sub Batch
                              </Typography>
                              <Select
                                sx={{ width: "100%" }}
                                value={
                                  refNoAllocationFormik.values.iv_sub_batch
                                }
                                onChange={refNoAllocationFormik.handleChange}
                                onBlur={refNoAllocationFormik.handleBlur}
                                displayEmpty
                                className="fieldBatch"
                                name="iv_sub_batch"
                                id="iv_sub_batch"
                                disabled={
                                  dnDetails && dnDetails.filledFlag === 1
                                } // 👈 direct
                                MenuProps={{
                                  PaperProps: {
                                    style: {
                                      width: 20,
                                      height: 180,
                                    },
                                  },
                                }}
                              >
                                <MenuItem value="" sx={{ fontSize: "12px" }}>
                                  Select Sub Batch
                                </MenuItem>
                                {subBatchArray.map((option) => (
                                  <MenuItem
                                    key={option}
                                    value={option}
                                    sx={{ fontSize: "12px" }}
                                  >
                                    {option}
                                  </MenuItem>
                                ))}
                              </Select>
                              <p className="form-error">
                                {refNoAllocationFormik.errors.iv_sub_batch &&
                                  refNoAllocationFormik.touched.iv_sub_batch
                                  ? refNoAllocationFormik.errors.iv_sub_batch
                                  : null}
                              </p>
                            </Grid>

                            {/* <Grid item lg={2}>
                                                <Typography className='fieldLabel'>Tariff</Typography>
                                                {dialogRowData.connectionType != 'Industrial' ? (
                                                  <TextField
                                                    value={tariff}
                                                    fullWidth
                                                    disabled={true} // already disabled since non-industrial
                                                    name="iv_tariff_to_allot"
                                                    id="iv_tariff_to_allot"
                                                    className='fieldCoverageMarla'
                                                  />
                                                ) : (
                                                  <Select
                                                    sx={{ width: '100%' }}
                                                    value={tariff}
                                                    onChange={(e) => {
                                                      refNoAllocationFormik.handleChange(e);
                                                      setTariff(e.target.value);
                                                    }}
                                                    onBlur={refNoAllocationFormik.handleBlur}
                                                    displayEmpty
                                                    disabled={dnDetails && dnDetails.filledFlag === 1} // 👈 direct
                                                    className='fieldBatch'
                                                    name="iv_tariff_to_allot"
                                                    id="iv_tariff_to_allot"
                                                    MenuProps={{
                                                      PaperProps: {
                                                        style: {
                                                          width: 20,
                                                          height: 180
                                                        }
                                                      }
                                                    }}
                                                  >
                                                    <MenuItem value='' sx={{ fontSize: '12px' }}>Select Tariff</MenuItem>
                                                    {shortListIndustrialTariff.map(option => (
                                                      <MenuItem key={option.tariffName} value={option.tariffName} sx={{ fontSize: '12px' }}>
                                                        {option.tariffName}
                                                      </MenuItem>
                                                    ))}
                                                  </Select>
                                                )}
                                                <Box className='form-error'>
                                                  {refNoAllocationFormik.errors.iv_tariff_to_allot &&
                                                    refNoAllocationFormik.touched.iv_tariff_to_allot
                                                    ? refNoAllocationFormik.errors.iv_tariff_to_allot
                                                    : null}
                                                </Box>
                                              </Grid> */}

                            {(dialogRowData.connectionType === "industrial" ||
                              dialogRowData.connectionType ===
                              "Industrial") && (
                                <Grid item lg={3} sx={{ marginTop: "2%" }}>
                                  <Typography className="fieldLabel">
                                    Industry / Factory Type
                                  </Typography>
                                  <FormControl>
                                    <RadioGroup
                                      defaultValue={industryFlag}
                                      value={industryFlag}
                                      onChange={() =>
                                        setIndustryFlag(!industryFlag)
                                      }
                                      row
                                    >
                                      <FormControlLabel
                                        value={true}
                                        control={
                                          <Radio
                                            disabled={
                                              dnDetails &&
                                              dnDetails.filledFlag === 1
                                            }
                                          />
                                        } // 👈 direct
                                        label="Yes"
                                      />
                                      <FormControlLabel
                                        value={false}
                                        control={
                                          <Radio
                                            disabled={
                                              dnDetails &&
                                              dnDetails.filledFlag === 1
                                            }
                                          />
                                        } // 👈 direct
                                        label="No"
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                  {industryFlag && (
                                    <>
                                      <TextField
                                        name="iv_industry_factory_type"
                                        value={
                                          refNoAllocationFormik.values
                                            .iv_industry_factory_type
                                        }
                                        type="text"
                                        fullWidth
                                        sx={{ width: "70%", marginTop: "4%" }}
                                        onChange={
                                          refNoAllocationFormik.handleChange
                                        }
                                        onBlur={refNoAllocationFormik.handleBlur}
                                        inputProps={{
                                          readOnly:
                                            dnDetails &&
                                            dnDetails.filledFlag === 1, // 👈 direct
                                        }}
                                        disabled={
                                          dnDetails && dnDetails.filledFlag === 1
                                        } // 👈 direct
                                        className="fieldCoverageMarla"
                                      />
                                      <p className="form-error">
                                        {refNoAllocationFormik.errors
                                          .iv_industry_factory_type &&
                                          refNoAllocationFormik.touched
                                            .iv_industry_factory_type
                                          ? refNoAllocationFormik.errors
                                            .iv_industry_factory_type
                                          : null}
                                      </p>
                                    </>
                                  )}
                                </Grid>
                              )}

                            {(dialogRowData.connectionType === "industrial" ||
                              dialogRowData.connectionType ===
                              "Industrial") && (
                                <Grid item lg={4}>
                                  <FormControl className="form-control">
                                    <RadioGroup
                                      className="radio-group"
                                      row
                                      name="iv_seasonal_flag"
                                      value={
                                        scoPart2Formik.values.iv_seasonal_flag
                                      }
                                      onChange={SeasonalNonSeasonal}
                                    >
                                      <FormControlLabel
                                        value={1}
                                        control={<Radio disabled={true} />}
                                        label="Seasonal"
                                      />
                                      <FormControlLabel
                                        value={0}
                                        control={<Radio disabled={true} />}
                                        label="Non-Seasonal"
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                  <p className="form-error">
                                    {scoPart2Formik.errors.iv_seasonal_flag &&
                                      scoPart2Formik.touched.iv_seasonal_flag
                                      ? scoPart2Formik.errors.iv_seasonal_flag
                                      : null}
                                  </p>
                                </Grid>
                              )}

                            {(CheckPermissions(
                              permissions,
                              "General Services",
                              "New Connection",
                              "Workflow Permissions",
                              "Meter Installation",
                              "SCO P1 Creation"
                            ) ||
                              CheckPermissions(
                                permissions,
                                "General Services",
                                "New Connection",
                                "Workflow Permissions",
                                "Meter Installation",
                                "SCO P1 Approval"
                              )) && (
                                <>
                                  <Grid
                                    container
                                    spacing={2}
                                    className="field-survey-container"
                                  >
                                    <Grid item lg={3}>
                                      <FormGroup
                                        className="radio-group"
                                        row
                                        name="iv_cantonment_board"
                                      >
                                        <FormControlLabel
                                          value={"CB"}
                                          control={
                                            <Checkbox
                                              disabled={
                                                dnDetails &&
                                                dnDetails.filledFlag === 1
                                              }
                                            />
                                          } // 👈 direct
                                          label="Cantonment Board"
                                          checked={
                                            refNoAllocationFormik.values
                                              .iv_cantonment_board === "CB"
                                          }
                                          onChange={Contanment}
                                        />
                                      </FormGroup>
                                    </Grid>

                                    <Grid item lg={4}>
                                      <FormGroup
                                        className="radio-group"
                                        row
                                        name="iv_fgovt"
                                      >
                                        <FormControlLabel
                                          value={"F"}
                                          control={
                                            <Checkbox
                                              disabled={
                                                dnDetails &&
                                                dnDetails.filledFlag === 1
                                              } // 👈 direct
                                              checked={
                                                refNoAllocationFormik.values
                                                  .iv_fgovt === "F"
                                              }
                                              onChange={FGovt}
                                            />
                                          }
                                          label="F.Gov / A. & L.Bodies under F.Govt"
                                        />
                                      </FormGroup>
                                    </Grid>

                                    <Grid item lg={5}>
                                      <FormGroup
                                        className="radio-group"
                                        row
                                        name="iv_pgovt"
                                      >
                                        <FormControlLabel
                                          value={"PG"}
                                          control={
                                            <Checkbox
                                              disabled={
                                                dnDetails &&
                                                dnDetails.filledFlag === 1
                                              }
                                            />
                                          } // 👈 direct
                                          label="P.Gov / A. & L.Bodies under P.Govt"
                                          checked={
                                            refNoAllocationFormik.values
                                              .iv_pgovt === "PG"
                                          }
                                          onChange={PGovt}
                                        />
                                      </FormGroup>
                                    </Grid>

                                    <Grid item lg={4}>
                                      <FormGroup
                                        className="radio-group"
                                        row
                                        name="iv_local_bodies"
                                      >
                                        <FormControlLabel
                                          value={"LB"}
                                          control={
                                            <Checkbox
                                              disabled={
                                                dnDetails &&
                                                dnDetails.filledFlag === 1
                                              }
                                            />
                                          } // 👈 direct
                                          label="Local Bodies"
                                          checked={
                                            refNoAllocationFormik.values
                                              .iv_local_bodies === "LB"
                                          }
                                          onChange={LocalBodies}
                                        />
                                      </FormGroup>
                                    </Grid>

                                    {(refNoAllocationFormik.values.iv_pgovt ||
                                      refNoAllocationFormik.values.iv_fgovt) && (
                                        <Grid item lg={4}>
                                          <Typography className="fieldLabel">
                                            Govt. Dept. Code
                                          </Typography>
                                          <Autocomplete
                                            id="iv_govt_dept_code"
                                            name="iv_govt_dept_code"
                                            value={
                                              govtDeptCode ? govtDeptCode : null
                                            }
                                            options={govtDeptCodes}
                                            getOptionLabel={(option) =>
                                              option.departmentCode
                                                ? `${option.departmentCode}${option.departmentName}`
                                                : ""
                                            }
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                variant="outlined"
                                                className="fieldBatch1"
                                                value={inputValue}
                                                onChange={(e) =>
                                                  setInputValue(e.target.value)
                                                }
                                                disabled={
                                                  dnDetails &&
                                                  dnDetails.filledFlag === 1
                                                } // 👈 direct
                                                inputProps={{
                                                  ...params.inputProps,
                                                  readOnly:
                                                    dnDetails &&
                                                    dnDetails.filledFlag === 1, // 👈 direct
                                                }}
                                                sx={{
                                                  "& .MuiInputBase-input": {
                                                    fontSize: "13px",
                                                    height: "12px",
                                                  },
                                                }}
                                              />
                                            )}
                                            onChange={(event, value) => {
                                              if (value) {
                                                setGovtDeptCode(value);
                                                refNoAllocationFormik.setFieldValue(
                                                  "iv_govt_dept_code",
                                                  value.departmentCode
                                                );
                                              }
                                            }}
                                          />
                                        </Grid>
                                      )}
                                  </Grid>
                                </>
                              )}
                          </Grid>
                        </>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            Reference Number Approval is in process by sanctioned
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 4 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <h3 className="step-title">Demand Notice Objection</h3>
                      <div className="description-box">
                        <p className="group-description">
                          <InfoIcon className="icon" />
                          Unable to generate the demand notice. Please contact
                          the relevant field operations officer.{" "}
                        </p>
                      </div>
                    </>
                  ) : dialogRowData.applicationProgressId === 5 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <div
                        className="step-title"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "1%",
                          padding: "0.5%",
                        }}
                      >
                        <h4
                          style={{
                            textAlign: "center",
                            width: "100%",
                            marginTop: "0.5%",
                          }}
                        >
                          DN Payment Submission
                        </h4>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <Button
                            variant="outlined"
                            onClick={() => downloadDNPDF(dialogRowData)}
                            sx={{
                              backgroundColor: "white",
                              cursor: "pointer",
                              border: "1px solid #006ad1",
                              boxShadow: "none",
                            }}
                          >
                            <PrintIcon
                              sx={{ color: "#006ad1", marginRight: "5px" }}
                            />
                            DN
                          </Button>
                          {dialogRowData.objectionStatus === 1 && (
                            <Button
                              variant="outlined"
                              onClick={() => downloadRejectionNoticePDF(dialogRowData)}
                              sx={{
                                backgroundColor: "white",
                                cursor: "pointer",
                                border: "1px solid #d32f2f",
                                boxShadow: "none",
                              }}
                            >
                              <CloseIcon
                                sx={{ color: "#d32f2f", marginRight: "5px" }}
                              />
                              Reject Notice
                            </Button>
                          )}
                        </div>
                      </div>
                      <Grid
                        container
                        className="dn-payment-submission-container"
                      >
                        <Grid item lg={3} className="item">
                          <Typography className="title">
                            Demand Notice No.
                          </Typography>
                          <Typography className="value">
                            {dnDetails.demandNoticeNo
                              ? dnDetails.demandNoticeNo
                              : "-"}
                          </Typography>
                        </Grid>
                        <Grid item lg={3} className="item">
                          <Typography className="title">
                            Reference No.
                          </Typography>
                          <Typography className="value">
                            {dnDetails.connectionAccountNo
                              ? dnDetails.connectionAccountNo
                              : "-"}
                          </Typography>
                        </Grid>
                        <Grid item lg={3} className="item">
                          <Typography className="title">Issue Date</Typography>
                          <Typography className="value">
                            {dnDetails.issueDate
                              ? convertDate(dnDetails.issueDate)
                              : "-"}
                          </Typography>
                        </Grid>
                        <Grid item lg={3} className="item">
                          <Typography className="title">Due Date</Typography>
                          <Typography className="value">
                            {dnDetails.dueDate
                              ? convertDate(dnDetails.dueDate)
                              : "-"}
                          </Typography>
                        </Grid>
                        <Grid item lg={3} className="item">
                          <Typography className="title">
                            Capital Cost
                          </Typography>
                          <Typography className="value">
                            {dnDetails.capitalCostAmount
                              ? numberFormatting(dnDetails.capitalCostAmount)
                              : "-"}
                          </Typography>
                        </Grid>
                        <Grid item lg={3} className="item">
                          <Typography className="title">
                            Security Cost
                          </Typography>
                          <Typography className="value">
                            {dnDetails.securityDepositeAmount
                              ? numberFormatting(
                                dnDetails.securityDepositeAmount
                              )
                              : "-"}
                          </Typography>
                        </Grid>
                        {Number(dnDetails.amountOfGridSharing) !== 0 && (
                          <Grid item lg={3} className="item">
                            <Typography className="title">
                              Grid Sharing Cost
                            </Typography>
                            <Typography className="value">
                              {dnDetails.amountOfGridSharing
                                ? numberFormatting(
                                  dnDetails.amountOfGridSharing
                                )
                                : "-"}
                            </Typography>
                          </Grid>
                        )}
                        {Number(dnDetails.amountOfFeederRehab) !== 0 && (
                          <Grid item lg={3} className="item">
                            <Typography className="title">
                              Feeder Rehabilitation Cost
                            </Typography>
                            <Typography className="value">
                              {dnDetails.amountOfFeederRehab
                                ? numberFormatting(
                                  dnDetails.amountOfFeederRehab
                                )
                                : "-"}
                            </Typography>
                          </Grid>
                        )}
                        {Number(dnDetails.civilWorkCharges) !== 0 && (
                          <Grid item lg={3} className="item">
                            <Typography className="title">
                              Civil Work Charges
                            </Typography>
                            <Typography className="value">
                              {dnDetails.civilWorkCharges
                                ? numberFormatting(
                                  dnDetails.civilWorkCharges
                                )
                                : "-"}
                            </Typography>
                          </Grid>
                        )}
                        {Number(dnDetails.fixedChargesOfMetering) !== 0 && (
                          <Grid item lg={3} className="item">
                            <Typography className="title">
                              Fixed Charges Of Metering
                            </Typography>
                            <Typography className="value">
                              {dnDetails.fixedChargesOfMetering
                                ? numberFormatting(
                                  dnDetails.fixedChargesOfMetering
                                )
                                : "-"}
                            </Typography>
                          </Grid>
                        )}
                        {Number(dnDetails.miscellaneousCharges) !== 0 && (
                          <Grid item lg={3} className="item">
                            <Typography className="title">Miscellaneous Charges</Typography>
                            <Typography className="value">
                              {numberFormatting(dnDetails.miscellaneousCharges)}
                            </Typography>
                          </Grid>
                        )}

                        {
                          Number(dnDetails.mtCharges) !== 0 && (
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                M&T Charges
                              </Typography>
                              <Typography className="value">
                                {dnDetails.mtCharges
                                  ? numberFormatting(
                                    dnDetails.mtCharges
                                  )
                                  : "-"}
                              </Typography>
                            </Grid>
                          )
                        }


                        {
                          Number(dnDetails.labourCharges) !== 0 && (
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Labour Charges
                              </Typography>
                              <Typography className="value">
                                {dnDetails.labourCharges
                                  ? numberFormatting(
                                    dnDetails.labourCharges
                                  )
                                  : "-"}
                              </Typography>
                            </Grid>
                          )
                        }

                        {
                          Number(dnDetails.designVetteingFee) !== 0 && (
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Design Vetting fee
                              </Typography>
                              <Typography className="value">
                                {dnDetails.designVetteingFee
                                  ? numberFormatting(
                                    dnDetails.designVetteingFee
                                  )
                                  : "-"}
                              </Typography>
                            </Grid>
                          )
                        }

                        {
                          Number(dnDetails.variationsCharges) !== 0 && (
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Variation Charges
                              </Typography>
                              <Typography className="value">
                                {dnDetails.variationsCharges
                                  ? numberFormatting(
                                    dnDetails.variationsCharges
                                  )
                                  : "-"}
                              </Typography>
                            </Grid>
                          )
                        }
                        {
                          Number(dnDetails.consultancyCharges) !== 0 && (
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Consultancy Charges
                              </Typography>
                              <Typography className="value">
                                {dnDetails.consultancyCharges
                                  ? numberFormatting(
                                    dnDetails.consultancyCharges
                                  )
                                  : "-"}
                              </Typography>
                            </Grid>
                          )
                        }


                        {
                          Number(dnDetails.dismentalmentCharges) !== 0 && (
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                DismentalmentCharges
                              </Typography>
                              <Typography className="value">
                                {dnDetails.dismentalmentCharges
                                  ? numberFormatting(
                                    dnDetails.dismentalmentCharges
                                  )
                                  : "-"}
                              </Typography>
                            </Grid>
                          )
                        }

                        {
                          Number(dnDetails.earthingCharges) !== 0 && (
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Earthing Charges
                              </Typography>
                              <Typography className="value">
                                {dnDetails.earthingCharges
                                  ? numberFormatting(
                                    dnDetails.earthingCharges
                                  )
                                  : "-"}
                              </Typography>
                            </Grid>
                          )
                        }
                        <Grid item lg={3} className="item">
                          <Typography className="title">Total Cost</Typography>
                          <Typography className="value">
                            {dnDetails.capitalCostAmount ||
                              dnDetails.securityDepositeAmount
                              ? numberFormatting(
                                parseInt(
                                  dnDetails.capitalCostAmount
                                ) +
                                parseInt(
                                  dnDetails.securityDepositeAmount
                                ) +
                                (!isNaN(
                                  parseInt(
                                    dnDetails.amountOfGridSharing
                                  )
                                )
                                  ? parseInt(
                                    dnDetails.amountOfGridSharing
                                  )
                                  : 0) +
                                (!isNaN(
                                  parseInt(
                                    dnDetails.amountOfFeederRehab
                                  )
                                )
                                  ? parseInt(
                                    dnDetails.amountOfFeederRehab
                                  )
                                  : 0) +
                                (!isNaN(parseInt(dnDetails.civilWorkCharges)) ? parseInt(dnDetails.civilWorkCharges) : 0) +
                                (!isNaN(parseInt(dnDetails.miscellaneousCharges)) ? parseInt(dnDetails.miscellaneousCharges) : 0) +
                                (!isNaN(parseInt(dnDetails.fixedChargesOfMetering)) ? parseInt(dnDetails.fixedChargesOfMetering) : 0) +

                                (!isNaN(parseInt(dnDetails.mtCharges)) ? parseInt(dnDetails.mtCharges) : 0) +
                                (!isNaN(parseInt(dnDetails.labourCharges)) ? parseInt(dnDetails.labourCharges) : 0) +
                                (!isNaN(parseInt(dnDetails.designVetteingFee)) ? parseInt(dnDetails.designVetteingFee) : 0) +
                                (!isNaN(parseInt(dnDetails.consultancyCharges)) ? parseInt(dnDetails.consultancyCharges) : 0) +
                                (!isNaN(parseInt(dnDetails.variationsCharges)) ? parseInt(dnDetails.variationsCharges) : 0) +
                                (!isNaN(parseInt(dnDetails.dismentalmentCharges)) ? parseInt(dnDetails.dismentalmentCharges) : 0) +
                                (!isNaN(parseInt(dnDetails.earthingCharges)) ? parseInt(dnDetails.earthingCharges) : 0)
                              )
                              : "-"}
                          </Typography>
                        </Grid>
                        <Grid item lg={3} className="item">
                          <Typography className="title">Bank Name</Typography>
                          <Typography className="value">
                            {dnDetails.bankName ? dnDetails.bankName : "-"}
                          </Typography>
                        </Grid>
                      </Grid>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "New Connection",
                        "Workflow Permissions",
                        "DN Image Uploading"
                      ) ? (
                        <>
                          <Grid
                            container
                            spacing={5}
                            display="flex"
                            flexDirection="row"
                            className="field-survey-container"
                          >
                            <Grid
                              item
                              style={{ marginTop: "1%", width: "25%" }}
                            >
                              <Typography
                                className="fieldLabel"
                                sx={{ paddingTop: "10px", paddingBottom: "2%" }}
                              >
                                Receipt Image
                              </Typography>
                              {dnReceiptImage ? (
                                <>
                                  <Button
                                    varient="outlined"
                                    component="label"
                                    startIcon={
                                      <CloseIcon
                                        sx={{ color: "red" }}
                                        onClick={() => {
                                          setDnReceiptImage("");
                                        }}
                                      />
                                    }
                                  >
                                    {dnReceiptImageThumbnail && (
                                      <img
                                        src={dnReceiptImageThumbnail}
                                        alt="DN Receipt"
                                        width="80"
                                      />
                                    )}
                                  </Button>
                                </>
                              ) : (
                                <>
                                  <Button
                                    variant="outlined"
                                    component="label"
                                    startIcon={<FileUploadOutlinedIcon />}
                                    sx={{
                                      padding: "4%",
                                      width: "100%",
                                      backgroundColor: "white",
                                    }}
                                  >
                                    Upload
                                    <input
                                      hidden
                                      accept={documentExtensions}
                                      id="iv_receipt_image"
                                      name="iv_receipt_image"
                                      type="file"
                                      onChange={DnReceiptImage}
                                    />
                                  </Button>
                                </>
                              )}
                              <Box className="form-error">
                                {dnReceiptImageError
                                  ? dnReceiptImageError
                                  : null}
                              </Box>
                              <Box className="form-error">
                                {dnPymentReceiptFormik.errors
                                  .iv_receipt_image &&
                                  dnPymentReceiptFormik.touched.iv_receipt_image
                                  ? dnPymentReceiptFormik.errors
                                    .iv_receipt_image
                                  : null}
                              </Box>
                            </Grid>
                            <Grid item style={{ marginTop: "1%" }}>
                              <Typography
                                className="fieldLabel"
                                sx={{ paddingTop: "10px", paddingBottom: "2%" }}
                              >
                                Payment Date
                              </Typography>
                              <input
                                name="iv_payment_date"
                                value={
                                  dnPymentReceiptFormik.values.iv_payment_date
                                }
                                onChange={dnPymentReceiptFormik.handleChange}
                                onBlur={dnPymentReceiptFormik.handleBlur}
                                type="date"
                                className="fieldReferenceNo"
                                style={{
                                  width: "200px",
                                  height: "30px",
                                  padding: "4px",
                                }}
                                min={
                                  dnDetails.issueDate
                                    ? dnDetails.issueDate.slice(0, 10)
                                    : undefined
                                }
                                max={new Date().toISOString().split("T")[0]}
                                onKeyDown={(e) => e.preventDefault()}
                              />

                              <Box className="form-error">
                                {dnPymentReceiptFormik.errors.iv_payment_date &&
                                  dnPymentReceiptFormik.touched.iv_payment_date
                                  ? dnPymentReceiptFormik.errors.iv_payment_date
                                  : null}
                              </Box>
                            </Grid>
                          </Grid>
                        </>
                      ) : isDemandNoteExpired == "1" ? (
                        <></>
                      ) : (
                        isDemandNoteExpired == "0" && (
                          <div className="description-box">
                            <p className="group-description">
                              <InfoIcon className="icon" />
                              Demand Note payment is in process by consumer.
                            </p>
                          </div>
                        )
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 5 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <h3 className="step-title">Demand Notice Objection</h3>
                      <div className="description-box">
                        <p className="group-description">
                          <InfoIcon className="icon" />
                          Unable to generate the demand notice. Please contact
                          the relevant field operations officer.{" "}
                        </p>
                      </div>
                    </>
                  ) : dialogRowData.applicationProgressId === 6 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "New Connection",
                      "Workflow Permissions",
                      "Demand Note Verification"
                    ) &&
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "New Connection",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15"
                      ) &&
                        dialogRowData.appliedLoad > 0 &&
                        dialogRowData.appliedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "New Connection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1"
                        ) &&
                          allTariffList &&
                          getTariff(
                            dialogRowData.appliedLoad,
                            dialogRowData.connectionType,
                            dialogRowData.seasonalNonSeasonalFlag,
                            allTariffList
                          )?.startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2"
                          ) &&
                            allTariffList &&
                            getTariff(
                              dialogRowData.appliedLoad,
                              dialogRowData.connectionType,
                              dialogRowData.seasonalNonSeasonalFlag,
                              allTariffList
                            )?.startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3"
                          ) &&
                            allTariffList &&
                            getTariff(
                              dialogRowData.appliedLoad,
                              dialogRowData.connectionType,
                              dialogRowData.seasonalNonSeasonalFlag,
                              allTariffList
                            )?.startsWith("A3")))) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "New Connection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70"
                        ) &&
                          dialogRowData.appliedLoad > 0 &&
                          dialogRowData.appliedLoad <= 70 &&
                          // ✅ Tariff A1, A2, A3 nahi hone chahiye
                          !["A1", "A2", "A3"].some((tariffCode) =>
                            getTariff(
                              dialogRowData.appliedLoad,
                              dialogRowData.connectionType,
                              dialogRowData.seasonalNonSeasonalFlag,
                              allTariffList
                            )
                              ?.toUpperCase()
                              .startsWith(tariffCode)
                          )) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "New Connection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70"
                        ) &&
                          dialogRowData.appliedLoad > 15 &&
                          dialogRowData.appliedLoad <= 70) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "New Connection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500"
                        ) &&
                          dialogRowData.appliedLoad > 70 &&
                          dialogRowData.appliedLoad <= 500) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "New Connection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000"
                        ) &&
                          dialogRowData.appliedLoad > 500)) ? (
                      <>
                        <h3 className="step-title">
                          Verify Demand Notice Payment
                        </h3>
                        <Grid container className="paidDnContainer">
                          <Grid item lg={3} className="item">
                            <Typography className="title">
                              Demand Notice No.
                            </Typography>
                            <Typography className="value">
                              {dnNumber}
                            </Typography>
                          </Grid>
                          <Grid item lg={3} className="item">
                            <Typography className="title">
                              Reference No.
                            </Typography>
                            <Typography className="value">
                              {dnDetails.connectionAccountNo
                                ? dnDetails.connectionAccountNo
                                : "-"}
                            </Typography>
                          </Grid>
                          <Grid item lg={3} className="item">
                            <Typography className="title">
                              DN. Amount
                            </Typography>
                            <Typography className="value">
                              {dnDetails.capitalCostAmount ||
                                dnDetails.securityDepositeAmount ||
                                dnDetails.amountOfGridSharing ||
                                dnDetails.amountOfFeederRehab
                                ? numberFormatting(
                                  parseInt(dnDetails.capitalCostAmount) +
                                  parseInt(dnDetails.securityDepositeAmount) +
                                  (!isNaN(parseInt(dnDetails.amountOfGridSharing)) ? parseInt(dnDetails.amountOfGridSharing) : 0) +
                                  (!isNaN(parseInt(dnDetails.amountOfFeederRehab)) ? parseInt(dnDetails.amountOfFeederRehab) : 0) +

                                  (!isNaN(parseInt(dnDetails.civilWorkCharges)) ? parseInt(dnDetails.civilWorkCharges) : 0) +
                                  (!isNaN(parseInt(dnDetails.fixedChargesOfMetering)) ? parseInt(dnDetails.fixedChargesOfMetering) : 0) +
                                  (!isNaN(parseInt(dnDetails.miscellaneousCharges)) ? parseInt(dnDetails.miscellaneousCharges) : 0) +

                                  (!isNaN(parseInt(dnDetails.mtCharges)) ? parseInt(dnDetails.mtCharges) : 0) +
                                  (!isNaN(parseInt(dnDetails.labourCharges)) ? parseInt(dnDetails.labourCharges) : 0) +
                                  (!isNaN(parseInt(dnDetails.designVetteingFee)) ? parseInt(dnDetails.designVetteingFee) : 0) +
                                  (!isNaN(parseInt(dnDetails.consultancyCharges)) ? parseInt(dnDetails.consultancyCharges) : 0) +
                                  (!isNaN(parseInt(dnDetails.variationsCharges)) ? parseInt(dnDetails.variationsCharges) : 0) +
                                  (!isNaN(parseInt(dnDetails.dismentalmentCharges)) ? parseInt(dnDetails.dismentalmentCharges) : 0) +
                                  (!isNaN(parseInt(dnDetails.earthingCharges)) ? parseInt(dnDetails.earthingCharges) : 0)
                                )
                                : "-"}
                            </Typography>
                          </Grid>
                          <Grid item lg={3} className="item">
                            <Typography className="title">
                              Payment Date
                            </Typography>
                            <Typography className="value">
                              {dnPaymentDate}
                            </Typography>
                          </Grid>
                          <Grid item lg={12}></Grid>
                          <Grid item lg={3} className="paidDnDocument item">
                            <Typography className="title">
                              Paid Demand Notice
                            </Typography>
                            <Grid
                              container
                              sx={{
                                backgroundColor: getDocumentBackGroundColor(0),
                                borderRadius: "10px",
                                height: "250px",
                                width: "100%",
                                marginRight: "2%",
                              }}
                              className="docContainer"
                            >
                              <Grid
                                item
                                lg={12}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  paddingBottom: "5px",
                                }}
                              >
                                <div
                                  onClick={() => {
                                    if (!paidDNImagePopUp) {
                                      setPaidDNImagePopUp(true);
                                    }
                                  }}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {dnImage &&
                                    dnImage.slice(0, 6) == "data:i" ? (
                                    <Base64Image data={dnImage} width="80" />
                                  ) : (
                                    <Base64Image data={pdfIcon} width="40" />
                                  )}
                                </div>
                                {paidDNImagePopUp && (
                                  <OpenBase64ImageInPopup
                                    docVerifyPopUp={paidDNImagePopUp}
                                    hideDocVerifyPopup={hidePaidDnImagePopUp}
                                    documentName="Paid DN Image"
                                    documentImage={dnImage}
                                    // backDocumentImage={dialogRowData.copyOfApplicantCNICBack}
                                    width={"100%"}
                                    document={dnImage}
                                    documentFlag={1}
                                    applicationProgressId={
                                      dialogRowData.applicationProgressId
                                    }
                                    objectionStatus={
                                      dialogRowData.objectionStatus
                                    }
                                    updateDocFlag={updateDocFlag}
                                    titleToUpdateFlag="copyOfApplicantCNIC"
                                    flag_document={1}
                                  // flag_documentBack={flag_copyOfApplicantCNICBack}
                                  />
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item lg={4.5} className="item">
                            <Typography className="title">
                              Customer ID. Front
                            </Typography>
                            <Grid
                              container
                              sx={{
                                backgroundColor: getDocumentBackGroundColor(0),
                                borderRadius: "10px",
                                height: "250px",
                                width: "100%",
                              }}
                              className="docContainer"
                            >
                              <img
                                src={dialogRowData.copyOfApplicantCNICFront}
                                alt="Cnic Front"
                                style={{ width: "100%", height: "100%" }}
                              ></img>
                            </Grid>
                          </Grid>
                          <Grid item lg={4.5} className="item">
                            <Typography className="title">
                              Customer ID. Back
                            </Typography>
                            <Grid
                              container
                              sx={{
                                backgroundColor: getDocumentBackGroundColor(0),
                                borderRadius: "10px",
                                height: "250px",
                                width: "100%",
                              }}
                              className="docContainer"
                            >
                              <img
                                src={dialogRowData.copyOfApplicantCNICBack}
                                alt="Cnic Back"
                                style={{ width: "100%", height: "100%" }}
                              ></img>
                            </Grid>
                          </Grid>
                        </Grid>
                      </>
                    ) : (
                      <>
                        <h3 className="step-title">
                          Demand Notice Payment Verification
                        </h3>
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The demand notice payment verificaition is in
                            process by sanctioning authority.{" "}
                          </p>
                        </div>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 6 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <h3 className="step-title">
                        Demand Notice Payment Objection
                      </h3>
                      <div className="description-box">
                        {CheckPermissions(
                          permissions,
                          "General Services",
                          "New Connection",
                          "Workflow Permissions",
                          "Demand Note Verification"
                        ) ? (
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            Demand notice payment was declared as unpaid. In
                            case the payment has been done, remove objection by
                            clicking below button.
                          </p>
                        ) : (
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            Demand notice payment was declared as unpaid by the
                            concerned revenue officer.{" "}
                          </p>
                        )}
                      </div>
                    </>
                  ) : dialogRowData.applicationProgressId === 7 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <h3 className="step-title">
                        Meter Installation Objection
                      </h3>
                      <div className="description-box">
                        <p className="group-description">
                          <InfoIcon className="icon" />
                          Unable to get details of the demand notice payment.
                          Please contact the relevant field operations officer!{" "}
                        </p>
                      </div>
                    </>
                  ) : dialogRowData.applicationProgressId === 8 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <div
                        className="step-title"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "1%",
                        }}
                      >
                        <h4 style={{ textAlign: "center", width: "100%" }}>
                          Meter Installation
                        </h4>
                      </div>
                      {submitSCOApiError ? (
                        <Alert
                          severity="error"
                          onClose={() => setSubmitSCOApiError("")}
                          sx={{ mb: 1, width: "100%" }}
                        >
                          {submitSCOApiError}
                        </Alert>
                      ) : null}
                      {dialogRowData.assignedToUserId ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                          }}
                        >
                          <Grid container className="sco-container">
                            <Grid item lg={3} className="item">
                              <Typography className="title">SCO No.</Typography>
                              <Typography className="value">
                                {scoDetails.scoId ? scoDetails.scoId : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                SCO Creation Date
                              </Typography>
                              <Typography className="value">
                                {scoDetails.scoCreationDate
                                  ? convertDate(scoDetails.scoCreationDate)
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">DN No.</Typography>
                              <Typography className="value">
                                {dnDetails.demandNoticeNo
                                  ? dnDetails.demandNoticeNo
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                DN Issue Date
                              </Typography>
                              <Typography className="value">
                                {dnDetails.issueDate
                                  ? convertDate(dnDetails.issueDate)
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                DN Payment Date
                              </Typography>
                              <Typography className="value">
                                {dnDetails.paymentDate
                                  ? convertDate(dnDetails.paymentDate)
                                  : "-"}
                              </Typography>
                            </Grid>
                          </Grid>
                          {
                            // dialogRowData.assignedToUserId ?
                            <div
                              style={{
                                padding: "10px",
                                backgroundColor: "#c6fbe7",
                                borderRadius: "10px",
                                width: "auto",
                                maxWidth: "300px",
                                height: "auto",
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <div style={{ width: "30px" }}>
                                <img src={InfoImage} height={20} />
                              </div>
                              <div>
                                <p style={{ marginBottom: "20px" }}>
                                  This application is assigned to:
                                </p>
                                <div style={{ display: "flex" }}>
                                  <p
                                    style={{
                                      fontFamily: "Roboto-Medium",
                                      width: "120px",
                                    }}
                                  >
                                    Name:
                                  </p>
                                  <p>{dialogRowData.assignedToUserName}</p>
                                </div>
                                <div style={{ display: "flex" }}>
                                  <p
                                    style={{
                                      fontFamily: "Roboto-Medium",
                                      width: "120px",
                                    }}
                                  >
                                    Designation:
                                  </p>
                                  <p>{dialogRowData.assignedToDesignation}</p>
                                </div>
                                <div style={{ display: "flex" }}>
                                  <p
                                    style={{
                                      fontFamily: "Roboto-Medium",
                                      width: "120px",
                                    }}
                                  >
                                    Phone:
                                  </p>
                                  <p>{dialogRowData.assignedToMobileNo}</p>
                                </div>
                                <div style={{ display: "flex" }}>
                                  <p
                                    style={{
                                      fontFamily: "Roboto-Medium",
                                      width: "120px",
                                    }}
                                  >
                                    Assigned On:
                                  </p>
                                  <p>
                                    {convertDatewithTimeWithoutSecond(
                                      dialogRowData.assigningDate
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>
                            // : <></>
                          }
                        </div>
                      ) : (
                        <Grid container className="sco-container">
                          <Grid item lg={2.4} className="item">
                            <Typography className="title">SCO No.</Typography>
                            <Typography className="value">
                              {scoDetails.scoId ? scoDetails.scoId : "-"}
                            </Typography>
                          </Grid>
                          <Grid item lg={2.4} className="item">
                            <Typography className="title">
                              SCO Creation Date
                            </Typography>
                            <Typography className="value">
                              {scoDetails.scoCreationDate
                                ? convertDate(scoDetails.scoCreationDate)
                                : "-"}
                            </Typography>
                          </Grid>
                          <Grid item lg={2.4} className="item">
                            <Typography className="title">DN No.</Typography>
                            <Typography className="value">
                              {dnDetails.demandNoticeNo
                                ? dnDetails.demandNoticeNo

                                : "-"}
                            </Typography>
                          </Grid>
                          <Grid item lg={2.4} className="item">
                            <Typography className="title">
                              DN Issue Date
                            </Typography>
                            <Typography className="value">
                              {dnDetails.issueDate
                                ? convertDate(dnDetails.issueDate)
                                : "-"}
                            </Typography>
                          </Grid>
                          <Grid item lg={2.4} className="item">
                            <Typography className="title">
                              DN Payment Date
                            </Typography>
                            <Typography className="value">
                              {dnDetails.paymentDate
                                ? convertDate(dnDetails.paymentDate)
                                : "-"}
                            </Typography>
                          </Grid>
                        </Grid>
                      )}

                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "New Connection",
                        "Workflow Permissions",
                        "Meter Installation"
                      ) ? (
                        <>
                          <Grid
                            container
                            spacing={2}
                            className="field-survey-container"
                          >
                            <Grid item lg={2}>
                              <Typography className="fieldLabel">
                                Store Requisition No.
                              </Typography>
                              <TextField
                                name="iv_store_requisition_no"
                                value={
                                  scoPart2Formik.values.iv_store_requisition_no
                                }
                                fullWidth
                                disabled={
                                  dialogRowData?.applicationId?.startsWith("NC-13")
                                    ? true
                                    : scoDetails.scoP2FillFlag == 1 ||
                                    scoDetails.scoP2FillFlag == 13
                                }
                                onChange={(e) => {
                                  let val = e.target.value.replace(/\D/g, ""); // only digits
                                  if (val.length <= 6) {
                                    scoPart2Formik.setFieldValue(
                                      "iv_store_requisition_no",
                                      val
                                    );
                                  }
                                }}
                                onBlur={(e) => {
                                  let val = e.target.value;
                                  if (val) {
                                    val = val.padStart(6, "0");
                                    scoPart2Formik.setFieldValue(
                                      "iv_store_requisition_no",
                                      val
                                    );
                                  }
                                  scoPart2Formik.handleBlur(e);
                                }}
                                inputProps={{ maxLength: 6 }}
                                type="text"
                                className="fieldCoverageMarla"
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors
                                  .iv_store_requisition_no &&
                                  scoPart2Formik.touched.iv_store_requisition_no
                                  ? scoPart2Formik.errors
                                    .iv_store_requisition_no
                                  : null}
                              </p>
                            </Grid>

                            <Grid item lg={1.6}>
                              <Typography className="fieldLabel">
                                Store Req. Date
                              </Typography>
                              <input
                                name="iv_store_requisition_date"
                                disabled={
                                  dialogRowData?.applicationId?.slice(3, 5) === "13" ||
                                    dialogRowData?.storeRequisitionDate
                                    ? true
                                    : scoDetails.scoP2FillFlag == 1 ||
                                    scoDetails.scoP2FillFlag == 13
                                }
                                value={
                                  scoPart2Formik.values.iv_store_requisition_date
                                }
                                onChange={scoPart2Formik.handleChange}
                                onBlur={scoPart2Formik.handleBlur}
                                type="date"
                                className="fieldReferenceNo"
                                style={{
                                  width: "100%",
                                  height: "30px",
                                  borderWidth: "1px",
                                  borderRadius: "3px",
                                  borderColor: "lightgrey",
                                }}
                                min={
                                  scoDetails.dateOfAuthorization
                                    ? scoDetails.dateOfAuthorization.slice(
                                      0,
                                      10
                                    )
                                    : null
                                }
                                max={new Date().toISOString().split("T")[0]}
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors
                                  .iv_store_requisition_date &&
                                  scoPart2Formik.touched.iv_store_requisition_date
                                  ? scoPart2Formik.errors
                                    .iv_store_requisition_date
                                  : null}
                              </p>
                            </Grid>

                            <Grid item lg={1.6}>
                              <Typography className="fieldLabel">
                                Sanc. Load (kW)
                              </Typography>
                              <TextField
                                required
                                disabled
                                type="number"
                                InputProps={{
                                  inputProps: { min: 0 },
                                }}
                                autoComplete="off"
                                name="iv_sanctioned_load"
                                value={scoPart2Formik.values.iv_sanctioned_load}
                                onChange={scoPart2Formik.handleChange}
                                onBlur={scoPart2Formik.handleBlur}
                                id="iv_sanctioned_load"
                                className="fieldCoverageMarla"
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_sanctioned_load &&
                                  scoPart2Formik.touched.iv_sanctioned_load
                                  ? scoPart2Formik.errors.iv_sanctioned_load
                                  : null}
                              </p>
                            </Grid>
                            <Grid item lg={2}>
                              <Typography className="fieldLabel">
                                Meter Manufacturer
                              </Typography>
                              <Autocomplete
                                id="iv_manufacturer_code"
                                name="iv_manufacturer_code"
                                value={
                                  manufacturerCode ? manufacturerCode : null
                                }
                                disabled={Boolean(
                                  scoDetails.scoP2FillFlag &&
                                  CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "New Connection",
                                    "Workflow Permissions",
                                    "Meter Installation",
                                    "SCO P2 Creation"
                                  )
                                )}
                                options={manufacturesList}
                                // className='fieldBatch1'
                                getOptionLabel={(option) =>
                                  option.code
                                    ? `${option.name} ${option.code}`
                                    : ""
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    className="fieldBatch1"
                                    value={inputValue}
                                    onChange={(e) =>
                                      setInputValue(e.target.value)
                                    }
                                    disabled={Boolean(
                                      scoDetails.scoP2FillFlag &&
                                      CheckPermissions(
                                        permissions,
                                        "General Services",
                                        "New Connection",
                                        "Workflow Permissions",
                                        "Meter Installation",
                                        "SCO P2 Creation"
                                      )
                                    )}
                                    sx={{
                                      height: "10px",
                                      "& .MuiInputBase-input": {
                                        fontSize: "13px",
                                        height: "12px",
                                      },
                                    }}
                                  />
                                )}
                                ListboxProps={{
                                  style: {
                                    maxHeight: 100,
                                    fontSize: "10px",
                                  },
                                }}
                                onChange={(event, value) => {
                                  if (value) {
                                    setManufcaturerCode(value);
                                    scoPart2Formik.setFieldValue(
                                      "iv_manufacturer_code",
                                      value.code
                                    );
                                  }
                                }}
                                filterOptions={(options) =>
                                  filterOptions(
                                    options,
                                    { inputValue: debouncedInputValue },
                                    ["code", "name"]
                                  )
                                }
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_manufacturer_code &&
                                  scoPart2Formik.touched.iv_manufacturer_code
                                  ? scoPart2Formik.errors.iv_manufacturer_code
                                  : null}
                              </p>
                            </Grid>
                            <Grid item lg={1.8}>
                              <Typography className="fieldLabel">
                                Meter Serial No.
                              </Typography>
                              <TextField
                                name="iv_meter_serial_no"
                                value={scoPart2Formik.values.iv_meter_serial_no}
                                type="text"
                                sx={{ width: '100%' }}
                                disabled={Boolean(
                                  scoDetails.scoP2FillFlag &&
                                  CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "New Connection",
                                    "Workflow Permissions",
                                    "Meter Installation",
                                    "SCO P2 Creation"
                                  )
                                )}
                                onChange={scoPart2Formik.handleChange}
                                onBlur={scoPart2Formik.handleBlur}
                                className="fieldCoverageMarla"
                                inputProps={{
                                  maxLength: (scoDetails?.meterType === 1 || scoDetails?.meterType === "1") &&
                                    dialogRowData?.applicationId?.startsWith("NC-14") ? 14 : 10
                                }}
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_meter_serial_no &&
                                  scoPart2Formik.touched.iv_meter_serial_no
                                  ? scoPart2Formik.errors.iv_meter_serial_no
                                  : null}
                              </p>
                            </Grid>

                            <Grid item lg={1.6}>
                              <Typography className="fieldLabel">
                                Sim No.
                              </Typography>
                              <TextField
                                name="iv_sim_number"
                                value={scoPart2Formik.values.iv_sim_number}
                                type="text"
                                sx={{ width: '100%' }}
                                disabled={Boolean(
                                  scoDetails.scoP2FillFlag &&
                                  CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "New Connection",
                                    "Workflow Permissions",
                                    "Meter Installation",
                                    "SCO P2 Creation"
                                  )
                                )}
                                onChange={scoPart2Formik.handleChange}
                                onBlur={scoPart2Formik.handleBlur}
                                className="fieldCoverageMarla"
                                inputProps={{ maxLength: 11 }}
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_sim_number &&
                                  scoPart2Formik.touched.iv_sim_number
                                  ? scoPart2Formik.errors.iv_sim_number
                                  : null}
                              </p>
                            </Grid>

                            <Grid item lg={3}>
                              <Typography className="fieldLabel">
                                Sim Id.
                              </Typography>
                              <TextField
                                name="iv_sim_ID"
                                value={scoPart2Formik.values.iv_sim_ID}
                                type="text"
                                sx={{ width: '100%' }}
                                disabled={Boolean(
                                  scoDetails.scoP2FillFlag &&
                                  CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "New Connection",
                                    "Workflow Permissions",
                                    "Meter Installation",
                                    "SCO P2 Creation"
                                  )
                                )}
                                onChange={scoPart2Formik.handleChange}
                                onBlur={scoPart2Formik.handleBlur}
                                className="fieldCoverageMarla"
                                inputProps={{ maxLength: 20 }}
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_sim_ID &&
                                  scoPart2Formik.touched.iv_sim_ID
                                  ? scoPart2Formik.errors.iv_sim_ID
                                  : null}
                              </p>
                            </Grid>

                            <Grid item lg={3.1}>
                              <Typography
                                className="fieldLabel"
                                sx={{ fontSize: "16px", color: "#006ad1" }}
                              >
                                Meter Type
                              </Typography>
                              <FormControl className="form-control">
                                <RadioGroup
                                  className="radio-group"
                                  row
                                  name="iv_meter_type"
                                  value={scoPart2Formik.values.iv_meter_type}
                                  onChange={scoPart2Formik.handleChange}
                                >
                                  <FormControlLabel
                                    value={1}
                                    className="form-control-label"
                                    // control={<Radio disabled={scoDetails.scoP2FillFlag === 1 && CheckPermissions(permissions, 'General Services', 'New Connection', 'Workflow Permissions', 'Meter Installation', 'SCO P2 Creation')} />}
                                    control={
                                      <Radio
                                        disabled={
                                          dialogRowData?.applicationId?.slice(
                                            3,
                                            5
                                          ) !== "14" ||
                                          Boolean(
                                            scoDetails.scoP2FillFlag &&
                                            CheckPermissions(
                                              permissions,
                                              "General Services",
                                              "New Connection",
                                              "Workflow Permissions",
                                              "Meter Installation",
                                              "SCO P2 Creation"
                                            )
                                          )
                                        }
                                      />
                                    }
                                    label="Smart"
                                    name="Smart"
                                    labelPlacement="end"
                                    sx={{
                                      backgroundColor: "white",
                                      padding: "0px 10px",
                                      borderRadius: "5px",
                                      marginLeft: "0px",
                                      marginRight: "5px",
                                      border: "1px solid lightgrey",
                                    }}
                                  />
                                  <FormControlLabel
                                    value={0}
                                    className="form-control-label"
                                    // control={<Radio disabled={scoDetails.scoP2FillFlag === 1 && CheckPermissions(permissions, 'General Services', 'New Connection', 'Workflow Permissions', 'Meter Installation', 'SCO P2 Creation')} />}
                                    control={
                                      <Radio
                                        disabled={
                                          dialogRowData?.applicationId?.slice(
                                            3,
                                            5
                                          ) !== "14" ||
                                          Boolean(
                                            scoDetails.scoP2FillFlag &&
                                            CheckPermissions(
                                              permissions,
                                              "General Services",
                                              "New Connection",
                                              "Workflow Permissions",
                                              "Meter Installation",
                                              "SCO P2 Creation"
                                            )
                                          )
                                        }
                                      />
                                    }
                                    label="Normal"
                                    name="Normal"
                                    labelPlacement="end"
                                    sx={{
                                      backgroundColor: "white",
                                      padding: "0px 10px",
                                      borderRadius: "5px",
                                      marginLeft: "0px",
                                      marginRight: "10px",
                                      border: "1px solid lightgrey",
                                    }}
                                  />
                                </RadioGroup>
                              </FormControl>
                              <Box className="form-error">
                                {scoPart2Formik.errors.iv_meter_type &&
                                  (scoPart2Formik.touched.iv_meter_type ||
                                    scoPart2Formik.submitCount > 0)
                                  ? scoPart2Formik.errors.iv_meter_type
                                  : null}
                              </Box>
                            </Grid>
                            <Grid item lg={1.5}>
                              <Typography
                                className="fieldLabel"
                                sx={{ fontSize: "16px", color: "#006ad1" }}
                              >
                                Meter Range
                              </Typography>
                              <TextField
                                name="iv_meter_range"
                                value={scoPart2Formik.values.iv_meter_range}
                                type="number"
                                inputProps={{ min: 5 }}
                                sx={{ width: '100%' }}
                                disabled={Boolean(
                                  scoDetails.scoP2FillFlag &&
                                  CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "New Connection",
                                    "Workflow Permissions",
                                    "Meter Installation",
                                    "SCO P2 Creation"
                                  )
                                )}
                                onChange={scoPart2Formik.handleChange}
                                onBlur={scoPart2Formik.handleBlur}
                                className="fieldCoverageMarla"
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_meter_range &&
                                  scoPart2Formik.touched.iv_meter_range
                                  ? scoPart2Formik.errors.iv_meter_range
                                  : null}
                              </p>
                            </Grid>
                            <Grid item lg={phase != "Single Phase" ? 2 : 1.5}>
                              <Typography
                                className="fieldLabel"
                                sx={{ fontSize: "16px", color: "#006ad1" }}
                              >
                                Meter Code{" "}
                                {phase != "Single Phase" ? "(Off Peak)" : ""}
                              </Typography>
                              <TextField
                                name="iv_meter_code1"
                                value={scoPart2Formik.values.iv_meter_code1}
                                type="text"
                                sx={{ width: '100%' }}
                                autoComplete="off"
                                disabled={Boolean(
                                  phase == "Single Phase" ||
                                  phase == "3 Phase" ||
                                  (scoDetails.scoP2FillFlag &&
                                    CheckPermissions(
                                      permissions,
                                      "General Services",
                                      "New Connection",
                                      "Workflow Permissions",
                                      "Meter Installation",
                                      "SCO P2 Creation"
                                    ))
                                )}
                                onChange={scoPart2Formik.handleChange}
                                onBlur={scoPart2Formik.handleBlur}
                                className="fieldCoverageMarla"
                                inputProps={{ maxLength: 6 }}
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_meter_code1 &&
                                  scoPart2Formik.touched.iv_meter_code1
                                  ? scoPart2Formik.errors.iv_meter_code1
                                  : null}
                              </p>
                            </Grid>
                            {phase != "Single Phase" && (
                              <>
                                <Grid
                                  item
                                  lg={phase != "Single Phase" ? 2 : 1.5}
                                >
                                  <Typography
                                    className="fieldLabel"
                                    sx={{ fontSize: "16px", color: "#006ad1" }}
                                  >
                                    Meter Code (Peak)
                                  </Typography>
                                  <TextField
                                    name="iv_meter_code2"
                                    value={scoPart2Formik.values.iv_meter_code2}
                                    type="text"
                                    autoComplete="off"
                                    sx={{ width: '100%' }}
                                    disabled={Boolean(
                                      phase == "3 Phase" ||
                                      (scoDetails.scoP2FillFlag &&
                                        CheckPermissions(
                                          permissions,
                                          "General Services",
                                          "New Connection",
                                          "Workflow Permissions",
                                          "Meter Installation",
                                          "SCO P2 Creation"
                                        ))
                                    )}
                                    onChange={scoPart2Formik.handleChange}
                                    onBlur={scoPart2Formik.handleBlur}
                                    className="fieldCoverageMarla"
                                    inputProps={{ maxLength: 6 }}
                                  />
                                  <p className="form-error">
                                    {scoPart2Formik.errors.iv_meter_code2 &&
                                      scoPart2Formik.touched.iv_meter_code2
                                      ? scoPart2Formik.errors.iv_meter_code2
                                      : null}
                                  </p>
                                </Grid>
                              </>
                            )}
                            {(dialogRowData.connectionType === "industrial" ||
                              dialogRowData.connectionType ===
                              "Industrial") && (
                                <Grid item lg={4}>
                                  <Typography className="fieldLabel">
                                    Seasonal / Non-Seasonal
                                  </Typography>
                                  <FormControl className="form-control">
                                    <RadioGroup
                                      className="radio-group"
                                      row
                                      name="iv_seasonal_flag"
                                      value={
                                        scoPart2Formik.values.iv_seasonal_flag
                                      }
                                      onChange={SeasonalNonSeasonal}
                                    >
                                      <FormControlLabel
                                        value={1}
                                        className="form-control-label"
                                        control={<Radio disabled />}
                                        label="Seasonal"
                                        labelPlacement="end"
                                        sx={{
                                          backgroundColor: "white",
                                          padding: "0px 10px",
                                          borderRadius: "5px",
                                          marginLeft: "0px",
                                          marginRight: "10px",
                                          border: "1px solid lightgrey",
                                        }}
                                      />
                                      <FormControlLabel
                                        value={0}
                                        className="form-control-label"
                                        control={<Radio disabled />}
                                        label="Non-Seasonal"
                                        labelPlacement="end"
                                        sx={{
                                          backgroundColor: "white",
                                          padding: "0px 10px",
                                          borderRadius: "5px",
                                          marginLeft: "0px",
                                          marginRight: "10px",
                                          border: "1px solid lightgrey",
                                        }}
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                  <p className="form-error">
                                    {scoPart2Formik.errors.iv_seasonal_flag &&
                                      scoPart2Formik.touched.iv_seasonal_flag
                                      ? scoPart2Formik.errors.iv_seasonal_flag
                                      : null}
                                  </p>
                                </Grid>
                              )}
                            <Grid item lg={1.7}>
                              <Typography className="fieldLabel">
                                Installed By
                              </Typography>
                              <TextField
                                name="iv_connection_installer_name"
                                value={
                                  scoPart2Formik.values
                                    .iv_connection_installer_name
                                }
                                type="text"
                                sx={{ width: '100%' }}
                                disabled
                                onChange={scoPart2Formik.handleChange}
                                onBlur={scoPart2Formik.handleBlur}
                                className="fieldCoverageMarla"
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors
                                  .iv_connection_installer_name &&
                                  scoPart2Formik.touched
                                    .iv_connection_installer_name
                                  ? scoPart2Formik.errors
                                    .iv_connection_installer_name
                                  : null}
                              </p>
                            </Grid>
                            <Grid item lg={1.6}>
                              <Typography className="fieldLabel">
                                Installation Date
                              </Typography>
                              <input
                                name="iv_date_of_connection"
                                value={
                                  scoPart2Formik.values.iv_date_of_connection
                                }
                                disabled={Boolean(
                                  scoDetails.scoP2FillFlag &&
                                  CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "New Connection",
                                    "Workflow Permissions",
                                    "Meter Installation",
                                    "SCO P2 Creation"
                                  )
                                )}
                                onChange={scoPart2Formik.handleChange}
                                onBlur={scoPart2Formik.handleBlur}
                                type="date"
                                className="fieldReferenceNo"
                                style={{
                                  width: "100%",
                                  height: "30px",
                                  borderWidth: "1px",
                                  borderRadius: "3px",
                                  borderColor: "lightgrey",
                                }}
                                min={
                                  scoPart2Formik.values
                                    .iv_store_requisition_date
                                }
                                max={new Date().toISOString().split("T")[0]}
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_date_of_connection
                                  ? scoPart2Formik.errors.iv_date_of_connection
                                  : null}
                              </p>
                            </Grid>
                            <Grid item lg={1.8}>
                              <Typography className="fieldLabel">
                                Transformer Code
                              </Typography>
                              <TextField
                                name="iv_transformer_code"
                                value={
                                  scoPart2Formik.values.iv_transformer_code
                                }
                                type="text"
                                fullWidth
                                onChange={scoPart2Formik.handleChange}
                                onBlur={scoPart2Formik.handleBlur}
                                className="fieldCoverageMarla"
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_transformer_code &&
                                  scoPart2Formik.touched.iv_transformer_code
                                  ? scoPart2Formik.errors.iv_transformer_code
                                  : null}
                              </p>
                            </Grid>
                            <Grid item lg={1.8}>
                              <Typography className="fieldLabel">
                                Transformer Ref No.
                              </Typography>
                              <TextField
                                name="iv_transformer_refNo"
                                value={
                                  scoPart2Formik.values.iv_transformer_refNo
                                }
                                type="text"
                                fullWidth
                                onChange={scoPart2Formik.handleChange}
                                onBlur={scoPart2Formik.handleBlur}
                                className="fieldCoverageMarla"
                                inputProps={{ maxLength: 14 }}
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_transformer_refNo &&
                                  scoPart2Formik.touched.iv_transformer_refNo
                                  ? scoPart2Formik.errors.iv_transformer_refNo
                                  : null}
                              </p>
                            </Grid>
                            <Grid item lg={7.2}>
                              <Typography
                                className="fieldLabel"
                                sx={{ fontSize: "16px", color: "#006ad1" }}
                              >
                                Meter Location
                              </Typography>
                              <FormControl className="form-control">
                                <RadioGroup
                                  className="radio-group"
                                  row
                                  name="iv_location_code"
                                  value={scoPart2Formik.values.iv_location_code}
                                  onChange={scoPart2Formik.handleChange}
                                >
                                  <FormControlLabel
                                    value={"P"}
                                    className="form-control-label"
                                    control={
                                      <Radio
                                        disabled={scoDetails.scoP2FillFlag == 1}
                                      />
                                    }
                                    label="Pole"
                                    labelPlacement="end"
                                    sx={{
                                      backgroundColor: "white",
                                      padding: "0px 10px",
                                      borderRadius: "5px",
                                      marginLeft: "0px",
                                      marginRight: "5px",
                                      border: "1px solid lightgrey",
                                    }}
                                  />
                                  <FormControlLabel
                                    value={"O"}
                                    className="form-control-label"
                                    control={
                                      <Radio
                                        disabled={scoDetails.scoP2FillFlag == 1}
                                      />
                                    }
                                    label="Outside"
                                    labelPlacement="end"
                                    sx={{
                                      backgroundColor: "white",
                                      padding: "0px 10px",
                                      borderRadius: "5px",
                                      marginLeft: "0px",
                                      marginRight: "10px",
                                      border: "1px solid lightgrey",
                                    }}
                                  />
                                  <FormControlLabel
                                    value={"I"}
                                    className="form-control-label"
                                    control={
                                      <Radio
                                        disabled={scoDetails.scoP2FillFlag == 1}
                                      />
                                    }
                                    label="Inside"
                                    labelPlacement="end"
                                    sx={{
                                      backgroundColor: "white",
                                      padding: "0px 10px",
                                      borderRadius: "5px",
                                      marginLeft: "0px",
                                      marginRight: "5px",
                                      border: "1px solid lightgrey",
                                    }}
                                  />
                                </RadioGroup>
                              </FormControl>
                              <Box className="form-error">
                                {scoPart2Formik.errors.iv_location_code &&
                                  scoPart2Formik.touched.iv_location_code
                                  ? scoPart2Formik.errors.iv_location_code
                                  : null}
                              </Box>
                            </Grid>
                            <Grid item lg={2.2}>
                              <Typography className="fieldLabel">
                                Installed Meter Image{" "}
                              </Typography>
                              {
                                <>
                                  <Box className="form-error">
                                    {scoPart2Formik.errors
                                      .iv_installed_meter_image
                                      ? scoPart2Formik.errors
                                        .iv_installed_meter_image
                                      : null}
                                  </Box>
                                  <Box className="form-error">
                                    {installedMeterImageError
                                      ? installedMeterImageError
                                      : null}
                                  </Box>
                                  {scoDetails.scoP2FillFlag == 1 ? (
                                    <>
                                      {
                                        <div
                                          onClick={() => {
                                            if (
                                              !installedMeterImageVerifyPopUp
                                            ) {
                                              setInstalledMeterImageVerifyPopUp(
                                                true
                                              );
                                            }
                                          }}
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          {installedMeterImage &&
                                            installedMeterImageThumbnail.slice(
                                              0,
                                              6
                                            ) === "data:i" ? (
                                            <Base64Image
                                              data={
                                                installedMeterImageThumbnail
                                              }
                                              width="80"
                                              height="100"
                                            />
                                          ) : (
                                            <Base64Image
                                              data={pdfIcon}
                                              width="80"
                                            />
                                          )}
                                          {installedMeterImageVerifyPopUp && (
                                            <OpenBase64ImageInPopup
                                              docVerifyPopUp={
                                                installedMeterImageVerifyPopUp
                                              }
                                              hideDocVerifyPopup={
                                                hideInstalledMeterImageVerifyAlert
                                              }
                                              documentName="Installed Meter Image"
                                              documentImage={
                                                installedMeterImageThumbnail
                                              }
                                              width={"100%"}
                                              document={
                                                installedMeterImageThumbnail
                                              }
                                              documentFlag=""
                                              applicationProgressId=""
                                              objectionStatus=""
                                              updateDocFlag=""
                                              titleToUpdateFlag=""
                                              flag_document=""
                                            />
                                          )}
                                        </div>
                                      }
                                    </>
                                  ) : (
                                    <Grid item lg={1}>
                                      {installedMeterImage ? (
                                        <>
                                          <Button
                                            varient="outlined"
                                            component="label"
                                            startIcon={
                                              <CloseIcon
                                                className="button-with-image"
                                                onClick={() => {
                                                  setInstalledMeterImage("");
                                                  setInstalledMeterImageThumbnail(
                                                    ""
                                                  );
                                                  setInstalledMeterImageError(
                                                    ""
                                                  );
                                                  scoPart2Formik.values.iv_installed_meter_image =
                                                    "";
                                                }}
                                              />
                                            }
                                          >
                                            {installedMeterImageThumbnail &&
                                              isImage(installedMeterImage) ? (
                                              <div className="btn-div">
                                                <img
                                                  src={
                                                    installedMeterImageThumbnail
                                                  }
                                                  alt="Installed Meter Image"
                                                  width="80"
                                                />
                                              </div>
                                            ) : (
                                              <span>
                                                {isPdf(installedMeterImage) ? (
                                                  <div className="btn-div">
                                                    <img
                                                      src={pdfIcon}
                                                      alt="PDF"
                                                      width="80"
                                                    />
                                                  </div>
                                                ) : (
                                                  "Other file type"
                                                )}
                                              </span>
                                            )}
                                          </Button>
                                        </>
                                      ) : (
                                        <>
                                          <Button
                                            disabled={Boolean(
                                              scoDetails.scoP2FillFlag &&
                                              CheckPermissions(
                                                permissions,
                                                "General Services",
                                                "New Connection",
                                                "Workflow Permissions",
                                                "Meter Installation",
                                                "SCO P2 Creation"
                                              )
                                            )}
                                            variant="outlined"
                                            component="label"
                                            startIcon={
                                              <FileUploadOutlinedIcon />
                                            }
                                            className="btn"
                                            sx={{ backgroundColor: "white" }}
                                          >
                                            Upload
                                            <input
                                              hidden
                                              accept={documentExtensions}
                                              id="iv_installed_meter_image"
                                              name="iv_installed_meter_image"
                                              type="file"
                                              onChange={InstalledMeterImage}
                                            />
                                          </Button>
                                        </>
                                      )}
                                    </Grid>
                                  )}
                                </>
                              }
                            </Grid>
                            <Grid
                              item
                              lg={12}
                              className="group-title-item"
                              sx={{ marginLeft: "20px" }}
                            >
                              <p className="group-title">Reading Information</p>
                            </Grid>
                            {phase === "Single Phase" && (
                              <Grid item lg={2.3}>
                                <Typography className="fieldLabel">
                                  Meter Reading
                                </Typography>
                                <TextField
                                  name="iv_meter_reading"
                                  value={scoPart2Formik.values.iv_meter_reading}
                                  type="text"
                                  fullWidth
                                  disabled={Boolean(
                                    scoDetails.scoP2FillFlag &&
                                    CheckPermissions(
                                      permissions,
                                      "General Services",
                                      "New Connection",
                                      "Workflow Permissions",
                                      "Meter Installation",
                                      "SCO P2 Creation"
                                    )
                                  )}
                                  onChange={scoPart2Formik.handleChange}
                                  onBlur={scoPart2Formik.handleBlur}
                                  className="fieldCoverageMarla"
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors.iv_meter_reading &&
                                    scoPart2Formik.touched.iv_meter_reading
                                    ? scoPart2Formik.errors.iv_meter_reading
                                    : null}
                                </p>
                              </Grid>
                            )}
                            {(phase === "3 Phase" ||
                              phase === "MDI (LT)(CT)" ||
                              phase === "MDI (HT)(CT/PT)") && (
                                <>
                                  <Grid item lg={1.5}>
                                    <Typography className="fieldLabel">
                                      Peak (kWh)
                                    </Typography>
                                    <TextField
                                      name="iv_meter_reading_peak_kwh"
                                      value={
                                        scoPart2Formik.values
                                          .iv_meter_reading_peak_kwh
                                      }
                                      type="text"
                                      fullWidth
                                      disabled={Boolean(
                                        scoDetails.scoP2FillFlag &&
                                        CheckPermissions(
                                          permissions,
                                          "General Services",
                                          "New Connection",
                                          "Workflow Permissions",
                                          "Meter Installation",
                                          "SCO P2 Creation"
                                        )
                                      )}
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {scoPart2Formik.errors
                                        .iv_meter_reading_peak_kwh &&
                                        scoPart2Formik.touched
                                          .iv_meter_reading_peak_kwh
                                        ? scoPart2Formik.errors
                                          .iv_meter_reading_peak_kwh
                                        : null}
                                    </p>
                                  </Grid>
                                  <Grid item lg={1.5}>
                                    <Typography className="fieldLabel">
                                      Off Peak (kWh)
                                    </Typography>
                                    <TextField
                                      name="iv_meter_reading_off_peak_kwh"
                                      value={
                                        scoPart2Formik.values
                                          .iv_meter_reading_off_peak_kwh
                                      }
                                      type="text"
                                      fullWidth
                                      disabled={Boolean(
                                        scoDetails.scoP2FillFlag &&
                                        CheckPermissions(
                                          permissions,
                                          "General Services",
                                          "New Connection",
                                          "Workflow Permissions",
                                          "Meter Installation",
                                          "SCO P2 Creation"
                                        )
                                      )}
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {scoPart2Formik.errors
                                        .iv_meter_reading_off_peak_kwh &&
                                        scoPart2Formik.touched
                                          .iv_meter_reading_off_peak_kwh
                                        ? scoPart2Formik.errors
                                          .iv_meter_reading_off_peak_kwh
                                        : null}
                                    </p>
                                  </Grid>
                                </>
                              )}
                            {(phase === "MDI (LT)(CT)" ||
                              phase === "MDI (HT)(CT/PT)") && (
                                <>
                                  <Grid item lg={1.5}>
                                    <Typography className="fieldLabel">
                                      Peak (kVARh)
                                    </Typography>
                                    <TextField
                                      name="iv_meter_reading_peak_kvarh"
                                      value={
                                        scoPart2Formik.values
                                          .iv_meter_reading_peak_kvarh
                                      }
                                      type="text"
                                      fullWidth
                                      disabled={Boolean(
                                        scoDetails.scoP2FillFlag &&
                                        CheckPermissions(
                                          permissions,
                                          "General Services",
                                          "New Connection",
                                          "Workflow Permissions",
                                          "Meter Installation",
                                          "SCO P2 Creation"
                                        )
                                      )}
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {scoPart2Formik.errors
                                        .iv_meter_reading_peak_kvarh &&
                                        scoPart2Formik.touched
                                          .iv_meter_reading_peak_kvarh
                                        ? scoPart2Formik.errors
                                          .iv_meter_reading_peak_kvarh
                                        : null}
                                    </p>
                                  </Grid>
                                  <Grid item lg={1.5}>
                                    <Typography className="fieldLabel">
                                      Off Peak (kVARh)
                                    </Typography>
                                    <TextField
                                      name="iv_meter_reading_off_peak_kvarh"
                                      value={
                                        scoPart2Formik.values
                                          .iv_meter_reading_off_peak_kvarh
                                      }
                                      type="text"
                                      fullWidth
                                      disabled={Boolean(
                                        scoDetails.scoP2FillFlag &&
                                        CheckPermissions(
                                          permissions,
                                          "General Services",
                                          "New Connection",
                                          "Workflow Permissions",
                                          "Meter Installation",
                                          "SCO P2 Creation"
                                        )
                                      )}
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {scoPart2Formik.errors
                                        .iv_meter_reading_off_peak_kvarh &&
                                        scoPart2Formik.touched
                                          .iv_meter_reading_off_peak_kvarh
                                        ? scoPart2Formik.errors
                                          .iv_meter_reading_off_peak_kvarh
                                        : null}
                                    </p>
                                  </Grid>
                                  <Grid item lg={1.5}>
                                    <Typography className="fieldLabel">
                                      MDI
                                    </Typography>
                                    <TextField
                                      name="iv_mdi"
                                      value={scoPart2Formik.values.iv_mdi}
                                      type="text"
                                      fullWidth
                                      disabled={Boolean(
                                        scoDetails.scoP2FillFlag &&
                                        CheckPermissions(
                                          permissions,
                                          "General Services",
                                          "New Connection",
                                          "Workflow Permissions",
                                          "Meter Installation",
                                          "SCO P2 Creation"
                                        )
                                      )}
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {scoPart2Formik.errors.iv_mdi &&
                                        scoPart2Formik.touched.iv_mdi
                                        ? scoPart2Formik.errors.iv_mdi
                                        : null}
                                    </p>
                                  </Grid>
                                  <Grid item lg={1.5}>
                                    <Typography className="fieldLabel">
                                      No. of MDI Resets
                                    </Typography>
                                    <TextField
                                      name="iv_no_of_mdi_resets"
                                      value={
                                        scoPart2Formik.values.iv_no_of_mdi_resets
                                      }
                                      type="text"
                                      fullWidth
                                      disabled={Boolean(
                                        scoDetails.scoP2FillFlag &&
                                        CheckPermissions(
                                          permissions,
                                          "General Services",
                                          "New Connection",
                                          "Workflow Permissions",
                                          "Meter Installation",
                                          "SCO P2 Creation"
                                        )
                                      )}
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                    <p className="form-error">
                                      {scoPart2Formik.errors
                                        .iv_no_of_mdi_resets &&
                                        scoPart2Formik.touched.iv_no_of_mdi_resets
                                        ? scoPart2Formik.errors
                                          .iv_no_of_mdi_resets
                                        : null}
                                    </p>
                                  </Grid>
                                  <Grid item lg={2}></Grid>
                                  <Grid item lg={2}>
                                    <Typography className="fieldLabel">
                                      CT Ratio
                                    </Typography>
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "3px",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Select
                                        sx={{ width: "100%" }}
                                        value={scoPart2Formik.values.iv_ct_nom == 0 ? 5 : scoPart2Formik.values.iv_ct_nom}
                                        onChange={scoPart2Formik.handleChange}
                                        onBlur={scoPart2Formik.handleBlur}
                                        displayEmpty
                                        disabled={
                                          scoDetails.scoP2FillFlag == 1
                                          // CheckPermissions(
                                          //   permissions,
                                          //   "General Services",
                                          //   "New Connection",
                                          //   "Workflow Permissions",
                                          //   "Meter Installation",
                                          //   "SCO P2 Creation"
                                          // )
                                        }
                                        className="fieldBatch1"
                                        name="iv_ct_nom"
                                        id="iv_ct_nom"
                                        MenuProps={{
                                          PaperProps: {
                                            style: {
                                              width: 35,
                                            },
                                          },
                                        }}
                                      >
                                        <MenuItem
                                          value=""
                                          sx={{ fontSize: "12px" }}
                                        >
                                          Select CT
                                        </MenuItem>

                                        <MenuItem
                                          value="5"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          5
                                        </MenuItem>
                                        <MenuItem
                                          value="100"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          100
                                        </MenuItem>
                                        <MenuItem
                                          value="200"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          200
                                        </MenuItem>
                                        <MenuItem
                                          value="300"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          300
                                        </MenuItem>
                                        <MenuItem
                                          value="400"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          400
                                        </MenuItem>
                                        <MenuItem
                                          value="600"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          600
                                        </MenuItem>
                                        <MenuItem
                                          value="800"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          800
                                        </MenuItem>
                                        <MenuItem
                                          value="1000"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          1000
                                        </MenuItem>
                                      </Select>
                                      /
                                      <TextField
                                        name="iv_ct_denom"
                                        value={scoPart2Formik.values.iv_ct_denom == 0 ? 5 : scoPart2Formik.values.iv_ct_denom}
                                        type="text"
                                        autoComplete="off"
                                        fullWidth
                                        disabled={true}
                                        onChange={scoPart2Formik.handleChange}
                                        onBlur={scoPart2Formik.handleBlur}
                                        className="fieldCoverageMarla"
                                      />
                                    </div>
                                    <p className="form-error">
                                      {scoPart2Formik.errors.iv_ct_nom &&
                                        scoPart2Formik.touched.iv_ct_nom
                                        ? scoPart2Formik.errors.iv_ct_nom
                                        : null}
                                    </p>
                                    <p className="form-error">
                                      {scoPart2Formik.errors.iv_ct_denom &&
                                        scoPart2Formik.touched.iv_ct_denom
                                        ? scoPart2Formik.errors.iv_ct_denom
                                        : null}
                                    </p>
                                  </Grid>
                                  {phase != "Single Phase" &&
                                    phase != "3 Phase" &&
                                    phase != "MDI (LT)(CT)" && (
                                      <Grid item lg={2}>
                                        <Typography className="fieldLabel">
                                          PT Ratio
                                        </Typography>
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "3px",
                                            alignItems: "center",
                                          }}
                                        >
                                          <TextField
                                            name="iv_pt_nom"
                                            value={
                                              scoPart2Formik.values.iv_pt_nom
                                            }
                                            type="text"
                                            fullWidth
                                            disabled={true}
                                            onChange={scoPart2Formik.handleChange}
                                            onBlur={scoPart2Formik.handleBlur}
                                            className="fieldCoverageMarla"
                                          />
                                          /
                                          <TextField
                                            name="iv_pt_denom"
                                            value={
                                              scoPart2Formik.values.iv_pt_denom
                                            }
                                            type="text"
                                            fullWidth
                                            disabled={true}
                                            onChange={scoPart2Formik.handleChange}
                                            onBlur={scoPart2Formik.handleBlur}
                                            className="fieldCoverageMarla"
                                          />
                                        </div>
                                        <p className="form-error">
                                          {scoPart2Formik.errors.iv_pt_nom &&
                                            scoPart2Formik.touched.iv_pt_nom
                                            ? scoPart2Formik.errors.iv_pt_nom
                                            : null}
                                        </p>
                                        <p className="form-error">
                                          {scoPart2Formik.errors.iv_pt_denom &&
                                            scoPart2Formik.touched.iv_pt_denom
                                            ? scoPart2Formik.errors.iv_pt_denom
                                            : null}
                                        </p>
                                      </Grid>
                                    )}

                                  <Grid item lg={1}>
                                    <Typography className="fieldLabel">
                                      MF
                                    </Typography>
                                    <input
                                      name="iv_mf"
                                      value={
                                        (() => {
                                          const val = calculateMF(
                                            scoPart2Formik.values.iv_ct_nom,
                                            scoPart2Formik.values.iv_ct_denom,
                                            scoPart2Formik.values.iv_pt_nom,
                                            scoPart2Formik.values.iv_pt_denom
                                          );

                                          return !isFinite(val) || val === 0 ? 1 : val;
                                        })()
                                      }
                                      type="text"
                                      disabled
                                      style={{
                                        backgroundColor: "#006ad1",
                                        color: "white",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        border: "none",
                                        width: "90%",
                                        fontSize: "18px",
                                      }}
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                  </Grid>
                                </>
                              )}
                          </Grid>
                        </>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            Meter Installation is in process by the sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 9 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <Grid
                        className="step-title"
                        container
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Grid item>
                          <h4 style={{ fontWeight: "normal" }}>
                            Ready For Billing
                          </h4>
                        </Grid>
                        <Grid item></Grid>
                      </Grid>
                      <Grid
                        container
                        className="ready-for-billing-cards-container"
                      >
                        <Grid item className="connection-information-container">
                          <Grid container className="data-container">
                            {!showUpdateBatchPopup ? (
                              <Grid item lg={2} className="item">
                                <Typography className="title">
                                  Ref. No.
                                </Typography>
                                <Typography
                                  className="value"
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  {scoDetails && scoDetails.batch
                                    ? scoDetails.batch
                                      .concat(dialogRowData.subDivisionCode)
                                      .concat(dnDetails.consumerAccountNo)
                                    : "-"}{" "}
                                  {/* <img
                                    src={pencilIcon}
                                    alt={"pencil"}
                                    height={"15"}
                                    style={{ cursor: "pointer" }}
                                    onClick={handleBatchEditClick}
                                  /> */}
                                </Typography>
                              </Grid>
                            ) : (
                              <Grid item lg={2} className="item">
                                <Typography className="title">
                                  Ref. No.
                                </Typography>
                                <Typography
                                  className="value"
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <select
                                    value={masterDataFormik.values.iv_batch}
                                    onChange={masterDataFormik.handleChange}
                                    onBlur={masterDataFormik.handleBlur}
                                    displayEmpty
                                    className="fieldBatch"
                                    name="iv_batch"
                                    id="iv_batch"
                                  >
                                    {batchArray.map((option) => (
                                      <option
                                        key={option}
                                        value={option}
                                        sx={{ fontSize: "12px" }}
                                      >
                                        {option}
                                      </option>
                                    ))}
                                  </select>
                                  <Box className="form-error">
                                    {masterDataFormik.errors.iv_batch &&
                                      masterDataFormik.touched.iv_batch
                                      ? masterDataFormik.errors.iv_batch
                                      : null}
                                  </Box>
                                  {scoDetails
                                    ? dnDetails.consumerAccountNo
                                    : "-"}
                                </Typography>
                              </Grid>
                            )}
                            <Grid item lg={1} className="item">
                              <Typography className="title">S/Batch</Typography>
                              <Typography className="value">
                                {scoDetails.subBatch
                                  ? scoDetails.subBatch
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1.25} className="item">
                              <Typography className="title">Tariff</Typography>
                              <Typography className="value">
                                {dnDetails ? dnDetails.tariff.slice(0, 7) : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1.5} className="item">
                              <Typography className="title">App. Id</Typography>
                              <Typography className="value">
                                {dnDetails
                                  ? dnDetails.tariff
                                    .slice(0, 1)
                                    .concat(
                                      dialogRowData.applicationId.slice(5)
                                    )
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1.5} className="item">
                              <Typography className="title">
                                Reg. Date
                              </Typography>
                              <Typography className="value">
                                {dialogRowData
                                  ? convertDate(dialogRowData.creationDate)
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1.5} className="item">
                              <Typography className="title">
                                Sec. Dept.
                              </Typography>
                              <Typography className="value">
                                {dnDetails.securityDepositeAmount
                                  ? numberFormatting(
                                    dnDetails.securityDepositeAmount
                                  )
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1.5} className="item">
                              <Typography className="title">
                                Pay Date
                              </Typography>
                              <Typography className="value">
                                {dnDetails
                                  ? convertDate(dnDetails.paymentDate)
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1.75} className="item">
                              <Typography className="title">
                                Conn Date
                              </Typography>
                              <Typography className="value">
                                {scoDetails.dateOfConnection
                                  ? convertDate(scoDetails.dateOfConnection)
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1} className="item">
                              <Typography className="title">
                                Sanc. Load
                              </Typography>
                              <Typography className="value">
                                {scoDetails.senctionLoad
                                  ? scoDetails.senctionLoad
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1} className="item">
                              <Typography className="title">R/U</Typography>
                              <Typography className="value">
                                {scoDetails.urbanRural
                                  ? scoDetails.urbanRural
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1} className="item">
                              <Typography className="title">F/P</Typography>
                              <Typography className="value">
                                {scoDetails.fataPata
                                  ? scoDetails.fataPata
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1} className="item">
                              <Typography className="title">
                                Seasonal
                              </Typography>
                              <Typography className="value">
                                {scoDetails.seasonalFlag
                                  ? scoDetails.seasonalFlag
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1.5} className="item">
                              <Typography className="title">
                                Transformer Code
                              </Typography>
                              <Typography className="value">
                                {scoDetails.installedTransformerCapacity
                                  ? scoDetails.installedTransformerCapacity
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1.5} className="item">
                              <Typography className="title">
                                Location Code
                              </Typography>
                              <Typography className="value">
                                {scoDetails.locationCode
                                  ? scoDetails.locationCode
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1.5} className="item">
                              <Typography className="title">
                                Meter Type
                              </Typography>
                              <Typography className="value">
                                {scoDetails.meterType
                                  ? getMeterType(scoDetails.meterType)
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1.75} className="item">
                              <Typography className="title">
                                Store Req. No.
                              </Typography>
                              <Typography className="value">
                                {scoDetails.storeRequisitionNo
                                  ? scoDetails.storeRequisitionNo
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1.75} className="item">
                              <Typography className="title">
                                Req. Date
                              </Typography>
                              <Typography className="value">
                                {scoDetails.storeRequisitionDate
                                  ? convertDate(scoDetails.storeRequisitionDate)
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1.75} className="item">
                              <Typography className="title">
                                SIM ID
                              </Typography>
                              <Typography className="value">
                                {scoDetails.simId
                                  ? scoDetails.simId
                                  : "N/A"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1.75} className="item">
                              <Typography className="title">
                                SIM Number
                              </Typography>
                              <Typography className="value">
                                {scoDetails.simNumber
                                  ? scoDetails.simNumber
                                  : "N/A"}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item className="meter-information-container">
                          <Grid container className="data-container">
                            <Grid item lg={1.5} className="item">
                              <Typography className="title">
                                Feeder Code
                              </Typography>
                              <Typography className="value">
                                {scoDetails.feederNo
                                  ? scoDetails.feederNo
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1.5} className="item">
                              <Typography className="title">
                                Manufacturer Code
                              </Typography>
                              <Typography className="value">
                                {scoDetails.manufacturerCode
                                  ? scoDetails.manufacturerCode
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={1.5} className="item">
                              <Typography className="title">
                                Meter Serial No.
                              </Typography>
                              <Typography className="value">
                                {scoDetails.meterNo ? scoDetails.meterNo : "-"}
                              </Typography>
                            </Grid>
                            {phase == "3 Phase" && (
                              <>
                                <Grid item lg={1.5} className="item">
                                  <Typography className="title">
                                    Peak (kWh)
                                  </Typography>
                                  <Typography className="value">
                                    {scoDetails.threePhasePeak
                                      ? scoDetails.threePhasePeak
                                      : "-"}
                                  </Typography>
                                </Grid>
                                <Grid item lg={1.5} className="item">
                                  <Typography className="title">
                                    Off Peak (kWh)
                                  </Typography>
                                  <Typography className="value">
                                    {scoDetails.threePhaseOffPeak
                                      ? scoDetails.threePhaseOffPeak
                                      : "-"}
                                  </Typography>
                                </Grid>
                              </>
                            )}
                            {(phase === "MDI (LT)(CT)" ||
                              phase === "MDI (HT)(CT/PT)") && (
                                <>
                                  <Grid item lg={1.5} className="item">
                                    <Typography className="title">
                                      Peak (kWh)
                                    </Typography>
                                    <Typography className="value">
                                      {scoDetails.threePhasePeakKWH
                                        ? scoDetails.threePhasePeakKWH
                                        : "-"}
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={1.5} className="item">
                                    <Typography className="title">
                                      Off Peak (kWh)
                                    </Typography>
                                    <Typography className="value">
                                      {scoDetails.threePhaseOffPeakKWH
                                        ? scoDetails.threePhaseOffPeakKWH
                                        : "-"}
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={1.5} className="item">
                                    <Typography className="title">
                                      Peak (kVARh)
                                    </Typography>
                                    <Typography className="value">
                                      {scoDetails.threePhasePeakKVARH
                                        ? scoDetails.threePhasePeakKVARH
                                        : "-"}
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={1.5} className="item">
                                    <Typography className="title">
                                      Off Peak (kVARh)
                                    </Typography>
                                    <Typography className="value">
                                      {scoDetails.threePhaseOffPeakKVARH
                                        ? scoDetails.threePhaseOffPeakKVARH
                                        : "-"}
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={1.5} className="item">
                                    <Typography className="title">MDI</Typography>
                                    <Typography className="value">
                                      {scoDetails.mdi ? scoDetails.mdi : "-"}
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={1.5} className="item">
                                    <Typography className="title">
                                      No. of MDI Resets
                                    </Typography>
                                    <Typography className="value">
                                      {scoDetails.noOfMDIreset
                                        ? scoDetails.noOfMDIreset
                                        : "-"}
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={1.5} className="item">
                                    <Typography className="title">
                                      CT Ratio
                                    </Typography>
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "3px",
                                        alignItems: "center",
                                        width: "100%",
                                      }}
                                    >
                                      <Typography
                                        className="value"
                                        style={{ width: "100px" }}
                                      >
                                        {scoDetails.cTN ? scoDetails.cTN : "-"}
                                      </Typography>
                                      /
                                      <Typography
                                        className="value"
                                        style={{ width: "100px" }}
                                      >
                                        {scoDetails.cTD ? scoDetails.cTD : "-"}
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item lg={1.5} className="item">
                                    <Typography className="title">
                                      PT Ration
                                    </Typography>
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "3px",
                                        alignItems: "center",
                                        width: "100%",
                                      }}
                                    >
                                      <Typography
                                        className="value"
                                        style={{ width: "100px" }}
                                      >
                                        {scoDetails.pTN ? scoDetails.pTN : "-"}
                                      </Typography>
                                      /
                                      <Typography
                                        className="value"
                                        style={{ width: "100px" }}
                                      >
                                        {scoDetails.pTD ? scoDetails.pTD : "-"}
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item lg={1.5} className="item">
                                    <Typography className="title">MF</Typography>
                                    <Typography className="value">
                                      {scoDetails.multiplyingFactor
                                        ? scoDetails.multiplyingFactor
                                        : "-"}
                                    </Typography>
                                  </Grid>
                                </>
                              )}
                            {phase === "Single Phase" && (
                              <Grid item lg={2} className="item">
                                <Typography className="title">
                                  Initial Reading
                                </Typography>
                                <Typography className="value">
                                  {scoDetails.meterReading
                                    ? scoDetails.meterReading
                                    : "-"}
                                </Typography>
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        spacing={2}
                        className="field-survey-container"
                        sx={{}}
                      >
                        <Grid item lg={2.5} sx={{ marginLeft: "2%" }}>
                          <Typography
                            className="fieldLabel"
                            sx={{ fontSize: "16px", color: "#006ad1" }}
                          >
                            Government Department
                          </Typography>
                          <FormControl className="form-control">
                            <RadioGroup
                              className="radio-group"
                              row
                              name="iv_govt_dept"
                              value={masterDataFormik.values.iv_govt_dept}
                              onChange={GovtDept}
                              disabled={true}
                            >
                              <FormControlLabel
                                value={1}
                                className="form-control-label"
                                control={<Radio disabled={true} />}
                                label="Yes"
                                name="Yes"
                                labelPlacement="end"
                                sx={{
                                  backgroundColor: "white",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                  marginLeft: "0px",
                                  marginRight: "5px",
                                  border: "1px solid lightgrey",
                                }}
                              />
                              <FormControlLabel
                                value={0}
                                className="form-control-label"
                                control={<Radio disabled={true} />}
                                label="No"
                                name="No"
                                labelPlacement="end"
                                sx={{
                                  backgroundColor: "white",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                  marginLeft: "0px",
                                  marginRight: "10px",
                                  border: "1px solid lightgrey",
                                }}
                              />
                            </RadioGroup>
                          </FormControl>
                          <Box className="form-error">
                            {masterDataFormik.errors.iv_govt_dept &&
                              masterDataFormik.touched.iv_govt_dept
                              ? masterDataFormik.errors.iv_govt_dept
                              : null}
                          </Box>
                        </Grid>
                        <Grid item lg={2}>
                          <Typography className="fieldLabel">
                            Electricity Duty
                          </Typography>
                          <Select
                            sx={{ width: "100%" }}
                            value={masterDataFormik.values.iv_ed_code}
                            onChange={masterDataFormik.handleChange}
                            onBlur={masterDataFormik.handleBlur}
                            displayEmpty
                            disabled={
                              masterDataFormDetails.filledByFlag === 1 &&
                              CheckPermissions(
                                permissions,
                                "General Services",
                                "New Connection",
                                "Workflow Permissions",
                                "Ready For Billing",
                                "Master Data Form Creation"
                              )
                            }
                            className="fieldBatch1"
                            name="iv_ed_code"
                            id="iv_ed_code"
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  width: 35,
                                },
                              },
                            }}
                          >
                            <MenuItem value="" sx={{ fontSize: "12px" }}>
                              Select ED Code
                            </MenuItem>
                            {masterDataFormik.values.iv_govt_dept == 0
                              ? [0, 1].map((option) => (
                                <MenuItem
                                  sx={{ fontSize: "12px" }}
                                  key={option}
                                  value={option}
                                >
                                  {option}
                                </MenuItem>
                              ))
                              : [5, 6].map((option) => (
                                <MenuItem
                                  sx={{ fontSize: "12px" }}
                                  key={option}
                                  value={option}
                                >
                                  {option}
                                </MenuItem>
                              ))}
                          </Select>
                          <p className="form-error">
                            {masterDataFormik.errors.iv_ed_code &&
                              masterDataFormik.touched.iv_ed_code
                              ? masterDataFormik.errors.iv_ed_code
                              : null}
                          </p>
                        </Grid>
                        <Grid item lg={4}>
                          <Typography className="fieldLabel">
                            Std. Class. Code
                          </Typography>
                          <Autocomplete
                            id="iv_standard_classification_code"
                            name="iv_standard_classification_code"
                            value={
                              standardClassificationCode
                                ? standardClassificationCode
                                : null
                            }
                            options={standardClassificationCodes}
                            suppressDefaultValueWarning
                            // className='fieldBatch1'
                            // getOptionLabel={(option) => option.XCLFM_CODE ? `${option.XCLFM_CODE}${option.XCLFM_DESC}` : ''}
                            getOptionLabel={(option) =>
                              option.XCLFM_CODE && option.XCLFM_DESC
                                ? `${option.XCLFM_CODE} - ${option.XCLFM_DESC}`
                                : ""
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                className="fieldBatch1"
                                value={inputValue}
                                onChange={(e) => setInputValue(e.target.value)}
                                disabled={
                                  masterDataFormDetails.filledByFlag === 1 &&
                                  CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "New Connection",
                                    "Workflow Permissions",
                                    "Ready For Billing",
                                    "Master Data Form Creation"
                                  )
                                }
                                sx={{
                                  "& .MuiInputBase-input": {
                                    fontSize: "13px",
                                    height: "12px",
                                  },
                                }}
                              />
                            )}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 100, // adjust the maximum height of the menu
                                },
                              },
                              ListboxProps: {
                                style: {
                                  fontSize: "10px", // set the font size of the options
                                },
                              },
                            }}
                            onChange={(event, value) => {
                              if (value) {
                                setStandardClassificationCode(value);
                                masterDataFormik.setFieldValue(
                                  "iv_standard_classification_code",
                                  value.XCLFM_CODE
                                );
                              }
                            }}
                            filterOptions={(options) =>
                              filterOptions(
                                options,
                                { inputValue: debouncedInputValue },
                                ["XCLFM_CODE", "XCLFM_DESC"]
                              )
                            }
                          />
                          <p className="form-error">
                            {masterDataFormik.errors
                              .iv_standard_classification_code &&
                              masterDataFormik.touched
                                .iv_standard_classification_code
                              ? masterDataFormik.errors
                                .iv_standard_classification_code
                              : null}
                          </p>
                        </Grid>
                        <Grid item lg={3}>
                          <Typography className="fieldLabel">
                            Exempt Income Tax ?
                          </Typography>
                          <FormControl className="form-control">
                            <RadioGroup
                              className="radio-group"
                              row
                              name="iv_income_tax"
                              value={masterDataFormik.values.iv_income_tax}
                              onChange={IncomeTax}
                            >
                              <FormControlLabel
                                value={1}
                                className="form-control-label"
                                control={
                                  <Radio
                                    disabled={
                                      masterDataFormDetails.filledByFlag ===
                                      1 &&
                                      CheckPermissions(
                                        permissions,
                                        "General Services",
                                        "New Connection",
                                        "Workflow Permissions",
                                        "Ready For Billing",
                                        "Master Data Form Creation"
                                      )
                                    }
                                  />
                                }
                                label="Yes"
                                name="Yes"
                                labelPlacement="end"
                                sx={{
                                  backgroundColor: "white",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                  marginLeft: "0px",
                                  marginRight: "10px",
                                  border: "1px solid lightgrey",
                                }}
                              />
                              <FormControlLabel
                                value={0}
                                className="form-control-label"
                                control={
                                  <Radio
                                    disabled={
                                      masterDataFormDetails.filledByFlag ===
                                      1 &&
                                      CheckPermissions(
                                        permissions,
                                        "General Services",
                                        "New Connection",
                                        "Workflow Permissions",
                                        "Ready For Billing",
                                        "Master Data Form Creation"
                                      )
                                    }
                                  />
                                }
                                label="No"
                                name="No"
                                labelPlacement="end"
                                sx={{
                                  backgroundColor: "white",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                  marginLeft: "0px",
                                  marginRight: "10px",
                                  border: "1px solid lightgrey",
                                }}
                              />
                            </RadioGroup>
                          </FormControl>
                          <Box className="form-error">
                            {masterDataFormik.errors.iv_income_tax &&
                              masterDataFormik.touched.iv_income_tax
                              ? masterDataFormik.errors.iv_income_tax
                              : null}
                          </Box>
                        </Grid>
                      </Grid>
                    </>
                  ) : dialogRowData.applicationProgressId === 9 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <h3 className="step-title">
                        Ready For Billing Objection
                      </h3>
                      <div className="description-box">
                        <p className="group-description">
                          <InfoIcon className="icon" />
                          Unable to get details. Please contact sub division
                          office.
                        </p>
                      </div>
                    </>
                  ) : dialogRowData.applicationProgressId === 10 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <div
                        className="step-title"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "1%",
                          alignItems: "center",
                        }}
                      >
                        <h4
                          style={{
                            textAlign: "center",
                            width: "100%",
                            marginTop: "0.5%",
                          }}
                        >
                          New Connection Application
                        </h4>
                        <Button
                          variant="outlined"
                          onClick={() => downloadMasterData(dialogRowData)}
                          sx={{
                            backgroundColor: "white",
                            cursor: "pointer",
                            border: "1px solid #006ad1",
                            boxShadow: "none",
                            width: "12%",
                          }}
                        >
                          <PrintIcon
                            sx={{ color: "#006ad1", marginLeft: "1%" }}
                          />
                          {dialogRowData.connectionType != "Domestic" &&
                            dialogRowData.connectionType != "Commercial"
                            ? "CP-137"
                            : "CP-136"}{" "}
                        </Button>
                      </div>
                      <Box
                        sx={{
                          color: "#00B091",
                          marginTop: "2%",
                          backgroundColor: "#DFFFE4",
                          padding: "1%",
                          width: "95%",
                          display: "flex",
                          flexDirection: "row",
                          marginLeft: "1%",
                        }}
                      >
                        <ErrorIcon
                          style={{ color: "#00B091", marginLeft: "1%" }}
                        />
                        <h4
                          style={{
                            marginLeft: "10px",
                            fontSize: "1vw",
                            fontWeight: "normal",
                          }}
                        >
                          Application Process is Complete.
                        </h4>
                      </Box>
                    </>
                  ) : null}
                </div>
                {isReleventToUser == true ? (
                  <div className="actions">
                    {dialogRowData.applicationProgressId === 0 ? (
                      <>
                        {CheckPermissions(
                          permissions,
                          "General Services",
                          "New Connection",
                          "Basic Permissions",
                          "Update"
                        ) ? (
                          <button
                            onClick={() =>
                              navigate("/new-connection-update", {
                                state: { dialogRowData },
                              })
                            }
                            className="view-button"
                          >
                            Upload Pending Documents
                          </button>
                        ) : null}
                      </>
                    ) : dialogRowData.applicationProgressId === 1 &&
                      (dialogRowData.objectionStatus === 0 ||
                        dialogRowData.objectionStatus === 2) ? (
                      CheckPermissions(
                        permissions,
                        "General Services",
                        "New Connection",
                        "Workflow Permissions",
                        "Document Verification"
                      ) && (
                        <>
                          {dialogRowData.ownerNOCFlag !== 1 ||
                            dialogRowData.premisesDocumentFlag !== 1 ||
                            dialogRowData.copyOfApplicantCNICFrontFlag !== 1 ||
                            dialogRowData.copyOfApplicantCNICBackFlag !== 1 ||
                            dialogRowData.scannedCopyOfNearByElectricityBillFlag !==
                            1 ||
                            dialogRowData.anyOtherDocumentFlag !== 1 ||
                            dialogRowData.copyOfOwnerCNICFrontFlag !== 1 ||
                            dialogRowData.copyOfOwnerCNICBackFlag !== 1 ||
                            dialogRowData.resolutionFormDescFlag !== 1 ||
                            dialogRowData.certFormDescFlag !== 1 ||
                            dialogRowData.certMemoDescFlag !== 1 ? (
                            <>
                              <button
                                disabled={
                                  dialogRowData.applicationId?.startsWith("NC-14")
                                    ? !flag_copyOfApplicantCNICFront ||
                                    (dialogRowData.anyOtherDocument && flag_anyOtherDocument !== 1 && flag_anyOtherDocument !== -1) || !flag_premisesDocument
                                    : !flag_copyOfApplicantCNICFront || !flag_premisesDocument
                                }
                                onClick={() => updateDocumentStatus()}
                                className="view-button"
                                style={{
                                  backgroundColor:
                                    flag_copyOfApplicantCNICFront === -1 ||
                                      flag_copyOfApplicantCNICBack === -1 ||
                                      flag_premisesDocument === -1 ||
                                      flag_scannedCopyOfNearByElectricityBill ===
                                      -1 ||
                                      flag_anyOtherDocument === -1 ||
                                      flag_copyOfOwnerCNICFront === -1 ||
                                      flag_copyOfOwnerCNICBack === -1 ||
                                      flag_ownerNOC === -1 ||
                                      flag_resolutionFormDesc === -1 ||
                                      flag_certMemoDesc === -1 ||
                                      flag_certFormDesc === -1
                                      ? "#E11B3C"
                                      : "#003971",
                                }}
                              >
                                {flag_copyOfApplicantCNICFront === -1 ||
                                  flag_copyOfApplicantCNICBack === -1 ||
                                  flag_premisesDocument === -1 ||
                                  flag_scannedCopyOfNearByElectricityBill ===
                                  -1 ||
                                  flag_anyOtherDocument === -1 ||
                                  flag_copyOfOwnerCNICFront === -1 ||
                                  flag_copyOfOwnerCNICBack === -1 ||
                                  flag_ownerNOC === -1 ||
                                  flag_resolutionFormDesc === -1 ||
                                  flag_certMemoDesc === -1 ||
                                  flag_certFormDesc === -1
                                  ? "Reject"
                                  : "Verify"}
                              </button>
                            </>
                          ) : null}
                        </>
                      )
                    ) : dialogRowData.applicationProgressId === 1 &&
                      dialogRowData.objectionStatus === 1 ? (
                      <>
                        {CheckPermissions(
                          permissions,
                          "General Services",
                          "New Connection",
                          "Basic Permissions",
                          "Update"
                        ) ? (
                          <>
                            <button
                              onClick={() => {
                                setOpen(false);
                                navigate("/new-connection-update", {
                                  state: { dialogRowData },
                                });
                              }}
                              className="view-button"
                            >
                              Re-Upload Document
                            </button>
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : dialogRowData.applicationProgressId === 21 && (dialogRowData.objectionStatus !== 1 || dialogRowData.objectionStatus == 2) ? (
                      <>
                        {dialogRowData.wiringTestReportDocument ? (
                          CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Wiring Test Report"
                          ) && (
                            <button
                              disabled={flag_wiringTestReport === null}
                              onClick={() => {
                                if (flag_wiringTestReport === 1) {
                                  verifyOrRejectWiringTestReport(dialogRowData.applicationId, 2, 0, 'Wiring Test Report Verified', 1, 'Wiring Test Report Verified');
                                } else if (flag_wiringTestReport === -1) {
                                  verifyOrRejectWiringTestReport(dialogRowData.applicationId, 21, 1, 'Wiring Test Report Rejected', -1, wiringTestReportObjectionRemarks);
                                }
                              }}
                              className="view-button"
                              style={{
                                backgroundColor:
                                  flag_wiringTestReport === -1
                                    ? "#E11B3C"
                                    : flag_wiringTestReport === 1
                                      ? "#003971"
                                      : "#cccccc",
                              }}
                            >
                              {flag_wiringTestReport === -1 ? "Reject" : "Verify"}
                            </button>
                          )
                        ) : (
                          CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Basic Permissions",
                            "Update"
                          ) && (
                            <button
                              disabled={!newWiringTestReportDocumentThumbnail}
                              onClick={uploadWiringTestReport}
                              className="view-button"
                              style={{
                                backgroundColor: newWiringTestReportDocumentThumbnail ? "#003971" : "#cccccc",
                                cursor: newWiringTestReportDocumentThumbnail ? "pointer" : "not-allowed"
                              }}
                            >
                              Submit
                            </button>
                          )
                        )}
                      </>
                    ) : dialogRowData.applicationProgressId === 21 && dialogRowData.objectionStatus === 1 ? (
                      <>
                        {
                          CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Basic Permissions",
                            "Update"
                          )
                          &&

                          <button
                            disabled={!newWiringTestReportDocumentThumbnail}
                            onClick={reuploadWiringTestReportAndRemoveObjection}
                            className="view-button"
                            style={{
                              marginRight: "10px",
                              backgroundColor: newWiringTestReportDocumentThumbnail ? "#003971" : "#cccccc",
                              cursor: newWiringTestReportDocumentThumbnail ? "pointer" : "not-allowed"
                            }}
                          >
                            Remove Objection
                          </button>

                        }
                      </>
                    )
                      :
                      dialogRowData.applicationProgressId === 2 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "New Connection",
                          "Workflow Permissions",
                          "Arrears Verification"
                        ) &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "New Connection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "15"
                        ) &&
                          dialogRowData.appliedLoad > 0 &&
                          dialogRowData.appliedLoad <= 15 &&
                          ((CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A1"
                          ) &&
                            allTariffList &&
                            getTariff(
                              dialogRowData.appliedLoad,
                              dialogRowData.connectionType,
                              dialogRowData.seasonalNonSeasonalFlag,
                              allTariffList
                            )?.startsWith("A1")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "New Connection",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A2"
                            ) &&
                              allTariffList &&
                              getTariff(
                                dialogRowData.appliedLoad,
                                dialogRowData.connectionType,
                                dialogRowData.seasonalNonSeasonalFlag,
                                allTariffList
                              )?.startsWith("A2")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "New Connection",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A3"
                            ) &&
                              allTariffList &&
                              getTariff(
                                dialogRowData.appliedLoad,
                                dialogRowData.connectionType,
                                dialogRowData.seasonalNonSeasonalFlag,
                                allTariffList
                              )?.startsWith("A3")))) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "70"
                          ) &&
                            dialogRowData.appliedLoad > 0 &&
                            dialogRowData.appliedLoad <= 70 &&
                            // ✅ Tariff A1, A2, A3 nahi hone chahiye
                            !["A1", "A2", "A3"].some((tariffCode) =>
                              getTariff(
                                dialogRowData.appliedLoad,
                                dialogRowData.connectionType,
                                dialogRowData.seasonalNonSeasonalFlag,
                                allTariffList
                              )
                                ?.toUpperCase()
                                .startsWith(tariffCode)
                            )) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "70"
                          ) &&
                            dialogRowData.appliedLoad > 15 &&
                            dialogRowData.appliedLoad <= 70) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "500"
                          ) &&
                            dialogRowData.appliedLoad > 70 &&
                            dialogRowData.appliedLoad <= 500) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "5000"
                          ) &&
                            dialogRowData.appliedLoad > 500)) && (
                          <>
                            <button
                              disabled={
                                arrearFlag == 1 &&
                                (noArrears ||
                                  error ||
                                  arearsFormik.values.iv_property_reference_no
                                    .length != 14 ||
                                  (arrearsDetailsRefno.arrearsAmount && (!arearsFormik.values.iv_arrears_remarks?.trim() || arearsFormik.values.iv_arrears_remarks?.trim().length < 10)))
                              }
                              onClick={async () => {
                                await arearsFormik.handleSubmit();
                              }}
                              className="view-button"
                            >
                              Submit
                            </button>
                          </>
                        )
                      ) : dialogRowData.applicationProgressId === 2 &&
                        dialogRowData.objectionStatus === 1 ? (
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "New Connection",
                          "Workflow Permissions",
                          "Arrear Bill Uploading"
                        ) && (
                          <>
                            <button
                              onClick={showRejectionRemovalAlert}
                              className="view-button"
                              style={{ marginRight: "10px" }}
                            >
                              Remove Objection
                            </button>
                          </>
                        )
                      ) : dialogRowData.applicationProgressId === 3 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        <>
                          {
                            // CheckPermissions(permissions, 'General Services', 'New Connection', 'Workflow Permissions', 'Field Survey', 'Survey Form Creation') &&
                            CheckPermissions(
                              permissions,
                              "General Services",
                              "New Connection",
                              "Workflow Permissions",
                              "Field Survey"
                            ) &&
                            ((CheckPermissions(
                              permissions,
                              "General Services",
                              "New Connection",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "15"
                            ) &&
                              dialogRowData.appliedLoad > 0 &&
                              dialogRowData.appliedLoad <= 15 &&
                              ((CheckPermissions(
                                permissions,
                                "General Services",
                                "New Connection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Tariff Authority",
                                "A1"
                              ) &&
                                allTariffList &&
                                getTariff(
                                  dialogRowData.appliedLoad,
                                  dialogRowData.connectionType,
                                  dialogRowData.seasonalNonSeasonalFlag,
                                  allTariffList
                                )?.startsWith("A1")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "New Connection",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A2"
                                ) &&
                                  allTariffList &&
                                  getTariff(
                                    dialogRowData.appliedLoad,
                                    dialogRowData.connectionType,
                                    dialogRowData.seasonalNonSeasonalFlag,
                                    allTariffList
                                  )?.startsWith("A2")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "New Connection",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A3"
                                ) &&
                                  allTariffList &&
                                  getTariff(
                                    dialogRowData.appliedLoad,
                                    dialogRowData.connectionType,
                                    dialogRowData.seasonalNonSeasonalFlag,
                                    allTariffList
                                  )?.startsWith("A3")))) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "New Connection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "70"
                              ) &&
                                dialogRowData.appliedLoad > 0 &&
                                dialogRowData.appliedLoad <= 70 &&
                                // ✅ Tariff A1, A2, A3 nahi hone chahiye
                                !["A1", "A2", "A3"].some((tariffCode) =>
                                  getTariff(
                                    dialogRowData.appliedLoad,
                                    dialogRowData.connectionType,
                                    dialogRowData.seasonalNonSeasonalFlag,
                                    allTariffList
                                  )
                                    ?.toUpperCase()
                                    .startsWith(tariffCode)
                                )) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "New Connection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "70"
                              ) &&
                                dialogRowData.appliedLoad > 15 &&
                                dialogRowData.appliedLoad <= 70) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "New Connection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "500"
                              ) &&
                                dialogRowData.appliedLoad > 70 &&
                                dialogRowData.appliedLoad <= 500) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "New Connection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "5000"
                              ) &&
                                dialogRowData.appliedLoad > 500)) && (
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    marginTop: "-40px",
                                    alignItems: "flex-end",
                                    gap: "0px",
                                  }}
                                >
                                  {CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "New Connection",
                                    "Workflow Permissions",
                                    "Field Survey",
                                    "Assign Task to Field Staff"
                                  ) && (
                                      <button
                                        onClick={() => {
                                          setLinemanAllocationSubPopUp(true);
                                        }}
                                        type="submit"
                                        className="view-button"
                                        style={{ marginBottom: "10px" }}
                                      >
                                        Assign To Field Staff
                                      </button>
                                    )}
                                  <button
                                    disabled={
                                      fieldFormik.values.iv_objection_Type === "Other" &&
                                      (!fieldFormik.values.iv_objection_Descripton?.trim() ||
                                        fieldFormik.values.iv_objection_Descripton?.trim().length < 10)
                                    }
                                    onClick={async () => {
                                      await fieldFormik.handleSubmit();
                                    }}
                                    type="submit"
                                    className="view-button"
                                    style={{ margin: "0%" }}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </>
                            )
                          }
                        </>
                      ) : dialogRowData.applicationProgressId === 3 &&
                        dialogRowData.objectionStatus === 1 ? (
                        <>
                          {
                            // CheckPermissions(permissions, 'General Services', 'New Connection', 'Workflow Permissions', 'Field Survey') ?
                            CheckPermissions(
                              permissions,
                              "General Services",
                              "New Connection",
                              "Workflow Permissions",
                              "Field Survey"
                            ) &&
                              ((CheckPermissions(
                                permissions,
                                "General Services",
                                "New Connection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "15"
                              ) &&
                                dialogRowData.appliedLoad > 0 &&
                                dialogRowData.appliedLoad <= 15 &&
                                ((CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "New Connection",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A1"
                                ) &&
                                  allTariffList &&
                                  getTariff(
                                    dialogRowData.appliedLoad,
                                    dialogRowData.connectionType,
                                    dialogRowData.seasonalNonSeasonalFlag,
                                    allTariffList
                                  )?.startsWith("A1")) ||
                                  (CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "New Connection",
                                    "Workflow Permissions",
                                    "Approval Category",
                                    "Tariff Authority",
                                    "A2"
                                  ) &&
                                    allTariffList &&
                                    getTariff(
                                      dialogRowData.appliedLoad,
                                      dialogRowData.connectionType,
                                      dialogRowData.seasonalNonSeasonalFlag,
                                      allTariffList
                                    )?.startsWith("A2")) ||
                                  (CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "New Connection",
                                    "Workflow Permissions",
                                    "Approval Category",
                                    "Tariff Authority",
                                    "A3"
                                  ) &&
                                    allTariffList &&
                                    getTariff(
                                      dialogRowData.appliedLoad,
                                      dialogRowData.connectionType,
                                      dialogRowData.seasonalNonSeasonalFlag,
                                      allTariffList
                                    )?.startsWith("A3")))) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "New Connection",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Load Sanctioning",
                                  "70"
                                ) &&
                                  dialogRowData.appliedLoad > 0 &&
                                  dialogRowData.appliedLoad <= 70 &&
                                  // ✅ Tariff A1, A2, A3 nahi hone chahiye
                                  !["A1", "A2", "A3"].some((tariffCode) =>
                                    getTariff(
                                      dialogRowData.appliedLoad,
                                      dialogRowData.connectionType,
                                      dialogRowData.seasonalNonSeasonalFlag,
                                      allTariffList
                                    )
                                      ?.toUpperCase()
                                      .startsWith(tariffCode)
                                  )) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "New Connection",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Load Sanctioning",
                                  "70"
                                ) &&
                                  dialogRowData.appliedLoad > 15 &&
                                  dialogRowData.appliedLoad <= 70) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "New Connection",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Load Sanctioning",
                                  "500"
                                ) &&
                                  dialogRowData.appliedLoad > 70 &&
                                  dialogRowData.appliedLoad <= 500) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "New Connection",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Load Sanctioning",
                                  "5000"
                                ) &&
                                  dialogRowData.appliedLoad > 500)) ? (
                              <>
                                <button
                                  onClick={showFieldRejectionRemovalAlert}
                                  className="view-button"
                                >
                                  Remove Objection
                                </button>
                              </>
                            ) : (
                              <>
                                {CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "New Connection",
                                  "Basic Permissions",
                                  "Update"
                                ) &&
                                  dialogRowData.remarks ===
                                  "Load at site exceeds than applied." && (
                                    <button
                                      onClick={appliedLoadFormik.handleSubmit}
                                      className="view-button"
                                    >
                                      Update
                                    </button>
                                  )}
                              </>
                            )
                          }
                        </>
                      ) : dialogRowData.applicationProgressId === 4 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        <>
                          {/* {
                                            CheckPermissions(permissions, 'General Services', 'New Connection', 'Workflow Permissions', 'Reference No. Allocation') &&
                                            <button onClick={() => {
                                              refNoAllocationFormik.handleSubmit();
                                            }} disabled={dnDetails.filledFlag === 1 || refNoAlreadyAllocatedError} style={{ display: dnDetails.filledFlag === 1 ? 'none' : 'block' }} type='submit' className='view-button' >Submit</button>
                                          } */}
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Reference No. Allocation"
                          ) &&
                            ((CheckPermissions(
                              permissions,
                              "General Services",
                              "New Connection",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "15"
                            ) &&
                              dialogRowData.appliedLoad > 0 &&
                              dialogRowData.appliedLoad <= 15 &&
                              ((CheckPermissions(
                                permissions,
                                "General Services",
                                "New Connection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Tariff Authority",
                                "A1"
                              ) &&
                                allTariffList &&
                                getTariff(
                                  dialogRowData.appliedLoad,
                                  dialogRowData.connectionType,
                                  dialogRowData.seasonalNonSeasonalFlag,
                                  allTariffList
                                )?.startsWith("A1")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "New Connection",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A2"
                                ) &&
                                  allTariffList &&
                                  getTariff(
                                    dialogRowData.appliedLoad,
                                    dialogRowData.connectionType,
                                    dialogRowData.seasonalNonSeasonalFlag,
                                    allTariffList
                                  )?.startsWith("A2")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "New Connection",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A3"
                                ) &&
                                  allTariffList &&
                                  getTariff(
                                    dialogRowData.appliedLoad,
                                    dialogRowData.connectionType,
                                    dialogRowData.seasonalNonSeasonalFlag,
                                    allTariffList
                                  )?.startsWith("A3")))) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "New Connection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "70"
                              ) &&
                                dialogRowData.appliedLoad > 0 &&
                                dialogRowData.appliedLoad <= 70 &&
                                // ✅ Tariff A1, A2, A3 nahi hone chahiye
                                !["A1", "A2", "A3"].some((tariffCode) =>
                                  getTariff(
                                    dialogRowData.appliedLoad,
                                    dialogRowData.connectionType,
                                    dialogRowData.seasonalNonSeasonalFlag,
                                    allTariffList
                                  )
                                    ?.toUpperCase()
                                    .startsWith(tariffCode)
                                )) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "New Connection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "70"
                              ) &&
                                dialogRowData.appliedLoad > 15 &&
                                dialogRowData.appliedLoad <= 70) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "New Connection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "500"
                              ) &&
                                dialogRowData.appliedLoad > 70 &&
                                dialogRowData.appliedLoad <= 500) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "New Connection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "5000"
                              ) &&
                                dialogRowData.appliedLoad > 500)) && (
                              <Box>
                                <button
                                  onClick={() => {
                                    refNoAllocationFormik.handleSubmit();
                                  }}
                                  disabled={
                                    dnDetails.filledFlag === 1 ||
                                    refNoAlreadyAllocatedError
                                  }
                                  style={{
                                    display:
                                      dnDetails.filledFlag === 1
                                        ? "none"
                                        : "block",
                                  }}
                                  type="submit"
                                  className="view-button"
                                >
                                  Submit
                                </button>

                                {refNoAlreadyAllocatedError && (
                                  <Box
                                    sx={{
                                      color: "red",
                                      fontSize: "20px",
                                      marginTop: "5px",
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {refNoAlreadyAllocatedError}
                                  </Box>
                                )}
                              </Box>
                            )}

                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Reference No. Allocation"
                          ) &&
                            CheckPermissions(
                              permissions,
                              "General Services",
                              "New Connection",
                              "Workflow Permissions",
                              "Demand Note Approval"
                            ) &&
                            ((CheckPermissions(
                              permissions,
                              "General Services",
                              "New Connection",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "15"
                            ) &&
                              dialogRowData.appliedLoad > 0 &&
                              dialogRowData.appliedLoad <= 15 &&
                              ((CheckPermissions(
                                permissions,
                                "General Services",
                                "New Connection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Tariff Authority",
                                "A1"
                              ) &&
                                allTariffList &&
                                getTariff(
                                  dialogRowData.appliedLoad,
                                  dialogRowData.connectionType,
                                  dialogRowData.seasonalNonSeasonalFlag,
                                  allTariffList
                                )?.startsWith("A1")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "New Connection",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A2"
                                ) &&
                                  allTariffList &&
                                  getTariff(
                                    dialogRowData.appliedLoad,
                                    dialogRowData.connectionType,
                                    dialogRowData.seasonalNonSeasonalFlag,
                                    allTariffList
                                  )?.startsWith("A2")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "New Connection",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A3"
                                ) &&
                                  allTariffList &&
                                  getTariff(
                                    dialogRowData.appliedLoad,
                                    dialogRowData.connectionType,
                                    dialogRowData.seasonalNonSeasonalFlag,
                                    allTariffList
                                  )?.startsWith("A3")))) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "New Connection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "70"
                              ) &&
                                dialogRowData.appliedLoad > 0 &&
                                dialogRowData.appliedLoad <= 70 &&
                                // ✅ Tariff A1, A2, A3 nahi hone chahiye
                                !["A1", "A2", "A3"].some((tariffCode) =>
                                  getTariff(
                                    dialogRowData.appliedLoad,
                                    dialogRowData.connectionType,
                                    dialogRowData.seasonalNonSeasonalFlag,
                                    allTariffList
                                  )
                                    ?.toUpperCase()
                                    .startsWith(tariffCode)
                                )) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "New Connection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "70"
                              ) &&
                                dialogRowData.appliedLoad > 15 &&
                                dialogRowData.appliedLoad <= 70) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "New Connection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "500"
                              ) &&
                                dialogRowData.appliedLoad > 70 &&
                                dialogRowData.appliedLoad <= 500) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "New Connection",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "5000"
                              ) &&
                                dialogRowData.appliedLoad > 500)) &&
                            dnDetails &&
                            dnDetails.filledFlag &&
                            dnDetails.filledFlag === 1 ? (
                            <div>
                              <button
                                onClick={refNoAllocationFormik.handleSubmit}
                                type="submit"
                                className="view-button"
                              >
                                Approve
                              </button>
                              <button
                                onClick={() => {
                                  showObjectionPopup();
                                }}
                                className="reject-button"
                                style={{ float: "right", marginRight: "10px" }}
                              >
                                Reject
                              </button>
                            </div>
                          ) : null}
                        </>
                      ) : dialogRowData.applicationProgressId === 4 &&
                        dialogRowData.objectionStatus === 1 ? (
                        <></>
                      ) : dialogRowData.applicationProgressId === 5 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        <>
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "DN Image Uploading"
                          ) && (
                              <button
                                className="view-button"
                                onClick={dnPymentReceiptFormik.handleSubmit}
                              >
                                Submit
                              </button>
                            )}
                        </>
                      ) : dialogRowData.applicationProgressId === 5 &&
                        dialogRowData.objectionStatus === 1 ? (
                        <></>
                      ) : dialogRowData.applicationProgressId === 6 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "New Connection",
                          "Workflow Permissions",
                          "Demand Note Verification"
                        ) &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "New Connection",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "15"
                        ) &&
                          dialogRowData.appliedLoad > 0 &&
                          dialogRowData.appliedLoad <= 15 &&
                          ((CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A1"
                          ) &&
                            allTariffList &&
                            getTariff(
                              dialogRowData.appliedLoad,
                              dialogRowData.connectionType,
                              dialogRowData.seasonalNonSeasonalFlag,
                              allTariffList
                            )?.startsWith("A1")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "New Connection",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A2"
                            ) &&
                              allTariffList &&
                              getTariff(
                                dialogRowData.appliedLoad,
                                dialogRowData.connectionType,
                                dialogRowData.seasonalNonSeasonalFlag,
                                allTariffList
                              )?.startsWith("A2")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "New Connection",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A3"
                            ) &&
                              allTariffList &&
                              getTariff(
                                dialogRowData.appliedLoad,
                                dialogRowData.connectionType,
                                dialogRowData.seasonalNonSeasonalFlag,
                                allTariffList
                              )?.startsWith("A3")))) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "70"
                          ) &&
                            dialogRowData.appliedLoad > 0 &&
                            dialogRowData.appliedLoad <= 70 &&
                            // ✅ Tariff A1, A2, A3 nahi hone chahiye
                            !["A1", "A2", "A3"].some((tariffCode) =>
                              getTariff(
                                dialogRowData.appliedLoad,
                                dialogRowData.connectionType,
                                dialogRowData.seasonalNonSeasonalFlag,
                                allTariffList
                              )
                                ?.toUpperCase()
                                .startsWith(tariffCode)
                            )) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "70"
                          ) &&
                            dialogRowData.appliedLoad > 15 &&
                            dialogRowData.appliedLoad <= 70) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "500"
                          ) &&
                            dialogRowData.appliedLoad > 70 &&
                            dialogRowData.appliedLoad <= 500) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "5000"
                          ) &&
                            dialogRowData.appliedLoad > 500)) && (
                          <div>
                            <button
                              onClick={() => {
                                callDNPaymentVerification(
                                  dialogRowData.applicationId,
                                  dialogRowData.applicationProgressId + 2,
                                  "DN Payment Verified",
                                  0,
                                  "DN Payment Verified",
                                  1
                                );
                              }}
                              className="view-button"
                            >
                              Verify
                            </button>
                            <button
                              onClick={() => {
                                callDNPaymentVerification(
                                  dialogRowData.applicationId,
                                  dialogRowData.applicationProgressId - 1,
                                  "DN Payment Rejected",
                                  0,
                                  "DN Payment Rejected",
                                  0
                                );
                              }}
                              className="reject-button"
                              style={{ float: "right", marginRight: "10px" }}
                            >
                              Reject
                            </button>
                          </div>
                        )
                      ) : dialogRowData.applicationProgressId === 6 &&
                        dialogRowData.objectionStatus === 1 ? (
                        <></>
                      ) : dialogRowData.applicationProgressId === 8 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        <>
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Meter Installation"
                          ) ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  marginTop: "-40px",
                                  alignItems: "flex-end",
                                  gap: "0px",
                                }}
                              >
                                {scoDetails.scoP2FillFlag === null ||
                                  scoDetails.scoP2FillFlag === 0 ? (
                                  // Only "Load Sanctioning" "15" permission holder can fill the form
                                  CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "New Connection",
                                    "Workflow Permissions",
                                    "Approval Category",
                                    "Load Sanctioning",
                                    "15"
                                  ) ? (
                                    <>
                                      {CheckPermissions(
                                        permissions,
                                        "General Services",
                                        "New Connection",
                                        "Workflow Permissions",
                                        "Field Survey",
                                        "Assign Task to Field Staff"
                                      ) && (
                                          <button
                                            onClick={() =>
                                              setLinemanAllocationSubPopUp(true)
                                            }
                                            type="submit"
                                            className="view-button"
                                            style={{ marginBottom: "-15px" }}
                                          >
                                            Assign To Field Staff
                                          </button>
                                        )}
                                      <button
                                        onClick={() =>
                                          scoPart2Formik.handleSubmit()
                                        }
                                        type="submit"
                                        className="view-button"
                                        disabled={scoDetails.scoP2FillFlag === 1}
                                      >
                                        Submit
                                      </button>
                                    </>
                                  ) : (
                                    <Alert sx={{ marginTop: '30px', color: 'red', marginRight: '370px' }} severity="error">
                                      Form filling is only allowed for sanctioned load authority.
                                    </Alert>
                                  )
                                ) : scoDetails.scoP2FillFlag === 1 &&
                                  (CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "New Connection",
                                    "Workflow Permissions",
                                    "Meter Installation",
                                    "SCO P1 Approval"
                                  ) ||
                                    CheckPermissions(
                                      permissions,
                                      "General Services",
                                      "New Connection",
                                      "Workflow Permissions",
                                      "Meter Installation",
                                      "SCO P2 Approval"
                                    )) && (
                                    // Load <= 15 with Tariff Authority checks (A1, A2, A3)
                                    (CheckPermissions(
                                      permissions,
                                      "General Services",
                                      "New Connection",
                                      "Workflow Permissions",
                                      "Approval Category",
                                      "Load Sanctioning",
                                      "15"
                                    ) &&
                                      dialogRowData.appliedLoad > 0 &&
                                      dialogRowData.appliedLoad <= 15 &&
                                      ((CheckPermissions(
                                        permissions,
                                        "General Services",
                                        "New Connection",
                                        "Workflow Permissions",
                                        "Approval Category",
                                        "Tariff Authority",
                                        "A1"
                                      ) &&
                                        allTariffList &&
                                        getTariff(
                                          dialogRowData.appliedLoad,
                                          dialogRowData.connectionType,
                                          dialogRowData.seasonalNonSeasonalFlag,
                                          allTariffList
                                        )?.startsWith("A1")) ||
                                        (CheckPermissions(
                                          permissions,
                                          "General Services",
                                          "New Connection",
                                          "Workflow Permissions",
                                          "Approval Category",
                                          "Tariff Authority",
                                          "A2"
                                        ) &&
                                          allTariffList &&
                                          getTariff(
                                            dialogRowData.appliedLoad,
                                            dialogRowData.connectionType,
                                            dialogRowData.seasonalNonSeasonalFlag,
                                            allTariffList
                                          )?.startsWith("A2")) ||
                                        (CheckPermissions(
                                          permissions,
                                          "General Services",
                                          "New Connection",
                                          "Workflow Permissions",
                                          "Approval Category",
                                          "Tariff Authority",
                                          "A3"
                                        ) &&
                                          allTariffList &&
                                          getTariff(
                                            dialogRowData.appliedLoad,
                                            dialogRowData.connectionType,
                                            dialogRowData.seasonalNonSeasonalFlag,
                                            allTariffList
                                          )?.startsWith("A3")))) ||
                                    // Load <= 70 for non-A1/A2/A3 tariffs
                                    (CheckPermissions(
                                      permissions,
                                      "General Services",
                                      "New Connection",
                                      "Workflow Permissions",
                                      "Approval Category",
                                      "Load Sanctioning",
                                      "70"
                                    ) &&
                                      dialogRowData.appliedLoad > 0 &&
                                      dialogRowData.appliedLoad <= 70 &&
                                      !["A1", "A2", "A3"].some((tariffCode) =>
                                        getTariff(
                                          dialogRowData.appliedLoad,
                                          dialogRowData.connectionType,
                                          dialogRowData.seasonalNonSeasonalFlag,
                                          allTariffList
                                        )
                                          ?.toUpperCase()
                                          .startsWith(tariffCode)
                                      )) ||
                                    // Load > 15 && <= 70: "Load Sanctioning" "70" permission
                                    (CheckPermissions(
                                      permissions,
                                      "General Services",
                                      "New Connection",
                                      "Workflow Permissions",
                                      "Approval Category",
                                      "Load Sanctioning",
                                      "70"
                                    ) &&
                                      dialogRowData.appliedLoad > 15 &&
                                      dialogRowData.appliedLoad <= 70) ||
                                    // Load > 70 && <= 500: "Load Sanctioning" "500" permission
                                    (CheckPermissions(
                                      permissions,
                                      "General Services",
                                      "New Connection",
                                      "Workflow Permissions",
                                      "Approval Category",
                                      "Load Sanctioning",
                                      "500"
                                    ) &&
                                      dialogRowData.appliedLoad > 70 &&
                                      dialogRowData.appliedLoad <= 500) ||
                                    // Load > 500: "Load Sanctioning" "5000" permission
                                    (CheckPermissions(
                                      permissions,
                                      "General Services",
                                      "New Connection",
                                      "Workflow Permissions",
                                      "Approval Category",
                                      "Load Sanctioning",
                                      "5000"
                                    ) &&
                                      dialogRowData.appliedLoad > 500)
                                  ) ? (
                                  <div style={{ width: "300px", display: "flex", gap: "10px" }}>
                                    <button
                                      onClick={() => {
                                        setMeterInstallationRejectAlert(true)
                                      }}
                                      className="reject-button"
                                      style={{ flex: 1 }}
                                    >
                                      Reject
                                    </button>
                                    <button
                                      onClick={async () => {
                                        const errors = await scoPart2Formik.validateForm();
                                        if (Object.keys(errors).length > 0) {
                                          const touchedFields = {};
                                          Object.keys(scoPart2Formik.values).forEach(key => touchedFields[key] = true);
                                          scoPart2Formik.setTouched(touchedFields);
                                          const errorMessages = Object.entries(errors).map(([key, value]) => `${key}: ${value}`).join('\n');
                                          alert('Validation Errors:\n' + errorMessages);
                                          return;
                                        }
                                        scoPart2Formik.handleSubmit();
                                      }}
                                      type="submit"
                                      className="view-button"
                                      style={{ flex: 1 }}
                                    >
                                      Approve
                                    </button>
                                  </div>
                                ) : (
                                  <Alert sx={{ marginTop: '30px', color: 'red', marginRight: '370px' }} severity="error">
                                    Meter Installation is in process by the sanctioning authority.
                                  </Alert>
                                )}
                              </div>
                            ) : (
                              <Alert sx={{ marginTop: '30px', color: 'red', marginRight: '370px' }} severity="error">
                                Form filling is only allowed for sanctioned load authority.
                              </Alert>
                            )}
                        </>
                      ) : dialogRowData.applicationProgressId === 9 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        <>
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Ready For Billing",
                            "Master Data Form Creation"
                          ) && (
                              <>
                                {(masterDataFormDetails.filledByFlag == null ||
                                  masterDataFormDetails.filledByFlag == 0) && (
                                    <button
                                      onClick={() => {
                                        masterDataFormik.handleSubmit();
                                      }}
                                      type="submit"
                                      className="view-button"
                                      disabled={
                                        masterDataFormDetails.filledByFlag === 1
                                      }
                                    >
                                      Submit
                                    </button>
                                  )}
                              </>
                            )}
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "New Connection",
                            "Workflow Permissions",
                            "Ready For Billing",
                            "Master Data Form Approval"
                          ) && (
                              <>
                                {masterDataFormDetails.filledByFlag === 1 && (
                                  <>
                                    <button
                                      onClick={masterDataFormik.handleSubmit}
                                      type="submit"
                                      className="view-button"
                                      disabled={
                                        masterDataFormDetails.filledByFlag === null
                                      }
                                      style={{ marginLeft: "10px" }}
                                    >
                                      Approve
                                    </button>
                                    {/* <button className='reject-button' style={{ float: 'right', marginRight: '10px' }} onClick={() => { updateCpFlag(dialogRowData.applicationId) }} >
                                                                  Reject
                                                                </button> */}
                                  </>
                                )}
                              </>
                            )}
                        </>
                      ) : dialogRowData.applicationProgressId === 9 &&
                        dialogRowData.objectionStatus === 1 ? (
                        <></>
                      ) : dialogRowData.applicationProgressId === 10 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        <></>
                      ) : null}
                  </div>
                ) : (
                  <div
                    style={{
                      margin: "auto",
                      padding: "10px",
                      backgroundColor: "#C46500",
                      color: "white",
                      borderRadius: "5px",
                      textAlign: "center",
                    }}
                  >
                    <p style={{ fontSize: "20px" }}>
                      Application doesn't belongs to your office.
                    </p>
                  </div>
                )}
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {/* Basic Info Update Dialog */}
      <Dialog
        open={showEditPopup}
        onClose={() => {
          setShowEditPopup(false);
          editBasicInfoFormik.resetForm();
        }}
        fullWidth={true}
        maxWidth="xl"
        className="alert-popups"
      >
        <DialogTitle className="dialog-title">
          Basic Information
          <Box sx={{ marginTop: "1%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setShowEditPopup(false);
                editBasicInfoFormik.resetForm();
              }}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <DialogContentText component="div" className="dialog-content-text">
            <Typography variant="h6" className="group-title">
              <div className="redCell"></div>
              Applicant's Details
            </Typography>
          </DialogContentText>
          <DialogContentText component="div" className="dialog-content-text">
            <div className="field-container">
              <Typography className="fieldLabel"> Type</Typography>
              <Select
                autoWidth={false}
                autoFocus
                value={editBasicInfoFormik.values.iv_connection_type}
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
                displayEmpty
                className="connectionTypeDropDownList"
                name="iv_connection_type"
                id="iv_connection_type"
              >
                <MenuItem value="">Select Type</MenuItem>
                {connectionTypesList.map((type) => (
                  <MenuItem key={type.connectionTypeName} value={type.connectionTypeName}>
                    {type.connectionTypeName}
                  </MenuItem>
                ))}
              </Select>
              <Box className="from-Error">
                {editBasicInfoFormik.errors.iv_connection_type &&
                  editBasicInfoFormik.touched.iv_connection_type
                  ? editBasicInfoFormik.errors.iv_connection_type
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography className="fieldLabel">Name</Typography>
              <TextField
                required
                type="text"
                name="iv_applicant_name"
                value={editBasicInfoFormik.values.iv_applicant_name}
                autoComplete="off"
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
                id="iv_applicant_name"
                className="textfield"
              />
              <Box className="from-Error">
                {editBasicInfoFormik.errors.iv_applicant_name &&
                  editBasicInfoFormik.touched.iv_applicant_name
                  ? editBasicInfoFormik.errors.iv_applicant_name
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography className="fieldLabel">
                NIC. / CNIC. / NICOP.
              </Typography>
              <TextField
                required
                type="text"
                name="iv_applicant_cnic"
                value={editBasicInfoFormik.values.iv_applicant_cnic}
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
                id="iv_applicant_cnic"
                className="textfield"
                inputProps={{ maxLength: 13, autoComplete: "off" }}
              />
              <Box className="from-Error">
                {editBasicInfoFormik.errors.iv_applicant_cnic &&
                  editBasicInfoFormik.touched.iv_applicant_cnic
                  ? editBasicInfoFormik.errors.iv_applicant_cnic
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography className="fieldLabel">&nbsp;</Typography>
              <FormControl className="form-control">
                <RadioGroup
                  className="radio-group"
                  row
                  name="iv_relation_type"
                  defaultValue={editBasicInfoFormik.values.iv_relation_type}
                  value={editBasicInfoFormik.values.iv_relation_type}
                  onChange={editBasicInfoFormik.handleChange}
                >
                  <FormControlLabel
                    value="Father's Name"
                    className="form-control-label"
                    control={<Radio />}
                    sx={{ ".MuiFormControlLabel-label": { fontSize: "14px" } }}
                    label="Father's Name"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="Husband's Name"
                    className="form-control-label"
                    sx={{ ".MuiFormControlLabel-label": { fontSize: "14px" } }}
                    control={<Radio />}
                    label="Husband's Name"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </FormControl>
              <Box className="from-Error">
                {editBasicInfoFormik.errors.iv_relation_type &&
                  editBasicInfoFormik.touched.iv_relation_type
                  ? editBasicInfoFormik.errors.iv_relation_type
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography className="fieldLabel">
                {" "}
                {editBasicInfoFormik.values.iv_relation_type === "Father's Name"
                  ? `Father's `
                  : editBasicInfoFormik.values.iv_relation_type ===
                    "Husband's Name"
                    ? `Husband's `
                    : "Relative "}
                Name
              </Typography>
              <TextField
                required
                type="text"
                name="iv_relative_name"
                value={editBasicInfoFormik.values.iv_relative_name}
                autoComplete="off"
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
                id="iv_relative_name"
                className="textfield"
              />
              <Box className="from-Error">
                {editBasicInfoFormik.errors.iv_relative_name &&
                  editBasicInfoFormik.touched.iv_relative_name
                  ? editBasicInfoFormik.errors.iv_relative_name
                  : null}
              </Box>
            </div>
          </DialogContentText>
          <DialogContentText component="div" className="dialog-content-text">
            <div className="field-container">
              <Typography className="fieldLabel"> Status</Typography>
              <FormControl className="form-control">
                <RadioGroup
                  className="radio-group"
                  row
                  name="iv_applicant_status"
                  defaultValue={editBasicInfoFormik.values.iv_applicant_status}
                  value={editBasicInfoFormik.values.iv_applicant_status}
                  onChange={editBasicInfoFormik.handleChange}
                >
                  <FormControlLabel
                    value="Owner"
                    className="form-control-label"
                    control={<Radio />}
                    sx={{ ".MuiFormControlLabel-label": { fontSize: "14px" } }}
                    label="Owner"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="Tenant"
                    className="form-control-label"
                    control={<Radio />}
                    sx={{ ".MuiFormControlLabel-label": { fontSize: "14px" } }}
                    label="Tenant"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </FormControl>
              <Box className="from-Error">
                {editBasicInfoFormik.errors.iv_applicant_status &&
                  editBasicInfoFormik.touched.iv_applicant_status
                  ? editBasicInfoFormik.errors.iv_applicant_status
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography className="fieldLabel"> Citizenship</Typography>
              <FormControl className="form-control">
                <RadioGroup
                  className="radio-group"
                  row
                  name="iv_applicant_citizenship"
                  defaultValue={
                    editBasicInfoFormik.values.iv_applicant_citizenship
                  }
                  value={editBasicInfoFormik.values.iv_applicant_citizenship}
                  onChange={editBasicInfoFormik.handleChange}
                >
                  <FormControlLabel
                    value="Pakistani"
                    className="form-control-label"
                    control={<Radio />}
                    sx={{ ".MuiFormControlLabel-label": { fontSize: "14px" } }}
                    label="Pakistani"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="Foreigner"
                    className="form-control-label"
                    control={<Radio />}
                    sx={{ ".MuiFormControlLabel-label": { fontSize: "14px" } }}
                    label="Foreigner"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </FormControl>
              <Box className="from-Error" sx={{ marginLeft: "-1%" }}>
                {editBasicInfoFormik.errors.iv_applicant_citizenship &&
                  editBasicInfoFormik.touched.iv_applicant_citizenship
                  ? editBasicInfoFormik.errors.iv_applicant_citizenship
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography className="fieldLabel">Mobile No.</Typography>
              <TextField
                required
                type="text"
                name="iv_applicant_phone_no"
                autoComplete="off"
                value={editBasicInfoFormik.values.iv_applicant_phone_no}
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
                inputProps={{ maxLength: 11 }}
                id="iv_applicant_phone_no"
                className="textfield"
              />
              <Box className="from-Error">
                {editBasicInfoFormik.errors.iv_applicant_phone_no &&
                  editBasicInfoFormik.touched.iv_applicant_phone_no
                  ? editBasicInfoFormik.errors.iv_applicant_phone_no
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography className="fieldLabel">
                Email<span style={{ color: "#A1A1A1" }}>(Optional)</span>
              </Typography>
              <TextField
                autoComplete="off"
                required
                type="text"
                name="iv_applicant_email"
                value={editBasicInfoFormik.values.iv_applicant_email}
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
                id="iv_applicant_email"
                className="textfield"
              />
              <Box className="from-Error">
                {editBasicInfoFormik.errors.iv_applicant_email &&
                  editBasicInfoFormik.touched.iv_applicant_email
                  ? editBasicInfoFormik.errors.iv_applicant_email
                  : null}
              </Box>
            </div>
            {editBasicInfoFormik.values.iv_connection_type === "Industrial" ||
              editBasicInfoFormik.values.iv_connection_type === "Commercial" ||
              editBasicInfoFormik.values.iv_connection_type ===
              "Corporate Company" ? (
              <>
                {/* NTN & STRN */}
                <div className="field-container">
                  <Typography className="fieldLabel"> NTN.</Typography>
                  <TextField
                    autoComplete="off"
                    required
                    type="double"
                    name="iv_ntn"
                    value={editBasicInfoFormik.values.iv_ntn}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    inputProps={{ maxLength: 13 }}
                    label=""
                    id="iv_ntn"
                    className="textfield"
                  />
                  <Box className="from-Error">
                    {editBasicInfoFormik.errors.iv_ntn &&
                      editBasicInfoFormik.touched.iv_ntn
                      ? editBasicInfoFormik.errors.iv_ntn
                      : null}
                  </Box>
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">STRN.</Typography>
                  <TextField
                    required
                    autoComplete="off"
                    type="text"
                    name="iv_strn"
                    value={editBasicInfoFormik.values.iv_strn}
                    inputProps={{ maxLength: 13 }}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    id="iv_strn"
                    className="textfield"
                  />
                  <Box className="from-Error">
                    {editBasicInfoFormik.errors.iv_strn &&
                      editBasicInfoFormik.touched.iv_strn
                      ? editBasicInfoFormik.errors.iv_strn
                      : null}
                  </Box>
                </div>
              </>
            ) : (
              <div className="field-container"></div>
            )}
          </DialogContentText>
          <DialogContentText component="div" className="dialog-content-text">
            <div className="field-container">
              <Typography className="fieldLabel">Area Type</Typography>
              <FormControl className="form-control">
                <RadioGroup
                  className="radio-group"
                  row
                  name="iv_area_type"
                  defaultValue={editBasicInfoFormik.values.iv_area_type}
                  value={editBasicInfoFormik.values.iv_area_type}
                  onChange={editBasicInfoFormik.handleChange}
                >
                  <FormControlLabel
                    value="Urban"
                    className="form-control-label"
                    sx={{ ".MuiFormControlLabel-label": { fontSize: "14px" } }}
                    control={<Radio />}
                    label="Urban"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="Rural"
                    className="form-control-label"
                    control={<Radio />}
                    sx={{ ".MuiFormControlLabel-label": { fontSize: "14px" } }}
                    label="Rural"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </FormControl>
              <Box className="from-Error">
                {editBasicInfoFormik.errors.iv_area_type &&
                  editBasicInfoFormik.touched.iv_area_type
                  ? editBasicInfoFormik.errors.iv_area_type
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography className="fieldLabel">Address</Typography>
              <TextField
                required
                type="text"
                inputProps={{
                  maxLength:
                    editBasicInfoFormik.values.iv_area_type == "Urban"
                      ? 100
                      : 30,
                }}
                name="iv_address"
                autoComplete="off"
                value={editBasicInfoFormik.values.iv_address}
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
                id="iv_address"
                className="textfield"
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={{ fontSize: "12px", color: "blue" }}
                      style={{ background: "#F2F4F6" }}
                    >
                      Max{" "}
                      {editBasicInfoFormik.values.iv_area_type === "Urban"
                        ? 40
                        : 30}{" "}
                      chars.
                    </InputAdornment>
                  ),
                }}
              />
              <Box className="from-Error">
                {editBasicInfoFormik.errors.iv_address &&
                  editBasicInfoFormik.touched.iv_address
                  ? editBasicInfoFormik.errors.iv_address
                  : null}
              </Box>
            </div>
            {editBasicInfoFormik.values.iv_area_type !== "Urban" ? (
              <div className="field-container">
                <Typography className="fieldLabel">Tehsil</Typography>
                <TextField
                  required
                  autoComplete="off"
                  type="text"
                  inputProps={{ maxLength: 15 }}
                  name="iv_town_tehsil"
                  value={editBasicInfoFormik.values.iv_town_tehsil}
                  onChange={editBasicInfoFormik.handleChange}
                  onBlur={editBasicInfoFormik.handleBlur}
                  id="iv_town_tehsil"
                  className="textfield"
                />
                <Box className="from-Error">
                  {editBasicInfoFormik.errors.iv_town_tehsil &&
                    editBasicInfoFormik.touched.iv_town_tehsil
                    ? editBasicInfoFormik.errors.iv_town_tehsil
                    : null}
                </Box>
              </div>
            ) : (
              <></>
            )}
            <div className="field-container">
              <Typography className="fieldLabel">District / City</Typography>
              <Autocomplete
                id="iv_city_district"
                name="iv_city_district"
                options={cities ? cities : []}
                value={editBasicInfoFormik.values.iv_city_district}
                filterOptions={filterOptions}
                onChange={(event, newValue) => {
                  if (newValue) {
                    editBasicInfoFormik.handleChange("iv_city_district")(
                      newValue
                    );
                  }
                }}
                onBlur={editBasicInfoFormik.handleBlur}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    type="text"
                    className="textfieldAutoSelect"
                  />
                )}
              />
              <Box className="from-Error">
                {editBasicInfoFormik.errors.iv_city_district &&
                  editBasicInfoFormik.touched.iv_city_district
                  ? editBasicInfoFormik.errors.iv_city_district
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography className="fieldLabel">
                Already installed meters
              </Typography>
              <TextField
                required
                autoComplete="off"
                type="number"
                InputProps={{
                  inputProps: { min: 0 },
                }}
                name="iv_meter_installed"
                value={editBasicInfoFormik.values.iv_meter_installed}
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
                id="iv_meter_installed"
                className="textfield"
              />
              <Box className="from-Error">
                {editBasicInfoFormik.errors.iv_meter_installed &&
                  editBasicInfoFormik.touched.iv_meter_installed
                  ? editBasicInfoFormik.errors.iv_meter_installed
                  : null}
              </Box>
            </div>
          </DialogContentText>
          {editBasicInfoFormik.values.iv_applicant_status === "Tenant" ? (
            <>
              <DialogContentText component="div" className="dialog-content-text">
                <Typography variant="h6" className="group-title">
                  <div className="cyanCell"></div>
                  Owner's Details
                </Typography>
              </DialogContentText>
              <DialogContentText component="div" className="dialog-content-text">
                <div className="field-container">
                  <Typography className="fieldLabel">Name</Typography>
                  <TextField
                    required
                    type="text"
                    autoComplete="off"
                    name="iv_owner_name"
                    value={editBasicInfoFormik.values.iv_owner_name}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    id="iv_owner_name"
                    className="textfield"
                  />
                  <Box className="from-Error">
                    {editBasicInfoFormik.errors.iv_owner_name &&
                      editBasicInfoFormik.touched.iv_owner_name
                      ? editBasicInfoFormik.errors.iv_owner_name
                      : null}
                  </Box>
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">
                    NIC. / CNIC. / NICOP.
                  </Typography>
                  <TextField
                    required
                    type="double"
                    autoComplete="off"
                    value={editBasicInfoFormik.values.iv_owner_cnic}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    inputProps={{ maxLength: 13 }}
                    name="iv_owner_cnic"
                    id="iv_owner_cnic"
                    className="textfield"
                  />
                  <Box className="from-Error">
                    {editBasicInfoFormik.errors.iv_owner_cnic &&
                      editBasicInfoFormik.touched.iv_owner_cnic
                      ? editBasicInfoFormik.errors.iv_owner_cnic
                      : null}
                  </Box>
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">Mobile No.</Typography>
                  <TextField
                    required
                    type="text"
                    autoComplete="off"
                    inputProps={{ maxLength: 11 }}
                    name="iv_owner_phone_no"
                    value={editBasicInfoFormik.values.iv_owner_phone_no}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    id="iv_owner_phone_no"
                    className="textfield"
                  />
                  <Box className="from-Error">
                    {editBasicInfoFormik.errors.iv_owner_phone_no &&
                      editBasicInfoFormik.touched.iv_owner_phone_no
                      ? editBasicInfoFormik.errors.iv_owner_phone_no
                      : null}
                  </Box>
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">
                    Email<span style={{ color: "#A1A1A1" }}>(Optional)</span>
                  </Typography>
                  <TextField
                    required
                    type="text"
                    value={editBasicInfoFormik.values.iv_owner_email}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    autoComplete="off"
                    name="iv_owner_email"
                    id="iv_owner_email"
                    className="textfield"
                  />
                  <Box className="from-Error">
                    {editBasicInfoFormik.errors.iv_owner_email &&
                      editBasicInfoFormik.touched.iv_owner_email
                      ? editBasicInfoFormik.errors.iv_owner_email
                      : null}
                  </Box>
                </div>
              </DialogContentText>
            </>
          ) : null}
          <DialogContentText component="div" className="dialog-content-text">
            <Typography variant="h6" className="group-title">
              <div
                className={
                  editBasicInfoFormik.values.iv_applicant_status === "Owner"
                    ? "cyanCell"
                    : "purpleCell"
                }
              ></div>
              Connection Details
            </Typography>
          </DialogContentText>
          <DialogContentText component="div" className="dialog-content-text">
            <div className="field-container">
              <div style={{ display: "flex" }}>
                <div style={{ width: "50%", paddingRight: "20px" }}>
                  <label> Load (kW)</label>
                  {showTooltip && (
                    <div className="tooltip">
                      {editBasicInfoFormik.values.iv_connection_type ===
                        "Domestic" && "Residential Maximum Load 1000kW."}
                      {editBasicInfoFormik.values.iv_connection_type ===
                        "Commercial" && "Commercial Maximum Load 5000kW."}
                    </div>
                  )}
                  <TextField
                    type="text"
                    name="iv_applied_load"
                    value={editBasicInfoFormik.values.iv_applied_load}
                    onChange={handleLoadChange}
                    onFocus={editBasicInfoFormik.handleFocus}
                    onBlur={(e) => {
                      setShowTooltip(false);
                      editBasicInfoFormik.handleBlur(e);
                    }}
                    min="-1"
                    className="textfield"
                  />
                  <Box className="from-Error-load">
                    {editBasicInfoFormik.errors.iv_applied_load &&
                      editBasicInfoFormik.touched.iv_applied_load
                      ? editBasicInfoFormik.errors.iv_applied_load
                      : null}
                  </Box>
                </div>
                <div style={{ width: "50%" }}>
                  <Typography className="fieldLabel"> Meter Type</Typography>
                  <TextField
                    type="text"
                    disabled
                    name="iv_phase"
                    value={phaseEdit}
                    id="iv_phase"
                    className="textfieldDisabled"
                  />
                </div>
              </div>
            </div>
            <div className="field-container">
              <Typography className="fieldLabel"> Tariff</Typography>
              <TextField
                disabled
                type="text"
                name="iv_tariff"
                value={tariffEdit}
                id="iv_tariff"
                className="textfieldDisabled"
              />
            </div>
            <div className="field-container">
              <Typography className="fieldLabel">
                Near-by Reference No.
                <span style={{ color: "#A1A1A1" }}>(Optional)</span>
              </Typography>
              <TextField
                type="text"
                name="iv_near_by_reference_no"
                autoComplete="off"
                value={editBasicInfoFormik.values.iv_near_by_reference_no}
                onChange={NearByReferenceNumber}
                onBlur={editBasicInfoFormik.handleBlur}
                inputProps={{ maxLength: 14 }}
                id="iv_near_by_reference_no"
                className="textfield"
              />
              <Box className="from-Error">
                {editBasicInfoFormik.errors.iv_near_by_reference_no &&
                  editBasicInfoFormik.touched.iv_near_by_reference_no
                  ? editBasicInfoFormik.errors.iv_near_by_reference_no
                  : null}
              </Box>

              <Box className="from-Error">
                {referenceNumberError ? referenceNumberError : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography className="fieldLabel">Circle</Typography>
              <Autocomplete
                id="iv_circle"
                name="iv_circle"
                value={defaultCircle ? defaultCircle : null}
                options={circleList}
                suppressDefaultValueWarning
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    className="textfieldAutoSelect"
                  />
                )}
                onChange={(event, value) => {
                  if (value) {
                    setDefaultCircle(value);
                    editBasicInfoFormik.values.iv_circle = value.code;
                    setDefaultDivision();
                    setSubDivision();
                  }
                }}
              />
              <Box className="from-Error">
                {editBasicInfoFormik.errors.iv_circle &&
                  editBasicInfoFormik.touched.iv_circle
                  ? editBasicInfoFormik.errors.iv_circle
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography className="fieldLabel">Division</Typography>
              <Autocomplete
                id="iv_division"
                name="iv_division"
                options={divisionList}
                value={defaultDivision ? defaultDivision : null}
                suppressDefaultValueWarning
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    className="textfieldAutoSelect"
                  />
                )}
                onChange={(event, value) => {
                  if (value) {
                    setDefaultDivision(value);
                    editBasicInfoFormik.values.iv_division = value.code;
                    setSubDivision();
                  }
                }}
              />
              <Box className="from-Error">
                {editBasicInfoFormik.errors.iv_division &&
                  editBasicInfoFormik.touched.iv_division
                  ? editBasicInfoFormik.errors.iv_division
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography className="fieldLabel">Sub Division</Typography>
              <Autocomplete
                id="iv_sub_divison"
                value={subDivision ? subDivision : null}
                name="iv_sub_divison"
                options={subDivisionList}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    className="textfieldAutoSelect"
                  />
                )}
                onChange={(event, value) => {
                  if (value) {
                    setSubDivision(value);
                    editBasicInfoFormik.values.iv_sub_divison = value.code;
                  }
                }}
              />
              <Box className="from-Error">
                {editBasicInfoFormik.errors.iv_sub_divison &&
                  editBasicInfoFormik.touched.iv_sub_divison
                  ? editBasicInfoFormik.errors.iv_sub_divison
                  : null}
              </Box>
            </div>
          </DialogContentText>
          <DialogContentText component="div" className="dialog-content-text">
            <div className="field-container">
              <Typography className="fieldLabelNameAndAddressing">
                Near-by Name
              </Typography>
              <TextField
                name="iv_near_by_name"
                required
                type="text"
                onBlur={editBasicInfoFormik.handleBlur}
                value={editBasicInfoFormik.values.iv_near_by_name}
                disabled
                className="textfieldDisabled"
              />
            </div>
            <div className="field-container">
              <Typography className="fieldLabelNameAndAddressing">
                Near-by Address
              </Typography>
              <TextField
                name="iv_near_by_address"
                required
                type="text"
                onBlur={editBasicInfoFormik.handleBlur}
                value={editBasicInfoFormik.values.iv_near_by_address}
                disabled
                className="textfieldDisabled"
              />
            </div>
            {editBasicInfoFormik.values.iv_connection_type === "Industrial" && (
              <div className="field-container">
                <Typography className="fieldLabel">&nbsp;</Typography>
                <FormControl className="form-control">
                  <RadioGroup
                    className="radio-group"
                    row
                    name="iv_meter_seasonal"
                    defaultValue={editBasicInfoFormik.values.iv_meter_seasonal}
                    value={editBasicInfoFormik.values.iv_meter_seasonal}
                    onChange={editBasicInfoFormik.handleChange}
                  >
                    <FormControlLabel
                      value={0}
                      className="form-control-label"
                      control={<Radio />}
                      label="Non-Seasonal"
                      sx={{
                        ".MuiFormControlLabel-label": { fontSize: "14px" },
                      }}
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value={1}
                      className="form-control-label"
                      control={<Radio />}
                      sx={{
                        ".MuiFormControlLabel-label": { fontSize: "14px" },
                      }}
                      label="Seasonal"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
                <Box className="from-Error">
                  {editBasicInfoFormik.errors.iv_meter_seasonal &&
                    editBasicInfoFormik.touched.iv_meter_seasonal
                    ? editBasicInfoFormik.errors.iv_meter_seasonal
                    : null}
                </Box>
              </div>
            )}
          </DialogContentText>
          <DialogContentText component="div" className="dialog-content-text">
            <Typography variant="h6" className="group-title">
              Required Documents
            </Typography>
          </DialogContentText>
          <Grid container spacing={1} className="documentsContainer">
            <Grid item lg={1.25}>
              <Typography className="documentLabel">
                1- Applicant's CNIC.
              </Typography>
              <Box className="documentError">
                {editBasicInfoFormik.errors.iv_applicant_cnic_document_front &&
                  editBasicInfoFormik.touched.iv_applicant_cnic_document_front
                  ? editBasicInfoFormik.errors.iv_applicant_cnic_document_front
                  : null}
              </Box>
              <Box className="documentError">
                {editBasicInfoFormik.errors.iv_applicant_cnic_document_back &&
                  editBasicInfoFormik.touched.iv_applicant_cnic_document_back
                  ? editBasicInfoFormik.errors.iv_applicant_cnic_document_back
                  : null}
              </Box>
            </Grid>
            <Grid item lg={0.875}>
              {applicantCnicDocumentFront ? (
                <>
                  <Button
                    varient="outlined"
                    component="label"
                    startIcon={
                      <CloseIcon
                        className="button-with-image"
                        onClick={() => {
                          setApplicantCnicDocumentFront("");
                        }}
                      />
                    }
                  >
                    {applicantCnicDocumentFrontThumbnail &&
                      isImage(applicantCnicDocumentFront) ? (
                      <div className="btn-div">
                        <img
                          src={applicantCnicDocumentFrontThumbnail}
                          alt="Applicant CNIC Front"
                          width="80"
                        />
                        {/* <p>{applicantCnicDocumentFrontFileName}</p> */}
                      </div>
                    ) : (
                      <span>
                        {isPdf(applicantCnicDocumentFront) ? (
                          <div className="btn-div">
                            <img src={pdfIcon} alt="PDF" width="80" />
                            {/* <p>{applicantCnicDocumentFrontFileName}</p> */}
                          </div>
                        ) : (
                          "Other file type"
                        )}
                      </span>
                    )}
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<FileUploadOutlinedIcon />}
                    className="btn"
                  >
                    Front
                    <input
                      hidden
                      accept={documentExtensions}
                      id="iv_applicant_cnic_document_front"
                      name="iv_applicant_cnic_document_front"
                      type="file"
                      onChange={ApplicantCnicDocumentFront}
                    />
                  </Button>
                  <Box className="documentError">
                    {applicantCnicDocumentFront == ""
                      ? applicantCnicFrontError
                      : null}
                  </Box>
                </>
              )}
            </Grid>
            <Grid item lg={0.875}>
              {applicantCnicDocumentBack ? (
                <>
                  <Button
                    component="label"
                    startIcon={
                      <CloseIcon
                        className="button-with-image"
                        onClick={() => {
                          setApplicantCnicDocumentBack("");
                        }}
                      />
                    }
                  >
                    {applicantCnicDocumentBackThumbnail &&
                      isImage(applicantCnicDocumentBack) ? (
                      <div className="btn-div">
                        <img
                          src={applicantCnicDocumentBackThumbnail}
                          alt="Applicant CNIC Back"
                          width="80"
                        />
                      </div>
                    ) : (
                      <span>
                        {isPdf(applicantCnicDocumentBack) ? (
                          <div className="btn-div">
                            <img src={pdfIcon} alt="PDF" width="80" />
                          </div>
                        ) : (
                          "Other file type"
                        )}
                      </span>
                    )}
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<FileUploadOutlinedIcon />}
                    className="btn"
                  >
                    Back
                    <input
                      hidden
                      accept={documentExtensions}
                      id="iv_applicant_cnic_document_back"
                      name="iv_applicant_cnic_document_back"
                      type="file"
                      onChange={ApplicantCnicDocumentBack}
                    />
                  </Button>
                  <Box className="documentError">
                    {applicantCnicDocumentBack == ""
                      ? applicantCnicBackError
                      : null}
                  </Box>
                </>
              )}
            </Grid>
            <Grid item lg={1.5}>
              <Typography className="documentLabel">
                2- Property documents
              </Typography>
              <Box className="documentError">
                {" "}
                {editBasicInfoFormik.errors.iv_property_documents &&
                  editBasicInfoFormik.touched.iv_property_documents
                  ? editBasicInfoFormik.errors.iv_property_documents
                  : null}
              </Box>
            </Grid>
            <Grid item lg={1.5}>
              {propertyDocuments ? (
                <>
                  <Button
                    component="label"
                    startIcon={
                      <CloseIcon
                        className="button-with-image"
                        onClick={() => {
                          setPropertDocuments("");
                        }}
                      />
                    }
                  >
                    {propertyDocumentsThumbnail &&
                      isImage(propertyDocuments) ? (
                      <div className="btn-div">
                        <img
                          src={propertyDocumentsThumbnail}
                          alt="Property Documents"
                          width="80"
                        />
                        {/* <p>{propertyDocumentsFileName}</p> */}
                      </div>
                    ) : (
                      <span>
                        {isPdf(propertyDocuments) ? (
                          <div className="btn-div">
                            <img src={pdfIcon} alt="PDF" width="80" />
                            {/* <p>{propertyDocumentsFileName}</p> */}
                          </div>
                        ) : (
                          "Other file type"
                        )}
                      </span>
                    )}
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<FileUploadOutlinedIcon />}
                    className="btn"
                  >
                    Upload
                    <input
                      hidden
                      accept={documentExtensions}
                      id="iv_property_documents"
                      name="iv_property_documents"
                      type="file"
                      onChange={PropertDocuments}
                    />
                  </Button>
                  <Box className="documentError">
                    {propertyDocuments == "" ? propertyDocumentError : null}
                  </Box>
                </>
              )}
            </Grid>
            <Grid item lg={1.5}>
              <Typography className="documentLabel">
                3- Near-by Electricity Bill{" "}
                <span style={{ color: "#A1A1A1", marginLeft: "3%" }}>
                  (Optional)
                </span>
              </Typography>
              <Box className="documentError">
                {" "}
                {editBasicInfoFormik.errors.iv_near_by_bill &&
                  editBasicInfoFormik.touched.iv_near_by_bill
                  ? editBasicInfoFormik.errors.iv_near_by_bill
                  : null}
              </Box>
            </Grid>
            <Grid item lg={1.5}>
              {nearByBillDocument ? (
                <>
                  <Button
                    varient="outlined"
                    component="label"
                    startIcon={
                      <CloseIcon
                        className="button-with-image"
                        onClick={() => {
                          setNearByBillDocument("");
                        }}
                      />
                    }
                  >
                    {nearByBillDocumentThumbnail &&
                      isImage(nearByBillDocument) ? (
                      <div className="btn-div">
                        <img
                          src={nearByBillDocumentThumbnail}
                          alt="Near By Bill"
                          width="80"
                        />
                        {/* <p>{nearByBillDocumentFileName}</p> */}
                      </div>
                    ) : (
                      <span>
                        {isPdf(nearByBillDocument) ? (
                          <div className="btn-div">
                            <img src={pdfIcon} alt="PDF" width="80" />
                            {/* <p>{nearByBillDocumentFileName}</p> */}
                          </div>
                        ) : (
                          "Other file type"
                        )}
                      </span>
                    )}
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<FileUploadOutlinedIcon />}
                    className="btn"
                  >
                    Upload
                    <input
                      hidden
                      accept={documentExtensions}
                      id="iv_near_by_bill"
                      name="iv_near_by_bill"
                      type="file"
                      onChange={NearByBillDocument}
                    />
                  </Button>
                  <Box className="documentError">
                    {nearByBillDocument == "" ? nearByBillError : null}
                  </Box>
                </>
              )}
            </Grid>
            <Grid item lg={1.5}>
              <Typography className="documentLabel">
                4- Any Other Doc.{" "}
                <span style={{ color: "#A1A1A1", marginLeft: "3%" }}>
                  (Optional)
                </span>
              </Typography>
              <Box className="documentError">
                {" "}
                {editBasicInfoFormik.errors.iv_any_other_document &&
                  editBasicInfoFormik.touched.iv_any_other_document
                  ? editBasicInfoFormik.errors.iv_any_other_document
                  : null}
              </Box>
            </Grid>
            <Grid item lg={1.5}>
              {anyOtherDocument ? (
                <>
                  <Button
                    varient="outlined"
                    component="label"
                    startIcon={
                      <CloseIcon
                        className="button-with-image"
                        onClick={() => {
                          setAnyOtherDocument("");
                        }}
                      />
                    }
                  >
                    {anyOtherDocumentThumbnail && isImage(anyOtherDocument) ? (
                      <div className="btn-div">
                        <img
                          src={anyOtherDocumentThumbnail}
                          alt="Any Other Doc."
                          width="80"
                        />
                        {/* <p>{nearByBillDocumentFileName}</p> */}
                      </div>
                    ) : (
                      <span>
                        {isPdf(anyOtherDocument) ? (
                          <div className="btn-div">
                            <img src={pdfIcon} alt="PDF" width="80" />
                            {/* <p>{nearByBillDocumentFileName}</p> */}
                          </div>
                        ) : (
                          "Other file type"
                        )}
                      </span>
                    )}
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<FileUploadOutlinedIcon />}
                    className="btn"
                  >
                    Upload
                    <input
                      hidden
                      accept={documentExtensions}
                      id="iv_any_other_document"
                      name="iv_any_other_document"
                      type="file"
                      onChange={AnyOtherDocument}
                    />
                  </Button>
                  <Box className="documentError">
                    {anyOtherDocument == "" ? anyOtherDocumentError : null}
                  </Box>
                </>
              )}
            </Grid>
            {editBasicInfoFormik.values.iv_applicant_status === "Tenant" && (
              <>
                <Grid item lg={1.25}>
                  <Typography className="documentLabel">
                    5- Owner's CNIC.
                  </Typography>
                  <Box className="documentError">
                    {" "}
                    {editBasicInfoFormik.errors.iv_owner_cnic_document_front &&
                      editBasicInfoFormik.touched.iv_owner_cnic_document_front
                      ? editBasicInfoFormik.errors.iv_owner_cnic_document_front
                      : null}
                  </Box>
                  <Box className="documentError">
                    {" "}
                    {editBasicInfoFormik.errors.iv_owner_cnic_document_back &&
                      editBasicInfoFormik.touched.iv_owner_cnic_document_back
                      ? editBasicInfoFormik.errors.iv_owner_cnic_document_back
                      : null}
                  </Box>
                </Grid>
                <Grid item lg={0.875}>
                  {ownerCnicDocumentFront ? (
                    <>
                      <Button
                        varient="outlined"
                        component="label"
                        startIcon={
                          <CloseIcon
                            className="button-with-image"
                            onClick={() => {
                              setOwnerCnicDocumentFront("");
                            }}
                          />
                        }
                      >
                        {ownerCnicDocumentFrontThumbnail &&
                          isImage(ownerCnicDocumentFront) ? (
                          <div className="btn-div">
                            <img
                              src={ownerCnicDocumentFrontThumbnail}
                              alt="Owner CNIC Front"
                              width="80"
                            />
                            {/* <p>{ownerCnicDocumentFrontFileName}</p> */}
                          </div>
                        ) : (
                          <span>
                            {isPdf(ownerCnicDocumentFront) ? (
                              <div className="btn-div">
                                <img src={pdfIcon} alt="PDF" width="80" />
                                {/* <p>{ownerCnicDocumentFrontFileName}</p> */}
                              </div>
                            ) : (
                              "Other file type"
                            )}
                          </span>
                        )}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="outlined"
                        component="label"
                        startIcon={<FileUploadOutlinedIcon />}
                        className="btn"
                      >
                        Front
                        <input
                          hidden
                          accept={documentExtensions}
                          id="iv_owner_cnic_document_front"
                          name="iv_owner_cnic_document_front"
                          type="file"
                          onChange={OwnerCnicDocumentFront}
                        />
                      </Button>
                      <Box className="documentError">
                        {ownerCnicDocumentFront == ""
                          ? ownerCnicFrontError
                          : null}
                      </Box>
                    </>
                  )}
                </Grid>
                <Grid item lg={0.875}>
                  {ownerCnicDocumentBack ? (
                    <>
                      <Button
                        varient="outlined"
                        component="label"
                        startIcon={
                          <CloseIcon
                            className="button-with-image"
                            onClick={() => {
                              setOwnerCnicDocumentBack("");
                            }}
                          />
                        }
                      >
                        {ownerCnicDocumentBackThumbnail &&
                          isImage(ownerCnicDocumentBack) ? (
                          <div className="btn-div">
                            <img
                              src={ownerCnicDocumentBackThumbnail}
                              alt="Owner CNIC Back"
                              width="80"
                            />
                            {/* <p>{ownerCnicDocumentBackFileName}</p> */}
                          </div>
                        ) : (
                          <span>
                            {isPdf(ownerCnicDocumentBack) ? (
                              <div className="btn-div">
                                <img src={pdfIcon} alt="PDF" width="80" />
                                {/* <p>{ownerCnicDocumentBackFileName}</p> */}
                              </div>
                            ) : (
                              "Other file type"
                            )}
                          </span>
                        )}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="outlined"
                        component="label"
                        startIcon={<FileUploadOutlinedIcon />}
                        className="btn"
                      >
                        Back
                        <input
                          hidden
                          accept={documentExtensions}
                          id="iv_owner_cnic_document_back"
                          name="iv_owner_cnic_document_back"
                          type="file"
                          onChange={OwnerCnicDocumentBack}
                        />
                      </Button>
                      <Box className="documentError">
                        {ownerCnicDocumentBack == ""
                          ? ownerCnicBackError
                          : null}
                      </Box>
                    </>
                  )}
                </Grid>
                <Grid item lg={1.5}>
                  <Typography className="documentLabel">
                    6- NOC. from owner
                  </Typography>
                  <Box className="documentError">
                    {" "}
                    {editBasicInfoFormik.errors.iv_noc_owner &&
                      editBasicInfoFormik.touched.iv_noc_owner
                      ? editBasicInfoFormik.errors.iv_noc_owner
                      : null}
                  </Box>
                </Grid>
                <Grid item lg={1.5}>
                  {nocOwnerDocument ? (
                    <>
                      <Button
                        varient="outlined"
                        component="label"
                        startIcon={
                          <CloseIcon
                            className="button-with-image"
                            onClick={() => {
                              setNocOwnerDocument("");
                            }}
                          />
                        }
                      >
                        {nocOwnerDocumentThumbnail &&
                          isImage(nocOwnerDocument) ? (
                          <div className="btn-div">
                            <img
                              src={nocOwnerDocumentThumbnail}
                              alt="Owner NOC"
                              width="80"
                            />
                            {/* <p>{nocOwnerDocumentFileName}</p> */}
                          </div>
                        ) : (
                          <span>
                            {isPdf(nocOwnerDocument) ? (
                              <div className="btn-div">
                                <img src={pdfIcon} alt="PDF" width="80" />
                                {/* <p>{nocOwnerDocumentFileName}</p> */}
                              </div>
                            ) : (
                              "Other file type"
                            )}
                          </span>
                        )}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="outlined"
                        component="label"
                        startIcon={<FileUploadOutlinedIcon />}
                        className="btn"
                      >
                        Upload
                        <input
                          hidden
                          accept={documentExtensions}
                          id="iv_noc_owner"
                          name="iv_noc_owner"
                          type="file"
                          onChange={NocOwnerDocument}
                        />
                      </Button>
                      <Box className="documentError">
                        {nocOwnerDocument == "" ? nocError : null}
                      </Box>
                    </>
                  )}
                </Grid>
              </>
            )}
            {editBasicInfoFormik.values.iv_connection_type === "Industrial" ? (
              <>
                <Grid item lg={1.5}>
                  <Typography className="documentLabel">
                    {editBasicInfoFormik.values.iv_applicant_status === "Owner"
                      ? "5- "
                      : "7- "}
                    Resolution from BoD's in the favour of signatory
                  </Typography>
                  <Box className="documentError">
                    {" "}
                    {editBasicInfoFormik.errors.iv_resolution &&
                      editBasicInfoFormik.touched.iv_resolution
                      ? editBasicInfoFormik.errors.iv_resolution
                      : null}
                  </Box>
                </Grid>
                <Grid item lg={1.5}>
                  {resolutionDocument ? (
                    <>
                      <Button
                        varient="outlined"
                        component="label"
                        startIcon={
                          <CloseIcon
                            className="button-with-image"
                            onClick={() => {
                              setResolutionDocument("");
                            }}
                          />
                        }
                      >
                        {resolutionDocumentThumbnail &&
                          isImage(resolutionDocument) ? (
                          <div className="btn-div">
                            <img
                              src={resolutionDocumentThumbnail}
                              alt="Resolution Document"
                              width="80"
                            />
                            {/* <p>{resolutionDocumentFileName}</p> */}
                          </div>
                        ) : (
                          <span>
                            {isPdf(resolutionDocument) ? (
                              <div className="btn-div">
                                <img src={pdfIcon} alt="PDF" width="80" />
                                {/* <p>{resolutionDocumentFileName}</p> */}
                              </div>
                            ) : (
                              "Other file type"
                            )}
                          </span>
                        )}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="outlined"
                        component="label"
                        startIcon={<FileUploadOutlinedIcon />}
                        className="btn"
                      >
                        Upload
                        <input
                          hidden
                          accept={documentExtensions}
                          id="iv_resolution"
                          name="iv_resolution"
                          type="file"
                          onChange={ResolutionDocument}
                        />
                      </Button>
                      <Box className="documentError">
                        {resolutionDocument == "" ? bodError : null}
                      </Box>
                    </>
                  )}
                </Grid>
                <Grid item lg={1.5}>
                  <Typography className="documentLabel">
                    {editBasicInfoFormik.values.iv_applicant_status === "Owner"
                      ? "6- "
                      : "8- "}
                    Memorandum of association certificate{" "}
                    <span style={{ color: "#A1A1A1" }}>(Optional)</span>
                  </Typography>
                  <Box className="documentError">
                    {" "}
                    {editBasicInfoFormik.errors.iv_memo &&
                      editBasicInfoFormik.touched.iv_memo
                      ? editBasicInfoFormik.errors.iv_memo
                      : null}
                  </Box>
                </Grid>
                <Grid item lg={1.5}>
                  {memorandumDocument ? (
                    <>
                      <Button
                        varient="outlined"
                        component="label"
                        startIcon={
                          <CloseIcon
                            className="button-with-image"
                            onClick={() => {
                              setMemorandumDocument("");
                            }}
                          />
                        }
                      >
                        {memorandumDocumentThumbnail &&
                          isImage(memorandumDocument) ? (
                          <div className="btn-div">
                            <img
                              src={memorandumDocumentThumbnail}
                              alt="Memorandum Document"
                              width="80"
                            />
                            {/* <p>{memorandumDocumentFileName}</p> */}
                          </div>
                        ) : (
                          <span>
                            {isPdf(memorandumDocument) ? (
                              <div className="btn-div">
                                <img src={pdfIcon} alt="PDF" width="80" />
                                {/* <p>{memorandumDocumentFileName}</p> */}
                              </div>
                            ) : (
                              "Other file type"
                            )}
                          </span>
                        )}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="outlined"
                        component="label"
                        startIcon={<FileUploadOutlinedIcon />}
                        className="btn"
                      >
                        Upload
                        <input
                          hidden
                          accept={documentExtensions}
                          id="iv_memo"
                          name="iv_memo"
                          type="file"
                          onChange={MemorandumDocument}
                        />
                      </Button>
                      <Box className="documentError">
                        {memorandumDocument == "" ? memorandumError : null}
                      </Box>
                    </>
                  )}
                </Grid>
                <Grid item lg={1.5}>
                  <Typography className="documentLabel">
                    {editBasicInfoFormik.values.iv_applicant_status === "Owner"
                      ? "7- "
                      : "9- "}
                    Certified copy of form-29
                  </Typography>
                  <Box className="documentError">
                    {" "}
                    {editBasicInfoFormik.errors.iv_form29initial &&
                      editBasicInfoFormik.touched.iv_form29initial
                      ? editBasicInfoFormik.errors.iv_form29initial
                      : null}
                  </Box>
                </Grid>
                <Grid item lg={1.5}>
                  {form29Document ? (
                    <>
                      <Button
                        varient="outlined"
                        component="label"
                        startIcon={
                          <CloseIcon
                            className="button-with-image"
                            onClick={() => {
                              setForm29Document("");
                            }}
                          />
                        }
                      >
                        {form29DocumentThumbnail && isImage(form29Document) ? (
                          <div className="btn-div">
                            <img
                              src={form29DocumentThumbnail}
                              alt="Form-29 Document"
                              width="80"
                            />
                            {/* <p>{form29DocumentFileName}</p> */}
                          </div>
                        ) : (
                          <span>
                            {isPdf(form29Document) ? (
                              <div className="btn-div">
                                <img src={pdfIcon} alt="PDF" width="80" />
                                {/* <p>{form29DocumentFileName}</p> */}
                              </div>
                            ) : (
                              "Other file type"
                            )}
                          </span>
                        )}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="outlined"
                        component="label"
                        startIcon={<FileUploadOutlinedIcon />}
                        className="btn"
                      >
                        Upload
                        <input
                          hidden
                          accept={documentExtensions}
                          id="iv_form29initial"
                          name="iv_form29initial"
                          type="file"
                          onChange={Form29Document}
                        />
                      </Button>
                      <Box className="documentError">
                        {form29Document == "" ? formError : null}
                      </Box>
                    </>
                  )}
                </Grid>
              </>
            ) : null}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            className="arrearBtn"
            sx={{ width: "15%" }}
            onClick={() => {
              editBasicInfoFormik.handleSubmit();
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Objection Dialog */}
      <Dialog
        open={objectionPopUpOpen}
        onClose={hideObjectionPopup}
        fullWidth={true}
        maxWidth={"sm"}
        className="objectionDialog"
        ref={formik.resetForm}
      >
        <DialogTitle className="objection-dialog-title">
          <Grid container className="objectionheadercontainer">
            <Grid item className="applicationTitleGrid">
              <p className="applicationTitleText">Rejection Reason </p>
            </Grid>
            <Grid item className="closeIcon">
              <CloseIcon id="clearPopup" onClick={hideObjectionPopup} />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className="objection-dialog-content">
          <DialogContentText component="div" className="objection-dialog-content-text">
            <Grid item lg={2.5} sx={{ marginTop: "2%" }}>
              <Typography className="fieldLabel">Step</Typography>
              <Select
                value={formik.values.iv_objection_step}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="fieldBatch"
                name="iv_objection_step"
                id="iv_objection_step"
                sx={{ width: "95%" }}
              >
                <MenuItem key={4} value={4}>
                  Reference No. Allocation
                </MenuItem>
                <MenuItem key={3} value={3}>
                  Field Survey
                </MenuItem>
                <MenuItem key={2} value={2}>
                  Arrear Verification
                </MenuItem>
                <MenuItem key={1} value={1}>
                  Document Verification
                </MenuItem>
              </Select>
              <Box className="from-Error">
                {formik.errors.iv_objection_step &&
                  formik.touched.iv_objection_step
                  ? formik.errors.iv_objection_step
                  : null}
              </Box>
            </Grid>
            <Grid item lg={2.5} sx={{ marginTop: "2%" }}>
              <Typography className="fieldLabel">Reason</Typography>
              <TextField
                type="text"
                name="iv_objection_Descripton"
                id="iv_objection_Descripton"
                placeholder="Enter reason for rejection"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.iv_objection_Descripton}
                className="objection-input"
              />
              <Box className="from-Error">
                {formik.errors.iv_objection_Descripton &&
                  formik.touched.iv_objection_Descripton
                  ? formik.errors.iv_objection_Descripton
                  : null}
              </Box>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="objection-dialog-action">
          <button
            onClick={() => {
              formik.handleSubmit();
            }}
            type="submit"
            className="submit-button"
          >
            Submit
          </button>
        </DialogActions>
      </Dialog>

      {/* Arrears Rejection Removal Alert */}
      <Dialog
        open={rejectionRemovalAlert}
        onClose={hideRejectionRemovalAlert}
        fullWidth={true}
        maxWidth={"sm"}
        className="rejection-removal"
      >
        <DialogTitle className="dialog-title">
          Arrears Verification
          <Box sx={{ marginRight: "2%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setArearPaidBillDocument("");
                setArearPaidBillDocumentThumbnail("");
                setRejectionRemovalAlert(false);
                arearBillDocumentFormik.resetForm();
                arearBillDocumentFormik.values.iv_arear_paid_bill_document = "";
              }}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent>
          {CheckPermissions(
            permissions,
            "General Services",
            "New Connection",
            "Workflow Permissions",
            "Arrear Bill Uploading"
          ) ? (
            <>
              <Grid
                container
                item
                lg={12}
                sx={{ display: "flex", flexDirection: "row" }}
              >
                <Grid
                  item
                  lg={4}
                  sx={{
                    marginTop: "2%",
                    display: "flex",
                    flexDirection: "column",
                    marginRight: "8%",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "normal",
                      marginBottom: "1%",
                      color: "#808080",
                    }}
                  >
                    Payment Date
                  </Typography>
                  <input
                    name="iv_arear_paid_bill_date"
                    value={
                      arearBillDocumentFormik.values.iv_arear_paid_bill_date
                    }
                    onChange={arearBillDocumentFormik.handleChange}
                    onBlur={arearBillDocumentFormik.handleBlur}
                    type="date"
                    style={{
                      padding: "10px", // Corrected syntax
                      borderRadius: "5px", // Enclosed in quotes
                      border: "1px solid #ccc", // Corrected syntax and enclosed in quotes
                      marginBottom: "10px",
                      width: "100%", // Corrected syntax and enclosed in quotes
                    }}
                    // min={dnDetails.issueDate.slice(0, 10)}
                    max={new Date().toISOString().split("T")[0]}
                  />
                  <Box
                    className="form-error"
                    sx={{ color: "red", marginTop: "1%" }}
                  >
                    {arearBillDocumentFormik.errors.iv_arear_paid_bill_date &&
                      arearBillDocumentFormik.touched.iv_arear_paid_bill_date
                      ? arearBillDocumentFormik.errors.iv_arear_paid_bill_date
                      : null}
                  </Box>
                </Grid>
                <Grid item lg={6} sx={{ marginTop: "2%", marginRight: "8%" }}>
                  <Typography
                    sx={{
                      fontWeight: "normal",
                      marginBottom: "1%",
                      color: "#808080",
                    }}
                  >
                    Paid Bill Image
                  </Typography>
                  {arearPaidBillDocument ? (
                    <>
                      <Button
                        varient="outlined"
                        component="label"
                        startIcon={
                          <CloseIcon
                            sx={{ color: "red" }}
                            onClick={() => {
                              setArearPaidBillDocument("");
                            }}
                          />
                        }
                      >
                        {arearPaidBillDocumentThumbnail && (
                          <img
                            src={arearPaidBillDocumentThumbnail}
                            alt="Arear paid bill"
                            width="100"
                          />
                        )}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="outlined"
                        component="label"
                        startIcon={<FileUploadOutlinedIcon />}
                        className="btn"
                        sx={{ marginTop: "2%", width: "70%" }}
                      >
                        Upload
                        <input
                          hidden
                          accept={documentExtensions}
                          id="iv_arear_paid_bill_document"
                          name="iv_arear_paid_bill_document"
                          type="file"
                          onChange={ArearPaidBillDocument}
                        />
                      </Button>
                    </>
                  )}
                  <Box
                    className="documentError"
                    sx={{ color: "red", marginTop: "1%" }}
                  >
                    {arearBillDocumentFormik.errors
                      .iv_arear_paid_bill_document &&
                      arearBillDocumentFormik.touched.iv_arear_paid_bill_document
                      ? arearBillDocumentFormik.errors
                        .iv_arear_paid_bill_document
                      : null}
                  </Box>
                  <Box
                    className="documentError"
                    sx={{ color: "red", marginTop: "1%" }}
                  >
                    {arearPaidBillDocumentError
                      ? arearPaidBillDocumentError
                      : null}
                  </Box>
                </Grid>
              </Grid>
            </>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            className="confirmButton"
            sx={{ width: "30%", textTransform: "capitalize" }}
            onClick={arearBillDocumentFormik.handleSubmit}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Field Rejection Removal Alert */}
      <Dialog
        open={fieldRejectionRemovalAlert}
        onClose={hideFieldRejectionRemovalAlert}
        fullWidth={true}
        maxWidth={"sm"}
        className="rejection-removal"
      >
        <DialogTitle className="dialog-title">Confirm</DialogTitle>
        <DialogContent>
          {dialogRowData.applicationProgressId === 3 ? (
            <DialogContentText>
              Are you sure you want to remove the field survey objection for
              application id: {dialogRowData.applicationId}?
            </DialogContentText>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button
            className="confirmButton"
            onClick={() =>
              callChangeObjectionStatus(
                2,

                "Field Objection Removed",
                "Field Objection has been Removed"
              )
            }
          >
            Confirm
          </Button>
          <Button
            className="confirmButton"
            onClick={hideFieldRejectionRemovalAlert}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Wiring Test Report Rejection Removal Alert */}
      <Dialog
        open={wiringTestReportRejectionRemovalAlert}
        onClose={hideWiringTestReportRejectionRemovalAlert}
        fullWidth={true}
        maxWidth={"sm"}
        className="rejection-removal"
      >
        <DialogTitle className="dialog-title">
          Wiring Test Report - Remove Objection
          <Box sx={{ marginRight: "2%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={hideWiringTestReportRejectionRemovalAlert}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ marginTop: "10px" }}>
            <Grid item lg={12}>
              <Typography
                sx={{
                  fontWeight: "normal",
                  marginBottom: "1%",
                  color: "#808080",
                }}
              >
                Upload New Wiring Test Report
              </Typography>
              {newWiringTestReportDocumentThumbnail ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={
                      <CloseIcon
                        onClick={() => {
                          setNewWiringTestReportDocument("");
                          setNewWiringTestReportDocumentThumbnail("");
                        }}
                      />
                    }
                  >
                    {newWiringTestReportDocumentThumbnail.slice(0, 10) === "data:image" ? (
                      <img
                        src={newWiringTestReportDocumentThumbnail}
                        alt="Wiring Test Report"
                        width="80"
                      />
                    ) : (
                      <img src={pdfIcon} alt="PDF" width="40" />
                    )}
                  </Button>
                  <Typography>{newWiringTestReportDocument}</Typography>
                </Box>
              ) : (
                <>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<FileUploadOutlinedIcon />}
                    className="btn"
                  >
                    Upload
                    <input
                      hidden
                      accept=".jpg,.jpeg,.png,.pdf"
                      type="file"
                      onChange={NewWiringTestReportDocument}
                    />
                  </Button>
                  {newWiringTestReportDocumentError && (
                    <Box sx={{ color: "red", marginTop: "5px" }}>
                      {newWiringTestReportDocumentError}
                    </Box>
                  )}
                </>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            className="confirmButton"
            sx={{ width: "30%", textTransform: "capitalize" }}
            onClick={reuploadWiringTestReportAndRemoveObjection}
          >
            Remove Objection
          </Button>
          <Button
            className="confirmButton"
            sx={{ width: "30%", textTransform: "capitalize" }}
            onClick={hideWiringTestReportRejectionRemovalAlert}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* DN Payment Verification Alert */}
      <Dialog
        open={dnPaymentVerifyAlert}
        onClose={hideDnPaymentVerifyAlert}
        fullWidth={true}
        maxWidth={"xm"}
        className="alert-popup"
      >
        <DialogTitle className="dialog-title">
          <p>Confirm</p>
          <CloseIcon
            id="clearPopup"
            onClick={hideDnPaymentVerifyAlert}
            sx={{ color: "white" }}
          />
        </DialogTitle>
        <DialogContent className="dialog-content">
          <DialogContentText className="dialog-content-text">
            Are you sure to verify the{" "}
            <span style={{ color: "red", fontWeight: "bold" }}>
              DEMAND NOTICE PAYMENT
            </span>
            ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              callDNPaymentVerification(dialogRowData.applicationId);
              hideDnPaymentVerifyAlert();
            }}
            className="action-button"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* DN Payment Rejection Alert */}
      <Dialog
        open={dnPaymentRejectAlert}
        onClose={hideDnPaymentRejectAlert}
        fullWidth={true}
        maxWidth={"sm"}
        className=""
      >
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <Typography className="fieldLabel">
              Are you sure the demand notice payment is un-verified?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              callChangeProgressIdAPI(
                5,
                "DN Payment Submitted",
                "DN Payment Unverified"
              );
              setDnPaymentRejectAlert(false);
            }}
          >
            Submit
          </Button>
          <Button onClick={hideDnPaymentRejectAlert}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* SCO Part 2 Approval Alert */}
      <Dialog
        open={scoPart2ApproveAlert}
        onClose={hideSCOPart2ApproveAlert}
        fullWidth={true}
        maxWidth={"sm"}
        className=""
      >
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <Typography className="fieldLabel">
              Are you sure you want to approve the SCO Part-2?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              scoPart2Formik.handleSubmit();
              setScoPart2ApproveAlert(false);
            }}
          >
            Submit
          </Button>
          <Button onClick={hideSCOPart2ApproveAlert}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* Meter Installation Reject Confirmation Dialog */}
      <Dialog
        open={meterInstallationRejectAlert}
        onClose={() => setMeterInstallationRejectAlert(false)}
      >
        <DialogTitle>Confirm Rejection</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to reject this meter installation?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setMeterInstallationRejectAlert(false);
              onPressRejectMeterInstallation();
            }}
            style={{ backgroundColor: "#dc3545", color: "white" }}
          >
            Yes
          </Button>
          <Button onClick={() => setMeterInstallationRejectAlert(false)}>
            No
          </Button>
        </DialogActions>
      </Dialog>

      {/* Backdrop */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Documents Objection Pop Up */}
      <Dialog
        open={documentsObjectionPopUp}
        onClose={() => {
          setDocumentsObjectionPopUp(false);
          setRejectedDocumentsList([]);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">Documents Objection</p>
          <CloseIcon
            id="clearPopup"
            className="closeIcon"
            onClick={() => {
              setDocumentsObjectionPopUp(false);
              setRejectedDocumentsList([]);
            }}
          />
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid
            container
            gap={1}
            className="container"
            style={{ display: "flex", flexDirection: "row" }}
          >
            <Grid
              item
              lg={12}
              style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
            >
              {/* Applicant CNIC */}
              {(dialogRowData.copyOfApplicantCNICFront || dialogRowData.copyOfApplicantCNICBack) && (
                <Grid item lg={2} style={{ marginRight: "1%" }}>
                  <Grid
                    container
                    sx={{
                      backgroundColor: (rejectedDocumentsList.includes('Applicant CNIC') ||
                        rejectedDocumentsList.some(d => d.toLowerCase().includes('cnic'))) ? "#FFCAC9" : "#D6F6D5",
                      borderRadius: "10px",
                      minHeight: "125px",
                      height: "auto",
                    }}
                  >
                    <Grid item lg={12} className="tittlegrid">
                      <p className="docTitle">Applicant's CNIC</p>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                        flexDirection: "column",
                      }}
                    >
                      {dialogRowData.copyOfApplicantCNICFront &&
                        dialogRowData.copyOfApplicantCNICFront.slice(0, 6) === "data:i" ? (
                        <Base64Image data={dialogRowData.copyOfApplicantCNICFront} width="80" />
                      ) : dialogRowData.copyOfApplicantCNICFront ? (
                        <Base64Image data={pdfIcon} width="40" />
                      ) : null}
                      {dialogRowData.copyOfApplicantCNICBack &&
                        dialogRowData.copyOfApplicantCNICBack.slice(0, 6) === "data:i" ? (
                        <Base64Image data={dialogRowData.copyOfApplicantCNICBack} width="80" />
                      ) : dialogRowData.copyOfApplicantCNICBack ? (
                        <Base64Image data={pdfIcon} width="40" />
                      ) : null}
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {/* Premises Document */}
              {dialogRowData.premisesDocument && (
                <Grid item lg={2} style={{ marginRight: "1%" }}>
                  <Grid
                    container
                    sx={{
                      backgroundColor: rejectedDocumentsList.some(d => d.toLowerCase().includes('premises')) ? "#FFCAC9" : "#D6F6D5",
                      borderRadius: "10px",
                      minHeight: "125px",
                      height: "auto",
                    }}
                  >
                    <Grid item lg={12} className="tittlegrid">
                      <p className="docTitle">Premises Document</p>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      {dialogRowData.premisesDocument.slice(0, 6) === "data:i" ? (
                        <Base64Image data={dialogRowData.premisesDocument} width="80" />
                      ) : (
                        <Base64Image data={pdfIcon} width="40" />
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {/* Nearby Bill */}
              {dialogRowData.scannedCopyOfNearByElectricityBill && (
                <Grid item lg={2} style={{ marginRight: "1%" }}>
                  <Grid
                    container
                    sx={{
                      backgroundColor: rejectedDocumentsList.some(d => d.toLowerCase().includes('bill') || d.toLowerCase().includes('nearby')) ? "#FFCAC9" : "#D6F6D5",
                      borderRadius: "10px",
                      minHeight: "125px",
                      height: "auto",
                    }}
                  >
                    <Grid item lg={12} className="tittlegrid">
                      <p className="docTitle">Nearby Electricity Bill</p>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      {dialogRowData.scannedCopyOfNearByElectricityBill.slice(0, 6) === "data:i" ? (
                        <Base64Image data={dialogRowData.scannedCopyOfNearByElectricityBill} width="80" />
                      ) : (
                        <Base64Image data={pdfIcon} width="40" />
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {/* Other Document */}
              {dialogRowData.anyOtherDocument && (
                <Grid item lg={2} style={{ marginRight: "1%" }}>
                  <Grid
                    container
                    sx={{
                      backgroundColor: rejectedDocumentsList.some(d => d.toLowerCase().includes('other')) ? "#FFCAC9" : "#D6F6D5",
                      borderRadius: "10px",
                      minHeight: "125px",
                      height: "auto",
                    }}
                  >
                    <Grid item lg={12} className="tittlegrid">
                      <p className="docTitle">Other Document</p>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      {dialogRowData.anyOtherDocument.slice(0, 6) === "data:i" ? (
                        <Base64Image data={dialogRowData.anyOtherDocument} width="80" />
                      ) : (
                        <Base64Image data={pdfIcon} width="40" />
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        {/* Footer */}
        <div style={{
          backgroundColor: '#808080',
          color: 'white',
          textAlign: 'center',
          padding: '12px',
          fontSize: '14px',
          fontWeight: '500'
        }}>
          Documents Objection by: {activityInfo.processedBy} on: {activityInfo.date}
        </div>
      </Dialog>

      {/* Documents Reupload Pop Up */}
      <Dialog
        open={documentsReuploadPopUp}
        onClose={() => {
          setDocumentsReuploadPopUp(false);
          setRejectedDocumentsList([]);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">Documents Reupload</p>
          <CloseIcon
            id="clearPopup"
            className="closeIcon"
            onClick={() => {
              setDocumentsReuploadPopUp(false);
              setRejectedDocumentsList([]);
            }}
          />
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid
            container
            gap={1}
            className="container"
            style={{ display: "flex", flexDirection: "row" }}
          >
            <Grid
              item
              lg={12}
              style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
            >
              {/* Applicant CNIC */}
              {(dialogRowData.copyOfApplicantCNICFront || dialogRowData.copyOfApplicantCNICBack) && (
                <Grid item lg={2} style={{ marginRight: "1%" }}>
                  <Grid
                    container
                    sx={{
                      backgroundColor: "#D6F6D5",
                      borderRadius: "10px",
                      minHeight: "125px",
                      height: "auto",
                    }}
                  >
                    <Grid item lg={12} className="tittlegrid">
                      <p className="docTitle">Applicant's CNIC</p>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                        flexDirection: "column",
                      }}
                    >
                      {dialogRowData.copyOfApplicantCNICFront &&
                        dialogRowData.copyOfApplicantCNICFront.slice(0, 6) === "data:i" ? (
                        <Base64Image data={dialogRowData.copyOfApplicantCNICFront} width="80" />
                      ) : dialogRowData.copyOfApplicantCNICFront ? (
                        <Base64Image data={pdfIcon} width="40" />
                      ) : null}
                      {dialogRowData.copyOfApplicantCNICBack &&
                        dialogRowData.copyOfApplicantCNICBack.slice(0, 6) === "data:i" ? (
                        <Base64Image data={dialogRowData.copyOfApplicantCNICBack} width="80" />
                      ) : dialogRowData.copyOfApplicantCNICBack ? (
                        <Base64Image data={pdfIcon} width="40" />
                      ) : null}
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {/* Premises Document */}
              {dialogRowData.premisesDocument && (
                <Grid item lg={2} style={{ marginRight: "1%" }}>
                  <Grid
                    container
                    sx={{
                      backgroundColor: "#D6F6D5",
                      borderRadius: "10px",
                      minHeight: "125px",
                      height: "auto",
                    }}
                  >
                    <Grid item lg={12} className="tittlegrid">
                      <p className="docTitle">Premises Document</p>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      {dialogRowData.premisesDocument.slice(0, 6) === "data:i" ? (
                        <Base64Image data={dialogRowData.premisesDocument} width="80" />
                      ) : (
                        <Base64Image data={pdfIcon} width="40" />
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {/* Nearby Bill */}
              {dialogRowData.scannedCopyOfNearByElectricityBill && (
                <Grid item lg={2} style={{ marginRight: "1%" }}>
                  <Grid
                    container
                    sx={{
                      backgroundColor: "#D6F6D5",
                      borderRadius: "10px",
                      minHeight: "125px",
                      height: "auto",
                    }}
                  >
                    <Grid item lg={12} className="tittlegrid">
                      <p className="docTitle">Nearby Electricity Bill</p>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      {dialogRowData.scannedCopyOfNearByElectricityBill.slice(0, 6) === "data:i" ? (
                        <Base64Image data={dialogRowData.scannedCopyOfNearByElectricityBill} width="80" />
                      ) : (
                        <Base64Image data={pdfIcon} width="40" />
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {/* Other Document */}
              {dialogRowData.anyOtherDocument && (
                <Grid item lg={2} style={{ marginRight: "1%" }}>
                  <Grid
                    container
                    sx={{
                      backgroundColor: "#D6F6D5",
                      borderRadius: "10px",
                      minHeight: "125px",
                      height: "auto",
                    }}
                  >
                    <Grid item lg={12} className="tittlegrid">
                      <p className="docTitle">Other Document</p>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      {dialogRowData.anyOtherDocument.slice(0, 6) === "data:i" ? (
                        <Base64Image data={dialogRowData.anyOtherDocument} width="80" />
                      ) : (
                        <Base64Image data={pdfIcon} width="40" />
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        {/* Footer */}
        <div style={{
          backgroundColor: '#808080',
          color: 'white',
          textAlign: 'center',
          padding: '12px',
          fontSize: '14px',
          fontWeight: '500'
        }}>
          Documents Reuploaded by: {activityInfo.processedBy} on: {activityInfo.date}
        </div>
      </Dialog>

      {/* Arrear Objection Pop Up */}
      <Dialog
        open={arrearObjectionPopUp}
        onClose={() => {
          setArrearObjectionPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">Arrear Objection</p>
          <CloseIcon
            id="clearPopup"
            className="closeIcon"
            onClick={() => {
              setArrearObjectionPopUp(false);
            }}
          />
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid
            container
            gap={1}
            className="container"
            style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px" }}
          >
            <Grid item lg={12} style={{ textAlign: "center" }}>
              <p style={{ fontSize: "16px", fontWeight: "500", color: "#333" }}>
                Arrears of <span style={{ fontWeight: "bold", color: "#d32f2f" }}>{arrearsDetailsRefno.arrearsAmount || "N/A"} PKR</span>
                have been raised against this application.
              </p>
            </Grid>
          </Grid>
        </DialogContent>
        {/* Footer */}
        <div style={{
          backgroundColor: '#808080',
          color: 'white',
          textAlign: 'center',
          padding: '12px',
          fontSize: '14px',
          fontWeight: '500'
        }}>
          Arrear Objection by: {activityInfo.processedBy} on: {activityInfo.date}
        </div>
      </Dialog>

      {/* Documents Verified Sub Pop Up */}
      <Dialog
        open={documentsVerifiedSubPopUp}
        onClose={() => {
          setDocumentsVerifiedSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">Documents Verification</p>
          <CloseIcon
            id="clearPopup"
            className="closeIcon"
            onClick={() => {
              setDocumentsVerifiedSubPopUp(false);
            }}
          />
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid
            container
            gap={1}
            className="container"
            style={{ display: "flex", flexDirection: "row" }}
          >
            <Grid
              item
              lg={12}
              style={{ display: "flex", flexDirection: "row" }}
            >
              {(dialogRowData.copyOfApplicantCNICFront ||
                dialogRowData.copyOfApplicantCNICBack) && (
                  <Grid item lg={2} style={{ marginRight: "1%" }}>
                    <Grid
                      container
                      sx={{
                        backgroundColor:
                          dialogRowData.copyOfApplicantCNICFrontFlag &&
                            dialogRowData.copyOfApplicantCNICBackFlag
                            ? getDocumentBackGroundColor(
                              dialogRowData.copyOfApplicantCNICFrontFlag
                            )
                            : getDocumentBackGroundColor(
                              flag_copyOfApplicantCNICFront
                            ),
                        borderRadius: "10px",
                        minHeight: "125px",
                        height: "auto",
                      }}
                    >
                      <Grid item lg={12} className="tittlegrid">
                        <p className="docTitle">Applicant's CNIC.</p>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          paddingBottom: "5px",
                        }}
                      >
                        <div
                          onClick={() => {
                            if (!copyOfApplicantCNICVerifyPopUp) {
                              setCopyOfApplicantCNICVerifyPopUp(true);
                            }
                          }}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            flexDirection: "column",
                          }}
                        >
                          {dialogRowData.copyOfApplicantCNICFront &&
                            dialogRowData.copyOfApplicantCNICFront.slice(0, 6) ==
                            "data:i" ? (
                            <Base64Image
                              data={dialogRowData.copyOfApplicantCNICFront}
                              width="80"
                            />
                          ) : (
                            <Base64Image data={pdfIcon} width="40" />
                          )}
                          {dialogRowData.copyOfApplicantCNICBack &&
                            dialogRowData.copyOfApplicantCNICBack.slice(0, 6) ==
                            "data:i" ? (
                            <Base64Image
                              data={dialogRowData.copyOfApplicantCNICBack}
                              width="80"
                            />
                          ) : (
                            <Base64Image data={pdfIcon} width="40" />
                          )}
                          {copyOfApplicantCNICVerifyPopUp && (
                            <OpenBase64ImageInPopup
                              docVerifyPopUp={copyOfApplicantCNICVerifyPopUp}
                              hideDocVerifyPopup={
                                hideCopyOfApplicantCNICVerifyAlert
                              }
                              documentName="Applicant CN"
                              documentImage={
                                dialogRowData.copyOfApplicantCNICFront
                              }
                              backDocumentImage={
                                dialogRowData.copyOfApplicantCNICBack
                              }
                              width={400}
                              document={dialogRowData.copyOfApplicantCNICFront}
                              documentFlag={
                                dialogRowData.copyOfApplicantCNICFrontFlag
                              }
                              applicationProgressId={
                                dialogRowData.applicationProgressId
                              }
                              objectionStatus={dialogRowData.objectionStatus}
                              updateDocFlag={updateDocFlag}
                              titleToUpdateFlag="copyOfApplicantCNIC"
                              flag_document={flag_copyOfApplicantCNICFront}
                              flag_documentBack={flag_copyOfApplicantCNICBack}
                            />
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              {dialogRowData.premisesDocument && (
                <Grid item lg={2} style={{ marginRight: "1%" }}>
                  <Grid
                    container
                    sx={{
                      backgroundColor: dialogRowData.premisesDocumentFlag
                        ? getDocumentBackGroundColor(
                          dialogRowData.premisesDocumentFlag
                        )
                        : getDocumentBackGroundColor(flag_premisesDocument),
                      borderRadius: "10px",
                      minHeight: "125px",
                      height: "auto",
                    }}
                  >
                    <Grid item lg={12} className="tittlegrid">
                      <p className="docTitle">Property Documents</p>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      <div
                        onClick={() => {
                          if (!propertyDocVerifyPopUp) {
                            setPropertyDocVerifyPopUp(true);
                          }
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {dialogRowData.premisesDocument.slice(0, 6) ==
                          "data:i" ? (
                          <Base64Image
                            data={dialogRowData.premisesDocument}
                            width="80"
                            height="100"
                          />
                        ) : (
                          <Base64Image data={pdfIcon} width="40" />
                        )}
                        {propertyDocVerifyPopUp && (
                          <OpenBase64ImageInPopup
                            docVerifyPopUp={propertyDocVerifyPopUp}
                            hideDocVerifyPopup={hidePropertyDocVerifyAlert}
                            documentName="Property Document"
                            documentImage={dialogRowData.premisesDocument}
                            width={400}
                            document={dialogRowData.premisesDocument}
                            documentFlag={dialogRowData.premisesDocumentFlag}
                            applicationProgressId={
                              dialogRowData.applicationProgressId
                            }
                            objectionStatus={dialogRowData.objectionStatus}
                            updateDocFlag={updateDocFlag}
                            titleToUpdateFlag="premisesDocument"
                            flag_document={flag_premisesDocument}
                          />
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {dialogRowData.scannedCopyOfNearByElectricityBill && (
                <Grid item lg={2} style={{ marginRight: "1%" }}>
                  <Grid
                    container
                    sx={{
                      backgroundColor:
                        dialogRowData.scannedCopyOfNearByElectricityBillFlag
                          ? getDocumentBackGroundColor(
                            dialogRowData.scannedCopyOfNearByElectricityBillFlag
                          )
                          : getDocumentBackGroundColor(
                            flag_scannedCopyOfNearByElectricityBill
                          ),
                      borderRadius: "10px",
                      minHeight: "125px",
                      height: "auto",
                    }}
                  >
                    <Grid item lg={12} className="tittlegrid">
                      <p className="docTitle">Near-by Elec. Bill</p>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      <div
                        onClick={() => {
                          if (!nearByBillVerifyPopUp) {
                            setNearByBillVerifyPopUp(true);
                          }
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {dialogRowData.scannedCopyOfNearByElectricityBill.slice(
                          0,
                          6
                        ) == "data:i" ? (
                          <Base64Image
                            data={
                              dialogRowData.scannedCopyOfNearByElectricityBill
                            }
                            width="80"
                            height="100"
                          />
                        ) : (
                          <Base64Image data={pdfIcon} width="80" />
                        )}
                        {nearByBillVerifyPopUp && (
                          <OpenBase64ImageInPopup
                            docVerifyPopUp={nearByBillVerifyPopUp}
                            hideDocVerifyPopup={hideNearByBillVerifyAlert}
                            documentName="Near-by Electricity Bill"
                            documentImage={
                              dialogRowData.scannedCopyOfNearByElectricityBill
                            }
                            width={400}
                            document={
                              dialogRowData.scannedCopyOfNearByElectricityBill
                            }
                            documentFlag={
                              dialogRowData.scannedCopyOfNearByElectricityBillFlag
                            }
                            applicationProgressId={
                              dialogRowData.applicationProgressId
                            }
                            objectionStatus={dialogRowData.objectionStatus}
                            updateDocFlag={updateDocFlag}
                            titleToUpdateFlag="scannedCopyOfNearByElectricityBill"
                            flag_document={
                              flag_scannedCopyOfNearByElectricityBill
                            }
                          />
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {dialogRowData.anyOtherDocument && (
                <Grid item lg={2} style={{ marginRight: "1%" }}>
                  <Grid
                    container
                    sx={{
                      backgroundColor: dialogRowData.anyOtherDocumentFlag
                        ? getDocumentBackGroundColor(
                          dialogRowData.anyOtherDocumentFlag
                        )
                        : getDocumentBackGroundColor(flag_anyOtherDocument),
                      borderRadius: "10px",
                      minHeight: "125px",
                      height: "auto",
                    }}
                  >
                    <Grid item lg={12} className="tittlegrid">
                      <p className="docTitle">Any Other Document</p>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      <div
                        onClick={() => {
                          if (!anyOtherDocumentVerifyPopUp) {
                            setAnyOtherDocumentVerifyPopUp(true);
                          }
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {dialogRowData.anyOtherDocument.slice(0, 6) ==
                          "data:i" ? (
                          <Base64Image
                            data={dialogRowData.anyOtherDocument}
                            width="80"
                            height="100"
                          />
                        ) : (
                          <Base64Image data={pdfIcon} width="80" />
                        )}
                        {anyOtherDocumentVerifyPopUp && (
                          <OpenBase64ImageInPopup
                            docVerifyPopUp={anyOtherDocumentVerifyPopUp}
                            hideDocVerifyPopup={hideAnyOtherDocumentVerifyAlert}
                            documentName="Any Other Document"
                            documentImage={dialogRowData.anyOtherDocument}
                            width={400}
                            document={dialogRowData.anyOtherDocument}
                            documentFlag={dialogRowData.anyOtherDocumentFlag}
                            applicationProgressId={
                              dialogRowData.applicationProgressId
                            }
                            objectionStatus={dialogRowData.objectionStatus}
                            updateDocFlag={updateDocFlag}
                            titleToUpdateFlag="anyOtherDocument"
                            flag_document={flag_anyOtherDocument}
                          />
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {tenantStatus.includes(dialogRowData.applicantStatus) ? (
                <>
                  {(dialogRowData.copyOfOwnerCNICFront ||
                    dialogRowData.copyOfOwnerCNICBack) && (
                      <Grid item lg={2} style={{ marginRight: "1%" }}>
                        <Grid
                          container
                          sx={{
                            backgroundColor:
                              dialogRowData.copyOfOwnerCNICFrontFlag
                                ? getDocumentBackGroundColor(
                                  dialogRowData.copyOfOwnerCNICFrontFlag
                                )
                                : getDocumentBackGroundColor(
                                  flag_copyOfOwnerCNICFront
                                ),
                            borderRadius: "10px",
                            minHeight: "125px",
                            height: "auto",
                          }}
                        >
                          <Grid item lg={12} className="tittlegrid">
                            <p className="docTitle">Owner's CNIC.</p>
                          </Grid>
                          <Grid
                            item
                            lg={12}
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              paddingBottom: "5px",
                            }}
                          >
                            <div
                              onClick={() => {
                                if (!copyOfOwnerCNICVerifyPopUp) {
                                  setCopyOfOwnerCNICVerifyPopUp(true);
                                }
                              }}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                flexDirection: "column",
                              }}
                            >
                              {dialogRowData.copyOfOwnerCNICFront.slice(0, 6) ==
                                "data:i" ? (
                                <Base64Image
                                  data={dialogRowData.copyOfOwnerCNICFront}
                                  width="80"
                                />
                              ) : (
                                <Base64Image data={pdfIcon} width="40" />
                              )}
                              {dialogRowData.copyOfOwnerCNICBack.slice(0, 6) ==
                                "data:i" ? (
                                <Base64Image
                                  data={dialogRowData.copyOfOwnerCNICBack}
                                  width="80"
                                />
                              ) : (
                                <Base64Image data={pdfIcon} width="40" />
                              )}
                              {copyOfOwnerCNICVerifyPopUp && (
                                <OpenBase64ImageInPopup
                                  docVerifyPopUp={copyOfOwnerCNICVerifyPopUp}
                                  hideDocVerifyPopup={
                                    hideCopyOfOwnerCNICVerifyAlert
                                  }
                                  documentName="Owner's CNIC"
                                  documentImage={
                                    dialogRowData.copyOfOwnerCNICFront
                                  }
                                  backDocumentImage={
                                    dialogRowData.copyOfOwnerCNICBack
                                  }
                                  width={400}
                                  document={dialogRowData.copyOfOwnerCNICFront}
                                  documentFlag={
                                    dialogRowData.copyOfOwnerCNICFrontFlag
                                  }
                                  applicationProgressId={
                                    dialogRowData.applicationProgressId
                                  }
                                  objectionStatus={dialogRowData.objectionStatus}
                                  updateDocFlag={updateDocFlag}
                                  titleToUpdateFlag="copyOfOwnerCNIC"
                                  flag_document={flag_copyOfOwnerCNICFront}
                                  flag_documentBack={flag_copyOfOwnerCNICBack}
                                />
                              )}
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  {dialogRowData.ownerNOC && (
                    <Grid item lg={2} style={{ marginRight: "1%" }}>
                      <Grid
                        container
                        sx={{
                          backgroundColor: dialogRowData.ownerNOCFlag
                            ? getDocumentBackGroundColor(
                              dialogRowData.ownerNOCFlag
                            )
                            : getDocumentBackGroundColor(flag_ownerNOC),
                          borderRadius: "10px",
                          minHeight: "125px",
                          height: "auto",
                        }}
                      >
                        <Grid item lg={12} className="tittlegrid">
                          <p className="docTitle">NOC. from Owner</p>
                        </Grid>
                        <Grid
                          item
                          lg={12}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingBottom: "5px",
                          }}
                        >
                          <div
                            onClick={() => {
                              if (!ownerNOCVerifyPopUp) {
                                setOwnerNOCVerifyPopUp(true);
                              }
                            }}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            {dialogRowData.ownerNOC.slice(0, 6) == "data:i" ? (
                              <Base64Image
                                data={dialogRowData.ownerNOC}
                                width="80"
                              />
                            ) : (
                              <Base64Image data={pdfIcon} width="80" />
                            )}
                            {ownerNOCVerifyPopUp && (
                              <OpenBase64ImageInPopup
                                docVerifyPopUp={ownerNOCVerifyPopUp}
                                hideDocVerifyPopup={hideOwnerNocVerifyAlert}
                                documentName="Noc from Owner"
                                documentImage={dialogRowData.ownerNOC}
                                width={400}
                                document={dialogRowData.ownerNOC}
                                documentFlag={dialogRowData.ownerNOCFlag}
                                applicationProgressId={
                                  dialogRowData.applicationProgressId
                                }
                                objectionStatus={dialogRowData.objectionStatus}
                                updateDocFlag={updateDocFlag}
                                titleToUpdateFlag="ownerNOC"
                                flag_document={flag_ownerNOC}
                              />
                            )}
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </>
              ) : null}
            </Grid>
            {dialogRowData.connectionType === "Industrial" ? (
              <>
                {dialogRowData.resolutionFormDesc && (
                  <Grid item lg={2}>
                    <Grid
                      container
                      sx={{
                        backgroundColor: dialogRowData.resolutionFormDescFlag
                          ? getDocumentBackGroundColor(
                            dialogRowData.resolutionFormDescFlag
                          )
                          : getDocumentBackGroundColor(flag_resolutionFormDesc),
                        borderRadius: "10px",
                        minHeight: "125px",
                        height: "auto",
                      }}
                    >
                      <Grid item lg={12} className="tittlegrid">
                        <p className="docTitle">BoD's Resolution Form</p>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          paddingBottom: "5px",
                        }}
                      >
                        <div
                          onClick={() => {
                            if (!resolutionFormDescVerifyPopUp) {
                              setResolutionFormDescVerifyPopUp(true);
                            }
                          }}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          {dialogRowData.resolutionFormDesc.slice(0, 6) ==
                            "data:i" ? (
                            <Base64Image
                              data={dialogRowData.resolutionFormDesc}
                              width="80"
                            />
                          ) : (
                            <Base64Image data={pdfIcon} width="80" />
                          )}
                          {resolutionFormDescVerifyPopUp && (
                            <OpenBase64ImageInPopup
                              docVerifyPopUp={resolutionFormDescVerifyPopUp}
                              hideDocVerifyPopup={
                                hideResolutionFormDescVerifyAlert
                              }
                              documentName="BoD's Resolution Form<"
                              documentImage={dialogRowData.resolutionFormDesc}
                              width={400}
                              document={dialogRowData.resolutionFormDesc}
                              documentFlag={
                                dialogRowData.resolutionFormDescFlag
                              }
                              applicationProgressId={
                                dialogRowData.applicationProgressId
                              }
                              objectionStatus={dialogRowData.objectionStatus}
                              updateDocFlag={updateDocFlag}
                              titleToUpdateFlag="resolutionFormDesc"
                              flag_document={flag_resolutionFormDesc}
                            />
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                {dialogRowData.certMemoDesc && (
                  <Grid item lg={2}>
                    <Grid
                      container
                      sx={{
                        backgroundColor: dialogRowData.certMemoDescFlag
                          ? getDocumentBackGroundColor(
                            dialogRowData.certMemoDescFlag
                          )
                          : getDocumentBackGroundColor(flag_certMemoDesc),
                        borderRadius: "10px",
                        minHeight: "125px",
                        height: "auto",
                      }}
                    >
                      <Grid item lg={12} className="tittlegrid">
                        <p className="docTitle">Memorandum of association</p>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          paddingBottom: "5px",
                        }}
                      >
                        <div
                          onClick={() => {
                            if (!certMemoDescVerifyPopUp) {
                              setCertMemoDescVerifyPopUp(true);
                            }
                          }}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          {dialogRowData.certMemoDesc.slice(0, 6) ==
                            "data:i" ? (
                            <Base64Image
                              data={dialogRowData.certMemoDesc}
                              width="80"
                            />
                          ) : (
                            <Base64Image data={pdfIcon} width="80" />
                          )}
                          {certMemoDescVerifyPopUp && (
                            <OpenBase64ImageInPopup
                              docVerifyPopUp={certMemoDescVerifyPopUp}
                              hideDocVerifyPopup={hideCertMemoDescVerifyAlert}
                              documentName="Memorandum of Association"
                              documentImage={dialogRowData.certMemoDesc}
                              width={400}
                              document={dialogRowData.certMemoDesc}
                              documentFlag={dialogRowData.certMemoDescFlag}
                              applicationProgressId={
                                dialogRowData.applicationProgressId
                              }
                              objectionStatus={dialogRowData.objectionStatus}
                              updateDocFlag={updateDocFlag}
                              titleToUpdateFlag="certMemoDesc"
                              flag_document={flag_certMemoDesc}
                            />
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                {dialogRowData.certFormDesc && (
                  <Grid item lg={2}>
                    <Grid
                      container
                      sx={{
                        backgroundColor: dialogRowData.certFormDescFlag
                          ? getDocumentBackGroundColor(
                            dialogRowData.certFormDescFlag
                          )
                          : getDocumentBackGroundColor(flag_certFormDesc),
                        borderRadius: "10px",
                        minHeight: "125px",
                        height: "auto",
                      }}
                    >
                      <Grid item lg={12} className="tittlegrid">
                        <p className="docTitle">Certified Form-29</p>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          paddingBottom: "5px",
                        }}
                      >
                        <div
                          onClick={() => {
                            if (!certFormDescVerifyPopUp) {
                              setCertFormDescVerifyPopUp(true);
                            }
                          }}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          {dialogRowData.certFormDesc.slice(0, 6) ==
                            "data:i" ? (
                            <Base64Image
                              data={dialogRowData.certFormDesc}
                              width="80"
                            />
                          ) : (
                            <Base64Image data={pdfIcon} width="80" />
                          )}
                          {certFormDescVerifyPopUp && (
                            <OpenBase64ImageInPopup
                              docVerifyPopUp={certFormDescVerifyPopUp}
                              hideDocVerifyPopup={hideCertFormDescVerifyAlert}
                              documentName="Certified Form-29"
                              documentImage={dialogRowData.certFormDesc}
                              width={400}
                              document={dialogRowData.certFormDesc}
                              documentFlag={dialogRowData.certFormDescFlag}
                              applicationProgressId={
                                dialogRowData.applicationProgressId
                              }
                              objectionStatus={dialogRowData.objectionStatus}
                              updateDocFlag={updateDocFlag}
                              titleToUpdateFlag="certFormDesc"
                              flag_document={flag_certFormDesc}
                            />
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </>
            ) : null}
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <p className="description">
            Documents Verified by:{" "}
            {eFileData.find((item) => item.remarks == "Documents Verified")
              ? eFileData.find((item) => item.remarks == "Documents Verified")
                .lastModifiedBy
              : ""}{" "}
            {eFileData.find((item) => item.remarks == "Documents Verified")
              ? "(" +
              eFileData.find((item) => item.remarks == "Documents Verified")
                .roleName +
              ")"
              : ""}{" "}
            on:{" "}
            {eFileData.find((item) => item.remarks == "Documents Verified")
              ? convertDatewithTimeWithoutSecond(
                eFileData.find((item) => item.remarks == "Documents Verified")
                  .lastModificationDate
              )
              : ""}
          </p>
        </DialogActions>
      </Dialog>

      <Dialog
        open={applicationSubittedPopUp}
        onClose={() => {
          setApplicationSubmittedPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">Application Submitted</p>
          <CloseIcon
            id="clearPopup"
            className="closeIcon"
            onClick={() => {
              setApplicationSubmittedPopUp(false);
            }}
          />
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid container gap={1} className="container">
            <Grid item lg={12} className="application-details">
              <Grid item lg={3} className="first-row-item">
                <p className="prop-title">Application Id</p>
                <p className=" prop-detail">{dialogRowData.applicationId}</p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">Applicant Name</p>
                <p className=" prop-detail">{dialogRowData.applicantName}</p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">Applicant CNIC.</p>
                <p className=" prop-detail">{dialogRowData.applicantCNIC}</p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">
                  {dialogRowData.applicantRelationType
                    ? sodowo(dialogRowData.applicantRelationType)
                    : "-"}
                </p>
                <p className=" prop-detail">
                  {dialogRowData.applicantRelativeName
                    ? dialogRowData.applicantRelativeName
                    : "-"}
                </p>
              </Grid>
            </Grid>
            <Grid item lg={12} className="application-details1">
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">Applied Date</p>
                <p className=" prop-detail">
                  {convertDate(dialogRowData.creationDate)}
                </p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">Subdivision</p>
                <p className=" prop-detail">
                  {subdivisionName(dialogRowData.subDivisionCode, subDivisions)}
                </p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">Applied Load</p>
                <p className=" prop-detail">{dialogRowData.appliedLoad}</p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">Connection Type</p>
                <p className=" prop-detail">{dialogRowData.connectionType}</p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">Sub. Through</p>
                <p className=" prop-detail">{dialogRowData.submittedThrough}</p>
              </Grid>
            </Grid>
            <Grid item lg={12} className="application-details">
              <Grid item lg={7} className="first-row-item">
                <p className="prop-title">Applicant Address</p>
                <p className=" prop-detail">{dialogRowData.premisesAddress}</p>
              </Grid>
              <Grid item lg={3} className="first-row-item">
                <p className="prop-title">Area Type</p>
                <p className=" prop-detail">{dialogRowData.areaType}</p>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <p className="description">
            Application Submitted by:
            {String(dialogRowData.createdBy).length === 13 &&
              /^\d+$/.test(dialogRowData.createdBy)
              ? dialogRowData.applicantName
              : dialogRowData.createdBy}
            on: {convertDatewithTimeWithoutSecond(dialogRowData.creationDate)}
          </p>
        </DialogActions>
      </Dialog>

      {/* Arrear Verified Sub Pop Up */}
      <Dialog
        open={arrearVerifiedSubPopUp}
        onClose={() => {
          setArrearVerifiedSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"sm"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">Arrear Verification</p>
          <CloseIcon
            id="clearPopup"
            onClick={() => {
              setArrearVerifiedSubPopUp(false);
            }}
            className="closeIcon"
          />
        </DialogTitle>
        <DialogContent className="dialog-content">
          <DialogContentText component="div">
            {dialogRowData.applicationProgressId > 3 ? (
              <p>
                All dues were{" "}
                <span style={{ fontWeight: "bold", color: "green" }}>PAID</span>{" "}
                against the property.
              </p>
            ) : (
              <p>Arrears verification is in process.</p>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action">
          {dialogRowData.applicationProgressId > 3 ? (
            <p className="description">
              Arrear Verified by:{" "}
              {eFileData.find((item) => item.remarks == "Arrears Verified")
                ? eFileData.find((item) => item.remarks == "Arrears Verified")
                  .lastModifiedBy
                : ""}{" "}
              {eFileData.find((item) => item.remarks == "Arrears Verified")
                ? "(" +
                eFileData.find((item) => item.remarks == "Arrears Verified")
                  .roleName +
                ")"
                : ""}{" "}
              on:{" "}
              {eFileData.find((item) => item.remarks == "Arrears Verified")
                ? convertDatewithTimeWithoutSecond(
                  eFileData.find((item) => item.remarks == "Arrears Verified")
                    .lastModificationDate
                )
                : ""}
            </p>
          ) : (
            <p className="description">-</p>
          )}
        </DialogActions>
      </Dialog>

      {/* Field Survey Sub Pop Up */}
      <Dialog
        open={fieldSurveyedSubPopUp}
        onClose={() => {
          setFieldSurveyedSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">Field Survey</p>
          <CloseIcon
            id="clearPopup"
            onClick={() => {
              setFieldSurveyedSubPopUp(false);
            }}
            className="closeIcon"
          />
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid container className="container">
            <Grid item lg={12} className="application-details">
              <Grid item lg={3} className="first-row-item">
                <p className="prop-title">Dist. within 40m </p>
                <p className="prop-detail" style={{ width: "70%" }}>
                  {fieldSurveyData
                    ? fieldSurveyData.isLTLWI40Flag === 1
                      ? "Yes"
                      : "No"
                    : "-"}
                </p>
              </Grid>
              {fieldSurveyData.isLTLWI40Flag !== 1 && (
                <Grid item lg={3} className="first-row-item">
                  <p className="prop-title">Est. Distance (m)</p>
                  <p className="prop-detail" style={{ width: "70%" }}>
                    {fieldSurveyData
                      ? fieldSurveyData.estDistanceInMeter
                        ? fieldSurveyData.estDistanceInMeter
                        : "-"
                      : "-"}
                  </p>
                </Grid>
              )}
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">Area (Marla) </p>
                <p className="prop-detail" style={{ width: "50%" }}>
                  {fieldSurveyData
                    ? fieldSurveyData.areaMarla
                      ? fieldSurveyData.areaMarla
                      : "-"
                    : "-"}
                </p>
              </Grid>
              <Grid item lg={3} className="first-row-item">
                <p className="prop-title">No. of Meters Installed </p>
                <p className="prop-detail" style={{ width: "70%" }}>
                  {fieldSurveyData
                    ? fieldSurveyData.noOfMeterInstalled
                      ? fieldSurveyData.noOfMeterInstalled
                      : "-"
                    : "-"}
                </p>
              </Grid>
              {fieldSurveyData.sketchDiagram && (
                <Grid item lg={3} className="first-row-item">
                  <p className="prop-title">Sketch Diagram </p>
                  <div className="prop-detail">
                    <a
                      href="#"
                      onClick={() =>
                        openBase64Image(fieldSurveyData.sketchDiagram)
                      }
                      target="_blank"
                      rel="noreferrer"
                      className="image"
                    >
                      <Base64Image
                        data={fieldSurveyData.sketchDiagram}
                        width={80}
                      />
                    </a>
                  </div>
                </Grid>
              )}
            </Grid>
            <Grid item lg={12} className="application-details">
              {fieldSurveyData.noOfMeterInstalled === 0 && (
                <Grid item lg={3}></Grid>
              )}
              {fieldSurveyData.installedMeterRefNos[0].installedMeterRefNo &&
                fieldSurveyData.installedMeterRefNos.map((item, index) => {
                  return (
                    <Grid item lg={3} className="first-row-item">
                      <p className="prop-title">Meter {index + 1} Ref. No. </p>
                      <p className="prop-detail" style={{ width: "79%" }}>
                        {item.installedMeterRefNo}
                      </p>
                    </Grid>
                  );
                })}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <p className="description">
            Field Surveyed by:{" "}
            {eFileData.find((item) => item.remarks == "Field Surveyed")
              ? eFileData.find((item) => item.remarks == "Field Surveyed")
                .lastModifiedBy
              : ""}{" "}
            {eFileData.find((item) => item.remarks == "Field Surveyed")
              ? "(" +
              eFileData.find((item) => item.remarks == "Field Surveyed")
                .roleName +
              ")"
              : ""}{" "}
            on:{" "}
            {eFileData.find((item) => item.remarks == "Field Surveyed")
              ? convertDatewithTimeWithoutSecond(
                eFileData.find((item) => item.remarks == "Field Surveyed")
                  .lastModificationDate
              )
              : ""}
          </p>
        </DialogActions>
      </Dialog>

      <Dialog
        open={linemanAllocationSubPopUp}
        onClose={() => {
          setLinemanAllocationSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"sm"}
        className="objectionDialog"
      >
        <DialogTitle className="objection-dialog-title">
          <Grid container className="objectionheadercontainer">
            <Grid item className="applicationTitleGrid">
              <p className="applicationTitleText">Assign To Field Staff </p>
            </Grid>
            <Grid item className="closeIcon">
              <CloseIcon
                id="clearPopup"
                onClick={() => {
                  setLinemanAllocationSubPopUp(false);
                }}
              />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className="objection-dialog-content">
          <DialogContentText component="div" className="objection-dialog-content-text">
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                backgroundColor: "white",
              }}
            >
              <thead>
                <tr
                  style={{
                    fontFamily: "Roboto-Medium",
                    backgroundColor: "#f5f5f5",
                    backgroundColor: "white",
                    boxShadow: "3px 3px 6px lightgray",
                  }}
                >
                  <th
                    style={{
                      width: "50px",
                      textAlign: "left",
                      padding: "10px",
                    }}
                  ></th>
                  <th
                    style={{
                      width: "20px",
                      textAlign: "left",
                      padding: "10px",
                    }}
                  >
                    Sr.
                  </th>
                  <th
                    style={{
                      width: "200px",
                      textAlign: "left",
                      padding: "10px",
                    }}
                  >
                    Name
                  </th>
                  <th
                    style={{
                      width: "50px",
                      textAlign: "left",
                      padding: "10px",
                    }}
                  >
                    Designation
                  </th>
                  <th
                    style={{
                      width: "50px",
                      textAlign: "left",
                      padding: "10px",
                    }}
                  >
                    Mobile No.
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    colSpan="5"
                    style={{ height: "10px", backgroundColor: "transparent" }}
                  ></td>
                </tr>
                {workForceData.map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      borderBottom: "1px solid #ddd",
                      backgroundColor: index % 2 ? "white" : "#d5e5ff",
                    }}
                  >
                    <td style={{ padding: "5px", textAlign: "left" }}>
                      <input
                        type="radio"
                        name="fieldStaff"
                        value={item.userId}
                        checked={selectedStaffId === item.userId}
                        onChange={() => setSelectedStaffId(item.userId)}
                      />
                    </td>
                    <td style={{ padding: "5px", textAlign: "left" }}>
                      {index + 1}
                    </td>
                    <td style={{ padding: "5px", textAlign: "left" }}>
                      {item.name}
                    </td>
                    <td style={{ padding: "5px", textAlign: "left" }}>
                      {fieldStaffDesignations.find(
                        (itm) => itm.employeeDesignationId == item.designation
                      )?.employeeDesignationName || "N/A"}
                    </td>
                    <td style={{ padding: "5px", textAlign: "left" }}>
                      {item.phoneNo}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="objection-dialog-action">
          <button
            onClick={() => {
              if (selectedStaffId) {
                callAssignmentAPI(dialogRowData.applicationId, selectedStaffId);
              } else {
                alert("Please select a field staff member before assigning.");
              }
            }}
            type="submit"
            className="submit-button"
          >
            Assign
          </button>
        </DialogActions>
      </Dialog>

      {/* Reference No. Allocation Sub Pop Up */}
      <Dialog
        open={referenceNoAllocatedSubPopUp}
        onClose={() => {
          setReferenceNoAllocatedSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">Reference No. Allocation</p>
          <div>
            {/* <PrintIcon
              onClick={() => downloadDNPDF(dialogRowData)}
              className="printIcon"
            /> */}
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setReferenceNoAllocatedSubPopUp(false);
              }}
              className="closeIcon"
            />
          </div>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid container className="container">
            <Grid item lg={12} className="application-details">
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">Demand Notice No. </p>
                <p className="prop-detail">
                  {dnDetails ? dnDetails.demandNoticeNo : "-"}
                </p>
              </Grid>
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">Reference No. </p>
                <p className="prop-detail">
                  {dnDetails ? dnDetails.connectionAccountNo : "-"}
                </p>
              </Grid>
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">DN Issue Date </p>
                <p className="prop-detail">
                  {dnDetails ? convertDate(dnDetails.issueDate) : "-"}
                </p>
              </Grid>
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">DN Due Date </p>
                <p className="prop-detail">
                  {dnDetails ? convertDate(dnDetails.dueDate) : "-"}
                </p>
              </Grid>
            </Grid>
            <Grid item lg={12} className="application-details">
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">Capital Cost </p>
                <p className="prop-detail">
                  {dnDetails
                    ? dnDetails.capitalCostAmount
                      ? numberFormatting(dnDetails.capitalCostAmount)
                      : "-"
                    : "-"}
                </p>
              </Grid>
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">Security Cost </p>
                <p className="prop-detail">
                  {dnDetails
                    ? dnDetails.securityDepositeAmount
                      ? numberFormatting(dnDetails.securityDepositeAmount)
                      : "-"
                    : "-"}
                </p>
              </Grid>
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">Total Cost</p>
                <p className="prop-detail">
                  {dnDetails.capitalCostAmount ||
                    dnDetails.securityDepositeAmount
                    ? numberFormatting(
                      parseInt(dnDetails.capitalCostAmount) +
                      parseInt(dnDetails.securityDepositeAmount) +
                      (!isNaN(parseInt(dnDetails.amountOfGridSharing))
                        ? parseInt(dnDetails.amountOfGridSharing)
                        : 0) +
                      (!isNaN(parseInt(dnDetails.amountOfFeederRehab))
                        ? parseInt(dnDetails.amountOfFeederRehab)
                        : 0)
                    )
                    : "-"}
                </p>
              </Grid>
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">Bank Name</p>
                <p className="prop-detail">
                  {dnDetails ? dnDetails.bankName : "-"}
                </p>
              </Grid>
            </Grid>
            <Grid item lg={12} className="application-details">
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">Area Type</p>
                <p className="prop-detail">
                  {dnDetails
                    ? dnDetails.urbanRural === "R"
                      ? "Rural"
                      : dnDetails.urbanRural === "U"
                        ? "Urban"
                        : "-"
                    : "-"}
                </p>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <p className="description">
            Demand Notice Approved by:{" "}
            {eFileData.find((item) => item.remarks == "Demand Notice Created")
              ? eFileData.find(
                (item) => item.remarks == "Demand Notice Created"
              ).lastModifiedBy
              : ""}{" "}
            {eFileData.find((item) => item.remarks == "Demand Notice Created")
              ? "(" +
              eFileData.find(
                (item) => item.remarks == "Demand Notice Created"
              ).roleName +
              ")"
              : ""}{" "}
            on:{" "}
            {eFileData.find((item) => item.remarks == "Demand Notice Created")
              ? convertDatewithTimeWithoutSecond(
                eFileData.find(
                  (item) => item.remarks == "Demand Notice Created"
                ).lastModificationDate
              )
              : ""}
          </p>
        </DialogActions>
      </Dialog>

      {/* DN Payment Submitted Pub Pop Up */}
      <Dialog
        open={dnPaymentSubmittedSubPopUp}
        onClose={() => {
          setDnPaymentSubmittedSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">DN Payment Submission</p>
          <div>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setDnPaymentSubmittedSubPopUp(false);
              }}
              className="closeIcon"
            />
          </div>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid container className="container">
            <Grid item lg={7} className="application-details">
              <Grid item lg={3.5} className="first-row-item">
                <p className="prop-title">Demand Notice No. </p>
                <p className="prop-detail">
                  {paidDnImageDetails
                    ? paidDnImageDetails.demandNoticeNo
                      ? paidDnImageDetails.demandNoticeNo
                      : "-"
                    : "-"}
                </p>
              </Grid>
              <Grid item lg={3.5} className="first-row-item">
                <p className="prop-title">Payment Date </p>
                <p className="prop-detail">
                  {paidDnImageDetails
                    ? paidDnImageDetails.paymentDate
                      ? convertDate(paidDnImageDetails.paymentDate)
                      : "-"
                    : "-"}
                </p>
              </Grid>
              {paidDnImageDetails.paidDNImage && (
                <Grid item lg={3} className="first-row-item">
                  <p className="prop-title">Paid DN Image </p>
                  <div className="prop-detail">
                    <a
                      href="#"
                      onClick={() =>
                        openBase64Image(paidDnImageDetails.paidDNImage)
                      }
                      target="_blank"
                      rel="noreferrer"
                      className="item"
                    >
                      <Base64Image
                        data={paidDnImageDetails.paidDNImage}
                        width={80}
                      />
                    </a>
                  </div>
                </Grid>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <p className="description">
            Paid Demand Notice Image Uploaded by:{" "}
            {eFileData.find((item) => item.remarks == "Demand Notice Paid")
              ? eFileData.find((item) => item.remarks == "Demand Notice Paid")
                .lastModifiedBy
              : ""}{" "}
            {eFileData.find((item) => item.remarks == "Demand Notice Paid")
              ? "(" +
              eFileData.find((item) => item.remarks == "Demand Notice Paid")
                .roleName +
              ")"
              : ""}{" "}
            on:{" "}
            {eFileData.find((item) => item.remarks == "Demand Notice Paid")
              ? convertDatewithTimeWithoutSecond(
                eFileData.find((item) => item.remarks == "Demand Notice Paid")
                  .lastModificationDate
              )
              : ""}
          </p>
        </DialogActions>
      </Dialog>

      {/* DN Payment Verified Sub Pop Up */}
      <Dialog
        open={dnPaymentVerifiedSubPopUp}
        onClose={() => {
          setDnPaymentVerifiedSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">DN Payment Verification</p>
          <div>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setDnPaymentVerifiedSubPopUp(false);
              }}
              className="closeIcon"
            />
          </div>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid container className="container">
            <Grid item lg={7} className="application-details">
              <Grid item lg={3.5} className="first-row-item">
                <p className="prop-title">Demand Notice No. </p>
                <p className="prop-detail">
                  {paidDnImageDetails ? paidDnImageDetails.demandNoticeNo : "-"}
                </p>
              </Grid>
              <Grid item lg={3} className="first-row-item">
                <p className="prop-title">Payment Date </p>
                <p className="prop-detail">
                  {paidDnImageDetails
                    ? convertDate(paidDnImageDetails.paymentDate)
                    : "-"}
                </p>
              </Grid>
            </Grid>
            <Grid item lg={6}></Grid>
            <Grid item lg={12} className="application-details">
              {paidDnImageDetails.paidDNImage && (
                <Grid item lg={3} className="first-row-item">
                  <p className="prop-title">Paid DN Image </p>
                  <div className="prop-detail">
                    <a
                      href="#"
                      onClick={() =>
                        openBase64Image(paidDnImageDetails.paidDNImage)
                      }
                      target="_blank"
                      rel="noreferrer"
                      className="item"
                    >
                      <Base64Image
                        data={paidDnImageDetails.paidDNImage}
                        width={80}
                      />
                    </a>
                  </div>
                </Grid>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <p className="description">
            Demand Notice Payment Verified by:{" "}
            {paidDnImageDetails.paidDNImageVerifiedBy} (CSL) on:{" "}
            {convertDatewithTimeWithoutSecond(
              paidDnImageDetails.paidDNImageVerifiedDateTime
            )}
          </p>
        </DialogActions>
      </Dialog>

      {/* Service Connection Order Sub Pop Up */}
      <Dialog
        open={serviceConnectionOrderedSubPopUp}
        onClose={() => {
          setServiceConnectionOrderedSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">Service Connection Order</p>
          <div>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setServiceConnectionOrderedSubPopUp(false);
              }}
              className="closeIcon"
            />
          </div>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid container className="container">
            <Grid item lg={12} className="application-details">
              <Grid item lg={2.5} className="first-row-item">
                <p className="prop-title">SCO No. </p>
                <p className="prop-detail">
                  {scoDetails ? scoDetails.scoId : "-"}
                </p>
              </Grid>
              <Grid item lg={1.5} className="first-row-item">
                <p className="prop-title">Feeder Code</p>
                <p className="prop-detail">
                  {scoDetails ? scoDetails.feederNo : "-"}
                </p>
              </Grid>
              <Grid item lg={3} className="first-row-item">
                <p className="prop-title">Feeder Name</p>
                <p className="prop-detail">
                  {scoDetails ? scoDetails.feederNo : "-"}
                </p>
              </Grid>
              <Grid item lg={1} className="first-row-item">
                <p className="prop-title">Batch </p>
                <p className="prop-detail">
                  {scoDetails ? scoDetails.batch : "-"}
                </p>
              </Grid>
              <Grid item lg={1} className="first-row-item">
                <p className="prop-title">S/Btch. </p>
                <p className="prop-detail">
                  {scoDetails ? scoDetails.subBatch : "-"}
                </p>
              </Grid>
              <Grid item lg={1} className="first-row-item">
                <p className="prop-title">R/U </p>
                <p className="prop-detail">
                  {scoDetails ? scoDetails.urbanRural : "-"}
                </p>
              </Grid>
              <Grid item lg={1} className="first-row-item">
                <p className="prop-title">F/P </p>
                <p className="prop-detail">
                  {scoDetails ? scoDetails.fataPata : "-"}
                </p>
              </Grid>
            </Grid>
            <Grid item lg={12} className="application-details">
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">F.Gvt./A.&L.Bds./P.Gvt</p>
                <p className="prop-detail">
                  {scoDetails
                    ? scoDetails.fGovt
                      ? scoDetails.fGovt
                      : "-"
                    : "-"}
                </p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">Cantonment Board </p>
                <p className="prop-detail">
                  {scoDetails
                    ? scoDetails.cantonmentBoard
                      ? scoDetails.cantonmentBoard
                      : "-"
                    : "-"}
                </p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">P.Gvt./A.&L.Bds./P.Gvt. </p>
                <p className="prop-detail">
                  {scoDetails
                    ? scoDetails.pGovt
                      ? scoDetails.pGovt
                      : "-"
                    : "-"}
                </p>
              </Grid>
              <Grid item lg={2} className="first-row-item">
                <p className="prop-title">Local Bodies</p>
                <p className="prop-detail">
                  {scoDetails
                    ? scoDetails.localBodies
                      ? scoDetails.localBodies
                      : "-"
                    : "-"}
                </p>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <p className="description">
            Service Connection Order Issued by:{" "}
            {eFileData.find((item) => item.remarks == "DN Payment Verified")
              ? eFileData.find((item) => item.remarks == "DN Payment Verified")
                .lastModifiedBy
              : ""}{" "}
            {eFileData.find((item) => item.remarks == "DN Payment Verified")
              ? "(" +
              eFileData.find((item) => item.remarks == "DN Payment Verified")
                .roleName +
              ")"
              : ""}{" "}
            on:{" "}
            {eFileData.find((item) => item.remarks == "DN Payment Verified")
              ? convertDatewithTimeWithoutSecond(
                eFileData.find(
                  (item) => item.remarks == "DN Payment Verified"
                ).lastModificationDate
              )
              : ""}
          </p>
        </DialogActions>
      </Dialog>

      {/* Meter Installed Sub Pop Up */}
      <Dialog
        open={meterInstalledSubPopUp}
        onClose={() => {
          setMeterInstalledSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">Meter Installation</p>
          <div>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setMeterInstalledSubPopUp(false);
              }}
              className="closeIcon"
            />
          </div>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid container className="container">
            {scoDetails.scoP2FillFlag && (
              <>
                <Grid
                  item
                  lg={12}
                  className="item"
                  style={{ marginBottom: "1%" }}
                >
                  <h3 className="group-title-first">Store Requisition Info</h3>
                </Grid>
                <Grid item lg={12} className="application-details">
                  <Grid item lg={2} className="first-row-item">
                    <p className="prop-title">SR No.</p>
                    <p className="prop-detail">
                      {scoDetails ? scoDetails.storeRequisitionNo : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={3} className="first-row-item">
                    <p className="prop-title">SR Date</p>
                    <p className="prop-detail">
                      {scoDetails ? scoDetails.storeRequisitionDate : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={3} className="first-row-item">
                    <p className="prop-title">Transformer Code</p>
                    <p className="prop-detail">
                      {scoDetails
                        ? scoDetails.installedTransformerCapacity
                          ? scoDetails.installedTransformerCapacity
                          : "-"
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={3} className="first-row-item">
                    <p className="prop-title">Seasonal / Non Seasonal</p>
                    <p className="prop-detail">
                      {scoDetails
                        ? scoDetails.seasonalFlag === 1
                          ? "Yes"
                          : "No"
                        : "-"}
                    </p>
                  </Grid>
                </Grid>

                <Grid
                  item
                  lg={12}
                  className="item"
                  style={{ marginBottom: "1%", marginTop: "1%" }}
                >
                  <h3 className="group-title">Meter Info</h3>
                </Grid>
                <Grid item lg={12} className="application-details">
                  <Grid item lg={1.5} className="first-row-item">
                    <p className="prop-title">Meter No.</p>
                    <p className="prop-detail">
                      {scoDetails ? scoDetails.meterNo : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1.5} className="first-row-item">
                    <p className="prop-title">Meter Id</p>
                    <p className="prop-detail">
                      {scoDetails
                        ? scoDetails.meterId
                          ? scoDetails.meterId
                          : "-"
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1.5} className="first-row-item">
                    <p className="prop-title">Manuf. Code</p>
                    <p className="prop-detail">
                      {scoDetails ? scoDetails.manufacturerCode : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1.5} className="first-row-item">
                    <p className="prop-title">Meter Read.</p>
                    <p className="prop-detail">
                      {scoDetails ? scoDetails.meterReading : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1.5} className="first-row-item">
                    <p className="prop-title">Multi. Factor</p>
                    <p className="prop-detail">
                      {scoDetails ? scoDetails.multiplyingFactor : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1.5} className="first-row-item">
                    <p className="prop-title">Loc. Code</p>
                    <p className="prop-detail">
                      {scoDetails
                        ? scoDetails.locationCode
                          ? scoDetails.locationCode
                          : "-"
                        : "-"}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  className="item"
                  style={{ marginBottom: "1%", marginTop: "1%" }}
                >
                  <h3 className="group-title">Connection Installation Info</h3>
                </Grid>
                <Grid item lg={12} className="application-details">
                  <Grid item lg={2} className="first-row-item">
                    <p className="prop-title">Installed By</p>
                    <p className="prop-detail">
                      {scoDetails
                        ? scoDetails.connectionInstallerName
                          ? scoDetails.connectionInstallerName
                          : "-"
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={2} className="first-row-item">
                    <p className="prop-title">Install. Date</p>
                    <p className="prop-detail">
                      {scoDetails
                        ? scoDetails.dateOfConnection
                          ? convertDate(scoDetails.dateOfConnection)
                          : "-"
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={2} className="first-row-item">
                    <p className="prop-title">Cp-78 Itm. No.</p>
                    <p className="prop-detail">
                      {scoDetails
                        ? scoDetails.cp78ItemNo
                          ? scoDetails.cp78ItemNo
                          : "-"
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={2} className="first-row-item">
                    <p className="prop-title">Sec. Slp/PB No.</p>
                    <p className="prop-detail">
                      {scoDetails
                        ? scoDetails.securitySlipOrPriceBondNo
                          ? scoDetails.securitySlipOrPriceBondNo
                          : "-"
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={2} className="first-row-item">
                    <p className="prop-title">TU. / NTU.</p>
                    <p className="prop-detail">
                      {scoDetails
                        ? scoDetails.tieUpNonTieUp
                          ? scoDetails.tieUpNonTieUp === 0
                            ? "Non-Tie Up"
                            : "Tie Up"
                          : "-"
                        : "-"}
                    </p>
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <p className="description">
            Meter Installation Verified by:{" "}
            {eFileData.find((item) => item.remarks == "Meter Installed")
              ? eFileData.find((item) => item.remarks == "Meter Installed")
                .lastModifiedBy
              : ""}{" "}
            {eFileData.find((item) => item.remarks == "Meter Installed")
              ? "(" +
              eFileData.find((item) => item.remarks == "Meter Installed")
                .roleName +
              ")"
              : ""}{" "}
            on:{" "}
            {eFileData.find((item) => item.remarks == "Meter Installed")
              ? convertDatewithTimeWithoutSecond(
                eFileData.find((item) => item.remarks == "Meter Installed")
                  .lastModificationDate
              )
              : ""}
          </p>
        </DialogActions>
      </Dialog>

      <Dialog
        open={newConnectionPopup}
        onClose={handleCloses}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          style: { width: "100%", height: "45%", borderRadius: 20 },
        }}
      >
        <DialogTitle>
          <Box className="backgroundAttached">
            <DoneIcon className="icon" />
          </Box>
          <Typography variant="h6" className="groupTitle">
            {" "}
            DN Generated
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <p className="applicationSubmit">
              {" "}
              Your Demand Note has been generated successfully.
            </p>
            <p className="trackId"> {dialogRowData.applicationId}</p>
            <div
              style={{
                borderRadius: "5px",
                marginLeft: "27%",
                marginTop: "2%",
                cursor: "pointer",
              }}
            >
              <Button
                variant="outlined"
                onClick={() => downloadDNPDF(dialogRowData)}
                sx={{
                  backgroundColor: "white",
                  cursor: "pointer",
                  border: "1px solid #006ad1",
                  boxShadow: "none",
                  padding: "2%",
                  width: "60%",
                }}
              >
                <PrintIcon sx={{ color: "#006ad1" }} />
                Print DN{" "}
              </Button>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      <Dialog
        open={wrongBatchPopup}
        onClose={() => setBatchError("")}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        sx={{ zIndex: "9999" }}
        PaperProps={{
          style: { width: "100%", height: "45%", borderRadius: 20 },
        }}
      >
        <DialogTitle></DialogTitle>
        <DialogContent>
          <DialogContentText
            component="div"
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={batchIcon} alt="batchIcon" width="90px" height="70px" />
            <Typography variant="h6" className="groupTitle">
              {" "}
              Batch Warning
            </Typography>
            <h5 className="applicationSubmit"> {batchError}</h5>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      <Dialog
        open={srnPopUp}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            srnHandleClose();
          }
        }}
        disableEscapeKeyDown
        fullWidth
        maxWidth="sm"
        PaperProps={{
          style: {
            width: "100%",
            borderRadius: 20,
          },
        }}
      >
        <DialogTitle sx={{ position: "relative", textAlign: "center", p: 3 }}>
          <IconButton
            aria-label="close"
            onClick={srnHandleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "#666",
              transition: "all 0.3s ease",
              "&:hover": {
                color: "red",
                backgroundColor: "rgba(255, 0, 0, 0.1)",
                transform: "scale(1.1)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Status Circle */}
          <Box
            sx={{
              backgroundColor: srnDetails?.status === "400" ? "red" : "green",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "50%",
              width: 90,
              height: 90,
              margin: "0 auto",
            }}
          >
            {srnDetails?.status === "400" ? (
              <ErrorIcon sx={{ color: "white", fontSize: 50 }} />
            ) : (
              <DoneIcon sx={{ color: "white", fontSize: 50 }} />
            )}
          </Box>

          {/* Message */}
          {srnDetails?.status === "200" ? (
            <Typography variant="h6" sx={{ mt: 2, textAlign: "center" }}>
              {/* Store Requisition Generated */}
              {srnDetails?.message}
            </Typography>
          ) : (
            <p
              style={{
                fontWeight: 500,
                fontSize: "22px",
                color: srnDetails?.status === "200" ? "green" : "red",
                marginTop: "16px",
                textAlign: "center",
                width: "100%",
              }}
            >
              {srnDetails?.message}
            </p>
          )}
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            {srnDetails &&
              CheckPermissions(
                permissions,
                "General Services",
                "New Connection",
                "Workflow Permissions",
                "Demand Note Verification"
              ) && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px",
                    flexWrap: "wrap",
                    width: "100%",
                  }}
                >
                  {srnDetails?.status === "400" && (
                    <Button
                      size="small"
                      sx={{
                        textTransform: "none",
                        padding: 0,
                        minWidth: "auto",
                        textAlign: "center",
                      }}
                      onClick={() => setShowMore(!showMore)}
                    >
                      {showMore ? "See less" : "See more"}
                    </Button>
                  )}
                </div>
              )}

            {srnDetails?.status === "400" && showMore && (
              <p
                className="innerMessage"
                style={{ color: "red", marginTop: "10px", textAlign: "center" }}
              >
                {srnDetails?.innerMessage || "Additional error details..."}
              </p>
            )}

            {/* ✅ Show store requisition no if success */}
            {/* {srnDetails &&
              CheckPermissions(
                permissions,
                "General Services",
                "New Connection",
                "Workflow Permissions",
                "Demand Note Verification"
              ) &&
              srnDetails.status === "200" && (
                <p className="applicationSubmit">{srnDetails.storeRequisitionNo}</p>
              )} */}

            {/* {srnDetails.status === "200" && ( */}
            {srnDetails &&
              srnDetails.status === "200" &&
              srnDetails.status !== "Paid DN rejected." &&
              dialogRowData?.applicationId?.slice(3, 5) === "13" && (
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", color: "#1976d2" }}
                  >
                    Store Requisition Number
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontSize: "20px", fontWeight: 500 }}
                  >
                    {srnDetails?.storeRequisitionNo}
                  </Typography>
                </div>
              )}

            {/* )} */}
            {srnDetails &&
              srnDetails.status === "200" &&
              srnDetails.status !== "Paid DN rejected." &&
              dialogRowData?.applicationId?.slice(3, 5) === "13" && (
                <>
                  <div
                    style={{
                      borderRadius: "5px",
                      marginLeft: "27%",
                      marginTop: "2%",
                      cursor: "pointer",
                    }}
                  >
                    <Button
                      variant="outlined"
                      sx={{
                        backgroundColor: "white",
                        cursor: "pointer",
                        border: "1px solid #006ad1",
                        boxShadow: "none",
                        padding: "2%",
                        width: "60%",
                      }}
                      onClick={() => setOpenSrnPopup(true)}
                    >
                      <PrintIcon sx={{ color: "#006ad1", paddingRight: 2 }} />
                      Get SR on email.
                    </Button>
                  </div>
                </>
              )}
          </DialogContentText>
        </DialogContent>

        <DialogActions></DialogActions>
      </Dialog>

      <Dialog
        open={scoPopUp}
        onClose={scoHandleClose}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          style: { width: "100%", height: "45%", borderRadius: 20 },
        }}
      >
        <DialogTitle>
          <Box className="backgroundAttached">
            <DoneIcon className="icon" />
          </Box>
          {scoDetails.scoP2FillFlag &&
            CheckPermissions(
              permissions,
              "General Services",
              "New Connection",
              "Workflow Permissions",
              "Meter Installation",
              "SCO P2 Creation"
            ) ? (
            <Typography variant="h6" className="groupTitle">
              SCO Generated
            </Typography>
          ) : (
            <Typography variant="h6" className="groupTitle">
              SCO Generated
            </Typography>
          )}
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            {scoDetails.scoP2FillFlag &&
              CheckPermissions(
                permissions,
                "General Services",
                "New Connection",
                "Workflow Permissions",
                "Meter Installation",
                "SCO P2 Creation"
              ) ? (
              <p className="applicationSubmit">
                Your Service Connection has been generated successfully.
              </p>
            ) : (
              <p className="applicationSubmit">
                Your Service Connection has been generated successfully.
              </p>
            )}
            <p className="trackId"> {dialogRowData.applicationId}</p>
            {/* <div
              style={{
                borderRadius: "5px",
                marginLeft: "27%",
                marginTop: "2%",
                cursor: "pointer",
              }}
            >
              {scoDetails.scoP2FillFlag &&
                CheckPermissions(
                  permissions,
                  "General Services",
                  "New Connection",
                  "Workflow Permissions",
                  "Meter Installation",
                  "SCO P2 Creation"
                ) ? (
                <Button
                  variant="outlined"
                  onClick={() => downloadSCOPDF(dialogRowData)}
                  sx={{
                    backgroundColor: "white",
                    cursor: "pointer",
                    border: "1px solid #006ad1",
                    boxShadow: "none",
                    padding: "2%",
                    width: "60%",
                  }}
                >
                  <PrintIcon sx={{ color: "#006ad1" }} />
                  Print SCO{" "}
                </Button>
              ) : (
                <Button
                  variant="outlined"
                  onClick={() => downloadSCOPDF(dialogRowData)}
                  sx={{
                    backgroundColor: "white",
                    cursor: "pointer",
                    border: "1px solid #006ad1",
                    boxShadow: "none",
                    padding: "2%",
                    width: "60%",
                  }}
                >
                  <PrintIcon sx={{ color: "#006ad1" }} />
                  Print SCO{" "}
                </Button>
              )}
            </div> */}
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      <Dialog
        open={cpPopUp}
        onClose={cpHandleClose}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          style: {
            width: "100%",
            height: submitCP136Error ? "24%" : "45%",
            borderRadius: 20,
          },
        }}
      >
        <DialogTitle>
          {submitCP136Error ? (
            <Box style={{ display: "flex", justifyContent: "center" }}>
              <ErrorIcon
                style={{ color: "red", height: "13%", width: "13%" }}
              />
            </Box>
          ) : (
            <Box className="backgroundAttached">
              <DoneIcon className="icon" />
            </Box>
          )}

          {submitCP136Error ? (
            <Typography
              variant="h5"
              style={{ color: "red", textAlign: "center" }}
            >
              Error
            </Typography>
          ) : (
            <Typography variant="h6" className="groupTitle">
              {" "}
              Application Completed
            </Typography>
          )}
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            {submitCP136Error ? (
              <p
                style={{ color: "red", textAlign: "center", fontSize: "18px" }}
              >
                {submitCP136Error}
              </p>
            ) : (
              <>
                <p className="applicationSubmit" style={{ marginTop: "5%" }}>
                  Your New Connection Application has been completed
                  successfully.
                </p>
                <p className="trackId">{dialogRowData?.applicationId}</p>
                {/* <div
                  style={{
                    borderRadius: '5px',
                    marginLeft: '27%',
                    marginTop: '2%',
                    cursor: 'pointer',
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => downloadMasterData(dialogRowData)}
                    sx={{
                      backgroundColor: 'white',
                      cursor: 'pointer',
                      border: '1px solid #006ad1',
                      boxShadow: 'none',
                      padding: '2%',
                      width: '60%',
                    }}
                  >
                    <PrintIcon sx={{ color: '#006ad1' }} />
                    {(dialogRowData?.connectionType !== 'Domestic' &&
                      dialogRowData?.connectionType !== 'Commercial')
                      ? 'Print CP-137'
                      : 'Print CP-136'}
                  </Button>
                </div> */}
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      {/* Allot Reference No. Popup */}
      <Dialog
        open={refNoUpdatePopup}
        onClose={refNoUpdatePopupClose}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          style: {
            borderRadius: 12,
            padding: "20px",
          },
        }}
      >
        <DialogTitle style={{ padding: "0 0 15px 0", textAlign: "center" }}>
          <Typography style={{ color: "#333", fontSize: "18px", fontWeight: 600 }}>
            Allot New Reference No.
          </Typography>
          {submitCP136Error && (
            <Typography style={{ color: "#d32f2f", fontSize: "13px", marginTop: "8px" }}>
              {submitCP136Error}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent style={{ padding: "10px 0" }}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Typography style={{ fontSize: "12px", color: "#666", marginBottom: "5px" }}>
                Batch
              </Typography>
              <Autocomplete
                options={batchArray}
                value={newSubBatch || null}
                onChange={(_, newValue) => {
                  setNewSubBatch(newValue || "");
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select"
                    size="small"
                  />
                )}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <Typography style={{ fontSize: "12px", color: "#666", marginBottom: "5px" }}>
                Subdivision
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={dialogRowData?.subDivisionCode || ""}
                disabled
                sx={{
                  "& .MuiInputBase-input.Mui-disabled": {
                    WebkitTextFillColor: "#333",
                    backgroundColor: "#f5f5f5",
                  },
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography style={{ fontSize: "12px", color: "#666", marginBottom: "5px" }}>
                Reference No. (7 digits)
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={newConnectionAccountNo}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 7);
                  setNewConnectionAccountNo(value);
                }}
                placeholder="Enter 7 digit reference"
                inputProps={{ maxLength: 7 }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center", gap: "12px", padding: "20px 0 0 0" }}>
          <Button
            variant="outlined"
            onClick={refNoUpdatePopupClose}
            sx={{
              borderColor: "#ccc",
              color: "#666",
              padding: "6px 24px",
              textTransform: "none",
              "&:hover": { borderColor: "#999", backgroundColor: "#f5f5f5" }
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleUpdateRefNoForBilling}
            disabled={refNoUpdateLoading || newConnectionAccountNo.length !== 7 || !newSubBatch}
            sx={{
              backgroundColor: "#006ad1",
              padding: "6px 24px",
              textTransform: "none",
              "&:hover": { backgroundColor: "#0056b3" },
              "&:disabled": { backgroundColor: "#ccc" }
            }}
          >
            {refNoUpdateLoading ? "Approving..." : "Approve"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openSrnPopup}
        onClose={() => {
          setOpenSrnPopup(false);
          setSelectedRow(null); // close karte waqt row reset
        }}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          style: {
            width: "100%",
            height: "auto",
            borderRadius: 20,
            padding: "10px",
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: "bold", textAlign: "center" }}>
          Send SRN Details
        </DialogTitle>

        <DialogContent>
          <Box
            sx={{
              mb: 2,
              p: 2,
              border: "1px solid #ddd",
              borderRadius: 2,
              backgroundColor: "#f9f9f9",
            }}
          >
            <Typography variant="body1">
              <strong>Application No:</strong> {dialogRowData.applicationId}
            </Typography>
            <Typography variant="body1">
              <strong>SRN No:</strong> {srnDetails?.storeRequisitionNo}
            </Typography>
          </Box>

          <DialogContentText sx={{ mb: 1 }}>
            Enter an email address to send the SRN details.
          </DialogContentText>

          <TextField
            autoFocus
            fullWidth
            variant="outlined"
            label="Email Address"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          {responseMessage && (
            <Typography
              variant="body2"
              sx={{
                mt: 2,
                color: responseMessage.includes("success") ? "green" : "red",
              }}
            >
              {responseMessage}
            </Typography>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => {
              setOpenSrnPopup(false);
              setSelectedRow(null);
            }}
            variant="outlined"
            color="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmitSrnData}
            variant="contained"
            color="primary"
            disabled={!email}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showQueuePriorityPopup}
        onClose={closeQueuePriorityPopup}
        className="dialog"
        fullWidth={true}
        maxWidth={"md"}
        sx={{ zIndex: (theme) => theme.zIndex.modal + 2 }}
        PaperProps={{
          style: { width: "100%", maxWidth: "920px", borderRadius: 20, overflow: "hidden" },
        }}
      >
        <DialogTitle sx={{ pt: 2, pb: 0.5 }}>
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: "999px",
              backgroundColor: "#facc15",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 1,
            }}
          >
            <ErrorIcon sx={{ fontSize: 44, color: "#fff" }} />
          </Box>
          <Typography
            variant="h6"
            className="groupTitle"
            sx={{ mt: 0.5, color: "#c62828", fontWeight: 700 }}
          >
            Queue Priority Alert
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ pt: 0.5, pb: 1.5 }}>
          <DialogContentText component="div">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                borderRadius: 1.5,
                border: "1px solid #f3e2ad",
                backgroundColor: "#fffaf0",
                py: 0.8,
                px: 1.2,
                mb: 1.5,
              }}
            >
              <InfoIcon sx={{ color: "#d4a72c", fontSize: 20 }} />
              <Typography sx={{ color: "#4d4d4d", fontSize: "14px" }}>
                You can't process this application, it will be Processed once it reaches Priority.
              </Typography>
            </Box>

            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                border: "1px solid #e1e5ea",
                backgroundColor: "#f8fafc",
                mb: 1.5,
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 2,
              }}
            >
              <Box sx={{ pr: 2, borderRight: "1px solid #dde3ea" }}>
                <Box sx={{ display: "flex", gap: 1.2, mb: 1.5 }}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: "50%",
                      backgroundColor: "#eaf1ff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PersonIcon sx={{ color: "#1976d2" }} />
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: 15, color: "#4b5563", fontWeight: 600 }}>
                      Selected ID
                    </Typography>
                    <Typography sx={{ fontSize: 20, lineHeight: 1.2, color: "#111827" }}>
                      {queuePriorityInfo.requestedApplicationId || "-"}
                    </Typography>
                  </Box>
                </Box>

                {queuePriorityInfo.requestedQueuePosition !== null &&
                queuePriorityInfo.requestedQueuePosition !== undefined &&
                String(queuePriorityInfo.requestedQueuePosition).trim() !== "" ? (
                  <Box sx={{ display: "flex", gap: 1.2 }}>
                    <Box
                      sx={{
                        width: 48,
                        height: 48,
                        borderRadius: "50%",
                        backgroundColor: "#eef6ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <InfoIcon sx={{ color: "#1d8ceb" }} />
                    </Box>
                    <Box>
                      <Typography sx={{ fontSize: 15, color: "#4b5563", fontWeight: 600 }}>
                        Your Queue Position
                      </Typography>
                      <Typography sx={{ fontSize: 20, lineHeight: 1.1, color: "#0070c9" }}>
                        {queuePriorityInfo.requestedQueuePosition}
                      </Typography>
                    </Box>
                  </Box>
                ) : null}
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}>
                <Box
                  sx={{
                    width: 56,
                    height: 56,
                    borderRadius: "50%",
                    backgroundColor: "#e8f7ef",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <RocketLaunchIcon sx={{ color: "#16a34a" }} />
                </Box>
                <Box>
                  <Typography sx={{ fontSize: 16, color: "#1c7f43", fontWeight: 600 }}>
                    Next Application to be Processed
                  </Typography>
                  <Typography sx={{ fontSize: 20, lineHeight: 1.2, color: "#059669" }}>
                    {queuePriorityInfo.nextApplicationId || "-"}
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                p: 1.6,
                borderRadius: 2,
                border: "1px solid #dbe7f3",
                backgroundColor: "#fcfdff",
              }}
            >
              <Typography sx={{ fontWeight: 700, color: "#006ad1", mb: 1.1, fontSize: 18 }}>
                Top 10 Applications (Processing Order)
              </Typography>
              {queuePriorityInfo.topQueueApplicationIds?.length ? (
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    gap: 1,
                  }}
                >
                  {queuePriorityInfo.topQueueApplicationIds.map((queueId, index) => {
                    const isSelected =
                      queueId === queuePriorityInfo.requestedApplicationId;
                    const isNextInQueue =
                      queueId === queuePriorityInfo.nextApplicationId;
                    return (
                      <Box
                        key={`${queueId}-${index}`}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 0.8,
                          borderRadius: 1.3,
                          px: 1.2,
                          py: 0.65,
                          border: isSelected
                            ? "1px solid #7ab6dc"
                            : isNextInQueue
                              ? "1px solid #6ec89a"
                              : "1px solid #e5e7eb",
                          backgroundColor: isSelected
                            ? "#eef8ff"
                            : isNextInQueue
                              ? "#f3fff8"
                              : "#ffffff",
                        }}
                      >
                        <Typography sx={{ fontSize: "15px", color: "#374151", minWidth: 30 }}>
                          {index + 1}.
                        </Typography>
                        <Typography sx={{ fontSize: "16px", color: "#111827", flex: 1 }}>
                          {queueId}
                        </Typography>
                        {isNextInQueue ? (
                          <Box
                            sx={{
                              px: 1,
                              py: 0.2,
                              borderRadius: 5,
                              fontSize: 12,
                              fontWeight: 700,
                              color: "#fff",
                              backgroundColor: "#16a34a",
                            }}
                          >
                            NEXT
                          </Box>
                        ) : null}
                        {isSelected ? (
                          <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#1e6ba8" }}>
                            (You)
                          </Typography>
                        ) : null}
                      </Box>
                    );
                  })}
                </Box>
              ) : (
                <Typography sx={{ fontSize: "18px", color: "#6b7280" }}>
                  No queue IDs found.
                </Typography>
              )}
            </Box>

            {/* <Box
              sx={{
                mt: 1.3,
                borderRadius: 1.2,
                border: "1px solid #d6e2ef",
                backgroundColor: "#f6fbff",
                color: "#1f5f93",
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 1.2,
                py: 0.8,
              }}
            >
              <InfoIcon sx={{ fontSize: 18 }} />
              <Typography sx={{ fontSize: 15, fontWeight: 600 }}>
                You are{" "}
                {queuePriorityInfo.requestedQueuePosition &&
                Number(queuePriorityInfo.requestedQueuePosition) > 1
                  ? Number(queuePriorityInfo.requestedQueuePosition) - 1
                  : 0}{" "}
                position(s) away from processing.
              </Typography>
            </Box> */}

            {/* <Box
              sx={{
                mt: 1,
                borderRadius: 1.2,
                border: "1px solid #d6e2ef",
                backgroundColor: "#f6fbff",
                color: "#1f5f93",
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 1.2,
                py: 0.8,
              }}
            >
              <InfoIcon sx={{ fontSize: 18 }} />
              <Typography sx={{ fontSize: 15, fontWeight: 600 }}>
                Your application will be processed once it reaches the top 10.
              </Typography>
            </Box> */}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button
            variant="contained"
            sx={{ minWidth: 110, fontWeight: 700, borderRadius: 2 }}
            onClick={closeQueuePriorityPopup}
          >
            Understood
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={showDnExpiryPopup}
        onClose={() => {
          setShowDnExpiryPopup(false);
        }}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          style: { width: "100%", height: "45%", borderRadius: 20 },
        }}
      >
        <DialogTitle>
          <Box className="backgroundRedAttached">
            <EventBusyIcon className="icon" />
          </Box>
          <Typography variant="h6" className="groupTitle">
            Demand Note Expired
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <p className="applicationSubmit">
              Demand Note for below Application ID. is expired.
            </p>
            <p className="trackId"> {dialogRowData.applicationId}</p>
            {/* <div style={{ borderRadius: '5px', marginLeft: '27%', marginTop: '2%', cursor: 'pointer' }}>
              {
                CheckPermissions(permissions, "General Services", "New Connection", "Workflow Permissions", "Demand Note Renewal") &&
                <Button variant="outlined" onClick={async () => { await callDemandNoteRenewalAPI(dialogRowData.applicationId); setShowDnExpiryPopup(false) }} sx={{ backgroundColor: 'white', cursor: 'pointer', border: '1px solid #006ad1', boxShadow: 'none', padding: '2%', width: '60%' }} >Renew DN</Button>
              }
            </div> */}
            <div
              style={{
                borderRadius: "5px",
                marginLeft: "27%",
                marginTop: "2%",
                cursor: "pointer",
              }}
            >
              {CheckPermissions(
                permissions,
                "General Services",
                "New Connection",
                "Workflow Permissions",
                "Demand Note Renewal"
              ) &&
                (() => {
                  const issueDateRaw = dnDetails.issueDate;
                  const issueDate = new Date(issueDateRaw);
                  const currentDate = new Date();

                  const msInDay = 1000 * 60 * 60 * 24;
                  const daysDifference = Math.floor(
                    (currentDate - issueDate) / msInDay
                  );

                  if (daysDifference >= 60) {
                    return (
                      <h3 style={{ color: "red" }}>
                        Your grace period has expired.
                      </h3>
                    );
                  } else {
                    return (
                      <Button
                        variant="outlined"
                        onClick={async () => {
                          await callDemandNoteRenewalAPI(
                            dialogRowData.applicationId
                          );
                          setShowDnExpiryPopup(false);
                        }}
                        sx={{
                          backgroundColor: "white",
                          cursor: "pointer",
                          border: "1px solid #006ad1",
                          boxShadow: "none",
                          padding: "2%",
                          width: "60%",
                        }}
                      >
                        Renew DN
                      </Button>
                    );
                  }
                })()}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        open={arrearsEntryPopUpOpen}
        onClose={hideArrearsEntryPopup}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Check Arrear</DialogTitle>
        <DialogContent>
          <Typography
            className="fieldLabel"
            sx={{ marginBottom: "10px", marginTop: "5px" }}
          >
            Enter Your Reference number
          </Typography>

          <TextField
            required
            type="text"
            name="iv_property_reference_no"
            value={arearsFormik.values.iv_property_reference_no}
            inputProps={{ maxLength: 14 }}
            onChange={arearsFormik.handleChange}
            onBlur={arearsFormik.handleBlur}
            fullWidth
            style={{ backgroundColor: "white" }}
            id="iv_property_reference_no"
            className="arearsReferenceNumber"
          />

          <Box className="form-error" sx={{ color: "red", marginTop: 1 }}>
            {arearsFormik.errors.iv_property_reference_no &&
              arearsFormik.touched.iv_property_reference_no
              ? arearsFormik.errors.iv_property_reference_no
              : null}
          </Box>
          {arrearsDetailsRefno && arrearsDetailsRefno.arrearsAmount && (
            <Typography
              className="fieldLabels"
              sx={{ color: "red", marginTop: "10px", fontSize: "1.5rem" }}
            >
              Arrear against this reference no is:{" "}
              {arrearsDetailsRefno.arrearsAmount}
            </Typography>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
});

export default Newconnectiontable;